import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: { input: any; output: any; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: { input: any; output: any; }
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: { input: any; output: any; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any; }
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AbonnementConsultant = {
  __typename?: 'AbonnementConsultant';
  acceptationCGV?: Maybe<Scalars['Boolean']['output']>;
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dernierPaiement?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  expirationAcces?: Maybe<Scalars['DateTime']['output']>;
  finAbonnement?: Maybe<Scalars['DateTime']['output']>;
  finPeriodeGratuite?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  referenceProduit: Scalars['String']['output'];
};

export type AbonnementConsultantFilterInput = {
  acceptationCGV?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<AbonnementConsultantFilterInput>>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dernierPaiement?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  expirationAcces?: InputMaybe<DateTimeOperationFilterInput>;
  finAbonnement?: InputMaybe<DateTimeOperationFilterInput>;
  finPeriodeGratuite?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AbonnementConsultantFilterInput>>;
  referenceProduit?: InputMaybe<StringOperationFilterInput>;
};

export enum AccountStatus {
  EntraConnected = 'ENTRA_CONNECTED',
  EntraDisabled = 'ENTRA_DISABLED',
  EntraInvited = 'ENTRA_INVITED',
  MagicLink = 'MAGIC_LINK'
}

export type AccountStatusOperationFilterInput = {
  eq?: InputMaybe<AccountStatus>;
  in?: InputMaybe<Array<AccountStatus>>;
  neq?: InputMaybe<AccountStatus>;
  nin?: InputMaybe<Array<AccountStatus>>;
};

export type Actif = {
  __typename?: 'Actif';
  actifFinancier?: Maybe<ActifFinancier>;
  arianeId?: Maybe<Scalars['String']['output']>;
  chargesImmo?: Maybe<Scalars['Decimal']['output']>;
  contratAgregationId?: Maybe<Scalars['String']['output']>;
  creationDate: Scalars['DateTime']['output'];
  dateAcquisition?: Maybe<Scalars['DateTime']['output']>;
  /** Date de début du démembrement temporaire */
  dateDebutDemembrement?: Maybe<Scalars['DateTime']['output']>;
  /** Date de fin du démembrement temporaire */
  dateFinDemembrement?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  epargneSecurise?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Long']['output'];
  loyerBrutsAnnuel?: Maybe<Scalars['Decimal']['output']>;
  modeDetention?: Maybe<TypeDetentionEnum>;
  numeroContrat?: Maybe<Scalars['String']['output']>;
  patrimoine: Patrimoine;
  patrimoineId: Scalars['Long']['output'];
  patrimoinesPassifs?: Maybe<Array<Passif>>;
  prixAcquisition?: Maybe<Scalars['Decimal']['output']>;
  regimeFiscal?: Maybe<TypeRegimeFiscalEnum>;
  revenuAnnuel?: Maybe<Scalars['Decimal']['output']>;
  sciImposableA?: Maybe<Scalars['Boolean']['output']>;
  taxeFonciere?: Maybe<Scalars['Decimal']['output']>;
  taxeHabitation?: Maybe<Scalars['Decimal']['output']>;
  type?: Maybe<TypeActifEnum>;
  /** Type de propriété */
  typeDePropriete?: Maybe<TypeDetentionEnum>;
  typeLocation?: Maybe<TypeLocationEnum>;
  typeSCPI?: Maybe<TypeScpiEnum>;
  valeurEstimee: Scalars['Decimal']['output'];
  /** Valorisation du droit démembré */
  valorisationDuDroitDemembre?: Maybe<Scalars['Decimal']['output']>;
};


export type ActifPatrimoinesPassifsArgs = {
  where?: InputMaybe<PassifFilterInput>;
};

export type ActifFilterInput = {
  actifFinancier?: InputMaybe<ActifFinancierFilterInput>;
  and?: InputMaybe<Array<ActifFilterInput>>;
  arianeId?: InputMaybe<StringOperationFilterInput>;
  chargesImmo?: InputMaybe<DecimalOperationFilterInput>;
  contratAgregationId?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateAcquisition?: InputMaybe<DateTimeOperationFilterInput>;
  /** Date de début du démembrement temporaire */
  dateDebutDemembrement?: InputMaybe<DateTimeOperationFilterInput>;
  /** Date de fin du démembrement temporaire */
  dateFinDemembrement?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  epargneSecurise?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  loyerBrutsAnnuel?: InputMaybe<DecimalOperationFilterInput>;
  modeDetention?: InputMaybe<NullableOfTypeDetentionEnumOperationFilterInput>;
  numeroContrat?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ActifFilterInput>>;
  patrimoine?: InputMaybe<PatrimoineFilterInput>;
  patrimoineId?: InputMaybe<LongOperationFilterInput>;
  patrimoinesPassifs?: InputMaybe<ListFilterInputTypeOfPassifFilterInput>;
  prixAcquisition?: InputMaybe<DecimalOperationFilterInput>;
  regimeFiscal?: InputMaybe<NullableOfTypeRegimeFiscalEnumOperationFilterInput>;
  revenuAnnuel?: InputMaybe<DecimalOperationFilterInput>;
  sciImposableA?: InputMaybe<BooleanOperationFilterInput>;
  taxeFonciere?: InputMaybe<DecimalOperationFilterInput>;
  taxeHabitation?: InputMaybe<DecimalOperationFilterInput>;
  type?: InputMaybe<NullableOfTypeActifEnumOperationFilterInput>;
  /** Type de propriété */
  typeDePropriete?: InputMaybe<NullableOfTypeDetentionEnumOperationFilterInput>;
  typeLocation?: InputMaybe<NullableOfTypeLocationEnumOperationFilterInput>;
  typeSCPI?: InputMaybe<NullableOfTypeScpiEnumOperationFilterInput>;
  valeurEstimee?: InputMaybe<DecimalOperationFilterInput>;
  /** Valorisation du droit démembré */
  valorisationDuDroitDemembre?: InputMaybe<DecimalOperationFilterInput>;
};

export type ActifFinancier = {
  __typename?: 'ActifFinancier';
  dateDisponibilite?: Maybe<Scalars['DateTime']['output']>;
  dateOuverture?: Maybe<Scalars['DateTime']['output']>;
  disponible?: Maybe<Scalars['Boolean']['output']>;
  epargneDisponible: Scalars['Decimal']['output'];
  epargneNonDisponible: Scalars['Decimal']['output'];
  epargnePrecaution: Scalars['Decimal']['output'];
  id: Scalars['Long']['output'];
  montantDisponible?: Maybe<Scalars['Decimal']['output']>;
  patrimoineActif: Actif;
  patrimoineActifId: Scalars['Long']['output'];
  versementProgrammes?: Maybe<Scalars['Decimal']['output']>;
};

export type ActifFinancierFilterInput = {
  and?: InputMaybe<Array<ActifFinancierFilterInput>>;
  dateDisponibilite?: InputMaybe<DateTimeOperationFilterInput>;
  dateOuverture?: InputMaybe<DateTimeOperationFilterInput>;
  disponible?: InputMaybe<BooleanOperationFilterInput>;
  epargneDisponible?: InputMaybe<DecimalOperationFilterInput>;
  epargneNonDisponible?: InputMaybe<DecimalOperationFilterInput>;
  epargnePrecaution?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  montantDisponible?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ActifFinancierFilterInput>>;
  patrimoineActif?: InputMaybe<ActifFilterInput>;
  patrimoineActifId?: InputMaybe<LongOperationFilterInput>;
  versementProgrammes?: InputMaybe<DecimalOperationFilterInput>;
};

export type ActifFinancierSortInput = {
  dateDisponibilite?: InputMaybe<SortEnumType>;
  dateOuverture?: InputMaybe<SortEnumType>;
  disponible?: InputMaybe<SortEnumType>;
  epargneDisponible?: InputMaybe<SortEnumType>;
  epargneNonDisponible?: InputMaybe<SortEnumType>;
  epargnePrecaution?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  montantDisponible?: InputMaybe<SortEnumType>;
  patrimoineActif?: InputMaybe<ActifSortInput>;
  patrimoineActifId?: InputMaybe<SortEnumType>;
  versementProgrammes?: InputMaybe<SortEnumType>;
};

export type ActifSortInput = {
  actifFinancier?: InputMaybe<ActifFinancierSortInput>;
  arianeId?: InputMaybe<SortEnumType>;
  chargesImmo?: InputMaybe<SortEnumType>;
  contratAgregationId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateAcquisition?: InputMaybe<SortEnumType>;
  /** Date de début du démembrement temporaire */
  dateDebutDemembrement?: InputMaybe<SortEnumType>;
  /** Date de fin du démembrement temporaire */
  dateFinDemembrement?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  epargneSecurise?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  loyerBrutsAnnuel?: InputMaybe<SortEnumType>;
  modeDetention?: InputMaybe<SortEnumType>;
  numeroContrat?: InputMaybe<SortEnumType>;
  patrimoine?: InputMaybe<PatrimoineSortInput>;
  patrimoineId?: InputMaybe<SortEnumType>;
  prixAcquisition?: InputMaybe<SortEnumType>;
  regimeFiscal?: InputMaybe<SortEnumType>;
  revenuAnnuel?: InputMaybe<SortEnumType>;
  sciImposableA?: InputMaybe<SortEnumType>;
  taxeFonciere?: InputMaybe<SortEnumType>;
  taxeHabitation?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  /** Type de propriété */
  typeDePropriete?: InputMaybe<SortEnumType>;
  typeLocation?: InputMaybe<SortEnumType>;
  typeSCPI?: InputMaybe<SortEnumType>;
  valeurEstimee?: InputMaybe<SortEnumType>;
  /** Valorisation du droit démembré */
  valorisationDuDroitDemembre?: InputMaybe<SortEnumType>;
};

export type ActionDeFormation = {
  __typename?: 'ActionDeFormation';
  actionDeFormationSession: Array<ActionDeFormationSession>;
  codeFamille?: Maybe<Scalars['Byte']['output']>;
  codeFamilleNavigation?: Maybe<FormationType>;
  codeSaison?: Maybe<Scalars['Byte']['output']>;
  codeSaisonNavigation?: Maybe<FormationSaison>;
  creationDate: Scalars['DateTime']['output'];
  cursusFormation: Array<CursusFormation>;
  dateDebutValidite?: Maybe<Scalars['DateTime']['output']>;
  dateFinValidite?: Maybe<Scalars['DateTime']['output']>;
  dureeHeure?: Maybe<Scalars['Decimal']['output']>;
  dureeJour?: Maybe<Scalars['Decimal']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  nom: Scalars['String']['output'];
  obligatoire?: Maybe<Scalars['Byte']['output']>;
  origineData?: Maybe<Scalars['Byte']['output']>;
  origineDataNavigation?: Maybe<OrigineData>;
  reference: Scalars['String']['output'];
};


export type ActionDeFormationActionDeFormationSessionArgs = {
  where?: InputMaybe<ActionDeFormationSessionFilterInput>;
};


export type ActionDeFormationCursusFormationArgs = {
  where?: InputMaybe<CursusFormationFilterInput>;
};

export type ActionDeFormationFilterInput = {
  actionDeFormationSession?: InputMaybe<ListFilterInputTypeOfActionDeFormationSessionFilterInput>;
  and?: InputMaybe<Array<ActionDeFormationFilterInput>>;
  codeFamille?: InputMaybe<ByteOperationFilterInput>;
  codeFamilleNavigation?: InputMaybe<FormationTypeFilterInput>;
  codeSaison?: InputMaybe<ByteOperationFilterInput>;
  codeSaisonNavigation?: InputMaybe<FormationSaisonFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursusFormation?: InputMaybe<ListFilterInputTypeOfCursusFormationFilterInput>;
  dateDebutValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dureeHeure?: InputMaybe<DecimalOperationFilterInput>;
  dureeJour?: InputMaybe<DecimalOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  obligatoire?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<ActionDeFormationFilterInput>>;
  origineData?: InputMaybe<ByteOperationFilterInput>;
  origineDataNavigation?: InputMaybe<OrigineDataFilterInput>;
  reference?: InputMaybe<StringOperationFilterInput>;
};

export type ActionDeFormationSession = {
  __typename?: 'ActionDeFormationSession';
  actionDeFormation: ActionDeFormation;
  actionDeFormationId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  session: Session;
  sessionId: Scalars['Long']['output'];
};

export type ActionDeFormationSessionFilterInput = {
  actionDeFormation?: InputMaybe<ActionDeFormationFilterInput>;
  actionDeFormationId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<ActionDeFormationSessionFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ActionDeFormationSessionFilterInput>>;
  session?: InputMaybe<SessionFilterInput>;
  sessionId?: InputMaybe<LongOperationFilterInput>;
};

export type ActivateOperationConfigInput = {
  /** Migre les opérations actives non verrouillées jusqu'à Signature incluse. Par défaut, les signale seulement. */
  migrateOperations?: Scalars['Boolean']['input'];
  operationConfigId: Scalars['UUID']['input'];
};

export type ActivateOperationConfigPayload = {
  __typename?: 'ActivateOperationConfigPayload';
  errors: Array<OperationConfigActivationError>;
  report?: Maybe<OperationConfigActivationReport>;
};

export type ActiviteRattachPartenaire = {
  __typename?: 'ActiviteRattachPartenaire';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate: Scalars['DateTime']['output'];
  libelle: Scalars['String']['output'];
  partenaire: Array<Partenaire>;
};


export type ActiviteRattachPartenairePartenaireArgs = {
  where?: InputMaybe<PartenaireFilterInput>;
};

export type ActiviteRattachPartenaireSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type AddRelationCoupleInput = {
  conjointId: Scalars['Long']['input'];
  conjointPersonnePhysiqueId: Scalars['Long']['input'];
  investisseurId: Scalars['Long']['input'];
  investisseurPersonnePhysiqueId: Scalars['Long']['input'];
  relationTypeCode: Scalars['String']['input'];
};

export type AdditionalDetails = {
  __typename?: 'AdditionalDetails';
  commentaireAllocation?: Maybe<Scalars['String']['output']>;
  commentaireAutre?: Maybe<Scalars['String']['output']>;
  commentaireEnveloppe?: Maybe<Scalars['String']['output']>;
};

export type AdditionalDetailsFilterInput = {
  and?: InputMaybe<Array<AdditionalDetailsFilterInput>>;
  commentaireAllocation?: InputMaybe<StringOperationFilterInput>;
  commentaireAutre?: InputMaybe<StringOperationFilterInput>;
  commentaireEnveloppe?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdditionalDetailsFilterInput>>;
};

export type AdditionalDetailsInput = {
  commentaireAllocation?: InputMaybe<Scalars['String']['input']>;
  commentaireAutre?: InputMaybe<Scalars['String']['input']>;
  commentaireEnveloppe?: InputMaybe<Scalars['String']['input']>;
};

export type AdequationConfig = {
  __typename?: 'AdequationConfig';
  fieldConfigs: Array<FieldConfig>;
  id: Scalars['Int']['output'];
  lastChangeDate: Scalars['DateTime']['output'];
};


export type AdequationConfigFieldConfigsArgs = {
  where?: InputMaybe<FieldConfigFilterInput>;
};

export type AdequationConfigFilterInput = {
  and?: InputMaybe<Array<AdequationConfigFilterInput>>;
  fieldConfigs?: InputMaybe<ListFilterInputTypeOfFieldConfigFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lastChangeDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AdequationConfigFilterInput>>;
};

export type AdhesionConsultant = {
  __typename?: 'AdhesionConsultant';
  adhesionFin?: Maybe<Scalars['DateTime']['output']>;
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  exerciceCommercial: ExerciceCommercial;
  exerciceCommercialId: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  modeReponse: Scalars['Byte']['output'];
  modeReponseNavigation: ModeReponseReadhesion;
  reponse: Scalars['Byte']['output'];
  reponseNavigation: ReponseReadhesion;
};

export type AdhesionConsultantFilterInput = {
  adhesionFin?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<AdhesionConsultantFilterInput>>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  exerciceCommercial?: InputMaybe<ExerciceCommercialFilterInput>;
  exerciceCommercialId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  modeReponse?: InputMaybe<ByteOperationFilterInput>;
  modeReponseNavigation?: InputMaybe<ModeReponseReadhesionFilterInput>;
  or?: InputMaybe<Array<AdhesionConsultantFilterInput>>;
  reponse?: InputMaybe<ByteOperationFilterInput>;
  reponseNavigation?: InputMaybe<ReponseReadhesionFilterInput>;
};

export type Adresse = {
  __typename?: 'Adresse';
  adresse1?: Maybe<Scalars['String']['output']>;
  adresse2?: Maybe<Scalars['String']['output']>;
  adresse3?: Maybe<Scalars['String']['output']>;
  arianeId?: Maybe<Scalars['Long']['output']>;
  cedex?: Maybe<Scalars['String']['output']>;
  codePostalCode?: Maybe<Scalars['String']['output']>;
  complement?: Maybe<Scalars['String']['output']>;
  consultant: Array<Consultant>;
  consultantStatutJuridique: Array<ConsultantStatutJuridique>;
  contact: Array<Contact>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  modeLogement?: Maybe<Scalars['String']['output']>;
  modeLogementNavigation?: Maybe<ModeLogement>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  paysCode?: Maybe<Scalars['String']['output']>;
  paysCodeNavigation?: Maybe<Pays>;
  personneMoraleAdresse: Array<PersonneMoraleAdresse>;
  personnePhysique: Array<PersonnePhysique>;
  typeAdresseCode: Scalars['String']['output'];
  typeAdresseCodeNavigation: TypeAdresse;
  villeNom?: Maybe<Scalars['String']['output']>;
};


export type AdresseConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type AdresseConsultantStatutJuridiqueArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};


export type AdresseContactArgs = {
  where?: InputMaybe<ContactFilterInput>;
};


export type AdressePersonneMoraleAdresseArgs = {
  where?: InputMaybe<PersonneMoraleAdresseFilterInput>;
};


export type AdressePersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type AdresseFilterInput = {
  adresse1?: InputMaybe<StringOperationFilterInput>;
  adresse2?: InputMaybe<StringOperationFilterInput>;
  adresse3?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AdresseFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  cedex?: InputMaybe<StringOperationFilterInput>;
  codePostalCode?: InputMaybe<StringOperationFilterInput>;
  complement?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  consultantStatutJuridique?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput>;
  contact?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  modeLogement?: InputMaybe<StringOperationFilterInput>;
  modeLogementNavigation?: InputMaybe<ModeLogementFilterInput>;
  note?: InputMaybe<NoteFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AdresseFilterInput>>;
  paysCode?: InputMaybe<StringOperationFilterInput>;
  paysCodeNavigation?: InputMaybe<PaysFilterInput>;
  personneMoraleAdresse?: InputMaybe<ListFilterInputTypeOfPersonneMoraleAdresseFilterInput>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  typeAdresseCode?: InputMaybe<StringOperationFilterInput>;
  typeAdresseCodeNavigation?: InputMaybe<TypeAdresseFilterInput>;
  villeNom?: InputMaybe<StringOperationFilterInput>;
};

export type AdresseInput = {
  codePays: Scalars['String']['input'];
  codePostal: Scalars['String']['input'];
  complement: Scalars['String']['input'];
  ville: Scalars['String']['input'];
  voie: Scalars['String']['input'];
};

export type AdressePersonneInput = {
  codePostal?: InputMaybe<Scalars['String']['input']>;
  complementAdresse?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  libelle?: InputMaybe<Scalars['String']['input']>;
  modeLogement?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pays?: InputMaybe<Scalars['String']['input']>;
  typeAdresseCode: Scalars['String']['input'];
  ville?: InputMaybe<Scalars['String']['input']>;
};

/** Affirmations du bloc pédagogie (Q17) */
export enum AffirmationPedagogieEnum {
  Diversification = 'DIVERSIFICATION',
  HorizonLongTerme = 'HORIZON_LONG_TERME',
  InvestissementRegulier = 'INVESTISSEMENT_REGULIER',
  PerformancesPassees = 'PERFORMANCES_PASSEES',
  RendementSansRisque = 'RENDEMENT_SANS_RISQUE'
}

export type AffirmationPedagogieEnumOperationFilterInput = {
  eq?: InputMaybe<AffirmationPedagogieEnum>;
  in?: InputMaybe<Array<AffirmationPedagogieEnum>>;
  neq?: InputMaybe<AffirmationPedagogieEnum>;
  nin?: InputMaybe<Array<AffirmationPedagogieEnum>>;
};

/** Réponse saisie pour une affirmation du bloc pédagogie */
export type AffirmationPedagogieInput = {
  affirmation: AffirmationPedagogieEnum;
  reponse?: InputMaybe<VraiFauxEnum>;
};

/** Affirmation du bloc pédagogie (Q17), dans l'ordre d'affichage */
export type AffirmationPedagogieReferentielDto = {
  __typename?: 'AffirmationPedagogieReferentielDto';
  affirmation: AffirmationPedagogieEnum;
  libelle: Scalars['String']['output'];
};

/** Affirmation du bloc pédagogie (Q17), dans l'ordre d'affichage */
export type AffirmationPedagogieReferentielDtoFilterInput = {
  affirmation?: InputMaybe<AffirmationPedagogieEnumOperationFilterInput>;
  and?: InputMaybe<Array<AffirmationPedagogieReferentielDtoFilterInput>>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AffirmationPedagogieReferentielDtoFilterInput>>;
};

/** Réponse à une affirmation du bloc pédagogie (Q17) */
export type AffirmationPedagogieReponse = {
  __typename?: 'AffirmationPedagogieReponse';
  affirmation: AffirmationPedagogieEnum;
  reponse?: Maybe<VraiFauxEnum>;
};

/** Réponse à une affirmation du bloc pédagogie (Q17) */
export type AffirmationPedagogieReponseFilterInput = {
  affirmation?: InputMaybe<AffirmationPedagogieEnumOperationFilterInput>;
  and?: InputMaybe<Array<AffirmationPedagogieReponseFilterInput>>;
  or?: InputMaybe<Array<AffirmationPedagogieReponseFilterInput>>;
  reponse?: InputMaybe<NullableOfVraiFauxEnumOperationFilterInput>;
};

export type AgregationInvestisseurVisionGlobaleFilterInput = {
  and?: InputMaybe<Array<AgregationInvestisseurVisionGlobaleFilterInput>>;
  codeInvestisseur?: InputMaybe<StringOperationFilterInput>;
  cumulVersementsNets?: InputMaybe<DecimalOperationFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  encoursTotal?: InputMaybe<DecimalOperationFilterInput>;
  montantTotalMensuelVp?: InputMaybe<DecimalOperationFilterInput>;
  nbContrats?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<AgregationInvestisseurVisionGlobaleFilterInput>>;
  performanceGlobaleFinanciere?: InputMaybe<DecimalOperationFilterInput>;
};

export type AgregationStorageFileModel = {
  __typename?: 'AgregationStorageFileModel';
  fileName: Scalars['String']['output'];
  sasUrl?: Maybe<Scalars['String']['output']>;
};

export type Allocation = {
  __typename?: 'Allocation';
  dateModification?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
  modeDeGestion?: Maybe<ModeDeGestion>;
  modeDeGestionId: Scalars['String']['output'];
  niveauDeRisque: NiveauDeRisque;
  produits: Array<Produit>;
  statut?: Maybe<AllocationPartenaireStatut>;
  storageFile?: Maybe<StorageFile>;
  storageFileId?: Maybe<Scalars['String']['output']>;
};


export type AllocationProduitsArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type AllocationConseil = {
  __typename?: 'AllocationConseil';
  id: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
  modeDeGestionCode: Scalars['String']['output'];
  niveauDeRisque: NiveauDeRisque;
};

export type AllocationConseilFilterInput = {
  and?: InputMaybe<Array<AllocationConseilFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  modeDeGestionCode?: InputMaybe<StringOperationFilterInput>;
  niveauDeRisque?: InputMaybe<NiveauDeRisqueOperationFilterInput>;
  or?: InputMaybe<Array<AllocationConseilFilterInput>>;
};

export type AllocationConseilInput = {
  id: Scalars['String']['input'];
  libelle: Scalars['String']['input'];
  modeDeGestionCode: Scalars['String']['input'];
  niveauDeRisque: NiveauDeRisque;
};

export type AllocationFilterInput = {
  and?: InputMaybe<Array<AllocationFilterInput>>;
  dateModification?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  modeDeGestion?: InputMaybe<ModeDeGestionFilterInput>;
  modeDeGestionId?: InputMaybe<StringOperationFilterInput>;
  niveauDeRisque?: InputMaybe<NiveauDeRisqueOperationFilterInput>;
  or?: InputMaybe<Array<AllocationFilterInput>>;
  produits?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
  statut?: InputMaybe<NullableOfAllocationPartenaireStatutOperationFilterInput>;
  storageFile?: InputMaybe<StorageFileFilterInput>;
  storageFileId?: InputMaybe<StringOperationFilterInput>;
};

export enum AllocationPartenaireStatut {
  Actif = 'ACTIF',
  Inactive = 'INACTIVE'
}

export type AllocationSortInput = {
  dateModification?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  modeDeGestion?: InputMaybe<ModeDeGestionSortInput>;
  modeDeGestionId?: InputMaybe<SortEnumType>;
  niveauDeRisque?: InputMaybe<SortEnumType>;
  statut?: InputMaybe<SortEnumType>;
  storageFile?: InputMaybe<StorageFileSortInput>;
  storageFileId?: InputMaybe<SortEnumType>;
};

export enum AllocationTransfertOption {
  Differente = 'DIFFERENTE',
  Identique = 'IDENTIQUE'
}

export enum AllocationVersementOption {
  Differente = 'DIFFERENTE',
  Identique = 'IDENTIQUE'
}

export enum AppReference {
  Ariane = 'ARIANE',
  Minotaure = 'MINOTAURE',
  MinotaureWithWarning = 'MINOTAURE_WITH_WARNING'
}

export type AppReferenceOperationFilterInput = {
  eq?: InputMaybe<AppReference>;
  in?: InputMaybe<Array<AppReference>>;
  neq?: InputMaybe<AppReference>;
  nin?: InputMaybe<Array<AppReference>>;
};

export type AppartenanceDocument = {
  __typename?: 'AppartenanceDocument';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  gedTypeDocument: Array<GedTypeDocument>;
  libelle: Scalars['String']['output'];
};


export type AppartenanceDocumentGedTypeDocumentArgs = {
  where?: InputMaybe<GedTypeDocumentFilterInput>;
};

export type AppartenanceDocumentFilterInput = {
  and?: InputMaybe<Array<AppartenanceDocumentFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  gedTypeDocument?: InputMaybe<ListFilterInputTypeOfGedTypeDocumentFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AppartenanceDocumentFilterInput>>;
};

/** Represente les critères d'applicabilité pour une configuration d'opération donnée. Tous les critères sont optionnels. Si un critère n'est pas défini (null), cela signifie que la configuration est applicable pour toutes les valeurs de ce critère. */
export type ApplicabilityCriteria = {
  __typename?: 'ApplicabilityCriteria';
  enveloppe?: Maybe<EnveloppeProduit>;
  habilitation?: Maybe<Habilitation>;
  id: Scalars['Int']['output'];
  natureOperation?: Maybe<NatureOperation>;
  tag?: Maybe<ApplicabilityTag>;
  typeInvestisseur?: Maybe<TypePersonne>;
};

/** Represente les critères d'applicabilité pour une configuration d'opération donnée. Tous les critères sont optionnels. Si un critère n'est pas défini (null), cela signifie que la configuration est applicable pour toutes les valeurs de ce critère. */
export type ApplicabilityCriteriaFilterInput = {
  and?: InputMaybe<Array<ApplicabilityCriteriaFilterInput>>;
  enveloppe?: InputMaybe<EnveloppeProduitFilterInput>;
  habilitation?: InputMaybe<HabilitationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  natureOperation?: InputMaybe<NatureOperationFilterInput>;
  or?: InputMaybe<Array<ApplicabilityCriteriaFilterInput>>;
  tag?: InputMaybe<NullableOfApplicabilityTagOperationFilterInput>;
  typeInvestisseur?: InputMaybe<NullableOfTypePersonneOperationFilterInput>;
};

export enum ApplicabilityTag {
  CapitalImmo = 'CAPITAL_IMMO',
  ElevationMiriad2 = 'ELEVATION_MIRIAD2',
  ImmoReemploi = 'IMMO_REEMPLOI',
  PleineNuePropriete = 'PLEINE_NUE_PROPRIETE',
  SortieAnticipeePartielle = 'SORTIE_ANTICIPEE_PARTIELLE',
  SortieRetraitePartielle = 'SORTIE_RETRAITE_PARTIELLE',
  Usufruit = 'USUFRUIT'
}

export type ApplicationSetting = {
  __typename?: 'ApplicationSetting';
  key: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export type ArbitrageDuplicationContext = {
  __typename?: 'ArbitrageDuplicationContext';
  objectifsIntersectionApplied?: Maybe<Scalars['Boolean']['output']>;
  sourceFicheId: Scalars['String']['output'];
  sourceObjectifs?: Maybe<Array<InvestisseurObjectifData>>;
};


export type ArbitrageDuplicationContextSourceObjectifsArgs = {
  where?: InputMaybe<InvestisseurObjectifDataFilterInput>;
};

export type ArbitrageDuplicationContextFilterInput = {
  and?: InputMaybe<Array<ArbitrageDuplicationContextFilterInput>>;
  objectifsIntersectionApplied?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ArbitrageDuplicationContextFilterInput>>;
  sourceFicheId?: InputMaybe<StringOperationFilterInput>;
  sourceObjectifs?: InputMaybe<ListFilterInputTypeOfInvestisseurObjectifDataFilterInput>;
};

export type ArbitrageDuplicationContextInput = {
  objectifsIntersectionApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sourceFicheId: Scalars['String']['input'];
  sourceObjectifs?: InputMaybe<Array<InvestisseurObjectifDataInput>>;
};

export type ArianeDumpJob = {
  __typename?: 'ArianeDumpJob';
  arianeDumpDataJson?: Maybe<Scalars['String']['output']>;
  arianeId: Scalars['Long']['output'];
  arianeProcessJobs: Array<ArianeProcessJob>;
  atlasId?: Maybe<Scalars['Long']['output']>;
  consultantId?: Maybe<Scalars['Long']['output']>;
  consultantMigrationJob?: Maybe<ConsultantMigrationJob>;
  consultantMigrationJobId?: Maybe<Scalars['Long']['output']>;
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  galaxyId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  importAppVersion?: Maybe<Scalars['Int']['output']>;
  importTimeStamp?: Maybe<Scalars['DateTime']['output']>;
  investisseur?: Maybe<ImportInvestisseur>;
  isActive: Scalars['Boolean']['output'];
  isPreImport: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  retryCount: Scalars['Int']['output'];
  shouldAutomaticallyProcess: Scalars['Boolean']['output'];
  status: JobStatus;
  waveMigrationJob?: Maybe<WaveMigrationJob>;
  waveMigrationJobId?: Maybe<Scalars['Long']['output']>;
};


export type ArianeDumpJobArianeProcessJobsArgs = {
  where?: InputMaybe<ArianeProcessJobFilterInput>;
};

export type ArianeDumpJobFilterInput = {
  and?: InputMaybe<Array<ArianeDumpJobFilterInput>>;
  arianeDumpDataJson?: InputMaybe<StringOperationFilterInput>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  arianeProcessJobs?: InputMaybe<ListFilterInputTypeOfArianeProcessJobFilterInput>;
  atlasId?: InputMaybe<LongOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  consultantMigrationJob?: InputMaybe<ConsultantMigrationJobFilterInput>;
  consultantMigrationJobId?: InputMaybe<LongOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  galaxyId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  importAppVersion?: InputMaybe<IntOperationFilterInput>;
  importTimeStamp?: InputMaybe<DateTimeOperationFilterInput>;
  investisseur?: InputMaybe<ImportInvestisseurFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isPreImport?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ArianeDumpJobFilterInput>>;
  priority?: InputMaybe<IntOperationFilterInput>;
  retryCount?: InputMaybe<IntOperationFilterInput>;
  shouldAutomaticallyProcess?: InputMaybe<BooleanOperationFilterInput>;
  status?: InputMaybe<JobStatusOperationFilterInput>;
  waveMigrationJob?: InputMaybe<WaveMigrationJobFilterInput>;
  waveMigrationJobId?: InputMaybe<LongOperationFilterInput>;
};

export type ArianeDumpJobSortInput = {
  arianeDumpDataJson?: InputMaybe<SortEnumType>;
  arianeId?: InputMaybe<SortEnumType>;
  atlasId?: InputMaybe<SortEnumType>;
  consultantId?: InputMaybe<SortEnumType>;
  consultantMigrationJob?: InputMaybe<ConsultantMigrationJobSortInput>;
  consultantMigrationJobId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  errorMessage?: InputMaybe<SortEnumType>;
  galaxyId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  importAppVersion?: InputMaybe<SortEnumType>;
  importTimeStamp?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<ImportInvestisseurSortInput>;
  isActive?: InputMaybe<SortEnumType>;
  isPreImport?: InputMaybe<SortEnumType>;
  priority?: InputMaybe<SortEnumType>;
  retryCount?: InputMaybe<SortEnumType>;
  shouldAutomaticallyProcess?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  waveMigrationJob?: InputMaybe<WaveMigrationJobSortInput>;
  waveMigrationJobId?: InputMaybe<SortEnumType>;
};

/** log d'import Ariane */
export type ArianeImportLog = {
  __typename?: 'ArianeImportLog';
  arianeProcessJob?: Maybe<ArianeProcessJob>;
  arianeProcessJobId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  /** Identifiant optionnel du log */
  logIdentifier?: Maybe<Scalars['String']['output']>;
  logLevel: ImportLogLevel;
  message: Scalars['String']['output'];
};

/** log d'import Ariane */
export type ArianeImportLogFilterInput = {
  and?: InputMaybe<Array<ArianeImportLogFilterInput>>;
  arianeProcessJob?: InputMaybe<ArianeProcessJobFilterInput>;
  arianeProcessJobId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  /** Identifiant optionnel du log */
  logIdentifier?: InputMaybe<StringOperationFilterInput>;
  logLevel?: InputMaybe<ImportLogLevelOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ArianeImportLogFilterInput>>;
};

/** log d'import Ariane */
export type ArianeImportLogSortInput = {
  arianeProcessJob?: InputMaybe<ArianeProcessJobSortInput>;
  arianeProcessJobId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Identifiant optionnel du log */
  logIdentifier?: InputMaybe<SortEnumType>;
  logLevel?: InputMaybe<SortEnumType>;
  message?: InputMaybe<SortEnumType>;
};

export type ArianeProcessJob = {
  __typename?: 'ArianeProcessJob';
  arianeDumpJob: ArianeDumpJob;
  arianeDumpJobId: Scalars['Long']['output'];
  createdAt: Scalars['DateTime']['output'];
  fieldsToPatch?: Maybe<PatchFields>;
  id: Scalars['Long']['output'];
  investisseur?: Maybe<ImportInvestisseur>;
  investisseurId: Scalars['Long']['output'];
  isActive: Scalars['Boolean']['output'];
  isPreImport: Scalars['Boolean']['output'];
  logs: Array<ArianeImportLog>;
  priority: Scalars['Int']['output'];
  processAppVersion?: Maybe<Scalars['Int']['output']>;
  processTimeStamp?: Maybe<Scalars['DateTime']['output']>;
  retryCount: Scalars['Int']['output'];
  statut: JobStatus;
};


export type ArianeProcessJobLogsArgs = {
  where?: InputMaybe<ArianeImportLogFilterInput>;
};

export type ArianeProcessJobFilterInput = {
  and?: InputMaybe<Array<ArianeProcessJobFilterInput>>;
  arianeDumpJob?: InputMaybe<ArianeDumpJobFilterInput>;
  arianeDumpJobId?: InputMaybe<LongOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  fieldsToPatch?: InputMaybe<NullableOfPatchFieldsOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<ImportInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isPreImport?: InputMaybe<BooleanOperationFilterInput>;
  logs?: InputMaybe<ListFilterInputTypeOfArianeImportLogFilterInput>;
  or?: InputMaybe<Array<ArianeProcessJobFilterInput>>;
  priority?: InputMaybe<IntOperationFilterInput>;
  processAppVersion?: InputMaybe<IntOperationFilterInput>;
  processTimeStamp?: InputMaybe<DateTimeOperationFilterInput>;
  retryCount?: InputMaybe<IntOperationFilterInput>;
  statut?: InputMaybe<JobStatusOperationFilterInput>;
};

export type ArianeProcessJobSortInput = {
  arianeDumpJob?: InputMaybe<ArianeDumpJobSortInput>;
  arianeDumpJobId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  fieldsToPatch?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<ImportInvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isPreImport?: InputMaybe<SortEnumType>;
  priority?: InputMaybe<SortEnumType>;
  processAppVersion?: InputMaybe<SortEnumType>;
  processTimeStamp?: InputMaybe<SortEnumType>;
  retryCount?: InputMaybe<SortEnumType>;
  statut?: InputMaybe<SortEnumType>;
};

export type AssujettiTva = {
  __typename?: 'AssujettiTVA';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantStatutJuridique: Array<ConsultantStatutJuridique>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type AssujettiTvaConsultantStatutJuridiqueArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};

export type AssujettiTvaFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<AssujettiTvaFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantStatutJuridique?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AssujettiTvaFilterInput>>;
};

export type AtlasAdresse = {
  __typename?: 'AtlasAdresse';
  adresse1?: Maybe<Scalars['String']['output']>;
  adresse2?: Maybe<Scalars['String']['output']>;
  adresse3?: Maybe<Scalars['String']['output']>;
  arianeId?: Maybe<Scalars['Long']['output']>;
  cedex?: Maybe<Scalars['String']['output']>;
  codePostalCode?: Maybe<Scalars['String']['output']>;
  complement?: Maybe<Scalars['String']['output']>;
  consultantStatutJuridiques: Array<AtlasConsultantStatutJuridique>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  modeLogement?: Maybe<Scalars['String']['output']>;
  noteId?: Maybe<Scalars['Long']['output']>;
  paysCode?: Maybe<Scalars['String']['output']>;
  paysCodeNavigation?: Maybe<AtlasPays>;
  personnePhysiqueAdresses: Array<AtlasPersonnePhysiqueAdresse>;
  typeAdresseCode: Scalars['String']['output'];
  villeNom?: Maybe<Scalars['String']['output']>;
};


export type AtlasAdresseConsultantStatutJuridiquesArgs = {
  where?: InputMaybe<AtlasConsultantStatutJuridiqueFilterInput>;
};


export type AtlasAdressePersonnePhysiqueAdressesArgs = {
  where?: InputMaybe<AtlasPersonnePhysiqueAdresseFilterInput>;
};

export type AtlasAdresseFilterInput = {
  adresse1?: InputMaybe<StringOperationFilterInput>;
  adresse2?: InputMaybe<StringOperationFilterInput>;
  adresse3?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AtlasAdresseFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  cedex?: InputMaybe<StringOperationFilterInput>;
  codePostalCode?: InputMaybe<StringOperationFilterInput>;
  complement?: InputMaybe<StringOperationFilterInput>;
  consultantStatutJuridiques?: InputMaybe<ListFilterInputTypeOfAtlasConsultantStatutJuridiqueFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  modeLogement?: InputMaybe<StringOperationFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AtlasAdresseFilterInput>>;
  paysCode?: InputMaybe<StringOperationFilterInput>;
  paysCodeNavigation?: InputMaybe<AtlasPaysFilterInput>;
  personnePhysiqueAdresses?: InputMaybe<ListFilterInputTypeOfAtlasPersonnePhysiqueAdresseFilterInput>;
  typeAdresseCode?: InputMaybe<StringOperationFilterInput>;
  villeNom?: InputMaybe<StringOperationFilterInput>;
};

export type AtlasCategorieSocioProfessionnelle = {
  __typename?: 'AtlasCategorieSocioProfessionnelle';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['Byte']['output'];
  inverseParentNavigation: Array<AtlasCategorieSocioProfessionnelle>;
  libelle: Scalars['String']['output'];
  parent?: Maybe<Scalars['Byte']['output']>;
  parentNavigation?: Maybe<AtlasCategorieSocioProfessionnelle>;
  situationProfessionnelles: Array<AtlasSituationProfessionnelle>;
};


export type AtlasCategorieSocioProfessionnelleInverseParentNavigationArgs = {
  where?: InputMaybe<AtlasCategorieSocioProfessionnelleFilterInput>;
};


export type AtlasCategorieSocioProfessionnelleSituationProfessionnellesArgs = {
  where?: InputMaybe<AtlasSituationProfessionnelleFilterInput>;
};

export type AtlasCategorieSocioProfessionnelleFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<AtlasCategorieSocioProfessionnelleFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  inverseParentNavigation?: InputMaybe<ListFilterInputTypeOfAtlasCategorieSocioProfessionnelleFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AtlasCategorieSocioProfessionnelleFilterInput>>;
  parent?: InputMaybe<ByteOperationFilterInput>;
  parentNavigation?: InputMaybe<AtlasCategorieSocioProfessionnelleFilterInput>;
  situationProfessionnelles?: InputMaybe<ListFilterInputTypeOfAtlasSituationProfessionnelleFilterInput>;
};

export type AtlasConsultant = {
  __typename?: 'AtlasConsultant';
  affiliationDate?: Maybe<Scalars['DateTime']['output']>;
  arianeId?: Maybe<Scalars['Long']['output']>;
  code: Scalars['String']['output'];
  codeTier?: Maybe<Scalars['String']['output']>;
  commentairePeriodeJunior?: Maybe<Scalars['String']['output']>;
  consultantPersonnePhysiques: Array<AtlasConsultantPersonnePhysique>;
  consultantStatutJuridiques: Array<AtlasConsultantStatutJuridique>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  date1AcquisitionDroit?: Maybe<Scalars['DateTime']['output']>;
  date1Manager?: Maybe<Scalars['DateTime']['output']>;
  date1VenteActee?: Maybe<Scalars['DateTime']['output']>;
  date1VenteFinancement?: Maybe<Scalars['DateTime']['output']>;
  date1VenteImmo?: Maybe<Scalars['DateTime']['output']>;
  date1VentePlacement?: Maybe<Scalars['DateTime']['output']>;
  dateAcquisitionDroit?: Maybe<Scalars['DateTime']['output']>;
  dateAffiliationProdemial?: Maybe<Scalars['DateTime']['output']>;
  dateContact?: Maybe<Scalars['DateTime']['output']>;
  dateDemission?: Maybe<Scalars['DateTime']['output']>;
  dateEntree?: Maybe<Scalars['DateTime']['output']>;
  dateFinPeriodeJunior?: Maybe<Scalars['DateTime']['output']>;
  dateFinValiditeAffiliation?: Maybe<Scalars['DateTime']['output']>;
  dateSeminairePro?: Maybe<Scalars['DateTime']['output']>;
  derniereDateExclusif?: Maybe<Scalars['DateTime']['output']>;
  derniereDateNonExclusif?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  eligilibleRenouvellement: Scalars['Boolean']['output'];
  exclusif: Scalars['Boolean']['output'];
  galaxy?: Maybe<AtlasConsultant>;
  galaxyId?: Maybe<Scalars['Long']['output']>;
  gerePar: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  inverseGalaxy: Array<AtlasConsultant>;
  inverseManager: Array<AtlasConsultant>;
  inverseParrain: Array<AtlasConsultant>;
  inverseTeteReseau: Array<AtlasConsultant>;
  investisseurConsultants: Array<AtlasInvestisseurConsultant>;
  manager?: Maybe<AtlasConsultant>;
  managerId?: Maybe<Scalars['Long']['output']>;
  mandatAutofacFinancement?: Maybe<Scalars['Byte']['output']>;
  mandatAutofacPlacement?: Maybe<Scalars['Byte']['output']>;
  mandatAutofacTotal?: Maybe<Scalars['Byte']['output']>;
  motifResiliationCode?: Maybe<Scalars['String']['output']>;
  nbAmbassadeurs?: Maybe<Scalars['Byte']['output']>;
  nbRecommandations?: Maybe<Scalars['Byte']['output']>;
  origineSaisie: Scalars['Byte']['output'];
  parrain?: Maybe<AtlasConsultant>;
  parrainId?: Maybe<Scalars['Long']['output']>;
  peutParainner?: Maybe<Scalars['Boolean']['output']>;
  qualificationCode?: Maybe<Scalars['String']['output']>;
  qualificationOfficielleCode?: Maybe<Scalars['String']['output']>;
  raisonSociale?: Maybe<Scalars['String']['output']>;
  reponseRenouvellement?: Maybe<Scalars['Byte']['output']>;
  resiliationDate?: Maybe<Scalars['DateTime']['output']>;
  souhaiteCollaborerAvecStelliumFi?: Maybe<Scalars['Boolean']['output']>;
  statutCode: Scalars['String']['output'];
  tauxRemuneration?: Maybe<Scalars['Decimal']['output']>;
  tauxRemunerationOfficiel?: Maybe<Scalars['Decimal']['output']>;
  teteReseau?: Maybe<AtlasConsultant>;
  teteReseauId?: Maybe<Scalars['Long']['output']>;
  titreCode?: Maybe<Scalars['String']['output']>;
  totalDebours?: Maybe<Scalars['Decimal']['output']>;
};


export type AtlasConsultantConsultantPersonnePhysiquesArgs = {
  where?: InputMaybe<AtlasConsultantPersonnePhysiqueFilterInput>;
};


export type AtlasConsultantConsultantStatutJuridiquesArgs = {
  where?: InputMaybe<AtlasConsultantStatutJuridiqueFilterInput>;
};


export type AtlasConsultantInverseGalaxyArgs = {
  where?: InputMaybe<AtlasConsultantFilterInput>;
};


export type AtlasConsultantInverseManagerArgs = {
  where?: InputMaybe<AtlasConsultantFilterInput>;
};


export type AtlasConsultantInverseParrainArgs = {
  where?: InputMaybe<AtlasConsultantFilterInput>;
};


export type AtlasConsultantInverseTeteReseauArgs = {
  where?: InputMaybe<AtlasConsultantFilterInput>;
};


export type AtlasConsultantInvestisseurConsultantsArgs = {
  where?: InputMaybe<AtlasInvestisseurConsultantFilterInput>;
};

export type AtlasConsultantFilterInput = {
  affiliationDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<AtlasConsultantFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  codeTier?: InputMaybe<StringOperationFilterInput>;
  commentairePeriodeJunior?: InputMaybe<StringOperationFilterInput>;
  consultantPersonnePhysiques?: InputMaybe<ListFilterInputTypeOfAtlasConsultantPersonnePhysiqueFilterInput>;
  consultantStatutJuridiques?: InputMaybe<ListFilterInputTypeOfAtlasConsultantStatutJuridiqueFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  date1AcquisitionDroit?: InputMaybe<DateTimeOperationFilterInput>;
  date1Manager?: InputMaybe<DateTimeOperationFilterInput>;
  date1VenteActee?: InputMaybe<DateTimeOperationFilterInput>;
  date1VenteFinancement?: InputMaybe<DateTimeOperationFilterInput>;
  date1VenteImmo?: InputMaybe<DateTimeOperationFilterInput>;
  date1VentePlacement?: InputMaybe<DateTimeOperationFilterInput>;
  dateAcquisitionDroit?: InputMaybe<DateTimeOperationFilterInput>;
  dateAffiliationProdemial?: InputMaybe<DateTimeOperationFilterInput>;
  dateContact?: InputMaybe<DateTimeOperationFilterInput>;
  dateDemission?: InputMaybe<DateTimeOperationFilterInput>;
  dateEntree?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinPeriodeJunior?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinValiditeAffiliation?: InputMaybe<DateTimeOperationFilterInput>;
  dateSeminairePro?: InputMaybe<DateTimeOperationFilterInput>;
  derniereDateExclusif?: InputMaybe<DateTimeOperationFilterInput>;
  derniereDateNonExclusif?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  eligilibleRenouvellement?: InputMaybe<BooleanOperationFilterInput>;
  exclusif?: InputMaybe<BooleanOperationFilterInput>;
  galaxy?: InputMaybe<AtlasConsultantFilterInput>;
  galaxyId?: InputMaybe<LongOperationFilterInput>;
  gerePar?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  inverseGalaxy?: InputMaybe<ListFilterInputTypeOfAtlasConsultantFilterInput>;
  inverseManager?: InputMaybe<ListFilterInputTypeOfAtlasConsultantFilterInput>;
  inverseParrain?: InputMaybe<ListFilterInputTypeOfAtlasConsultantFilterInput>;
  inverseTeteReseau?: InputMaybe<ListFilterInputTypeOfAtlasConsultantFilterInput>;
  investisseurConsultants?: InputMaybe<ListFilterInputTypeOfAtlasInvestisseurConsultantFilterInput>;
  manager?: InputMaybe<AtlasConsultantFilterInput>;
  managerId?: InputMaybe<LongOperationFilterInput>;
  mandatAutofacFinancement?: InputMaybe<ByteOperationFilterInput>;
  mandatAutofacPlacement?: InputMaybe<ByteOperationFilterInput>;
  mandatAutofacTotal?: InputMaybe<ByteOperationFilterInput>;
  motifResiliationCode?: InputMaybe<StringOperationFilterInput>;
  nbAmbassadeurs?: InputMaybe<ByteOperationFilterInput>;
  nbRecommandations?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<AtlasConsultantFilterInput>>;
  origineSaisie?: InputMaybe<ByteOperationFilterInput>;
  parrain?: InputMaybe<AtlasConsultantFilterInput>;
  parrainId?: InputMaybe<LongOperationFilterInput>;
  peutParainner?: InputMaybe<BooleanOperationFilterInput>;
  qualificationCode?: InputMaybe<StringOperationFilterInput>;
  qualificationOfficielleCode?: InputMaybe<StringOperationFilterInput>;
  raisonSociale?: InputMaybe<StringOperationFilterInput>;
  reponseRenouvellement?: InputMaybe<ByteOperationFilterInput>;
  resiliationDate?: InputMaybe<DateTimeOperationFilterInput>;
  souhaiteCollaborerAvecStelliumFi?: InputMaybe<BooleanOperationFilterInput>;
  statutCode?: InputMaybe<StringOperationFilterInput>;
  tauxRemuneration?: InputMaybe<DecimalOperationFilterInput>;
  tauxRemunerationOfficiel?: InputMaybe<DecimalOperationFilterInput>;
  teteReseau?: InputMaybe<AtlasConsultantFilterInput>;
  teteReseauId?: InputMaybe<LongOperationFilterInput>;
  titreCode?: InputMaybe<StringOperationFilterInput>;
  totalDebours?: InputMaybe<DecimalOperationFilterInput>;
};

export type AtlasConsultantPersonnePhysique = {
  __typename?: 'AtlasConsultantPersonnePhysique';
  consultant: AtlasConsultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  personnePhysique: AtlasPersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
};

export type AtlasConsultantPersonnePhysiqueFilterInput = {
  and?: InputMaybe<Array<AtlasConsultantPersonnePhysiqueFilterInput>>;
  consultant?: InputMaybe<AtlasConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AtlasConsultantPersonnePhysiqueFilterInput>>;
  personnePhysique?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
};

export type AtlasConsultantSortInput = {
  affiliationDate?: InputMaybe<SortEnumType>;
  arianeId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  codeTier?: InputMaybe<SortEnumType>;
  commentairePeriodeJunior?: InputMaybe<SortEnumType>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  date1AcquisitionDroit?: InputMaybe<SortEnumType>;
  date1Manager?: InputMaybe<SortEnumType>;
  date1VenteActee?: InputMaybe<SortEnumType>;
  date1VenteFinancement?: InputMaybe<SortEnumType>;
  date1VenteImmo?: InputMaybe<SortEnumType>;
  date1VentePlacement?: InputMaybe<SortEnumType>;
  dateAcquisitionDroit?: InputMaybe<SortEnumType>;
  dateAffiliationProdemial?: InputMaybe<SortEnumType>;
  dateContact?: InputMaybe<SortEnumType>;
  dateDemission?: InputMaybe<SortEnumType>;
  dateEntree?: InputMaybe<SortEnumType>;
  dateFinPeriodeJunior?: InputMaybe<SortEnumType>;
  dateFinValiditeAffiliation?: InputMaybe<SortEnumType>;
  dateSeminairePro?: InputMaybe<SortEnumType>;
  derniereDateExclusif?: InputMaybe<SortEnumType>;
  derniereDateNonExclusif?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  eligilibleRenouvellement?: InputMaybe<SortEnumType>;
  exclusif?: InputMaybe<SortEnumType>;
  galaxy?: InputMaybe<AtlasConsultantSortInput>;
  galaxyId?: InputMaybe<SortEnumType>;
  gerePar?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  manager?: InputMaybe<AtlasConsultantSortInput>;
  managerId?: InputMaybe<SortEnumType>;
  mandatAutofacFinancement?: InputMaybe<SortEnumType>;
  mandatAutofacPlacement?: InputMaybe<SortEnumType>;
  mandatAutofacTotal?: InputMaybe<SortEnumType>;
  motifResiliationCode?: InputMaybe<SortEnumType>;
  nbAmbassadeurs?: InputMaybe<SortEnumType>;
  nbRecommandations?: InputMaybe<SortEnumType>;
  origineSaisie?: InputMaybe<SortEnumType>;
  parrain?: InputMaybe<AtlasConsultantSortInput>;
  parrainId?: InputMaybe<SortEnumType>;
  peutParainner?: InputMaybe<SortEnumType>;
  qualificationCode?: InputMaybe<SortEnumType>;
  qualificationOfficielleCode?: InputMaybe<SortEnumType>;
  raisonSociale?: InputMaybe<SortEnumType>;
  reponseRenouvellement?: InputMaybe<SortEnumType>;
  resiliationDate?: InputMaybe<SortEnumType>;
  souhaiteCollaborerAvecStelliumFi?: InputMaybe<SortEnumType>;
  statutCode?: InputMaybe<SortEnumType>;
  tauxRemuneration?: InputMaybe<SortEnumType>;
  tauxRemunerationOfficiel?: InputMaybe<SortEnumType>;
  teteReseau?: InputMaybe<AtlasConsultantSortInput>;
  teteReseauId?: InputMaybe<SortEnumType>;
  titreCode?: InputMaybe<SortEnumType>;
  totalDebours?: InputMaybe<SortEnumType>;
};

export type AtlasConsultantStatutJuridique = {
  __typename?: 'AtlasConsultantStatutJuridique';
  actif: Scalars['Boolean']['output'];
  adressePro: AtlasAdresse;
  adresseProId: Scalars['Long']['output'];
  assujettiTVACode?: Maybe<Scalars['String']['output']>;
  codeTier?: Maybe<Scalars['String']['output']>;
  commissionDifferenceImmo: Scalars['Boolean']['output'];
  commissionDifferencePlacement: Scalars['Boolean']['output'];
  consultant: AtlasConsultant;
  consultantId: Scalars['Long']['output'];
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateAttest3558?: Maybe<Scalars['DateTime']['output']>;
  dateAttestHonneur?: Maybe<Scalars['DateTime']['output']>;
  dateAttestKbisPerso?: Maybe<Scalars['DateTime']['output']>;
  dateAttestUrssafSociete?: Maybe<Scalars['DateTime']['output']>;
  dateKBISOriginal?: Maybe<Scalars['DateTime']['output']>;
  dateUrssafPer?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatStatutCode: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  nomCommercial?: Maybe<Scalars['String']['output']>;
  numeroTva?: Maybe<Scalars['String']['output']>;
  raisonSociale?: Maybe<Scalars['String']['output']>;
  siret?: Maybe<Scalars['String']['output']>;
  statutJuridiqueCode: Scalars['String']['output'];
  typeSocieteCode?: Maybe<Scalars['String']['output']>;
  villeSiret?: Maybe<Scalars['String']['output']>;
};

export type AtlasConsultantStatutJuridiqueFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  adressePro?: InputMaybe<AtlasAdresseFilterInput>;
  adresseProId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<AtlasConsultantStatutJuridiqueFilterInput>>;
  assujettiTVACode?: InputMaybe<StringOperationFilterInput>;
  codeTier?: InputMaybe<StringOperationFilterInput>;
  commissionDifferenceImmo?: InputMaybe<BooleanOperationFilterInput>;
  commissionDifferencePlacement?: InputMaybe<BooleanOperationFilterInput>;
  consultant?: InputMaybe<AtlasConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttest3558?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttestHonneur?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttestKbisPerso?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttestUrssafSociete?: InputMaybe<DateTimeOperationFilterInput>;
  dateKBISOriginal?: InputMaybe<DateTimeOperationFilterInput>;
  dateUrssafPer?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatStatutCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  nomCommercial?: InputMaybe<StringOperationFilterInput>;
  numeroTva?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AtlasConsultantStatutJuridiqueFilterInput>>;
  raisonSociale?: InputMaybe<StringOperationFilterInput>;
  siret?: InputMaybe<StringOperationFilterInput>;
  statutJuridiqueCode?: InputMaybe<StringOperationFilterInput>;
  typeSocieteCode?: InputMaybe<StringOperationFilterInput>;
  villeSiret?: InputMaybe<StringOperationFilterInput>;
};

export type AtlasDisposition = {
  __typename?: 'AtlasDisposition';
  autresDispositions?: Maybe<Scalars['Boolean']['output']>;
  autresDonation?: Maybe<Scalars['Boolean']['output']>;
  beneficiaire?: Maybe<Scalars['String']['output']>;
  dateDonation?: Maybe<Scalars['LocalDate']['output']>;
  demembrement?: Maybe<Scalars['String']['output']>;
  donationConjoint?: Maybe<Scalars['Boolean']['output']>;
  donationDernierVivant?: Maybe<Scalars['Boolean']['output']>;
  donationPartage?: Maybe<Scalars['Boolean']['output']>;
  forme?: Maybe<Scalars['String']['output']>;
  legsParticuliers?: Maybe<Scalars['Boolean']['output']>;
  legsUniversels?: Maybe<Scalars['Boolean']['output']>;
  montant?: Maybe<Scalars['Int']['output']>;
  objet?: Maybe<Scalars['String']['output']>;
  personnePhysique: AtlasPersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
};

export type AtlasDispositionFilterInput = {
  and?: InputMaybe<Array<AtlasDispositionFilterInput>>;
  autresDispositions?: InputMaybe<BooleanOperationFilterInput>;
  autresDonation?: InputMaybe<BooleanOperationFilterInput>;
  beneficiaire?: InputMaybe<StringOperationFilterInput>;
  dateDonation?: InputMaybe<LocalDateOperationFilterInput>;
  demembrement?: InputMaybe<StringOperationFilterInput>;
  donationConjoint?: InputMaybe<BooleanOperationFilterInput>;
  donationDernierVivant?: InputMaybe<BooleanOperationFilterInput>;
  donationPartage?: InputMaybe<BooleanOperationFilterInput>;
  forme?: InputMaybe<StringOperationFilterInput>;
  legsParticuliers?: InputMaybe<BooleanOperationFilterInput>;
  legsUniversels?: InputMaybe<BooleanOperationFilterInput>;
  montant?: InputMaybe<IntOperationFilterInput>;
  objet?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AtlasDispositionFilterInput>>;
  personnePhysique?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
};

export type AtlasEmail = {
  __typename?: 'AtlasEmail';
  adresse: Scalars['String']['output'];
  arianeId?: Maybe<Scalars['Long']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  estAdresseCorrespondance?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  noteId?: Maybe<Scalars['Long']['output']>;
  personnePhysiqueEmails: Array<AtlasPersonnePhysiqueEmail>;
  typeEmailCode: Scalars['String']['output'];
};


export type AtlasEmailPersonnePhysiqueEmailsArgs = {
  where?: InputMaybe<AtlasPersonnePhysiqueEmailFilterInput>;
};

export type AtlasEmailFilterInput = {
  adresse?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AtlasEmailFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  estAdresseCorrespondance?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AtlasEmailFilterInput>>;
  personnePhysiqueEmails?: InputMaybe<ListFilterInputTypeOfAtlasPersonnePhysiqueEmailFilterInput>;
  typeEmailCode?: InputMaybe<StringOperationFilterInput>;
};

export type AtlasEtatCivil = {
  __typename?: 'AtlasEtatCivil';
  codePaysResidenceStableCouple?: Maybe<Scalars['String']['output']>;
  codePaysResidenceStableCoupleNavigation?: Maybe<AtlasPays>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateChangementSituation?: Maybe<Scalars['LocalDate']['output']>;
  dateContratUnion?: Maybe<Scalars['LocalDate']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  foyerFiscalIdentique: Scalars['Boolean']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  lieuContratUnion?: Maybe<Scalars['String']['output']>;
  nombreEnfantACharge?: Maybe<Scalars['Byte']['output']>;
  noteId?: Maybe<Scalars['Long']['output']>;
  personnePhysique: AtlasPersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
  regimePacsIndivision?: Maybe<Scalars['Boolean']['output']>;
  typeAvantageMatrimonialCode?: Maybe<Scalars['String']['output']>;
  typeRegimeSituationEtatCivilCode?: Maybe<Scalars['String']['output']>;
  typeSituationEtatCivilCode?: Maybe<Scalars['String']['output']>;
  typeSituationEtatCivilCodeNavigation?: Maybe<AtlasTypeSituationEtatCivil>;
};

export type AtlasEtatCivilFilterInput = {
  and?: InputMaybe<Array<AtlasEtatCivilFilterInput>>;
  codePaysResidenceStableCouple?: InputMaybe<StringOperationFilterInput>;
  codePaysResidenceStableCoupleNavigation?: InputMaybe<AtlasPaysFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateChangementSituation?: InputMaybe<LocalDateOperationFilterInput>;
  dateContratUnion?: InputMaybe<LocalDateOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  foyerFiscalIdentique?: InputMaybe<BooleanOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  lieuContratUnion?: InputMaybe<StringOperationFilterInput>;
  nombreEnfantACharge?: InputMaybe<ByteOperationFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AtlasEtatCivilFilterInput>>;
  personnePhysique?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  regimePacsIndivision?: InputMaybe<BooleanOperationFilterInput>;
  typeAvantageMatrimonialCode?: InputMaybe<StringOperationFilterInput>;
  typeRegimeSituationEtatCivilCode?: InputMaybe<StringOperationFilterInput>;
  typeSituationEtatCivilCode?: InputMaybe<StringOperationFilterInput>;
  typeSituationEtatCivilCodeNavigation?: InputMaybe<AtlasTypeSituationEtatCivilFilterInput>;
};

export type AtlasInvestisseur = {
  __typename?: 'AtlasInvestisseur';
  arianeId?: Maybe<Scalars['Long']['output']>;
  code: Scalars['String']['output'];
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateConnaissance?: Maybe<Scalars['LocalDate']['output']>;
  dateDernierScanAccuity?: Maybe<Scalars['LocalDate']['output']>;
  dateEntreeRelation?: Maybe<Scalars['LocalDate']['output']>;
  dateMajScanAccuityRequis?: Maybe<Scalars['LocalDate']['output']>;
  dateSuppression?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  gdaBackOffice?: Maybe<Scalars['Boolean']['output']>;
  gerePar: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  idSourceAramis?: Maybe<Scalars['String']['output']>;
  idSourceDiapason?: Maybe<Scalars['String']['output']>;
  inverseRecommandePar: Array<AtlasInvestisseur>;
  investisseurConsultants: Array<AtlasInvestisseurConsultant>;
  investisseurPersonnePhysiques: Array<AtlasInvestisseurPersonnePhysique>;
  logiqueSuppression?: Maybe<Scalars['Boolean']['output']>;
  modeCommunication?: Maybe<Scalars['String']['output']>;
  objectifMontantEpargneMensuel?: Maybe<Scalars['Decimal']['output']>;
  objectifMontantEpargnePrecaution?: Maybe<Scalars['Decimal']['output']>;
  origineContactCode?: Maybe<Scalars['String']['output']>;
  origineSaisie?: Maybe<Scalars['Byte']['output']>;
  ppeBackOffice?: Maybe<Scalars['Boolean']['output']>;
  recommandePar?: Maybe<AtlasInvestisseur>;
  recommandeParId?: Maybe<Scalars['Long']['output']>;
  recommandeParNom?: Maybe<Scalars['String']['output']>;
  scanAccuityRequis?: Maybe<Scalars['Boolean']['output']>;
  statutCode: Scalars['String']['output'];
};


export type AtlasInvestisseurInverseRecommandeParArgs = {
  where?: InputMaybe<AtlasInvestisseurFilterInput>;
};


export type AtlasInvestisseurInvestisseurConsultantsArgs = {
  where?: InputMaybe<AtlasInvestisseurConsultantFilterInput>;
};


export type AtlasInvestisseurInvestisseurPersonnePhysiquesArgs = {
  where?: InputMaybe<AtlasInvestisseurPersonnePhysiqueFilterInput>;
};

export type AtlasInvestisseurConsultant = {
  __typename?: 'AtlasInvestisseurConsultant';
  actif: Scalars['Int']['output'];
  arianeId?: Maybe<Scalars['Long']['output']>;
  batchDateUpdate?: Maybe<Scalars['DateTime']['output']>;
  causeDesactivation?: Maybe<Scalars['Byte']['output']>;
  consultant: AtlasConsultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateActivation: Scalars['DateTime']['output'];
  dateDesactivation?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  investisseur: AtlasInvestisseur;
  investisseurId: Scalars['Long']['output'];
  typeRelationInvestisseurConsultantCode: Scalars['String']['output'];
};

export type AtlasInvestisseurConsultantFilterInput = {
  actif?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<AtlasInvestisseurConsultantFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  batchDateUpdate?: InputMaybe<DateTimeOperationFilterInput>;
  causeDesactivation?: InputMaybe<ByteOperationFilterInput>;
  consultant?: InputMaybe<AtlasConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateActivation?: InputMaybe<DateTimeOperationFilterInput>;
  dateDesactivation?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<AtlasInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AtlasInvestisseurConsultantFilterInput>>;
  typeRelationInvestisseurConsultantCode?: InputMaybe<StringOperationFilterInput>;
};

export type AtlasInvestisseurFilterInput = {
  and?: InputMaybe<Array<AtlasInvestisseurFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateConnaissance?: InputMaybe<LocalDateOperationFilterInput>;
  dateDernierScanAccuity?: InputMaybe<LocalDateOperationFilterInput>;
  dateEntreeRelation?: InputMaybe<LocalDateOperationFilterInput>;
  dateMajScanAccuityRequis?: InputMaybe<LocalDateOperationFilterInput>;
  dateSuppression?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  gdaBackOffice?: InputMaybe<BooleanOperationFilterInput>;
  gerePar?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSourceAramis?: InputMaybe<StringOperationFilterInput>;
  idSourceDiapason?: InputMaybe<StringOperationFilterInput>;
  inverseRecommandePar?: InputMaybe<ListFilterInputTypeOfAtlasInvestisseurFilterInput>;
  investisseurConsultants?: InputMaybe<ListFilterInputTypeOfAtlasInvestisseurConsultantFilterInput>;
  investisseurPersonnePhysiques?: InputMaybe<ListFilterInputTypeOfAtlasInvestisseurPersonnePhysiqueFilterInput>;
  logiqueSuppression?: InputMaybe<BooleanOperationFilterInput>;
  modeCommunication?: InputMaybe<StringOperationFilterInput>;
  objectifMontantEpargneMensuel?: InputMaybe<DecimalOperationFilterInput>;
  objectifMontantEpargnePrecaution?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<AtlasInvestisseurFilterInput>>;
  origineContactCode?: InputMaybe<StringOperationFilterInput>;
  origineSaisie?: InputMaybe<ByteOperationFilterInput>;
  ppeBackOffice?: InputMaybe<BooleanOperationFilterInput>;
  recommandePar?: InputMaybe<AtlasInvestisseurFilterInput>;
  recommandeParId?: InputMaybe<LongOperationFilterInput>;
  recommandeParNom?: InputMaybe<StringOperationFilterInput>;
  scanAccuityRequis?: InputMaybe<BooleanOperationFilterInput>;
  statutCode?: InputMaybe<StringOperationFilterInput>;
};

export type AtlasInvestisseurPersonnePhysique = {
  __typename?: 'AtlasInvestisseurPersonnePhysique';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  investisseur: AtlasInvestisseur;
  investisseurId: Scalars['Long']['output'];
  personnePhysique: AtlasPersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
};

export type AtlasInvestisseurPersonnePhysiqueFilterInput = {
  and?: InputMaybe<Array<AtlasInvestisseurPersonnePhysiqueFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  investisseur?: InputMaybe<AtlasInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AtlasInvestisseurPersonnePhysiqueFilterInput>>;
  personnePhysique?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
};

export type AtlasInvestisseurSortInput = {
  arianeId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateConnaissance?: InputMaybe<SortEnumType>;
  dateDernierScanAccuity?: InputMaybe<SortEnumType>;
  dateEntreeRelation?: InputMaybe<SortEnumType>;
  dateMajScanAccuityRequis?: InputMaybe<SortEnumType>;
  dateSuppression?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  gdaBackOffice?: InputMaybe<SortEnumType>;
  gerePar?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSourceAramis?: InputMaybe<SortEnumType>;
  idSourceDiapason?: InputMaybe<SortEnumType>;
  logiqueSuppression?: InputMaybe<SortEnumType>;
  modeCommunication?: InputMaybe<SortEnumType>;
  objectifMontantEpargneMensuel?: InputMaybe<SortEnumType>;
  objectifMontantEpargnePrecaution?: InputMaybe<SortEnumType>;
  origineContactCode?: InputMaybe<SortEnumType>;
  origineSaisie?: InputMaybe<SortEnumType>;
  ppeBackOffice?: InputMaybe<SortEnumType>;
  recommandePar?: InputMaybe<AtlasInvestisseurSortInput>;
  recommandeParId?: InputMaybe<SortEnumType>;
  recommandeParNom?: InputMaybe<SortEnumType>;
  scanAccuityRequis?: InputMaybe<SortEnumType>;
  statutCode?: InputMaybe<SortEnumType>;
};

export type AtlasPays = {
  __typename?: 'AtlasPays';
  actif?: Maybe<Scalars['Boolean']['output']>;
  adresses: Array<AtlasAdresse>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatCivils: Array<AtlasEtatCivil>;
  inverseNationaliteCodeNavigation: Array<AtlasPays>;
  libelle: Scalars['String']['output'];
  nationalite?: Maybe<Scalars['String']['output']>;
  nationaliteCode: Scalars['String']['output'];
  nationaliteCodeNavigation: AtlasPays;
  personnePhysiqueCodePaysNaissanceNavigations: Array<AtlasPersonnePhysique>;
  personnePhysiqueCodePaysNationaliteNavigations: Array<AtlasPersonnePhysique>;
  personnePhysiqueCodePaysNationaliteSecondaireNavigations: Array<AtlasPersonnePhysique>;
  reglementairesCodePaysFactaResidenceFiscaleNavigations: Array<AtlasReglementaire>;
  reglementairesCodePaysPpeNavigations: Array<AtlasReglementaire>;
};


export type AtlasPaysAdressesArgs = {
  where?: InputMaybe<AtlasAdresseFilterInput>;
};


export type AtlasPaysEtatCivilsArgs = {
  where?: InputMaybe<AtlasEtatCivilFilterInput>;
};


export type AtlasPaysInverseNationaliteCodeNavigationArgs = {
  where?: InputMaybe<AtlasPaysFilterInput>;
};


export type AtlasPaysPersonnePhysiqueCodePaysNaissanceNavigationsArgs = {
  where?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
};


export type AtlasPaysPersonnePhysiqueCodePaysNationaliteNavigationsArgs = {
  where?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
};


export type AtlasPaysPersonnePhysiqueCodePaysNationaliteSecondaireNavigationsArgs = {
  where?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
};


export type AtlasPaysReglementairesCodePaysFactaResidenceFiscaleNavigationsArgs = {
  where?: InputMaybe<AtlasReglementaireFilterInput>;
};


export type AtlasPaysReglementairesCodePaysPpeNavigationsArgs = {
  where?: InputMaybe<AtlasReglementaireFilterInput>;
};

export type AtlasPaysFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  adresses?: InputMaybe<ListFilterInputTypeOfAtlasAdresseFilterInput>;
  and?: InputMaybe<Array<AtlasPaysFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatCivils?: InputMaybe<ListFilterInputTypeOfAtlasEtatCivilFilterInput>;
  inverseNationaliteCodeNavigation?: InputMaybe<ListFilterInputTypeOfAtlasPaysFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  nationalite?: InputMaybe<StringOperationFilterInput>;
  nationaliteCode?: InputMaybe<StringOperationFilterInput>;
  nationaliteCodeNavigation?: InputMaybe<AtlasPaysFilterInput>;
  or?: InputMaybe<Array<AtlasPaysFilterInput>>;
  personnePhysiqueCodePaysNaissanceNavigations?: InputMaybe<ListFilterInputTypeOfAtlasPersonnePhysiqueFilterInput>;
  personnePhysiqueCodePaysNationaliteNavigations?: InputMaybe<ListFilterInputTypeOfAtlasPersonnePhysiqueFilterInput>;
  personnePhysiqueCodePaysNationaliteSecondaireNavigations?: InputMaybe<ListFilterInputTypeOfAtlasPersonnePhysiqueFilterInput>;
  reglementairesCodePaysFactaResidenceFiscaleNavigations?: InputMaybe<ListFilterInputTypeOfAtlasReglementaireFilterInput>;
  reglementairesCodePaysPpeNavigations?: InputMaybe<ListFilterInputTypeOfAtlasReglementaireFilterInput>;
};

export type AtlasPersonnePhysique = {
  __typename?: 'AtlasPersonnePhysique';
  arianeId?: Maybe<Scalars['Long']['output']>;
  civiliteCode: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  codePaysNaissance?: Maybe<Scalars['String']['output']>;
  codePaysNaissanceNavigation?: Maybe<AtlasPays>;
  codePaysNationalite?: Maybe<Scalars['String']['output']>;
  codePaysNationaliteNavigation?: Maybe<AtlasPays>;
  codePaysNationaliteSecondaire?: Maybe<Scalars['String']['output']>;
  codePaysNationaliteSecondaireNavigation?: Maybe<AtlasPays>;
  codePostaleNaissance?: Maybe<Scalars['String']['output']>;
  consultantPersonnePhysiques: Array<AtlasConsultantPersonnePhysique>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateNaissance?: Maybe<Scalars['LocalDate']['output']>;
  departementNaissance?: Maybe<Scalars['String']['output']>;
  deuxiemePrenom?: Maybe<Scalars['String']['output']>;
  disposition?: Maybe<AtlasDisposition>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatCivil?: Maybe<AtlasEtatCivil>;
  fullNameSearchText: Scalars['String']['output'];
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseurPersonnePhysiques: Array<AtlasInvestisseurPersonnePhysique>;
  login?: Maybe<Scalars['String']['output']>;
  mesureProtectionDate?: Maybe<Scalars['LocalDate']['output']>;
  nom: Scalars['String']['output'];
  nomCompletDeuxiemeParent?: Maybe<Scalars['String']['output']>;
  nomCompletPremierParent?: Maybe<Scalars['String']['output']>;
  nomNaissance?: Maybe<Scalars['String']['output']>;
  nomNaissanceUniformise?: Maybe<Scalars['String']['output']>;
  nomUniformise: Scalars['String']['output'];
  personnePhysiqueAdresses: Array<AtlasPersonnePhysiqueAdresse>;
  personnePhysiqueEmails: Array<AtlasPersonnePhysiqueEmail>;
  personnePhysiqueTelephones: Array<AtlasPersonnePhysiqueTelephone>;
  prenom: Scalars['String']['output'];
  prenomUniformise: Scalars['String']['output'];
  reglementaire?: Maybe<AtlasReglementaire>;
  relationCouples1: Array<AtlasRelationCouple>;
  relationCouples2: Array<AtlasRelationCouple>;
  situationProfessionnelle?: Maybe<AtlasSituationProfessionnelle>;
  troisiemePrenom?: Maybe<Scalars['String']['output']>;
  typeMesureProtectionCode?: Maybe<Scalars['String']['output']>;
  villeNaissanceNom?: Maybe<Scalars['String']['output']>;
};


export type AtlasPersonnePhysiqueConsultantPersonnePhysiquesArgs = {
  where?: InputMaybe<AtlasConsultantPersonnePhysiqueFilterInput>;
};


export type AtlasPersonnePhysiqueInvestisseurPersonnePhysiquesArgs = {
  where?: InputMaybe<AtlasInvestisseurPersonnePhysiqueFilterInput>;
};


export type AtlasPersonnePhysiquePersonnePhysiqueAdressesArgs = {
  where?: InputMaybe<AtlasPersonnePhysiqueAdresseFilterInput>;
};


export type AtlasPersonnePhysiquePersonnePhysiqueEmailsArgs = {
  where?: InputMaybe<AtlasPersonnePhysiqueEmailFilterInput>;
};


export type AtlasPersonnePhysiquePersonnePhysiqueTelephonesArgs = {
  where?: InputMaybe<AtlasPersonnePhysiqueTelephoneFilterInput>;
};


export type AtlasPersonnePhysiqueRelationCouples1Args = {
  where?: InputMaybe<AtlasRelationCoupleFilterInput>;
};


export type AtlasPersonnePhysiqueRelationCouples2Args = {
  where?: InputMaybe<AtlasRelationCoupleFilterInput>;
};

export type AtlasPersonnePhysiqueAdresse = {
  __typename?: 'AtlasPersonnePhysiqueAdresse';
  adresse: AtlasAdresse;
  adresseId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  personnePhysique: AtlasPersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
};

export type AtlasPersonnePhysiqueAdresseFilterInput = {
  adresse?: InputMaybe<AtlasAdresseFilterInput>;
  adresseId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<AtlasPersonnePhysiqueAdresseFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AtlasPersonnePhysiqueAdresseFilterInput>>;
  personnePhysique?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
};

export type AtlasPersonnePhysiqueEmail = {
  __typename?: 'AtlasPersonnePhysiqueEmail';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  email: AtlasEmail;
  emailId: Scalars['Long']['output'];
  personnePhysique: AtlasPersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
};

export type AtlasPersonnePhysiqueEmailFilterInput = {
  and?: InputMaybe<Array<AtlasPersonnePhysiqueEmailFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<AtlasEmailFilterInput>;
  emailId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AtlasPersonnePhysiqueEmailFilterInput>>;
  personnePhysique?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
};

export type AtlasPersonnePhysiqueFilterInput = {
  and?: InputMaybe<Array<AtlasPersonnePhysiqueFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  civiliteCode?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  codePaysNaissance?: InputMaybe<StringOperationFilterInput>;
  codePaysNaissanceNavigation?: InputMaybe<AtlasPaysFilterInput>;
  codePaysNationalite?: InputMaybe<StringOperationFilterInput>;
  codePaysNationaliteNavigation?: InputMaybe<AtlasPaysFilterInput>;
  codePaysNationaliteSecondaire?: InputMaybe<StringOperationFilterInput>;
  codePaysNationaliteSecondaireNavigation?: InputMaybe<AtlasPaysFilterInput>;
  codePostaleNaissance?: InputMaybe<StringOperationFilterInput>;
  consultantPersonnePhysiques?: InputMaybe<ListFilterInputTypeOfAtlasConsultantPersonnePhysiqueFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateNaissance?: InputMaybe<LocalDateOperationFilterInput>;
  departementNaissance?: InputMaybe<StringOperationFilterInput>;
  deuxiemePrenom?: InputMaybe<StringOperationFilterInput>;
  disposition?: InputMaybe<AtlasDispositionFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatCivil?: InputMaybe<AtlasEtatCivilFilterInput>;
  fullNameSearchText?: InputMaybe<StringOperationFilterInput>;
  genre?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseurPersonnePhysiques?: InputMaybe<ListFilterInputTypeOfAtlasInvestisseurPersonnePhysiqueFilterInput>;
  login?: InputMaybe<StringOperationFilterInput>;
  mesureProtectionDate?: InputMaybe<LocalDateOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  nomCompletDeuxiemeParent?: InputMaybe<StringOperationFilterInput>;
  nomCompletPremierParent?: InputMaybe<StringOperationFilterInput>;
  nomNaissance?: InputMaybe<StringOperationFilterInput>;
  nomNaissanceUniformise?: InputMaybe<StringOperationFilterInput>;
  nomUniformise?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AtlasPersonnePhysiqueFilterInput>>;
  personnePhysiqueAdresses?: InputMaybe<ListFilterInputTypeOfAtlasPersonnePhysiqueAdresseFilterInput>;
  personnePhysiqueEmails?: InputMaybe<ListFilterInputTypeOfAtlasPersonnePhysiqueEmailFilterInput>;
  personnePhysiqueTelephones?: InputMaybe<ListFilterInputTypeOfAtlasPersonnePhysiqueTelephoneFilterInput>;
  prenom?: InputMaybe<StringOperationFilterInput>;
  prenomUniformise?: InputMaybe<StringOperationFilterInput>;
  reglementaire?: InputMaybe<AtlasReglementaireFilterInput>;
  relationCouples1?: InputMaybe<ListFilterInputTypeOfAtlasRelationCoupleFilterInput>;
  relationCouples2?: InputMaybe<ListFilterInputTypeOfAtlasRelationCoupleFilterInput>;
  situationProfessionnelle?: InputMaybe<AtlasSituationProfessionnelleFilterInput>;
  troisiemePrenom?: InputMaybe<StringOperationFilterInput>;
  typeMesureProtectionCode?: InputMaybe<StringOperationFilterInput>;
  villeNaissanceNom?: InputMaybe<StringOperationFilterInput>;
};

export type AtlasPersonnePhysiqueTelephone = {
  __typename?: 'AtlasPersonnePhysiqueTelephone';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  personnePhysique: AtlasPersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
  telephone: AtlasTelephone;
  telephoneId: Scalars['Long']['output'];
};

export type AtlasPersonnePhysiqueTelephoneFilterInput = {
  and?: InputMaybe<Array<AtlasPersonnePhysiqueTelephoneFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AtlasPersonnePhysiqueTelephoneFilterInput>>;
  personnePhysique?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  telephone?: InputMaybe<AtlasTelephoneFilterInput>;
  telephoneId?: InputMaybe<LongOperationFilterInput>;
};

export type AtlasReglementaire = {
  __typename?: 'AtlasReglementaire';
  codePaysFactaResidenceFiscale?: Maybe<Scalars['String']['output']>;
  codePaysFactaResidenceFiscaleNavigation?: Maybe<AtlasPays>;
  codePaysPpe?: Maybe<Scalars['String']['output']>;
  codePaysPpeNavigation?: Maybe<AtlasPays>;
  factaStatut?: Maybe<Scalars['Boolean']['output']>;
  factaTinCode?: Maybe<Scalars['String']['output']>;
  nifCode?: Maybe<Scalars['String']['output']>;
  personnePhysique: AtlasPersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
  ppeAnciennete?: Maybe<Scalars['LocalDate']['output']>;
  ppeStatut?: Maybe<Scalars['Boolean']['output']>;
  typePpeMotifCode?: Maybe<Scalars['String']['output']>;
  typePpeRelationCode?: Maybe<Scalars['String']['output']>;
};

export type AtlasReglementaireFilterInput = {
  and?: InputMaybe<Array<AtlasReglementaireFilterInput>>;
  codePaysFactaResidenceFiscale?: InputMaybe<StringOperationFilterInput>;
  codePaysFactaResidenceFiscaleNavigation?: InputMaybe<AtlasPaysFilterInput>;
  codePaysPpe?: InputMaybe<StringOperationFilterInput>;
  codePaysPpeNavigation?: InputMaybe<AtlasPaysFilterInput>;
  factaStatut?: InputMaybe<BooleanOperationFilterInput>;
  factaTinCode?: InputMaybe<StringOperationFilterInput>;
  nifCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AtlasReglementaireFilterInput>>;
  personnePhysique?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  ppeAnciennete?: InputMaybe<LocalDateOperationFilterInput>;
  ppeStatut?: InputMaybe<BooleanOperationFilterInput>;
  typePpeMotifCode?: InputMaybe<StringOperationFilterInput>;
  typePpeRelationCode?: InputMaybe<StringOperationFilterInput>;
};

export type AtlasRelationCouple = {
  __typename?: 'AtlasRelationCouple';
  personnePhysique1: AtlasPersonnePhysique;
  personnePhysique1Id: Scalars['Long']['output'];
  personnePhysique2: AtlasPersonnePhysique;
  personnePhysique2Id: Scalars['Long']['output'];
  typeRelationCoupleCode: Scalars['String']['output'];
  typeRelationCoupleCodeNavigation: TypeRelationCouple;
};

export type AtlasRelationCoupleFilterInput = {
  and?: InputMaybe<Array<AtlasRelationCoupleFilterInput>>;
  or?: InputMaybe<Array<AtlasRelationCoupleFilterInput>>;
  personnePhysique1?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
  personnePhysique1Id?: InputMaybe<LongOperationFilterInput>;
  personnePhysique2?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
  personnePhysique2Id?: InputMaybe<LongOperationFilterInput>;
  typeRelationCoupleCode?: InputMaybe<StringOperationFilterInput>;
  typeRelationCoupleCodeNavigation?: InputMaybe<TypeRelationCoupleFilterInput>;
};

export type AtlasSituationProfessionnelle = {
  __typename?: 'AtlasSituationProfessionnelle';
  categorieSocioProfessionnelleCodeAtlas?: Maybe<Scalars['Byte']['output']>;
  categorieSocioProfessionnelleCodeAtlasNavigation?: Maybe<AtlasCategorieSocioProfessionnelle>;
  dateDepartRetraite?: Maybe<Scalars['LocalDate']['output']>;
  nomSociete?: Maybe<Scalars['String']['output']>;
  origineRevenus?: Maybe<Scalars['String']['output']>;
  personnePhysique: AtlasPersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
  profession?: Maybe<Scalars['String']['output']>;
};

export type AtlasSituationProfessionnelleFilterInput = {
  and?: InputMaybe<Array<AtlasSituationProfessionnelleFilterInput>>;
  categorieSocioProfessionnelleCodeAtlas?: InputMaybe<ByteOperationFilterInput>;
  categorieSocioProfessionnelleCodeAtlasNavigation?: InputMaybe<AtlasCategorieSocioProfessionnelleFilterInput>;
  dateDepartRetraite?: InputMaybe<LocalDateOperationFilterInput>;
  nomSociete?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AtlasSituationProfessionnelleFilterInput>>;
  origineRevenus?: InputMaybe<StringOperationFilterInput>;
  personnePhysique?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  profession?: InputMaybe<StringOperationFilterInput>;
};

export type AtlasTelephone = {
  __typename?: 'AtlasTelephone';
  arianeId?: Maybe<Scalars['Long']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  estNumeroCorrespondance?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  noteId?: Maybe<Scalars['Long']['output']>;
  numero: Scalars['String']['output'];
  personnePhysiqueTelephones: Array<AtlasPersonnePhysiqueTelephone>;
  prefixe?: Maybe<Scalars['String']['output']>;
  typeTelephoneCode: Scalars['String']['output'];
};


export type AtlasTelephonePersonnePhysiqueTelephonesArgs = {
  where?: InputMaybe<AtlasPersonnePhysiqueTelephoneFilterInput>;
};

export type AtlasTelephoneFilterInput = {
  and?: InputMaybe<Array<AtlasTelephoneFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  estNumeroCorrespondance?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  numero?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AtlasTelephoneFilterInput>>;
  personnePhysiqueTelephones?: InputMaybe<ListFilterInputTypeOfAtlasPersonnePhysiqueTelephoneFilterInput>;
  prefixe?: InputMaybe<StringOperationFilterInput>;
  typeTelephoneCode?: InputMaybe<StringOperationFilterInput>;
};

export type AtlasTypeSituationEtatCivil = {
  __typename?: 'AtlasTypeSituationEtatCivil';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatCivils: Array<AtlasEtatCivil>;
  libelle: Scalars['String']['output'];
};


export type AtlasTypeSituationEtatCivilEtatCivilsArgs = {
  where?: InputMaybe<AtlasEtatCivilFilterInput>;
};

export type AtlasTypeSituationEtatCivilFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<AtlasTypeSituationEtatCivilFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatCivils?: InputMaybe<ListFilterInputTypeOfAtlasEtatCivilFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AtlasTypeSituationEtatCivilFilterInput>>;
};

export type AvancementConnaissanceClientInvestisseur = {
  __typename?: 'AvancementConnaissanceClientInvestisseur';
  budgetState: RecueilStepState;
  /** id du document helios de la CNI */
  cnIdocumentID?: Maybe<Scalars['String']['output']>;
  cniEtat: EtatCni;
  cniLastChangeDate: Scalars['DateTime']['output'];
  /** Date métier du changement d'etat (expiré, signé) */
  cniReferenceDate?: Maybe<Scalars['DateTime']['output']>;
  /** id du document helios du DER */
  deRdocumentID?: Maybe<Scalars['String']['output']>;
  derEtat: EtatDer;
  derLastChangeDate: Scalars['DateTime']['output'];
  /** Date de référence métier du changement d'etat (expiré, signé) */
  derReferenceDate?: Maybe<Scalars['DateTime']['output']>;
  etatGlobal: EtatGlobalInvestisseur;
  etatGlobalLastChangeDate: Scalars['DateTime']['output'];
  fiscaliteState: RecueilStepState;
  id: Scalars['Long']['output'];
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  isQPIFormCompleted: Scalars['Boolean']['output'];
  isRecueilFormCompleted: Scalars['Boolean']['output'];
  isRecueilSituationPersonnelleCompleted: Scalars['Boolean']['output'];
  lastChangeDate: Scalars['DateTime']['output'];
  metadatasConnaissanceClient: MetadatasConnaissanceClient;
  metadatasConnaissanceClientId: Scalars['Long']['output'];
  objectifsState: RecueilStepState;
  patrimoineState: RecueilStepState;
  /** id du document helios du QPI */
  qpIdocumentID?: Maybe<Scalars['String']['output']>;
  qpiEtat: EtatQpi;
  qpiLastChangeDate: Scalars['DateTime']['output'];
  /** Date de référence métier du changement d'etat (expiré, signé) */
  qpiReferenceDate?: Maybe<Scalars['DateTime']['output']>;
  recueilEtat: EtatRecueil;
  recueilLastChangeDate: Scalars['DateTime']['output'];
  /** Date de référence métier du changement d'etat (expiré, signé) */
  recueilReferenceDate?: Maybe<Scalars['DateTime']['output']>;
  /** id du document helios du Recueil */
  recueildocumentID?: Maybe<Scalars['String']['output']>;
  situationPersonnelleState: RecueilStepState;
  /** Etat du formulaire QPI */
  statutFormulaireQPI: FormulaireStatut;
  /** Etat du formulaire Recueil */
  statutFormulaireRecueil: FormulaireStatut;
};

export type AvancementConnaissanceClientInvestisseurFilterInput = {
  and?: InputMaybe<Array<AvancementConnaissanceClientInvestisseurFilterInput>>;
  budgetState?: InputMaybe<RecueilStepStateOperationFilterInput>;
  /** id du document helios de la CNI */
  cnIdocumentID?: InputMaybe<StringOperationFilterInput>;
  cniEtat?: InputMaybe<EtatCniOperationFilterInput>;
  cniLastChangeDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Date métier du changement d'etat (expiré, signé) */
  cniReferenceDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** id du document helios du DER */
  deRdocumentID?: InputMaybe<StringOperationFilterInput>;
  derEtat?: InputMaybe<EtatDerOperationFilterInput>;
  derLastChangeDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Date de référence métier du changement d'etat (expiré, signé) */
  derReferenceDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatGlobal?: InputMaybe<EtatGlobalInvestisseurOperationFilterInput>;
  etatGlobalLastChangeDate?: InputMaybe<DateTimeOperationFilterInput>;
  fiscaliteState?: InputMaybe<RecueilStepStateOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<MinotaureInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  isQPIFormCompleted?: InputMaybe<BooleanOperationFilterInput>;
  isRecueilFormCompleted?: InputMaybe<BooleanOperationFilterInput>;
  isRecueilSituationPersonnelleCompleted?: InputMaybe<BooleanOperationFilterInput>;
  lastChangeDate?: InputMaybe<DateTimeOperationFilterInput>;
  metadatasConnaissanceClient?: InputMaybe<MetadatasConnaissanceClientFilterInput>;
  metadatasConnaissanceClientId?: InputMaybe<LongOperationFilterInput>;
  objectifsState?: InputMaybe<RecueilStepStateOperationFilterInput>;
  or?: InputMaybe<Array<AvancementConnaissanceClientInvestisseurFilterInput>>;
  patrimoineState?: InputMaybe<RecueilStepStateOperationFilterInput>;
  /** id du document helios du QPI */
  qpIdocumentID?: InputMaybe<StringOperationFilterInput>;
  qpiEtat?: InputMaybe<EtatQpiOperationFilterInput>;
  qpiLastChangeDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Date de référence métier du changement d'etat (expiré, signé) */
  qpiReferenceDate?: InputMaybe<DateTimeOperationFilterInput>;
  recueilEtat?: InputMaybe<EtatRecueilOperationFilterInput>;
  recueilLastChangeDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Date de référence métier du changement d'etat (expiré, signé) */
  recueilReferenceDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** id du document helios du Recueil */
  recueildocumentID?: InputMaybe<StringOperationFilterInput>;
  situationPersonnelleState?: InputMaybe<RecueilStepStateOperationFilterInput>;
  /** Etat du formulaire QPI */
  statutFormulaireQPI?: InputMaybe<FormulaireStatutOperationFilterInput>;
  /** Etat du formulaire Recueil */
  statutFormulaireRecueil?: InputMaybe<FormulaireStatutOperationFilterInput>;
};

export type AvancementConnaissanceClientInvestisseurSortInput = {
  budgetState?: InputMaybe<SortEnumType>;
  /** id du document helios de la CNI */
  cnIdocumentID?: InputMaybe<SortEnumType>;
  cniEtat?: InputMaybe<SortEnumType>;
  cniLastChangeDate?: InputMaybe<SortEnumType>;
  /** Date métier du changement d'etat (expiré, signé) */
  cniReferenceDate?: InputMaybe<SortEnumType>;
  /** id du document helios du DER */
  deRdocumentID?: InputMaybe<SortEnumType>;
  derEtat?: InputMaybe<SortEnumType>;
  derLastChangeDate?: InputMaybe<SortEnumType>;
  /** Date de référence métier du changement d'etat (expiré, signé) */
  derReferenceDate?: InputMaybe<SortEnumType>;
  etatGlobal?: InputMaybe<SortEnumType>;
  etatGlobalLastChangeDate?: InputMaybe<SortEnumType>;
  fiscaliteState?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<MinotaureInvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  isQPIFormCompleted?: InputMaybe<SortEnumType>;
  isRecueilFormCompleted?: InputMaybe<SortEnumType>;
  isRecueilSituationPersonnelleCompleted?: InputMaybe<SortEnumType>;
  lastChangeDate?: InputMaybe<SortEnumType>;
  metadatasConnaissanceClient?: InputMaybe<MetadatasConnaissanceClientSortInput>;
  metadatasConnaissanceClientId?: InputMaybe<SortEnumType>;
  objectifsState?: InputMaybe<SortEnumType>;
  patrimoineState?: InputMaybe<SortEnumType>;
  /** id du document helios du QPI */
  qpIdocumentID?: InputMaybe<SortEnumType>;
  qpiEtat?: InputMaybe<SortEnumType>;
  qpiLastChangeDate?: InputMaybe<SortEnumType>;
  /** Date de référence métier du changement d'etat (expiré, signé) */
  qpiReferenceDate?: InputMaybe<SortEnumType>;
  recueilEtat?: InputMaybe<SortEnumType>;
  recueilLastChangeDate?: InputMaybe<SortEnumType>;
  /** Date de référence métier du changement d'etat (expiré, signé) */
  recueilReferenceDate?: InputMaybe<SortEnumType>;
  /** id du document helios du Recueil */
  recueildocumentID?: InputMaybe<SortEnumType>;
  situationPersonnelleState?: InputMaybe<SortEnumType>;
  /** Etat du formulaire QPI */
  statutFormulaireQPI?: InputMaybe<SortEnumType>;
  /** Etat du formulaire Recueil */
  statutFormulaireRecueil?: InputMaybe<SortEnumType>;
};

export enum BackOfficeService {
  Psi = 'PSI',
  Svp = 'SVP'
}

export type BackOfficeServiceOperationFilterInput = {
  eq?: InputMaybe<BackOfficeService>;
  in?: InputMaybe<Array<BackOfficeService>>;
  neq?: InputMaybe<BackOfficeService>;
  nin?: InputMaybe<Array<BackOfficeService>>;
};

export type BesoinsOperation = {
  __typename?: 'BesoinsOperation';
  disponibiliteEpargne?: Maybe<DisponibiliteEpargne>;
  horizonPlacement?: Maybe<HorizonPlacement>;
  motivationOperation?: Maybe<Scalars['String']['output']>;
  selectedObjectifCodes: Array<Scalars['String']['output']>;
  toleranceRisque?: Maybe<ToleranceRisque>;
};


export type BesoinsOperationSelectedObjectifCodesArgs = {
  where?: InputMaybe<StringOperationFilterInput>;
};

export type BesoinsOperationFilterInput = {
  and?: InputMaybe<Array<BesoinsOperationFilterInput>>;
  disponibiliteEpargne?: InputMaybe<NullableOfDisponibiliteEpargneOperationFilterInput>;
  horizonPlacement?: InputMaybe<HorizonPlacementFilterInput>;
  motivationOperation?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BesoinsOperationFilterInput>>;
  selectedObjectifCodes?: InputMaybe<ListStringOperationFilterInput>;
  toleranceRisque?: InputMaybe<NullableOfToleranceRisqueOperationFilterInput>;
};

export type BesoinsOperationInput = {
  disponibiliteEpargne?: InputMaybe<DisponibiliteEpargne>;
  horizonPlacement?: InputMaybe<HorizonPlacementInput>;
  motivationOperation?: InputMaybe<Scalars['String']['input']>;
  selectedObjectifCodes: Array<Scalars['String']['input']>;
  toleranceRisque?: InputMaybe<ToleranceRisque>;
};

export type BilanFinancierInput = {
  actif?: InputMaybe<Scalars['Decimal']['input']>;
  charges?: InputMaybe<Scalars['Decimal']['input']>;
  investisseurId: Scalars['Long']['input'];
  passif?: InputMaybe<Scalars['Decimal']['input']>;
  prevoyance?: InputMaybe<Scalars['Decimal']['input']>;
  revenus?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum BlobFilesPermissionDs {
  Read = 'READ',
  Write = 'WRITE'
}

export type BlobFilesPermissionDsOperationFilterInput = {
  eq?: InputMaybe<BlobFilesPermissionDs>;
  in?: InputMaybe<Array<BlobFilesPermissionDs>>;
  neq?: InputMaybe<BlobFilesPermissionDs>;
  nin?: InputMaybe<Array<BlobFilesPermissionDs>>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Budget = {
  __typename?: 'Budget';
  arianeId?: Maybe<Scalars['String']['output']>;
  budgetInvestisseurs: Array<BudgetInvestisseur>;
  commentaire?: Maybe<Scalars['String']['output']>;
  creationDate: Scalars['DateTime']['output'];
  designation?: Maybe<Scalars['String']['output']>;
  editionDate: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  isGenerated?: Maybe<Scalars['Boolean']['output']>;
  montantAnnuel: Scalars['Decimal']['output'];
  patrimoineBudget?: Maybe<PatrimoineBudget>;
  typeBudget: TypeBudget;
  typeBudgetId: Scalars['Int']['output'];
};


export type BudgetBudgetInvestisseursArgs = {
  where?: InputMaybe<BudgetInvestisseurFilterInput>;
};

export type BudgetCreationInput = {
  commentaire?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  investisseurIds: Array<Scalars['Long']['input']>;
  montantAnnuel: Scalars['Decimal']['input'];
  typeBudgetCode?: InputMaybe<Scalars['String']['input']>;
};

export type BudgetDto = {
  __typename?: 'BudgetDto';
  budgetId: Scalars['Long']['output'];
  budgetInvestisseurs: Array<BudgetInvestisseurDto>;
  capitalRestantDu?: Maybe<Scalars['Decimal']['output']>;
  commentaire?: Maybe<Scalars['String']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  dureeRestante?: Maybe<Scalars['Int']['output']>;
  foyerFiscalId: Scalars['Long']['output'];
  isGenerated: Scalars['Boolean']['output'];
  /** Montant saisi dans le budget, peut être annuel ou mensuel selon le type de budget */
  montant: Scalars['Decimal']['output'];
  patrimoineId?: Maybe<Scalars['Long']['output']>;
  typeBudgetCode: Scalars['String']['output'];
};


export type BudgetDtoBudgetInvestisseursArgs = {
  where?: InputMaybe<BudgetInvestisseurDtoFilterInput>;
};

export type BudgetFilterInput = {
  and?: InputMaybe<Array<BudgetFilterInput>>;
  arianeId?: InputMaybe<StringOperationFilterInput>;
  budgetInvestisseurs?: InputMaybe<ListFilterInputTypeOfBudgetInvestisseurFilterInput>;
  commentaire?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  designation?: InputMaybe<StringOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isGenerated?: InputMaybe<BooleanOperationFilterInput>;
  montantAnnuel?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<BudgetFilterInput>>;
  patrimoineBudget?: InputMaybe<PatrimoineBudgetFilterInput>;
  typeBudget?: InputMaybe<TypeBudgetFilterInput>;
  typeBudgetId?: InputMaybe<IntOperationFilterInput>;
};

export type BudgetInvestisseur = {
  __typename?: 'BudgetInvestisseur';
  budget: Budget;
  budgetId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  tauxDetention: Scalars['Decimal']['output'];
};

export type BudgetInvestisseurDto = {
  __typename?: 'BudgetInvestisseurDto';
  investisseur?: Maybe<Investisseur>;
  investisseurId: Scalars['Long']['output'];
  pourcentageDetention: Scalars['Decimal']['output'];
};

export type BudgetInvestisseurDtoFilterInput = {
  and?: InputMaybe<Array<BudgetInvestisseurDtoFilterInput>>;
  investisseur?: InputMaybe<MinotaureInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<BudgetInvestisseurDtoFilterInput>>;
  pourcentageDetention?: InputMaybe<DecimalOperationFilterInput>;
};

export type BudgetInvestisseurFilterInput = {
  and?: InputMaybe<Array<BudgetInvestisseurFilterInput>>;
  budget?: InputMaybe<BudgetFilterInput>;
  budgetId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<MinotaureInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<BudgetInvestisseurFilterInput>>;
  tauxDetention?: InputMaybe<DecimalOperationFilterInput>;
};

export type BudgetModificationInput = {
  commentaire?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Long']['input'];
  investisseurIds: Array<Scalars['Long']['input']>;
  montantAnnuel: Scalars['Decimal']['input'];
  typeBudgetCode?: InputMaybe<Scalars['String']['input']>;
};

export type ByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']['input']>;
  gt?: InputMaybe<Scalars['Byte']['input']>;
  gte?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  lt?: InputMaybe<Scalars['Byte']['input']>;
  lte?: InputMaybe<Scalars['Byte']['input']>;
  neq?: InputMaybe<Scalars['Byte']['input']>;
  ngt?: InputMaybe<Scalars['Byte']['input']>;
  ngte?: InputMaybe<Scalars['Byte']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  nlt?: InputMaybe<Scalars['Byte']['input']>;
  nlte?: InputMaybe<Scalars['Byte']['input']>;
};

export type CapaciteEpargneDetail = {
  __typename?: 'CapaciteEpargneDetail';
  capaciteEpargneMensuelle: Scalars['Decimal']['output'];
  chargesFixesMensuelles: Scalars['Decimal']['output'];
  depensesCourantesMensuelles: Scalars['Decimal']['output'];
  impotsMensuels: Scalars['Decimal']['output'];
  impotsMensuelsCsp: Scalars['Decimal']['output'];
  revenusAnnuels: Scalars['Decimal']['output'];
};

/** Informations supplémentaires sur la capacité financière de l'investisseur dans le but d'atteindre ses objectifs */
export type CapaciteFinanciere = {
  __typename?: 'CapaciteFinanciere';
  commentaire?: Maybe<Scalars['String']['output']>;
  /** Effort d'épargne mensuel (supplément d'epargne mensuel possible pas l'investisseur) */
  effortEpargne?: Maybe<Scalars['Decimal']['output']>;
  /** Montant de l'épargne de précaution souhaitée par l'investisseur en euro */
  epargnePrecautionCible?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Long']['output'];
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  levierType?: Maybe<LevierType>;
};

/** Informations supplémentaires sur la capacité financière de l'investisseur dans le but d'atteindre ses objectifs */
export type CapaciteFinanciereFilterInput = {
  and?: InputMaybe<Array<CapaciteFinanciereFilterInput>>;
  commentaire?: InputMaybe<StringOperationFilterInput>;
  /** Effort d'épargne mensuel (supplément d'epargne mensuel possible pas l'investisseur) */
  effortEpargne?: InputMaybe<DecimalOperationFilterInput>;
  /** Montant de l'épargne de précaution souhaitée par l'investisseur en euro */
  epargnePrecautionCible?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<MinotaureInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  levierType?: InputMaybe<NullableOfLevierTypeOperationFilterInput>;
  or?: InputMaybe<Array<CapaciteFinanciereFilterInput>>;
};

/** Informations supplémentaires sur la capacité financière de l'investisseur dans le but d'atteindre ses objectifs */
export type CapaciteFinanciereSortInput = {
  commentaire?: InputMaybe<SortEnumType>;
  /** Effort d'épargne mensuel (supplément d'epargne mensuel possible pas l'investisseur) */
  effortEpargne?: InputMaybe<SortEnumType>;
  /** Montant de l'épargne de précaution souhaitée par l'investisseur en euro */
  epargnePrecautionCible?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<MinotaureInvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  levierType?: InputMaybe<SortEnumType>;
};

/** Détail du calcul de capacité à supporter des pertes. */
export type CapaciteSupportPertesDetail = {
  __typename?: 'CapaciteSupportPertesDetail';
  capaciteEpargne: Scalars['Decimal']['output'];
  chargesFixes: Scalars['Decimal']['output'];
  depensesCourantes: Scalars['Decimal']['output'];
  diversification: Scalars['Decimal']['output'];
  epargneBancaire: Scalars['Decimal']['output'];
  epargneFinanciere: Scalars['Decimal']['output'];
  epargneFinanciereNbActifsIncomplets: Scalars['Int']['output'];
  epargneFinanciereSecurise: Scalars['Decimal']['output'];
  epargneRetraiteSalariale: Scalars['Decimal']['output'];
  epargneRetraiteSalarialeDisponible: Scalars['Decimal']['output'];
  epargneRetraiteSalarialeDisponibleSecurise: Scalars['Decimal']['output'];
  epargneRetraiteSalarialeNbActifsIncomplets: Scalars['Int']['output'];
  impots: Scalars['Decimal']['output'];
  isMinor: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
  missingFields: Array<Scalars['String']['output']>;
  revenus: Scalars['Decimal']['output'];
  score: Scalars['Int']['output'];
};


/** Détail du calcul de capacité à supporter des pertes. */
export type CapaciteSupportPertesDetailMissingFieldsArgs = {
  where?: InputMaybe<StringOperationFilterInput>;
};

/** Détail du calcul de capacité à supporter des pertes. */
export type CapaciteSupportPertesDetailFilterInput = {
  and?: InputMaybe<Array<CapaciteSupportPertesDetailFilterInput>>;
  capaciteEpargne?: InputMaybe<DecimalOperationFilterInput>;
  chargesFixes?: InputMaybe<DecimalOperationFilterInput>;
  depensesCourantes?: InputMaybe<DecimalOperationFilterInput>;
  diversification?: InputMaybe<DecimalOperationFilterInput>;
  epargneBancaire?: InputMaybe<DecimalOperationFilterInput>;
  epargneFinanciere?: InputMaybe<DecimalOperationFilterInput>;
  epargneFinanciereNbActifsIncomplets?: InputMaybe<IntOperationFilterInput>;
  epargneFinanciereSecurise?: InputMaybe<DecimalOperationFilterInput>;
  epargneRetraiteSalariale?: InputMaybe<DecimalOperationFilterInput>;
  epargneRetraiteSalarialeDisponible?: InputMaybe<DecimalOperationFilterInput>;
  epargneRetraiteSalarialeDisponibleSecurise?: InputMaybe<DecimalOperationFilterInput>;
  epargneRetraiteSalarialeNbActifsIncomplets?: InputMaybe<IntOperationFilterInput>;
  impots?: InputMaybe<DecimalOperationFilterInput>;
  isMinor?: InputMaybe<BooleanOperationFilterInput>;
  isValid?: InputMaybe<BooleanOperationFilterInput>;
  missingFields?: InputMaybe<ListStringOperationFilterInput>;
  or?: InputMaybe<Array<CapaciteSupportPertesDetailFilterInput>>;
  revenus?: InputMaybe<DecimalOperationFilterInput>;
  score?: InputMaybe<IntOperationFilterInput>;
};

/** Détail du calcul de capacité à supporter des pertes. */
export type CapaciteSupportPertesDetailSortInput = {
  capaciteEpargne?: InputMaybe<SortEnumType>;
  chargesFixes?: InputMaybe<SortEnumType>;
  depensesCourantes?: InputMaybe<SortEnumType>;
  diversification?: InputMaybe<SortEnumType>;
  epargneBancaire?: InputMaybe<SortEnumType>;
  epargneFinanciere?: InputMaybe<SortEnumType>;
  epargneFinanciereNbActifsIncomplets?: InputMaybe<SortEnumType>;
  epargneFinanciereSecurise?: InputMaybe<SortEnumType>;
  epargneRetraiteSalariale?: InputMaybe<SortEnumType>;
  epargneRetraiteSalarialeDisponible?: InputMaybe<SortEnumType>;
  epargneRetraiteSalarialeDisponibleSecurise?: InputMaybe<SortEnumType>;
  epargneRetraiteSalarialeNbActifsIncomplets?: InputMaybe<SortEnumType>;
  impots?: InputMaybe<SortEnumType>;
  isMinor?: InputMaybe<SortEnumType>;
  isValid?: InputMaybe<SortEnumType>;
  revenus?: InputMaybe<SortEnumType>;
  score?: InputMaybe<SortEnumType>;
};

export type CarteDemarchageInput = {
  dateFinValidite?: InputMaybe<Scalars['DateTime']['input']>;
  documentId: Scalars['String']['input'];
};

export enum CategorieBudgetEnum {
  Charges = 'CHARGES',
  Revenus = 'REVENUS'
}

export type CategorieBudgetEnumOperationFilterInput = {
  eq?: InputMaybe<CategorieBudgetEnum>;
  in?: InputMaybe<Array<CategorieBudgetEnum>>;
  neq?: InputMaybe<CategorieBudgetEnum>;
  nin?: InputMaybe<Array<CategorieBudgetEnum>>;
};

export type CategorieSocioProfessionnelle = {
  __typename?: 'CategorieSocioProfessionnelle';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['Byte']['output'];
  correspondancePcs2003: Scalars['Byte']['output'];
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  inverseParentNavigation: Array<CategorieSocioProfessionnelle>;
  libelle: Scalars['String']['output'];
  parent?: Maybe<Scalars['Byte']['output']>;
  parentNavigation?: Maybe<CategorieSocioProfessionnelle>;
  situationProfessionnelles: Array<SituationProfessionnelle>;
};


export type CategorieSocioProfessionnelleInverseParentNavigationArgs = {
  where?: InputMaybe<CategorieSocioProfessionnelleFilterInput>;
};


export type CategorieSocioProfessionnelleSituationProfessionnellesArgs = {
  where?: InputMaybe<SituationProfessionnelleFilterInput>;
};

export type CategorieSocioProfessionnelleFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CategorieSocioProfessionnelleFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  correspondancePcs2003?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  inverseParentNavigation?: InputMaybe<ListFilterInputTypeOfCategorieSocioProfessionnelleFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CategorieSocioProfessionnelleFilterInput>>;
  parent?: InputMaybe<ByteOperationFilterInput>;
  parentNavigation?: InputMaybe<CategorieSocioProfessionnelleFilterInput>;
  situationProfessionnelles?: InputMaybe<ListFilterInputTypeOfSituationProfessionnelleFilterInput>;
};

export type CategorieSocioProfessionnelleSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  correspondancePcs2003?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  parent?: InputMaybe<SortEnumType>;
  parentNavigation?: InputMaybe<CategorieSocioProfessionnelleSortInput>;
};

export type CessionHistoCommande = {
  __typename?: 'CessionHistoCommande';
  cessionnaire: Consultant;
  cessionnaireId: Scalars['Long']['output'];
  commande: Commande;
  commandeId: Scalars['Long']['output'];
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  motifCession: MotifCession;
  motifCessionId: Scalars['Byte']['output'];
  statutJuridiqueConsultant?: Maybe<ConsultantStatutJuridique>;
  statutJuridiqueConsultantId?: Maybe<Scalars['Long']['output']>;
};

export type CessionHistoCommandeFilterInput = {
  and?: InputMaybe<Array<CessionHistoCommandeFilterInput>>;
  cessionnaire?: InputMaybe<ConsultantFilterInput>;
  cessionnaireId?: InputMaybe<LongOperationFilterInput>;
  commande?: InputMaybe<CommandeFilterInput>;
  commandeId?: InputMaybe<LongOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  motifCession?: InputMaybe<MotifCessionFilterInput>;
  motifCessionId?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<CessionHistoCommandeFilterInput>>;
  statutJuridiqueConsultant?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  statutJuridiqueConsultantId?: InputMaybe<LongOperationFilterInput>;
};

export type CessionHistoInvestisseur = {
  __typename?: 'CessionHistoInvestisseur';
  cessionnaire: Consultant;
  cessionnaireId: Scalars['Long']['output'];
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  motifCession: MotifCession;
  motifCessionId: Scalars['Byte']['output'];
};

export type CessionHistoInvestisseurFilterInput = {
  and?: InputMaybe<Array<CessionHistoInvestisseurFilterInput>>;
  cessionnaire?: InputMaybe<ConsultantFilterInput>;
  cessionnaireId?: InputMaybe<LongOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  motifCession?: InputMaybe<MotifCessionFilterInput>;
  motifCessionId?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<CessionHistoInvestisseurFilterInput>>;
};

/** A segment of a collection. */
export type CessionHistoInvestisseurPaginatedCollectionSegment = {
  __typename?: 'CessionHistoInvestisseurPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CessionHistoInvestisseur>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type CessionHistoInvestisseurSortInput = {
  cessionnaire?: InputMaybe<ConsultantSortInput>;
  cessionnaireId?: InputMaybe<SortEnumType>;
  consultant?: InputMaybe<ConsultantSortInput>;
  consultantId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  motifCession?: InputMaybe<MotifCessionSortInput>;
  motifCessionId?: InputMaybe<SortEnumType>;
};

export type Civilite = {
  __typename?: 'Civilite';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  personnePhysique: Array<PersonnePhysique>;
};


export type CivilitePersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type CiviliteFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CiviliteFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CiviliteFilterInput>>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
};

export type CiviliteSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type Commande = {
  __typename?: 'Commande';
  achatPersonnel: Scalars['Byte']['output'];
  baseCommissionnement?: Maybe<Scalars['Decimal']['output']>;
  cessionHistoCommande: Array<CessionHistoCommande>;
  conseillerCommande: Array<ConseillerCommande>;
  creationDate: Scalars['DateTime']['output'];
  dateActe?: Maybe<Scalars['DateTime']['output']>;
  dateAnnulation?: Maybe<Scalars['DateTime']['output']>;
  dateSortie?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatCommande: Scalars['Byte']['output'];
  etatCommandeNavigation: EtatCommande;
  etatPMR?: Maybe<Scalars['Byte']['output']>;
  etatPMRNavigation?: Maybe<EtatPmrCommande>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  investisseurCommande: Array<InvestisseurCommande>;
  modeSortie?: Maybe<ModeSortieCommande>;
  modeSortieId?: Maybe<Scalars['Byte']['output']>;
  motifAnnulation?: Maybe<MotifAnnulationCommande>;
  motifAnnulationId?: Maybe<Scalars['Byte']['output']>;
  mouvement: Array<Mouvement>;
  nom: Scalars['String']['output'];
  numCommande: Scalars['Long']['output'];
  numeroContrat?: Maybe<Scalars['String']['output']>;
  prixVenteTotalTTC?: Maybe<Scalars['Decimal']['output']>;
  produit: Produit;
  produitId: Scalars['Long']['output'];
  typeAnnulationId?: Maybe<Scalars['Byte']['output']>;
  typeCommande: Scalars['Byte']['output'];
  typeCommandeNavigation: TypeCommande;
};


export type CommandeCessionHistoCommandeArgs = {
  where?: InputMaybe<CessionHistoCommandeFilterInput>;
};


export type CommandeConseillerCommandeArgs = {
  where?: InputMaybe<ConseillerCommandeFilterInput>;
};


export type CommandeInvestisseurCommandeArgs = {
  where?: InputMaybe<InvestisseurCommandeFilterInput>;
};


export type CommandeMouvementArgs = {
  where?: InputMaybe<MouvementFilterInput>;
};

export type CommandeFilterInput = {
  achatPersonnel?: InputMaybe<ByteOperationFilterInput>;
  and?: InputMaybe<Array<CommandeFilterInput>>;
  baseCommissionnement?: InputMaybe<DecimalOperationFilterInput>;
  cessionHistoCommande?: InputMaybe<ListFilterInputTypeOfCessionHistoCommandeFilterInput>;
  conseillerCommande?: InputMaybe<ListFilterInputTypeOfConseillerCommandeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateActe?: InputMaybe<DateTimeOperationFilterInput>;
  dateAnnulation?: InputMaybe<DateTimeOperationFilterInput>;
  dateSortie?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatCommande?: InputMaybe<ByteOperationFilterInput>;
  etatCommandeNavigation?: InputMaybe<EtatCommandeFilterInput>;
  etatPMR?: InputMaybe<ByteOperationFilterInput>;
  etatPMRNavigation?: InputMaybe<EtatPmrCommandeFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  investisseurCommande?: InputMaybe<ListFilterInputTypeOfInvestisseurCommandeFilterInput>;
  modeSortie?: InputMaybe<ModeSortieCommandeFilterInput>;
  modeSortieId?: InputMaybe<ByteOperationFilterInput>;
  motifAnnulation?: InputMaybe<MotifAnnulationCommandeFilterInput>;
  motifAnnulationId?: InputMaybe<ByteOperationFilterInput>;
  mouvement?: InputMaybe<ListFilterInputTypeOfMouvementFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  numCommande?: InputMaybe<LongOperationFilterInput>;
  numeroContrat?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CommandeFilterInput>>;
  prixVenteTotalTTC?: InputMaybe<DecimalOperationFilterInput>;
  produit?: InputMaybe<ProduitFilterInput>;
  produitId?: InputMaybe<LongOperationFilterInput>;
  typeAnnulationId?: InputMaybe<ByteOperationFilterInput>;
  typeCommande?: InputMaybe<ByteOperationFilterInput>;
  typeCommandeNavigation?: InputMaybe<TypeCommandeFilterInput>;
};

export type CommandeSortInput = {
  achatPersonnel?: InputMaybe<SortEnumType>;
  baseCommissionnement?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateActe?: InputMaybe<SortEnumType>;
  dateAnnulation?: InputMaybe<SortEnumType>;
  dateSortie?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  etatCommande?: InputMaybe<SortEnumType>;
  etatCommandeNavigation?: InputMaybe<EtatCommandeSortInput>;
  etatPMR?: InputMaybe<SortEnumType>;
  etatPMRNavigation?: InputMaybe<EtatPmrCommandeSortInput>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  modeSortie?: InputMaybe<ModeSortieCommandeSortInput>;
  modeSortieId?: InputMaybe<SortEnumType>;
  motifAnnulation?: InputMaybe<MotifAnnulationCommandeSortInput>;
  motifAnnulationId?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
  numCommande?: InputMaybe<SortEnumType>;
  numeroContrat?: InputMaybe<SortEnumType>;
  prixVenteTotalTTC?: InputMaybe<SortEnumType>;
  produit?: InputMaybe<ProduitSortInput>;
  produitId?: InputMaybe<SortEnumType>;
  typeAnnulationId?: InputMaybe<SortEnumType>;
  typeCommande?: InputMaybe<SortEnumType>;
  typeCommandeNavigation?: InputMaybe<TypeCommandeSortInput>;
};

/** A segment of a collection. */
export type CommandesFinancieresPaginatedCollectionSegment = {
  __typename?: 'CommandesFinancieresPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Commande>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type CommandesPaginatedCollectionSegment = {
  __typename?: 'CommandesPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Commande>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type CommentairePatrimoine = {
  __typename?: 'CommentairePatrimoine';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  patrimoine: Patrimoine;
  patrimoineId: Scalars['Long']['output'];
  text: Scalars['String']['output'];
};

export type CommentairePatrimoineFilterInput = {
  and?: InputMaybe<Array<CommentairePatrimoineFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<CommentairePatrimoineFilterInput>>;
  patrimoine?: InputMaybe<PatrimoineFilterInput>;
  patrimoineId?: InputMaybe<LongOperationFilterInput>;
  text?: InputMaybe<StringOperationFilterInput>;
};

export type CommissionAdiType = {
  __typename?: 'CommissionAdiType';
  code: Scalars['Int']['output'];
  consultantCommissionAdiActuelCommissionAdiTypeNavigation: Array<ConsultantCommissionAdi>;
  consultantCommissionAdiChoixCommissionAdiTypeNavigation: Array<ConsultantCommissionAdi>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  libelle: Scalars['String']['output'];
};


export type CommissionAdiTypeConsultantCommissionAdiActuelCommissionAdiTypeNavigationArgs = {
  where?: InputMaybe<ConsultantCommissionAdiFilterInput>;
};


export type CommissionAdiTypeConsultantCommissionAdiChoixCommissionAdiTypeNavigationArgs = {
  where?: InputMaybe<ConsultantCommissionAdiFilterInput>;
};

export type CommissionAdiTypeFilterInput = {
  and?: InputMaybe<Array<CommissionAdiTypeFilterInput>>;
  code?: InputMaybe<IntOperationFilterInput>;
  consultantCommissionAdiActuelCommissionAdiTypeNavigation?: InputMaybe<ListFilterInputTypeOfConsultantCommissionAdiFilterInput>;
  consultantCommissionAdiChoixCommissionAdiTypeNavigation?: InputMaybe<ListFilterInputTypeOfConsultantCommissionAdiFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CommissionAdiTypeFilterInput>>;
};

export type CommissionAdiTypeSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type ConditionVersementComplementaire = {
  __typename?: 'ConditionVersementComplementaire';
  id: Scalars['UUID']['output'];
  montantMinAvecTransfert?: Maybe<Scalars['Int']['output']>;
  montantMinAvecVP?: Maybe<Scalars['Int']['output']>;
  montantMinVC?: Maybe<Scalars['Int']['output']>;
};

export type ConditionVersementComplementaireFilterInput = {
  and?: InputMaybe<Array<ConditionVersementComplementaireFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  montantMinAvecTransfert?: InputMaybe<IntOperationFilterInput>;
  montantMinAvecVP?: InputMaybe<IntOperationFilterInput>;
  montantMinVC?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConditionVersementComplementaireFilterInput>>;
};

export type ConditionVersementInitial = {
  __typename?: 'ConditionVersementInitial';
  id: Scalars['UUID']['output'];
  montantMinAvecTransfert?: Maybe<Scalars['Int']['output']>;
  montantMinAvecVP?: Maybe<Scalars['Int']['output']>;
  montantMinSouscription?: Maybe<Scalars['Int']['output']>;
};

export type ConditionVersementInitialFilterInput = {
  and?: InputMaybe<Array<ConditionVersementInitialFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  montantMinAvecTransfert?: InputMaybe<IntOperationFilterInput>;
  montantMinAvecVP?: InputMaybe<IntOperationFilterInput>;
  montantMinSouscription?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConditionVersementInitialFilterInput>>;
};

export type ConditionVersementProgramme = {
  __typename?: 'ConditionVersementProgramme';
  id: Scalars['UUID']['output'];
  montantMinAnnuel?: Maybe<Scalars['Int']['output']>;
  montantMinMensuel?: Maybe<Scalars['Int']['output']>;
  montantMinSemestriel?: Maybe<Scalars['Int']['output']>;
  montantMinTrimestriel?: Maybe<Scalars['Int']['output']>;
};

export type ConditionVersementProgrammeFilterInput = {
  and?: InputMaybe<Array<ConditionVersementProgrammeFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  montantMinAnnuel?: InputMaybe<IntOperationFilterInput>;
  montantMinMensuel?: InputMaybe<IntOperationFilterInput>;
  montantMinSemestriel?: InputMaybe<IntOperationFilterInput>;
  montantMinTrimestriel?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConditionVersementProgrammeFilterInput>>;
};

/** Représente un template JSReport. */
export type ConfigTemplate = {
  __typename?: 'ConfigTemplate';
  id: Scalars['UUID']['output'];
  /** Nom du template dans JSReport. */
  templateName: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** Représente un template JSReport. */
export type ConfigTemplateFilterInput = {
  and?: InputMaybe<Array<ConfigTemplateFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ConfigTemplateFilterInput>>;
  /** Nom du template dans JSReport. */
  templateName?: InputMaybe<StringOperationFilterInput>;
  version?: InputMaybe<IntOperationFilterInput>;
};

export type ConnaissanceClientData = {
  __typename?: 'ConnaissanceClientData';
  investisseurs: Array<InvestisseurOperationData>;
  objectifs: Array<InvestisseurObjectifData>;
  toleranceRisque?: Maybe<ToleranceRisque>;
};


export type ConnaissanceClientDataInvestisseursArgs = {
  where?: InputMaybe<InvestisseurOperationDataFilterInput>;
};


export type ConnaissanceClientDataObjectifsArgs = {
  where?: InputMaybe<InvestisseurObjectifDataFilterInput>;
};

export type ConnaissanceClientDataFilterInput = {
  and?: InputMaybe<Array<ConnaissanceClientDataFilterInput>>;
  investisseurs?: InputMaybe<ListFilterInputTypeOfInvestisseurOperationDataFilterInput>;
  objectifs?: InputMaybe<ListFilterInputTypeOfInvestisseurObjectifDataFilterInput>;
  or?: InputMaybe<Array<ConnaissanceClientDataFilterInput>>;
  toleranceRisque?: InputMaybe<NullableOfToleranceRisqueOperationFilterInput>;
};

export type ConnaissanceClientDataInput = {
  investisseurs: Array<InvestisseurOperationDataInput>;
  objectifs: Array<InvestisseurObjectifDataInput>;
  toleranceRisque?: InputMaybe<ToleranceRisque>;
};

export type ConnaissanceExperience = {
  __typename?: 'ConnaissanceExperience';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Byte']['output'];
  libelle: Scalars['String']['output'];
  profilInvestisseur: Array<ProfilInvestisseur>;
};


export type ConnaissanceExperienceProfilInvestisseurArgs = {
  where?: InputMaybe<ProfilInvestisseurFilterInput>;
};

export type ConnaissanceExperienceFilterInput = {
  and?: InputMaybe<Array<ConnaissanceExperienceFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<ByteOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConnaissanceExperienceFilterInput>>;
  profilInvestisseur?: InputMaybe<ListFilterInputTypeOfProfilInvestisseurFilterInput>;
};

/** Réponses saisies au questionnaire Connaissance et expérience (version 2) */
export type ConnaissanceExperienceInput = {
  experience?: InputMaybe<ExperienceInput>;
  investisseurId: Scalars['Long']['input'];
  pedagogie: Array<AffirmationPedagogieInput>;
  produitsEpargne: Array<ProduitEpargneInput>;
  supportsInvestissement: Array<SupportInvestissementInput>;
};

/** Référentiel du questionnaire Connaissance et expérience v2 (sans barème ni bonnes réponses) */
export type ConnaissanceExperienceReferentielDto = {
  __typename?: 'ConnaissanceExperienceReferentielDto';
  affirmationsPedagogie: Array<AffirmationPedagogieReferentielDto>;
  modesGestion: Array<ModeGestionReferentielDto>;
  nombresOperations: Array<NombreOperationsReferentielDto>;
  produitsEpargne: Array<ProduitEpargneReferentielDto>;
  reactionsPerte: Array<ReactionPerteReferentielDto>;
  supportsInvestissement: Array<SupportInvestissementReferentielDto>;
};


/** Référentiel du questionnaire Connaissance et expérience v2 (sans barème ni bonnes réponses) */
export type ConnaissanceExperienceReferentielDtoAffirmationsPedagogieArgs = {
  where?: InputMaybe<AffirmationPedagogieReferentielDtoFilterInput>;
};


/** Référentiel du questionnaire Connaissance et expérience v2 (sans barème ni bonnes réponses) */
export type ConnaissanceExperienceReferentielDtoModesGestionArgs = {
  where?: InputMaybe<ModeGestionReferentielDtoFilterInput>;
};


/** Référentiel du questionnaire Connaissance et expérience v2 (sans barème ni bonnes réponses) */
export type ConnaissanceExperienceReferentielDtoNombresOperationsArgs = {
  where?: InputMaybe<NombreOperationsReferentielDtoFilterInput>;
};


/** Référentiel du questionnaire Connaissance et expérience v2 (sans barème ni bonnes réponses) */
export type ConnaissanceExperienceReferentielDtoProduitsEpargneArgs = {
  where?: InputMaybe<ProduitEpargneReferentielDtoFilterInput>;
};


/** Référentiel du questionnaire Connaissance et expérience v2 (sans barème ni bonnes réponses) */
export type ConnaissanceExperienceReferentielDtoReactionsPerteArgs = {
  where?: InputMaybe<ReactionPerteReferentielDtoFilterInput>;
};


/** Référentiel du questionnaire Connaissance et expérience v2 (sans barème ni bonnes réponses) */
export type ConnaissanceExperienceReferentielDtoSupportsInvestissementArgs = {
  where?: InputMaybe<SupportInvestissementReferentielDtoFilterInput>;
};

/** Réponses au questionnaire Connaissance et expérience (version 2) */
export type ConnaissanceExperienceReponses = {
  __typename?: 'ConnaissanceExperienceReponses';
  experience: ExperienceReponse;
  /** Indique que toutes les questions obligatoires ont une réponse */
  isComplete: Scalars['Boolean']['output'];
  /** Niveau de connaissance et expérience (1 = Novice, 2 = Informé, 3 = Expérimenté), null tant que le questionnaire est incomplet */
  niveau?: Maybe<Scalars['Int']['output']>;
  pedagogie: Array<AffirmationPedagogieReponse>;
  produitsEpargne: Array<ProduitEpargneReponse>;
  supportsInvestissement: Array<SupportInvestissementReponse>;
  /** Score total du questionnaire (de -5 à 115) */
  totalPoints: Scalars['Int']['output'];
};


/** Réponses au questionnaire Connaissance et expérience (version 2) */
export type ConnaissanceExperienceReponsesPedagogieArgs = {
  where?: InputMaybe<AffirmationPedagogieReponseFilterInput>;
};


/** Réponses au questionnaire Connaissance et expérience (version 2) */
export type ConnaissanceExperienceReponsesProduitsEpargneArgs = {
  where?: InputMaybe<ProduitEpargneReponseFilterInput>;
};


/** Réponses au questionnaire Connaissance et expérience (version 2) */
export type ConnaissanceExperienceReponsesSupportsInvestissementArgs = {
  where?: InputMaybe<SupportInvestissementReponseFilterInput>;
};

/** Réponses au questionnaire Connaissance et expérience (version 2) */
export type ConnaissanceExperienceReponsesFilterInput = {
  and?: InputMaybe<Array<ConnaissanceExperienceReponsesFilterInput>>;
  experience?: InputMaybe<ExperienceReponseFilterInput>;
  /** Indique que toutes les questions obligatoires ont une réponse */
  isComplete?: InputMaybe<BooleanOperationFilterInput>;
  /** Niveau de connaissance et expérience (1 = Novice, 2 = Informé, 3 = Expérimenté), null tant que le questionnaire est incomplet */
  niveau?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConnaissanceExperienceReponsesFilterInput>>;
  pedagogie?: InputMaybe<ListFilterInputTypeOfAffirmationPedagogieReponseFilterInput>;
  produitsEpargne?: InputMaybe<ListFilterInputTypeOfProduitEpargneReponseFilterInput>;
  supportsInvestissement?: InputMaybe<ListFilterInputTypeOfSupportInvestissementReponseFilterInput>;
  /** Score total du questionnaire (de -5 à 115) */
  totalPoints?: InputMaybe<IntOperationFilterInput>;
};

/** Réponses au questionnaire Connaissance et expérience (version 2) */
export type ConnaissanceExperienceReponsesSortInput = {
  experience?: InputMaybe<ExperienceReponseSortInput>;
  /** Indique que toutes les questions obligatoires ont une réponse */
  isComplete?: InputMaybe<SortEnumType>;
  /** Niveau de connaissance et expérience (1 = Novice, 2 = Informé, 3 = Expérimenté), null tant que le questionnaire est incomplet */
  niveau?: InputMaybe<SortEnumType>;
  /** Score total du questionnaire (de -5 à 115) */
  totalPoints?: InputMaybe<SortEnumType>;
};

export type ConseilOperation = {
  __typename?: 'ConseilOperation';
  allocation?: Maybe<AllocationConseil>;
  allocationPrecision?: Maybe<Scalars['String']['output']>;
  allocationTransfertOption?: Maybe<AllocationTransfertOption>;
  allocationVersementOption?: Maybe<AllocationVersementOption>;
  arbitrageDuplicationContext?: Maybe<ArbitrageDuplicationContext>;
  arbitrageLibreSupportsEntrants?: Maybe<Scalars['String']['output']>;
  arbitrageLibreSupportsSortants?: Maybe<Scalars['String']['output']>;
  autoSouscription?: Maybe<Scalars['Boolean']['output']>;
  avecArbitragesProgrammes?: Maybe<Scalars['Boolean']['output']>;
  avecMiseEnPlaceOuModificationVP?: Maybe<Scalars['Boolean']['output']>;
  fondsEvenementiels: Array<FondsEvenementielData>;
  impactDiminutionFrais?: Maybe<ImpactDiminutionFraisEnum>;
  optionsAutomatiques: Array<OptionAutomatiqueData>;
  portefeuilleOption?: Maybe<PortefeuilleOption>;
  precisionComplementaire?: Maybe<AdditionalDetails>;
  transactionPersonnelle?: Maybe<TransactionPersonnelleEnum>;
  versements: Versements;
  vpModeOptions?: Maybe<VpModeOptions>;
};


export type ConseilOperationFondsEvenementielsArgs = {
  where?: InputMaybe<FondsEvenementielDataFilterInput>;
};


export type ConseilOperationOptionsAutomatiquesArgs = {
  where?: InputMaybe<OptionAutomatiqueDataFilterInput>;
};

export type ConseilOperationFilterInput = {
  allocation?: InputMaybe<AllocationConseilFilterInput>;
  allocationPrecision?: InputMaybe<StringOperationFilterInput>;
  allocationTransfertOption?: InputMaybe<NullableOfAllocationTransfertOptionOperationFilterInput>;
  allocationVersementOption?: InputMaybe<NullableOfAllocationVersementOptionOperationFilterInput>;
  and?: InputMaybe<Array<ConseilOperationFilterInput>>;
  arbitrageDuplicationContext?: InputMaybe<ArbitrageDuplicationContextFilterInput>;
  arbitrageLibreSupportsEntrants?: InputMaybe<StringOperationFilterInput>;
  arbitrageLibreSupportsSortants?: InputMaybe<StringOperationFilterInput>;
  autoSouscription?: InputMaybe<BooleanOperationFilterInput>;
  avecArbitragesProgrammes?: InputMaybe<BooleanOperationFilterInput>;
  avecMiseEnPlaceOuModificationVP?: InputMaybe<BooleanOperationFilterInput>;
  fondsEvenementiels?: InputMaybe<ListFilterInputTypeOfFondsEvenementielDataFilterInput>;
  impactDiminutionFrais?: InputMaybe<NullableOfImpactDiminutionFraisEnumOperationFilterInput>;
  optionsAutomatiques?: InputMaybe<ListFilterInputTypeOfOptionAutomatiqueDataFilterInput>;
  or?: InputMaybe<Array<ConseilOperationFilterInput>>;
  portefeuilleOption?: InputMaybe<NullableOfPortefeuilleOptionOperationFilterInput>;
  precisionComplementaire?: InputMaybe<AdditionalDetailsFilterInput>;
  transactionPersonnelle?: InputMaybe<NullableOfTransactionPersonnelleEnumOperationFilterInput>;
  versements?: InputMaybe<VersementsFilterInput>;
  vpModeOptions?: InputMaybe<NullableOfVpModeOptionsOperationFilterInput>;
};

export type ConseilOperationInput = {
  allocation?: InputMaybe<AllocationConseilInput>;
  allocationPrecision?: InputMaybe<Scalars['String']['input']>;
  allocationTransfertOption?: InputMaybe<AllocationTransfertOption>;
  allocationVersementOption?: InputMaybe<AllocationVersementOption>;
  arbitrageDuplicationContext?: InputMaybe<ArbitrageDuplicationContextInput>;
  arbitrageLibreSupportsEntrants?: InputMaybe<Scalars['String']['input']>;
  arbitrageLibreSupportsSortants?: InputMaybe<Scalars['String']['input']>;
  autoSouscription?: InputMaybe<Scalars['Boolean']['input']>;
  avecArbitragesProgrammes?: InputMaybe<Scalars['Boolean']['input']>;
  avecMiseEnPlaceOuModificationVP?: InputMaybe<Scalars['Boolean']['input']>;
  fondsEvenementiels: Array<FondsEvenementielDataInput>;
  impactDiminutionFrais?: InputMaybe<ImpactDiminutionFraisEnum>;
  optionsAutomatiques: Array<OptionAutomatiqueDataInput>;
  portefeuilleOption?: InputMaybe<PortefeuilleOption>;
  precisionComplementaire?: InputMaybe<AdditionalDetailsInput>;
  transactionPersonnelle?: InputMaybe<TransactionPersonnelleEnum>;
  versements: VersementsInput;
  vpModeOptions?: InputMaybe<VpModeOptions>;
};

export type ConseillerCommande = {
  __typename?: 'ConseillerCommande';
  commande: Commande;
  commandeId: Scalars['Long']['output'];
  conseiller: Consultant;
  conseillerId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  typeConseillerCommande: Scalars['Byte']['output'];
  typeConseillerCommandeNavigation: TypeConseillerCommande;
};

export type ConseillerCommandeFilterInput = {
  and?: InputMaybe<Array<ConseillerCommandeFilterInput>>;
  commande?: InputMaybe<CommandeFilterInput>;
  commandeId?: InputMaybe<LongOperationFilterInput>;
  conseiller?: InputMaybe<ConsultantFilterInput>;
  conseillerId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConseillerCommandeFilterInput>>;
  typeConseillerCommande?: InputMaybe<ByteOperationFilterInput>;
  typeConseillerCommandeNavigation?: InputMaybe<TypeConseillerCommandeFilterInput>;
};

export type Consultant = {
  __typename?: 'Consultant';
  abonnementConsultant: Array<AbonnementConsultant>;
  adhesionConsultant: Array<AdhesionConsultant>;
  adresse: Array<Adresse>;
  affiliationDate?: Maybe<Scalars['DateTime']['output']>;
  arianeId?: Maybe<Scalars['Long']['output']>;
  atlasConsultant?: Maybe<AtlasConsultant>;
  cessionHistoCommandeCessionnaire: Array<CessionHistoCommande>;
  cessionHistoCommandeConsultant: Array<CessionHistoCommande>;
  cessionHistoInvestisseurCessionnaire: Array<CessionHistoInvestisseur>;
  cessionHistoInvestisseurConsultant: Array<CessionHistoInvestisseur>;
  code: Scalars['String']['output'];
  codeTier?: Maybe<Scalars['String']['output']>;
  commentairePeriodeJunior?: Maybe<Scalars['String']['output']>;
  conseillerCommande: Array<ConseillerCommande>;
  consultantCommissionAdi?: Maybe<ConsultantCommissionAdi>;
  consultantDistinction: Array<ConsultantDistinction>;
  consultantHabilitations: Array<ConsultantHabilitation>;
  consultantHabilitationsFictives: Array<ConsultantHabilitationsFictives>;
  consultantMouvement: Array<ConsultantMouvement>;
  consultantOrganisationConstellation: Array<ConsultantOrganisation>;
  consultantOrganisationConsultant?: Maybe<ConsultantOrganisation>;
  consultantOrganisationEtoile: Array<ConsultantOrganisation>;
  consultantOrganisationGalaxie: Array<ConsultantOrganisation>;
  consultantOrganisationManager: Array<ConsultantOrganisation>;
  consultantOrganisationPlanete: Array<ConsultantOrganisation>;
  consultantRcp: Array<ConsultantRcp>;
  consultantStatutCommercial: Array<ConsultantStatutCommercial>;
  consultantStatutJuridique: Array<ConsultantStatutJuridique>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  date1AcquisitionDroit?: Maybe<Scalars['DateTime']['output']>;
  date1Manager?: Maybe<Scalars['DateTime']['output']>;
  date1VenteActee?: Maybe<Scalars['DateTime']['output']>;
  date1VenteFinancement?: Maybe<Scalars['DateTime']['output']>;
  date1VenteImmo?: Maybe<Scalars['DateTime']['output']>;
  date1VentePlacement?: Maybe<Scalars['DateTime']['output']>;
  dateAcquisitionDroit?: Maybe<Scalars['DateTime']['output']>;
  dateAffiliationProdemial?: Maybe<Scalars['DateTime']['output']>;
  dateContact?: Maybe<Scalars['DateTime']['output']>;
  dateDemission?: Maybe<Scalars['DateTime']['output']>;
  dateEntree?: Maybe<Scalars['DateTime']['output']>;
  dateFinPeriodeJunior?: Maybe<Scalars['DateTime']['output']>;
  dateFinValiditeAffiliation?: Maybe<Scalars['DateTime']['output']>;
  dateSeminairePro?: Maybe<Scalars['DateTime']['output']>;
  derniereDateExclusif?: Maybe<Scalars['DateTime']['output']>;
  derniereDateNonExclusif?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  edition: Array<Edition>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  eligilibleRenouvellement: Scalars['Boolean']['output'];
  email: Array<Email>;
  equivalenceDeFormationConsultant: Array<EquivalenceDeFormation>;
  equivalenceDeFormationConsultantFormateur: Array<EquivalenceDeFormation>;
  exclusif: Scalars['Boolean']['output'];
  facture: Array<Facture>;
  filesMetadata: Array<FileMetadata>;
  galaxy?: Maybe<Consultant>;
  galaxyId?: Maybe<Scalars['Long']['output']>;
  gerePar: AppReference;
  habilitationALPSI: Scalars['Boolean']['output'];
  habilitationAssurance: Scalars['Boolean']['output'];
  habilitationCIF: Scalars['Boolean']['output'];
  habilitationIOB: Scalars['Boolean']['output'];
  habilitationImmo: Scalars['Boolean']['output'];
  habilitationPMR: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  importHistories?: Maybe<Array<ImportHistory>>;
  inscriptionCycleCourt: Array<InscriptionCycleCourt>;
  inscriptionSession: Array<InscriptionSession>;
  inverseGalaxy: Array<Consultant>;
  inverseManager: Array<Consultant>;
  inverseParrain: Array<Consultant>;
  inverseTeteReseau: Array<Consultant>;
  investisseurConsultant: Array<InvestisseurConsultant>;
  /** Le consultant ne peut pas acceder a Minotaure */
  isDisabled: Scalars['Boolean']['output'];
  manager?: Maybe<Consultant>;
  managerId?: Maybe<Scalars['Long']['output']>;
  mandatAutofacFinancement?: Maybe<Scalars['Byte']['output']>;
  mandatAutofacPlacement?: Maybe<Scalars['Byte']['output']>;
  mandatAutofacTotal?: Maybe<Scalars['Byte']['output']>;
  minotaureImportProgress?: Maybe<MinotaureImportProgress>;
  motifResiliationCode?: Maybe<Scalars['String']['output']>;
  motifResiliationCodeNavigation?: Maybe<MotifResiliationConsultant>;
  nbAmbassadeurs?: Maybe<Scalars['Byte']['output']>;
  nbRecommandations?: Maybe<Scalars['Byte']['output']>;
  origineSaisie: Scalars['Byte']['output'];
  origineSaisieNavigation: OrigineData;
  parrain?: Maybe<Consultant>;
  parrainId?: Maybe<Scalars['Long']['output']>;
  personnePhysique: Array<PersonnePhysique>;
  peutParainner?: Maybe<Scalars['Boolean']['output']>;
  qualificationCode?: Maybe<Scalars['String']['output']>;
  qualificationCodeNavigation?: Maybe<QualificationConsultant>;
  raisonSociale?: Maybe<Scalars['String']['output']>;
  reponseRenouvellement?: Maybe<Scalars['Byte']['output']>;
  resiliationDate?: Maybe<Scalars['DateTime']['output']>;
  resiliationPaiementB2S: Array<ResiliationPaiementB2S>;
  souhaiteCollaborerAvecStelliumFi?: Maybe<Scalars['Boolean']['output']>;
  statutCode: Scalars['String']['output'];
  statutCodeNavigation: StatutConsultant;
  tauxRemuneration?: Maybe<Scalars['Decimal']['output']>;
  telephone: Array<Telephone>;
  teteReseau?: Maybe<Consultant>;
  teteReseauId?: Maybe<Scalars['Long']['output']>;
  titreCode?: Maybe<Scalars['String']['output']>;
  titreCodeNavigation?: Maybe<TitreConsultant>;
  totalDebours?: Maybe<Scalars['Decimal']['output']>;
  /** is consultant transfered from Ariane to Minotaure */
  transferStatus: ConsultantTransferStatus;
  waveLabel?: Maybe<Scalars['String']['output']>;
};


export type ConsultantAbonnementConsultantArgs = {
  where?: InputMaybe<AbonnementConsultantFilterInput>;
};


export type ConsultantAdhesionConsultantArgs = {
  where?: InputMaybe<AdhesionConsultantFilterInput>;
};


export type ConsultantAdresseArgs = {
  where?: InputMaybe<AdresseFilterInput>;
};


export type ConsultantCessionHistoCommandeCessionnaireArgs = {
  where?: InputMaybe<CessionHistoCommandeFilterInput>;
};


export type ConsultantCessionHistoCommandeConsultantArgs = {
  where?: InputMaybe<CessionHistoCommandeFilterInput>;
};


export type ConsultantCessionHistoInvestisseurCessionnaireArgs = {
  where?: InputMaybe<CessionHistoInvestisseurFilterInput>;
};


export type ConsultantCessionHistoInvestisseurConsultantArgs = {
  where?: InputMaybe<CessionHistoInvestisseurFilterInput>;
};


export type ConsultantConseillerCommandeArgs = {
  where?: InputMaybe<ConseillerCommandeFilterInput>;
};


export type ConsultantConsultantDistinctionArgs = {
  where?: InputMaybe<ConsultantDistinctionFilterInput>;
};


export type ConsultantConsultantHabilitationsArgs = {
  where?: InputMaybe<ConsultantHabilitationFilterInput>;
};


export type ConsultantConsultantHabilitationsFictivesArgs = {
  where?: InputMaybe<ConsultantHabilitationsFictivesFilterInput>;
};


export type ConsultantConsultantMouvementArgs = {
  where?: InputMaybe<ConsultantMouvementFilterInput>;
};


export type ConsultantConsultantOrganisationConstellationArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};


export type ConsultantConsultantOrganisationEtoileArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};


export type ConsultantConsultantOrganisationGalaxieArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};


export type ConsultantConsultantOrganisationManagerArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};


export type ConsultantConsultantOrganisationPlaneteArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};


export type ConsultantConsultantRcpArgs = {
  where?: InputMaybe<ConsultantRcpFilterInput>;
};


export type ConsultantConsultantStatutCommercialArgs = {
  where?: InputMaybe<ConsultantStatutCommercialFilterInput>;
};


export type ConsultantConsultantStatutJuridiqueArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};


export type ConsultantEditionArgs = {
  where?: InputMaybe<EditionFilterInput>;
};


export type ConsultantEmailArgs = {
  where?: InputMaybe<EmailFilterInput>;
};


export type ConsultantEquivalenceDeFormationConsultantArgs = {
  where?: InputMaybe<EquivalenceDeFormationFilterInput>;
};


export type ConsultantEquivalenceDeFormationConsultantFormateurArgs = {
  where?: InputMaybe<EquivalenceDeFormationFilterInput>;
};


export type ConsultantFactureArgs = {
  where?: InputMaybe<FactureFilterInput>;
};


export type ConsultantImportHistoriesArgs = {
  where?: InputMaybe<ImportHistoryFilterInput>;
};


export type ConsultantInscriptionCycleCourtArgs = {
  where?: InputMaybe<InscriptionCycleCourtFilterInput>;
};


export type ConsultantInscriptionSessionArgs = {
  where?: InputMaybe<InscriptionSessionFilterInput>;
};


export type ConsultantInverseGalaxyArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type ConsultantInverseManagerArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type ConsultantInverseParrainArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type ConsultantInverseTeteReseauArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type ConsultantInvestisseurConsultantArgs = {
  where?: InputMaybe<InvestisseurConsultantFilterInput>;
};


export type ConsultantPersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};


export type ConsultantResiliationPaiementB2SArgs = {
  where?: InputMaybe<ResiliationPaiementB2SFilterInput>;
};


export type ConsultantTelephoneArgs = {
  where?: InputMaybe<TelephoneFilterInput>;
};

export type ConsultantAgregation = {
  __typename?: 'ConsultantAgregation';
  civilite?: Maybe<Scalars['String']['output']>;
  codeConsultant: Scalars['String']['output'];
  contratsInvestisseurs?: Maybe<Array<ContratsInvestisseur>>;
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  galaxieConsultant?: Maybe<ConsultantAgregation>;
  idConsultant?: Maybe<Scalars['String']['output']>;
  idGalaxie?: Maybe<Scalars['String']['output']>;
  idPersonne: Scalars['String']['output'];
  nom?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  prenomUniformise?: Maybe<Scalars['String']['output']>;
};

export type ConsultantAgregationFilterInput = {
  and?: InputMaybe<Array<ConsultantAgregationFilterInput>>;
  civilite?: InputMaybe<StringOperationFilterInput>;
  codeConsultant?: InputMaybe<StringOperationFilterInput>;
  contratsInvestisseurs?: InputMaybe<ListFilterInputTypeOfContratsInvestisseurFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  galaxieConsultant?: InputMaybe<ConsultantAgregationFilterInput>;
  idConsultant?: InputMaybe<StringOperationFilterInput>;
  idGalaxie?: InputMaybe<StringOperationFilterInput>;
  idPersonne?: InputMaybe<StringOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantAgregationFilterInput>>;
  prenom?: InputMaybe<StringOperationFilterInput>;
  prenomUniformise?: InputMaybe<StringOperationFilterInput>;
};

export type ConsultantAgregationSortInput = {
  civilite?: InputMaybe<SortEnumType>;
  codeConsultant?: InputMaybe<SortEnumType>;
  dateChargement?: InputMaybe<SortEnumType>;
  galaxieConsultant?: InputMaybe<ConsultantAgregationSortInput>;
  idConsultant?: InputMaybe<SortEnumType>;
  idGalaxie?: InputMaybe<SortEnumType>;
  idPersonne?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
  prenom?: InputMaybe<SortEnumType>;
  prenomUniformise?: InputMaybe<SortEnumType>;
};

export type ConsultantCarteDemarchage = {
  __typename?: 'ConsultantCarteDemarchage';
  consultantHabilitation: ConsultantHabilitation;
  consultantHabilitationId: Scalars['Long']['output'];
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  dateFinInitiale?: Maybe<Scalars['DateTime']['output']>;
  documentId?: Maybe<Scalars['UUID']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
};

export type ConsultantCarteDemarchageFilterInput = {
  and?: InputMaybe<Array<ConsultantCarteDemarchageFilterInput>>;
  consultantHabilitation?: InputMaybe<ConsultantHabilitationFilterInput>;
  consultantHabilitationId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinInitiale?: InputMaybe<DateTimeOperationFilterInput>;
  documentId?: InputMaybe<UuidOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantCarteDemarchageFilterInput>>;
};

export type ConsultantCommissionAdi = {
  __typename?: 'ConsultantCommissionAdi';
  actuelCommissionAdiType: Scalars['Int']['output'];
  actuelCommissionAdiTypeNavigation: CommissionAdiType;
  choixCommissionAdiType?: Maybe<Scalars['Int']['output']>;
  choixCommissionAdiTypeNavigation?: Maybe<CommissionAdiType>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateChoixCommissionAdiType?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idNavigation: Consultant;
};

export type ConsultantCommissionAdiFilterInput = {
  actuelCommissionAdiType?: InputMaybe<IntOperationFilterInput>;
  actuelCommissionAdiTypeNavigation?: InputMaybe<CommissionAdiTypeFilterInput>;
  and?: InputMaybe<Array<ConsultantCommissionAdiFilterInput>>;
  choixCommissionAdiType?: InputMaybe<IntOperationFilterInput>;
  choixCommissionAdiTypeNavigation?: InputMaybe<CommissionAdiTypeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateChoixCommissionAdiType?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idNavigation?: InputMaybe<ConsultantFilterInput>;
  or?: InputMaybe<Array<ConsultantCommissionAdiFilterInput>>;
};

export type ConsultantCommissionAdiSortInput = {
  actuelCommissionAdiType?: InputMaybe<SortEnumType>;
  actuelCommissionAdiTypeNavigation?: InputMaybe<CommissionAdiTypeSortInput>;
  choixCommissionAdiType?: InputMaybe<SortEnumType>;
  choixCommissionAdiTypeNavigation?: InputMaybe<CommissionAdiTypeSortInput>;
  creationDate?: InputMaybe<SortEnumType>;
  dateChoixCommissionAdiType?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idNavigation?: InputMaybe<ConsultantSortInput>;
};

export type ConsultantContrat = {
  __typename?: 'ConsultantContrat';
  consultantStatutJuridique: ConsultantStatutJuridique;
  consultantStatutJuridiqueId: Scalars['Long']['output'];
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateContrat?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  pieceJointe: Array<PieceJointeConsultant>;
  typeContratCode: Scalars['String']['output'];
  typeContratCodeNavigation: TypeContrat;
};


export type ConsultantContratPieceJointeArgs = {
  where?: InputMaybe<PieceJointeConsultantFilterInput>;
};

export type ConsultantContratFilterInput = {
  and?: InputMaybe<Array<ConsultantContratFilterInput>>;
  consultantStatutJuridique?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  consultantStatutJuridiqueId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateContrat?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantContratFilterInput>>;
  pieceJointe?: InputMaybe<ListFilterInputTypeOfPieceJointeConsultantFilterInput>;
  typeContratCode?: InputMaybe<StringOperationFilterInput>;
  typeContratCodeNavigation?: InputMaybe<TypeContratFilterInput>;
};

export enum ConsultantContratsGraphEnum {
  ByAssureur = 'BY_ASSUREUR',
  ByContrat = 'BY_CONTRAT',
  ByEnveloppe = 'BY_ENVELOPPE'
}

export type ConsultantDistinction = {
  __typename?: 'ConsultantDistinction';
  categorie: DistinctionCategorie;
  categorieId: Scalars['Byte']['output'];
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateApparitionDistinction: Scalars['DateTime']['output'];
  dateCalculDistinction: Scalars['DateTime']['output'];
  dateDistinction: Scalars['DateTime']['output'];
  distinction: Scalars['Byte']['output'];
  distinctionNavigation: Distinction;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  exercicePMR: Scalars['Int']['output'];
  exercicePMRNavigation: ExerciceCommercial;
  id: Scalars['Long']['output'];
  nombreEtoile: Scalars['Byte']['output'];
  statutDistinction: StatutDistinction;
  statutDistinctionId: Scalars['Byte']['output'];
};

export type ConsultantDistinctionFilterInput = {
  and?: InputMaybe<Array<ConsultantDistinctionFilterInput>>;
  categorie?: InputMaybe<DistinctionCategorieFilterInput>;
  categorieId?: InputMaybe<ByteOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateApparitionDistinction?: InputMaybe<DateTimeOperationFilterInput>;
  dateCalculDistinction?: InputMaybe<DateTimeOperationFilterInput>;
  dateDistinction?: InputMaybe<DateTimeOperationFilterInput>;
  distinction?: InputMaybe<ByteOperationFilterInput>;
  distinctionNavigation?: InputMaybe<DistinctionFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  exercicePMR?: InputMaybe<IntOperationFilterInput>;
  exercicePMRNavigation?: InputMaybe<ExerciceCommercialFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  nombreEtoile?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantDistinctionFilterInput>>;
  statutDistinction?: InputMaybe<StatutDistinctionFilterInput>;
  statutDistinctionId?: InputMaybe<ByteOperationFilterInput>;
};

export type ConsultantFilterInput = {
  abonnementConsultant?: InputMaybe<ListFilterInputTypeOfAbonnementConsultantFilterInput>;
  adhesionConsultant?: InputMaybe<ListFilterInputTypeOfAdhesionConsultantFilterInput>;
  adresse?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  affiliationDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<ConsultantFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  cessionHistoCommandeCessionnaire?: InputMaybe<ListFilterInputTypeOfCessionHistoCommandeFilterInput>;
  cessionHistoCommandeConsultant?: InputMaybe<ListFilterInputTypeOfCessionHistoCommandeFilterInput>;
  cessionHistoInvestisseurCessionnaire?: InputMaybe<ListFilterInputTypeOfCessionHistoInvestisseurFilterInput>;
  cessionHistoInvestisseurConsultant?: InputMaybe<ListFilterInputTypeOfCessionHistoInvestisseurFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  codeTier?: InputMaybe<StringOperationFilterInput>;
  commentairePeriodeJunior?: InputMaybe<StringOperationFilterInput>;
  conseillerCommande?: InputMaybe<ListFilterInputTypeOfConseillerCommandeFilterInput>;
  consultantCommissionAdi?: InputMaybe<ConsultantCommissionAdiFilterInput>;
  consultantDistinction?: InputMaybe<ListFilterInputTypeOfConsultantDistinctionFilterInput>;
  consultantHabilitations?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationFilterInput>;
  consultantHabilitationsFictives?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationsFictivesFilterInput>;
  consultantMouvement?: InputMaybe<ListFilterInputTypeOfConsultantMouvementFilterInput>;
  consultantOrganisationConstellation?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  consultantOrganisationConsultant?: InputMaybe<ConsultantOrganisationFilterInput>;
  consultantOrganisationEtoile?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  consultantOrganisationGalaxie?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  consultantOrganisationManager?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  consultantOrganisationPlanete?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  consultantRcp?: InputMaybe<ListFilterInputTypeOfConsultantRcpFilterInput>;
  consultantStatutCommercial?: InputMaybe<ListFilterInputTypeOfConsultantStatutCommercialFilterInput>;
  consultantStatutJuridique?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  date1AcquisitionDroit?: InputMaybe<DateTimeOperationFilterInput>;
  date1Manager?: InputMaybe<DateTimeOperationFilterInput>;
  date1VenteActee?: InputMaybe<DateTimeOperationFilterInput>;
  date1VenteFinancement?: InputMaybe<DateTimeOperationFilterInput>;
  date1VenteImmo?: InputMaybe<DateTimeOperationFilterInput>;
  date1VentePlacement?: InputMaybe<DateTimeOperationFilterInput>;
  dateAcquisitionDroit?: InputMaybe<DateTimeOperationFilterInput>;
  dateAffiliationProdemial?: InputMaybe<DateTimeOperationFilterInput>;
  dateContact?: InputMaybe<DateTimeOperationFilterInput>;
  dateDemission?: InputMaybe<DateTimeOperationFilterInput>;
  dateEntree?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinPeriodeJunior?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinValiditeAffiliation?: InputMaybe<DateTimeOperationFilterInput>;
  dateSeminairePro?: InputMaybe<DateTimeOperationFilterInput>;
  derniereDateExclusif?: InputMaybe<DateTimeOperationFilterInput>;
  derniereDateNonExclusif?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  edition?: InputMaybe<ListFilterInputTypeOfEditionFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  eligilibleRenouvellement?: InputMaybe<BooleanOperationFilterInput>;
  email?: InputMaybe<ListFilterInputTypeOfEmailFilterInput>;
  equivalenceDeFormationConsultant?: InputMaybe<ListFilterInputTypeOfEquivalenceDeFormationFilterInput>;
  equivalenceDeFormationConsultantFormateur?: InputMaybe<ListFilterInputTypeOfEquivalenceDeFormationFilterInput>;
  exclusif?: InputMaybe<BooleanOperationFilterInput>;
  facture?: InputMaybe<ListFilterInputTypeOfFactureFilterInput>;
  galaxy?: InputMaybe<ConsultantFilterInput>;
  galaxyId?: InputMaybe<LongOperationFilterInput>;
  gerePar?: InputMaybe<AppReferenceOperationFilterInput>;
  habilitationALPSI?: InputMaybe<BooleanOperationFilterInput>;
  habilitationAssurance?: InputMaybe<BooleanOperationFilterInput>;
  habilitationCIF?: InputMaybe<BooleanOperationFilterInput>;
  habilitationIOB?: InputMaybe<BooleanOperationFilterInput>;
  habilitationImmo?: InputMaybe<BooleanOperationFilterInput>;
  habilitationPMR?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  inscriptionCycleCourt?: InputMaybe<ListFilterInputTypeOfInscriptionCycleCourtFilterInput>;
  inscriptionSession?: InputMaybe<ListFilterInputTypeOfInscriptionSessionFilterInput>;
  inverseGalaxy?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  inverseManager?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  inverseParrain?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  inverseTeteReseau?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  investisseurConsultant?: InputMaybe<ListFilterInputTypeOfInvestisseurConsultantFilterInput>;
  manager?: InputMaybe<ConsultantFilterInput>;
  managerId?: InputMaybe<LongOperationFilterInput>;
  mandatAutofacFinancement?: InputMaybe<ByteOperationFilterInput>;
  mandatAutofacPlacement?: InputMaybe<ByteOperationFilterInput>;
  mandatAutofacTotal?: InputMaybe<ByteOperationFilterInput>;
  motifResiliationCode?: InputMaybe<StringOperationFilterInput>;
  motifResiliationCodeNavigation?: InputMaybe<MotifResiliationConsultantFilterInput>;
  nbAmbassadeurs?: InputMaybe<ByteOperationFilterInput>;
  nbRecommandations?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantFilterInput>>;
  origineSaisie?: InputMaybe<ByteOperationFilterInput>;
  origineSaisieNavigation?: InputMaybe<OrigineDataFilterInput>;
  parrain?: InputMaybe<ConsultantFilterInput>;
  parrainId?: InputMaybe<LongOperationFilterInput>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  peutParainner?: InputMaybe<BooleanOperationFilterInput>;
  qualificationCode?: InputMaybe<StringOperationFilterInput>;
  qualificationCodeNavigation?: InputMaybe<QualificationConsultantFilterInput>;
  raisonSociale?: InputMaybe<StringOperationFilterInput>;
  reponseRenouvellement?: InputMaybe<ByteOperationFilterInput>;
  resiliationDate?: InputMaybe<DateTimeOperationFilterInput>;
  resiliationPaiementB2S?: InputMaybe<ListFilterInputTypeOfResiliationPaiementB2SFilterInput>;
  souhaiteCollaborerAvecStelliumFi?: InputMaybe<BooleanOperationFilterInput>;
  statutCode?: InputMaybe<StringOperationFilterInput>;
  statutCodeNavigation?: InputMaybe<StatutConsultantFilterInput>;
  tauxRemuneration?: InputMaybe<DecimalOperationFilterInput>;
  telephone?: InputMaybe<ListFilterInputTypeOfTelephoneFilterInput>;
  teteReseau?: InputMaybe<ConsultantFilterInput>;
  teteReseauId?: InputMaybe<LongOperationFilterInput>;
  titreCode?: InputMaybe<StringOperationFilterInput>;
  titreCodeNavigation?: InputMaybe<TitreConsultantFilterInput>;
  totalDebours?: InputMaybe<DecimalOperationFilterInput>;
};

export type ConsultantHabilitation = {
  __typename?: 'ConsultantHabilitation';
  actionsBackOffice: Array<ConsultantHabilitationActionBackOffice>;
  associationProNom?: Maybe<Scalars['String']['output']>;
  cifPartenaireCode?: Maybe<Scalars['String']['output']>;
  codeHabilitation?: Maybe<Scalars['String']['output']>;
  consultant?: Maybe<Consultant>;
  consultantCartesDemarchage: Array<ConsultantCarteDemarchage>;
  consultantHabilitationInscription: Array<ConsultantHabilitationInscription>;
  consultantId?: Maybe<Scalars['Long']['output']>;
  consultantStatutJuridique?: Maybe<ConsultantStatutJuridique>;
  consultantStatutJuridiqueId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  datePremiereHabilitation?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  evaluationRequise?: Maybe<Scalars['Boolean']['output']>;
  expirations: Array<ConsultantHabilitationExpiration>;
  garantAdresse?: Maybe<Scalars['String']['output']>;
  garantNom?: Maybe<Scalars['String']['output']>;
  habilitation?: Maybe<Habilitation>;
  habilitationId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  invalidityReasons: Array<ConsultantHabilitationInvalidityReason>;
  mediateur?: Maybe<Scalars['String']['output']>;
  mediateurAssu?: Maybe<Scalars['String']['output']>;
  mediateurCif?: Maybe<Scalars['String']['output']>;
  mediateurIOB?: Maybe<Scalars['String']['output']>;
  mediateurImmo?: Maybe<Scalars['String']['output']>;
  partenaireCourtierFinancement1?: Maybe<Scalars['String']['output']>;
  partenaireCourtierFinancement2?: Maybe<Scalars['String']['output']>;
  statut?: Maybe<Scalars['Int']['output']>;
  statutChanges: Array<ConsultantHabilitationStatutChange>;
};


export type ConsultantHabilitationActionsBackOfficeArgs = {
  where?: InputMaybe<ConsultantHabilitationActionBackOfficeFilterInput>;
};


export type ConsultantHabilitationConsultantCartesDemarchageArgs = {
  where?: InputMaybe<ConsultantCarteDemarchageFilterInput>;
};


export type ConsultantHabilitationConsultantHabilitationInscriptionArgs = {
  where?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
};


export type ConsultantHabilitationExpirationsArgs = {
  where?: InputMaybe<ConsultantHabilitationExpirationFilterInput>;
};


export type ConsultantHabilitationInvalidityReasonsArgs = {
  where?: InputMaybe<ConsultantHabilitationInvalidityReasonFilterInput>;
};


export type ConsultantHabilitationStatutChangesArgs = {
  where?: InputMaybe<ConsultantHabilitationStatutChangeFilterInput>;
};

export type ConsultantHabilitationActionBackOffice = {
  __typename?: 'ConsultantHabilitationActionBackOffice';
  active: Scalars['Boolean']['output'];
  consultantHabilitation: ConsultantHabilitation;
  consultantHabilitationId: Scalars['Long']['output'];
  consultantHabilitationTempStatut: Scalars['Boolean']['output'];
  dateAction: Scalars['DateTime']['output'];
  dateEcheance?: Maybe<Scalars['DateTime']['output']>;
  echeance: ConsultantHabilitationActionBackOfficeEcheance;
  echeanceCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type ConsultantHabilitationActionBackOfficeEcheance = {
  __typename?: 'ConsultantHabilitationActionBackOfficeEcheance';
  actionsBackOffice: Array<ConsultantHabilitationActionBackOffice>;
  code: Scalars['String']['output'];
};


export type ConsultantHabilitationActionBackOfficeEcheanceActionsBackOfficeArgs = {
  where?: InputMaybe<ConsultantHabilitationActionBackOfficeFilterInput>;
};

export type ConsultantHabilitationActionBackOfficeEcheanceFilterInput = {
  actionsBackOffice?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationActionBackOfficeFilterInput>;
  and?: InputMaybe<Array<ConsultantHabilitationActionBackOfficeEcheanceFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationActionBackOfficeEcheanceFilterInput>>;
};

export type ConsultantHabilitationActionBackOfficeFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ConsultantHabilitationActionBackOfficeFilterInput>>;
  consultantHabilitation?: InputMaybe<ConsultantHabilitationFilterInput>;
  consultantHabilitationId?: InputMaybe<LongOperationFilterInput>;
  consultantHabilitationTempStatut?: InputMaybe<BooleanOperationFilterInput>;
  dateAction?: InputMaybe<DateTimeOperationFilterInput>;
  dateEcheance?: InputMaybe<DateTimeOperationFilterInput>;
  echeance?: InputMaybe<ConsultantHabilitationActionBackOfficeEcheanceFilterInput>;
  echeanceCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationActionBackOfficeFilterInput>>;
};

export type ConsultantHabilitationExpiration = {
  __typename?: 'ConsultantHabilitationExpiration';
  dateExpiration: Scalars['DateTime']['output'];
  expirationReason: Scalars['String']['output'];
  habilitation: ConsultantHabilitation;
  habilitationId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  reason: ConsultantHabilitationExpirationReason;
};

export type ConsultantHabilitationExpirationFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationExpirationFilterInput>>;
  dateExpiration?: InputMaybe<DateTimeOperationFilterInput>;
  expirationReason?: InputMaybe<StringOperationFilterInput>;
  habilitation?: InputMaybe<ConsultantHabilitationFilterInput>;
  habilitationId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationExpirationFilterInput>>;
  reason?: InputMaybe<ConsultantHabilitationExpirationReasonFilterInput>;
};

export type ConsultantHabilitationExpirationReason = {
  __typename?: 'ConsultantHabilitationExpirationReason';
  code: Scalars['String']['output'];
  expirations: Array<ConsultantHabilitationExpiration>;
};


export type ConsultantHabilitationExpirationReasonExpirationsArgs = {
  where?: InputMaybe<ConsultantHabilitationExpirationFilterInput>;
};

export type ConsultantHabilitationExpirationReasonFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationExpirationReasonFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  expirations?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationExpirationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationExpirationReasonFilterInput>>;
};

export type ConsultantHabilitationFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationFilterInput>>;
  associationProNom?: InputMaybe<StringOperationFilterInput>;
  cifPartenaireCode?: InputMaybe<StringOperationFilterInput>;
  codeHabilitation?: InputMaybe<StringOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  consultantStatutJuridiqueId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  datePremiereHabilitation?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  evaluationRequise?: InputMaybe<BooleanOperationFilterInput>;
  garantAdresse?: InputMaybe<StringOperationFilterInput>;
  garantNom?: InputMaybe<StringOperationFilterInput>;
  habilitation?: InputMaybe<HabilitationFilterInput>;
  habilitationId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  mediateur?: InputMaybe<StringOperationFilterInput>;
  mediateurAssu?: InputMaybe<StringOperationFilterInput>;
  mediateurCif?: InputMaybe<StringOperationFilterInput>;
  mediateurIOB?: InputMaybe<StringOperationFilterInput>;
  mediateurImmo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationFilterInput>>;
  partenaireCourtierFinancement1?: InputMaybe<StringOperationFilterInput>;
  partenaireCourtierFinancement2?: InputMaybe<StringOperationFilterInput>;
  statut?: InputMaybe<IntOperationFilterInput>;
};

export type ConsultantHabilitationInscription = {
  __typename?: 'ConsultantHabilitationInscription';
  carteTStellium?: Maybe<Scalars['Boolean']['output']>;
  consultantHabilitation?: Maybe<ConsultantHabilitation>;
  consultantHabilitationId?: Maybe<Scalars['Long']['output']>;
  consultantHabilitationInscriptionCategorie: Array<ConsultantHabilitationInscriptionCategorie>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateDepot?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  descriptionInscription?: Maybe<Scalars['String']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idHabConsInsc?: Maybe<Scalars['Long']['output']>;
  idSource?: Maybe<Scalars['String']['output']>;
  libelleInscription?: Maybe<Scalars['String']['output']>;
  numeroCarteTConsultant?: Maybe<Scalars['String']['output']>;
  numeroInscription?: Maybe<Scalars['String']['output']>;
  orgCIF?: Maybe<Scalars['String']['output']>;
  organismeCode?: Maybe<Scalars['String']['output']>;
  organismeCodeNavigation?: Maybe<Organisme>;
  pieceJointeConsultant: Array<PieceJointeConsultant>;
};


export type ConsultantHabilitationInscriptionConsultantHabilitationInscriptionCategorieArgs = {
  where?: InputMaybe<ConsultantHabilitationInscriptionCategorieFilterInput>;
};


export type ConsultantHabilitationInscriptionPieceJointeConsultantArgs = {
  where?: InputMaybe<PieceJointeConsultantFilterInput>;
};

export type ConsultantHabilitationInscriptionCategorie = {
  __typename?: 'ConsultantHabilitationInscriptionCategorie';
  consultantHabilitationInscription: ConsultantHabilitationInscription;
  consultantHabilitationInscriptionCategorieMandant: Array<ConsultantHabilitationInscriptionCategorieMandant>;
  consultantHabilitationInscriptionId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  habilitationInscriptionCategorie: HabilitationInscriptionCategorie;
  habilitationInscriptionCategorieId: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  rn_Create_User?: Maybe<Scalars['Long']['output']>;
  rn_Edit_User?: Maybe<Scalars['Long']['output']>;
};


export type ConsultantHabilitationInscriptionCategorieConsultantHabilitationInscriptionCategorieMandantArgs = {
  where?: InputMaybe<ConsultantHabilitationInscriptionCategorieMandantFilterInput>;
};

export type ConsultantHabilitationInscriptionCategorieFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationInscriptionCategorieFilterInput>>;
  consultantHabilitationInscription?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
  consultantHabilitationInscriptionCategorieMandant?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInscriptionCategorieMandantFilterInput>;
  consultantHabilitationInscriptionId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  habilitationInscriptionCategorie?: InputMaybe<HabilitationInscriptionCategorieFilterInput>;
  habilitationInscriptionCategorieId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationInscriptionCategorieFilterInput>>;
  rn_Create_User?: InputMaybe<LongOperationFilterInput>;
  rn_Edit_User?: InputMaybe<LongOperationFilterInput>;
};

export type ConsultantHabilitationInscriptionCategorieMandant = {
  __typename?: 'ConsultantHabilitationInscriptionCategorieMandant';
  consultantHabilitationInscriptionCategorie?: Maybe<ConsultantHabilitationInscriptionCategorie>;
  consultantHabilitationInscriptionCategorieId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  mandant?: Maybe<Scalars['String']['output']>;
};

export type ConsultantHabilitationInscriptionCategorieMandantFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationInscriptionCategorieMandantFilterInput>>;
  consultantHabilitationInscriptionCategorie?: InputMaybe<ConsultantHabilitationInscriptionCategorieFilterInput>;
  consultantHabilitationInscriptionCategorieId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  mandant?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationInscriptionCategorieMandantFilterInput>>;
};

export type ConsultantHabilitationInscriptionFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationInscriptionFilterInput>>;
  carteTStellium?: InputMaybe<BooleanOperationFilterInput>;
  consultantHabilitation?: InputMaybe<ConsultantHabilitationFilterInput>;
  consultantHabilitationId?: InputMaybe<LongOperationFilterInput>;
  consultantHabilitationInscriptionCategorie?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInscriptionCategorieFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateDepot?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  descriptionInscription?: InputMaybe<StringOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idHabConsInsc?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  libelleInscription?: InputMaybe<StringOperationFilterInput>;
  numeroCarteTConsultant?: InputMaybe<StringOperationFilterInput>;
  numeroInscription?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationInscriptionFilterInput>>;
  orgCIF?: InputMaybe<StringOperationFilterInput>;
  organismeCode?: InputMaybe<StringOperationFilterInput>;
  organismeCodeNavigation?: InputMaybe<OrganismeFilterInput>;
  pieceJointeConsultant?: InputMaybe<ListFilterInputTypeOfPieceJointeConsultantFilterInput>;
};

export type ConsultantHabilitationInvalidityReason = {
  __typename?: 'ConsultantHabilitationInvalidityReason';
  consultantHabilitation: ConsultantHabilitation;
  consultantHabilitationId: Scalars['Long']['output'];
  evaluationDate: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  reason: ConsultantHabilitationStatutChangeReason;
  reasonCode?: Maybe<Scalars['String']['output']>;
};

export type ConsultantHabilitationInvalidityReasonFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationInvalidityReasonFilterInput>>;
  consultantHabilitation?: InputMaybe<ConsultantHabilitationFilterInput>;
  consultantHabilitationId?: InputMaybe<LongOperationFilterInput>;
  evaluationDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationInvalidityReasonFilterInput>>;
  reason?: InputMaybe<ConsultantHabilitationStatutChangeReasonFilterInput>;
  reasonCode?: InputMaybe<StringOperationFilterInput>;
};

export type ConsultantHabilitationStatutChange = {
  __typename?: 'ConsultantHabilitationStatutChange';
  changeDate: Scalars['DateTime']['output'];
  changeReason: ConsultantHabilitationStatutChangeReason;
  changeReasonCode?: Maybe<Scalars['String']['output']>;
  changeType: ConsultantHabilitationStatutChangeType;
  changeTypeCode: Scalars['String']['output'];
  consultantHabilitation: ConsultantHabilitation;
  consultantHabilitationId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
};

export type ConsultantHabilitationStatutChangeFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationStatutChangeFilterInput>>;
  changeDate?: InputMaybe<DateTimeOperationFilterInput>;
  changeReason?: InputMaybe<ConsultantHabilitationStatutChangeReasonFilterInput>;
  changeReasonCode?: InputMaybe<StringOperationFilterInput>;
  changeType?: InputMaybe<ConsultantHabilitationStatutChangeTypeFilterInput>;
  changeTypeCode?: InputMaybe<StringOperationFilterInput>;
  consultantHabilitation?: InputMaybe<ConsultantHabilitationFilterInput>;
  consultantHabilitationId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationStatutChangeFilterInput>>;
};

export type ConsultantHabilitationStatutChangeReason = {
  __typename?: 'ConsultantHabilitationStatutChangeReason';
  code: Scalars['String']['output'];
  invalidityReasons: Array<ConsultantHabilitationInvalidityReason>;
  statutChanges: Array<ConsultantHabilitationStatutChange>;
};


export type ConsultantHabilitationStatutChangeReasonInvalidityReasonsArgs = {
  where?: InputMaybe<ConsultantHabilitationInvalidityReasonFilterInput>;
};


export type ConsultantHabilitationStatutChangeReasonStatutChangesArgs = {
  where?: InputMaybe<ConsultantHabilitationStatutChangeFilterInput>;
};

export enum ConsultantHabilitationStatutChangeReasonEnum {
  CarteDeDemarchage = 'CARTE_DE_DEMARCHAGE',
  CollabStefi = 'COLLAB_STEFI',
  FormationContinue = 'FORMATION_CONTINUE',
  FormationInitiale = 'FORMATION_INITIALE',
  HabilitationIob = 'HABILITATION_IOB',
  InitiativeBackOffice = 'INITIATIVE_BACK_OFFICE',
  Inscription = 'INSCRIPTION',
  Rcp = 'RCP',
  Resiliation = 'RESILIATION',
  StatutJuridique = 'STATUT_JURIDIQUE'
}

export type ConsultantHabilitationStatutChangeReasonEnumOperationFilterInput = {
  eq?: InputMaybe<ConsultantHabilitationStatutChangeReasonEnum>;
  in?: InputMaybe<Array<ConsultantHabilitationStatutChangeReasonEnum>>;
  neq?: InputMaybe<ConsultantHabilitationStatutChangeReasonEnum>;
  nin?: InputMaybe<Array<ConsultantHabilitationStatutChangeReasonEnum>>;
};

export type ConsultantHabilitationStatutChangeReasonFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationStatutChangeReasonFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  invalidityReasons?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInvalidityReasonFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationStatutChangeReasonFilterInput>>;
  statutChanges?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationStatutChangeFilterInput>;
};

export type ConsultantHabilitationStatutChangeType = {
  __typename?: 'ConsultantHabilitationStatutChangeType';
  code: Scalars['String']['output'];
  statutChanges: Array<ConsultantHabilitationStatutChange>;
};


export type ConsultantHabilitationStatutChangeTypeStatutChangesArgs = {
  where?: InputMaybe<ConsultantHabilitationStatutChangeFilterInput>;
};

export type ConsultantHabilitationStatutChangeTypeFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationStatutChangeTypeFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationStatutChangeTypeFilterInput>>;
  statutChanges?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationStatutChangeFilterInput>;
};

export type ConsultantHabilitationsFictives = {
  __typename?: 'ConsultantHabilitationsFictives';
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  habilitation: Scalars['String']['output'];
  id: Scalars['Long']['output'];
};

export type ConsultantHabilitationsFictivesFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationsFictivesFilterInput>>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  habilitation?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationsFictivesFilterInput>>;
};

export type ConsultantId = {
  __typename?: 'ConsultantId';
  code: Scalars['String']['output'];
  id: Scalars['Long']['output'];
};

export type ConsultantMigrationJob = {
  __typename?: 'ConsultantMigrationJob';
  arianeDumpJobs: Array<ArianeDumpJob>;
  consultantId: Scalars['Long']['output'];
  createdAt: Scalars['DateTime']['output'];
  galaxyMigrationJob?: Maybe<GalaxyMigrationJob>;
  galaxyMigrationJobId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  isActive: Scalars['Boolean']['output'];
  isPreImport: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  shouldAutomaticallyProcess: Scalars['Boolean']['output'];
  startMigrationTimeStamp?: Maybe<Scalars['DateTime']['output']>;
  status: JobStatus;
  waveMigrationJob?: Maybe<WaveMigrationJob>;
  waveMigrationJobId?: Maybe<Scalars['Long']['output']>;
};


export type ConsultantMigrationJobArianeDumpJobsArgs = {
  where?: InputMaybe<ArianeDumpJobFilterInput>;
};

export type ConsultantMigrationJobFilterInput = {
  and?: InputMaybe<Array<ConsultantMigrationJobFilterInput>>;
  arianeDumpJobs?: InputMaybe<ListFilterInputTypeOfArianeDumpJobFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  galaxyMigrationJob?: InputMaybe<GalaxyMigrationJobFilterInput>;
  galaxyMigrationJobId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isPreImport?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantMigrationJobFilterInput>>;
  priority?: InputMaybe<IntOperationFilterInput>;
  shouldAutomaticallyProcess?: InputMaybe<BooleanOperationFilterInput>;
  startMigrationTimeStamp?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<JobStatusOperationFilterInput>;
  waveMigrationJob?: InputMaybe<WaveMigrationJobFilterInput>;
  waveMigrationJobId?: InputMaybe<LongOperationFilterInput>;
};

export type ConsultantMigrationJobSortInput = {
  consultantId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  galaxyMigrationJob?: InputMaybe<GalaxyMigrationJobSortInput>;
  galaxyMigrationJobId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isPreImport?: InputMaybe<SortEnumType>;
  priority?: InputMaybe<SortEnumType>;
  shouldAutomaticallyProcess?: InputMaybe<SortEnumType>;
  startMigrationTimeStamp?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  waveMigrationJob?: InputMaybe<WaveMigrationJobSortInput>;
  waveMigrationJobId?: InputMaybe<SortEnumType>;
};

export type ConsultantMouvement = {
  __typename?: 'ConsultantMouvement';
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  mouvement: Mouvement;
  mouvementId: Scalars['Long']['output'];
  roleConsultantMouvement: Scalars['Byte']['output'];
  roleConsultantMouvementNavigation: TypeConseillerCommande;
};

export type ConsultantMouvementFilterInput = {
  and?: InputMaybe<Array<ConsultantMouvementFilterInput>>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  mouvement?: InputMaybe<MouvementFilterInput>;
  mouvementId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantMouvementFilterInput>>;
  roleConsultantMouvement?: InputMaybe<ByteOperationFilterInput>;
  roleConsultantMouvementNavigation?: InputMaybe<TypeConseillerCommandeFilterInput>;
};

export enum ConsultantOrdreSignatureEnum {
  ConsultantEnDernier = 'CONSULTANT_EN_DERNIER',
  ConsultantEnPremier = 'CONSULTANT_EN_PREMIER'
}

export type ConsultantOrdreSignatureEnumOperationFilterInput = {
  eq?: InputMaybe<ConsultantOrdreSignatureEnum>;
  in?: InputMaybe<Array<ConsultantOrdreSignatureEnum>>;
  neq?: InputMaybe<ConsultantOrdreSignatureEnum>;
  nin?: InputMaybe<Array<ConsultantOrdreSignatureEnum>>;
};

export type ConsultantOrganisation = {
  __typename?: 'ConsultantOrganisation';
  constellation?: Maybe<Consultant>;
  constellationId?: Maybe<Scalars['Long']['output']>;
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  etoile?: Maybe<Consultant>;
  etoileId?: Maybe<Scalars['Long']['output']>;
  galaxie?: Maybe<Consultant>;
  galaxieId?: Maybe<Scalars['Long']['output']>;
  manager?: Maybe<Consultant>;
  managerId?: Maybe<Scalars['Long']['output']>;
  nbMembresOrgan4Nvx?: Maybe<Scalars['Int']['output']>;
  nbMembresOrgan8Nvx?: Maybe<Scalars['Int']['output']>;
  planete?: Maybe<Consultant>;
  planeteId?: Maybe<Scalars['Long']['output']>;
  qualification?: Maybe<QualificationConsultant>;
  qualificationId?: Maybe<Scalars['String']['output']>;
  tauxRemuneration?: Maybe<TauxRemunerationConsultant>;
  tauxRemunerationId?: Maybe<Scalars['Int']['output']>;
  titre?: Maybe<TitreConsultant>;
  titreId?: Maybe<Scalars['String']['output']>;
};

export type ConsultantOrganisationFilterInput = {
  and?: InputMaybe<Array<ConsultantOrganisationFilterInput>>;
  constellation?: InputMaybe<ConsultantFilterInput>;
  constellationId?: InputMaybe<LongOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  etoile?: InputMaybe<ConsultantFilterInput>;
  etoileId?: InputMaybe<LongOperationFilterInput>;
  galaxie?: InputMaybe<ConsultantFilterInput>;
  galaxieId?: InputMaybe<LongOperationFilterInput>;
  manager?: InputMaybe<ConsultantFilterInput>;
  managerId?: InputMaybe<LongOperationFilterInput>;
  nbMembresOrgan4Nvx?: InputMaybe<IntOperationFilterInput>;
  nbMembresOrgan8Nvx?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantOrganisationFilterInput>>;
  planete?: InputMaybe<ConsultantFilterInput>;
  planeteId?: InputMaybe<LongOperationFilterInput>;
  qualification?: InputMaybe<QualificationConsultantFilterInput>;
  qualificationId?: InputMaybe<StringOperationFilterInput>;
  tauxRemuneration?: InputMaybe<TauxRemunerationConsultantFilterInput>;
  tauxRemunerationId?: InputMaybe<IntOperationFilterInput>;
  titre?: InputMaybe<TitreConsultantFilterInput>;
  titreId?: InputMaybe<StringOperationFilterInput>;
};

export type ConsultantOrganisationSortInput = {
  constellation?: InputMaybe<ConsultantSortInput>;
  constellationId?: InputMaybe<SortEnumType>;
  consultant?: InputMaybe<ConsultantSortInput>;
  consultantId?: InputMaybe<SortEnumType>;
  etoile?: InputMaybe<ConsultantSortInput>;
  etoileId?: InputMaybe<SortEnumType>;
  galaxie?: InputMaybe<ConsultantSortInput>;
  galaxieId?: InputMaybe<SortEnumType>;
  manager?: InputMaybe<ConsultantSortInput>;
  managerId?: InputMaybe<SortEnumType>;
  nbMembresOrgan4Nvx?: InputMaybe<SortEnumType>;
  nbMembresOrgan8Nvx?: InputMaybe<SortEnumType>;
  planete?: InputMaybe<ConsultantSortInput>;
  planeteId?: InputMaybe<SortEnumType>;
  qualification?: InputMaybe<QualificationConsultantSortInput>;
  qualificationId?: InputMaybe<SortEnumType>;
  tauxRemuneration?: InputMaybe<TauxRemunerationConsultantSortInput>;
  tauxRemunerationId?: InputMaybe<SortEnumType>;
  titre?: InputMaybe<TitreConsultantSortInput>;
  titreId?: InputMaybe<SortEnumType>;
};

export type ConsultantPreferences = {
  __typename?: 'ConsultantPreferences';
  code: Scalars['String']['output'];
  consultant?: Maybe<Consultant>;
  consultantId: Scalars['Long']['output'];
  /** Graphe affiché dans le premier placeholder des contrats d'un consultant */
  contratsGraphType1?: Maybe<ConsultantContratsGraphEnum>;
  /** Graphe affiché dans le deuxième placeholder des contrats d'un consultant */
  contratsGraphType2?: Maybe<ConsultantContratsGraphEnum>;
  /** Génération par défaut du recueil solo/couple */
  generationRecueilType: GenerationRecueilTypeEnum;
  /** Graphe affiché dans le premier placeholder du détail d'un contrat */
  graphType1?: Maybe<ContratDetailGraphEnum>;
  /** Graphe affiché dans le deuxième placeholder du détail d'un contrat */
  graphType2?: Maybe<ContratDetailGraphEnum>;
  /** Ordre de signature des documents par le consultant */
  ordreSignature: ConsultantOrdreSignatureEnum;
  /** Visibilité des champs complémentaires dans le recueil */
  recueilChampsComplementairesVisible: Scalars['Boolean']['output'];
  /** Graphe affiché dans le placeholder des supports d'un consultant */
  supportsGraphType1?: Maybe<ConsultantSupportsGraphEnum>;
  /** Graphe affiché dans le placeholder des supports d'un consultant */
  supportsGraphType2?: Maybe<ConsultantSupportsGraphEnum>;
};

export type ConsultantPreferencesFilterInput = {
  and?: InputMaybe<Array<ConsultantPreferencesFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<MinotaureConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  /** Graphe affiché dans le premier placeholder des contrats d'un consultant */
  contratsGraphType1?: InputMaybe<NullableOfConsultantContratsGraphEnumOperationFilterInput>;
  /** Graphe affiché dans le deuxième placeholder des contrats d'un consultant */
  contratsGraphType2?: InputMaybe<NullableOfConsultantContratsGraphEnumOperationFilterInput>;
  /** Génération par défaut du recueil solo/couple */
  generationRecueilType?: InputMaybe<GenerationRecueilTypeEnumOperationFilterInput>;
  /** Graphe affiché dans le premier placeholder du détail d'un contrat */
  graphType1?: InputMaybe<NullableOfContratDetailGraphEnumOperationFilterInput>;
  /** Graphe affiché dans le deuxième placeholder du détail d'un contrat */
  graphType2?: InputMaybe<NullableOfContratDetailGraphEnumOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantPreferencesFilterInput>>;
  /** Ordre de signature des documents par le consultant */
  ordreSignature?: InputMaybe<ConsultantOrdreSignatureEnumOperationFilterInput>;
  /** Visibilité des champs complémentaires dans le recueil */
  recueilChampsComplementairesVisible?: InputMaybe<BooleanOperationFilterInput>;
  /** Graphe affiché dans le placeholder des supports d'un consultant */
  supportsGraphType1?: InputMaybe<NullableOfConsultantSupportsGraphEnumOperationFilterInput>;
  /** Graphe affiché dans le placeholder des supports d'un consultant */
  supportsGraphType2?: InputMaybe<NullableOfConsultantSupportsGraphEnumOperationFilterInput>;
};

export type ConsultantPreferencesInput = {
  contratsGraphType1?: InputMaybe<ConsultantContratsGraphEnum>;
  contratsGraphType2?: InputMaybe<ConsultantContratsGraphEnum>;
  generationRecueilType?: InputMaybe<GenerationRecueilTypeEnum>;
  graphType1?: InputMaybe<ContratDetailGraphEnum>;
  graphType2?: InputMaybe<ContratDetailGraphEnum>;
  ordreSignature?: InputMaybe<ConsultantOrdreSignatureEnum>;
  recueilChampsComplementairesVisible?: InputMaybe<Scalars['Boolean']['input']>;
  supportsGraphType1?: InputMaybe<ConsultantSupportsGraphEnum>;
  supportsGraphType2?: InputMaybe<ConsultantSupportsGraphEnum>;
};

export type ConsultantPreferencesSortInput = {
  code?: InputMaybe<SortEnumType>;
  consultant?: InputMaybe<MinotaureConsultantSortInput>;
  consultantId?: InputMaybe<SortEnumType>;
  /** Graphe affiché dans le premier placeholder des contrats d'un consultant */
  contratsGraphType1?: InputMaybe<SortEnumType>;
  /** Graphe affiché dans le deuxième placeholder des contrats d'un consultant */
  contratsGraphType2?: InputMaybe<SortEnumType>;
  /** Génération par défaut du recueil solo/couple */
  generationRecueilType?: InputMaybe<SortEnumType>;
  /** Graphe affiché dans le premier placeholder du détail d'un contrat */
  graphType1?: InputMaybe<SortEnumType>;
  /** Graphe affiché dans le deuxième placeholder du détail d'un contrat */
  graphType2?: InputMaybe<SortEnumType>;
  /** Ordre de signature des documents par le consultant */
  ordreSignature?: InputMaybe<SortEnumType>;
  /** Visibilité des champs complémentaires dans le recueil */
  recueilChampsComplementairesVisible?: InputMaybe<SortEnumType>;
  /** Graphe affiché dans le placeholder des supports d'un consultant */
  supportsGraphType1?: InputMaybe<SortEnumType>;
  /** Graphe affiché dans le placeholder des supports d'un consultant */
  supportsGraphType2?: InputMaybe<SortEnumType>;
};

export type ConsultantRcp = {
  __typename?: 'ConsultantRcp';
  assureurRcpAdresse?: Maybe<Scalars['String']['output']>;
  assureurRcpNom?: Maybe<Scalars['String']['output']>;
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  consultantStatutJuridique?: Maybe<ConsultantStatutJuridique>;
  consultantStatutJuridiqueId?: Maybe<Scalars['Long']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateAnnulation?: Maybe<Scalars['DateTime']['output']>;
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  documentId?: Maybe<Scalars['UUID']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  garantieRcpMontantParSinistre: Scalars['Decimal']['output'];
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  motifAnnulationId?: Maybe<Scalars['String']['output']>;
  organismeAssureur?: Maybe<OrganismeAssureurRcp>;
  organismeAssureurId?: Maybe<Scalars['Long']['output']>;
  typeRcpCode?: Maybe<Scalars['String']['output']>;
  typeRcpCodeNavigation?: Maybe<TypeRcp>;
};

export type ConsultantRcpFilterInput = {
  and?: InputMaybe<Array<ConsultantRcpFilterInput>>;
  assureurRcpAdresse?: InputMaybe<StringOperationFilterInput>;
  assureurRcpNom?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  consultantStatutJuridique?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  consultantStatutJuridiqueId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateAnnulation?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  documentId?: InputMaybe<UuidOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  garantieRcpMontantParSinistre?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  motifAnnulationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantRcpFilterInput>>;
  organismeAssureur?: InputMaybe<OrganismeAssureurRcpFilterInput>;
  organismeAssureurId?: InputMaybe<LongOperationFilterInput>;
  typeRcpCode?: InputMaybe<StringOperationFilterInput>;
  typeRcpCodeNavigation?: InputMaybe<TypeRcpFilterInput>;
};

export type ConsultantRepartitionClasseActif = {
  __typename?: 'ConsultantRepartitionClasseActif';
  classeActif?: Maybe<Scalars['String']['output']>;
  codeConsultant: Scalars['String']['output'];
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  encours?: Maybe<Scalars['Decimal']['output']>;
  poidsClasseActif?: Maybe<Scalars['Decimal']['output']>;
  poidsSousClasseActif?: Maybe<Scalars['Decimal']['output']>;
  sousClasseActif: Scalars['String']['output'];
};

export type ConsultantRepartitionClasseActifFilterInput = {
  and?: InputMaybe<Array<ConsultantRepartitionClasseActifFilterInput>>;
  classeActif?: InputMaybe<StringOperationFilterInput>;
  codeConsultant?: InputMaybe<StringOperationFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  encours?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantRepartitionClasseActifFilterInput>>;
  poidsClasseActif?: InputMaybe<DecimalOperationFilterInput>;
  poidsSousClasseActif?: InputMaybe<DecimalOperationFilterInput>;
  sousClasseActif?: InputMaybe<StringOperationFilterInput>;
};

export type ConsultantRepartitionClasseActifSortInput = {
  classeActif?: InputMaybe<SortEnumType>;
  codeConsultant?: InputMaybe<SortEnumType>;
  dateChargement?: InputMaybe<SortEnumType>;
  encours?: InputMaybe<SortEnumType>;
  poidsClasseActif?: InputMaybe<SortEnumType>;
  poidsSousClasseActif?: InputMaybe<SortEnumType>;
  sousClasseActif?: InputMaybe<SortEnumType>;
};

export type ConsultantRepartitionEnveloppe = {
  __typename?: 'ConsultantRepartitionEnveloppe';
  codeConsultant: Scalars['String']['output'];
  codeEnveloppe: Scalars['String']['output'];
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  encours?: Maybe<Scalars['Decimal']['output']>;
  enveloppeAgregation?: Maybe<Enveloppe>;
  nbContrats?: Maybe<Scalars['Int']['output']>;
  poidsEnveloppeContrats?: Maybe<Scalars['Decimal']['output']>;
  poidsEnveloppeEncours?: Maybe<Scalars['Decimal']['output']>;
};

export type ConsultantRepartitionEnveloppeFilterInput = {
  and?: InputMaybe<Array<ConsultantRepartitionEnveloppeFilterInput>>;
  codeConsultant?: InputMaybe<StringOperationFilterInput>;
  codeEnveloppe?: InputMaybe<StringOperationFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  encours?: InputMaybe<DecimalOperationFilterInput>;
  enveloppeAgregation?: InputMaybe<EnveloppeFilterInput>;
  nbContrats?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantRepartitionEnveloppeFilterInput>>;
  poidsEnveloppeContrats?: InputMaybe<DecimalOperationFilterInput>;
  poidsEnveloppeEncours?: InputMaybe<DecimalOperationFilterInput>;
};

export type ConsultantRepartitionEnveloppeSortInput = {
  codeConsultant?: InputMaybe<SortEnumType>;
  codeEnveloppe?: InputMaybe<SortEnumType>;
  dateChargement?: InputMaybe<SortEnumType>;
  encours?: InputMaybe<SortEnumType>;
  enveloppeAgregation?: InputMaybe<EnveloppeSortInput>;
  nbContrats?: InputMaybe<SortEnumType>;
  poidsEnveloppeContrats?: InputMaybe<SortEnumType>;
  poidsEnveloppeEncours?: InputMaybe<SortEnumType>;
};

export type ConsultantRepartitionEsg = {
  __typename?: 'ConsultantRepartitionEsg';
  codeConsultant: Scalars['String']['output'];
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  encours?: Maybe<Scalars['Decimal']['output']>;
  esg: Scalars['String']['output'];
  poidsEsg?: Maybe<Scalars['Decimal']['output']>;
};

export type ConsultantRepartitionEsgFilterInput = {
  and?: InputMaybe<Array<ConsultantRepartitionEsgFilterInput>>;
  codeConsultant?: InputMaybe<StringOperationFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  encours?: InputMaybe<DecimalOperationFilterInput>;
  esg?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantRepartitionEsgFilterInput>>;
  poidsEsg?: InputMaybe<DecimalOperationFilterInput>;
};

export type ConsultantRepartitionEsgSortInput = {
  codeConsultant?: InputMaybe<SortEnumType>;
  dateChargement?: InputMaybe<SortEnumType>;
  encours?: InputMaybe<SortEnumType>;
  esg?: InputMaybe<SortEnumType>;
  poidsEsg?: InputMaybe<SortEnumType>;
};

export type ConsultantRepartitionPartenaire = {
  __typename?: 'ConsultantRepartitionPartenaire';
  codeConsultant: Scalars['String']['output'];
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  encours?: Maybe<Scalars['Decimal']['output']>;
  idPartenaire: Scalars['String']['output'];
  nbContrats?: Maybe<Scalars['Int']['output']>;
  partenaireAgregation?: Maybe<PartenaireAgregation>;
  poidsPartenaireContrats?: Maybe<Scalars['Decimal']['output']>;
  poidsPartenaireEncours?: Maybe<Scalars['Decimal']['output']>;
};

export type ConsultantRepartitionPartenaireFilterInput = {
  and?: InputMaybe<Array<ConsultantRepartitionPartenaireFilterInput>>;
  codeConsultant?: InputMaybe<StringOperationFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  encours?: InputMaybe<DecimalOperationFilterInput>;
  idPartenaire?: InputMaybe<StringOperationFilterInput>;
  nbContrats?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantRepartitionPartenaireFilterInput>>;
  partenaireAgregation?: InputMaybe<PartenaireAgregationFilterInput>;
  poidsPartenaireContrats?: InputMaybe<DecimalOperationFilterInput>;
  poidsPartenaireEncours?: InputMaybe<DecimalOperationFilterInput>;
};

export type ConsultantRepartitionPartenaireSortInput = {
  codeConsultant?: InputMaybe<SortEnumType>;
  dateChargement?: InputMaybe<SortEnumType>;
  encours?: InputMaybe<SortEnumType>;
  idPartenaire?: InputMaybe<SortEnumType>;
  nbContrats?: InputMaybe<SortEnumType>;
  partenaireAgregation?: InputMaybe<PartenaireAgregationSortInput>;
  poidsPartenaireContrats?: InputMaybe<SortEnumType>;
  poidsPartenaireEncours?: InputMaybe<SortEnumType>;
};

export type ConsultantRepartitionProduit = {
  __typename?: 'ConsultantRepartitionProduit';
  codeConsultant: Scalars['String']['output'];
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  encours?: Maybe<Scalars['Decimal']['output']>;
  idProduit: Scalars['String']['output'];
  nbContrats?: Maybe<Scalars['Int']['output']>;
  poidsProduitContrats?: Maybe<Scalars['Decimal']['output']>;
  poidsProduitEncours?: Maybe<Scalars['Decimal']['output']>;
  produit?: Maybe<ProduitAgregation>;
};

export type ConsultantRepartitionProduitFilterInput = {
  and?: InputMaybe<Array<ConsultantRepartitionProduitFilterInput>>;
  codeConsultant?: InputMaybe<StringOperationFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  encours?: InputMaybe<DecimalOperationFilterInput>;
  idProduit?: InputMaybe<StringOperationFilterInput>;
  nbContrats?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantRepartitionProduitFilterInput>>;
  poidsProduitContrats?: InputMaybe<DecimalOperationFilterInput>;
  poidsProduitEncours?: InputMaybe<DecimalOperationFilterInput>;
  produit?: InputMaybe<ProduitAgregationFilterInput>;
};

export type ConsultantRepartitionProduitSortInput = {
  codeConsultant?: InputMaybe<SortEnumType>;
  dateChargement?: InputMaybe<SortEnumType>;
  encours?: InputMaybe<SortEnumType>;
  idProduit?: InputMaybe<SortEnumType>;
  nbContrats?: InputMaybe<SortEnumType>;
  poidsProduitContrats?: InputMaybe<SortEnumType>;
  poidsProduitEncours?: InputMaybe<SortEnumType>;
  produit?: InputMaybe<ProduitAgregationSortInput>;
};

export type ConsultantRepartitionSocieteGestion = {
  __typename?: 'ConsultantRepartitionSocieteGestion';
  codeConsultant: Scalars['String']['output'];
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  encours?: Maybe<Scalars['Decimal']['output']>;
  poidsSocieteGestion?: Maybe<Scalars['Decimal']['output']>;
  societeGestion: Scalars['String']['output'];
};

export type ConsultantRepartitionSocieteGestionFilterInput = {
  and?: InputMaybe<Array<ConsultantRepartitionSocieteGestionFilterInput>>;
  codeConsultant?: InputMaybe<StringOperationFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  encours?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantRepartitionSocieteGestionFilterInput>>;
  poidsSocieteGestion?: InputMaybe<DecimalOperationFilterInput>;
  societeGestion?: InputMaybe<StringOperationFilterInput>;
};

export type ConsultantRepartitionSocieteGestionSortInput = {
  codeConsultant?: InputMaybe<SortEnumType>;
  dateChargement?: InputMaybe<SortEnumType>;
  encours?: InputMaybe<SortEnumType>;
  poidsSocieteGestion?: InputMaybe<SortEnumType>;
  societeGestion?: InputMaybe<SortEnumType>;
};

export type ConsultantRepartitionSri = {
  __typename?: 'ConsultantRepartitionSri';
  codeConsultant: Scalars['String']['output'];
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  encours?: Maybe<Scalars['Decimal']['output']>;
  poidsSri?: Maybe<Scalars['Decimal']['output']>;
  sri: Scalars['Int']['output'];
};

export type ConsultantRepartitionSriFilterInput = {
  and?: InputMaybe<Array<ConsultantRepartitionSriFilterInput>>;
  codeConsultant?: InputMaybe<StringOperationFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  encours?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantRepartitionSriFilterInput>>;
  poidsSri?: InputMaybe<DecimalOperationFilterInput>;
  sri?: InputMaybe<IntOperationFilterInput>;
};

export type ConsultantRepartitionSriSortInput = {
  codeConsultant?: InputMaybe<SortEnumType>;
  dateChargement?: InputMaybe<SortEnumType>;
  encours?: InputMaybe<SortEnumType>;
  poidsSri?: InputMaybe<SortEnumType>;
  sri?: InputMaybe<SortEnumType>;
};

export type ConsultantRepartitionSupport = {
  __typename?: 'ConsultantRepartitionSupport';
  codeConsultant: Scalars['String']['output'];
  codeIsin: Scalars['String']['output'];
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  dateCotation?: Maybe<Scalars['LocalDate']['output']>;
  encours?: Maybe<Scalars['Decimal']['output']>;
  nbContrats?: Maybe<Scalars['Int']['output']>;
  poidsSupport?: Maybe<Scalars['Decimal']['output']>;
  supportClasseActif?: Maybe<SupportsClassesActif>;
  valeurLiquidative?: Maybe<Scalars['Decimal']['output']>;
};

export type ConsultantRepartitionSupportFilterInput = {
  and?: InputMaybe<Array<ConsultantRepartitionSupportFilterInput>>;
  codeConsultant?: InputMaybe<StringOperationFilterInput>;
  codeIsin?: InputMaybe<StringOperationFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  dateCotation?: InputMaybe<LocalDateOperationFilterInput>;
  encours?: InputMaybe<DecimalOperationFilterInput>;
  nbContrats?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantRepartitionSupportFilterInput>>;
  poidsSupport?: InputMaybe<DecimalOperationFilterInput>;
  supportClasseActif?: InputMaybe<SupportsClassesActifFilterInput>;
  valeurLiquidative?: InputMaybe<DecimalOperationFilterInput>;
};

export type ConsultantRepartitionSupportSortInput = {
  codeConsultant?: InputMaybe<SortEnumType>;
  codeIsin?: InputMaybe<SortEnumType>;
  dateChargement?: InputMaybe<SortEnumType>;
  dateCotation?: InputMaybe<SortEnumType>;
  encours?: InputMaybe<SortEnumType>;
  nbContrats?: InputMaybe<SortEnumType>;
  poidsSupport?: InputMaybe<SortEnumType>;
  supportClasseActif?: InputMaybe<SupportsClassesActifSortInput>;
  valeurLiquidative?: InputMaybe<SortEnumType>;
};

export type ConsultantSortInput = {
  affiliationDate?: InputMaybe<SortEnumType>;
  arianeId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  codeTier?: InputMaybe<SortEnumType>;
  commentairePeriodeJunior?: InputMaybe<SortEnumType>;
  consultantCommissionAdi?: InputMaybe<ConsultantCommissionAdiSortInput>;
  consultantOrganisationConsultant?: InputMaybe<ConsultantOrganisationSortInput>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  date1AcquisitionDroit?: InputMaybe<SortEnumType>;
  date1Manager?: InputMaybe<SortEnumType>;
  date1VenteActee?: InputMaybe<SortEnumType>;
  date1VenteFinancement?: InputMaybe<SortEnumType>;
  date1VenteImmo?: InputMaybe<SortEnumType>;
  date1VentePlacement?: InputMaybe<SortEnumType>;
  dateAcquisitionDroit?: InputMaybe<SortEnumType>;
  dateAffiliationProdemial?: InputMaybe<SortEnumType>;
  dateContact?: InputMaybe<SortEnumType>;
  dateDemission?: InputMaybe<SortEnumType>;
  dateEntree?: InputMaybe<SortEnumType>;
  dateFinPeriodeJunior?: InputMaybe<SortEnumType>;
  dateFinValiditeAffiliation?: InputMaybe<SortEnumType>;
  dateSeminairePro?: InputMaybe<SortEnumType>;
  derniereDateExclusif?: InputMaybe<SortEnumType>;
  derniereDateNonExclusif?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  eligilibleRenouvellement?: InputMaybe<SortEnumType>;
  exclusif?: InputMaybe<SortEnumType>;
  galaxy?: InputMaybe<ConsultantSortInput>;
  galaxyId?: InputMaybe<SortEnumType>;
  gerePar?: InputMaybe<SortEnumType>;
  habilitationALPSI?: InputMaybe<SortEnumType>;
  habilitationAssurance?: InputMaybe<SortEnumType>;
  habilitationCIF?: InputMaybe<SortEnumType>;
  habilitationIOB?: InputMaybe<SortEnumType>;
  habilitationImmo?: InputMaybe<SortEnumType>;
  habilitationPMR?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  manager?: InputMaybe<ConsultantSortInput>;
  managerId?: InputMaybe<SortEnumType>;
  mandatAutofacFinancement?: InputMaybe<SortEnumType>;
  mandatAutofacPlacement?: InputMaybe<SortEnumType>;
  mandatAutofacTotal?: InputMaybe<SortEnumType>;
  motifResiliationCode?: InputMaybe<SortEnumType>;
  motifResiliationCodeNavigation?: InputMaybe<MotifResiliationConsultantSortInput>;
  nbAmbassadeurs?: InputMaybe<SortEnumType>;
  nbRecommandations?: InputMaybe<SortEnumType>;
  origineSaisie?: InputMaybe<SortEnumType>;
  origineSaisieNavigation?: InputMaybe<OrigineDataSortInput>;
  parrain?: InputMaybe<ConsultantSortInput>;
  parrainId?: InputMaybe<SortEnumType>;
  peutParainner?: InputMaybe<SortEnumType>;
  qualificationCode?: InputMaybe<SortEnumType>;
  qualificationCodeNavigation?: InputMaybe<QualificationConsultantSortInput>;
  raisonSociale?: InputMaybe<SortEnumType>;
  reponseRenouvellement?: InputMaybe<SortEnumType>;
  resiliationDate?: InputMaybe<SortEnumType>;
  souhaiteCollaborerAvecStelliumFi?: InputMaybe<SortEnumType>;
  statutCode?: InputMaybe<SortEnumType>;
  statutCodeNavigation?: InputMaybe<StatutConsultantSortInput>;
  tauxRemuneration?: InputMaybe<SortEnumType>;
  teteReseau?: InputMaybe<ConsultantSortInput>;
  teteReseauId?: InputMaybe<SortEnumType>;
  titreCode?: InputMaybe<SortEnumType>;
  titreCodeNavigation?: InputMaybe<TitreConsultantSortInput>;
  totalDebours?: InputMaybe<SortEnumType>;
};

export type ConsultantStatutCommercial = {
  __typename?: 'ConsultantStatutCommercial';
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  stacActif: Scalars['Int']['output'];
  stacDateDebut: Scalars['DateTime']['output'];
  stacDateFin?: Maybe<Scalars['DateTime']['output']>;
  stacMotifAcquisitionStatut: Scalars['String']['output'];
  statutCommercialCode: Scalars['String']['output'];
  statutCommercialCodeNavigation: StatutCommercial;
};

export type ConsultantStatutCommercialFilterInput = {
  and?: InputMaybe<Array<ConsultantStatutCommercialFilterInput>>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantStatutCommercialFilterInput>>;
  stacActif?: InputMaybe<IntOperationFilterInput>;
  stacDateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  stacDateFin?: InputMaybe<DateTimeOperationFilterInput>;
  stacMotifAcquisitionStatut?: InputMaybe<StringOperationFilterInput>;
  statutCommercialCode?: InputMaybe<StringOperationFilterInput>;
  statutCommercialCodeNavigation?: InputMaybe<StatutCommercialFilterInput>;
};

export type ConsultantStatutJuridique = {
  __typename?: 'ConsultantStatutJuridique';
  actif: Scalars['Boolean']['output'];
  adressePro: Adresse;
  adresseProId: Scalars['Long']['output'];
  assujettiTVACode?: Maybe<Scalars['String']['output']>;
  assujettiTVACodeNavigation?: Maybe<AssujettiTva>;
  cessionHistoCommande: Array<CessionHistoCommande>;
  changes: Array<ConsultantStatutJuridiqueChange>;
  codeTier?: Maybe<Scalars['String']['output']>;
  commissionDifferenceImmo: Scalars['Boolean']['output'];
  commissionDifferencePlacement: Scalars['Boolean']['output'];
  consultant: Consultant;
  consultantContrat: Array<ConsultantContrat>;
  consultantHabilitation: Array<ConsultantHabilitation>;
  consultantId: Scalars['Long']['output'];
  consultantRcp: Array<ConsultantRcp>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateAttest3558?: Maybe<Scalars['DateTime']['output']>;
  dateAttestHonneur?: Maybe<Scalars['DateTime']['output']>;
  dateAttestKbisPerso?: Maybe<Scalars['DateTime']['output']>;
  dateAttestUrssafSociete?: Maybe<Scalars['DateTime']['output']>;
  dateKBISOriginal?: Maybe<Scalars['DateTime']['output']>;
  dateUrssafPer?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatStatutCode: Scalars['String']['output'];
  etatStatutCodeNavigation: EtatStatut;
  facture: Array<Facture>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  lienConsultantStatutJuridiqueTypeHabilitation: Array<LienConsultantStatutJuridiqueTypeHabilitation>;
  nomCommercial?: Maybe<Scalars['String']['output']>;
  numeroTva?: Maybe<Scalars['String']['output']>;
  raisonSociale?: Maybe<Scalars['String']['output']>;
  siret?: Maybe<Scalars['String']['output']>;
  statutJuridiqueCode: Scalars['String']['output'];
  statutJuridiqueCodeNavigation: StatutJuridique;
  typeSocieteCode?: Maybe<Scalars['String']['output']>;
  typeSocieteCodeNavigation?: Maybe<TypeSociete>;
  villeSiret?: Maybe<Scalars['String']['output']>;
};


export type ConsultantStatutJuridiqueCessionHistoCommandeArgs = {
  where?: InputMaybe<CessionHistoCommandeFilterInput>;
};


export type ConsultantStatutJuridiqueChangesArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueChangeFilterInput>;
};


export type ConsultantStatutJuridiqueConsultantContratArgs = {
  where?: InputMaybe<ConsultantContratFilterInput>;
};


export type ConsultantStatutJuridiqueConsultantHabilitationArgs = {
  where?: InputMaybe<ConsultantHabilitationFilterInput>;
};


export type ConsultantStatutJuridiqueConsultantRcpArgs = {
  where?: InputMaybe<ConsultantRcpFilterInput>;
};


export type ConsultantStatutJuridiqueFactureArgs = {
  where?: InputMaybe<FactureFilterInput>;
};


export type ConsultantStatutJuridiqueLienConsultantStatutJuridiqueTypeHabilitationArgs = {
  where?: InputMaybe<LienConsultantStatutJuridiqueTypeHabilitationFilterInput>;
};

export type ConsultantStatutJuridiqueChange = {
  __typename?: 'ConsultantStatutJuridiqueChange';
  changeDate: Scalars['DateTime']['output'];
  changeReason: ConsultantStatutJuridiqueChangeReason;
  changeReasonCode: Scalars['String']['output'];
  consultantStatutJuridique: ConsultantStatutJuridique;
  consultantStatutJuridiqueId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
};

export type ConsultantStatutJuridiqueChangeFilterInput = {
  and?: InputMaybe<Array<ConsultantStatutJuridiqueChangeFilterInput>>;
  changeDate?: InputMaybe<DateTimeOperationFilterInput>;
  changeReason?: InputMaybe<ConsultantStatutJuridiqueChangeReasonFilterInput>;
  changeReasonCode?: InputMaybe<StringOperationFilterInput>;
  consultantStatutJuridique?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  consultantStatutJuridiqueId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantStatutJuridiqueChangeFilterInput>>;
};

export type ConsultantStatutJuridiqueChangeReason = {
  __typename?: 'ConsultantStatutJuridiqueChangeReason';
  code: Scalars['String']['output'];
  statutJuridiqueChanges: Array<ConsultantStatutJuridiqueChange>;
};


export type ConsultantStatutJuridiqueChangeReasonStatutJuridiqueChangesArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueChangeFilterInput>;
};

export type ConsultantStatutJuridiqueChangeReasonFilterInput = {
  and?: InputMaybe<Array<ConsultantStatutJuridiqueChangeReasonFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantStatutJuridiqueChangeReasonFilterInput>>;
  statutJuridiqueChanges?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueChangeFilterInput>;
};

export type ConsultantStatutJuridiqueFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  adressePro?: InputMaybe<AdresseFilterInput>;
  adresseProId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<ConsultantStatutJuridiqueFilterInput>>;
  assujettiTVACode?: InputMaybe<StringOperationFilterInput>;
  assujettiTVACodeNavigation?: InputMaybe<AssujettiTvaFilterInput>;
  cessionHistoCommande?: InputMaybe<ListFilterInputTypeOfCessionHistoCommandeFilterInput>;
  changes?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueChangeFilterInput>;
  codeTier?: InputMaybe<StringOperationFilterInput>;
  commissionDifferenceImmo?: InputMaybe<BooleanOperationFilterInput>;
  commissionDifferencePlacement?: InputMaybe<BooleanOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantContrat?: InputMaybe<ListFilterInputTypeOfConsultantContratFilterInput>;
  consultantHabilitation?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  consultantRcp?: InputMaybe<ListFilterInputTypeOfConsultantRcpFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttest3558?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttestHonneur?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttestKbisPerso?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttestUrssafSociete?: InputMaybe<DateTimeOperationFilterInput>;
  dateKBISOriginal?: InputMaybe<DateTimeOperationFilterInput>;
  dateUrssafPer?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatStatutCode?: InputMaybe<StringOperationFilterInput>;
  etatStatutCodeNavigation?: InputMaybe<EtatStatutFilterInput>;
  facture?: InputMaybe<ListFilterInputTypeOfFactureFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  lienConsultantStatutJuridiqueTypeHabilitation?: InputMaybe<ListFilterInputTypeOfLienConsultantStatutJuridiqueTypeHabilitationFilterInput>;
  nomCommercial?: InputMaybe<StringOperationFilterInput>;
  numeroTva?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantStatutJuridiqueFilterInput>>;
  raisonSociale?: InputMaybe<StringOperationFilterInput>;
  siret?: InputMaybe<StringOperationFilterInput>;
  statutJuridiqueCode?: InputMaybe<StringOperationFilterInput>;
  statutJuridiqueCodeNavigation?: InputMaybe<StatutJuridiqueFilterInput>;
  typeSocieteCode?: InputMaybe<StringOperationFilterInput>;
  typeSocieteCodeNavigation?: InputMaybe<TypeSocieteFilterInput>;
  villeSiret?: InputMaybe<StringOperationFilterInput>;
};

export enum ConsultantSupportsGraphEnum {
  ByClasseActif = 'BY_CLASSE_ACTIF',
  ByEsg = 'BY_ESG',
  BySocieteGestion = 'BY_SOCIETE_GESTION',
  BySousClasseActif = 'BY_SOUS_CLASSE_ACTIF',
  BySri = 'BY_SRI'
}

export enum ConsultantTransferStatus {
  ManagedByAriane = 'MANAGED_BY_ARIANE',
  ManagedByArianeWithPreImportDone = 'MANAGED_BY_ARIANE_WITH_PRE_IMPORT_DONE',
  ManagedByArianeWithPreImportDoneWithErrors = 'MANAGED_BY_ARIANE_WITH_PRE_IMPORT_DONE_WITH_ERRORS',
  ManagedByMinotaure = 'MANAGED_BY_MINOTAURE',
  ManagedByMinotaureWithInvestisseurTransferErrors = 'MANAGED_BY_MINOTAURE_WITH_INVESTISSEUR_TRANSFER_ERRORS',
  TransferFromArianeToMinotaureInProgress = 'TRANSFER_FROM_ARIANE_TO_MINOTAURE_IN_PROGRESS'
}

export type ConsultantTransferStatusOperationFilterInput = {
  eq?: InputMaybe<ConsultantTransferStatus>;
  in?: InputMaybe<Array<ConsultantTransferStatus>>;
  neq?: InputMaybe<ConsultantTransferStatus>;
  nin?: InputMaybe<Array<ConsultantTransferStatus>>;
};

export type ConsultantVisionGlobale = {
  __typename?: 'ConsultantVisionGlobale';
  codeConsultant: Scalars['String']['output'];
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  encoursMoyenClient?: Maybe<Scalars['Decimal']['output']>;
  encoursMoyenContrat?: Maybe<Scalars['Decimal']['output']>;
  encoursMoyenSocieteGestion?: Maybe<Scalars['Decimal']['output']>;
  encoursMoyenSupport?: Maybe<Scalars['Decimal']['output']>;
  encoursTotal?: Maybe<Scalars['Decimal']['output']>;
  nbClients?: Maybe<Scalars['Int']['output']>;
  nbContrats?: Maybe<Scalars['Int']['output']>;
  nbSocietesGestions?: Maybe<Scalars['Int']['output']>;
  nbSupports?: Maybe<Scalars['Int']['output']>;
};

/** A segment of a collection. */
export type ConsultantsAgregationCollectionSegment = {
  __typename?: 'ConsultantsAgregationCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ConsultantAgregation>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
};

/** A segment of a collection. */
export type ConsultantsByNamePaginatedCollectionSegment = {
  __typename?: 'ConsultantsByNamePaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Consultant>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ConsultantsPaginatedCollectionSegment = {
  __typename?: 'ConsultantsPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Consultant>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  adresse: Array<Adresse>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  email: Array<Email>;
  estBenefEffectif: Scalars['Boolean']['output'];
  estInterlocuteurPrincipal: Scalars['Boolean']['output'];
  fonction?: Maybe<FonctionContact>;
  fonctionId?: Maybe<Scalars['Byte']['output']>;
  id: Scalars['Long']['output'];
  idSourceARInvestisseurEntreprise?: Maybe<Scalars['Long']['output']>;
  idSourceContact?: Maybe<Scalars['Long']['output']>;
  idSourceOfInvPP?: Maybe<Scalars['Long']['output']>;
  partenaire?: Maybe<Partenaire>;
  partenaireId?: Maybe<Scalars['Long']['output']>;
  personneMorale?: Maybe<PersonneMorale>;
  personneMoraleId?: Maybe<Scalars['Long']['output']>;
  personnePhysique?: Maybe<PersonnePhysique>;
  personnePhysiqueId?: Maybe<Scalars['Long']['output']>;
  telephone: Array<Telephone>;
};


export type ContactAdresseArgs = {
  where?: InputMaybe<AdresseFilterInput>;
};


export type ContactEmailArgs = {
  where?: InputMaybe<EmailFilterInput>;
};


export type ContactTelephoneArgs = {
  where?: InputMaybe<TelephoneFilterInput>;
};

export type ContactCreationInput = {
  investisseur1: ContactInput;
  investisseur2?: InputMaybe<ContactInput>;
  investisseur2Id?: InputMaybe<Scalars['Long']['input']>;
  typeRelationCode?: InputMaybe<Scalars['String']['input']>;
};

export type ContactFilterInput = {
  adresse?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  and?: InputMaybe<Array<ContactFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<ListFilterInputTypeOfEmailFilterInput>;
  estBenefEffectif?: InputMaybe<BooleanOperationFilterInput>;
  estInterlocuteurPrincipal?: InputMaybe<BooleanOperationFilterInput>;
  fonction?: InputMaybe<FonctionContactFilterInput>;
  fonctionId?: InputMaybe<ByteOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSourceARInvestisseurEntreprise?: InputMaybe<LongOperationFilterInput>;
  idSourceContact?: InputMaybe<LongOperationFilterInput>;
  idSourceOfInvPP?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ContactFilterInput>>;
  partenaire?: InputMaybe<PartenaireFilterInput>;
  partenaireId?: InputMaybe<LongOperationFilterInput>;
  personneMorale?: InputMaybe<PersonneMoraleFilterInput>;
  personneMoraleId?: InputMaybe<LongOperationFilterInput>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  telephone?: InputMaybe<ListFilterInputTypeOfTelephoneFilterInput>;
};

export type ContactInput = {
  civilite?: InputMaybe<Scalars['String']['input']>;
  consultantApporteurAffaireId?: InputMaybe<Scalars['Long']['input']>;
  consultantPrincipalId?: InputMaybe<Scalars['Long']['input']>;
  dateNaissance: Scalars['DateTime']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  nom: Scalars['String']['input'];
  prenom: Scalars['String']['input'];
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type Contrat = {
  __typename?: 'Contrat';
  clauseBeneficiaire?: Maybe<Scalars['String']['output']>;
  codeEtatContrat?: Maybe<Scalars['String']['output']>;
  codeModeGestion?: Maybe<Scalars['String']['output']>;
  contratsInvestisseurs?: Maybe<Array<ContratsInvestisseur>>;
  contratsSupports?: Maybe<Array<ContratsSupport>>;
  cumulRachats?: Maybe<Scalars['Decimal']['output']>;
  cumulVersementsBruts?: Maybe<Scalars['Decimal']['output']>;
  cumulVersementsLibresBruts?: Maybe<Scalars['Decimal']['output']>;
  cumulVersementsLibresNets?: Maybe<Scalars['Decimal']['output']>;
  cumulVersementsNets?: Maybe<Scalars['Decimal']['output']>;
  cumulVpBruts?: Maybe<Scalars['Decimal']['output']>;
  cumulVpNets?: Maybe<Scalars['Decimal']['output']>;
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  dateDebutContrat?: Maybe<Scalars['LocalDate']['output']>;
  dateDernierVp?: Maybe<Scalars['LocalDate']['output']>;
  dateFinContrat?: Maybe<Scalars['LocalDate']['output']>;
  dateValorisation?: Maybe<Scalars['LocalDate']['output']>;
  epargneSecurisee?: Maybe<Scalars['Decimal']['output']>;
  flagEpargneHandicap?: Maybe<Scalars['Boolean']['output']>;
  flagNantissement?: Maybe<Scalars['Boolean']['output']>;
  flagRpp?: Maybe<Scalars['Boolean']['output']>;
  flagVp?: Maybe<Scalars['Boolean']['output']>;
  idContrat: Scalars['String']['output'];
  idPartenaire: Scalars['String']['output'];
  modeGestion?: Maybe<ModeGestion>;
  numeroContrat?: Maybe<Scalars['String']['output']>;
  perfPlusMoinsValueFinanciereBrute?: Maybe<Scalars['Decimal']['output']>;
  perfPlusMoinsValueFinanciereNette?: Maybe<Scalars['Decimal']['output']>;
  periodiciteVp?: Maybe<PeriodiciteVp>;
  produit?: Maybe<ProduitAgregation>;
  refIdProduit?: Maybe<Scalars['String']['output']>;
  rppDatedebut?: Maybe<Scalars['LocalDate']['output']>;
  rppMontantUnitaire?: Maybe<Scalars['Decimal']['output']>;
  rppPeriodicite?: Maybe<Scalars['String']['output']>;
  valorisation?: Maybe<Scalars['Decimal']['output']>;
  versementInitialBrut?: Maybe<Scalars['Decimal']['output']>;
  versementInitialNet?: Maybe<Scalars['Decimal']['output']>;
  vpDateDebut?: Maybe<Scalars['LocalDate']['output']>;
  vpDuree?: Maybe<Scalars['Int']['output']>;
  vpMontantUnitaire?: Maybe<Scalars['Decimal']['output']>;
  vpPeriodicite?: Maybe<Scalars['String']['output']>;
};

export type ContratBackOfficeFilterInput = {
  codeConsultant?: InputMaybe<Scalars['String']['input']>;
  enveloppes?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterNomPrenomInvestisseur?: InputMaybe<Scalars['String']['input']>;
  filterNumeroContrat?: InputMaybe<Scalars['String']['input']>;
  filterProduit?: InputMaybe<Scalars['String']['input']>;
  managersGalaxie?: InputMaybe<Array<Scalars['String']['input']>>;
  partenaires?: InputMaybe<Array<Scalars['String']['input']>>;
  performanceMax?: InputMaybe<Scalars['Decimal']['input']>;
  performanceMin?: InputMaybe<Scalars['Decimal']['input']>;
  performancePourcentageMax?: InputMaybe<Scalars['Decimal']['input']>;
  performancePourcentageMin?: InputMaybe<Scalars['Decimal']['input']>;
  supports?: InputMaybe<Array<Scalars['String']['input']>>;
  valorisationMax?: InputMaybe<Scalars['Decimal']['input']>;
  valorisationMin?: InputMaybe<Scalars['Decimal']['input']>;
  vp?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export enum ContratBackOfficeOrderField {
  DateEffet = 'DATE_EFFET',
  MontantInvesti = 'MONTANT_INVESTI',
  NomConsultant = 'NOM_CONSULTANT',
  NomInvestisseur = 'NOM_INVESTISSEUR',
  NomManagerGalaxie = 'NOM_MANAGER_GALAXIE',
  NumeroContrat = 'NUMERO_CONTRAT',
  Performance = 'PERFORMANCE',
  PerformancePercent = 'PERFORMANCE_PERCENT',
  Valorisation = 'VALORISATION',
  Vp = 'VP'
}

export type ContratBackOfficeOrderInput = {
  descending: Scalars['Boolean']['input'];
  field?: InputMaybe<ContratBackOfficeOrderField>;
};

export type ContratConsultantFilterInput = {
  enveloppes?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterNomPrenomInvestisseur?: InputMaybe<Scalars['String']['input']>;
  filterNumeroContrat?: InputMaybe<Scalars['String']['input']>;
  filterProduit?: InputMaybe<Scalars['String']['input']>;
  partenaires?: InputMaybe<Array<Scalars['String']['input']>>;
  performanceMax?: InputMaybe<Scalars['Decimal']['input']>;
  performanceMin?: InputMaybe<Scalars['Decimal']['input']>;
  performancePourcentageMax?: InputMaybe<Scalars['Decimal']['input']>;
  performancePourcentageMin?: InputMaybe<Scalars['Decimal']['input']>;
  supports?: InputMaybe<Array<Scalars['String']['input']>>;
  valorisationMax?: InputMaybe<Scalars['Decimal']['input']>;
  valorisationMin?: InputMaybe<Scalars['Decimal']['input']>;
  vp?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type ContratConsultantOrderInput = {
  descending: Scalars['Boolean']['input'];
  field?: InputMaybe<ContratOrderField>;
};

export enum ContratDetailGraphEnum {
  ByClasseActif = 'BY_CLASSE_ACTIF',
  BySocieteGestion = 'BY_SOCIETE_GESTION',
  BySousClasseActif = 'BY_SOUS_CLASSE_ACTIF',
  BySupport = 'BY_SUPPORT'
}

export type ContratFilterInput = {
  and?: InputMaybe<Array<ContratFilterInput>>;
  clauseBeneficiaire?: InputMaybe<StringOperationFilterInput>;
  codeEtatContrat?: InputMaybe<StringOperationFilterInput>;
  codeModeGestion?: InputMaybe<StringOperationFilterInput>;
  contratsInvestisseurs?: InputMaybe<ListFilterInputTypeOfContratsInvestisseurFilterInput>;
  contratsSupports?: InputMaybe<ListFilterInputTypeOfContratsSupportFilterInput>;
  cumulRachats?: InputMaybe<DecimalOperationFilterInput>;
  cumulVersementsBruts?: InputMaybe<DecimalOperationFilterInput>;
  cumulVersementsLibresBruts?: InputMaybe<DecimalOperationFilterInput>;
  cumulVersementsLibresNets?: InputMaybe<DecimalOperationFilterInput>;
  cumulVersementsNets?: InputMaybe<DecimalOperationFilterInput>;
  cumulVpBruts?: InputMaybe<DecimalOperationFilterInput>;
  cumulVpNets?: InputMaybe<DecimalOperationFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  dateDebutContrat?: InputMaybe<LocalDateOperationFilterInput>;
  dateDernierVp?: InputMaybe<LocalDateOperationFilterInput>;
  dateFinContrat?: InputMaybe<LocalDateOperationFilterInput>;
  dateValorisation?: InputMaybe<LocalDateOperationFilterInput>;
  epargneSecurisee?: InputMaybe<DecimalOperationFilterInput>;
  flagEpargneHandicap?: InputMaybe<BooleanOperationFilterInput>;
  flagNantissement?: InputMaybe<BooleanOperationFilterInput>;
  flagRpp?: InputMaybe<BooleanOperationFilterInput>;
  flagVp?: InputMaybe<BooleanOperationFilterInput>;
  idContrat?: InputMaybe<StringOperationFilterInput>;
  idPartenaire?: InputMaybe<StringOperationFilterInput>;
  modeGestion?: InputMaybe<ModeGestionFilterInput>;
  numeroContrat?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContratFilterInput>>;
  perfPlusMoinsValueFinanciereBrute?: InputMaybe<DecimalOperationFilterInput>;
  perfPlusMoinsValueFinanciereNette?: InputMaybe<DecimalOperationFilterInput>;
  periodiciteVp?: InputMaybe<PeriodiciteVpFilterInput>;
  produit?: InputMaybe<ProduitAgregationFilterInput>;
  refIdProduit?: InputMaybe<StringOperationFilterInput>;
  rppDatedebut?: InputMaybe<LocalDateOperationFilterInput>;
  rppMontantUnitaire?: InputMaybe<DecimalOperationFilterInput>;
  rppPeriodicite?: InputMaybe<StringOperationFilterInput>;
  valorisation?: InputMaybe<DecimalOperationFilterInput>;
  versementInitialBrut?: InputMaybe<DecimalOperationFilterInput>;
  versementInitialNet?: InputMaybe<DecimalOperationFilterInput>;
  vpDateDebut?: InputMaybe<LocalDateOperationFilterInput>;
  vpDuree?: InputMaybe<IntOperationFilterInput>;
  vpMontantUnitaire?: InputMaybe<DecimalOperationFilterInput>;
  vpPeriodicite?: InputMaybe<StringOperationFilterInput>;
};

export enum ContratOrderField {
  DateEffet = 'DATE_EFFET',
  MontantInvesti = 'MONTANT_INVESTI',
  NomInvestisseur = 'NOM_INVESTISSEUR',
  NumeroContrat = 'NUMERO_CONTRAT',
  Performance = 'PERFORMANCE',
  PerformancePercent = 'PERFORMANCE_PERCENT',
  Valorisation = 'VALORISATION',
  Vp = 'VP'
}

export type ContratSortInput = {
  clauseBeneficiaire?: InputMaybe<SortEnumType>;
  codeEtatContrat?: InputMaybe<SortEnumType>;
  codeModeGestion?: InputMaybe<SortEnumType>;
  cumulRachats?: InputMaybe<SortEnumType>;
  cumulVersementsBruts?: InputMaybe<SortEnumType>;
  cumulVersementsLibresBruts?: InputMaybe<SortEnumType>;
  cumulVersementsLibresNets?: InputMaybe<SortEnumType>;
  cumulVersementsNets?: InputMaybe<SortEnumType>;
  cumulVpBruts?: InputMaybe<SortEnumType>;
  cumulVpNets?: InputMaybe<SortEnumType>;
  dateChargement?: InputMaybe<SortEnumType>;
  dateDebutContrat?: InputMaybe<SortEnumType>;
  dateDernierVp?: InputMaybe<SortEnumType>;
  dateFinContrat?: InputMaybe<SortEnumType>;
  dateValorisation?: InputMaybe<SortEnumType>;
  epargneSecurisee?: InputMaybe<SortEnumType>;
  flagEpargneHandicap?: InputMaybe<SortEnumType>;
  flagNantissement?: InputMaybe<SortEnumType>;
  flagRpp?: InputMaybe<SortEnumType>;
  flagVp?: InputMaybe<SortEnumType>;
  idContrat?: InputMaybe<SortEnumType>;
  idPartenaire?: InputMaybe<SortEnumType>;
  modeGestion?: InputMaybe<ModeGestionSortInput>;
  numeroContrat?: InputMaybe<SortEnumType>;
  perfPlusMoinsValueFinanciereBrute?: InputMaybe<SortEnumType>;
  perfPlusMoinsValueFinanciereNette?: InputMaybe<SortEnumType>;
  periodiciteVp?: InputMaybe<PeriodiciteVpSortInput>;
  produit?: InputMaybe<ProduitAgregationSortInput>;
  refIdProduit?: InputMaybe<SortEnumType>;
  rppDatedebut?: InputMaybe<SortEnumType>;
  rppMontantUnitaire?: InputMaybe<SortEnumType>;
  rppPeriodicite?: InputMaybe<SortEnumType>;
  valorisation?: InputMaybe<SortEnumType>;
  versementInitialBrut?: InputMaybe<SortEnumType>;
  versementInitialNet?: InputMaybe<SortEnumType>;
  vpDateDebut?: InputMaybe<SortEnumType>;
  vpDuree?: InputMaybe<SortEnumType>;
  vpMontantUnitaire?: InputMaybe<SortEnumType>;
  vpPeriodicite?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ContratsBackOfficeCollectionSegment = {
  __typename?: 'ContratsBackOfficeCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Contrat>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ContratsConsultantCollectionSegment = {
  __typename?: 'ContratsConsultantCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Contrat>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContratsInvestisseur = {
  __typename?: 'ContratsInvestisseur';
  /** Récupère les autres investisseurs liés au même contrat et partenaire */
  autresInvestisseurs: Array<ContratsInvestisseur>;
  codeConsultant?: Maybe<Scalars['String']['output']>;
  codeInvestisseur?: Maybe<Scalars['String']['output']>;
  consultant?: Maybe<ConsultantAgregation>;
  contrat?: Maybe<Contrat>;
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  idContrat: Scalars['String']['output'];
  idPartenaire: Scalars['String']['output'];
  idPersonnePartenaire?: Maybe<Scalars['String']['output']>;
  investisseur?: Maybe<InvestisseurAgregation>;
  ordreInvestisseur: Scalars['Int']['output'];
};

export type ContratsInvestisseurFilterInput = {
  and?: InputMaybe<Array<ContratsInvestisseurFilterInput>>;
  codeConsultant?: InputMaybe<StringOperationFilterInput>;
  codeInvestisseur?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ConsultantAgregationFilterInput>;
  contrat?: InputMaybe<ContratFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  idContrat?: InputMaybe<StringOperationFilterInput>;
  idPartenaire?: InputMaybe<StringOperationFilterInput>;
  idPersonnePartenaire?: InputMaybe<StringOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurAgregationFilterInput>;
  or?: InputMaybe<Array<ContratsInvestisseurFilterInput>>;
  ordreInvestisseur?: InputMaybe<IntOperationFilterInput>;
};

export type ContratsInvestisseurSortInput = {
  codeConsultant?: InputMaybe<SortEnumType>;
  codeInvestisseur?: InputMaybe<SortEnumType>;
  consultant?: InputMaybe<ConsultantAgregationSortInput>;
  contrat?: InputMaybe<ContratSortInput>;
  dateChargement?: InputMaybe<SortEnumType>;
  idContrat?: InputMaybe<SortEnumType>;
  idPartenaire?: InputMaybe<SortEnumType>;
  idPersonnePartenaire?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurAgregationSortInput>;
  ordreInvestisseur?: InputMaybe<SortEnumType>;
};

export type ContratsSupport = {
  __typename?: 'ContratsSupport';
  contrat?: Maybe<Contrat>;
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  dateCotation?: Maybe<Scalars['LocalDate']['output']>;
  dateValorisation?: Maybe<Scalars['LocalDate']['output']>;
  idPartenaire: Scalars['String']['output'];
  idSupportComposant: Scalars['String']['output'];
  indicateurPma?: Maybe<Scalars['Decimal']['output']>;
  nombreParts?: Maybe<Scalars['Decimal']['output']>;
  perfPlusMoinsValueFinanciere?: Maybe<Scalars['Decimal']['output']>;
  poidsSupportDansContrat?: Maybe<Scalars['Decimal']['output']>;
  refIdContrat?: Maybe<Scalars['String']['output']>;
  refIdSupportInfoGen?: Maybe<Scalars['String']['output']>;
  supportGen?: Maybe<SupportsGen>;
  valeurLiquidative?: Maybe<Scalars['Decimal']['output']>;
  valorisation?: Maybe<Scalars['Decimal']['output']>;
};

export type ContratsSupportFilterInput = {
  and?: InputMaybe<Array<ContratsSupportFilterInput>>;
  contrat?: InputMaybe<ContratFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  dateCotation?: InputMaybe<LocalDateOperationFilterInput>;
  dateValorisation?: InputMaybe<LocalDateOperationFilterInput>;
  idPartenaire?: InputMaybe<StringOperationFilterInput>;
  idSupportComposant?: InputMaybe<StringOperationFilterInput>;
  indicateurPma?: InputMaybe<DecimalOperationFilterInput>;
  nombreParts?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ContratsSupportFilterInput>>;
  perfPlusMoinsValueFinanciere?: InputMaybe<DecimalOperationFilterInput>;
  poidsSupportDansContrat?: InputMaybe<DecimalOperationFilterInput>;
  refIdContrat?: InputMaybe<StringOperationFilterInput>;
  refIdSupportInfoGen?: InputMaybe<StringOperationFilterInput>;
  supportGen?: InputMaybe<SupportsGenFilterInput>;
  valeurLiquidative?: InputMaybe<DecimalOperationFilterInput>;
  valorisation?: InputMaybe<DecimalOperationFilterInput>;
};

export type CreateOperationBoxPlacementResult = {
  __typename?: 'CreateOperationBoxPlacementResult';
  operationGroupId: Scalars['Int']['output'];
  operationId: Scalars['Int']['output'];
  resumePath: Scalars['String']['output'];
  resumeUrl: Scalars['String']['output'];
  statutId: Scalars['Int']['output'];
};

export type CreateOperationFromProxeemaInput = {
  coInvestisseurId?: InputMaybe<Scalars['Long']['input']>;
  contratId?: InputMaybe<Scalars['Long']['input']>;
  enveloppeId?: InputMaybe<Scalars['Int']['input']>;
  investisseurId: Scalars['Long']['input'];
  operationConfigId?: InputMaybe<Scalars['Int']['input']>;
  operationType: OperationType;
  produitId?: InputMaybe<Scalars['Long']['input']>;
  proxeemaOperationId: Scalars['String']['input'];
  proxeemaOperationUrl: Scalars['String']['input'];
};

export type CreateRechercheInput = {
  filtres: Array<FiltreSettingInput>;
  label: Scalars['String']['input'];
};

export type CreateStorageFileInput = {
  denomination?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};

export type Cursus = {
  __typename?: 'Cursus';
  codeFamille?: Maybe<Scalars['Byte']['output']>;
  codeFamilleNavigation?: Maybe<FormationType>;
  codeSaison?: Maybe<Scalars['Byte']['output']>;
  codeSaisonNavigation?: Maybe<FormationSaison>;
  creationDate: Scalars['DateTime']['output'];
  cursusCycleCourt: Array<CursusCycleCourt>;
  cursusFormation: Array<CursusFormation>;
  dateDebutValidite?: Maybe<Scalars['DateTime']['output']>;
  dateFinValidite?: Maybe<Scalars['DateTime']['output']>;
  dureeHeure?: Maybe<Scalars['Decimal']['output']>;
  dureeJour?: Maybe<Scalars['Decimal']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  nom: Scalars['String']['output'];
  obligatoire?: Maybe<Scalars['Byte']['output']>;
  reference: Scalars['String']['output'];
};


export type CursusCursusCycleCourtArgs = {
  where?: InputMaybe<CursusCycleCourtFilterInput>;
};


export type CursusCursusFormationArgs = {
  where?: InputMaybe<CursusFormationFilterInput>;
};

export type CursusCycleCourt = {
  __typename?: 'CursusCycleCourt';
  creationDate: Scalars['DateTime']['output'];
  cursus: Cursus;
  cursusId: Scalars['Long']['output'];
  cycleCourt: CycleCourt;
  cycleCourtId: Scalars['Long']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
};

export type CursusCycleCourtFilterInput = {
  and?: InputMaybe<Array<CursusCycleCourtFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursus?: InputMaybe<CursusFilterInput>;
  cursusId?: InputMaybe<LongOperationFilterInput>;
  cycleCourt?: InputMaybe<CycleCourtFilterInput>;
  cycleCourtId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<CursusCycleCourtFilterInput>>;
};

export type CursusFilterInput = {
  and?: InputMaybe<Array<CursusFilterInput>>;
  codeFamille?: InputMaybe<ByteOperationFilterInput>;
  codeFamilleNavigation?: InputMaybe<FormationTypeFilterInput>;
  codeSaison?: InputMaybe<ByteOperationFilterInput>;
  codeSaisonNavigation?: InputMaybe<FormationSaisonFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursusCycleCourt?: InputMaybe<ListFilterInputTypeOfCursusCycleCourtFilterInput>;
  cursusFormation?: InputMaybe<ListFilterInputTypeOfCursusFormationFilterInput>;
  dateDebutValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dureeHeure?: InputMaybe<DecimalOperationFilterInput>;
  dureeJour?: InputMaybe<DecimalOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  obligatoire?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<CursusFilterInput>>;
  reference?: InputMaybe<StringOperationFilterInput>;
};

export type CursusFormation = {
  __typename?: 'CursusFormation';
  creationDate: Scalars['DateTime']['output'];
  cursus: Cursus;
  cursusId: Scalars['Long']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  formation: ActionDeFormation;
  formationId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
};

export type CursusFormationFilterInput = {
  and?: InputMaybe<Array<CursusFormationFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursus?: InputMaybe<CursusFilterInput>;
  cursusId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  formation?: InputMaybe<ActionDeFormationFilterInput>;
  formationId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<CursusFormationFilterInput>>;
};

export type CycleCourt = {
  __typename?: 'CycleCourt';
  codeEtat?: Maybe<Scalars['Byte']['output']>;
  codeEtatNavigation?: Maybe<SessionEtat>;
  codeGenre?: Maybe<Scalars['Byte']['output']>;
  codeGenreNavigation?: Maybe<SessionGenre>;
  creationDate: Scalars['DateTime']['output'];
  cursusCycleCourt: Array<CursusCycleCourt>;
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  dureeHeure?: Maybe<Scalars['Decimal']['output']>;
  dureeJour?: Maybe<Scalars['Decimal']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  inscriptionCycleCourt: Array<InscriptionCycleCourt>;
  nom: Scalars['String']['output'];
};


export type CycleCourtCursusCycleCourtArgs = {
  where?: InputMaybe<CursusCycleCourtFilterInput>;
};


export type CycleCourtInscriptionCycleCourtArgs = {
  where?: InputMaybe<InscriptionCycleCourtFilterInput>;
};

export type CycleCourtFilterInput = {
  and?: InputMaybe<Array<CycleCourtFilterInput>>;
  codeEtat?: InputMaybe<ByteOperationFilterInput>;
  codeEtatNavigation?: InputMaybe<SessionEtatFilterInput>;
  codeGenre?: InputMaybe<ByteOperationFilterInput>;
  codeGenreNavigation?: InputMaybe<SessionGenreFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursusCycleCourt?: InputMaybe<ListFilterInputTypeOfCursusCycleCourtFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  dureeHeure?: InputMaybe<DecimalOperationFilterInput>;
  dureeJour?: InputMaybe<DecimalOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  inscriptionCycleCourt?: InputMaybe<ListFilterInputTypeOfInscriptionCycleCourtFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CycleCourtFilterInput>>;
};

export type DerResponse = {
  __typename?: 'DERResponse';
  fieldsToComplete?: Maybe<Array<FieldToComplete>>;
  isGestionPrivee: Scalars['Boolean']['output'];
  storageFiles?: Maybe<Array<StorageFile>>;
};


export type DerResponseFieldsToCompleteArgs = {
  where?: InputMaybe<FieldToCompleteFilterInput>;
};

export enum DerStateTransitionTrigger {
  ConsultantAddsOrReplaceBySignedDer = 'CONSULTANT_ADDS_OR_REPLACE_BY_SIGNED_DER',
  ConsultantDataCompleted = 'CONSULTANT_DATA_COMPLETED',
  ConsultantDataNotComplete = 'CONSULTANT_DATA_NOT_COMPLETE',
  ConsultantStartsOrRestartDerSignatureProcess = 'CONSULTANT_STARTS_OR_RESTART_DER_SIGNATURE_PROCESS',
  DerHasBeenSigned = 'DER_HAS_BEEN_SIGNED',
  DerSignatureIsCancelled = 'DER_SIGNATURE_IS_CANCELLED'
}

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A connection to a list of items. */
export type DeactivatedConfigsConnection = {
  __typename?: 'DeactivatedConfigsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeactivatedConfigsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeactivatedOperationConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeactivatedConfigsEdge = {
  __typename?: 'DeactivatedConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeactivatedOperationConfig;
};

export type DeactivatedOperationConfig = {
  __typename?: 'DeactivatedOperationConfig';
  operationConfigId: Scalars['UUID']['output'];
  version: Scalars['Int']['output'];
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DeleteRelationCoupleInput = {
  conjointId: Scalars['Long']['input'];
  conjointPersonnePhysiqueId: Scalars['Long']['input'];
  investisseurId: Scalars['Long']['input'];
  investisseurPersonnePhysiqueId: Scalars['Long']['input'];
};

export type DeleteRelationInput = {
  personnePhysiqueId: Scalars['Long']['input'];
  relationPersonnePhysiqueIds: Array<Scalars['Long']['input']>;
  typeRelation?: InputMaybe<Scalars['String']['input']>;
};

export type Departement = {
  __typename?: 'Departement';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  nom?: Maybe<Scalars['String']['output']>;
  organisme: Array<Organisme>;
  personnePhysique: Array<PersonnePhysique>;
};


export type DepartementOrganismeArgs = {
  where?: InputMaybe<OrganismeFilterInput>;
};


export type DepartementPersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type DepartementFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<DepartementFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DepartementFilterInput>>;
  organisme?: InputMaybe<ListFilterInputTypeOfOrganismeFilterInput>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
};

export type DepartementSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
};

export enum DerStatus {
  NotRequested = 'NOT_REQUESTED',
  NotRequired = 'NOT_REQUIRED',
  Pending = 'PENDING',
  Validated = 'VALIDATED'
}

export type DerStatusOperationFilterInput = {
  eq?: InputMaybe<DerStatus>;
  in?: InputMaybe<Array<DerStatus>>;
  neq?: InputMaybe<DerStatus>;
  nin?: InputMaybe<Array<DerStatus>>;
};

export type DetenteurPatrimoineActif = {
  __typename?: 'DetenteurPatrimoineActif';
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  detentionNuPropriete?: Maybe<Scalars['Decimal']['output']>;
  detentionPleinePropriete?: Maybe<Scalars['Decimal']['output']>;
  detentionUsufruit?: Maybe<Scalars['Decimal']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseur?: Maybe<Investisseur>;
  investisseurId?: Maybe<Scalars['Long']['output']>;
  patrimoineActif?: Maybe<PatrimoineActif>;
  patrimoineActifId?: Maybe<Scalars['Long']['output']>;
  personnePhysique?: Maybe<PersonnePhysique>;
  personnePhysiqueId?: Maybe<Scalars['Long']['output']>;
};

export type DetenteurPatrimoineActifFilterInput = {
  and?: InputMaybe<Array<DetenteurPatrimoineActifFilterInput>>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  detentionNuPropriete?: InputMaybe<DecimalOperationFilterInput>;
  detentionPleinePropriete?: InputMaybe<DecimalOperationFilterInput>;
  detentionUsufruit?: InputMaybe<DecimalOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<DetenteurPatrimoineActifFilterInput>>;
  patrimoineActif?: InputMaybe<PatrimoineActifFilterInput>;
  patrimoineActifId?: InputMaybe<LongOperationFilterInput>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
};

export type DetenteurPatrimoineChargeRevenu = {
  __typename?: 'DetenteurPatrimoineChargeRevenu';
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  patrimoineChargeRevenu: PatrimoineChargeRevenu;
  patrimoineChargeRevenuId: Scalars['Long']['output'];
  tauxDetention?: Maybe<Scalars['Decimal']['output']>;
};

export type DetenteurPatrimoineChargeRevenuFilterInput = {
  and?: InputMaybe<Array<DetenteurPatrimoineChargeRevenuFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<DetenteurPatrimoineChargeRevenuFilterInput>>;
  patrimoineChargeRevenu?: InputMaybe<PatrimoineChargeRevenuFilterInput>;
  patrimoineChargeRevenuId?: InputMaybe<LongOperationFilterInput>;
  tauxDetention?: InputMaybe<DecimalOperationFilterInput>;
};

export type DetenteurPatrimoinePassif = {
  __typename?: 'DetenteurPatrimoinePassif';
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  patrimoinePassif: PatrimoinePassif;
  patrimoinePassifId: Scalars['Long']['output'];
  quotePartAdi?: Maybe<Scalars['Decimal']['output']>;
  tauxDetention: Scalars['Decimal']['output'];
};

export type DetenteurPatrimoinePassifFilterInput = {
  and?: InputMaybe<Array<DetenteurPatrimoinePassifFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<DetenteurPatrimoinePassifFilterInput>>;
  patrimoinePassif?: InputMaybe<PatrimoinePassifFilterInput>;
  patrimoinePassifId?: InputMaybe<LongOperationFilterInput>;
  quotePartAdi?: InputMaybe<DecimalOperationFilterInput>;
  tauxDetention?: InputMaybe<DecimalOperationFilterInput>;
};

export type Detention = {
  __typename?: 'Detention';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  patrimoineActif: Array<PatrimoineActif>;
  patrimoineChargeRevenu: Array<PatrimoineChargeRevenu>;
  patrimoinePassif: Array<PatrimoinePassif>;
};


export type DetentionPatrimoineActifArgs = {
  where?: InputMaybe<PatrimoineActifFilterInput>;
};


export type DetentionPatrimoineChargeRevenuArgs = {
  where?: InputMaybe<PatrimoineChargeRevenuFilterInput>;
};


export type DetentionPatrimoinePassifArgs = {
  where?: InputMaybe<PatrimoinePassifFilterInput>;
};

export type DetentionFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<DetentionFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DetentionFilterInput>>;
  patrimoineActif?: InputMaybe<ListFilterInputTypeOfPatrimoineActifFilterInput>;
  patrimoineChargeRevenu?: InputMaybe<ListFilterInputTypeOfPatrimoineChargeRevenuFilterInput>;
  patrimoinePassif?: InputMaybe<ListFilterInputTypeOfPatrimoinePassifFilterInput>;
};

/** Déclaration de détention ou de connaissance d'un produit */
export enum DetentionProduitEnum {
  /** Aucun des deux */
  Aucun = 'AUCUN',
  /** Je connais (sans avoir détenu au cours des 36 derniers mois) */
  Connait = 'CONNAIT',
  /** Je détiens (ou ai détenu au cours des 36 derniers mois) */
  Detient = 'DETIENT'
}

export enum DisponibiliteEpargne {
  ConserverAvecRetraits = 'CONSERVER_AVEC_RETRAITS',
  ConserverSansRetrait = 'CONSERVER_SANS_RETRAIT',
  DedieRetraite = 'DEDIE_RETRAITE',
  ToujoursDispo = 'TOUJOURS_DISPO',
  Transmission = 'TRANSMISSION'
}

export type DisponibiliteEpargneOption = {
  __typename?: 'DisponibiliteEpargneOption';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: DisponibiliteEpargne;
};

export type Disposition = {
  __typename?: 'Disposition';
  autresDispositions?: Maybe<Scalars['Boolean']['output']>;
  autresDonation?: Maybe<Scalars['Boolean']['output']>;
  beneficiaire?: Maybe<Scalars['String']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateDonation?: Maybe<Scalars['LocalDate']['output']>;
  demembrement?: Maybe<Scalars['String']['output']>;
  donationConjoint?: Maybe<Scalars['Boolean']['output']>;
  donationDernierVivant?: Maybe<Scalars['Boolean']['output']>;
  donationPartage?: Maybe<Scalars['Boolean']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  forme?: Maybe<Scalars['String']['output']>;
  idSource?: Maybe<Scalars['String']['output']>;
  legsParticuliers?: Maybe<Scalars['Boolean']['output']>;
  legsUniversels?: Maybe<Scalars['Boolean']['output']>;
  montant?: Maybe<Scalars['Int']['output']>;
  note: Array<Note>;
  objet?: Maybe<Scalars['String']['output']>;
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
};


export type DispositionNoteArgs = {
  where?: InputMaybe<NoteFilterInput>;
};

export type DispositionFilterInput = {
  and?: InputMaybe<Array<DispositionFilterInput>>;
  autresDispositions?: InputMaybe<BooleanOperationFilterInput>;
  autresDonation?: InputMaybe<BooleanOperationFilterInput>;
  beneficiaire?: InputMaybe<StringOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDonation?: InputMaybe<LocalDateOperationFilterInput>;
  demembrement?: InputMaybe<StringOperationFilterInput>;
  donationConjoint?: InputMaybe<BooleanOperationFilterInput>;
  donationDernierVivant?: InputMaybe<BooleanOperationFilterInput>;
  donationPartage?: InputMaybe<BooleanOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  forme?: InputMaybe<StringOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  legsParticuliers?: InputMaybe<BooleanOperationFilterInput>;
  legsUniversels?: InputMaybe<BooleanOperationFilterInput>;
  montant?: InputMaybe<IntOperationFilterInput>;
  note?: InputMaybe<ListFilterInputTypeOfNoteFilterInput>;
  objet?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DispositionFilterInput>>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
};

export type DispositionSortInput = {
  autresDispositions?: InputMaybe<SortEnumType>;
  autresDonation?: InputMaybe<SortEnumType>;
  beneficiaire?: InputMaybe<SortEnumType>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateDonation?: InputMaybe<SortEnumType>;
  demembrement?: InputMaybe<SortEnumType>;
  donationConjoint?: InputMaybe<SortEnumType>;
  donationDernierVivant?: InputMaybe<SortEnumType>;
  donationPartage?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  forme?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  legsParticuliers?: InputMaybe<SortEnumType>;
  legsUniversels?: InputMaybe<SortEnumType>;
  montant?: InputMaybe<SortEnumType>;
  objet?: InputMaybe<SortEnumType>;
  personnePhysique?: InputMaybe<PersonnePhysiqueSortInput>;
  personnePhysiqueId?: InputMaybe<SortEnumType>;
};

export type Distinction = {
  __typename?: 'Distinction';
  code: Scalars['Byte']['output'];
  consultantDistinction: Array<ConsultantDistinction>;
  creationDate: Scalars['DateTime']['output'];
  distinctionCategorie: Scalars['Byte']['output'];
  distinctionCategorieNavigation: DistinctionCategorie;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type DistinctionConsultantDistinctionArgs = {
  where?: InputMaybe<ConsultantDistinctionFilterInput>;
};

export type DistinctionCategorie = {
  __typename?: 'DistinctionCategorie';
  code: Scalars['Byte']['output'];
  consultantDistinction: Array<ConsultantDistinction>;
  creationDate: Scalars['DateTime']['output'];
  distinction: Array<Distinction>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type DistinctionCategorieConsultantDistinctionArgs = {
  where?: InputMaybe<ConsultantDistinctionFilterInput>;
};


export type DistinctionCategorieDistinctionArgs = {
  where?: InputMaybe<DistinctionFilterInput>;
};

export type DistinctionCategorieFilterInput = {
  and?: InputMaybe<Array<DistinctionCategorieFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  consultantDistinction?: InputMaybe<ListFilterInputTypeOfConsultantDistinctionFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  distinction?: InputMaybe<ListFilterInputTypeOfDistinctionFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DistinctionCategorieFilterInput>>;
};

export type DistinctionFilterInput = {
  and?: InputMaybe<Array<DistinctionFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  consultantDistinction?: InputMaybe<ListFilterInputTypeOfConsultantDistinctionFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  distinctionCategorie?: InputMaybe<ByteOperationFilterInput>;
  distinctionCategorieNavigation?: InputMaybe<DistinctionCategorieFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DistinctionFilterInput>>;
};

export type DocumentCategory = {
  __typename?: 'DocumentCategory';
  documentTypes?: Maybe<Array<DocumentType>>;
  gedCategoryCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};


export type DocumentCategoryDocumentTypesArgs = {
  where?: InputMaybe<DocumentTypeFilterInput>;
};

export type DocumentCategoryFilterInput = {
  and?: InputMaybe<Array<DocumentCategoryFilterInput>>;
  documentTypes?: InputMaybe<ListFilterInputTypeOfDocumentTypeFilterInput>;
  gedCategoryCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DocumentCategoryFilterInput>>;
};

export type DocumentCategorySortInput = {
  gedCategoryCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  label?: InputMaybe<SortEnumType>;
};

export type DocumentFilterConfigurationInput = {
  activeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  consultantCodesFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  consultantFilesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  consultantIdsFilter?: InputMaybe<Array<Scalars['Int']['input']>>;
  continuationToken?: InputMaybe<Scalars['String']['input']>;
  creeParFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  documentIdsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  documentTypesFilter?: InputMaybe<Array<GedDocumentType>>;
  documentTypesStringFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  etatSignatureFilter?: InputMaybe<Array<SignatureState>>;
  handwrittenSignatureFilter?: InputMaybe<Scalars['Boolean']['input']>;
  includeSignatairesToIdsFilter?: InputMaybe<Scalars['Boolean']['input']>;
  investisseurFilesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  investisseurIdsFilter?: InputMaybe<Array<Scalars['Long']['input']>>;
  maxDocumentsPerRequest?: InputMaybe<Scalars['Int']['input']>;
  nomDeFichierFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  timeStampFilter?: InputMaybe<FilterDateTimeInput>;
};

export type DocumentSignatureInput = {
  documentIds: Array<Scalars['String']['input']>;
  providerSettings: ProviderSettingsInput;
  signataire: Array<SignataireInput>;
};

export enum DocumentStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  ToReview = 'TO_REVIEW',
  Uploaded = 'UPLOADED',
  Waiting = 'WAITING'
}

export type DocumentStatusOperationFilterInput = {
  eq?: InputMaybe<DocumentStatus>;
  in?: InputMaybe<Array<DocumentStatus>>;
  neq?: InputMaybe<DocumentStatus>;
  nin?: InputMaybe<Array<DocumentStatus>>;
};

export type DocumentType = {
  __typename?: 'DocumentType';
  availableForRequest: Scalars['Boolean']['output'];
  documentCategory: DocumentCategory;
  fileNamePrefix: Scalars['String']['output'];
  gedCategoryId: Scalars['Int']['output'];
  gedTypeCode: Scalars['String']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  hasExpirationDate?: Maybe<Scalars['Boolean']['output']>;
  hasRectoVerso?: Maybe<Scalars['Boolean']['output']>;
  hasReferenceDate?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isDeprecated?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  maxExpectedDocument?: Maybe<Scalars['Int']['output']>;
  replacementGedTypeCode?: Maybe<Scalars['String']['output']>;
};

export enum DocumentTypeEnum {
  Autre = 'AUTRE',
  Der = 'DER',
  Qpi = 'QPI',
  Recueil = 'RECUEIL'
}

export type DocumentTypeEnumOperationFilterInput = {
  eq?: InputMaybe<DocumentTypeEnum>;
  in?: InputMaybe<Array<DocumentTypeEnum>>;
  neq?: InputMaybe<DocumentTypeEnum>;
  nin?: InputMaybe<Array<DocumentTypeEnum>>;
};

export type DocumentTypeFilterInput = {
  and?: InputMaybe<Array<DocumentTypeFilterInput>>;
  availableForRequest?: InputMaybe<BooleanOperationFilterInput>;
  documentCategory?: InputMaybe<DocumentCategoryFilterInput>;
  fileNamePrefix?: InputMaybe<StringOperationFilterInput>;
  gedCategoryId?: InputMaybe<IntOperationFilterInput>;
  gedTypeCode?: InputMaybe<StringOperationFilterInput>;
  groupName?: InputMaybe<StringOperationFilterInput>;
  hasExpirationDate?: InputMaybe<BooleanOperationFilterInput>;
  hasRectoVerso?: InputMaybe<BooleanOperationFilterInput>;
  hasReferenceDate?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDeprecated?: InputMaybe<BooleanOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  maxExpectedDocument?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<DocumentTypeFilterInput>>;
  replacementGedTypeCode?: InputMaybe<StringOperationFilterInput>;
};

export type DocumentTypeSortInput = {
  availableForRequest?: InputMaybe<SortEnumType>;
  documentCategory?: InputMaybe<DocumentCategorySortInput>;
  fileNamePrefix?: InputMaybe<SortEnumType>;
  gedCategoryId?: InputMaybe<SortEnumType>;
  gedTypeCode?: InputMaybe<SortEnumType>;
  groupName?: InputMaybe<SortEnumType>;
  hasExpirationDate?: InputMaybe<SortEnumType>;
  hasRectoVerso?: InputMaybe<SortEnumType>;
  hasReferenceDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeprecated?: InputMaybe<SortEnumType>;
  label?: InputMaybe<SortEnumType>;
  maxExpectedDocument?: InputMaybe<SortEnumType>;
  replacementGedTypeCode?: InputMaybe<SortEnumType>;
};

export enum DocumentUploadSide {
  Document = 'DOCUMENT',
  Recto = 'RECTO',
  RectoVerso = 'RECTO_VERSO',
  Verso = 'VERSO'
}

export type DocumentUploadSideOperationFilterInput = {
  eq?: InputMaybe<DocumentUploadSide>;
  in?: InputMaybe<Array<DocumentUploadSide>>;
  neq?: InputMaybe<DocumentUploadSide>;
  nin?: InputMaybe<Array<DocumentUploadSide>>;
};

export type DonationInput = {
  beneficiaire?: InputMaybe<Scalars['String']['input']>;
  commentaire?: InputMaybe<Scalars['String']['input']>;
  dateDonation?: InputMaybe<Scalars['DateTime']['input']>;
  demembrement?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['Boolean']['input']>;
  donationDernierVivant?: InputMaybe<Scalars['Boolean']['input']>;
  forme?: InputMaybe<Scalars['String']['input']>;
  montant?: InputMaybe<Scalars['Int']['input']>;
  objet?: InputMaybe<Scalars['String']['input']>;
};

export type DoublonInvestisseurCheckResult = {
  __typename?: 'DoublonInvestisseurCheckResult';
  canBeCreated: Scalars['Boolean']['output'];
  existingRelationInvestisseurId?: Maybe<Scalars['Long']['output']>;
  isDoublon: Scalars['Boolean']['output'];
  isInOwnPortefeuille: Scalars['Boolean']['output'];
  isOtherConsultantContact: Scalars['Boolean']['output'];
  isOtherConsultantSigned: Scalars['Boolean']['output'];
};

export type EcartInvestisseurSyncResult = {
  __typename?: 'EcartInvestisseurSyncResult';
  errorCount: Scalars['Int']['output'];
  errorIds: Array<Scalars['Long']['output']>;
  isStop: Scalars['Boolean']['output'];
  remainingServiceCalls: Scalars['Int']['output'];
  status: EcartInvestisseurSyncStatus;
  unprocessedItems: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
};


export type EcartInvestisseurSyncResultErrorIdsArgs = {
  where?: InputMaybe<LongOperationFilterInput>;
};

export enum EcartInvestisseurSyncStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Incomplete = 'INCOMPLETE'
}

export type Edition = {
  __typename?: 'Edition';
  consultant?: Maybe<Consultant>;
  consultantId?: Maybe<Scalars['Long']['output']>;
  dateCreation: Scalars['DateTime']['output'];
  dateEdition: Scalars['DateTime']['output'];
  dateProchaineEdition?: Maybe<Scalars['DateTime']['output']>;
  documentId?: Maybe<Scalars['UUID']['output']>;
  estSupprime: Scalars['Boolean']['output'];
  extension: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  nombreTelechargement: Scalars['Int']['output'];
  typeEditionCode: Scalars['String']['output'];
  typeEditionCodeNavigation: TypeEdition;
};

export type EditionFilterInput = {
  and?: InputMaybe<Array<EditionFilterInput>>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  dateCreation?: InputMaybe<DateTimeOperationFilterInput>;
  dateEdition?: InputMaybe<DateTimeOperationFilterInput>;
  dateProchaineEdition?: InputMaybe<DateTimeOperationFilterInput>;
  documentId?: InputMaybe<UuidOperationFilterInput>;
  estSupprime?: InputMaybe<BooleanOperationFilterInput>;
  extension?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  nombreTelechargement?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EditionFilterInput>>;
  typeEditionCode?: InputMaybe<StringOperationFilterInput>;
  typeEditionCodeNavigation?: InputMaybe<TypeEditionFilterInput>;
};

export type Email = {
  __typename?: 'Email';
  adresse: Scalars['String']['output'];
  arianeId?: Maybe<Scalars['Long']['output']>;
  consultant: Array<Consultant>;
  contact: Array<Contact>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  estAdresseCorrespondance?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  personnePhysique: Array<PersonnePhysique>;
  typeEmailCode: Scalars['String']['output'];
  typeEmailCodeNavigation: TypeEmail;
};


export type EmailConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type EmailContactArgs = {
  where?: InputMaybe<ContactFilterInput>;
};


export type EmailPersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type EmailFilterInput = {
  adresse?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<EmailFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  contact?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  estAdresseCorrespondance?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<NoteFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<EmailFilterInput>>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  typeEmailCode?: InputMaybe<StringOperationFilterInput>;
  typeEmailCodeNavigation?: InputMaybe<TypeEmailFilterInput>;
};

export type EmailInput = {
  adresse: Scalars['String']['input'];
  estAdresseCorrespondance?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  typeEmailCode?: InputMaybe<Scalars['String']['input']>;
};

export type EngagementBudgetaire = {
  __typename?: 'EngagementBudgetaire';
  /** 35% des revenus actuels - les crédits */
  capaciteRemboursementRestanteMensuel: Scalars['Int']['output'];
  /** la date d'échéance la plus proche dans le temps des crédits en cours */
  dateProchaineEcheanceCredit?: Maybe<Scalars['DateTime']['output']>;
  /** somme des mensualités des crédits en cours */
  mensualiteCreditTotale: Scalars['Int']['output'];
  /** Différence des revenus actuels et les charges(hors impots) + credits sur le mois */
  soldeBudgetMensuel: Scalars['Decimal']['output'];
  /** somme des crédits et charges courantes (hors impots) divisée par la somme des revenus (les revenus fonciers (immobilier) sont pondérés à 70%) */
  tauxEndettement?: Maybe<Scalars['Int']['output']>;
};

export type Enveloppe = {
  __typename?: 'Enveloppe';
  code: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  libelle?: Maybe<Scalars['String']['output']>;
};

export type EnveloppeFilterInput = {
  and?: InputMaybe<Array<EnveloppeFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EnveloppeFilterInput>>;
};

export type EnveloppeProduit = {
  __typename?: 'EnveloppeProduit';
  backOfficeService: BackOfficeService;
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  enveloppeProduitExtension: EnveloppeProduitExtension;
  libelle: Scalars['String']['output'];
  produit: Array<Produit>;
  type2: Scalars['Byte']['output'];
  type2Navigation: Type2Produit;
};


export type EnveloppeProduitProduitArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type EnveloppeProduitExtension = {
  __typename?: 'EnveloppeProduitExtension';
  code: Scalars['Byte']['output'];
};

export type EnveloppeProduitFilterInput = {
  and?: InputMaybe<Array<EnveloppeProduitFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EnveloppeProduitFilterInput>>;
  produit?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

export type EnveloppeProduitSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  type2?: InputMaybe<SortEnumType>;
  type2Navigation?: InputMaybe<Type2ProduitSortInput>;
};

export type EnveloppeSortInput = {
  code?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type EquivalenceDeFormation = {
  __typename?: 'EquivalenceDeFormation';
  codeFormation: Scalars['Byte']['output'];
  codeFormationNavigation: Formation;
  commentaire?: Maybe<Scalars['String']['output']>;
  consultant: Consultant;
  consultantFormateur?: Maybe<Consultant>;
  consultantFormateurId?: Maybe<Scalars['Long']['output']>;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateFinValidite?: Maybe<Scalars['DateTime']['output']>;
  dateFormation?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  nom?: Maybe<Scalars['String']['output']>;
  nombreHeures?: Maybe<Scalars['Decimal']['output']>;
  organisme?: Maybe<Scalars['String']['output']>;
  typeJustification?: Maybe<Scalars['Byte']['output']>;
  typeJustificationNavigation?: Maybe<TypeJustificationFormation>;
};

export type EquivalenceDeFormationFilterInput = {
  and?: InputMaybe<Array<EquivalenceDeFormationFilterInput>>;
  codeFormation?: InputMaybe<ByteOperationFilterInput>;
  codeFormationNavigation?: InputMaybe<FormationFilterInput>;
  commentaire?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantFormateur?: InputMaybe<ConsultantFilterInput>;
  consultantFormateurId?: InputMaybe<LongOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateFormation?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  nombreHeures?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<EquivalenceDeFormationFilterInput>>;
  organisme?: InputMaybe<StringOperationFilterInput>;
  typeJustification?: InputMaybe<ByteOperationFilterInput>;
  typeJustificationNavigation?: InputMaybe<TypeJustificationFormationFilterInput>;
};

export type EquivalenceDeFormationInput = {
  codeFormation: Scalars['Byte']['input'];
  commentaire?: InputMaybe<Scalars['String']['input']>;
  consultantId: Scalars['Long']['input'];
  dateFormation?: InputMaybe<Scalars['DateTime']['input']>;
  nom?: InputMaybe<Scalars['String']['input']>;
  nombreHeures?: InputMaybe<Scalars['Decimal']['input']>;
  organisme?: InputMaybe<Scalars['String']['input']>;
  typeJustification?: InputMaybe<Scalars['Byte']['input']>;
};

export type EquivalenceFormationContinue = {
  __typename?: 'EquivalenceFormationContinue';
  consultantId: Scalars['Long']['output'];
  dateFormation: Scalars['DateTime']['output'];
  millesime: Scalars['Int']['output'];
  nom: Scalars['String']['output'];
  nombreHeures?: Maybe<Scalars['Decimal']['output']>;
};

export type EquivalenceFormationContinueFilterInput = {
  and?: InputMaybe<Array<EquivalenceFormationContinueFilterInput>>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  dateFormation?: InputMaybe<DateTimeOperationFilterInput>;
  millesime?: InputMaybe<IntOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  nombreHeures?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<EquivalenceFormationContinueFilterInput>>;
};

export type EquivalenceFormationContinueSortInput = {
  consultantId?: InputMaybe<SortEnumType>;
  dateFormation?: InputMaybe<SortEnumType>;
  millesime?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
  nombreHeures?: InputMaybe<SortEnumType>;
};

export type ErrorLogDetail = {
  __typename?: 'ErrorLogDetail';
  logIdentifier?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ErrorLogDetailFilterInput = {
  and?: InputMaybe<Array<ErrorLogDetailFilterInput>>;
  logIdentifier?: InputMaybe<StringOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErrorLogDetailFilterInput>>;
};

export enum EtatCni {
  Ajoute = 'AJOUTE',
  Expire = 'EXPIRE',
  Manquant = 'MANQUANT'
}

export type EtatCniOperationFilterInput = {
  eq?: InputMaybe<EtatCni>;
  in?: InputMaybe<Array<EtatCni>>;
  neq?: InputMaybe<EtatCni>;
  nin?: InputMaybe<Array<EtatCni>>;
};

export type EtatCivil = {
  __typename?: 'EtatCivil';
  codePaysResidenceStableCouple?: Maybe<Scalars['String']['output']>;
  codePaysResidenceStableCoupleNavigation?: Maybe<Pays>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateChangementSituation?: Maybe<Scalars['LocalDate']['output']>;
  dateContratUnion?: Maybe<Scalars['LocalDate']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  foyerFiscalIdentique: Scalars['Boolean']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  lieuContratUnion?: Maybe<Scalars['String']['output']>;
  nombreEnfantACharge?: Maybe<Scalars['Byte']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
  regimePacsIndivision?: Maybe<Scalars['Boolean']['output']>;
  typeAvantageMatrimonialCode?: Maybe<Scalars['String']['output']>;
  typeAvantageMatrimonialCodeNavigation?: Maybe<TypeAvantageMatrimonial>;
  typeRegimeSituationEtatCivilCode?: Maybe<Scalars['String']['output']>;
  typeRegimeSituationEtatCivilCodeNavigation?: Maybe<TypeRegimeSituationEtatCivil>;
  typeSituationEtatCivilCode?: Maybe<Scalars['String']['output']>;
  typeSituationEtatCivilCodeNavigation?: Maybe<TypeSituationEtatCivil>;
};

export type EtatCivilFilterInput = {
  and?: InputMaybe<Array<EtatCivilFilterInput>>;
  codePaysResidenceStableCouple?: InputMaybe<StringOperationFilterInput>;
  codePaysResidenceStableCoupleNavigation?: InputMaybe<PaysFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateChangementSituation?: InputMaybe<LocalDateOperationFilterInput>;
  dateContratUnion?: InputMaybe<LocalDateOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  foyerFiscalIdentique?: InputMaybe<BooleanOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  lieuContratUnion?: InputMaybe<StringOperationFilterInput>;
  nombreEnfantACharge?: InputMaybe<ByteOperationFilterInput>;
  note?: InputMaybe<NoteFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<EtatCivilFilterInput>>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  regimePacsIndivision?: InputMaybe<BooleanOperationFilterInput>;
  typeAvantageMatrimonialCode?: InputMaybe<StringOperationFilterInput>;
  typeAvantageMatrimonialCodeNavigation?: InputMaybe<TypeAvantageMatrimonialFilterInput>;
  typeRegimeSituationEtatCivilCode?: InputMaybe<StringOperationFilterInput>;
  typeRegimeSituationEtatCivilCodeNavigation?: InputMaybe<TypeRegimeSituationEtatCivilFilterInput>;
  typeSituationEtatCivilCode?: InputMaybe<StringOperationFilterInput>;
  typeSituationEtatCivilCodeNavigation?: InputMaybe<TypeSituationEtatCivilFilterInput>;
};

export type EtatCivilInput = {
  avantageMatrimonial?: InputMaybe<Scalars['String']['input']>;
  commentaire?: InputMaybe<Scalars['String']['input']>;
  dateChangementSituation?: InputMaybe<Scalars['DateTime']['input']>;
  dateContratUnion?: InputMaybe<Scalars['DateTime']['input']>;
  foyerFiscalIdentique: Scalars['Boolean']['input'];
  lieuContratUnion?: InputMaybe<Scalars['String']['input']>;
  nombreEnfantACharge?: InputMaybe<Scalars['Byte']['input']>;
  regimeMatrimoniale?: InputMaybe<Scalars['String']['input']>;
  regimePacsIndivision: Scalars['Boolean']['input'];
  situationMatrimoniale?: InputMaybe<Scalars['String']['input']>;
};

export type EtatCivilSortInput = {
  codePaysResidenceStableCouple?: InputMaybe<SortEnumType>;
  codePaysResidenceStableCoupleNavigation?: InputMaybe<PaysSortInput>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateChangementSituation?: InputMaybe<SortEnumType>;
  dateContratUnion?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  foyerFiscalIdentique?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  lieuContratUnion?: InputMaybe<SortEnumType>;
  nombreEnfantACharge?: InputMaybe<SortEnumType>;
  note?: InputMaybe<NoteSortInput>;
  noteId?: InputMaybe<SortEnumType>;
  personnePhysique?: InputMaybe<PersonnePhysiqueSortInput>;
  personnePhysiqueId?: InputMaybe<SortEnumType>;
  regimePacsIndivision?: InputMaybe<SortEnumType>;
  typeAvantageMatrimonialCode?: InputMaybe<SortEnumType>;
  typeAvantageMatrimonialCodeNavigation?: InputMaybe<TypeAvantageMatrimonialSortInput>;
  typeRegimeSituationEtatCivilCode?: InputMaybe<SortEnumType>;
  typeRegimeSituationEtatCivilCodeNavigation?: InputMaybe<TypeRegimeSituationEtatCivilSortInput>;
  typeSituationEtatCivilCode?: InputMaybe<SortEnumType>;
  typeSituationEtatCivilCodeNavigation?: InputMaybe<TypeSituationEtatCivilSortInput>;
};

export type EtatCommande = {
  __typename?: 'EtatCommande';
  code: Scalars['Byte']['output'];
  commande: Array<Commande>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};

export type EtatCommandeFilterInput = {
  and?: InputMaybe<Array<EtatCommandeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  commande?: InputMaybe<ListFilterInputTypeOfCommandeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtatCommandeFilterInput>>;
};

export type EtatCommandeSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export enum EtatDer {
  ACompleter = 'A_COMPLETER',
  ASigner = 'A_SIGNER',
  EnSignature = 'EN_SIGNATURE',
  EnSignatureApresSigne = 'EN_SIGNATURE_APRES_SIGNE',
  Signe = 'SIGNE'
}

export type EtatDerOperationFilterInput = {
  eq?: InputMaybe<EtatDer>;
  in?: InputMaybe<Array<EtatDer>>;
  neq?: InputMaybe<EtatDer>;
  nin?: InputMaybe<Array<EtatDer>>;
};

export enum EtatGlobalInvestisseur {
  AActualiser = 'A_ACTUALISER',
  ATerminer = 'A_TERMINER',
  Termine = 'TERMINE'
}

export type EtatGlobalInvestisseurOperationFilterInput = {
  eq?: InputMaybe<EtatGlobalInvestisseur>;
  in?: InputMaybe<Array<EtatGlobalInvestisseur>>;
  neq?: InputMaybe<EtatGlobalInvestisseur>;
  nin?: InputMaybe<Array<EtatGlobalInvestisseur>>;
};

export type EtatMouvement = {
  __typename?: 'EtatMouvement';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  mouvement: Array<Mouvement>;
};


export type EtatMouvementMouvementArgs = {
  where?: InputMaybe<MouvementFilterInput>;
};

export type EtatMouvementFilterInput = {
  and?: InputMaybe<Array<EtatMouvementFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  mouvement?: InputMaybe<ListFilterInputTypeOfMouvementFilterInput>;
  or?: InputMaybe<Array<EtatMouvementFilterInput>>;
};

export type EtatMouvementSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type EtatPmrCommande = {
  __typename?: 'EtatPmrCommande';
  code: Scalars['Byte']['output'];
  commande: Array<Commande>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};

export type EtatPmrCommandeFilterInput = {
  and?: InputMaybe<Array<EtatPmrCommandeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  commande?: InputMaybe<ListFilterInputTypeOfCommandeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtatPmrCommandeFilterInput>>;
};

export type EtatPmrCommandeSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type EtatProduit = {
  __typename?: 'EtatProduit';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  produit: Array<Produit>;
};


export type EtatProduitProduitArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type EtatProduitFilterInput = {
  and?: InputMaybe<Array<EtatProduitFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtatProduitFilterInput>>;
  produit?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

export type EtatProduitSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export enum EtatQpi {
  ACompleter = 'A_COMPLETER',
  ASigner = 'A_SIGNER',
  EnSignatureApresExpiration = 'EN_SIGNATURE_APRES_EXPIRATION',
  EnSignatureApresSigne = 'EN_SIGNATURE_APRES_SIGNE',
  EnSignaturePremierFois = 'EN_SIGNATURE_PREMIER_FOIS',
  Expire = 'EXPIRE',
  Signe = 'SIGNE',
  SigneNouveauACompleter = 'SIGNE_NOUVEAU_A_COMPLETER',
  SigneNouveauASigner = 'SIGNE_NOUVEAU_A_SIGNER'
}

export type EtatQpiOperationFilterInput = {
  eq?: InputMaybe<EtatQpi>;
  in?: InputMaybe<Array<EtatQpi>>;
  neq?: InputMaybe<EtatQpi>;
  nin?: InputMaybe<Array<EtatQpi>>;
};

export enum EtatRecueil {
  ACompleter = 'A_COMPLETER',
  ASigner = 'A_SIGNER',
  EnSignatureApresExpiration = 'EN_SIGNATURE_APRES_EXPIRATION',
  EnSignatureApresSigne = 'EN_SIGNATURE_APRES_SIGNE',
  EnSignaturePremierFois = 'EN_SIGNATURE_PREMIER_FOIS',
  Expire = 'EXPIRE',
  Signe = 'SIGNE'
}

export type EtatRecueilOperationFilterInput = {
  eq?: InputMaybe<EtatRecueil>;
  in?: InputMaybe<Array<EtatRecueil>>;
  neq?: InputMaybe<EtatRecueil>;
  nin?: InputMaybe<Array<EtatRecueil>>;
};

export type EtatResiliationB2S = {
  __typename?: 'EtatResiliationB2S';
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate: Scalars['DateTime']['output'];
  libelle: Scalars['String']['output'];
  resiliationPaiementB2S: Array<ResiliationPaiementB2S>;
};


export type EtatResiliationB2SResiliationPaiementB2SArgs = {
  where?: InputMaybe<ResiliationPaiementB2SFilterInput>;
};

export type EtatResiliationB2SFilterInput = {
  and?: InputMaybe<Array<EtatResiliationB2SFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtatResiliationB2SFilterInput>>;
  resiliationPaiementB2S?: InputMaybe<ListFilterInputTypeOfResiliationPaiementB2SFilterInput>;
};

export type EtatStatut = {
  __typename?: 'EtatStatut';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantStatutJuridique: Array<ConsultantStatutJuridique>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type EtatStatutConsultantStatutJuridiqueArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};

export type EtatStatutFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EtatStatutFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantStatutJuridique?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtatStatutFilterInput>>;
};

export type EtatTransfertClient = {
  __typename?: 'EtatTransfertClient';
  code: Scalars['String']['output'];
  transfertClient: Array<TransfertClient>;
};


export type EtatTransfertClientTransfertClientArgs = {
  where?: InputMaybe<TransfertClientFilterInput>;
};

export type EtatTransfertClientFilterInput = {
  and?: InputMaybe<Array<EtatTransfertClientFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtatTransfertClientFilterInput>>;
  transfertClient?: InputMaybe<ListFilterInputTypeOfTransfertClientFilterInput>;
};

export type EtatTransfertClientSortInput = {
  code?: InputMaybe<SortEnumType>;
};

export type Etiquette = {
  __typename?: 'Etiquette';
  color: Scalars['String']['output'];
  consultantId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  investisseurEtiquette?: Maybe<Array<InvestisseurEtiquette>>;
  label: Scalars['String']['output'];
};


export type EtiquetteInvestisseurEtiquetteArgs = {
  where?: InputMaybe<InvestisseurEtiquetteFilterInput>;
};

export type EtiquetteDto = {
  __typename?: 'EtiquetteDto';
  color: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  label: Scalars['String']['output'];
  selectedInvestisseurIds: Array<Scalars['Long']['output']>;
};


export type EtiquetteDtoSelectedInvestisseurIdsArgs = {
  where?: InputMaybe<LongOperationFilterInput>;
};

export type EtiquetteDtoInput = {
  color: Scalars['String']['input'];
  id: Scalars['Long']['input'];
  label: Scalars['String']['input'];
  selectedInvestisseurIds: Array<Scalars['Long']['input']>;
};

export type EtiquetteFilterInput = {
  and?: InputMaybe<Array<EtiquetteFilterInput>>;
  color?: InputMaybe<StringOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseurEtiquette?: InputMaybe<ListFilterInputTypeOfInvestisseurEtiquetteFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtiquetteFilterInput>>;
};

export type EtiquetteIndicateurDto = {
  __typename?: 'EtiquetteIndicateurDto';
  color: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  label: Scalars['String']['output'];
};

export type EtiquetteIndicateurDtoFilterInput = {
  and?: InputMaybe<Array<EtiquetteIndicateurDtoFilterInput>>;
  color?: InputMaybe<StringOperationFilterInput>;
  count?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtiquetteIndicateurDtoFilterInput>>;
};

export type EtiquetteIndicateurDtoSortInput = {
  color?: InputMaybe<SortEnumType>;
  count?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  label?: InputMaybe<SortEnumType>;
};

export type EtiquetteInput = {
  etiquettes: Array<EtiquetteDtoInput>;
  investisseurIds: Array<Scalars['Long']['input']>;
};

export type EtiquetteSortInput = {
  color?: InputMaybe<SortEnumType>;
  consultantId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  label?: InputMaybe<SortEnumType>;
};

export type ExerciceCommercial = {
  __typename?: 'ExerciceCommercial';
  actif: Scalars['Boolean']['output'];
  adhesionConsultant: Array<AdhesionConsultant>;
  codeExercice: Scalars['Long']['output'];
  consultantDistinction: Array<ConsultantDistinction>;
  creationDate: Scalars['DateTime']['output'];
  dateAdhesionReport?: Maybe<Scalars['DateTime']['output']>;
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  libelleExercice: Scalars['String']['output'];
};


export type ExerciceCommercialAdhesionConsultantArgs = {
  where?: InputMaybe<AdhesionConsultantFilterInput>;
};


export type ExerciceCommercialConsultantDistinctionArgs = {
  where?: InputMaybe<ConsultantDistinctionFilterInput>;
};

export type ExerciceCommercialFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  adhesionConsultant?: InputMaybe<ListFilterInputTypeOfAdhesionConsultantFilterInput>;
  and?: InputMaybe<Array<ExerciceCommercialFilterInput>>;
  codeExercice?: InputMaybe<LongOperationFilterInput>;
  consultantDistinction?: InputMaybe<ListFilterInputTypeOfConsultantDistinctionFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateAdhesionReport?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  libelleExercice?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExerciceCommercialFilterInput>>;
};

/** Réponses saisies pour le bloc expérience réelle et réaction à la perte */
export type ExperienceInput = {
  modeGestion?: InputMaybe<ModeGestionEpargneEnum>;
  nombreOperations?: InputMaybe<NombreOperationsEnum>;
  pertesSubies?: InputMaybe<Scalars['Boolean']['input']>;
  reactionPerte?: InputMaybe<ReactionPerteEnum>;
};

/** Réponses du bloc expérience réelle et réaction à la perte (Q18, Q19) */
export type ExperienceReponse = {
  __typename?: 'ExperienceReponse';
  modeGestion?: Maybe<ModeGestionEpargneEnum>;
  nombreOperations?: Maybe<NombreOperationsEnum>;
  pertesSubies?: Maybe<Scalars['Boolean']['output']>;
  reactionPerte?: Maybe<ReactionPerteEnum>;
};

/** Réponses du bloc expérience réelle et réaction à la perte (Q18, Q19) */
export type ExperienceReponseFilterInput = {
  and?: InputMaybe<Array<ExperienceReponseFilterInput>>;
  modeGestion?: InputMaybe<NullableOfModeGestionEpargneEnumOperationFilterInput>;
  nombreOperations?: InputMaybe<NullableOfNombreOperationsEnumOperationFilterInput>;
  or?: InputMaybe<Array<ExperienceReponseFilterInput>>;
  pertesSubies?: InputMaybe<BooleanOperationFilterInput>;
  reactionPerte?: InputMaybe<NullableOfReactionPerteEnumOperationFilterInput>;
};

/** Réponses du bloc expérience réelle et réaction à la perte (Q18, Q19) */
export type ExperienceReponseSortInput = {
  modeGestion?: InputMaybe<SortEnumType>;
  nombreOperations?: InputMaybe<SortEnumType>;
  pertesSubies?: InputMaybe<SortEnumType>;
  reactionPerte?: InputMaybe<SortEnumType>;
};

export type Expiration = {
  __typename?: 'Expiration';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateAnniversaire: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  periode: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  typePieceJointe: Array<TypePieceJointe>;
};


export type ExpirationTypePieceJointeArgs = {
  where?: InputMaybe<TypePieceJointeFilterInput>;
};

export type ExpirationFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ExpirationFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateAnniversaire?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExpirationFilterInput>>;
  periode?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<IntOperationFilterInput>;
  typePieceJointe?: InputMaybe<ListFilterInputTypeOfTypePieceJointeFilterInput>;
};

export type Facture = {
  __typename?: 'Facture';
  besoinApprobation: Scalars['Boolean']['output'];
  codeEtablissement: Scalars['String']['output'];
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateApprobation?: Maybe<Scalars['DateTime']['output']>;
  dateCreation: Scalars['DateTime']['output'];
  dateFacture: Scalars['DateTime']['output'];
  dateLimiteValidite: Scalars['DateTime']['output'];
  dateModification?: Maybe<Scalars['DateTime']['output']>;
  datePaiement?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['UUID']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  montant: Scalars['Decimal']['output'];
  nomFichier?: Maybe<Scalars['String']['output']>;
  nomFiliale: Scalars['String']['output'];
  nombreTelechargement: Scalars['Int']['output'];
  noteApprobation?: Maybe<Note>;
  noteApprobationId?: Maybe<Scalars['Long']['output']>;
  numeroEcritureComptable: Scalars['String']['output'];
  numeroFacture: Scalars['String']['output'];
  numeroPieceComptable: Scalars['String']['output'];
  statutApprobation?: Maybe<Scalars['Boolean']['output']>;
  statutJuridique: ConsultantStatutJuridique;
  statutJuridiqueId: Scalars['Long']['output'];
  yearFacture?: Maybe<Scalars['Int']['output']>;
};

export type FactureFilterInput = {
  and?: InputMaybe<Array<FactureFilterInput>>;
  besoinApprobation?: InputMaybe<BooleanOperationFilterInput>;
  codeEtablissement?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateApprobation?: InputMaybe<DateTimeOperationFilterInput>;
  dateCreation?: InputMaybe<DateTimeOperationFilterInput>;
  dateFacture?: InputMaybe<DateTimeOperationFilterInput>;
  dateLimiteValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateModification?: InputMaybe<DateTimeOperationFilterInput>;
  datePaiement?: InputMaybe<DateTimeOperationFilterInput>;
  documentId?: InputMaybe<UuidOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  montant?: InputMaybe<DecimalOperationFilterInput>;
  nomFichier?: InputMaybe<StringOperationFilterInput>;
  nomFiliale?: InputMaybe<StringOperationFilterInput>;
  nombreTelechargement?: InputMaybe<IntOperationFilterInput>;
  noteApprobation?: InputMaybe<NoteFilterInput>;
  noteApprobationId?: InputMaybe<LongOperationFilterInput>;
  numeroEcritureComptable?: InputMaybe<StringOperationFilterInput>;
  numeroFacture?: InputMaybe<StringOperationFilterInput>;
  numeroPieceComptable?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FactureFilterInput>>;
  statutApprobation?: InputMaybe<BooleanOperationFilterInput>;
  statutJuridique?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  statutJuridiqueId?: InputMaybe<LongOperationFilterInput>;
  yearFacture?: InputMaybe<IntOperationFilterInput>;
};

export type FailedFinancialRecalculationJob = {
  __typename?: 'FailedFinancialRecalculationJob';
  consultantPrimaire: FinancialRecalculationJobIdentity;
  createdAtUtc: Scalars['DateTime']['output'];
  exceptionMessage?: Maybe<Scalars['String']['output']>;
  exceptionType?: Maybe<Scalars['String']['output']>;
  failedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  investisseur: FinancialRecalculationJobIdentity;
  jobId: Scalars['Long']['output'];
  message: Scalars['String']['output'];
  priority: FinancialRecalculationPriority;
};

/** A segment of a collection. */
export type FailedFinancialRecalculationJobsCollectionSegment = {
  __typename?: 'FailedFinancialRecalculationJobsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FailedFinancialRecalculationJob>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type FailedJobItem = {
  __typename?: 'FailedJobItem';
  consultant?: Maybe<Consultant>;
  consultantId?: Maybe<Scalars['Long']['output']>;
  createdAt: Scalars['DateTime']['output'];
  errorLogs: Array<ErrorLogDetail>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  galaxy?: Maybe<Consultant>;
  galaxyId?: Maybe<Scalars['Long']['output']>;
  investisseur?: Maybe<Investisseur>;
  investisseurId?: Maybe<Scalars['Long']['output']>;
  isActive: Scalars['Boolean']['output'];
  jobId: Scalars['Long']['output'];
};


export type FailedJobItemErrorLogsArgs = {
  where?: InputMaybe<ErrorLogDetailFilterInput>;
};

export type FailedJobItemFilterInput = {
  and?: InputMaybe<Array<FailedJobItemFilterInput>>;
  consultant?: InputMaybe<MinotaureConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  errorLogs?: InputMaybe<ListFilterInputTypeOfErrorLogDetailFilterInput>;
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  galaxy?: InputMaybe<MinotaureConsultantFilterInput>;
  galaxyId?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<MinotaureInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  jobId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<FailedJobItemFilterInput>>;
};

/** Represente la configuration pour un champ, y compris sa visibilité et les validateurs associés. */
export type FieldConfig = {
  __typename?: 'FieldConfig';
  /** Clé unique identifiant le champ. */
  fieldKey: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** Indique si le champ est visible dans l'ihm. */
  isVisible: Scalars['Boolean']['output'];
  /** Liste des validateurs applicables à ce champ. */
  validators: Array<FieldValidatorConfig>;
  /** Condition optionnelle, combinée avec IsVisible. Sans condition, la visibilité reste statique. */
  visibilityCondition?: Maybe<FieldVisibilityCondition>;
};


/** Represente la configuration pour un champ, y compris sa visibilité et les validateurs associés. */
export type FieldConfigValidatorsArgs = {
  where?: InputMaybe<FieldValidatorConfigFilterInput>;
};

/** Represente la configuration pour un champ, y compris sa visibilité et les validateurs associés. */
export type FieldConfigFilterInput = {
  and?: InputMaybe<Array<FieldConfigFilterInput>>;
  /** Clé unique identifiant le champ. */
  fieldKey?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Indique si le champ est visible dans l'ihm. */
  isVisible?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FieldConfigFilterInput>>;
  /** Liste des validateurs applicables à ce champ. */
  validators?: InputMaybe<ListFilterInputTypeOfFieldValidatorConfigFilterInput>;
  /** Condition optionnelle, combinée avec IsVisible. Sans condition, la visibilité reste statique. */
  visibilityCondition?: InputMaybe<FieldVisibilityConditionFilterInput>;
};

export type FieldToComplete = {
  __typename?: 'FieldToComplete';
  message: Scalars['String']['output'];
  type: TypeMissingFieldEnum;
};

export type FieldToCompleteFilterInput = {
  and?: InputMaybe<Array<FieldToCompleteFilterInput>>;
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FieldToCompleteFilterInput>>;
  type?: InputMaybe<TypeMissingFieldEnumOperationFilterInput>;
};

export type FieldValidatorConfig = {
  __typename?: 'FieldValidatorConfig';
  /** Message d'erreur associé au validateur. */
  errorMessage: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** Liste des paramètres associés au validateur. */
  parameters: Array<FieldValidatorConfigParameter>;
  /** Clé unique identifiant le validateur. */
  validatorKey: Scalars['String']['output'];
};


export type FieldValidatorConfigParametersArgs = {
  where?: InputMaybe<FieldValidatorConfigParameterFilterInput>;
};

export type FieldValidatorConfigFilterInput = {
  and?: InputMaybe<Array<FieldValidatorConfigFilterInput>>;
  /** Message d'erreur associé au validateur. */
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<FieldValidatorConfigFilterInput>>;
  /** Liste des paramètres associés au validateur. */
  parameters?: InputMaybe<ListFilterInputTypeOfFieldValidatorConfigParameterFilterInput>;
  /** Clé unique identifiant le validateur. */
  validatorKey?: InputMaybe<StringOperationFilterInput>;
};

/** Représente un paramètre associé à un validateur de champ. */
export type FieldValidatorConfigParameter = {
  __typename?: 'FieldValidatorConfigParameter';
  id: Scalars['String']['output'];
  /** Clé unique identifiant le paramètre. */
  key: Scalars['String']['output'];
  /** Valeur associée au paramètre. */
  value: Scalars['String']['output'];
};

/** Représente un paramètre associé à un validateur de champ. */
export type FieldValidatorConfigParameterFilterInput = {
  and?: InputMaybe<Array<FieldValidatorConfigParameterFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  /** Clé unique identifiant le paramètre. */
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FieldValidatorConfigParameterFilterInput>>;
  /** Valeur associée au paramètre. */
  value?: InputMaybe<StringOperationFilterInput>;
};

export type FieldVisibilityCondition = {
  __typename?: 'FieldVisibilityCondition';
  fieldKey: Scalars['String']['output'];
  operator: FieldVisibilityOperator;
  value?: Maybe<Scalars['String']['output']>;
};

export type FieldVisibilityConditionFilterInput = {
  and?: InputMaybe<Array<FieldVisibilityConditionFilterInput>>;
  fieldKey?: InputMaybe<StringOperationFilterInput>;
  operator?: InputMaybe<FieldVisibilityOperatorOperationFilterInput>;
  or?: InputMaybe<Array<FieldVisibilityConditionFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export enum FieldVisibilityOperator {
  Equals = 'EQUALS',
  IsNotEmpty = 'IS_NOT_EMPTY'
}

export type FieldVisibilityOperatorOperationFilterInput = {
  eq?: InputMaybe<FieldVisibilityOperator>;
  in?: InputMaybe<Array<FieldVisibilityOperator>>;
  neq?: InputMaybe<FieldVisibilityOperator>;
  nin?: InputMaybe<Array<FieldVisibilityOperator>>;
};

export type FileInvestisseur = {
  __typename?: 'FileInvestisseur';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  nom?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
};

export type FileMetadata = {
  __typename?: 'FileMetadata';
  actif?: Maybe<Scalars['Boolean']['output']>;
  categorieCode?: Maybe<GedCategory>;
  consultantId?: Maybe<Scalars['Long']['output']>;
  contratId?: Maybe<Scalars['String']['output']>;
  creePar?: Maybe<Scalars['String']['output']>;
  dateDeCreation: Scalars['DateTime']['output'];
  dateDeDebutValidite?: Maybe<Scalars['DateTime']['output']>;
  dateDeDerniereModification: Scalars['DateTime']['output'];
  dateDeFinValidite?: Maybe<Scalars['DateTime']['output']>;
  dateDeReference?: Maybe<Scalars['LocalDate']['output']>;
  dateSignature?: Maybe<Scalars['DateTime']['output']>;
  denomination?: Maybe<Scalars['String']['output']>;
  derniereModificationPar?: Maybe<Scalars['String']['output']>;
  documentIdentifier?: Maybe<Scalars['String']['output']>;
  etatSignature?: Maybe<SignatureState>;
  extension?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  investisseurId?: Maybe<Scalars['Long']['output']>;
  investisseurIds?: Maybe<Array<Scalars['Long']['output']>>;
  investisseurs: Array<Maybe<FileInvestisseur>>;
  isHandwrittenSignature: Scalars['Boolean']['output'];
  patrimoineId?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<Permission>;
  signatureId?: Maybe<Scalars['String']['output']>;
  signatureOrder?: Maybe<Scalars['Int']['output']>;
  signatureStates?: Maybe<SignerStatesResponse>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  typeDocument?: Maybe<GedDocumentType>;
  typeDocumentCode?: Maybe<Scalars['String']['output']>;
  typeLibelle?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlExpireDate?: Maybe<Scalars['DateTime']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
};


export type FileMetadataInvestisseurIdsArgs = {
  where?: InputMaybe<LongOperationFilterInput>;
};


export type FileMetadataTagsArgs = {
  where?: InputMaybe<StringOperationFilterInput>;
};

export type FileMetadataFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<FileMetadataFilterInput>>;
  categorieCode?: InputMaybe<NullableOfGedCategoryOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  contratId?: InputMaybe<StringOperationFilterInput>;
  creePar?: InputMaybe<StringOperationFilterInput>;
  dateDeCreation?: InputMaybe<DateTimeOperationFilterInput>;
  dateDeDebutValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateDeDerniereModification?: InputMaybe<DateTimeOperationFilterInput>;
  dateDeFinValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateDeReference?: InputMaybe<LocalDateOperationFilterInput>;
  dateSignature?: InputMaybe<DateTimeOperationFilterInput>;
  denomination?: InputMaybe<StringOperationFilterInput>;
  derniereModificationPar?: InputMaybe<StringOperationFilterInput>;
  etatSignature?: InputMaybe<NullableOfSignatureStateOperationFilterInput>;
  extension?: InputMaybe<StringOperationFilterInput>;
  fileId?: InputMaybe<StringOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  investisseurIds?: InputMaybe<ListLongOperationFilterInput>;
  isHandwrittenSignature?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FileMetadataFilterInput>>;
  patrimoineId?: InputMaybe<StringOperationFilterInput>;
  permission?: InputMaybe<NullableOfPermissionOperationFilterInput>;
  signatureId?: InputMaybe<StringOperationFilterInput>;
  signatureOrder?: InputMaybe<IntOperationFilterInput>;
  tags?: InputMaybe<ListStringOperationFilterInput>;
  typeDocument?: InputMaybe<NullableOfGedDocumentTypeOperationFilterInput>;
  typeDocumentCode?: InputMaybe<StringOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
  urlExpireDate?: InputMaybe<DateTimeOperationFilterInput>;
  versionNumber?: InputMaybe<IntOperationFilterInput>;
};

export type FileMetadataSortInput = {
  actif?: InputMaybe<SortEnumType>;
  categorieCode?: InputMaybe<SortEnumType>;
  consultantId?: InputMaybe<SortEnumType>;
  contratId?: InputMaybe<SortEnumType>;
  creePar?: InputMaybe<SortEnumType>;
  dateDeCreation?: InputMaybe<SortEnumType>;
  dateDeDebutValidite?: InputMaybe<SortEnumType>;
  dateDeDerniereModification?: InputMaybe<SortEnumType>;
  dateDeFinValidite?: InputMaybe<SortEnumType>;
  dateDeReference?: InputMaybe<SortEnumType>;
  dateSignature?: InputMaybe<SortEnumType>;
  denomination?: InputMaybe<SortEnumType>;
  derniereModificationPar?: InputMaybe<SortEnumType>;
  etatSignature?: InputMaybe<SortEnumType>;
  extension?: InputMaybe<SortEnumType>;
  fileId?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  investisseurId?: InputMaybe<SortEnumType>;
  isHandwrittenSignature?: InputMaybe<SortEnumType>;
  patrimoineId?: InputMaybe<SortEnumType>;
  permission?: InputMaybe<SortEnumType>;
  signatureId?: InputMaybe<SortEnumType>;
  signatureOrder?: InputMaybe<SortEnumType>;
  typeDocument?: InputMaybe<SortEnumType>;
  typeDocumentCode?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
  urlExpireDate?: InputMaybe<SortEnumType>;
  versionNumber?: InputMaybe<SortEnumType>;
};

export type FileMetadataUpdateInput = {
  actif?: InputMaybe<Scalars['Boolean']['input']>;
  denomination?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  typeDocumentCode?: InputMaybe<Scalars['String']['input']>;
};

export enum FileStorageStatus {
  Active = 'ACTIVE',
  Deprecated = 'DEPRECATED'
}

export type FilialeFacturation = {
  __typename?: 'FilialeFacturation';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate: Scalars['DateTime']['output'];
  gammeProduit: Array<GammeProduit>;
  libelle: Scalars['String']['output'];
  produit: Array<Produit>;
};


export type FilialeFacturationGammeProduitArgs = {
  where?: InputMaybe<GammeProduitFilterInput>;
};


export type FilialeFacturationProduitArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type FilialeFacturationFilterInput = {
  and?: InputMaybe<Array<FilialeFacturationFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FilialeFacturationFilterInput>>;
  produit?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

export type FilialeFacturationSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type FilleulDataInput = {
  adresse: AdresseInput;
  civilite: Scalars['String']['input'];
  codeComFilleulProspect: Scalars['String']['input'];
  codeParrain: Scalars['String']['input'];
  codePaysNaissance: Scalars['String']['input'];
  codePaysNationalite: Scalars['String']['input'];
  dateNaissance: Scalars['String']['input'];
  departementNaissance: Scalars['String']['input'];
  email: Scalars['String']['input'];
  emailFacturation: Scalars['String']['input'];
  genre?: InputMaybe<Scalars['String']['input']>;
  isExclusif: Scalars['Boolean']['input'];
  nom: Scalars['String']['input'];
  nomNaissance: Scalars['String']['input'];
  prenom: Scalars['String']['input'];
  prenoms: Scalars['String']['input'];
  professionLiberale?: InputMaybe<ProfessionLiberaleInput>;
  societe?: InputMaybe<SocieteInput>;
  souhaitCollabStelliumFi: Scalars['Boolean']['input'];
  statutJuridiqueAssurance: TypeStatutJuridique;
  statutJuridiqueImmobilier: TypeStatutJuridique;
  telephone: TelephoneInput;
  villeNaissance: Scalars['String']['input'];
};

export type FilterDateTimeInput = {
  mode: FilterMode;
  toCompare?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum FilterMode {
  Contains = 'CONTAINS',
  Equal = 'EQUAL',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NoneOf = 'NONE_OF',
  OneOf = 'ONE_OF',
  Unequal = 'UNEQUAL'
}

export type FiltreSetting = {
  __typename?: 'FiltreSetting';
  builderCode: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  operator: Scalars['String']['output'];
  recherche: RechercheSauvegarde;
  rechercheId: Scalars['Long']['output'];
  value: Scalars['String']['output'];
};

export type FiltreSettingFilterInput = {
  and?: InputMaybe<Array<FiltreSettingFilterInput>>;
  builderCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  operator?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FiltreSettingFilterInput>>;
  recherche?: InputMaybe<RechercheSauvegardeFilterInput>;
  rechercheId?: InputMaybe<LongOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type FiltreSettingInput = {
  builderCode: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Durees en secondes issues des dates du job et des logs de tentative. Sans echantillon valide, les durees sont null. */
export type FinancialRecalculationDurationStats = {
  __typename?: 'FinancialRecalculationDurationStats';
  averageSeconds?: Maybe<Scalars['Float']['output']>;
  maximumSeconds?: Maybe<Scalars['Float']['output']>;
  minimumSeconds?: Maybe<Scalars['Float']['output']>;
  sampleCount: Scalars['Long']['output'];
};

export type FinancialRecalculationJobFilterInput = {
  and?: InputMaybe<Array<FinancialRecalculationJobFilterInput>>;
  completedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  createdAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  logs?: InputMaybe<ListFilterInputTypeOfFinancialRecalculationLogFilterInput>;
  or?: InputMaybe<Array<FinancialRecalculationJobFilterInput>>;
  priority?: InputMaybe<FinancialRecalculationPriorityOperationFilterInput>;
  retryCount?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<FinancialRecalculationJobStatusOperationFilterInput>;
};

export type FinancialRecalculationJobIdentity = {
  __typename?: 'FinancialRecalculationJobIdentity';
  code: Scalars['String']['output'];
  id?: Maybe<Scalars['Long']['output']>;
  nom: Scalars['String']['output'];
  prenom: Scalars['String']['output'];
};

export type FinancialRecalculationJobOutcomeStats = {
  __typename?: 'FinancialRecalculationJobOutcomeStats';
  elapsedSinceCreation: FinancialRecalculationDurationStats;
  processing: FinancialRecalculationDurationStats;
};

export type FinancialRecalculationJobPriorityStats = {
  __typename?: 'FinancialRecalculationJobPriorityStats';
  completed: FinancialRecalculationJobOutcomeStats;
  failed: FinancialRecalculationJobOutcomeStats;
  priority: FinancialRecalculationPriority;
  statusCounts: Array<FinancialRecalculationJobStatusCount>;
};

export type FinancialRecalculationJobStats = {
  __typename?: 'FinancialRecalculationJobStats';
  end: Scalars['DateTime']['output'];
  priorities: Array<FinancialRecalculationJobPriorityStats>;
  start: Scalars['DateTime']['output'];
};

export enum FinancialRecalculationJobStatus {
  Abandoned = 'ABANDONED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Todo = 'TODO'
}

export type FinancialRecalculationJobStatusCount = {
  __typename?: 'FinancialRecalculationJobStatusCount';
  count: Scalars['Long']['output'];
  status: FinancialRecalculationJobStatus;
};

export type FinancialRecalculationJobStatusOperationFilterInput = {
  eq?: InputMaybe<FinancialRecalculationJobStatus>;
  in?: InputMaybe<Array<FinancialRecalculationJobStatus>>;
  neq?: InputMaybe<FinancialRecalculationJobStatus>;
  nin?: InputMaybe<Array<FinancialRecalculationJobStatus>>;
};

export enum FinancialRecalculationLogEvent {
  Failed = 'FAILED',
  Started = 'STARTED'
}

export type FinancialRecalculationLogEventOperationFilterInput = {
  eq?: InputMaybe<FinancialRecalculationLogEvent>;
  in?: InputMaybe<Array<FinancialRecalculationLogEvent>>;
  neq?: InputMaybe<FinancialRecalculationLogEvent>;
  nin?: InputMaybe<Array<FinancialRecalculationLogEvent>>;
};

export type FinancialRecalculationLogFilterInput = {
  and?: InputMaybe<Array<FinancialRecalculationLogFilterInput>>;
  attempt?: InputMaybe<IntOperationFilterInput>;
  createdAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  elapsedSinceCreationSeconds?: InputMaybe<FloatOperationFilterInput>;
  event?: InputMaybe<FinancialRecalculationLogEventOperationFilterInput>;
  exceptionDetails?: InputMaybe<StringOperationFilterInput>;
  exceptionMessage?: InputMaybe<StringOperationFilterInput>;
  exceptionType?: InputMaybe<StringOperationFilterInput>;
  financialRecalculationJob?: InputMaybe<FinancialRecalculationJobFilterInput>;
  financialRecalculationJobId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FinancialRecalculationLogFilterInput>>;
  processingDurationSeconds?: InputMaybe<FloatOperationFilterInput>;
  workerId?: InputMaybe<IntOperationFilterInput>;
};

export enum FinancialRecalculationPriority {
  Bulk = 'BULK',
  Interactive = 'INTERACTIVE'
}

export type FinancialRecalculationPriorityOperationFilterInput = {
  eq?: InputMaybe<FinancialRecalculationPriority>;
  in?: InputMaybe<Array<FinancialRecalculationPriority>>;
  neq?: InputMaybe<FinancialRecalculationPriority>;
  nin?: InputMaybe<Array<FinancialRecalculationPriority>>;
};

export type FinancialRecalculationScheduleResult = {
  __typename?: 'FinancialRecalculationScheduleResult';
  hasMore: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['Long']['output']>;
  scheduledCount: Scalars['Int']['output'];
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export type FonctionContact = {
  __typename?: 'FonctionContact';
  code: Scalars['Byte']['output'];
  contact: Array<Contact>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type FonctionContactContactArgs = {
  where?: InputMaybe<ContactFilterInput>;
};

export type FonctionContactFilterInput = {
  and?: InputMaybe<Array<FonctionContactFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  contact?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FonctionContactFilterInput>>;
};

export type FondsEvenementiel = {
  __typename?: 'FondsEvenementiel';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
  modeDeGestion?: Maybe<ModeDeGestion>;
  modeDeGestionId: Scalars['String']['output'];
  ordre: Scalars['Int']['output'];
  produits: Array<Produit>;
};


export type FondsEvenementielProduitsArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type FondsEvenementielData = {
  __typename?: 'FondsEvenementielData';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  libelle: Scalars['String']['output'];
};

export type FondsEvenementielDataFilterInput = {
  and?: InputMaybe<Array<FondsEvenementielDataFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isSelected?: InputMaybe<BooleanOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FondsEvenementielDataFilterInput>>;
};

export type FondsEvenementielDataInput = {
  code: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  libelle: Scalars['String']['input'];
};

export type FondsEvenementielExtension = {
  __typename?: 'FondsEvenementielExtension';
  id: Scalars['Long']['output'];
};

export type FondsEvenementielFilterInput = {
  and?: InputMaybe<Array<FondsEvenementielFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  modeDeGestion?: InputMaybe<ModeDeGestionFilterInput>;
  modeDeGestionId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FondsEvenementielFilterInput>>;
  ordre?: InputMaybe<IntOperationFilterInput>;
  produits?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

/** Résultat d'un lot de recalcul de synthèse financière. */
export type ForceSyntheseFinanciereRecalculationResult = {
  __typename?: 'ForceSyntheseFinanciereRecalculationResult';
  /** Indique s'il reste encore des investisseurs à traiter après ce lot. */
  hasMore: Scalars['Boolean']['output'];
  /** Cursor à réutiliser pour lancer le lot suivant. Null quand le traitement est terminé. */
  nextCursor?: Maybe<Scalars['Long']['output']>;
  /** Nombre d'investisseurs recalculés dans ce lot. */
  processedCount: Scalars['Int']['output'];
};

export type Formation = {
  __typename?: 'Formation';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  equivalenceDeFormation: Array<EquivalenceDeFormation>;
  libelle: Scalars['String']['output'];
  type: Scalars['Byte']['output'];
  typeNavigation: FormationType;
};


export type FormationEquivalenceDeFormationArgs = {
  where?: InputMaybe<EquivalenceDeFormationFilterInput>;
};

export type FormationContinue = {
  __typename?: 'FormationContinue';
  codeFamille?: Maybe<Scalars['Byte']['output']>;
  consultantId: Scalars['Long']['output'];
  cursus: Scalars['String']['output'];
  dateValidationFormation?: Maybe<Scalars['DateTime']['output']>;
  formationValide?: Maybe<Scalars['Byte']['output']>;
  millesime: Scalars['Int']['output'];
  nbHeures?: Maybe<Scalars['Decimal']['output']>;
  nomADF: Scalars['String']['output'];
  nomSession: Scalars['String']['output'];
  referenceActionDeFormation: Scalars['String']['output'];
};

export type FormationContinueFilterInput = {
  and?: InputMaybe<Array<FormationContinueFilterInput>>;
  codeFamille?: InputMaybe<ByteOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  cursus?: InputMaybe<StringOperationFilterInput>;
  dateValidationFormation?: InputMaybe<DateTimeOperationFilterInput>;
  formationValide?: InputMaybe<ByteOperationFilterInput>;
  millesime?: InputMaybe<IntOperationFilterInput>;
  nbHeures?: InputMaybe<DecimalOperationFilterInput>;
  nomADF?: InputMaybe<StringOperationFilterInput>;
  nomSession?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationContinueFilterInput>>;
  referenceActionDeFormation?: InputMaybe<StringOperationFilterInput>;
};

export type FormationContinueSortInput = {
  codeFamille?: InputMaybe<SortEnumType>;
  consultantId?: InputMaybe<SortEnumType>;
  cursus?: InputMaybe<SortEnumType>;
  dateValidationFormation?: InputMaybe<SortEnumType>;
  formationValide?: InputMaybe<SortEnumType>;
  millesime?: InputMaybe<SortEnumType>;
  nbHeures?: InputMaybe<SortEnumType>;
  nomADF?: InputMaybe<SortEnumType>;
  nomSession?: InputMaybe<SortEnumType>;
  referenceActionDeFormation?: InputMaybe<SortEnumType>;
};

export type FormationEtat = {
  __typename?: 'FormationEtat';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  inscriptionCycleCourt: Array<InscriptionCycleCourt>;
  inscriptionSession: Array<InscriptionSession>;
  libelle: Scalars['String']['output'];
};


export type FormationEtatInscriptionCycleCourtArgs = {
  where?: InputMaybe<InscriptionCycleCourtFilterInput>;
};


export type FormationEtatInscriptionSessionArgs = {
  where?: InputMaybe<InscriptionSessionFilterInput>;
};

export type FormationEtatFilterInput = {
  and?: InputMaybe<Array<FormationEtatFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  inscriptionCycleCourt?: InputMaybe<ListFilterInputTypeOfInscriptionCycleCourtFilterInput>;
  inscriptionSession?: InputMaybe<ListFilterInputTypeOfInscriptionSessionFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationEtatFilterInput>>;
};

export type FormationFilterInput = {
  and?: InputMaybe<Array<FormationFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  equivalenceDeFormation?: InputMaybe<ListFilterInputTypeOfEquivalenceDeFormationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationFilterInput>>;
  type?: InputMaybe<ByteOperationFilterInput>;
  typeNavigation?: InputMaybe<FormationTypeFilterInput>;
};

export type FormationHabilitante = {
  __typename?: 'FormationHabilitante';
  codeEtat?: Maybe<Scalars['Byte']['output']>;
  codeNature?: Maybe<Scalars['Byte']['output']>;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  cursus: Scalars['String']['output'];
  dateInscription?: Maybe<Scalars['DateTime']['output']>;
  dateValidationFormation?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  formationValide?: Maybe<Scalars['Byte']['output']>;
  nomADF: Scalars['String']['output'];
  nomSession: Scalars['String']['output'];
  referenceActionDeFormation: Scalars['String']['output'];
  sessionId?: Maybe<Scalars['Long']['output']>;
  typesHabilitations?: Maybe<Array<TypeHabilitation>>;
};


export type FormationHabilitanteTypesHabilitationsArgs = {
  where?: InputMaybe<TypeHabilitationOperationFilterInput>;
};

export type FormationHabilitanteFilterInput = {
  and?: InputMaybe<Array<FormationHabilitanteFilterInput>>;
  codeEtat?: InputMaybe<ByteOperationFilterInput>;
  codeNature?: InputMaybe<ByteOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursus?: InputMaybe<StringOperationFilterInput>;
  dateInscription?: InputMaybe<DateTimeOperationFilterInput>;
  dateValidationFormation?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  formationValide?: InputMaybe<ByteOperationFilterInput>;
  nomADF?: InputMaybe<StringOperationFilterInput>;
  nomSession?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationHabilitanteFilterInput>>;
  referenceActionDeFormation?: InputMaybe<StringOperationFilterInput>;
  sessionId?: InputMaybe<LongOperationFilterInput>;
  typesHabilitations?: InputMaybe<ListTypeHabilitationOperationFilterInput>;
};

export type FormationHabilitanteSortInput = {
  codeEtat?: InputMaybe<SortEnumType>;
  codeNature?: InputMaybe<SortEnumType>;
  consultantId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  cursus?: InputMaybe<SortEnumType>;
  dateInscription?: InputMaybe<SortEnumType>;
  dateValidationFormation?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  formationValide?: InputMaybe<SortEnumType>;
  nomADF?: InputMaybe<SortEnumType>;
  nomSession?: InputMaybe<SortEnumType>;
  referenceActionDeFormation?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
};

export type FormationMotifAbandon = {
  __typename?: 'FormationMotifAbandon';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  inscriptionCycleCourt: Array<InscriptionCycleCourt>;
  libelle: Scalars['String']['output'];
};


export type FormationMotifAbandonInscriptionCycleCourtArgs = {
  where?: InputMaybe<InscriptionCycleCourtFilterInput>;
};

export type FormationMotifAbandonFilterInput = {
  and?: InputMaybe<Array<FormationMotifAbandonFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  inscriptionCycleCourt?: InputMaybe<ListFilterInputTypeOfInscriptionCycleCourtFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationMotifAbandonFilterInput>>;
};

export type FormationNature = {
  __typename?: 'FormationNature';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  inscriptionCycleCourt: Array<InscriptionCycleCourt>;
  inscriptionSession: Array<InscriptionSession>;
  libelle: Scalars['String']['output'];
};


export type FormationNatureInscriptionCycleCourtArgs = {
  where?: InputMaybe<InscriptionCycleCourtFilterInput>;
};


export type FormationNatureInscriptionSessionArgs = {
  where?: InputMaybe<InscriptionSessionFilterInput>;
};

export type FormationNatureFilterInput = {
  and?: InputMaybe<Array<FormationNatureFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  inscriptionCycleCourt?: InputMaybe<ListFilterInputTypeOfInscriptionCycleCourtFilterInput>;
  inscriptionSession?: InputMaybe<ListFilterInputTypeOfInscriptionSessionFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationNatureFilterInput>>;
};

export type FormationOrigine = {
  __typename?: 'FormationOrigine';
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  inscriptionCycleCourt: Array<InscriptionCycleCourt>;
  libelle: Scalars['String']['output'];
};


export type FormationOrigineInscriptionCycleCourtArgs = {
  where?: InputMaybe<InscriptionCycleCourtFilterInput>;
};

export type FormationOrigineFilterInput = {
  and?: InputMaybe<Array<FormationOrigineFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  inscriptionCycleCourt?: InputMaybe<ListFilterInputTypeOfInscriptionCycleCourtFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationOrigineFilterInput>>;
};

export type FormationSaison = {
  __typename?: 'FormationSaison';
  actionDeFormation: Array<ActionDeFormation>;
  code: Scalars['Byte']['output'];
  codeSource: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  cursus: Array<Cursus>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type FormationSaisonActionDeFormationArgs = {
  where?: InputMaybe<ActionDeFormationFilterInput>;
};


export type FormationSaisonCursusArgs = {
  where?: InputMaybe<CursusFilterInput>;
};

export type FormationSaisonFilterInput = {
  actionDeFormation?: InputMaybe<ListFilterInputTypeOfActionDeFormationFilterInput>;
  and?: InputMaybe<Array<FormationSaisonFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  codeSource?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursus?: InputMaybe<ListFilterInputTypeOfCursusFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationSaisonFilterInput>>;
};

export type FormationType = {
  __typename?: 'FormationType';
  actionDeFormation: Array<ActionDeFormation>;
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  cursus: Array<Cursus>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  formation: Array<Formation>;
  libelle: Scalars['String']['output'];
};


export type FormationTypeActionDeFormationArgs = {
  where?: InputMaybe<ActionDeFormationFilterInput>;
};


export type FormationTypeCursusArgs = {
  where?: InputMaybe<CursusFilterInput>;
};


export type FormationTypeFormationArgs = {
  where?: InputMaybe<FormationFilterInput>;
};

export type FormationTypeFilterInput = {
  actionDeFormation?: InputMaybe<ListFilterInputTypeOfActionDeFormationFilterInput>;
  and?: InputMaybe<Array<FormationTypeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursus?: InputMaybe<ListFilterInputTypeOfCursusFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  formation?: InputMaybe<ListFilterInputTypeOfFormationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationTypeFilterInput>>;
};

export type FormeJuridique = {
  __typename?: 'FormeJuridique';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  personneMorale: Array<PersonneMorale>;
  type: Scalars['Byte']['output'];
  typeNavigation: TypeFormeJuridique;
};


export type FormeJuridiquePersonneMoraleArgs = {
  where?: InputMaybe<PersonneMoraleFilterInput>;
};

export type FormeJuridiqueFilterInput = {
  and?: InputMaybe<Array<FormeJuridiqueFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormeJuridiqueFilterInput>>;
  personneMorale?: InputMaybe<ListFilterInputTypeOfPersonneMoraleFilterInput>;
  type?: InputMaybe<ByteOperationFilterInput>;
  typeNavigation?: InputMaybe<TypeFormeJuridiqueFilterInput>;
};

export enum FormulaireStatut {
  ATerminer = 'A_TERMINER',
  Complete = 'COMPLETE'
}

export type FormulaireStatutOperationFilterInput = {
  eq?: InputMaybe<FormulaireStatut>;
  in?: InputMaybe<Array<FormulaireStatut>>;
  neq?: InputMaybe<FormulaireStatut>;
  nin?: InputMaybe<Array<FormulaireStatut>>;
};

/** Représente un foyer fiscal auquel sont rattachés les investisseurs */
export type FoyerFiscal = {
  __typename?: 'FoyerFiscal';
  /** Charges déductibles du revenu global */
  chargesDeductiblesDuRevenuGlobal?: Maybe<Scalars['Decimal']['output']>;
  /** Contribution sociale généralisée déductible */
  csgDeductible?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Long']['output'];
  /** Indique si le foyer fiscal est imposable à l'impôt sur la fortune immobilière */
  imposableImpotFortuneImmo: Scalars['Boolean']['output'];
  /** Indique si le foyer fiscal est imposable à l'impôt sur le revenu */
  imposableImpotRevenu: Scalars['Boolean']['output'];
  /** Année ou les impots sur les revenus ont été acquittés */
  impotAnneeRevenus?: Maybe<Scalars['Int']['output']>;
  /** Autres impôts regroupés (taxe foncière, d'habitation, ...) */
  impotAutre?: Maybe<Scalars['Int']['output']>;
  impotAutreCommentaire?: Maybe<Scalars['String']['output']>;
  impotFortuneAnneeRevenus?: Maybe<Scalars['Int']['output']>;
  impotFortuneImmoCommentaire?: Maybe<Scalars['String']['output']>;
  /** Valeur nette taxable de l'IFI */
  impotFortuneImmoNet?: Maybe<Scalars['Int']['output']>;
  /** Impôt brut (avant réduction et crédit d'impôt) */
  impotRevenuBrut?: Maybe<Scalars['Int']['output']>;
  impotRevenuCommentaire?: Maybe<Scalars['String']['output']>;
  /** Montant Impôt net (après réduction et crédit d'impôt) */
  impotRevenuNet?: Maybe<Scalars['Int']['output']>;
  /** le taux applicable à la tranche de revenu la plus élevée (pourcentage) */
  impotRevenuTauxMarginal?: Maybe<Scalars['Int']['output']>;
  /** Total des crédits d'impôt, imputations */
  impotRevenuTotalCredit?: Maybe<Scalars['Decimal']['output']>;
  /** Total des réductions d'impôt */
  impotRevenuTotalReduction?: Maybe<Scalars['Decimal']['output']>;
  /** Impôt total avant crédits d'impôt */
  impotTotalAvantCreditsImpot?: Maybe<Scalars['Decimal']['output']>;
  investisseurs: Array<Investisseur>;
  isCompleted: Scalars['Boolean']['output'];
  /** Nombre de parts */
  nbParts?: Maybe<Scalars['Decimal']['output']>;
  /** Plafond épargne retraite non utilisé */
  plafondEpargneRetraireNonUtilise?: Maybe<Scalars['Decimal']['output']>;
  /** Revenus brut global */
  revenusBrutGlobal?: Maybe<Scalars['Decimal']['output']>;
  /** Total des prélèvements sociaux */
  totalDesPrelevementsSociaux?: Maybe<Scalars['Decimal']['output']>;
  /** Total des salaires et assimilés */
  totalSalairesAssimiles?: Maybe<Scalars['Decimal']['output']>;
};


/** Représente un foyer fiscal auquel sont rattachés les investisseurs */
export type FoyerFiscalInvestisseursArgs = {
  where?: InputMaybe<MinotaureInvestisseurFilterInput>;
};

/** Représente un foyer fiscal auquel sont rattachés les investisseurs */
export type FoyerFiscalFilterInput = {
  and?: InputMaybe<Array<FoyerFiscalFilterInput>>;
  /** Charges déductibles du revenu global */
  chargesDeductiblesDuRevenuGlobal?: InputMaybe<DecimalOperationFilterInput>;
  /** Contribution sociale généralisée déductible */
  csgDeductible?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  /** Indique si le foyer fiscal est imposable à l'impôt sur la fortune immobilière */
  imposableImpotFortuneImmo?: InputMaybe<BooleanOperationFilterInput>;
  /** Indique si le foyer fiscal est imposable à l'impôt sur le revenu */
  imposableImpotRevenu?: InputMaybe<BooleanOperationFilterInput>;
  /** Année ou les impots sur les revenus ont été acquittés */
  impotAnneeRevenus?: InputMaybe<IntOperationFilterInput>;
  /** Autres impôts regroupés (taxe foncière, d'habitation, ...) */
  impotAutre?: InputMaybe<IntOperationFilterInput>;
  impotAutreCommentaire?: InputMaybe<StringOperationFilterInput>;
  impotFortuneAnneeRevenus?: InputMaybe<IntOperationFilterInput>;
  impotFortuneImmoCommentaire?: InputMaybe<StringOperationFilterInput>;
  /** Valeur nette taxable de l'IFI */
  impotFortuneImmoNet?: InputMaybe<IntOperationFilterInput>;
  /** Impôt brut (avant réduction et crédit d'impôt) */
  impotRevenuBrut?: InputMaybe<IntOperationFilterInput>;
  impotRevenuCommentaire?: InputMaybe<StringOperationFilterInput>;
  /** Montant Impôt net (après réduction et crédit d'impôt) */
  impotRevenuNet?: InputMaybe<IntOperationFilterInput>;
  /** le taux applicable à la tranche de revenu la plus élevée (pourcentage) */
  impotRevenuTauxMarginal?: InputMaybe<IntOperationFilterInput>;
  /** Total des crédits d'impôt, imputations */
  impotRevenuTotalCredit?: InputMaybe<DecimalOperationFilterInput>;
  /** Total des réductions d'impôt */
  impotRevenuTotalReduction?: InputMaybe<DecimalOperationFilterInput>;
  /** Impôt total avant crédits d'impôt */
  impotTotalAvantCreditsImpot?: InputMaybe<DecimalOperationFilterInput>;
  investisseurs?: InputMaybe<ListFilterInputTypeOfMinotaureInvestisseurFilterInput>;
  isCompleted?: InputMaybe<BooleanOperationFilterInput>;
  /** Nombre de parts */
  nbParts?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<FoyerFiscalFilterInput>>;
  /** Plafond épargne retraite non utilisé */
  plafondEpargneRetraireNonUtilise?: InputMaybe<DecimalOperationFilterInput>;
  /** Revenus brut global */
  revenusBrutGlobal?: InputMaybe<DecimalOperationFilterInput>;
  /** Total des prélèvements sociaux */
  totalDesPrelevementsSociaux?: InputMaybe<DecimalOperationFilterInput>;
  /** Total des salaires et assimilés */
  totalSalairesAssimiles?: InputMaybe<DecimalOperationFilterInput>;
};

/** Représente un foyer fiscal auquel sont rattachés les investisseurs */
export type FoyerFiscalSortInput = {
  /** Charges déductibles du revenu global */
  chargesDeductiblesDuRevenuGlobal?: InputMaybe<SortEnumType>;
  /** Contribution sociale généralisée déductible */
  csgDeductible?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Indique si le foyer fiscal est imposable à l'impôt sur la fortune immobilière */
  imposableImpotFortuneImmo?: InputMaybe<SortEnumType>;
  /** Indique si le foyer fiscal est imposable à l'impôt sur le revenu */
  imposableImpotRevenu?: InputMaybe<SortEnumType>;
  /** Année ou les impots sur les revenus ont été acquittés */
  impotAnneeRevenus?: InputMaybe<SortEnumType>;
  /** Autres impôts regroupés (taxe foncière, d'habitation, ...) */
  impotAutre?: InputMaybe<SortEnumType>;
  impotAutreCommentaire?: InputMaybe<SortEnumType>;
  impotFortuneAnneeRevenus?: InputMaybe<SortEnumType>;
  impotFortuneImmoCommentaire?: InputMaybe<SortEnumType>;
  /** Valeur nette taxable de l'IFI */
  impotFortuneImmoNet?: InputMaybe<SortEnumType>;
  /** Impôt brut (avant réduction et crédit d'impôt) */
  impotRevenuBrut?: InputMaybe<SortEnumType>;
  impotRevenuCommentaire?: InputMaybe<SortEnumType>;
  /** Montant Impôt net (après réduction et crédit d'impôt) */
  impotRevenuNet?: InputMaybe<SortEnumType>;
  /** le taux applicable à la tranche de revenu la plus élevée (pourcentage) */
  impotRevenuTauxMarginal?: InputMaybe<SortEnumType>;
  /** Total des crédits d'impôt, imputations */
  impotRevenuTotalCredit?: InputMaybe<SortEnumType>;
  /** Total des réductions d'impôt */
  impotRevenuTotalReduction?: InputMaybe<SortEnumType>;
  /** Impôt total avant crédits d'impôt */
  impotTotalAvantCreditsImpot?: InputMaybe<SortEnumType>;
  isCompleted?: InputMaybe<SortEnumType>;
  /** Nombre de parts */
  nbParts?: InputMaybe<SortEnumType>;
  /** Plafond épargne retraite non utilisé */
  plafondEpargneRetraireNonUtilise?: InputMaybe<SortEnumType>;
  /** Revenus brut global */
  revenusBrutGlobal?: InputMaybe<SortEnumType>;
  /** Total des prélèvements sociaux */
  totalDesPrelevementsSociaux?: InputMaybe<SortEnumType>;
  /** Total des salaires et assimilés */
  totalSalairesAssimiles?: InputMaybe<SortEnumType>;
};

export type FoyerFiscalUpdateDataInput = {
  chargesDeductiblesDuRevenuGlobal?: InputMaybe<Scalars['Decimal']['input']>;
  csgDeductible?: InputMaybe<Scalars['Decimal']['input']>;
  imposableImpotFortuneImmo: Scalars['Boolean']['input'];
  imposableImpotRevenu: Scalars['Boolean']['input'];
  impotAnneeRevenus?: InputMaybe<Scalars['Int']['input']>;
  impotFortuneAnneeRevenus?: InputMaybe<Scalars['Int']['input']>;
  impotFortuneImmoCommentaire?: InputMaybe<Scalars['String']['input']>;
  impotFortuneImmoNet?: InputMaybe<Scalars['Int']['input']>;
  impotRevenuBrut?: InputMaybe<Scalars['Int']['input']>;
  impotRevenuCommentaire?: InputMaybe<Scalars['String']['input']>;
  impotRevenuNet?: InputMaybe<Scalars['Int']['input']>;
  impotRevenuTauxMarginal?: InputMaybe<Scalars['Int']['input']>;
  impotRevenuTotalCredit?: InputMaybe<Scalars['Decimal']['input']>;
  impotRevenuTotalReduction?: InputMaybe<Scalars['Decimal']['input']>;
  impotTotalAvantCreditsImpot?: InputMaybe<Scalars['Decimal']['input']>;
  investisseurId: Scalars['Long']['input'];
  isCompleted: Scalars['Boolean']['input'];
  nbParts?: InputMaybe<Scalars['Decimal']['input']>;
  plafondEpargneRetraireNonUtilise?: InputMaybe<Scalars['Decimal']['input']>;
  revenusBrutGlobal?: InputMaybe<Scalars['Decimal']['input']>;
  totalDesPrelevementsSociaux?: InputMaybe<Scalars['Decimal']['input']>;
  totalSalairesAssimiles?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum FrequenceVersement {
  Annuel = 'ANNUEL',
  Mensuel = 'MENSUEL',
  Semestriel = 'SEMESTRIEL',
  Trimestriel = 'TRIMESTRIEL'
}

export type GalaxyMigrationJob = {
  __typename?: 'GalaxyMigrationJob';
  consultantMigrationJobs: Array<ConsultantMigrationJob>;
  createdAt: Scalars['DateTime']['output'];
  galaxyId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  isActive: Scalars['Boolean']['output'];
  isPreImport: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  shouldAutomaticallyProcess: Scalars['Boolean']['output'];
  startMigrationTimeStamp?: Maybe<Scalars['DateTime']['output']>;
  status: JobStatus;
  waveMigrationJob?: Maybe<WaveMigrationJob>;
  waveMigrationJobId?: Maybe<Scalars['Long']['output']>;
};


export type GalaxyMigrationJobConsultantMigrationJobsArgs = {
  where?: InputMaybe<ConsultantMigrationJobFilterInput>;
};

export type GalaxyMigrationJobFilterInput = {
  and?: InputMaybe<Array<GalaxyMigrationJobFilterInput>>;
  consultantMigrationJobs?: InputMaybe<ListFilterInputTypeOfConsultantMigrationJobFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  galaxyId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isPreImport?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<GalaxyMigrationJobFilterInput>>;
  priority?: InputMaybe<IntOperationFilterInput>;
  shouldAutomaticallyProcess?: InputMaybe<BooleanOperationFilterInput>;
  startMigrationTimeStamp?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<JobStatusOperationFilterInput>;
  waveMigrationJob?: InputMaybe<WaveMigrationJobFilterInput>;
  waveMigrationJobId?: InputMaybe<LongOperationFilterInput>;
};

export type GalaxyMigrationJobSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  galaxyId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isPreImport?: InputMaybe<SortEnumType>;
  priority?: InputMaybe<SortEnumType>;
  shouldAutomaticallyProcess?: InputMaybe<SortEnumType>;
  startMigrationTimeStamp?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  waveMigrationJob?: InputMaybe<WaveMigrationJobSortInput>;
  waveMigrationJobId?: InputMaybe<SortEnumType>;
};

export type GammeProduit = {
  __typename?: 'GammeProduit';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  filialeFacturation: Scalars['Byte']['output'];
  filialeFacturationNavigation: FilialeFacturation;
  libelle: Scalars['String']['output'];
  type2Produit: Array<Type2Produit>;
};


export type GammeProduitType2ProduitArgs = {
  where?: InputMaybe<Type2ProduitFilterInput>;
};

export type GammeProduitFilterInput = {
  and?: InputMaybe<Array<GammeProduitFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  filialeFacturation?: InputMaybe<ByteOperationFilterInput>;
  filialeFacturationNavigation?: InputMaybe<FilialeFacturationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GammeProduitFilterInput>>;
  type2Produit?: InputMaybe<ListFilterInputTypeOfType2ProduitFilterInput>;
};

export type GammeProduitSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  filialeFacturation?: InputMaybe<SortEnumType>;
  filialeFacturationNavigation?: InputMaybe<FilialeFacturationSortInput>;
  libelle?: InputMaybe<SortEnumType>;
};

export type GedCategorie = {
  __typename?: 'GedCategorie';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  gedTypeDocument: Array<GedTypeDocument>;
  libelle: Scalars['String']['output'];
};


export type GedCategorieGedTypeDocumentArgs = {
  where?: InputMaybe<GedTypeDocumentFilterInput>;
};

export type GedCategorieFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<GedCategorieFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  gedTypeDocument?: InputMaybe<ListFilterInputTypeOfGedTypeDocumentFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GedCategorieFilterInput>>;
};

export enum GedCategory {
  Affi = 'AFFI',
  Apprenti = 'APPRENTI',
  Autre = 'AUTRE',
  Contrat = 'CONTRAT',
  ContratFinancement = 'CONTRAT_FINANCEMENT',
  Corres = 'CORRES',
  Credits = 'CREDITS',
  Documentpersonnel = 'DOCUMENTPERSONNEL',
  Epargne = 'EPARGNE',
  Groupe = 'GROUPE',
  Hab = 'HAB',
  Icont = 'ICONT',
  IdentiteCoordonnees = 'IDENTITE_COORDONNEES',
  Idt = 'IDT',
  Immo = 'IMMO',
  Impots = 'IMPOTS',
  Label = 'LABEL',
  Nr = 'NR',
  Portrait = 'PORTRAIT',
  Reglementaire = 'REGLEMENTAIRE',
  Revenus = 'REVENUS',
  Service = 'SERVICE',
  SimulationFinancement = 'SIMULATION_FINANCEMENT',
  Staj = 'STAJ',
  ValeurNonSupportee = 'VALEUR_NON_SUPPORTEE'
}

export enum GedDocumentType {
  ActDeces = 'ACT_DECES',
  ActNaissance = 'ACT_NAISSANCE',
  ActProp = 'ACT_PROP',
  AraConsPj1 = 'ARA_CONS_PJ1',
  AraConsPj2 = 'ARA_CONS_PJ2',
  AraConsPj3 = 'ARA_CONS_PJ3',
  AraConsPj17 = 'ARA_CONS_PJ17',
  AraConsPj18 = 'ARA_CONS_PJ18',
  AraConsPj19 = 'ARA_CONS_PJ19',
  AraConsPj20 = 'ARA_CONS_PJ20',
  AraConsPj21 = 'ARA_CONS_PJ21',
  AraConsPj22 = 'ARA_CONS_PJ22',
  AraConsPj65 = 'ARA_CONS_PJ65',
  AraConsPj66 = 'ARA_CONS_PJ66',
  AraConsPj67 = 'ARA_CONS_PJ67',
  AraConsPj68 = 'ARA_CONS_PJ68',
  AraConsPj69 = 'ARA_CONS_PJ69',
  AraConsPj70 = 'ARA_CONS_PJ70',
  AraConsPj71 = 'ARA_CONS_PJ71',
  AraConsPj81 = 'ARA_CONS_PJ81',
  AraConsPj82 = 'ARA_CONS_PJ82',
  AraConsPj83 = 'ARA_CONS_PJ83',
  AraConsPj84 = 'ARA_CONS_PJ84',
  AraConsPj85 = 'ARA_CONS_PJ85',
  AraConsPj86 = 'ARA_CONS_PJ86',
  AraConsPj87 = 'ARA_CONS_PJ87',
  AraConsPj88 = 'ARA_CONS_PJ88',
  AraConsPj89 = 'ARA_CONS_PJ89',
  AraConsPj90 = 'ARA_CONS_PJ90',
  AraConsPj91 = 'ARA_CONS_PJ91',
  AraConsPj92 = 'ARA_CONS_PJ92',
  AraConsPj94 = 'ARA_CONS_PJ94',
  AraConsPj95 = 'ARA_CONS_PJ95',
  AraConsPj96 = 'ARA_CONS_PJ96',
  AraConsPj97 = 'ARA_CONS_PJ97',
  AraConsPj132 = 'ARA_CONS_PJ132',
  AraConsPj164 = 'ARA_CONS_PJ164',
  AraConsPj165 = 'ARA_CONS_PJ165',
  AraConsPj166 = 'ARA_CONS_PJ166',
  AraConsPj167 = 'ARA_CONS_PJ167',
  AraConsPj168 = 'ARA_CONS_PJ168',
  AraConsPj169 = 'ARA_CONS_PJ169',
  AraConsPj170 = 'ARA_CONS_PJ170',
  AraConsPj171 = 'ARA_CONS_PJ171',
  AraConsPj172 = 'ARA_CONS_PJ172',
  AraConsPj173 = 'ARA_CONS_PJ173',
  AraConsPj174 = 'ARA_CONS_PJ174',
  AraConsPj175 = 'ARA_CONS_PJ175',
  AraConsPj177 = 'ARA_CONS_PJ177',
  AraConsPj178 = 'ARA_CONS_PJ178',
  AraConsPj179 = 'ARA_CONS_PJ179',
  AraConsPj180 = 'ARA_CONS_PJ180',
  AraConsPj196 = 'ARA_CONS_PJ196',
  AraConsPj212 = 'ARA_CONS_PJ212',
  AraConsPj228 = 'ARA_CONS_PJ228',
  AraConsPj244 = 'ARA_CONS_PJ244',
  AraConsPj261 = 'ARA_CONS_PJ261',
  AraConsPj262 = 'ARA_CONS_PJ262',
  AraConsPj263 = 'ARA_CONS_PJ263',
  AraConsPj278 = 'ARA_CONS_PJ278',
  AraConsPj294 = 'ARA_CONS_PJ294',
  AraConsPj313 = 'ARA_CONS_PJ313',
  AraConsPj314 = 'ARA_CONS_PJ314',
  AraConsPj329 = 'ARA_CONS_PJ329',
  AraConsPj330 = 'ARA_CONS_PJ330',
  AraConsPj331 = 'ARA_CONS_PJ331',
  AraConsPj332 = 'ARA_CONS_PJ332',
  AraConsPj333 = 'ARA_CONS_PJ333',
  AraConsPj334 = 'ARA_CONS_PJ334',
  AraConsPj361 = 'ARA_CONS_PJ361',
  AraConsPj377 = 'ARA_CONS_PJ377',
  AraConsPj378 = 'ARA_CONS_PJ378',
  AraConsPj489 = 'ARA_CONS_PJ489',
  Att85A = 'ATT85A',
  AttestCollabCci = 'ATTEST_COLLAB_CCI',
  AttFi = 'ATT_FI',
  AttFiad = 'ATT_FIAD',
  AttFormation = 'ATT_FORMATION',
  AttHabImmo = 'ATT_HAB_IMMO',
  AttHeberg = 'ATT_HEBERG',
  AttInv = 'ATT_INV',
  AttResTmp = 'ATT_RES_TMP',
  AttSign = 'ATT_SIGN',
  AttStellium = 'ATT_STELLIUM',
  AttStNoFr = 'ATT_ST_NO_FR',
  AttUsg = 'ATT_USG',
  AttVigilanceAgc = 'ATT_VIGILANCE_AGC',
  AttVigilancePl = 'ATT_VIGILANCE_PL',
  AttVigilanceSoc = 'ATT_VIGILANCE_SOC',
  Autre = 'AUTRE',
  AvenantActivConcur = 'AVENANT_ACTIV_CONCUR',
  AvenantFinActivConcur = 'AVENANT_FIN_ACTIV_CONCUR',
  AvenantMif2Alpsi = 'AVENANT_MIF2_ALPSI',
  AvenantMif2Cif = 'AVENANT_MIF2_CIF',
  BancReleve = 'BANC_RELEVE',
  BilanCompt = 'BILAN_COMPT',
  BilanExploit = 'BILAN_EXPLOIT',
  BullPaye = 'BULL_PAYE',
  BullPayeDernierDecembre = 'BULL_PAYE_DERNIER_DECEMBRE',
  CaptureSyntheseCompteUrssaf = 'CAPTURE_SYNTHESE_COMPTE_URSSAF',
  CarteDemarchageAlpsi = 'CARTE_DEMARCHAGE_ALPSI',
  CarteDemarchageStefi = 'CARTE_DEMARCHAGE_STEFI',
  CarteT = 'CARTE_T',
  CarteVitale = 'CARTE_VITALE',
  Carto = 'CARTO',
  Cerfa3558Agc = 'CERFA3558_AGC',
  Cerfa3558Pl = 'CERFA3558_PL',
  Cerfa3558Soc = 'CERFA3558_SOC',
  Cerfa3666Agc = 'CERFA3666_AGC',
  Cerfa3666Pl = 'CERFA3666_PL',
  Cerfa3666Soc = 'CERFA3666_SOC',
  CertifTravail = 'CERTIF_TRAVAIL',
  Cni = 'CNI',
  CniHeberg = 'CNI_HEBERG',
  CniMere = 'CNI_MERE',
  CniPere = 'CNI_PERE',
  ContAgentCo = 'CONT_AGENT_CO',
  ContApprentissage = 'CONT_APPRENTISSAGE',
  ContAutre = 'CONT_AUTRE',
  ContCollabFinancement = 'CONT_COLLAB_FINANCEMENT',
  ContIntermAssuCourtage = 'CONT_INTERM_ASSU_COURTAGE',
  ContTrav = 'CONT_TRAV',
  ConventionCadre = 'CONVENTION_CADRE',
  ConvDistribInvest = 'CONV_DISTRIB_INVEST',
  Dci = 'DCI',
  DclAdeq = 'DCL_ADEQ',
  DeclFond = 'DECL_FOND',
  Der = 'DER',
  Diplome = 'DIPLOME',
  EditionConsultant = 'EDITION_CONSULTANT',
  EpargnReleve = 'EPARGN_RELEVE',
  Esp = 'ESP',
  Esp1Er = 'ESP1ER',
  ExtrCasierJudi = 'EXTR_CASIER_JUDI',
  ExtrKbis = 'EXTR_KBIS',
  ExtMarg = 'EXT_MARG',
  FicheConseil = 'FICHE_CONSEIL',
  FinBancReleve = 'FIN_BANC_RELEVE',
  FinBilan = 'FIN_BILAN',
  FinImpotsMultiple = 'FIN_IMPOTS_MULTIPLE',
  FinRevPlus55 = 'FIN_REV_PLUS55',
  FormationContinueAlpsi = 'FORMATION_CONTINUE_ALPSI',
  FormationContinueAssu = 'FORMATION_CONTINUE_ASSU',
  FormationContinueFinancement = 'FORMATION_CONTINUE_FINANCEMENT',
  FormationContinueImmo = 'FORMATION_CONTINUE_IMMO',
  FormulaireRelationSecondaire = 'FORMULAIRE_RELATION_SECONDAIRE',
  FormulaireTransfertClient = 'FORMULAIRE_TRANSFERT_CLIENT',
  Fpat = 'FPAT',
  Fpres = 'FPRES',
  ImmatOriasAlpsi = 'IMMAT_ORIAS_ALPSI',
  ImmatOriasCif = 'IMMAT_ORIAS_CIF',
  ImmatOriasIob = 'IMMAT_ORIAS_IOB',
  ImmatOriasMia = 'IMMAT_ORIAS_MIA',
  ImmoCompromis = 'IMMO_COMPROMIS',
  ImmoResa = 'IMMO_RESA',
  Impot2031 = 'IMPOT2031',
  Impot2035 = 'IMPOT2035',
  Impot2042 = 'IMPOT2042',
  Impot2044 = 'IMPOT2044',
  Impot2139 = 'IMPOT2139',
  ImpotAvis = 'IMPOT_AVIS',
  ImpotAvisN = 'IMPOT_AVIS_N',
  ImpotAvisN1 = 'IMPOT_AVIS_N1',
  ImpotFonc = 'IMPOT_FONC',
  ImpotHab = 'IMPOT_HAB',
  ImpotIfi = 'IMPOT_IFI',
  Jd = 'JD',
  JugCurat = 'JUG_CURAT',
  JugDiv = 'JUG_DIV',
  JugOrd = 'JUG_ORD',
  JugTut = 'JUG_TUT',
  JustifApport = 'JUSTIF_APPORT',
  JustifDomicile = 'JUSTIF_DOMICILE',
  JustifPrim = 'JUSTIF_PRIM',
  JustDom = 'JUST_DOM',
  JustFiscEtr = 'JUST_FISC_ETR',
  JustFond = 'JUST_FOND',
  Kbis = 'KBIS',
  KbisPl = 'KBIS_PL',
  KbisSoc = 'KBIS_SOC',
  Lettre = 'LETTRE',
  LivretFam = 'LIVRET_FAM',
  LMission = 'L_MISSION',
  MandatAlpsi = 'MANDAT_ALPSI',
  MandatAutofac = 'MANDAT_AUTOFAC',
  MandatAutofacPar = 'MANDAT_AUTOFAC_PAR',
  MandatCif = 'MANDAT_CIF',
  MandatEntremisePl = 'MANDAT_ENTREMISE_PL',
  MandatEntremiseSoc = 'MANDAT_ENTREMISE_SOC',
  MandatFinanc = 'MANDAT_FINANC',
  MandatStefi = 'MANDAT_STEFI',
  MandatStelliumImmo = 'MANDAT_STELLIUM_IMMO',
  MariageContrat = 'MARIAGE_CONTRAT',
  MdtSepa = 'MDT_SEPA',
  Message = 'MESSAGE',
  NotifAffiliationAgc = 'NOTIF_AFFILIATION_AGC',
  NotifAffiliationPl = 'NOTIF_AFFILIATION_PL',
  NotifAffiliationSoc = 'NOTIF_AFFILIATION_SOC',
  NotifDemandeDelaiUrssaf = 'NOTIF_DEMANDE_DELAI_URSSAF',
  Nr = 'NR',
  OffrePret = 'OFFRE_PRET',
  PacsDiss = 'PACS_DISS',
  Passeport = 'PASSEPORT',
  PhotoIdentite = 'PHOTO_IDENTITE',
  PhotoPortrait = 'PHOTO_PORTRAIT',
  ProfInvest = 'PROF_INVEST',
  Rbe = 'RBE',
  Rcp = 'RCP',
  RecInfo = 'REC_INFO',
  Reglimpactplus = 'REGLIMPACTPLUS',
  RembAnticp = 'REMB_ANTICP',
  RevCptEpargne = 'REV_CPT_EPARGNE',
  RevFonc = 'REV_FONC',
  RevFoncBail = 'REV_FONC_BAIL',
  RevFoncEstim = 'REV_FONC_ESTIM',
  RevFoncQuit = 'REV_FONC_QUIT',
  RevPensions = 'REV_PENSIONS',
  Rib = 'RIB',
  RibAgc = 'RIB_AGC',
  RibPl = 'RIB_PL',
  RibSoc = 'RIB_SOC',
  Rsac = 'RSAC',
  Rto = 'RTO',
  SciStatuts = 'SCI_STATUTS',
  SimulFinanc = 'SIMUL_FINANC',
  SimulOpe = 'SIMUL_OPE',
  Souscript = 'SOUSCRIPT',
  SouscriptComp = 'SOUSCRIPT_COMP',
  StatutSociete = 'STATUT_SOCIETE',
  TabAmort = 'TAB_AMORT',
  TitreSejour = 'TITRE_SEJOUR',
  TtireDansRachat = 'TTIRE_DANS_RACHAT',
  ValeurNonSupportee = 'VALEUR_NON_SUPPORTEE'
}

export type GedTypeDocument = {
  __typename?: 'GedTypeDocument';
  actif?: Maybe<Scalars['Boolean']['output']>;
  appartenanceDocument: AppartenanceDocument;
  appartenanceDocumentId: Scalars['Byte']['output'];
  code: Scalars['String']['output'];
  codeCategorie: Scalars['String']['output'];
  codeCategorieNavigation: GedCategorie;
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  dernierDocumentVisible: Scalars['Boolean']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  suppressionNonDefinitive: Scalars['Boolean']['output'];
};

export type GedTypeDocumentFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<GedTypeDocumentFilterInput>>;
  appartenanceDocument?: InputMaybe<AppartenanceDocumentFilterInput>;
  appartenanceDocumentId?: InputMaybe<ByteOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  codeCategorie?: InputMaybe<StringOperationFilterInput>;
  codeCategorieNavigation?: InputMaybe<GedCategorieFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  dernierDocumentVisible?: InputMaybe<BooleanOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GedTypeDocumentFilterInput>>;
  personnePhysiqueDocument?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueDocumentFilterInput>;
  suppressionNonDefinitive?: InputMaybe<BooleanOperationFilterInput>;
};

export type GenerateOperationAdequationInput = {
  operationId: Scalars['UUID']['input'];
};

export type GeneratedBudgetInput = {
  amount: Scalars['Decimal']['input'];
  budgetType: SousCategorie2BudgetEnum;
  investisseurs: Array<GeneratedBudgetInvestisseurInput>;
};

export type GeneratedBudgetInvestisseurInput = {
  detention: Scalars['Decimal']['input'];
  investisseurId: Scalars['Long']['input'];
};

export enum GenerationRecueilTypeEnum {
  Couple = 'COUPLE',
  Solo = 'SOLO'
}

export type GenerationRecueilTypeEnumOperationFilterInput = {
  eq?: InputMaybe<GenerationRecueilTypeEnum>;
  in?: InputMaybe<Array<GenerationRecueilTypeEnum>>;
  neq?: InputMaybe<GenerationRecueilTypeEnum>;
  nin?: InputMaybe<Array<GenerationRecueilTypeEnum>>;
};

export type Habilitation = {
  __typename?: 'Habilitation';
  actif: Scalars['Boolean']['output'];
  associationProNom: Scalars['Boolean']['output'];
  cifPartenaireCode: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  consultantHabilitation: Array<ConsultantHabilitation>;
  creationDate: Scalars['DateTime']['output'];
  dateDebut?: Maybe<Scalars['LocalDate']['output']>;
  dateFin?: Maybe<Scalars['LocalDate']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  garantAdresse: Scalars['Boolean']['output'];
  garantNom: Scalars['Boolean']['output'];
  habilitationInscription: Array<HabilitationInscription>;
  habilitationRcp: Array<HabilitationRcp>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  libelle?: Maybe<Scalars['String']['output']>;
  lienConsultantStatutJuridiqueTypeHabilitation: Array<LienConsultantStatutJuridiqueTypeHabilitation>;
  mediateur: Scalars['Boolean']['output'];
  origineHabilitation?: Maybe<Scalars['String']['output']>;
  partenaireCourtierFinancement1: Scalars['Boolean']['output'];
  partenaireCourtierFinancement2: Scalars['Boolean']['output'];
  produit: Array<Produit>;
};


export type HabilitationConsultantHabilitationArgs = {
  where?: InputMaybe<ConsultantHabilitationFilterInput>;
};


export type HabilitationHabilitationInscriptionArgs = {
  where?: InputMaybe<HabilitationInscriptionFilterInput>;
};


export type HabilitationHabilitationRcpArgs = {
  where?: InputMaybe<HabilitationRcpFilterInput>;
};


export type HabilitationLienConsultantStatutJuridiqueTypeHabilitationArgs = {
  where?: InputMaybe<LienConsultantStatutJuridiqueTypeHabilitationFilterInput>;
};


export type HabilitationProduitArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type HabilitationFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<HabilitationFilterInput>>;
  associationProNom?: InputMaybe<BooleanOperationFilterInput>;
  cifPartenaireCode?: InputMaybe<BooleanOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantHabilitation?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<LocalDateOperationFilterInput>;
  dateFin?: InputMaybe<LocalDateOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  garantAdresse?: InputMaybe<BooleanOperationFilterInput>;
  garantNom?: InputMaybe<BooleanOperationFilterInput>;
  habilitationInscription?: InputMaybe<ListFilterInputTypeOfHabilitationInscriptionFilterInput>;
  habilitationRcp?: InputMaybe<ListFilterInputTypeOfHabilitationRcpFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  lienConsultantStatutJuridiqueTypeHabilitation?: InputMaybe<ListFilterInputTypeOfLienConsultantStatutJuridiqueTypeHabilitationFilterInput>;
  mediateur?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<HabilitationFilterInput>>;
  origineHabilitation?: InputMaybe<StringOperationFilterInput>;
  partenaireCourtierFinancement1?: InputMaybe<BooleanOperationFilterInput>;
  partenaireCourtierFinancement2?: InputMaybe<BooleanOperationFilterInput>;
  produit?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

export type HabilitationInfo = {
  __typename?: 'HabilitationInfo';
  habilitation?: Maybe<ConsultantHabilitation>;
  habilitationId: Scalars['Long']['output'];
  statutChangeReasons: Array<ConsultantHabilitationStatutChangeReasonEnum>;
};


export type HabilitationInfoStatutChangeReasonsArgs = {
  where?: InputMaybe<ConsultantHabilitationStatutChangeReasonEnumOperationFilterInput>;
};

export type HabilitationInscription = {
  __typename?: 'HabilitationInscription';
  actif: Scalars['Boolean']['output'];
  dateAnniversaire?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  dateFinFixe?: Maybe<Scalars['DateTime']['output']>;
  dureeValidite?: Maybe<Scalars['Int']['output']>;
  habilitation?: Maybe<Habilitation>;
  habilitationId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  obligatoire?: Maybe<Scalars['Boolean']['output']>;
  organismeDefautCode?: Maybe<Scalars['String']['output']>;
  organismeDefautCodeNavigation?: Maybe<Organisme>;
};

export type HabilitationInscriptionCategorie = {
  __typename?: 'HabilitationInscriptionCategorie';
  code?: Maybe<Scalars['String']['output']>;
  consultantHabilitationInscriptionCategorie: Array<ConsultantHabilitationInscriptionCategorie>;
  id: Scalars['Int']['output'];
  libelle?: Maybe<Scalars['String']['output']>;
  mandataire?: Maybe<Scalars['String']['output']>;
};


export type HabilitationInscriptionCategorieConsultantHabilitationInscriptionCategorieArgs = {
  where?: InputMaybe<ConsultantHabilitationInscriptionCategorieFilterInput>;
};

export type HabilitationInscriptionCategorieFilterInput = {
  and?: InputMaybe<Array<HabilitationInscriptionCategorieFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantHabilitationInscriptionCategorie?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInscriptionCategorieFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  mandataire?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<HabilitationInscriptionCategorieFilterInput>>;
};

export type HabilitationInscriptionFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<HabilitationInscriptionFilterInput>>;
  dateAnniversaire?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinFixe?: InputMaybe<DateTimeOperationFilterInput>;
  dureeValidite?: InputMaybe<IntOperationFilterInput>;
  habilitation?: InputMaybe<HabilitationFilterInput>;
  habilitationId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  obligatoire?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<HabilitationInscriptionFilterInput>>;
  organismeDefautCode?: InputMaybe<StringOperationFilterInput>;
};

export type HabilitationRcp = {
  __typename?: 'HabilitationRcp';
  actif?: Maybe<Scalars['Boolean']['output']>;
  dateAnniversaire?: Maybe<Scalars['DateTime']['output']>;
  habilitation: Habilitation;
  habilitationId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  obligatoire?: Maybe<Scalars['Boolean']['output']>;
  typeRcpCode: Scalars['String']['output'];
  typeRcpCodeNavigation: TypeRcp;
};

export type HabilitationRcpFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<HabilitationRcpFilterInput>>;
  dateAnniversaire?: InputMaybe<DateTimeOperationFilterInput>;
  habilitation?: InputMaybe<HabilitationFilterInput>;
  habilitationId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  obligatoire?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<HabilitationRcpFilterInput>>;
  typeRcpCode?: InputMaybe<StringOperationFilterInput>;
};

export type HabilitationSortInput = {
  actif?: InputMaybe<SortEnumType>;
  associationProNom?: InputMaybe<SortEnumType>;
  cifPartenaireCode?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateDebut?: InputMaybe<SortEnumType>;
  dateFin?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  garantAdresse?: InputMaybe<SortEnumType>;
  garantNom?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  mediateur?: InputMaybe<SortEnumType>;
  origineHabilitation?: InputMaybe<SortEnumType>;
  partenaireCourtierFinancement1?: InputMaybe<SortEnumType>;
  partenaireCourtierFinancement2?: InputMaybe<SortEnumType>;
};

export type HabilitationStatusOverrideInput = {
  consultantHabilitationId: Scalars['Long']['input'];
  consultantHabilitationTempStatut: Scalars['Boolean']['input'];
  dateEcheance?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HabilitationStatusStopOverrideInput = {
  consultantHabilitationId: Scalars['Long']['input'];
};

export type HorizonPlacement = {
  __typename?: 'HorizonPlacement';
  horizonRetraite?: Maybe<Scalars['Decimal']['output']>;
  justification?: Maybe<Scalars['String']['output']>;
  value?: Maybe<HorizonPlacementEnum>;
};

export enum HorizonPlacementEnum {
  De0A3Ans = 'DE0A3ANS',
  De3A5Ans = 'DE3A5ANS',
  De5A8Ans = 'DE5A8ANS',
  De8A10Ans = 'DE8A10ANS',
  Retraite = 'RETRAITE',
  Sup10Ans = 'SUP10ANS'
}

export type HorizonPlacementFilterInput = {
  and?: InputMaybe<Array<HorizonPlacementFilterInput>>;
  horizonRetraite?: InputMaybe<DecimalOperationFilterInput>;
  justification?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<HorizonPlacementFilterInput>>;
  value?: InputMaybe<NullableOfHorizonPlacementEnumOperationFilterInput>;
};

export type HorizonPlacementInput = {
  horizonRetraite?: InputMaybe<Scalars['Decimal']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<HorizonPlacementEnum>;
};

export enum ImpactDiminutionFraisEnum {
  PointValeur = 'POINT_VALEUR',
  RemunerationPersonnelle = 'REMUNERATION_PERSONNELLE'
}

export type ImportConsultant = {
  __typename?: 'ImportConsultant';
  activeConsultantMigrationJob?: Maybe<ConsultantMigrationJob>;
  activeConsultantMigrationJobId?: Maybe<Scalars['Long']['output']>;
  activeWaveMigrationJob?: Maybe<WaveMigrationJob>;
  activeWaveMigrationJobId?: Maybe<Scalars['Long']['output']>;
  code: Scalars['String']['output'];
  consultantMigrationJobs?: Maybe<Array<ConsultantMigrationJob>>;
  galaxy?: Maybe<ImportGalaxy>;
  galaxyId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  investisseurs?: Maybe<Array<ImportInvestisseur>>;
  waveMigrationJobs?: Maybe<Array<ImportConsultantWaveMigrationJob>>;
};


export type ImportConsultantConsultantMigrationJobsArgs = {
  where?: InputMaybe<ConsultantMigrationJobFilterInput>;
};


export type ImportConsultantInvestisseursArgs = {
  where?: InputMaybe<ImportInvestisseurFilterInput>;
};


export type ImportConsultantWaveMigrationJobsArgs = {
  where?: InputMaybe<ImportConsultantWaveMigrationJobFilterInput>;
};

/** A segment of a collection. */
export type ImportConsultantCollectionSegment = {
  __typename?: 'ImportConsultantCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ImportConsultant>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportConsultantFilterInput = {
  activeConsultantMigrationJob?: InputMaybe<ConsultantMigrationJobFilterInput>;
  activeConsultantMigrationJobId?: InputMaybe<LongOperationFilterInput>;
  activeWaveMigrationJob?: InputMaybe<WaveMigrationJobFilterInput>;
  activeWaveMigrationJobId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<ImportConsultantFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantMigrationJobs?: InputMaybe<ListFilterInputTypeOfConsultantMigrationJobFilterInput>;
  galaxy?: InputMaybe<ImportGalaxyFilterInput>;
  galaxyId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseurs?: InputMaybe<ListFilterInputTypeOfImportInvestisseurFilterInput>;
  or?: InputMaybe<Array<ImportConsultantFilterInput>>;
  waveMigrationJobs?: InputMaybe<ListFilterInputTypeOfImportConsultantWaveMigrationJobFilterInput>;
};

export type ImportConsultantSortInput = {
  activeConsultantMigrationJob?: InputMaybe<ConsultantMigrationJobSortInput>;
  activeConsultantMigrationJobId?: InputMaybe<SortEnumType>;
  activeWaveMigrationJob?: InputMaybe<WaveMigrationJobSortInput>;
  activeWaveMigrationJobId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  galaxy?: InputMaybe<ImportGalaxySortInput>;
  galaxyId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type ImportConsultantWaveMigrationJob = {
  __typename?: 'ImportConsultantWaveMigrationJob';
  consultant: ImportConsultant;
  consultantsId: Scalars['Long']['output'];
  waveMigrationJob: WaveMigrationJob;
  waveMigrationJobId: Scalars['Long']['output'];
};

export type ImportConsultantWaveMigrationJobFilterInput = {
  and?: InputMaybe<Array<ImportConsultantWaveMigrationJobFilterInput>>;
  consultant?: InputMaybe<ImportConsultantFilterInput>;
  consultantsId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ImportConsultantWaveMigrationJobFilterInput>>;
  waveMigrationJob?: InputMaybe<WaveMigrationJobFilterInput>;
  waveMigrationJobId?: InputMaybe<LongOperationFilterInput>;
};

export type ImportGalaxy = {
  __typename?: 'ImportGalaxy';
  activeGalaxyMigrationJob?: Maybe<GalaxyMigrationJob>;
  activeGalaxyMigrationJobId?: Maybe<Scalars['Long']['output']>;
  activeWaveMigrationJob?: Maybe<WaveMigrationJob>;
  activeWaveMigrationJobId?: Maybe<Scalars['Long']['output']>;
  galaxyMigrationJobs?: Maybe<Array<GalaxyMigrationJob>>;
  id: Scalars['Long']['output'];
  waveMigrationJobs?: Maybe<Array<ImportGalaxyWaveMigrationJob>>;
};


export type ImportGalaxyGalaxyMigrationJobsArgs = {
  where?: InputMaybe<GalaxyMigrationJobFilterInput>;
};


export type ImportGalaxyWaveMigrationJobsArgs = {
  where?: InputMaybe<ImportGalaxyWaveMigrationJobFilterInput>;
};

/** A segment of a collection. */
export type ImportGalaxyCollectionSegment = {
  __typename?: 'ImportGalaxyCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ImportGalaxy>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportGalaxyFilterInput = {
  activeGalaxyMigrationJob?: InputMaybe<GalaxyMigrationJobFilterInput>;
  activeGalaxyMigrationJobId?: InputMaybe<LongOperationFilterInput>;
  activeWaveMigrationJob?: InputMaybe<WaveMigrationJobFilterInput>;
  activeWaveMigrationJobId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<ImportGalaxyFilterInput>>;
  galaxyMigrationJobs?: InputMaybe<ListFilterInputTypeOfGalaxyMigrationJobFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ImportGalaxyFilterInput>>;
  waveMigrationJobs?: InputMaybe<ListFilterInputTypeOfImportGalaxyWaveMigrationJobFilterInput>;
};

export type ImportGalaxySortInput = {
  activeGalaxyMigrationJob?: InputMaybe<GalaxyMigrationJobSortInput>;
  activeGalaxyMigrationJobId?: InputMaybe<SortEnumType>;
  activeWaveMigrationJob?: InputMaybe<WaveMigrationJobSortInput>;
  activeWaveMigrationJobId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type ImportGalaxyWaveMigrationJob = {
  __typename?: 'ImportGalaxyWaveMigrationJob';
  galaxiesId: Scalars['Long']['output'];
  galaxy: ImportGalaxy;
  waveMigrationJob: WaveMigrationJob;
  waveMigrationJobId: Scalars['Long']['output'];
};

export type ImportGalaxyWaveMigrationJobFilterInput = {
  and?: InputMaybe<Array<ImportGalaxyWaveMigrationJobFilterInput>>;
  galaxiesId?: InputMaybe<LongOperationFilterInput>;
  galaxy?: InputMaybe<ImportGalaxyFilterInput>;
  or?: InputMaybe<Array<ImportGalaxyWaveMigrationJobFilterInput>>;
  waveMigrationJob?: InputMaybe<WaveMigrationJobFilterInput>;
  waveMigrationJobId?: InputMaybe<LongOperationFilterInput>;
};

/** historique des imports Ariane */
export type ImportHistory = {
  __typename?: 'ImportHistory';
  arianeDataJsonDump?: Maybe<Scalars['String']['output']>;
  atlasDataJsonDump?: Maybe<Scalars['String']['output']>;
  consultant?: Maybe<Consultant>;
  consultantId?: Maybe<Scalars['Long']['output']>;
  date: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  isLatestVersion?: Maybe<Scalars['Boolean']['output']>;
  isPreImport: Scalars['Boolean']['output'];
  logs: Array<ImportLog>;
  processJobId?: Maybe<Scalars['Long']['output']>;
  status: ImportStatus;
  waveJobId?: Maybe<Scalars['Long']['output']>;
};


/** historique des imports Ariane */
export type ImportHistoryLogsArgs = {
  where?: InputMaybe<ImportLogFilterInput>;
};

/** historique des imports Ariane */
export type ImportHistoryFilterInput = {
  and?: InputMaybe<Array<ImportHistoryFilterInput>>;
  arianeDataJsonDump?: InputMaybe<StringOperationFilterInput>;
  atlasDataJsonDump?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<MinotaureConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<MinotaureInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  isLatestVersion?: InputMaybe<BooleanOperationFilterInput>;
  isPreImport?: InputMaybe<BooleanOperationFilterInput>;
  logs?: InputMaybe<ListFilterInputTypeOfImportLogFilterInput>;
  or?: InputMaybe<Array<ImportHistoryFilterInput>>;
  processJobId?: InputMaybe<LongOperationFilterInput>;
  status?: InputMaybe<ImportStatusOperationFilterInput>;
  waveJobId?: InputMaybe<LongOperationFilterInput>;
};

export type ImportInvestisseur = {
  __typename?: 'ImportInvestisseur';
  activeInvestisseurDumpJob?: Maybe<ArianeDumpJob>;
  activeInvestisseurDumpJobId?: Maybe<Scalars['Long']['output']>;
  activeInvestisseurProcessJob?: Maybe<ArianeProcessJob>;
  activeInvestisseurProcessJobId?: Maybe<Scalars['Long']['output']>;
  arianeId?: Maybe<Scalars['Long']['output']>;
  consultant?: Maybe<ImportConsultant>;
  consultantId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
};

export type ImportInvestisseurFilterInput = {
  activeInvestisseurDumpJob?: InputMaybe<ArianeDumpJobFilterInput>;
  activeInvestisseurDumpJobId?: InputMaybe<LongOperationFilterInput>;
  activeInvestisseurProcessJob?: InputMaybe<ArianeProcessJobFilterInput>;
  activeInvestisseurProcessJobId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<ImportInvestisseurFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  consultant?: InputMaybe<ImportConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ImportInvestisseurFilterInput>>;
};

export type ImportInvestisseurSortInput = {
  activeInvestisseurDumpJob?: InputMaybe<ArianeDumpJobSortInput>;
  activeInvestisseurDumpJobId?: InputMaybe<SortEnumType>;
  activeInvestisseurProcessJob?: InputMaybe<ArianeProcessJobSortInput>;
  activeInvestisseurProcessJobId?: InputMaybe<SortEnumType>;
  arianeId?: InputMaybe<SortEnumType>;
  consultant?: InputMaybe<ImportConsultantSortInput>;
  consultantId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ImportInvestisseursCollectionSegment = {
  __typename?: 'ImportInvestisseursCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ImportInvestisseur>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** log d'import Ariane */
export type ImportLog = {
  __typename?: 'ImportLog';
  history: ImportHistory;
  id: Scalars['Long']['output'];
  importHistoryId: Scalars['Long']['output'];
  /** Identifiant optionnel du log */
  logIdentifier?: Maybe<Scalars['String']['output']>;
  logLevel: ImportLogLevel;
  message: Scalars['String']['output'];
};

/** log d'import Ariane */
export type ImportLogFilterInput = {
  and?: InputMaybe<Array<ImportLogFilterInput>>;
  history?: InputMaybe<ImportHistoryFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  importHistoryId?: InputMaybe<LongOperationFilterInput>;
  /** Identifiant optionnel du log */
  logIdentifier?: InputMaybe<StringOperationFilterInput>;
  logLevel?: InputMaybe<ImportLogLevelOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ImportLogFilterInput>>;
};

export enum ImportLogLevel {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type ImportLogLevelOperationFilterInput = {
  eq?: InputMaybe<ImportLogLevel>;
  in?: InputMaybe<Array<ImportLogLevel>>;
  neq?: InputMaybe<ImportLogLevel>;
  nin?: InputMaybe<Array<ImportLogLevel>>;
};

/** A segment of a collection. */
export type ImportLogsCollectionSegment = {
  __typename?: 'ImportLogsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ArianeImportLog>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ImportStatus {
  Error = 'ERROR',
  Success = 'SUCCESS',
  SuccessWithWarnings = 'SUCCESS_WITH_WARNINGS'
}

export type ImportStatusOperationFilterInput = {
  eq?: InputMaybe<ImportStatus>;
  in?: InputMaybe<Array<ImportStatus>>;
  neq?: InputMaybe<ImportStatus>;
  nin?: InputMaybe<Array<ImportStatus>>;
};

export type InscriptionCycleCourt = {
  __typename?: 'InscriptionCycleCourt';
  codeEtat?: Maybe<Scalars['Byte']['output']>;
  codeEtatNavigation?: Maybe<FormationEtat>;
  codeMotifAbandon?: Maybe<Scalars['Byte']['output']>;
  codeMotifAbandonNavigation?: Maybe<FormationMotifAbandon>;
  codeNature?: Maybe<Scalars['Byte']['output']>;
  codeNatureNavigation?: Maybe<FormationNature>;
  codeOrigine?: Maybe<Scalars['String']['output']>;
  codeOrigineNavigation?: Maybe<FormationOrigine>;
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  cycleCourt?: Maybe<CycleCourt>;
  cycleCourtId?: Maybe<Scalars['Long']['output']>;
  dateAbandon?: Maybe<Scalars['DateTime']['output']>;
  dateDebutElearning?: Maybe<Scalars['DateTime']['output']>;
  dateFacture?: Maybe<Scalars['DateTime']['output']>;
  dateInscription?: Maybe<Scalars['DateTime']['output']>;
  dateValidationQCM?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  formationValide?: Maybe<Scalars['Byte']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  montantFacture?: Maybe<Scalars['Decimal']['output']>;
  numeroFacture?: Maybe<Scalars['String']['output']>;
};

export type InscriptionCycleCourtFilterInput = {
  and?: InputMaybe<Array<InscriptionCycleCourtFilterInput>>;
  codeEtat?: InputMaybe<ByteOperationFilterInput>;
  codeEtatNavigation?: InputMaybe<FormationEtatFilterInput>;
  codeMotifAbandon?: InputMaybe<ByteOperationFilterInput>;
  codeMotifAbandonNavigation?: InputMaybe<FormationMotifAbandonFilterInput>;
  codeNature?: InputMaybe<ByteOperationFilterInput>;
  codeNatureNavigation?: InputMaybe<FormationNatureFilterInput>;
  codeOrigine?: InputMaybe<StringOperationFilterInput>;
  codeOrigineNavigation?: InputMaybe<FormationOrigineFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cycleCourt?: InputMaybe<CycleCourtFilterInput>;
  cycleCourtId?: InputMaybe<LongOperationFilterInput>;
  dateAbandon?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebutElearning?: InputMaybe<DateTimeOperationFilterInput>;
  dateFacture?: InputMaybe<DateTimeOperationFilterInput>;
  dateInscription?: InputMaybe<DateTimeOperationFilterInput>;
  dateValidationQCM?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  formationValide?: InputMaybe<ByteOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  montantFacture?: InputMaybe<DecimalOperationFilterInput>;
  numeroFacture?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InscriptionCycleCourtFilterInput>>;
};

export type InscriptionImmoInput = {
  dateDebut: Scalars['DateTime']['input'];
  dateDepot: Scalars['DateTime']['input'];
  dateFin: Scalars['DateTime']['input'];
  idStatutJuridique: Scalars['Long']['input'];
  numeroCarteT?: InputMaybe<Scalars['String']['input']>;
  organisme: Scalars['String']['input'];
};

export type InscriptionSession = {
  __typename?: 'InscriptionSession';
  codeEtat?: Maybe<Scalars['Byte']['output']>;
  codeEtatNavigation?: Maybe<FormationEtat>;
  codeNature?: Maybe<Scalars['Byte']['output']>;
  codeNatureNavigation?: Maybe<FormationNature>;
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateInscription?: Maybe<Scalars['DateTime']['output']>;
  dateValidationFormation?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  formationValide?: Maybe<Scalars['Byte']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  session?: Maybe<Session>;
  sessionId?: Maybe<Scalars['Long']['output']>;
};

export type InscriptionSessionFilterInput = {
  and?: InputMaybe<Array<InscriptionSessionFilterInput>>;
  codeEtat?: InputMaybe<ByteOperationFilterInput>;
  codeEtatNavigation?: InputMaybe<FormationEtatFilterInput>;
  codeNature?: InputMaybe<ByteOperationFilterInput>;
  codeNatureNavigation?: InputMaybe<FormationNatureFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateInscription?: InputMaybe<DateTimeOperationFilterInput>;
  dateValidationFormation?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  formationValide?: InputMaybe<ByteOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<InscriptionSessionFilterInput>>;
  session?: InputMaybe<SessionFilterInput>;
  sessionId?: InputMaybe<LongOperationFilterInput>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

/** Intitulé d'une question selon un profil */
export type IntituleParProfilDto = {
  __typename?: 'IntituleParProfilDto';
  intitule: Scalars['String']['output'];
  profil: Scalars['Int']['output'];
};

/** Intitulé d'une question selon un profil */
export type IntituleParProfilDtoFilterInput = {
  and?: InputMaybe<Array<IntituleParProfilDtoFilterInput>>;
  intitule?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IntituleParProfilDtoFilterInput>>;
  profil?: InputMaybe<IntOperationFilterInput>;
};

export type Investisseur = {
  __typename?: 'Investisseur';
  /** Récupère l'ensemble des budgets, en intégrant les crédits et impôts */
  allBudgets?: Maybe<Array<BudgetDto>>;
  arianeId?: Maybe<Scalars['Long']['output']>;
  atlasInvestisseur?: Maybe<AtlasInvestisseur>;
  avancementConnaissanceClientInvestisseur?: Maybe<AvancementConnaissanceClientInvestisseur>;
  bilanFinancier?: Maybe<InvestisseurBilanFinancier>;
  budgetInvestisseurs?: Maybe<Array<BudgetInvestisseur>>;
  /** Calcul de la capacité d'épargne de l'investisseur */
  capaciteEpargne?: Maybe<CapaciteEpargneDetail>;
  capaciteFinanciere?: Maybe<CapaciteFinanciere>;
  cessionHistoInvestisseur: Array<CessionHistoInvestisseur>;
  code: Scalars['String']['output'];
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Le QPI actuellement actif pour l'investisseur */
  currentQPI?: Maybe<InvestisseurQpi>;
  currentQPIId?: Maybe<Scalars['Long']['output']>;
  dateConnaissance?: Maybe<Scalars['LocalDate']['output']>;
  dateDernierScanAccuity?: Maybe<Scalars['LocalDate']['output']>;
  dateEntreeRelation?: Maybe<Scalars['LocalDate']['output']>;
  dateMajScanAccuityRequis?: Maybe<Scalars['LocalDate']['output']>;
  dateModificationFiche?: Maybe<Scalars['DateTime']['output']>;
  dateSuppression?: Maybe<Scalars['DateTime']['output']>;
  detenteurPatrimoineActif: Array<DetenteurPatrimoineActif>;
  detenteurPatrimoineChargeRevenu: Array<DetenteurPatrimoineChargeRevenu>;
  detenteurPatrimoinePassif: Array<DetenteurPatrimoinePassif>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Récupère l'engagement budgetaire de l'investisseur (revenus, credits, charges) */
  engagementBudgetaire?: Maybe<EngagementBudgetaire>;
  /** Récupère les etiquettes de l'investiseur filtrées par le consultant */
  etiquettes?: Maybe<Array<Etiquette>>;
  filesMetadata: Array<FileMetadata>;
  foyerFiscal?: Maybe<FoyerFiscal>;
  foyerFiscalId?: Maybe<Scalars['Long']['output']>;
  gdaBackOffice?: Maybe<Scalars['Boolean']['output']>;
  gerePar: AppReference;
  /** Indique si l'investisseur possède une ligne MyStellium. Un investisseur sans ligne est considéré comme non invité. */
  hasMyStelliumInvestisseur: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  idSourceAramis?: Maybe<Scalars['String']['output']>;
  idSourceDiapason?: Maybe<Scalars['String']['output']>;
  importHistories?: Maybe<Array<ImportHistory>>;
  importInvestisseur?: Maybe<ImportInvestisseur>;
  inverseRecommandePar: Array<Investisseur>;
  investisseurCommande: Array<InvestisseurCommande>;
  investisseurConsultant: Array<InvestisseurConsultant>;
  investisseurConsultantRelations?: Maybe<Array<InvestisseurRelationConsultant>>;
  investisseurEntite?: Maybe<InvestisseurEntite>;
  investisseurEtiquette?: Maybe<Array<InvestisseurEtiquette>>;
  investisseurObjectif: Array<InvestisseurObjectif>;
  investisseurPatrimoines?: Maybe<Array<InvestisseurPatrimoine>>;
  investisseurQpi?: Maybe<InvestisseurQpi>;
  /** Liste de tous les QPI de l'investisseur (historique) */
  investisseurQpis?: Maybe<Array<InvestisseurQpi>>;
  /** boolean to know if the investisseur is active or not (for logical deletion) */
  isActif: Scalars['Boolean']['output'];
  /** is investisseur transfered from Ariane to Minotaure or created directly in Minotaure */
  isTransferedToMinotaure: Scalars['Boolean']['output'];
  logiqueSuppression?: Maybe<Scalars['Boolean']['output']>;
  modeCommunication?: Maybe<Scalars['String']['output']>;
  modeCommunicationNavigation?: Maybe<ModeCommunication>;
  mouvement: Array<Mouvement>;
  /** Compte MyStellium de l'investisseur */
  myStelliumInvestisseur?: Maybe<MyStelliumInvestisseur>;
  note: Array<Note>;
  objectifDefinis?: Maybe<Array<ObjectifDefini>>;
  objectifMontantEpargneMensuel?: Maybe<Scalars['Decimal']['output']>;
  objectifMontantEpargnePrecaution?: Maybe<Scalars['Decimal']['output']>;
  operationInvestisseurs?: Maybe<Array<OperationInvestisseur>>;
  origineContactCode?: Maybe<Scalars['String']['output']>;
  origineContactCodeNavigation?: Maybe<OrigineContact>;
  origineSaisie?: Maybe<Scalars['Byte']['output']>;
  origineSaisieNavigation?: Maybe<OrigineData>;
  patrimoineFiscalite?: Maybe<PatrimoineFiscalite>;
  pendingPurge: Scalars['Boolean']['output'];
  personneMorale: Array<PersonneMorale>;
  personnePhysique: Array<PersonnePhysique>;
  ppeBackOffice?: Maybe<Scalars['Boolean']['output']>;
  profilInvestisseur: Array<ProfilInvestisseur>;
  projetInvestisseurs?: Maybe<Array<ProjetInvestisseur>>;
  recommandePar?: Maybe<Investisseur>;
  recommandeParId?: Maybe<Scalars['Long']['output']>;
  recommandeParNom?: Maybe<Scalars['String']['output']>;
  scanAccuityRequis?: Maybe<Scalars['Boolean']['output']>;
  signedQPI?: Maybe<InvestisseurQpi>;
  /** Le dernier QPI signé et non expiré pour l'investisseur */
  signedQPIId?: Maybe<Scalars['Long']['output']>;
  statutCode: Scalars['String']['output'];
  statutCodeNavigation: TypeStatutInvestisseur;
  syntheseEpargne?: Maybe<SyntheseEpargne>;
  /** Synthèse épargne dénormalisée de l'investisseur, maintenue à jour automatiquement */
  syntheseFinanciere?: Maybe<InvestisseurSyntheseFinanciere>;
  toSyncToAtlas: Scalars['Boolean']['output'];
  type: TypePersonne;
  vueDEnsemble: VueDEnsembleResult;
};


export type InvestisseurBudgetInvestisseursArgs = {
  where?: InputMaybe<BudgetInvestisseurFilterInput>;
};


export type InvestisseurCessionHistoInvestisseurArgs = {
  where?: InputMaybe<CessionHistoInvestisseurFilterInput>;
};


export type InvestisseurDetenteurPatrimoineActifArgs = {
  where?: InputMaybe<DetenteurPatrimoineActifFilterInput>;
};


export type InvestisseurDetenteurPatrimoineChargeRevenuArgs = {
  where?: InputMaybe<DetenteurPatrimoineChargeRevenuFilterInput>;
};


export type InvestisseurDetenteurPatrimoinePassifArgs = {
  where?: InputMaybe<DetenteurPatrimoinePassifFilterInput>;
};


export type InvestisseurImportHistoriesArgs = {
  where?: InputMaybe<ImportHistoryFilterInput>;
};


export type InvestisseurInvestisseurCommandeArgs = {
  where?: InputMaybe<InvestisseurCommandeFilterInput>;
};


export type InvestisseurInvestisseurConsultantArgs = {
  where?: InputMaybe<InvestisseurConsultantFilterInput>;
};


export type InvestisseurInvestisseurEtiquetteArgs = {
  where?: InputMaybe<InvestisseurEtiquetteFilterInput>;
};


export type InvestisseurInvestisseurObjectifArgs = {
  where?: InputMaybe<InvestisseurObjectifFilterInput>;
};


export type InvestisseurInvestisseurPatrimoinesArgs = {
  where?: InputMaybe<InvestisseurPatrimoineFilterInput>;
};


export type InvestisseurInvestisseurQpisArgs = {
  where?: InputMaybe<MinotaureInvestisseurQpiFilterInput>;
};


export type InvestisseurMouvementArgs = {
  where?: InputMaybe<MouvementFilterInput>;
};


export type InvestisseurNoteArgs = {
  where?: InputMaybe<NoteFilterInput>;
};


export type InvestisseurObjectifDefinisArgs = {
  where?: InputMaybe<ObjectifDefiniFilterInput>;
};


export type InvestisseurOperationInvestisseursArgs = {
  where?: InputMaybe<OperationInvestisseurFilterInput>;
};


export type InvestisseurPersonneMoraleArgs = {
  where?: InputMaybe<PersonneMoraleFilterInput>;
};


export type InvestisseurPersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};


export type InvestisseurProfilInvestisseurArgs = {
  where?: InputMaybe<ProfilInvestisseurFilterInput>;
};


export type InvestisseurProjetInvestisseursArgs = {
  where?: InputMaybe<ProjetInvestisseurFilterInput>;
};


export type InvestisseurVueDEnsembleArgs = {
  avecCoInvestisseur?: Scalars['Boolean']['input'];
};

export type InvestisseurAgregation = {
  __typename?: 'InvestisseurAgregation';
  civilite?: Maybe<Scalars['String']['output']>;
  codeInvestisseur: Scalars['String']['output'];
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  dateNaissance?: Maybe<Scalars['LocalDate']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  estPersonnePhysique?: Maybe<Scalars['Boolean']['output']>;
  idInvestisseur?: Maybe<Scalars['Long']['output']>;
  idPersonne: Scalars['String']['output'];
  nom?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  prenomUniformise?: Maybe<Scalars['String']['output']>;
};

export type InvestisseurAgregationFilterInput = {
  and?: InputMaybe<Array<InvestisseurAgregationFilterInput>>;
  civilite?: InputMaybe<StringOperationFilterInput>;
  codeInvestisseur?: InputMaybe<StringOperationFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  dateNaissance?: InputMaybe<LocalDateOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  estPersonnePhysique?: InputMaybe<BooleanOperationFilterInput>;
  idInvestisseur?: InputMaybe<LongOperationFilterInput>;
  idPersonne?: InputMaybe<StringOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurAgregationFilterInput>>;
  prenom?: InputMaybe<StringOperationFilterInput>;
  prenomUniformise?: InputMaybe<StringOperationFilterInput>;
};

export type InvestisseurAgregationSortInput = {
  civilite?: InputMaybe<SortEnumType>;
  codeInvestisseur?: InputMaybe<SortEnumType>;
  dateChargement?: InputMaybe<SortEnumType>;
  dateNaissance?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  estPersonnePhysique?: InputMaybe<SortEnumType>;
  idInvestisseur?: InputMaybe<SortEnumType>;
  idPersonne?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
  prenom?: InputMaybe<SortEnumType>;
  prenomUniformise?: InputMaybe<SortEnumType>;
};

export type InvestisseurArianeUpdaterInput = {
  arianeId: Scalars['Long']['input'];
  code: Scalars['String']['input'];
  emailArianeId?: InputMaybe<Scalars['Long']['input']>;
  telephoneArianeId?: InputMaybe<Scalars['Long']['input']>;
};

export type InvestisseurBilanFinancier = {
  __typename?: 'InvestisseurBilanFinancier';
  aCreditEnCours: Scalars['Boolean']['output'];
  computedActif: Scalars['Decimal']['output'];
  computedCharges: Scalars['Decimal']['output'];
  computedPassif: Scalars['Decimal']['output'];
  computedPrevoyance: Scalars['Decimal']['output'];
  computedRevenus: Scalars['Decimal']['output'];
  dateProchaineEcheance?: Maybe<Scalars['DateTime']['output']>;
  effectiveActif: Scalars['Decimal']['output'];
  effectiveCharges: Scalars['Decimal']['output'];
  effectivePassif: Scalars['Decimal']['output'];
  effectivePrevoyance: Scalars['Decimal']['output'];
  effectiveRevenus: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  investisseur?: Maybe<Investisseur>;
  investisseurId: Scalars['Long']['output'];
  manuelActif: Scalars['Decimal']['output'];
  manuelCharges: Scalars['Decimal']['output'];
  manuelPassif: Scalars['Decimal']['output'];
  manuelPrevoyance: Scalars['Decimal']['output'];
  manuelRevenus: Scalars['Decimal']['output'];
};

export type InvestisseurBilanFinancierFilterInput = {
  aCreditEnCours?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<InvestisseurBilanFinancierFilterInput>>;
  computedActif?: InputMaybe<DecimalOperationFilterInput>;
  computedCharges?: InputMaybe<DecimalOperationFilterInput>;
  computedPassif?: InputMaybe<DecimalOperationFilterInput>;
  computedPrevoyance?: InputMaybe<DecimalOperationFilterInput>;
  computedRevenus?: InputMaybe<DecimalOperationFilterInput>;
  dateProchaineEcheance?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveActif?: InputMaybe<DecimalOperationFilterInput>;
  effectiveCharges?: InputMaybe<DecimalOperationFilterInput>;
  effectivePassif?: InputMaybe<DecimalOperationFilterInput>;
  effectivePrevoyance?: InputMaybe<DecimalOperationFilterInput>;
  effectiveRevenus?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  investisseur?: InputMaybe<MinotaureInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  manuelActif?: InputMaybe<DecimalOperationFilterInput>;
  manuelCharges?: InputMaybe<DecimalOperationFilterInput>;
  manuelPassif?: InputMaybe<DecimalOperationFilterInput>;
  manuelPrevoyance?: InputMaybe<DecimalOperationFilterInput>;
  manuelRevenus?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurBilanFinancierFilterInput>>;
};

export type InvestisseurBilanFinancierSortInput = {
  aCreditEnCours?: InputMaybe<SortEnumType>;
  computedActif?: InputMaybe<SortEnumType>;
  computedCharges?: InputMaybe<SortEnumType>;
  computedPassif?: InputMaybe<SortEnumType>;
  computedPrevoyance?: InputMaybe<SortEnumType>;
  computedRevenus?: InputMaybe<SortEnumType>;
  dateProchaineEcheance?: InputMaybe<SortEnumType>;
  effectiveActif?: InputMaybe<SortEnumType>;
  effectiveCharges?: InputMaybe<SortEnumType>;
  effectivePassif?: InputMaybe<SortEnumType>;
  effectivePrevoyance?: InputMaybe<SortEnumType>;
  effectiveRevenus?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<MinotaureInvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  manuelActif?: InputMaybe<SortEnumType>;
  manuelCharges?: InputMaybe<SortEnumType>;
  manuelPassif?: InputMaybe<SortEnumType>;
  manuelPrevoyance?: InputMaybe<SortEnumType>;
  manuelRevenus?: InputMaybe<SortEnumType>;
};

export type InvestisseurCommande = {
  __typename?: 'InvestisseurCommande';
  commande: Commande;
  commandeId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  investisseur?: Maybe<Investisseur>;
  investisseurId?: Maybe<Scalars['Long']['output']>;
  ordre: Scalars['Byte']['output'];
};

export type InvestisseurCommandeFilterInput = {
  and?: InputMaybe<Array<InvestisseurCommandeFilterInput>>;
  commande?: InputMaybe<CommandeFilterInput>;
  commandeId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurCommandeFilterInput>>;
  ordre?: InputMaybe<ByteOperationFilterInput>;
};

export type InvestisseurConsultant = {
  __typename?: 'InvestisseurConsultant';
  actif: Scalars['Int']['output'];
  arianeId?: Maybe<Scalars['Long']['output']>;
  batchDateUpdate?: Maybe<Scalars['DateTime']['output']>;
  consultant?: Maybe<Consultant>;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateActivation: Scalars['DateTime']['output'];
  dateDesactivation?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  typeRelationInvestisseurConsultantCode: Scalars['String']['output'];
  typeRelationInvestisseurConsultantCodeNavigation: TypeRelationInvestisseurConsultant;
};

export type InvestisseurConsultantFilterInput = {
  actif?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<InvestisseurConsultantFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  batchDateUpdate?: InputMaybe<DateTimeOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateActivation?: InputMaybe<DateTimeOperationFilterInput>;
  dateDesactivation?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurConsultantFilterInput>>;
  typeRelationInvestisseurConsultantCode?: InputMaybe<StringOperationFilterInput>;
  typeRelationInvestisseurConsultantCodeNavigation?: InputMaybe<TypeRelationInvestisseurConsultantFilterInput>;
};

/** A segment of a collection. */
export type InvestisseurConsultantPaginatedCollectionSegment = {
  __typename?: 'InvestisseurConsultantPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<InvestisseurConsultant>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvestisseurConsultantSortInput = {
  actif?: InputMaybe<SortEnumType>;
  arianeId?: InputMaybe<SortEnumType>;
  batchDateUpdate?: InputMaybe<SortEnumType>;
  consultant?: InputMaybe<ConsultantSortInput>;
  consultantId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateActivation?: InputMaybe<SortEnumType>;
  dateDesactivation?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  typeRelationInvestisseurConsultantCode?: InputMaybe<SortEnumType>;
  typeRelationInvestisseurConsultantCodeNavigation?: InputMaybe<TypeRelationInvestisseurConsultantSortInput>;
};

export type InvestisseurContactInput = {
  civilite?: InputMaybe<Scalars['String']['input']>;
  consultantApporteurAffaireId?: InputMaybe<Scalars['Long']['input']>;
  consultantPrincipalId?: InputMaybe<Scalars['Long']['input']>;
  dateNaissance: Scalars['DateTime']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  nom: Scalars['String']['input'];
  origineSaisie: Scalars['Byte']['input'];
  prenom: Scalars['String']['input'];
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type InvestisseurCreationArianeUpdateInput = {
  investisseur1: InvestisseurArianeUpdaterInput;
  investisseur2?: InputMaybe<InvestisseurArianeUpdaterInput>;
  relationArianeId?: InputMaybe<Scalars['Long']['input']>;
};

export type InvestisseurCreationInput = {
  investisseur1: InvestisseurContactInput;
  investisseur2?: InputMaybe<InvestisseurContactInput>;
  investisseur2Id?: InputMaybe<Scalars['Long']['input']>;
  typeRelationCode?: InputMaybe<Scalars['String']['input']>;
};

export type InvestisseurEntite = {
  __typename?: 'InvestisseurEntite';
  code: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  personneMorale?: Maybe<PersonneMorale>;
  personnePhysique?: Maybe<PersonnePhysique>;
  type: InvestisseurType;
};

export type InvestisseurEtiquette = {
  __typename?: 'InvestisseurEtiquette';
  etiquette: Etiquette;
  etiquetteId: Scalars['Long']['output'];
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
};

export type InvestisseurEtiquetteFilterInput = {
  and?: InputMaybe<Array<InvestisseurEtiquetteFilterInput>>;
  etiquette?: InputMaybe<EtiquetteFilterInput>;
  etiquetteId?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<MinotaureInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurEtiquetteFilterInput>>;
};

export type InvestisseurFilterInput = {
  and?: InputMaybe<Array<InvestisseurFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  cessionHistoInvestisseur?: InputMaybe<ListFilterInputTypeOfCessionHistoInvestisseurFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateConnaissance?: InputMaybe<LocalDateOperationFilterInput>;
  dateDernierScanAccuity?: InputMaybe<LocalDateOperationFilterInput>;
  dateEntreeRelation?: InputMaybe<LocalDateOperationFilterInput>;
  dateMajScanAccuityRequis?: InputMaybe<LocalDateOperationFilterInput>;
  dateSuppression?: InputMaybe<DateTimeOperationFilterInput>;
  detenteurPatrimoineActif?: InputMaybe<ListFilterInputTypeOfDetenteurPatrimoineActifFilterInput>;
  detenteurPatrimoineChargeRevenu?: InputMaybe<ListFilterInputTypeOfDetenteurPatrimoineChargeRevenuFilterInput>;
  detenteurPatrimoinePassif?: InputMaybe<ListFilterInputTypeOfDetenteurPatrimoinePassifFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  gdaBackOffice?: InputMaybe<BooleanOperationFilterInput>;
  gerePar?: InputMaybe<AppReferenceOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSourceAramis?: InputMaybe<StringOperationFilterInput>;
  idSourceDiapason?: InputMaybe<StringOperationFilterInput>;
  inverseRecommandePar?: InputMaybe<ListFilterInputTypeOfInvestisseurFilterInput>;
  investisseurCommande?: InputMaybe<ListFilterInputTypeOfInvestisseurCommandeFilterInput>;
  investisseurConsultant?: InputMaybe<ListFilterInputTypeOfInvestisseurConsultantFilterInput>;
  investisseurObjectif?: InputMaybe<ListFilterInputTypeOfInvestisseurObjectifFilterInput>;
  investisseurQpi?: InputMaybe<InvestisseurQpiFilterInput>;
  logiqueSuppression?: InputMaybe<BooleanOperationFilterInput>;
  modeCommunication?: InputMaybe<StringOperationFilterInput>;
  modeCommunicationNavigation?: InputMaybe<ModeCommunicationFilterInput>;
  mouvement?: InputMaybe<ListFilterInputTypeOfMouvementFilterInput>;
  note?: InputMaybe<ListFilterInputTypeOfNoteFilterInput>;
  objectifMontantEpargneMensuel?: InputMaybe<DecimalOperationFilterInput>;
  objectifMontantEpargnePrecaution?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurFilterInput>>;
  origineContactCode?: InputMaybe<StringOperationFilterInput>;
  origineContactCodeNavigation?: InputMaybe<OrigineContactFilterInput>;
  origineSaisie?: InputMaybe<ByteOperationFilterInput>;
  origineSaisieNavigation?: InputMaybe<OrigineDataFilterInput>;
  patrimoineFiscalite?: InputMaybe<PatrimoineFiscaliteFilterInput>;
  personneMorale?: InputMaybe<ListFilterInputTypeOfPersonneMoraleFilterInput>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  ppeBackOffice?: InputMaybe<BooleanOperationFilterInput>;
  profilInvestisseur?: InputMaybe<ListFilterInputTypeOfProfilInvestisseurFilterInput>;
  recommandePar?: InputMaybe<InvestisseurFilterInput>;
  recommandeParId?: InputMaybe<LongOperationFilterInput>;
  recommandeParNom?: InputMaybe<StringOperationFilterInput>;
  scanAccuityRequis?: InputMaybe<BooleanOperationFilterInput>;
  statutCode?: InputMaybe<StringOperationFilterInput>;
  statutCodeNavigation?: InputMaybe<TypeStatutInvestisseurFilterInput>;
};

export type InvestisseurInput = {
  dateNaissance?: InputMaybe<Scalars['DateTime']['input']>;
  detentionNP?: InputMaybe<Scalars['Decimal']['input']>;
  detentionPP?: InputMaybe<Scalars['Decimal']['input']>;
  detentionUS?: InputMaybe<Scalars['Decimal']['input']>;
  investisseurId?: InputMaybe<Scalars['Long']['input']>;
  quotePartADI?: InputMaybe<Scalars['Decimal']['input']>;
  typeDetenteur?: InputMaybe<TypeDetenteurEnum>;
};

export type InvestisseurObjectif = {
  __typename?: 'InvestisseurObjectif';
  arianeId?: Maybe<Scalars['Long']['output']>;
  commun?: Maybe<Scalars['UUID']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  horizonDelais?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Long']['output'];
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  montant?: Maybe<Scalars['Decimal']['output']>;
  precisions?: Maybe<Scalars['String']['output']>;
  priorite: Scalars['Int']['output'];
  typeObjectifInvestisseurCode: Scalars['String']['output'];
  typeObjectifInvestisseurCodeNavigation: TypeObjectifInvestisseur;
};

export type InvestisseurObjectifData = {
  __typename?: 'InvestisseurObjectifData';
  categorieCode?: Maybe<Scalars['String']['output']>;
  categorieLibelle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSelected: Scalars['Boolean']['output'];
  objectifCode?: Maybe<Scalars['String']['output']>;
  objectifLibelle: Scalars['String']['output'];
};

export type InvestisseurObjectifDataFilterInput = {
  and?: InputMaybe<Array<InvestisseurObjectifDataFilterInput>>;
  categorieCode?: InputMaybe<StringOperationFilterInput>;
  categorieLibelle?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isSelected?: InputMaybe<BooleanOperationFilterInput>;
  objectifCode?: InputMaybe<StringOperationFilterInput>;
  objectifLibelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurObjectifDataFilterInput>>;
};

export type InvestisseurObjectifDataInput = {
  categorieCode?: InputMaybe<Scalars['String']['input']>;
  categorieLibelle: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isSelected: Scalars['Boolean']['input'];
  objectifCode?: InputMaybe<Scalars['String']['input']>;
  objectifLibelle: Scalars['String']['input'];
};

export type InvestisseurObjectifFilterInput = {
  and?: InputMaybe<Array<InvestisseurObjectifFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  commun?: InputMaybe<UuidOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  horizonDelais?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  montant?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurObjectifFilterInput>>;
  precisions?: InputMaybe<StringOperationFilterInput>;
  priorite?: InputMaybe<IntOperationFilterInput>;
  typeObjectifInvestisseurCode?: InputMaybe<StringOperationFilterInput>;
  typeObjectifInvestisseurCodeNavigation?: InputMaybe<TypeObjectifInvestisseurFilterInput>;
};

export type InvestisseurObjectifSortInput = {
  arianeId?: InputMaybe<SortEnumType>;
  commun?: InputMaybe<SortEnumType>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  horizonDelais?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  montant?: InputMaybe<SortEnumType>;
  precisions?: InputMaybe<SortEnumType>;
  priorite?: InputMaybe<SortEnumType>;
  typeObjectifInvestisseurCode?: InputMaybe<SortEnumType>;
  typeObjectifInvestisseurCodeNavigation?: InputMaybe<TypeObjectifInvestisseurSortInput>;
};

export type InvestisseurOperationData = {
  __typename?: 'InvestisseurOperationData';
  civiliteCode?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateNaissance?: Maybe<Scalars['LocalDate']['output']>;
  denomination?: Maybe<Scalars['String']['output']>;
  /** DER complété lors de la dernière actualisation de la connaissance client de l'opération. Null si l'information n'était pas disponible. */
  derComplete?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  nom?: Maybe<Scalars['String']['output']>;
  /** Instant UTC auquel les états DER, recueil et QPI ont été copiés dans la connaissance client de l'opération. Null si aucune observation n'a été enregistrée. */
  observedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  patrimoine?: Maybe<SituationPatrimoineData>;
  prenom?: Maybe<Scalars['String']['output']>;
  profil?: Maybe<ProfilInvestisseurData>;
  /** Questionnaire de profil investisseur complété lors de la dernière actualisation de la connaissance client de l'opération. Null si indisponible. */
  qpiComplete?: Maybe<Scalars['Boolean']['output']>;
  /** Recueil complété lors de la dernière actualisation de la connaissance client de l'opération. Null si l'information n'était pas disponible. */
  recueilComplete?: Maybe<Scalars['Boolean']['output']>;
  situationPersonnelle?: Maybe<SituationPersonnelleData>;
  statutCodeNavigation?: Maybe<TypeStatutInvestisseur>;
};

export type InvestisseurOperationDataFilterInput = {
  and?: InputMaybe<Array<InvestisseurOperationDataFilterInput>>;
  civiliteCode?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateNaissance?: InputMaybe<LocalDateOperationFilterInput>;
  denomination?: InputMaybe<StringOperationFilterInput>;
  /** DER complété lors de la dernière actualisation de la connaissance client de l'opération. Null si l'information n'était pas disponible. */
  derComplete?: InputMaybe<BooleanOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  /** Instant UTC auquel les états DER, recueil et QPI ont été copiés dans la connaissance client de l'opération. Null si aucune observation n'a été enregistrée. */
  observedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurOperationDataFilterInput>>;
  patrimoine?: InputMaybe<SituationPatrimoineDataFilterInput>;
  prenom?: InputMaybe<StringOperationFilterInput>;
  profil?: InputMaybe<ProfilInvestisseurDataFilterInput>;
  /** Questionnaire de profil investisseur complété lors de la dernière actualisation de la connaissance client de l'opération. Null si indisponible. */
  qpiComplete?: InputMaybe<BooleanOperationFilterInput>;
  /** Recueil complété lors de la dernière actualisation de la connaissance client de l'opération. Null si l'information n'était pas disponible. */
  recueilComplete?: InputMaybe<BooleanOperationFilterInput>;
  situationPersonnelle?: InputMaybe<SituationPersonnelleDataFilterInput>;
  statutCodeNavigation?: InputMaybe<TypeStatutInvestisseurFilterInput>;
};

export type InvestisseurOperationDataInput = {
  civiliteCode?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['DateTime']['input']>;
  dateNaissance?: InputMaybe<Scalars['LocalDate']['input']>;
  denomination?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Long']['input'];
  nom?: InputMaybe<Scalars['String']['input']>;
  patrimoine?: InputMaybe<SituationPatrimoineDataInput>;
  prenom?: InputMaybe<Scalars['String']['input']>;
  profil?: InputMaybe<ProfilInvestisseurDataInput>;
  situationPersonnelle?: InputMaybe<SituationPersonnelleDataInput>;
  statutCodeNavigation?: InputMaybe<TypeStatutInvestisseurInput>;
};

export type InvestisseurPatrimoine = {
  __typename?: 'InvestisseurPatrimoine';
  ageInvestisseur?: Maybe<Scalars['Int']['output']>;
  creationDate: Scalars['DateTime']['output'];
  dateNaissance?: Maybe<Scalars['LocalDate']['output']>;
  detentionNP?: Maybe<Scalars['Decimal']['output']>;
  detentionPP?: Maybe<Scalars['Decimal']['output']>;
  detentionUS?: Maybe<Scalars['Decimal']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  investisseur?: Maybe<Investisseur>;
  investisseurId?: Maybe<Scalars['Long']['output']>;
  nomInvestisseur?: Maybe<Scalars['String']['output']>;
  patrimoine: Patrimoine;
  patrimoineId: Scalars['Long']['output'];
  quotePartADI?: Maybe<Scalars['Decimal']['output']>;
  typeDetenteur?: Maybe<TypeDetenteurEnum>;
  valeurDetentionFiscale?: Maybe<Scalars['Int']['output']>;
};

export type InvestisseurPatrimoineFilterInput = {
  ageInvestisseur?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<InvestisseurPatrimoineFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateNaissance?: InputMaybe<LocalDateOperationFilterInput>;
  detentionNP?: InputMaybe<DecimalOperationFilterInput>;
  detentionPP?: InputMaybe<DecimalOperationFilterInput>;
  detentionUS?: InputMaybe<DecimalOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<MinotaureInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  nomInvestisseur?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurPatrimoineFilterInput>>;
  patrimoine?: InputMaybe<PatrimoineFilterInput>;
  patrimoineId?: InputMaybe<LongOperationFilterInput>;
  quotePartADI?: InputMaybe<DecimalOperationFilterInput>;
  typeDetenteur?: InputMaybe<NullableOfTypeDetenteurEnumOperationFilterInput>;
  valeurDetentionFiscale?: InputMaybe<IntOperationFilterInput>;
};

export type InvestisseurPatrimoineSortInput = {
  ageInvestisseur?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateNaissance?: InputMaybe<SortEnumType>;
  detentionNP?: InputMaybe<SortEnumType>;
  detentionPP?: InputMaybe<SortEnumType>;
  detentionUS?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<MinotaureInvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  nomInvestisseur?: InputMaybe<SortEnumType>;
  patrimoine?: InputMaybe<PatrimoineSortInput>;
  patrimoineId?: InputMaybe<SortEnumType>;
  quotePartADI?: InputMaybe<SortEnumType>;
  typeDetenteur?: InputMaybe<SortEnumType>;
  valeurDetentionFiscale?: InputMaybe<SortEnumType>;
};

/** Représente un questionnaire de connaissance du client et de son profil d'investisseur. Un même investisseur peut avoir plusieurs questionnaires (historique) mais un seul questionnaire actif à la fois. */
export type InvestisseurQpi = {
  __typename?: 'InvestisseurQpi';
  /** Détail du calcul de la capacité à supporter des pertes */
  capaciteSupportPertesDetail?: Maybe<CapaciteSupportPertesDetail>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateCalcul?: Maybe<Scalars['DateTime']['output']>;
  /** Id du document dans la GED (Importé d'Ariane ou signé depuis Minotaure) */
  documentId?: Maybe<Scalars['String']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  /** Détermine si les résultats du QPI et le document associé ont été importés depuis Ariane */
  isImportedFromAriane: Scalars['Boolean']['output'];
  /** Indique que le profil investisseur est dans la version courante du questionnaire (seule version qui peut être complétée) */
  isVersionProfilCourante: Scalars['Boolean']['output'];
  motivationDerogation?: Maybe<Scalars['String']['output']>;
  profilCalculCode?: Maybe<Scalars['String']['output']>;
  profilCalculCodeNavigation?: Maybe<ProfilQpi>;
  profilDerogationCode?: Maybe<Scalars['String']['output']>;
  profilDerogationCodeNavigation?: Maybe<ProfilQpi>;
  /** Réponse à la question ESG principale (Q01AESG) extraite des réponses de sensibilité extra-financière */
  reponseESG?: Maybe<Scalars['Int']['output']>;
  /** Réponses au questionnaire de connaissance du client Harvest (version 1) au format JSON [{id, valeur}] */
  reponsesConnaissanceClientJson?: Maybe<Scalars['String']['output']>;
  /** Réponses au questionnaire courant (connaissance et expérience, tolérance au risque) ; null pour un questionnaire d'une version précédente */
  reponsesProfil?: Maybe<ReponsesProfilInvestisseur>;
  /** Réponses au questionnaire de sensibilité extra-financière au format JSON */
  reponsesSensibiliteExtraFinanciereJson?: Maybe<Scalars['String']['output']>;
  /** Réponses au questionnaire de tolérance au risque Harvest (version 1) au format JSON [{id, valeur}] */
  reponsesToleranceAuRisqueJson?: Maybe<Scalars['String']['output']>;
  /** Résultat du questionnaire de capacité de perte (1 à 5) */
  resultatCapacitePerte?: Maybe<Scalars['Int']['output']>;
  /** Résultat du questionnaire de connaissance du client (1 à 3) */
  resultatConnaissance?: Maybe<Scalars['Int']['output']>;
  /** Profil de risque global: minimum entre Tolerance au risque et Capacité à supporter des pertes (1 à 5) */
  resultatProfilDeRisque?: Maybe<Scalars['Int']['output']>;
  /** Résultat du questionnaire de sensibilité extra-financière (0 à 3) */
  resultatSensibiliteExtraFinanciere?: Maybe<Scalars['Int']['output']>;
  /** Résultat du questionnaire de tolérance au risque (1 à 5) */
  resultatToleranceAuRisque?: Maybe<Scalars['Int']['output']>;
  srriCalcul?: Maybe<Scalars['Int']['output']>;
  srriDerogation?: Maybe<Scalars['Int']['output']>;
  /** Version du questionnaire du profil investisseur (1 = questionnaire Harvest, 2 = nouveau questionnaire interne) */
  versionProfil: Scalars['Int']['output'];
  /** Indique que le profil investisseur a été réalisé dans une version précédente du questionnaire et doit être recommencé dans la version courante (hors QPI importés d'Ariane, gérés à part) */
  versionProfilObsolete: Scalars['Boolean']['output'];
};

export type InvestisseurQpiFilterInput = {
  and?: InputMaybe<Array<InvestisseurQpiFilterInput>>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateCalcul?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  motivationDerogation?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurQpiFilterInput>>;
  profilCalculCode?: InputMaybe<StringOperationFilterInput>;
  profilCalculCodeNavigation?: InputMaybe<ProfilQpiFilterInput>;
  profilDerogationCode?: InputMaybe<StringOperationFilterInput>;
  profilDerogationCodeNavigation?: InputMaybe<ProfilQpiFilterInput>;
  srriCalcul?: InputMaybe<IntOperationFilterInput>;
  srriDerogation?: InputMaybe<IntOperationFilterInput>;
};

export type InvestisseurQpiSortInput = {
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateCalcul?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  motivationDerogation?: InputMaybe<SortEnumType>;
  profilCalculCode?: InputMaybe<SortEnumType>;
  profilCalculCodeNavigation?: InputMaybe<ProfilQpiSortInput>;
  profilDerogationCode?: InputMaybe<SortEnumType>;
  profilDerogationCodeNavigation?: InputMaybe<ProfilQpiSortInput>;
  srriCalcul?: InputMaybe<SortEnumType>;
  srriDerogation?: InputMaybe<SortEnumType>;
};

export type InvestisseurRelationAutreInput = {
  adresse?: InputMaybe<AdressePersonneInput>;
  arianeId?: InputMaybe<Scalars['Long']['input']>;
  /** Identifiant dans Ariane du consultant qui sera responsable de la relation si elle est créée */
  attachedConsultantId?: InputMaybe<Scalars['Long']['input']>;
  civilite?: InputMaybe<Scalars['String']['input']>;
  dateNaissance?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<EmailInput>;
  nom: Scalars['String']['input'];
  origineSaisie: Scalars['Byte']['input'];
  /** Carefull here you must set the related user and not the user you want to apply a relation */
  personnePhysiqueId?: InputMaybe<Scalars['Long']['input']>;
  prenom: Scalars['String']['input'];
  relationId?: InputMaybe<Scalars['Long']['input']>;
  relationPersonneIdToDelete?: InputMaybe<Scalars['Long']['input']>;
  relationPersonneIds: Array<Scalars['Long']['input']>;
  targetPersonneArianeId?: InputMaybe<Scalars['Long']['input']>;
  telephone?: InputMaybe<TelephonePersonneInput>;
  typeRelation: Scalars['String']['input'];
};

export type InvestisseurRelationConsultant = {
  __typename?: 'InvestisseurRelationConsultant';
  consultantCode?: Maybe<Scalars['String']['output']>;
  consultantId: Scalars['Long']['output'];
  nom?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  typeRelationInvestisseurConsultantCode?: Maybe<Scalars['String']['output']>;
};

export type InvestisseurRelationFamilleInput = {
  aChargeRelationPersonneIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  adopte: Scalars['Boolean']['input'];
  allRelationPersonneIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  arianeId?: InputMaybe<Scalars['Long']['input']>;
  /** Identifiant dans Ariane du consultant qui sera responsable de la relation si elle est créée */
  attachedConsultantId?: InputMaybe<Scalars['Long']['input']>;
  autoriteParentaleRelationPersonneIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  civilite?: InputMaybe<Scalars['String']['input']>;
  commentaire?: InputMaybe<Scalars['String']['input']>;
  dateFinChargeFiscale?: InputMaybe<Scalars['DateTime']['input']>;
  dateNaissance?: InputMaybe<Scalars['DateTime']['input']>;
  deuxiemePrenom?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<EmailInput>;
  estTypeRelationPersonneIds: Array<Scalars['Long']['input']>;
  gardeAlternee: Scalars['Boolean']['input'];
  niveauEtude?: InputMaybe<Scalars['String']['input']>;
  nom: Scalars['String']['input'];
  origineSaisie: Scalars['Byte']['input'];
  /** Carefull here you must set the related user and not the user you want to apply a relation */
  personnePhysiqueId?: InputMaybe<Scalars['Long']['input']>;
  prenom: Scalars['String']['input'];
  relationPersonneIdToDelete?: InputMaybe<Scalars['Long']['input']>;
  relationPersonneIds: Array<Scalars['Long']['input']>;
  targetPersonneArianeId?: InputMaybe<Scalars['Long']['input']>;
  telephone?: InputMaybe<TelephonePersonneInput>;
  troisiemePrenom?: InputMaybe<Scalars['String']['input']>;
  typeRelationFamilleCode: Scalars['String']['input'];
};

export type InvestisseurSortInput = {
  arianeId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateConnaissance?: InputMaybe<SortEnumType>;
  dateDernierScanAccuity?: InputMaybe<SortEnumType>;
  dateEntreeRelation?: InputMaybe<SortEnumType>;
  dateMajScanAccuityRequis?: InputMaybe<SortEnumType>;
  dateSuppression?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  gdaBackOffice?: InputMaybe<SortEnumType>;
  gerePar?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSourceAramis?: InputMaybe<SortEnumType>;
  idSourceDiapason?: InputMaybe<SortEnumType>;
  investisseurQpi?: InputMaybe<InvestisseurQpiSortInput>;
  logiqueSuppression?: InputMaybe<SortEnumType>;
  modeCommunication?: InputMaybe<SortEnumType>;
  modeCommunicationNavigation?: InputMaybe<ModeCommunicationSortInput>;
  objectifMontantEpargneMensuel?: InputMaybe<SortEnumType>;
  objectifMontantEpargnePrecaution?: InputMaybe<SortEnumType>;
  origineContactCode?: InputMaybe<SortEnumType>;
  origineContactCodeNavigation?: InputMaybe<OrigineContactSortInput>;
  origineSaisie?: InputMaybe<SortEnumType>;
  origineSaisieNavigation?: InputMaybe<OrigineDataSortInput>;
  patrimoineFiscalite?: InputMaybe<PatrimoineFiscaliteSortInput>;
  ppeBackOffice?: InputMaybe<SortEnumType>;
  recommandePar?: InputMaybe<InvestisseurSortInput>;
  recommandeParId?: InputMaybe<SortEnumType>;
  recommandeParNom?: InputMaybe<SortEnumType>;
  scanAccuityRequis?: InputMaybe<SortEnumType>;
  statutCode?: InputMaybe<SortEnumType>;
  statutCodeNavigation?: InputMaybe<TypeStatutInvestisseurSortInput>;
};

/** Synthèse épargne de l'investisseur, dénormalisée en base pour permettre le tri et le filtre. Recalculée automatiquement à chaque écriture impactant le patrimoine financier de l'investisseur. */
export type InvestisseurSyntheseFinanciere = {
  __typename?: 'InvestisseurSyntheseFinanciere';
  capaciteEpargneMensuelleCouple: Scalars['Decimal']['output'];
  capaciteEpargneMensuelleInvestisseur: Scalars['Decimal']['output'];
  capaciteRemboursementRestanteMensuelCouple: Scalars['Int']['output'];
  capaciteRemboursementRestanteMensuelInvestisseur: Scalars['Int']['output'];
  /** Date du dernier recalcul de la synthèse */
  dateCalcul: Scalars['DateTime']['output'];
  dateProchaineEcheanceCreditCouple?: Maybe<Scalars['DateTime']['output']>;
  dateProchaineEcheanceCreditInvestisseur?: Maybe<Scalars['DateTime']['output']>;
  effortEpargneCouple: Scalars['Decimal']['output'];
  effortEpargneInvestisseur: Scalars['Decimal']['output'];
  epargneDisponibleCouple: Scalars['Decimal']['output'];
  epargneDisponibleDePrecautionCouple: Scalars['Decimal']['output'];
  /** Somme de la valeur estimée de l'épargne bancaire et de l'épargne sécurisé de l'épargne financière */
  epargneDisponibleDePrecautionInvestisseur: Scalars['Decimal']['output'];
  /** Somme des valeurs estimées de l'épargne bancaire et de l'épargne financière */
  epargneDisponibleInvestisseur: Scalars['Decimal']['output'];
  epargneNonDisponibleCouple: Scalars['Decimal']['output'];
  /** Somme des valeurs estimées de l'épargne retraite et salariale, de l'épargne de diversification, et des autres épargnes */
  epargneNonDisponibleInvestisseur: Scalars['Decimal']['output'];
  epargnePrecautionReelleCouple: Scalars['Decimal']['output'];
  epargnePrecautionReelleInvestisseur: Scalars['Decimal']['output'];
  epargnePrecautionSouhaiteeCouple: Scalars['Decimal']['output'];
  epargnePrecautionSouhaiteeInvestisseur: Scalars['Decimal']['output'];
  /** Somme des valeurs estimées de l'épargne du couple (Investisseur + Conjoint potentiel) */
  epargneTotaleCouple: Scalars['Decimal']['output'];
  /** Somme des valeurs estimées de l'épargne de l'Investisseur */
  epargneTotaleInvestisseur: Scalars['Decimal']['output'];
  investisseur?: Maybe<Investisseur>;
  investisseurId: Scalars['Long']['output'];
  mensualiteCreditTotaleCouple: Scalars['Int']['output'];
  mensualiteCreditTotaleInvestisseur: Scalars['Int']['output'];
  soldeBudgetMensuelCouple: Scalars['Decimal']['output'];
  soldeBudgetMensuelInvestisseur: Scalars['Decimal']['output'];
  tauxEndettementCouple?: Maybe<Scalars['Int']['output']>;
  tauxEndettementInvestisseur?: Maybe<Scalars['Int']['output']>;
};

/** Synthèse épargne de l'investisseur, dénormalisée en base pour permettre le tri et le filtre. Recalculée automatiquement à chaque écriture impactant le patrimoine financier de l'investisseur. */
export type InvestisseurSyntheseFinanciereFilterInput = {
  and?: InputMaybe<Array<InvestisseurSyntheseFinanciereFilterInput>>;
  capaciteEpargneMensuelleCouple?: InputMaybe<DecimalOperationFilterInput>;
  capaciteEpargneMensuelleInvestisseur?: InputMaybe<DecimalOperationFilterInput>;
  capaciteRemboursementRestanteMensuelCouple?: InputMaybe<IntOperationFilterInput>;
  capaciteRemboursementRestanteMensuelInvestisseur?: InputMaybe<IntOperationFilterInput>;
  /** Date du dernier recalcul de la synthèse */
  dateCalcul?: InputMaybe<DateTimeOperationFilterInput>;
  dateProchaineEcheanceCreditCouple?: InputMaybe<DateTimeOperationFilterInput>;
  dateProchaineEcheanceCreditInvestisseur?: InputMaybe<DateTimeOperationFilterInput>;
  effortEpargneCouple?: InputMaybe<DecimalOperationFilterInput>;
  effortEpargneInvestisseur?: InputMaybe<DecimalOperationFilterInput>;
  epargneDisponibleCouple?: InputMaybe<DecimalOperationFilterInput>;
  epargneDisponibleDePrecautionCouple?: InputMaybe<DecimalOperationFilterInput>;
  /** Somme de la valeur estimée de l'épargne bancaire et de l'épargne sécurisé de l'épargne financière */
  epargneDisponibleDePrecautionInvestisseur?: InputMaybe<DecimalOperationFilterInput>;
  /** Somme des valeurs estimées de l'épargne bancaire et de l'épargne financière */
  epargneDisponibleInvestisseur?: InputMaybe<DecimalOperationFilterInput>;
  epargneNonDisponibleCouple?: InputMaybe<DecimalOperationFilterInput>;
  /** Somme des valeurs estimées de l'épargne retraite et salariale, de l'épargne de diversification, et des autres épargnes */
  epargneNonDisponibleInvestisseur?: InputMaybe<DecimalOperationFilterInput>;
  epargnePrecautionReelleCouple?: InputMaybe<DecimalOperationFilterInput>;
  epargnePrecautionReelleInvestisseur?: InputMaybe<DecimalOperationFilterInput>;
  epargnePrecautionSouhaiteeCouple?: InputMaybe<DecimalOperationFilterInput>;
  epargnePrecautionSouhaiteeInvestisseur?: InputMaybe<DecimalOperationFilterInput>;
  /** Somme des valeurs estimées de l'épargne du couple (Investisseur + Conjoint potentiel) */
  epargneTotaleCouple?: InputMaybe<DecimalOperationFilterInput>;
  /** Somme des valeurs estimées de l'épargne de l'Investisseur */
  epargneTotaleInvestisseur?: InputMaybe<DecimalOperationFilterInput>;
  investisseur?: InputMaybe<MinotaureInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  mensualiteCreditTotaleCouple?: InputMaybe<IntOperationFilterInput>;
  mensualiteCreditTotaleInvestisseur?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurSyntheseFinanciereFilterInput>>;
  soldeBudgetMensuelCouple?: InputMaybe<DecimalOperationFilterInput>;
  soldeBudgetMensuelInvestisseur?: InputMaybe<DecimalOperationFilterInput>;
  tauxEndettementCouple?: InputMaybe<IntOperationFilterInput>;
  tauxEndettementInvestisseur?: InputMaybe<IntOperationFilterInput>;
};

/** Synthèse épargne de l'investisseur, dénormalisée en base pour permettre le tri et le filtre. Recalculée automatiquement à chaque écriture impactant le patrimoine financier de l'investisseur. */
export type InvestisseurSyntheseFinanciereSortInput = {
  capaciteEpargneMensuelleCouple?: InputMaybe<SortEnumType>;
  capaciteEpargneMensuelleInvestisseur?: InputMaybe<SortEnumType>;
  capaciteRemboursementRestanteMensuelCouple?: InputMaybe<SortEnumType>;
  capaciteRemboursementRestanteMensuelInvestisseur?: InputMaybe<SortEnumType>;
  /** Date du dernier recalcul de la synthèse */
  dateCalcul?: InputMaybe<SortEnumType>;
  dateProchaineEcheanceCreditCouple?: InputMaybe<SortEnumType>;
  dateProchaineEcheanceCreditInvestisseur?: InputMaybe<SortEnumType>;
  effortEpargneCouple?: InputMaybe<SortEnumType>;
  effortEpargneInvestisseur?: InputMaybe<SortEnumType>;
  epargneDisponibleCouple?: InputMaybe<SortEnumType>;
  epargneDisponibleDePrecautionCouple?: InputMaybe<SortEnumType>;
  /** Somme de la valeur estimée de l'épargne bancaire et de l'épargne sécurisé de l'épargne financière */
  epargneDisponibleDePrecautionInvestisseur?: InputMaybe<SortEnumType>;
  /** Somme des valeurs estimées de l'épargne bancaire et de l'épargne financière */
  epargneDisponibleInvestisseur?: InputMaybe<SortEnumType>;
  epargneNonDisponibleCouple?: InputMaybe<SortEnumType>;
  /** Somme des valeurs estimées de l'épargne retraite et salariale, de l'épargne de diversification, et des autres épargnes */
  epargneNonDisponibleInvestisseur?: InputMaybe<SortEnumType>;
  epargnePrecautionReelleCouple?: InputMaybe<SortEnumType>;
  epargnePrecautionReelleInvestisseur?: InputMaybe<SortEnumType>;
  epargnePrecautionSouhaiteeCouple?: InputMaybe<SortEnumType>;
  epargnePrecautionSouhaiteeInvestisseur?: InputMaybe<SortEnumType>;
  /** Somme des valeurs estimées de l'épargne du couple (Investisseur + Conjoint potentiel) */
  epargneTotaleCouple?: InputMaybe<SortEnumType>;
  /** Somme des valeurs estimées de l'épargne de l'Investisseur */
  epargneTotaleInvestisseur?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<MinotaureInvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  mensualiteCreditTotaleCouple?: InputMaybe<SortEnumType>;
  mensualiteCreditTotaleInvestisseur?: InputMaybe<SortEnumType>;
  soldeBudgetMensuelCouple?: InputMaybe<SortEnumType>;
  soldeBudgetMensuelInvestisseur?: InputMaybe<SortEnumType>;
  tauxEndettementCouple?: InputMaybe<SortEnumType>;
  tauxEndettementInvestisseur?: InputMaybe<SortEnumType>;
};

export enum InvestisseurType {
  PersonneMorale = 'PERSONNE_MORALE',
  PersonnePhysique = 'PERSONNE_PHYSIQUE'
}

/** A segment of a collection. */
export type InvestisseursByNamePaginatedCollectionSegment = {
  __typename?: 'InvestisseursByNamePaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Investisseur>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type InvestisseursByNameWithFilterPaginatedCollectionSegment = {
  __typename?: 'InvestisseursByNameWithFilterPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Investisseur>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type InvestisseursFromMinotaurePaginatedCollectionSegment = {
  __typename?: 'InvestisseursFromMinotaurePaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Investisseur>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type InvestisseursPaginatedCollectionSegment = {
  __typename?: 'InvestisseursPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Investisseur>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type InvestisseursPersonnesMoralesByNamePaginatedCollectionSegment = {
  __typename?: 'InvestisseursPersonnesMoralesByNamePaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Investisseur>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type InvestisseursPersonnesPhysiquesByNamePaginatedCollectionSegment = {
  __typename?: 'InvestisseursPersonnesPhysiquesByNamePaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Investisseur>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvestorPurgeCheckItemResponse = {
  __typename?: 'InvestorPurgeCheckItemResponse';
  familyRelations: Array<InvestorPurgeFamilyRelationResponse>;
  isOk: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  message: Scalars['String']['output'];
  severity: Scalars['String']['output'];
};

export type InvestorPurgeCheckResponse = {
  __typename?: 'InvestorPurgeCheckResponse';
  blockingIssueCount: Scalars['Int']['output'];
  canPurge: Scalars['Boolean']['output'];
  checks: Array<InvestorPurgeCheckItemResponse>;
  investorId: Scalars['Long']['output'];
  warningCount: Scalars['Int']['output'];
};

export type InvestorPurgeExecutionResponse = {
  __typename?: 'InvestorPurgeExecutionResponse';
  completedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  executionId: Scalars['String']['output'];
  investorId: Scalars['Long']['output'];
  isInProgress: Scalars['Boolean']['output'];
  lastStatusCheckedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  startedAtUtc: Scalars['DateTime']['output'];
  status?: Maybe<Scalars['String']['output']>;
  statusLevel: Scalars['String']['output'];
};

export type InvestorPurgeFamilyRelationResponse = {
  __typename?: 'InvestorPurgeFamilyRelationResponse';
  relatedInvestorCode: Scalars['String']['output'];
  relatedInvestorDisplayName: Scalars['String']['output'];
  relatedInvestorId: Scalars['Long']['output'];
  relatedInvestorStatusCode?: Maybe<Scalars['String']['output']>;
  relationId?: Maybe<Scalars['Long']['output']>;
  relationTypeCode?: Maybe<Scalars['String']['output']>;
};

export type InvestorPurgeRequestResult = {
  __typename?: 'InvestorPurgeRequestResult';
  check: InvestorPurgeCheckResponse;
  execution?: Maybe<InvestorPurgeExecutionResponse>;
  investorId: Scalars['Long']['output'];
  isBlocked: Scalars['Boolean']['output'];
};

export type JobLevelStats = {
  __typename?: 'JobLevelStats';
  activeCompletedCount: Scalars['Int']['output'];
  activeFailedCount: Scalars['Int']['output'];
  activeTodoCount: Scalars['Int']['output'];
  activeTotalCount: Scalars['Int']['output'];
  completedCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  failedItems: Array<FailedJobItem>;
  todoCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};


export type JobLevelStatsFailedItemsArgs = {
  where?: InputMaybe<FailedJobItemFilterInput>;
};

export enum JobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Idle = 'IDLE',
  Patched = 'PATCHED',
  Redo = 'REDO',
  Todo = 'TODO',
  ToPatch = 'TO_PATCH'
}

export type JobStatusOperationFilterInput = {
  eq?: InputMaybe<JobStatus>;
  in?: InputMaybe<Array<JobStatus>>;
  neq?: InputMaybe<JobStatus>;
  nin?: InputMaybe<Array<JobStatus>>;
};

export enum LevierType {
  Commun = 'COMMUN',
  Individuel = 'INDIVIDUEL'
}

export type LienConsultantStatutJuridiqueTypeHabilitation = {
  __typename?: 'LienConsultantStatutJuridiqueTypeHabilitation';
  consultantStatutJuridique: ConsultantStatutJuridique;
  consultantStatutJuridiqueId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  typeHabilitation: Habilitation;
  typeHabilitationId: Scalars['Long']['output'];
};

export type LienConsultantStatutJuridiqueTypeHabilitationFilterInput = {
  and?: InputMaybe<Array<LienConsultantStatutJuridiqueTypeHabilitationFilterInput>>;
  consultantStatutJuridiqueId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<LienConsultantStatutJuridiqueTypeHabilitationFilterInput>>;
  typeHabilitation?: InputMaybe<HabilitationFilterInput>;
  typeHabilitationId?: InputMaybe<LongOperationFilterInput>;
};

export type ListFilterInputTypeOfAbonnementConsultantFilterInput = {
  all?: InputMaybe<AbonnementConsultantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AbonnementConsultantFilterInput>;
  some?: InputMaybe<AbonnementConsultantFilterInput>;
};

export type ListFilterInputTypeOfActionDeFormationFilterInput = {
  all?: InputMaybe<ActionDeFormationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ActionDeFormationFilterInput>;
  some?: InputMaybe<ActionDeFormationFilterInput>;
};

export type ListFilterInputTypeOfActionDeFormationSessionFilterInput = {
  all?: InputMaybe<ActionDeFormationSessionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ActionDeFormationSessionFilterInput>;
  some?: InputMaybe<ActionDeFormationSessionFilterInput>;
};

export type ListFilterInputTypeOfAdhesionConsultantFilterInput = {
  all?: InputMaybe<AdhesionConsultantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AdhesionConsultantFilterInput>;
  some?: InputMaybe<AdhesionConsultantFilterInput>;
};

export type ListFilterInputTypeOfAdresseFilterInput = {
  all?: InputMaybe<AdresseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AdresseFilterInput>;
  some?: InputMaybe<AdresseFilterInput>;
};

export type ListFilterInputTypeOfAffirmationPedagogieReponseFilterInput = {
  all?: InputMaybe<AffirmationPedagogieReponseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AffirmationPedagogieReponseFilterInput>;
  some?: InputMaybe<AffirmationPedagogieReponseFilterInput>;
};

export type ListFilterInputTypeOfAllocationFilterInput = {
  all?: InputMaybe<AllocationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AllocationFilterInput>;
  some?: InputMaybe<AllocationFilterInput>;
};

export type ListFilterInputTypeOfArianeDumpJobFilterInput = {
  all?: InputMaybe<ArianeDumpJobFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ArianeDumpJobFilterInput>;
  some?: InputMaybe<ArianeDumpJobFilterInput>;
};

export type ListFilterInputTypeOfArianeImportLogFilterInput = {
  all?: InputMaybe<ArianeImportLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ArianeImportLogFilterInput>;
  some?: InputMaybe<ArianeImportLogFilterInput>;
};

export type ListFilterInputTypeOfArianeProcessJobFilterInput = {
  all?: InputMaybe<ArianeProcessJobFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ArianeProcessJobFilterInput>;
  some?: InputMaybe<ArianeProcessJobFilterInput>;
};

export type ListFilterInputTypeOfAtlasAdresseFilterInput = {
  all?: InputMaybe<AtlasAdresseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasAdresseFilterInput>;
  some?: InputMaybe<AtlasAdresseFilterInput>;
};

export type ListFilterInputTypeOfAtlasCategorieSocioProfessionnelleFilterInput = {
  all?: InputMaybe<AtlasCategorieSocioProfessionnelleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasCategorieSocioProfessionnelleFilterInput>;
  some?: InputMaybe<AtlasCategorieSocioProfessionnelleFilterInput>;
};

export type ListFilterInputTypeOfAtlasConsultantFilterInput = {
  all?: InputMaybe<AtlasConsultantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasConsultantFilterInput>;
  some?: InputMaybe<AtlasConsultantFilterInput>;
};

export type ListFilterInputTypeOfAtlasConsultantPersonnePhysiqueFilterInput = {
  all?: InputMaybe<AtlasConsultantPersonnePhysiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasConsultantPersonnePhysiqueFilterInput>;
  some?: InputMaybe<AtlasConsultantPersonnePhysiqueFilterInput>;
};

export type ListFilterInputTypeOfAtlasConsultantStatutJuridiqueFilterInput = {
  all?: InputMaybe<AtlasConsultantStatutJuridiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasConsultantStatutJuridiqueFilterInput>;
  some?: InputMaybe<AtlasConsultantStatutJuridiqueFilterInput>;
};

export type ListFilterInputTypeOfAtlasEtatCivilFilterInput = {
  all?: InputMaybe<AtlasEtatCivilFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasEtatCivilFilterInput>;
  some?: InputMaybe<AtlasEtatCivilFilterInput>;
};

export type ListFilterInputTypeOfAtlasInvestisseurConsultantFilterInput = {
  all?: InputMaybe<AtlasInvestisseurConsultantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasInvestisseurConsultantFilterInput>;
  some?: InputMaybe<AtlasInvestisseurConsultantFilterInput>;
};

export type ListFilterInputTypeOfAtlasInvestisseurFilterInput = {
  all?: InputMaybe<AtlasInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasInvestisseurFilterInput>;
  some?: InputMaybe<AtlasInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfAtlasInvestisseurPersonnePhysiqueFilterInput = {
  all?: InputMaybe<AtlasInvestisseurPersonnePhysiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasInvestisseurPersonnePhysiqueFilterInput>;
  some?: InputMaybe<AtlasInvestisseurPersonnePhysiqueFilterInput>;
};

export type ListFilterInputTypeOfAtlasPaysFilterInput = {
  all?: InputMaybe<AtlasPaysFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasPaysFilterInput>;
  some?: InputMaybe<AtlasPaysFilterInput>;
};

export type ListFilterInputTypeOfAtlasPersonnePhysiqueAdresseFilterInput = {
  all?: InputMaybe<AtlasPersonnePhysiqueAdresseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasPersonnePhysiqueAdresseFilterInput>;
  some?: InputMaybe<AtlasPersonnePhysiqueAdresseFilterInput>;
};

export type ListFilterInputTypeOfAtlasPersonnePhysiqueEmailFilterInput = {
  all?: InputMaybe<AtlasPersonnePhysiqueEmailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasPersonnePhysiqueEmailFilterInput>;
  some?: InputMaybe<AtlasPersonnePhysiqueEmailFilterInput>;
};

export type ListFilterInputTypeOfAtlasPersonnePhysiqueFilterInput = {
  all?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
  some?: InputMaybe<AtlasPersonnePhysiqueFilterInput>;
};

export type ListFilterInputTypeOfAtlasPersonnePhysiqueTelephoneFilterInput = {
  all?: InputMaybe<AtlasPersonnePhysiqueTelephoneFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasPersonnePhysiqueTelephoneFilterInput>;
  some?: InputMaybe<AtlasPersonnePhysiqueTelephoneFilterInput>;
};

export type ListFilterInputTypeOfAtlasReglementaireFilterInput = {
  all?: InputMaybe<AtlasReglementaireFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasReglementaireFilterInput>;
  some?: InputMaybe<AtlasReglementaireFilterInput>;
};

export type ListFilterInputTypeOfAtlasRelationCoupleFilterInput = {
  all?: InputMaybe<AtlasRelationCoupleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasRelationCoupleFilterInput>;
  some?: InputMaybe<AtlasRelationCoupleFilterInput>;
};

export type ListFilterInputTypeOfAtlasSituationProfessionnelleFilterInput = {
  all?: InputMaybe<AtlasSituationProfessionnelleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasSituationProfessionnelleFilterInput>;
  some?: InputMaybe<AtlasSituationProfessionnelleFilterInput>;
};

export type ListFilterInputTypeOfAvancementConnaissanceClientInvestisseurFilterInput = {
  all?: InputMaybe<AvancementConnaissanceClientInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AvancementConnaissanceClientInvestisseurFilterInput>;
  some?: InputMaybe<AvancementConnaissanceClientInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfBudgetInvestisseurFilterInput = {
  all?: InputMaybe<BudgetInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BudgetInvestisseurFilterInput>;
  some?: InputMaybe<BudgetInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfCategorieSocioProfessionnelleFilterInput = {
  all?: InputMaybe<CategorieSocioProfessionnelleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CategorieSocioProfessionnelleFilterInput>;
  some?: InputMaybe<CategorieSocioProfessionnelleFilterInput>;
};

export type ListFilterInputTypeOfCessionHistoCommandeFilterInput = {
  all?: InputMaybe<CessionHistoCommandeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CessionHistoCommandeFilterInput>;
  some?: InputMaybe<CessionHistoCommandeFilterInput>;
};

export type ListFilterInputTypeOfCessionHistoInvestisseurFilterInput = {
  all?: InputMaybe<CessionHistoInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CessionHistoInvestisseurFilterInput>;
  some?: InputMaybe<CessionHistoInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfCommandeFilterInput = {
  all?: InputMaybe<CommandeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CommandeFilterInput>;
  some?: InputMaybe<CommandeFilterInput>;
};

export type ListFilterInputTypeOfCommentairePatrimoineFilterInput = {
  all?: InputMaybe<CommentairePatrimoineFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CommentairePatrimoineFilterInput>;
  some?: InputMaybe<CommentairePatrimoineFilterInput>;
};

export type ListFilterInputTypeOfConseillerCommandeFilterInput = {
  all?: InputMaybe<ConseillerCommandeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConseillerCommandeFilterInput>;
  some?: InputMaybe<ConseillerCommandeFilterInput>;
};

export type ListFilterInputTypeOfConsultantCommissionAdiFilterInput = {
  all?: InputMaybe<ConsultantCommissionAdiFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantCommissionAdiFilterInput>;
  some?: InputMaybe<ConsultantCommissionAdiFilterInput>;
};

export type ListFilterInputTypeOfConsultantContratFilterInput = {
  all?: InputMaybe<ConsultantContratFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantContratFilterInput>;
  some?: InputMaybe<ConsultantContratFilterInput>;
};

export type ListFilterInputTypeOfConsultantDistinctionFilterInput = {
  all?: InputMaybe<ConsultantDistinctionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantDistinctionFilterInput>;
  some?: InputMaybe<ConsultantDistinctionFilterInput>;
};

export type ListFilterInputTypeOfConsultantFilterInput = {
  all?: InputMaybe<ConsultantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantFilterInput>;
  some?: InputMaybe<ConsultantFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationActionBackOfficeFilterInput = {
  all?: InputMaybe<ConsultantHabilitationActionBackOfficeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationActionBackOfficeFilterInput>;
  some?: InputMaybe<ConsultantHabilitationActionBackOfficeFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationExpirationFilterInput = {
  all?: InputMaybe<ConsultantHabilitationExpirationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationExpirationFilterInput>;
  some?: InputMaybe<ConsultantHabilitationExpirationFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationFilterInput = {
  all?: InputMaybe<ConsultantHabilitationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationFilterInput>;
  some?: InputMaybe<ConsultantHabilitationFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationInscriptionCategorieFilterInput = {
  all?: InputMaybe<ConsultantHabilitationInscriptionCategorieFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationInscriptionCategorieFilterInput>;
  some?: InputMaybe<ConsultantHabilitationInscriptionCategorieFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationInscriptionCategorieMandantFilterInput = {
  all?: InputMaybe<ConsultantHabilitationInscriptionCategorieMandantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationInscriptionCategorieMandantFilterInput>;
  some?: InputMaybe<ConsultantHabilitationInscriptionCategorieMandantFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationInscriptionFilterInput = {
  all?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
  some?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationInvalidityReasonFilterInput = {
  all?: InputMaybe<ConsultantHabilitationInvalidityReasonFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationInvalidityReasonFilterInput>;
  some?: InputMaybe<ConsultantHabilitationInvalidityReasonFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationStatutChangeFilterInput = {
  all?: InputMaybe<ConsultantHabilitationStatutChangeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationStatutChangeFilterInput>;
  some?: InputMaybe<ConsultantHabilitationStatutChangeFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationsFictivesFilterInput = {
  all?: InputMaybe<ConsultantHabilitationsFictivesFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationsFictivesFilterInput>;
  some?: InputMaybe<ConsultantHabilitationsFictivesFilterInput>;
};

export type ListFilterInputTypeOfConsultantMigrationJobFilterInput = {
  all?: InputMaybe<ConsultantMigrationJobFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantMigrationJobFilterInput>;
  some?: InputMaybe<ConsultantMigrationJobFilterInput>;
};

export type ListFilterInputTypeOfConsultantMouvementFilterInput = {
  all?: InputMaybe<ConsultantMouvementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantMouvementFilterInput>;
  some?: InputMaybe<ConsultantMouvementFilterInput>;
};

export type ListFilterInputTypeOfConsultantOrganisationFilterInput = {
  all?: InputMaybe<ConsultantOrganisationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantOrganisationFilterInput>;
  some?: InputMaybe<ConsultantOrganisationFilterInput>;
};

export type ListFilterInputTypeOfConsultantRcpFilterInput = {
  all?: InputMaybe<ConsultantRcpFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantRcpFilterInput>;
  some?: InputMaybe<ConsultantRcpFilterInput>;
};

export type ListFilterInputTypeOfConsultantStatutCommercialFilterInput = {
  all?: InputMaybe<ConsultantStatutCommercialFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantStatutCommercialFilterInput>;
  some?: InputMaybe<ConsultantStatutCommercialFilterInput>;
};

export type ListFilterInputTypeOfConsultantStatutJuridiqueChangeFilterInput = {
  all?: InputMaybe<ConsultantStatutJuridiqueChangeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantStatutJuridiqueChangeFilterInput>;
  some?: InputMaybe<ConsultantStatutJuridiqueChangeFilterInput>;
};

export type ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput = {
  all?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  some?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};

export type ListFilterInputTypeOfContactFilterInput = {
  all?: InputMaybe<ContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContactFilterInput>;
  some?: InputMaybe<ContactFilterInput>;
};

export type ListFilterInputTypeOfContratsInvestisseurFilterInput = {
  all?: InputMaybe<ContratsInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContratsInvestisseurFilterInput>;
  some?: InputMaybe<ContratsInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfContratsSupportFilterInput = {
  all?: InputMaybe<ContratsSupportFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContratsSupportFilterInput>;
  some?: InputMaybe<ContratsSupportFilterInput>;
};

export type ListFilterInputTypeOfCursusCycleCourtFilterInput = {
  all?: InputMaybe<CursusCycleCourtFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CursusCycleCourtFilterInput>;
  some?: InputMaybe<CursusCycleCourtFilterInput>;
};

export type ListFilterInputTypeOfCursusFilterInput = {
  all?: InputMaybe<CursusFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CursusFilterInput>;
  some?: InputMaybe<CursusFilterInput>;
};

export type ListFilterInputTypeOfCursusFormationFilterInput = {
  all?: InputMaybe<CursusFormationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CursusFormationFilterInput>;
  some?: InputMaybe<CursusFormationFilterInput>;
};

export type ListFilterInputTypeOfCycleCourtFilterInput = {
  all?: InputMaybe<CycleCourtFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CycleCourtFilterInput>;
  some?: InputMaybe<CycleCourtFilterInput>;
};

export type ListFilterInputTypeOfDetenteurPatrimoineActifFilterInput = {
  all?: InputMaybe<DetenteurPatrimoineActifFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DetenteurPatrimoineActifFilterInput>;
  some?: InputMaybe<DetenteurPatrimoineActifFilterInput>;
};

export type ListFilterInputTypeOfDetenteurPatrimoineChargeRevenuFilterInput = {
  all?: InputMaybe<DetenteurPatrimoineChargeRevenuFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DetenteurPatrimoineChargeRevenuFilterInput>;
  some?: InputMaybe<DetenteurPatrimoineChargeRevenuFilterInput>;
};

export type ListFilterInputTypeOfDetenteurPatrimoinePassifFilterInput = {
  all?: InputMaybe<DetenteurPatrimoinePassifFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DetenteurPatrimoinePassifFilterInput>;
  some?: InputMaybe<DetenteurPatrimoinePassifFilterInput>;
};

export type ListFilterInputTypeOfDispositionFilterInput = {
  all?: InputMaybe<DispositionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DispositionFilterInput>;
  some?: InputMaybe<DispositionFilterInput>;
};

export type ListFilterInputTypeOfDistinctionFilterInput = {
  all?: InputMaybe<DistinctionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DistinctionFilterInput>;
  some?: InputMaybe<DistinctionFilterInput>;
};

export type ListFilterInputTypeOfDocumentTypeFilterInput = {
  all?: InputMaybe<DocumentTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DocumentTypeFilterInput>;
  some?: InputMaybe<DocumentTypeFilterInput>;
};

export type ListFilterInputTypeOfEditionFilterInput = {
  all?: InputMaybe<EditionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EditionFilterInput>;
  some?: InputMaybe<EditionFilterInput>;
};

export type ListFilterInputTypeOfEmailFilterInput = {
  all?: InputMaybe<EmailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmailFilterInput>;
  some?: InputMaybe<EmailFilterInput>;
};

export type ListFilterInputTypeOfEnveloppeProduitFilterInput = {
  all?: InputMaybe<EnveloppeProduitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EnveloppeProduitFilterInput>;
  some?: InputMaybe<EnveloppeProduitFilterInput>;
};

export type ListFilterInputTypeOfEquivalenceDeFormationFilterInput = {
  all?: InputMaybe<EquivalenceDeFormationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EquivalenceDeFormationFilterInput>;
  some?: InputMaybe<EquivalenceDeFormationFilterInput>;
};

export type ListFilterInputTypeOfErrorLogDetailFilterInput = {
  all?: InputMaybe<ErrorLogDetailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ErrorLogDetailFilterInput>;
  some?: InputMaybe<ErrorLogDetailFilterInput>;
};

export type ListFilterInputTypeOfEtatCivilFilterInput = {
  all?: InputMaybe<EtatCivilFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EtatCivilFilterInput>;
  some?: InputMaybe<EtatCivilFilterInput>;
};

export type ListFilterInputTypeOfFactureFilterInput = {
  all?: InputMaybe<FactureFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FactureFilterInput>;
  some?: InputMaybe<FactureFilterInput>;
};

export type ListFilterInputTypeOfFieldConfigFilterInput = {
  all?: InputMaybe<FieldConfigFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FieldConfigFilterInput>;
  some?: InputMaybe<FieldConfigFilterInput>;
};

export type ListFilterInputTypeOfFieldValidatorConfigFilterInput = {
  all?: InputMaybe<FieldValidatorConfigFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FieldValidatorConfigFilterInput>;
  some?: InputMaybe<FieldValidatorConfigFilterInput>;
};

export type ListFilterInputTypeOfFieldValidatorConfigParameterFilterInput = {
  all?: InputMaybe<FieldValidatorConfigParameterFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FieldValidatorConfigParameterFilterInput>;
  some?: InputMaybe<FieldValidatorConfigParameterFilterInput>;
};

export type ListFilterInputTypeOfFiltreSettingFilterInput = {
  all?: InputMaybe<FiltreSettingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FiltreSettingFilterInput>;
  some?: InputMaybe<FiltreSettingFilterInput>;
};

export type ListFilterInputTypeOfFinancialRecalculationLogFilterInput = {
  all?: InputMaybe<FinancialRecalculationLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FinancialRecalculationLogFilterInput>;
  some?: InputMaybe<FinancialRecalculationLogFilterInput>;
};

export type ListFilterInputTypeOfFondsEvenementielDataFilterInput = {
  all?: InputMaybe<FondsEvenementielDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FondsEvenementielDataFilterInput>;
  some?: InputMaybe<FondsEvenementielDataFilterInput>;
};

export type ListFilterInputTypeOfFondsEvenementielFilterInput = {
  all?: InputMaybe<FondsEvenementielFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FondsEvenementielFilterInput>;
  some?: InputMaybe<FondsEvenementielFilterInput>;
};

export type ListFilterInputTypeOfFormationFilterInput = {
  all?: InputMaybe<FormationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FormationFilterInput>;
  some?: InputMaybe<FormationFilterInput>;
};

export type ListFilterInputTypeOfFormeJuridiqueFilterInput = {
  all?: InputMaybe<FormeJuridiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FormeJuridiqueFilterInput>;
  some?: InputMaybe<FormeJuridiqueFilterInput>;
};

export type ListFilterInputTypeOfGalaxyMigrationJobFilterInput = {
  all?: InputMaybe<GalaxyMigrationJobFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GalaxyMigrationJobFilterInput>;
  some?: InputMaybe<GalaxyMigrationJobFilterInput>;
};

export type ListFilterInputTypeOfGedTypeDocumentFilterInput = {
  all?: InputMaybe<GedTypeDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GedTypeDocumentFilterInput>;
  some?: InputMaybe<GedTypeDocumentFilterInput>;
};

export type ListFilterInputTypeOfHabilitationInscriptionFilterInput = {
  all?: InputMaybe<HabilitationInscriptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<HabilitationInscriptionFilterInput>;
  some?: InputMaybe<HabilitationInscriptionFilterInput>;
};

export type ListFilterInputTypeOfHabilitationRcpFilterInput = {
  all?: InputMaybe<HabilitationRcpFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<HabilitationRcpFilterInput>;
  some?: InputMaybe<HabilitationRcpFilterInput>;
};

export type ListFilterInputTypeOfImportConsultantWaveMigrationJobFilterInput = {
  all?: InputMaybe<ImportConsultantWaveMigrationJobFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ImportConsultantWaveMigrationJobFilterInput>;
  some?: InputMaybe<ImportConsultantWaveMigrationJobFilterInput>;
};

export type ListFilterInputTypeOfImportGalaxyWaveMigrationJobFilterInput = {
  all?: InputMaybe<ImportGalaxyWaveMigrationJobFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ImportGalaxyWaveMigrationJobFilterInput>;
  some?: InputMaybe<ImportGalaxyWaveMigrationJobFilterInput>;
};

export type ListFilterInputTypeOfImportHistoryFilterInput = {
  all?: InputMaybe<ImportHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ImportHistoryFilterInput>;
  some?: InputMaybe<ImportHistoryFilterInput>;
};

export type ListFilterInputTypeOfImportInvestisseurFilterInput = {
  all?: InputMaybe<ImportInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ImportInvestisseurFilterInput>;
  some?: InputMaybe<ImportInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfImportLogFilterInput = {
  all?: InputMaybe<ImportLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ImportLogFilterInput>;
  some?: InputMaybe<ImportLogFilterInput>;
};

export type ListFilterInputTypeOfInscriptionCycleCourtFilterInput = {
  all?: InputMaybe<InscriptionCycleCourtFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InscriptionCycleCourtFilterInput>;
  some?: InputMaybe<InscriptionCycleCourtFilterInput>;
};

export type ListFilterInputTypeOfInscriptionSessionFilterInput = {
  all?: InputMaybe<InscriptionSessionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InscriptionSessionFilterInput>;
  some?: InputMaybe<InscriptionSessionFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurCommandeFilterInput = {
  all?: InputMaybe<InvestisseurCommandeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurCommandeFilterInput>;
  some?: InputMaybe<InvestisseurCommandeFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurConsultantFilterInput = {
  all?: InputMaybe<InvestisseurConsultantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurConsultantFilterInput>;
  some?: InputMaybe<InvestisseurConsultantFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurEtiquetteFilterInput = {
  all?: InputMaybe<InvestisseurEtiquetteFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurEtiquetteFilterInput>;
  some?: InputMaybe<InvestisseurEtiquetteFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurFilterInput = {
  all?: InputMaybe<InvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurFilterInput>;
  some?: InputMaybe<InvestisseurFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurObjectifDataFilterInput = {
  all?: InputMaybe<InvestisseurObjectifDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurObjectifDataFilterInput>;
  some?: InputMaybe<InvestisseurObjectifDataFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurObjectifFilterInput = {
  all?: InputMaybe<InvestisseurObjectifFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurObjectifFilterInput>;
  some?: InputMaybe<InvestisseurObjectifFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurOperationDataFilterInput = {
  all?: InputMaybe<InvestisseurOperationDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurOperationDataFilterInput>;
  some?: InputMaybe<InvestisseurOperationDataFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurPatrimoineFilterInput = {
  all?: InputMaybe<InvestisseurPatrimoineFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurPatrimoineFilterInput>;
  some?: InputMaybe<InvestisseurPatrimoineFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurQpiFilterInput = {
  all?: InputMaybe<InvestisseurQpiFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurQpiFilterInput>;
  some?: InputMaybe<InvestisseurQpiFilterInput>;
};

export type ListFilterInputTypeOfLienConsultantStatutJuridiqueTypeHabilitationFilterInput = {
  all?: InputMaybe<LienConsultantStatutJuridiqueTypeHabilitationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LienConsultantStatutJuridiqueTypeHabilitationFilterInput>;
  some?: InputMaybe<LienConsultantStatutJuridiqueTypeHabilitationFilterInput>;
};

export type ListFilterInputTypeOfMinotaureInvestisseurFilterInput = {
  all?: InputMaybe<MinotaureInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MinotaureInvestisseurFilterInput>;
  some?: InputMaybe<MinotaureInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfMinotaureInvestisseurQpiFilterInput = {
  all?: InputMaybe<MinotaureInvestisseurQpiFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MinotaureInvestisseurQpiFilterInput>;
  some?: InputMaybe<MinotaureInvestisseurQpiFilterInput>;
};

export type ListFilterInputTypeOfModeDeGestionConfigFilterInput = {
  all?: InputMaybe<ModeDeGestionConfigFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ModeDeGestionConfigFilterInput>;
  some?: InputMaybe<ModeDeGestionConfigFilterInput>;
};

export type ListFilterInputTypeOfMotifAnnulationCommandeFilterInput = {
  all?: InputMaybe<MotifAnnulationCommandeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MotifAnnulationCommandeFilterInput>;
  some?: InputMaybe<MotifAnnulationCommandeFilterInput>;
};

export type ListFilterInputTypeOfMotifCessionFilterInput = {
  all?: InputMaybe<MotifCessionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MotifCessionFilterInput>;
  some?: InputMaybe<MotifCessionFilterInput>;
};

export type ListFilterInputTypeOfMouvementFilterInput = {
  all?: InputMaybe<MouvementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MouvementFilterInput>;
  some?: InputMaybe<MouvementFilterInput>;
};

export type ListFilterInputTypeOfMyStelliumDocumentRequestFilterInput = {
  all?: InputMaybe<MyStelliumDocumentRequestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MyStelliumDocumentRequestFilterInput>;
  some?: InputMaybe<MyStelliumDocumentRequestFilterInput>;
};

export type ListFilterInputTypeOfMyStelliumDocumentRequestTypeFilterInput = {
  all?: InputMaybe<MyStelliumDocumentRequestTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MyStelliumDocumentRequestTypeFilterInput>;
  some?: InputMaybe<MyStelliumDocumentRequestTypeFilterInput>;
};

export type ListFilterInputTypeOfMyStelliumDocumentUploadFilterInput = {
  all?: InputMaybe<MyStelliumDocumentUploadFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MyStelliumDocumentUploadFilterInput>;
  some?: InputMaybe<MyStelliumDocumentUploadFilterInput>;
};

export type ListFilterInputTypeOfMyStelliumInvestisseurConnectionFilterInput = {
  all?: InputMaybe<MyStelliumInvestisseurConnectionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MyStelliumInvestisseurConnectionFilterInput>;
  some?: InputMaybe<MyStelliumInvestisseurConnectionFilterInput>;
};

export type ListFilterInputTypeOfMyStelliumRecommendationFilterInput = {
  all?: InputMaybe<MyStelliumRecommendationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MyStelliumRecommendationFilterInput>;
  some?: InputMaybe<MyStelliumRecommendationFilterInput>;
};

export type ListFilterInputTypeOfNoteFilterInput = {
  all?: InputMaybe<NoteFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<NoteFilterInput>;
  some?: InputMaybe<NoteFilterInput>;
};

export type ListFilterInputTypeOfObjectifDefiniFilterInput = {
  all?: InputMaybe<ObjectifDefiniFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ObjectifDefiniFilterInput>;
  some?: InputMaybe<ObjectifDefiniFilterInput>;
};

export type ListFilterInputTypeOfObjectifReferenceFilterInput = {
  all?: InputMaybe<ObjectifReferenceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ObjectifReferenceFilterInput>;
  some?: InputMaybe<ObjectifReferenceFilterInput>;
};

export type ListFilterInputTypeOfOperationAdequationCheckFilterInput = {
  all?: InputMaybe<OperationAdequationCheckFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OperationAdequationCheckFilterInput>;
  some?: InputMaybe<OperationAdequationCheckFilterInput>;
};

export type ListFilterInputTypeOfOperationAdequationFieldFilterInput = {
  all?: InputMaybe<OperationAdequationFieldFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OperationAdequationFieldFilterInput>;
  some?: InputMaybe<OperationAdequationFieldFilterInput>;
};

export type ListFilterInputTypeOfOperationAdequationParameterFilterInput = {
  all?: InputMaybe<OperationAdequationParameterFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OperationAdequationParameterFilterInput>;
  some?: InputMaybe<OperationAdequationParameterFilterInput>;
};

export type ListFilterInputTypeOfOperationFilterInput = {
  all?: InputMaybe<OperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OperationFilterInput>;
  some?: InputMaybe<OperationFilterInput>;
};

export type ListFilterInputTypeOfOperationInvestisseurFilterInput = {
  all?: InputMaybe<OperationInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OperationInvestisseurFilterInput>;
  some?: InputMaybe<OperationInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfOperationSignatureDocumentMetadataFilterInput = {
  all?: InputMaybe<OperationSignatureDocumentMetadataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OperationSignatureDocumentMetadataFilterInput>;
  some?: InputMaybe<OperationSignatureDocumentMetadataFilterInput>;
};

export type ListFilterInputTypeOfOperationSignatureDocumentRequirementFilterInput = {
  all?: InputMaybe<OperationSignatureDocumentRequirementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OperationSignatureDocumentRequirementFilterInput>;
  some?: InputMaybe<OperationSignatureDocumentRequirementFilterInput>;
};

export type ListFilterInputTypeOfOperationSignatureSignerMetadataFilterInput = {
  all?: InputMaybe<OperationSignatureSignerMetadataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OperationSignatureSignerMetadataFilterInput>;
  some?: InputMaybe<OperationSignatureSignerMetadataFilterInput>;
};

export type ListFilterInputTypeOfOptionAutomatiqueDataFilterInput = {
  all?: InputMaybe<OptionAutomatiqueDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OptionAutomatiqueDataFilterInput>;
  some?: InputMaybe<OptionAutomatiqueDataFilterInput>;
};

export type ListFilterInputTypeOfOptionAutomatiqueFilterInput = {
  all?: InputMaybe<OptionAutomatiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OptionAutomatiqueFilterInput>;
  some?: InputMaybe<OptionAutomatiqueFilterInput>;
};

export type ListFilterInputTypeOfOptionToleranceDtoFilterInput = {
  all?: InputMaybe<OptionToleranceDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OptionToleranceDtoFilterInput>;
  some?: InputMaybe<OptionToleranceDtoFilterInput>;
};

export type ListFilterInputTypeOfOptionVerificationDtoFilterInput = {
  all?: InputMaybe<OptionVerificationDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OptionVerificationDtoFilterInput>;
  some?: InputMaybe<OptionVerificationDtoFilterInput>;
};

export type ListFilterInputTypeOfOrganismeFilterInput = {
  all?: InputMaybe<OrganismeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrganismeFilterInput>;
  some?: InputMaybe<OrganismeFilterInput>;
};

export type ListFilterInputTypeOfPassifFilterInput = {
  all?: InputMaybe<PassifFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PassifFilterInput>;
  some?: InputMaybe<PassifFilterInput>;
};

export type ListFilterInputTypeOfPatrimoineActifFilterInput = {
  all?: InputMaybe<PatrimoineActifFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PatrimoineActifFilterInput>;
  some?: InputMaybe<PatrimoineActifFilterInput>;
};

export type ListFilterInputTypeOfPatrimoineBudgetFilterInput = {
  all?: InputMaybe<PatrimoineBudgetFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PatrimoineBudgetFilterInput>;
  some?: InputMaybe<PatrimoineBudgetFilterInput>;
};

export type ListFilterInputTypeOfPatrimoineChargeRevenuFilterInput = {
  all?: InputMaybe<PatrimoineChargeRevenuFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PatrimoineChargeRevenuFilterInput>;
  some?: InputMaybe<PatrimoineChargeRevenuFilterInput>;
};

export type ListFilterInputTypeOfPatrimoinePassifFilterInput = {
  all?: InputMaybe<PatrimoinePassifFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PatrimoinePassifFilterInput>;
  some?: InputMaybe<PatrimoinePassifFilterInput>;
};

export type ListFilterInputTypeOfPaysFilterInput = {
  all?: InputMaybe<PaysFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PaysFilterInput>;
  some?: InputMaybe<PaysFilterInput>;
};

export type ListFilterInputTypeOfPersonneMoraleAdresseFilterInput = {
  all?: InputMaybe<PersonneMoraleAdresseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonneMoraleAdresseFilterInput>;
  some?: InputMaybe<PersonneMoraleAdresseFilterInput>;
};

export type ListFilterInputTypeOfPersonneMoraleFilterInput = {
  all?: InputMaybe<PersonneMoraleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonneMoraleFilterInput>;
  some?: InputMaybe<PersonneMoraleFilterInput>;
};

export type ListFilterInputTypeOfPersonneMoraleTelephoneFilterInput = {
  all?: InputMaybe<PersonneMoraleTelephoneFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonneMoraleTelephoneFilterInput>;
  some?: InputMaybe<PersonneMoraleTelephoneFilterInput>;
};

export type ListFilterInputTypeOfPersonnePhysiqueDocumentFilterInput = {
  all?: InputMaybe<PersonnePhysiqueDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonnePhysiqueDocumentFilterInput>;
  some?: InputMaybe<PersonnePhysiqueDocumentFilterInput>;
};

export type ListFilterInputTypeOfPersonnePhysiqueFilterInput = {
  all?: InputMaybe<PersonnePhysiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonnePhysiqueFilterInput>;
  some?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type ListFilterInputTypeOfPieceJointeConsultantFilterInput = {
  all?: InputMaybe<PieceJointeConsultantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PieceJointeConsultantFilterInput>;
  some?: InputMaybe<PieceJointeConsultantFilterInput>;
};

export type ListFilterInputTypeOfProduitEpargneReponseFilterInput = {
  all?: InputMaybe<ProduitEpargneReponseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProduitEpargneReponseFilterInput>;
  some?: InputMaybe<ProduitEpargneReponseFilterInput>;
};

export type ListFilterInputTypeOfProduitFilterInput = {
  all?: InputMaybe<ProduitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProduitFilterInput>;
  some?: InputMaybe<ProduitFilterInput>;
};

export type ListFilterInputTypeOfProduitSpecificConfigFilterInput = {
  all?: InputMaybe<ProduitSpecificConfigFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProduitSpecificConfigFilterInput>;
  some?: InputMaybe<ProduitSpecificConfigFilterInput>;
};

export type ListFilterInputTypeOfProfilInvestisseurFilterInput = {
  all?: InputMaybe<ProfilInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProfilInvestisseurFilterInput>;
  some?: InputMaybe<ProfilInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfProjetDocumentFilterInput = {
  all?: InputMaybe<ProjetDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjetDocumentFilterInput>;
  some?: InputMaybe<ProjetDocumentFilterInput>;
};

export type ListFilterInputTypeOfProjetInvestisseurFilterInput = {
  all?: InputMaybe<ProjetInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjetInvestisseurFilterInput>;
  some?: InputMaybe<ProjetInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfReglementaireFilterInput = {
  all?: InputMaybe<ReglementaireFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ReglementaireFilterInput>;
  some?: InputMaybe<ReglementaireFilterInput>;
};

export type ListFilterInputTypeOfRelationAutreFilterInput = {
  all?: InputMaybe<RelationAutreFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RelationAutreFilterInput>;
  some?: InputMaybe<RelationAutreFilterInput>;
};

export type ListFilterInputTypeOfRelationCoupleFilterInput = {
  all?: InputMaybe<RelationCoupleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RelationCoupleFilterInput>;
  some?: InputMaybe<RelationCoupleFilterInput>;
};

export type ListFilterInputTypeOfRelationFamilleFilterInput = {
  all?: InputMaybe<RelationFamilleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RelationFamilleFilterInput>;
  some?: InputMaybe<RelationFamilleFilterInput>;
};

export type ListFilterInputTypeOfResiliationPaiementB2SFilterInput = {
  all?: InputMaybe<ResiliationPaiementB2SFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ResiliationPaiementB2SFilterInput>;
  some?: InputMaybe<ResiliationPaiementB2SFilterInput>;
};

export type ListFilterInputTypeOfSeanceSessionFilterInput = {
  all?: InputMaybe<SeanceSessionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SeanceSessionFilterInput>;
  some?: InputMaybe<SeanceSessionFilterInput>;
};

export type ListFilterInputTypeOfSessionFilterInput = {
  all?: InputMaybe<SessionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SessionFilterInput>;
  some?: InputMaybe<SessionFilterInput>;
};

export type ListFilterInputTypeOfSituationProfessionnelleFilterInput = {
  all?: InputMaybe<SituationProfessionnelleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SituationProfessionnelleFilterInput>;
  some?: InputMaybe<SituationProfessionnelleFilterInput>;
};

export type ListFilterInputTypeOfSupportInvestissementReponseFilterInput = {
  all?: InputMaybe<SupportInvestissementReponseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SupportInvestissementReponseFilterInput>;
  some?: InputMaybe<SupportInvestissementReponseFilterInput>;
};

export type ListFilterInputTypeOfTelephoneFilterInput = {
  all?: InputMaybe<TelephoneFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TelephoneFilterInput>;
  some?: InputMaybe<TelephoneFilterInput>;
};

export type ListFilterInputTypeOfTestamentFilterInput = {
  all?: InputMaybe<TestamentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TestamentFilterInput>;
  some?: InputMaybe<TestamentFilterInput>;
};

export type ListFilterInputTypeOfToleranceRisqueReponseFilterInput = {
  all?: InputMaybe<ToleranceRisqueReponseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ToleranceRisqueReponseFilterInput>;
  some?: InputMaybe<ToleranceRisqueReponseFilterInput>;
};

export type ListFilterInputTypeOfTransfertClientFilterInput = {
  all?: InputMaybe<TransfertClientFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TransfertClientFilterInput>;
  some?: InputMaybe<TransfertClientFilterInput>;
};

export type ListFilterInputTypeOfType2ProduitFilterInput = {
  all?: InputMaybe<Type2ProduitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Type2ProduitFilterInput>;
  some?: InputMaybe<Type2ProduitFilterInput>;
};

export type ListFilterInputTypeOfTypeEditionFilterInput = {
  all?: InputMaybe<TypeEditionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TypeEditionFilterInput>;
  some?: InputMaybe<TypeEditionFilterInput>;
};

export type ListFilterInputTypeOfTypeObjectifInvestisseurFilterInput = {
  all?: InputMaybe<TypeObjectifInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TypeObjectifInvestisseurFilterInput>;
  some?: InputMaybe<TypeObjectifInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfTypePieceJointeFilterInput = {
  all?: InputMaybe<TypePieceJointeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TypePieceJointeFilterInput>;
  some?: InputMaybe<TypePieceJointeFilterInput>;
};

export type ListFilterInputTypeOfTypeRelationAutreFilterInput = {
  all?: InputMaybe<TypeRelationAutreFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TypeRelationAutreFilterInput>;
  some?: InputMaybe<TypeRelationAutreFilterInput>;
};

export type ListFilterInputTypeOfTypeRelationFamilleFilterInput = {
  all?: InputMaybe<TypeRelationFamilleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TypeRelationFamilleFilterInput>;
  some?: InputMaybe<TypeRelationFamilleFilterInput>;
};

export type ListFilterInputTypeOfVeElementFilterInput = {
  all?: InputMaybe<VeElementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VeElementFilterInput>;
  some?: InputMaybe<VeElementFilterInput>;
};

export type ListFilterInputTypeOfWavePreLaunchSyncFilterInput = {
  all?: InputMaybe<WavePreLaunchSyncFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<WavePreLaunchSyncFilterInput>;
  some?: InputMaybe<WavePreLaunchSyncFilterInput>;
};

export type ListLongOperationFilterInput = {
  all?: InputMaybe<LongOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LongOperationFilterInput>;
  some?: InputMaybe<LongOperationFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type ListTypeHabilitationOperationFilterInput = {
  all?: InputMaybe<TypeHabilitationOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TypeHabilitationOperationFilterInput>;
  some?: InputMaybe<TypeHabilitationOperationFilterInput>;
};

export type LocalDateOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalDate']['input']>;
  gt?: InputMaybe<Scalars['LocalDate']['input']>;
  gte?: InputMaybe<Scalars['LocalDate']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  lt?: InputMaybe<Scalars['LocalDate']['input']>;
  lte?: InputMaybe<Scalars['LocalDate']['input']>;
  neq?: InputMaybe<Scalars['LocalDate']['input']>;
  ngt?: InputMaybe<Scalars['LocalDate']['input']>;
  ngte?: InputMaybe<Scalars['LocalDate']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  nlt?: InputMaybe<Scalars['LocalDate']['input']>;
  nlte?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type MetadatasConnaissanceClient = {
  __typename?: 'MetadatasConnaissanceClient';
  avancementsConnaissanceClientInvestisseurs: Array<AvancementConnaissanceClientInvestisseur>;
  id: Scalars['Long']['output'];
};


export type MetadatasConnaissanceClientAvancementsConnaissanceClientInvestisseursArgs = {
  where?: InputMaybe<AvancementConnaissanceClientInvestisseurFilterInput>;
};

export type MetadatasConnaissanceClientFilterInput = {
  and?: InputMaybe<Array<MetadatasConnaissanceClientFilterInput>>;
  avancementsConnaissanceClientInvestisseurs?: InputMaybe<ListFilterInputTypeOfAvancementConnaissanceClientInvestisseurFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<MetadatasConnaissanceClientFilterInput>>;
};

export type MetadatasConnaissanceClientSortInput = {
  id?: InputMaybe<SortEnumType>;
};

export type MinotaureConsultantFilterInput = {
  and?: InputMaybe<Array<MinotaureConsultantFilterInput>>;
  atlasConsultant?: InputMaybe<AtlasConsultantFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  importHistories?: InputMaybe<ListFilterInputTypeOfImportHistoryFilterInput>;
  /** Le consultant ne peut pas acceder a Minotaure */
  isDisabled?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<MinotaureConsultantFilterInput>>;
  /** is consultant transfered from Ariane to Minotaure */
  transferStatus?: InputMaybe<ConsultantTransferStatusOperationFilterInput>;
};

export type MinotaureConsultantSortInput = {
  atlasConsultant?: InputMaybe<AtlasConsultantSortInput>;
  code?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Le consultant ne peut pas acceder a Minotaure */
  isDisabled?: InputMaybe<SortEnumType>;
  /** is consultant transfered from Ariane to Minotaure */
  transferStatus?: InputMaybe<SortEnumType>;
};

export type MinotaureImportProgress = {
  __typename?: 'MinotaureImportProgress';
  minotaureInvestisseurs: Scalars['Long']['output'];
  totalInvestisseurs: Scalars['Long']['output'];
};

export type MinotaureInvestisseurFilterInput = {
  and?: InputMaybe<Array<MinotaureInvestisseurFilterInput>>;
  atlasInvestisseur?: InputMaybe<AtlasInvestisseurFilterInput>;
  avancementConnaissanceClientInvestisseur?: InputMaybe<AvancementConnaissanceClientInvestisseurFilterInput>;
  bilanFinancier?: InputMaybe<InvestisseurBilanFinancierFilterInput>;
  budgetInvestisseurs?: InputMaybe<ListFilterInputTypeOfBudgetInvestisseurFilterInput>;
  capaciteFinanciere?: InputMaybe<CapaciteFinanciereFilterInput>;
  /** Le QPI actuellement actif pour l'investisseur */
  currentQPI?: InputMaybe<MinotaureInvestisseurQpiFilterInput>;
  currentQPIId?: InputMaybe<LongOperationFilterInput>;
  dateModificationFiche?: InputMaybe<DateTimeOperationFilterInput>;
  foyerFiscal?: InputMaybe<FoyerFiscalFilterInput>;
  foyerFiscalId?: InputMaybe<LongOperationFilterInput>;
  /** Indique si l'investisseur possède une ligne MyStellium. Un investisseur sans ligne est considéré comme non invité. */
  hasMyStelliumInvestisseur?: InputMaybe<BooleanOperationFilterInput>;
  /** Indique si au moins un contrat de l'investisseur a les versements programmés activés (flagVp). Faux inclut les investisseurs sans contrat. */
  hasVersementsProgrammes?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  importHistories?: InputMaybe<ListFilterInputTypeOfImportHistoryFilterInput>;
  investisseurEtiquette?: InputMaybe<ListFilterInputTypeOfInvestisseurEtiquetteFilterInput>;
  investisseurPatrimoines?: InputMaybe<ListFilterInputTypeOfInvestisseurPatrimoineFilterInput>;
  /** Liste de tous les QPI de l'investisseur (historique) */
  investisseurQpis?: InputMaybe<ListFilterInputTypeOfMinotaureInvestisseurQpiFilterInput>;
  /** Vision globale par Investisseur des contrats agrégés, reliée par le code investisseur Atlas. */
  investisseurVisionGlobale?: InputMaybe<AgregationInvestisseurVisionGlobaleFilterInput>;
  /** boolean to know if the investisseur is active or not (for logical deletion) */
  isActif?: InputMaybe<BooleanOperationFilterInput>;
  /** is investisseur transfered from Ariane to Minotaure or created directly in Minotaure */
  isTransferedToMinotaure?: InputMaybe<BooleanOperationFilterInput>;
  /** Compte MyStellium de l'investisseur */
  myStelliumInvestisseur?: InputMaybe<MyStelliumInvestisseurFilterInput>;
  objectifDefinis?: InputMaybe<ListFilterInputTypeOfObjectifDefiniFilterInput>;
  operationInvestisseurs?: InputMaybe<ListFilterInputTypeOfOperationInvestisseurFilterInput>;
  or?: InputMaybe<Array<MinotaureInvestisseurFilterInput>>;
  pendingPurge?: InputMaybe<BooleanOperationFilterInput>;
  projetInvestisseurs?: InputMaybe<ListFilterInputTypeOfProjetInvestisseurFilterInput>;
  signedQPI?: InputMaybe<MinotaureInvestisseurQpiFilterInput>;
  /** Le dernier QPI signé et non expiré pour l'investisseur */
  signedQPIId?: InputMaybe<LongOperationFilterInput>;
  /** Synthèse épargne dénormalisée de l'investisseur, maintenue à jour automatiquement */
  syntheseFinanciere?: InputMaybe<InvestisseurSyntheseFinanciereFilterInput>;
  toSyncToAtlas?: InputMaybe<BooleanOperationFilterInput>;
  type?: InputMaybe<TypePersonneOperationFilterInput>;
};

/** Représente un questionnaire de connaissance du client et de son profil d'investisseur. Un même investisseur peut avoir plusieurs questionnaires (historique) mais un seul questionnaire actif à la fois. */
export type MinotaureInvestisseurQpiFilterInput = {
  and?: InputMaybe<Array<MinotaureInvestisseurQpiFilterInput>>;
  /** Détail du calcul de la capacité à supporter des pertes */
  capaciteSupportPertesDetail?: InputMaybe<CapaciteSupportPertesDetailFilterInput>;
  /** Id du document dans la GED (Importé d'Ariane ou signé depuis Minotaure) */
  documentId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<MinotaureInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  /** Détermine si les résultats du QPI et le document associé ont été importés depuis Ariane */
  isImportedFromAriane?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<MinotaureInvestisseurQpiFilterInput>>;
  /** Réponse à la question ESG principale (Q01AESG) extraite des réponses de sensibilité extra-financière */
  reponseESG?: InputMaybe<IntOperationFilterInput>;
  /** Réponses au questionnaire de connaissance du client Harvest (version 1) au format JSON [{id, valeur}] */
  reponsesConnaissanceClientJson?: InputMaybe<StringOperationFilterInput>;
  /** Réponses au questionnaire courant (connaissance et expérience, tolérance au risque) ; null pour un questionnaire d'une version précédente */
  reponsesProfil?: InputMaybe<ReponsesProfilInvestisseurFilterInput>;
  /** Réponses au questionnaire de sensibilité extra-financière au format JSON */
  reponsesSensibiliteExtraFinanciereJson?: InputMaybe<StringOperationFilterInput>;
  /** Réponses au questionnaire de tolérance au risque Harvest (version 1) au format JSON [{id, valeur}] */
  reponsesToleranceAuRisqueJson?: InputMaybe<StringOperationFilterInput>;
  /** Résultat du questionnaire de capacité de perte (1 à 5) */
  resultatCapacitePerte?: InputMaybe<IntOperationFilterInput>;
  /** Résultat du questionnaire de connaissance du client (1 à 3) */
  resultatConnaissance?: InputMaybe<IntOperationFilterInput>;
  /** Profil de risque global: minimum entre Tolerance au risque et Capacité à supporter des pertes (1 à 5) */
  resultatProfilDeRisque?: InputMaybe<IntOperationFilterInput>;
  /** Résultat du questionnaire de sensibilité extra-financière (0 à 3) */
  resultatSensibiliteExtraFinanciere?: InputMaybe<IntOperationFilterInput>;
  /** Résultat du questionnaire de tolérance au risque (1 à 5) */
  resultatToleranceAuRisque?: InputMaybe<IntOperationFilterInput>;
  /** Version du questionnaire du profil investisseur (1 = questionnaire Harvest, 2 = nouveau questionnaire interne) */
  versionProfil?: InputMaybe<IntOperationFilterInput>;
};

/** Représente un questionnaire de connaissance du client et de son profil d'investisseur. Un même investisseur peut avoir plusieurs questionnaires (historique) mais un seul questionnaire actif à la fois. */
export type MinotaureInvestisseurQpiSortInput = {
  /** Détail du calcul de la capacité à supporter des pertes */
  capaciteSupportPertesDetail?: InputMaybe<CapaciteSupportPertesDetailSortInput>;
  /** Id du document dans la GED (Importé d'Ariane ou signé depuis Minotaure) */
  documentId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<MinotaureInvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  /** Détermine si les résultats du QPI et le document associé ont été importés depuis Ariane */
  isImportedFromAriane?: InputMaybe<SortEnumType>;
  /** Réponse à la question ESG principale (Q01AESG) extraite des réponses de sensibilité extra-financière */
  reponseESG?: InputMaybe<SortEnumType>;
  /** Réponses au questionnaire de connaissance du client Harvest (version 1) au format JSON [{id, valeur}] */
  reponsesConnaissanceClientJson?: InputMaybe<SortEnumType>;
  /** Réponses au questionnaire courant (connaissance et expérience, tolérance au risque) ; null pour un questionnaire d'une version précédente */
  reponsesProfil?: InputMaybe<ReponsesProfilInvestisseurSortInput>;
  /** Réponses au questionnaire de sensibilité extra-financière au format JSON */
  reponsesSensibiliteExtraFinanciereJson?: InputMaybe<SortEnumType>;
  /** Réponses au questionnaire de tolérance au risque Harvest (version 1) au format JSON [{id, valeur}] */
  reponsesToleranceAuRisqueJson?: InputMaybe<SortEnumType>;
  /** Résultat du questionnaire de capacité de perte (1 à 5) */
  resultatCapacitePerte?: InputMaybe<SortEnumType>;
  /** Résultat du questionnaire de connaissance du client (1 à 3) */
  resultatConnaissance?: InputMaybe<SortEnumType>;
  /** Profil de risque global: minimum entre Tolerance au risque et Capacité à supporter des pertes (1 à 5) */
  resultatProfilDeRisque?: InputMaybe<SortEnumType>;
  /** Résultat du questionnaire de sensibilité extra-financière (0 à 3) */
  resultatSensibiliteExtraFinanciere?: InputMaybe<SortEnumType>;
  /** Résultat du questionnaire de tolérance au risque (1 à 5) */
  resultatToleranceAuRisque?: InputMaybe<SortEnumType>;
  /** Version du questionnaire du profil investisseur (1 = questionnaire Harvest, 2 = nouveau questionnaire interne) */
  versionProfil?: InputMaybe<SortEnumType>;
};

export type MinotaureInvestisseurSortInput = {
  atlasInvestisseur?: InputMaybe<AtlasInvestisseurSortInput>;
  avancementConnaissanceClientInvestisseur?: InputMaybe<AvancementConnaissanceClientInvestisseurSortInput>;
  bilanFinancier?: InputMaybe<InvestisseurBilanFinancierSortInput>;
  capaciteFinanciere?: InputMaybe<CapaciteFinanciereSortInput>;
  /** Le QPI actuellement actif pour l'investisseur */
  currentQPI?: InputMaybe<MinotaureInvestisseurQpiSortInput>;
  currentQPIId?: InputMaybe<SortEnumType>;
  dateModificationFiche?: InputMaybe<SortEnumType>;
  foyerFiscal?: InputMaybe<FoyerFiscalSortInput>;
  foyerFiscalId?: InputMaybe<SortEnumType>;
  /** Indique si l'investisseur possède une ligne MyStellium. Un investisseur sans ligne est considéré comme non invité. */
  hasMyStelliumInvestisseur?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** boolean to know if the investisseur is active or not (for logical deletion) */
  isActif?: InputMaybe<SortEnumType>;
  /** is investisseur transfered from Ariane to Minotaure or created directly in Minotaure */
  isTransferedToMinotaure?: InputMaybe<SortEnumType>;
  /** Compte MyStellium de l'investisseur */
  myStelliumInvestisseur?: InputMaybe<MyStelliumInvestisseurSortInput>;
  pendingPurge?: InputMaybe<SortEnumType>;
  signedQPI?: InputMaybe<MinotaureInvestisseurQpiSortInput>;
  /** Le dernier QPI signé et non expiré pour l'investisseur */
  signedQPIId?: InputMaybe<SortEnumType>;
  /** Synthèse épargne dénormalisée de l'investisseur, maintenue à jour automatiquement */
  syntheseFinanciere?: InputMaybe<InvestisseurSyntheseFinanciereSortInput>;
  toSyncToAtlas?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type ModeCommunication = {
  __typename?: 'ModeCommunication';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  investisseur: Array<Investisseur>;
  libelle: Scalars['String']['output'];
};


export type ModeCommunicationInvestisseurArgs = {
  where?: InputMaybe<InvestisseurFilterInput>;
};

export type ModeCommunicationFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ModeCommunicationFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  investisseur?: InputMaybe<ListFilterInputTypeOfInvestisseurFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeCommunicationFilterInput>>;
};

export type ModeCommunicationSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type ModeDeGestion = {
  __typename?: 'ModeDeGestion';
  id: Scalars['String']['output'];
  libelle?: Maybe<Scalars['String']['output']>;
};

export type ModeDeGestionConfig = {
  __typename?: 'ModeDeGestionConfig';
  conditionVersementComplementaire?: Maybe<ConditionVersementComplementaire>;
  conditionVersementInitial?: Maybe<ConditionVersementInitial>;
  conditionVersementProgramme?: Maybe<ConditionVersementProgramme>;
  id: Scalars['UUID']['output'];
  modeDeGestion?: Maybe<ModeDeGestion>;
  modeDeGestionId: Scalars['String']['output'];
};

export type ModeDeGestionConfigFilterInput = {
  and?: InputMaybe<Array<ModeDeGestionConfigFilterInput>>;
  conditionVersementComplementaire?: InputMaybe<ConditionVersementComplementaireFilterInput>;
  conditionVersementInitial?: InputMaybe<ConditionVersementInitialFilterInput>;
  conditionVersementProgramme?: InputMaybe<ConditionVersementProgrammeFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modeDeGestion?: InputMaybe<ModeDeGestionFilterInput>;
  modeDeGestionId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeDeGestionConfigFilterInput>>;
};

export type ModeDeGestionFilterInput = {
  and?: InputMaybe<Array<ModeDeGestionFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeDeGestionFilterInput>>;
};

export type ModeDeGestionInput = {
  id: Scalars['String']['input'];
  libelle?: InputMaybe<Scalars['String']['input']>;
};

export type ModeDeGestionSortInput = {
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type ModeGestion = {
  __typename?: 'ModeGestion';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  libelle?: Maybe<Scalars['String']['output']>;
};

/** Mode de gestion principal des produits d'épargne (Q18) */
export enum ModeGestionEpargneEnum {
  AucuneGestion = 'AUCUNE_GESTION',
  Autonome = 'AUTONOME',
  Conseillee = 'CONSEILLEE',
  Deleguee = 'DELEGUEE'
}

export type ModeGestionEpargneEnumOperationFilterInput = {
  eq?: InputMaybe<ModeGestionEpargneEnum>;
  in?: InputMaybe<Array<ModeGestionEpargneEnum>>;
  neq?: InputMaybe<ModeGestionEpargneEnum>;
  nin?: InputMaybe<Array<ModeGestionEpargneEnum>>;
};

export type ModeGestionFilterInput = {
  and?: InputMaybe<Array<ModeGestionFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeGestionFilterInput>>;
};

/** Mode de gestion (Q18) */
export type ModeGestionReferentielDto = {
  __typename?: 'ModeGestionReferentielDto';
  /** Indique que la question du nombre d'opérations (Q18-bis) doit être posée pour ce mode de gestion */
  afficheNombreOperations: Scalars['Boolean']['output'];
  code: ModeGestionEpargneEnum;
  libelle: Scalars['String']['output'];
};

/** Mode de gestion (Q18) */
export type ModeGestionReferentielDtoFilterInput = {
  /** Indique que la question du nombre d'opérations (Q18-bis) doit être posée pour ce mode de gestion */
  afficheNombreOperations?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ModeGestionReferentielDtoFilterInput>>;
  code?: InputMaybe<ModeGestionEpargneEnumOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeGestionReferentielDtoFilterInput>>;
};

export type ModeGestionSortInput = {
  code?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type ModeLogement = {
  __typename?: 'ModeLogement';
  actif?: Maybe<Scalars['Boolean']['output']>;
  adresse: Array<Adresse>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type ModeLogementAdresseArgs = {
  where?: InputMaybe<AdresseFilterInput>;
};

export type ModeLogementFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  adresse?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  and?: InputMaybe<Array<ModeLogementFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeLogementFilterInput>>;
};

export type ModeReponseReadhesion = {
  __typename?: 'ModeReponseReadhesion';
  adhesionConsultant: Array<AdhesionConsultant>;
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type ModeReponseReadhesionAdhesionConsultantArgs = {
  where?: InputMaybe<AdhesionConsultantFilterInput>;
};

export type ModeReponseReadhesionFilterInput = {
  adhesionConsultant?: InputMaybe<ListFilterInputTypeOfAdhesionConsultantFilterInput>;
  and?: InputMaybe<Array<ModeReponseReadhesionFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeReponseReadhesionFilterInput>>;
};

export type ModeSortieCommande = {
  __typename?: 'ModeSortieCommande';
  code: Scalars['Byte']['output'];
  commande: Array<Commande>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};

export type ModeSortieCommandeFilterInput = {
  and?: InputMaybe<Array<ModeSortieCommandeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  commande?: InputMaybe<ListFilterInputTypeOfCommandeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeSortieCommandeFilterInput>>;
};

export type ModeSortieCommandeSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type ModeleDocument = {
  __typename?: 'ModeleDocument';
  categorie: Scalars['String']['output'];
  cifPartenaireCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** 0 pour personne seule, 1 pour couple, null si indifférent */
  investisseurCouple?: Maybe<Scalars['Boolean']['output']>;
  nom: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
};

export type ModeleDocumentFilterInput = {
  and?: InputMaybe<Array<ModeleDocumentFilterInput>>;
  categorie?: InputMaybe<StringOperationFilterInput>;
  cifPartenaireCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  /** 0 pour personne seule, 1 pour couple, null si indifférent */
  investisseurCouple?: InputMaybe<BooleanOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeleDocumentFilterInput>>;
  template?: InputMaybe<StringOperationFilterInput>;
};

export type ModeleDocumentSortInput = {
  categorie?: InputMaybe<SortEnumType>;
  cifPartenaireCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** 0 pour personne seule, 1 pour couple, null si indifférent */
  investisseurCouple?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
  template?: InputMaybe<SortEnumType>;
};

export type MotifAnnulationCommande = {
  __typename?: 'MotifAnnulationCommande';
  code: Scalars['Byte']['output'];
  commande: Array<Commande>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  mouvement: Array<Mouvement>;
  typeMotif: Scalars['Byte']['output'];
  typeMotifNavigation: TypeMotifAnnulationMouvement;
};


export type MotifAnnulationCommandeMouvementArgs = {
  where?: InputMaybe<MouvementFilterInput>;
};

export type MotifAnnulationCommandeFilterInput = {
  and?: InputMaybe<Array<MotifAnnulationCommandeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  commande?: InputMaybe<ListFilterInputTypeOfCommandeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  mouvement?: InputMaybe<ListFilterInputTypeOfMouvementFilterInput>;
  or?: InputMaybe<Array<MotifAnnulationCommandeFilterInput>>;
  typeMotif?: InputMaybe<ByteOperationFilterInput>;
  typeMotifNavigation?: InputMaybe<TypeMotifAnnulationMouvementFilterInput>;
};

export type MotifAnnulationCommandeSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  typeMotif?: InputMaybe<SortEnumType>;
  typeMotifNavigation?: InputMaybe<TypeMotifAnnulationMouvementSortInput>;
};

export type MotifCession = {
  __typename?: 'MotifCession';
  cessionHistoCommande: Array<CessionHistoCommande>;
  cessionHistoInvestisseur: Array<CessionHistoInvestisseur>;
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  type: Scalars['Byte']['output'];
  typeNavigation: TypeMotifCession;
};


export type MotifCessionCessionHistoCommandeArgs = {
  where?: InputMaybe<CessionHistoCommandeFilterInput>;
};


export type MotifCessionCessionHistoInvestisseurArgs = {
  where?: InputMaybe<CessionHistoInvestisseurFilterInput>;
};

export type MotifCessionFilterInput = {
  and?: InputMaybe<Array<MotifCessionFilterInput>>;
  cessionHistoCommande?: InputMaybe<ListFilterInputTypeOfCessionHistoCommandeFilterInput>;
  cessionHistoInvestisseur?: InputMaybe<ListFilterInputTypeOfCessionHistoInvestisseurFilterInput>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MotifCessionFilterInput>>;
  type?: InputMaybe<ByteOperationFilterInput>;
  typeNavigation?: InputMaybe<TypeMotifCessionFilterInput>;
};

export type MotifCessionSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  typeNavigation?: InputMaybe<TypeMotifCessionSortInput>;
};

export type MotifResiliationConsultant = {
  __typename?: 'MotifResiliationConsultant';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultant: Array<Consultant>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type MotifResiliationConsultantConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};

export type MotifResiliationConsultantFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<MotifResiliationConsultantFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MotifResiliationConsultantFilterInput>>;
};

export type MotifResiliationConsultantSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type Mouvement = {
  __typename?: 'Mouvement';
  avecCorrespondant: Scalars['Boolean']['output'];
  baseCommission?: Maybe<Scalars['Decimal']['output']>;
  commande: Commande;
  commandeId: Scalars['Long']['output'];
  consultantMouvement: Array<ConsultantMouvement>;
  creationDate: Scalars['DateTime']['output'];
  dateActe?: Maybe<Scalars['DateTime']['output']>;
  dateAnnulation?: Maybe<Scalars['DateTime']['output']>;
  dateDebutMouvement?: Maybe<Scalars['DateTime']['output']>;
  dateFinMouvement?: Maybe<Scalars['DateTime']['output']>;
  dateTraitement?: Maybe<Scalars['DateTime']['output']>;
  dateValeur?: Maybe<Scalars['DateTime']['output']>;
  dateValidationComptable?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatMouvement: EtatMouvement;
  etatMouvementId: Scalars['Byte']['output'];
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  montantFraisReels?: Maybe<Scalars['Decimal']['output']>;
  montantVersement?: Maybe<Scalars['Decimal']['output']>;
  motifAnnulation?: Maybe<MotifAnnulationCommande>;
  motifAnnulationId?: Maybe<Scalars['Byte']['output']>;
  natureMouvement: NatureMouvement;
  natureMouvementId: Scalars['Byte']['output'];
  nouveauxFrais?: Maybe<Scalars['Decimal']['output']>;
  periodicite?: Maybe<PeriodiciteMouvement>;
  periodiciteId?: Maybe<Scalars['Byte']['output']>;
  pointValeurStrategique?: Maybe<Scalars['Decimal']['output']>;
  reductionLignee: Scalars['Boolean']['output'];
  tauxFraisProduit?: Maybe<Scalars['Decimal']['output']>;
};


export type MouvementConsultantMouvementArgs = {
  where?: InputMaybe<ConsultantMouvementFilterInput>;
};

export type MouvementFilterInput = {
  and?: InputMaybe<Array<MouvementFilterInput>>;
  avecCorrespondant?: InputMaybe<BooleanOperationFilterInput>;
  baseCommission?: InputMaybe<DecimalOperationFilterInput>;
  commande?: InputMaybe<CommandeFilterInput>;
  commandeId?: InputMaybe<LongOperationFilterInput>;
  consultantMouvement?: InputMaybe<ListFilterInputTypeOfConsultantMouvementFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateActe?: InputMaybe<DateTimeOperationFilterInput>;
  dateAnnulation?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebutMouvement?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinMouvement?: InputMaybe<DateTimeOperationFilterInput>;
  dateTraitement?: InputMaybe<DateTimeOperationFilterInput>;
  dateValeur?: InputMaybe<DateTimeOperationFilterInput>;
  dateValidationComptable?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatMouvement?: InputMaybe<EtatMouvementFilterInput>;
  etatMouvementId?: InputMaybe<ByteOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  montantFraisReels?: InputMaybe<DecimalOperationFilterInput>;
  montantVersement?: InputMaybe<DecimalOperationFilterInput>;
  motifAnnulation?: InputMaybe<MotifAnnulationCommandeFilterInput>;
  motifAnnulationId?: InputMaybe<ByteOperationFilterInput>;
  natureMouvement?: InputMaybe<NatureMouvementFilterInput>;
  natureMouvementId?: InputMaybe<ByteOperationFilterInput>;
  nouveauxFrais?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<MouvementFilterInput>>;
  periodicite?: InputMaybe<PeriodiciteMouvementFilterInput>;
  periodiciteId?: InputMaybe<ByteOperationFilterInput>;
  pointValeurStrategique?: InputMaybe<DecimalOperationFilterInput>;
  reductionLignee?: InputMaybe<BooleanOperationFilterInput>;
  tauxFraisProduit?: InputMaybe<DecimalOperationFilterInput>;
};

export type MouvementSortInput = {
  avecCorrespondant?: InputMaybe<SortEnumType>;
  baseCommission?: InputMaybe<SortEnumType>;
  commande?: InputMaybe<CommandeSortInput>;
  commandeId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateActe?: InputMaybe<SortEnumType>;
  dateAnnulation?: InputMaybe<SortEnumType>;
  dateDebutMouvement?: InputMaybe<SortEnumType>;
  dateFinMouvement?: InputMaybe<SortEnumType>;
  dateTraitement?: InputMaybe<SortEnumType>;
  dateValeur?: InputMaybe<SortEnumType>;
  dateValidationComptable?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  etatMouvement?: InputMaybe<EtatMouvementSortInput>;
  etatMouvementId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  montantFraisReels?: InputMaybe<SortEnumType>;
  montantVersement?: InputMaybe<SortEnumType>;
  motifAnnulation?: InputMaybe<MotifAnnulationCommandeSortInput>;
  motifAnnulationId?: InputMaybe<SortEnumType>;
  natureMouvement?: InputMaybe<NatureMouvementSortInput>;
  natureMouvementId?: InputMaybe<SortEnumType>;
  nouveauxFrais?: InputMaybe<SortEnumType>;
  periodicite?: InputMaybe<PeriodiciteMouvementSortInput>;
  periodiciteId?: InputMaybe<SortEnumType>;
  pointValeurStrategique?: InputMaybe<SortEnumType>;
  reductionLignee?: InputMaybe<SortEnumType>;
  tauxFraisProduit?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type MouvementsPaginatedCollectionSegment = {
  __typename?: 'MouvementsPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Mouvement>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Acquitte explicitement la suppression du bulletin détaché après vérification de son état inactif dans la GED. Un document encore actif ne peut pas être acquitté. */
  acknowledgeOperationSouscriptionBulletinDeletion: OperationData;
  /** Active une configuration et désactive les configurations actives de mêmes critères. Signale les opérations concernées et peut migrer celles non verrouillées n'ayant pas dépassé Signature. */
  activateOperationConfig: ActivateOperationConfigPayload;
  /** Add or update Carte de démarchage */
  addOrUpdateCarteDemarchage: Scalars['Boolean']['output'];
  /** Add or update Pièce Justificative */
  addOrUpdatePieceJustificative: Scalars['Boolean']['output'];
  /** Add or update RCP */
  addOrUpdateRcp: Scalars['Boolean']['output'];
  /** Creates a RelationCouple */
  addRelationCouple: Scalars['Boolean']['output'];
  addRelationCoupleAndUpdateConnaissanceClient: Scalars['Boolean']['output'];
  /** Turns the Consultant state from 'Prospect' to 'Affilié' */
  affiliationConsultant: ConsultantId;
  apicilSsoUrl?: Maybe<Scalars['String']['output']>;
  /** Applique atomiquement les allocations, options automatiques, fonds événementiels et configurations d'opération après vérification du hash du fichier. */
  applyOperationConfigImport: OperationConfigImportApplyResult;
  /** Rattache le fichier uploadé à l'allocation et désactive l'ancien fichier le cas échéant. */
  attachAllocationFile: Allocation;
  /** Joint au projet un document déjà déposé dans la GED. */
  attachProjetDocument: ProjetDocument;
  /** Calculate loose capacity score for the given investisseur ID.Requires the user to be a consultant and have rights on the specified investisseur. */
  calculateScoreCapacitePerte: CapaciteSupportPertesDetail;
  /** Calculate ESG score for the given investisseur ID.Requires the user to be a consultant and have rights on the specified investisseur. */
  calculateScoreESG: InvestisseurQpi;
  /** Cancel the signatures */
  cancelSignatures: Array<Scalars['String']['output']>;
  /** Vérifie l'accès aux investisseurs demandés et si necessaire crée les investisseurs et leurs foyers fiscaux dans Minotaure. Retourne ces investisseurs. */
  checkInvestisseurs: Array<Investisseur>;
  /** Technical operation : compute habilitations for one Statut Juridique */
  computeHabilitations: Array<HabilitationInfo>;
  /** Technical operation : compute habilitations for a batch of Statuts Juridiques */
  computeHabilitationsBatch: Array<HabilitationInfo>;
  /** Technical operation : compute habilitations for all active Statuts Juridiques */
  computeHabilitationsForActiveStatutsJuridiques: Scalars['String']['output'];
  /** Technical operation : compute latest habilitation changes */
  computeLatestHabilitationChanges: Scalars['String']['output'];
  /** Technical operation : compute habilitations that require update */
  computeRequiredHabilitations: Array<HabilitationInfo>;
  /** Crée un fichier PDF temporaire pour l'allocation donnée et retourne une URL SAS d'écriture. */
  createAllocationFileUpload: StorageFileWithConnectionInfo;
  createBudget: Array<Budget>;
  createConsultantFileMetadata: FileMetadata;
  /** Creates a new Consultant */
  createConsultantProspect: ConsultantId;
  createContact: Array<Scalars['String']['output']>;
  createFicheConseilStorageFile: StorageFileWithConnectionInfo;
  createFileMetadata: FileMetadata;
  /** Creates a new Investisseur or a couple of Investisseurs */
  createInvestisseur: Array<Investisseur>;
  /** Crée un fichier temporaire DOCX pour un template JSReport et retourne une URL SAS d'écriture. */
  createJsReportTemplateFile: StorageFileWithConnectionInfo;
  /** Crée la configuration d'une vague de migration. */
  createMigrationWaveJob?: Maybe<WaveMigrationJob>;
  createMinotaureInvestisseur: Scalars['Boolean']['output'];
  createOperationBoxPlacement?: Maybe<CreateOperationBoxPlacementResult>;
  /** Crée un fichier temporaire pour importer les allocations, options automatiques et configurations d'opération, puis retourne une URL SAS d'écriture. */
  createOperationConfigImportFile: StorageFileWithConnectionInfo;
  createOrUpdateConsultantPreferences: Array<ConsultantPreferences>;
  createOrUpdatePatrimoine: InvestisseurPatrimoine;
  createProjet: Scalars['Long']['output'];
  createRecherche?: Maybe<RechercheSauvegarde>;
  /** Create the signature document */
  createSignatures: Array<Scalars['String']['output']>;
  createSouscription: Scalars['UUID']['output'];
  /** Supprime le fichier d'allocation rattaché à l'allocation donnée. */
  deleteAllocationFile: Allocation;
  deleteBudget: Scalars['Boolean']['output'];
  /** Deletes a Consultant Prospect */
  deleteConsultantProspect: ConsultantId;
  /** Deletes a document (sets metadata.Actif to false) */
  deleteDocument: Scalars['Boolean']['output'];
  deleteOperation: Scalars['Boolean']['output'];
  deletePatrimoine: Scalars['Boolean']['output'];
  /** Supprime le projet après avoir supprimé ses documents joints dans la GED. */
  deleteProjet: Scalars['Boolean']['output'];
  /** Supprime le document dans la GED puis le retire du projet. */
  deleteProjetDocument: Scalars['Boolean']['output'];
  deleteRecherche: Scalars['Boolean']['output'];
  /** Delete the RelationAutre of an Investor */
  deleteRelationAutre?: Maybe<Scalars['Int']['output']>;
  /** Delete the RelationCouple of an Investor */
  deleteRelationCouple: Scalars['Boolean']['output'];
  deleteRelationCoupleAndUpdateConnaissanceClient: Scalars['Boolean']['output'];
  /** Delete the RelationFamille of an Investor */
  deleteRelationFamille?: Maybe<Scalars['Int']['output']>;
  deprecateStorageFile: Array<StorageFile>;
  /** Détache explicitement le bulletin de souscription et planifie sa suppression logique GED. La date de signature est conservée. Répéter la demande pour le même bulletin en attente est sans effet. */
  detachOperationSouscriptionBulletin: OperationData;
  /** Corrige les erreurs de cohérence éventuelles de la connaissance client pour l'investisseur */
  ensureConnaissanceClientDataCoherence: Scalars['Boolean']['output'];
  /** Technical operation : evaluate de forthcoming expirations of habilitations */
  evaluateHabilitationExpirations: Scalars['String']['output'];
  /** returns the last generated DER metadata or generates a new one if it does not exist or is not up to date (ie if consultant habilitations have changed since the last generation). */
  existingDEROrGenerateIt?: Maybe<DerResponse>;
  /** Exporte la liste des vagues de migration et des consultants associés */
  exportMigrationPlanningAllConsultants?: Maybe<StorageFile>;
  /** Exporte la liste des investisseurs d'une vague de migration qui ont été mis à jour dans Ariane après la migration. */
  exportWaveEcartInvestisseurUpdatedInAriane?: Maybe<StorageFile>;
  /** Exporte la liste des investisseurs de l'écart Ariane-Atlas d'une vague de migration. */
  exportWaveMigrationEcartInvestisseurs?: Maybe<StorageFile>;
  /** Exporte la liste des consultants d'une vague de migration. */
  exportWaveMigrationJobData?: Maybe<StorageFile>;
  /** Exporte la liste des signatures en cours lors de l'import d'une vague */
  exportWaveMigrationPendingSignatures?: Maybe<StorageFile>;
  /** Remplit les données manquantes sur les signatures des investisseurs qui ont un écart Ariane-Atlas. Retourne 'COMPLETED' si données pour cette vague sont complètes. Le paramètre maxArianeCalls permet de limiter le nombre de calls à l'api polygone par requête. */
  fillDataEcartInvestisseurs: EcartInvestisseurSyncResult;
  /** force DER generation and returns the generated file metadata. */
  forceDERUpdate?: Maybe<DerResponse>;
  forceRefreshUserAccessRight: UserAccessRight;
  /** Refresh consultant cache from technical or backoffice action */
  forceRefreshUserAccessRightByConsultantCode?: Maybe<UserAccessRight>;
  /** Force le recalcul et la persistance des données de synthèse financière pour les investisseurs sélectionnés via un filtre GraphQL. */
  forceSyntheseFinanciereRecalculation: ForceSyntheseFinanciereRecalculationResult;
  generateContratsAgregationBackOfficeExport?: Maybe<AgregationStorageFileModel>;
  generateContratsAgregationExport?: Maybe<AgregationStorageFileModel>;
  generateContratsBySupportAgregationBackOfficeExport?: Maybe<AgregationStorageFileModel>;
  generateContratsBySupportAgregationExport?: Maybe<AgregationStorageFileModel>;
  generateCsvExport?: Maybe<StorageFile>;
  generateDocumentFromModel?: Maybe<StorageFile>;
  /** Évalue le snapshot enregistré et sauvegarde le rapport courant ; le réutilise lorsque les entrées sont inchangées. */
  generateOperationAdequation: OperationAdequationPayload;
  /** Génère le document conseil pour l'opération indiquée et retourne le fichier créé. */
  generateOperationConseil?: Maybe<StorageFile>;
  /** Génère l'aperçu du document conseil de l'opération, annexe d'allocation incluse, dans un fichier temporaire non rattaché à l'opération. */
  generateOperationConseilPreview?: Maybe<StorageFile>;
  /** Generates a QPI for the given investisseur ID.Requires the user to be a consultant and have rights on the specified investisseur. */
  generateQPI?: Maybe<StorageFile>;
  /** Generates a recueil for the given investisseurs IDs. Requires the user to be a consultant and have rights on all specified investisseurs. */
  generateRecueil?: Maybe<StorageFile>;
  generateSupportsAgregationBackOfficeExport?: Maybe<AgregationStorageFileModel>;
  generateSupportsAgregationExport?: Maybe<AgregationStorageFileModel>;
  /** Generates the synthese patrimonial file. */
  generateSyntesePatrimonial?: Maybe<StorageFile>;
  /** Initialise le QPI (vide) pour un investisseur */
  initInvestisseurQpi: InvestisseurQpi;
  /** Met à jour les entitées nécessaires suite au passage à la retraite d'un investisseur */
  manageInvestisseurRetraite: Scalars['Boolean']['output'];
  /** BackOffice action in order to override an habilitation status */
  overrideHabilitationStatus: Scalars['Boolean']['output'];
  /** Créé un ArianeProcessJob de patch. Permet de patcher des propriétés d'investisseurs déjà importés */
  patchImportedData: Scalars['String']['output'];
  /** Lance les process liés au transfert d'investisseurs (suppression des etiquettes) */
  proceedInvestisseurTransfer: Scalars['Boolean']['output'];
  /** Technical operation : refresh statuts commerciaux & habilitations flags and */
  refreshStatutsCommerciauxAndHabilitationFlags: Scalars['String']['output'];
  /** Technical operation : register an EquivalenceDeFormation */
  registerEquivalenceDeFormation: Scalars['Boolean']['output'];
  /** Technical operation : register an IMMO inscription */
  registerInscriptionImmo: Scalars['Boolean']['output'];
  /** Relance signatures */
  relanceSignatures: Scalars['Boolean']['output'];
  /** Vérifie puis demande la purge RGPD DoublonsBuster pour l'investisseur si aucun contrôle bloquant n'est remonté. */
  requestInvestisseurPurge: InvestorPurgeRequestResult;
  /** Supprime les données signatures  et doublons des investisseurs qui ont un écart Ariane-Atlas. Permet de Refaire une synchro avec Ariane ensuite */
  resetDataEcartInvestisseurs: Scalars['Boolean']['output'];
  /** Efface les informations de signature de l'opération (mode, verrou, documents) et recrée les emplacements des documents requis vides. */
  resetOperationSignature: OperationData;
  /** Résiliation Consultant */
  resiliationConsultant: Scalars['Boolean']['output'];
  /** Relance l'import pour les job correspondant au filtre. */
  restartArianeDump: Scalars['String']['output'];
  /** Pour l'investisseur du job Failed demande, relance le plus ancien echec non couvert par un succes plus recent, en lui donnant la priorite la plus forte des echecs restants. Retourne false si aucun echec pertinent ne reste. */
  restartFailedFinancialRecalculationJob: Scalars['Boolean']['output'];
  /** Le filtre selectionne les investisseurs. Pour chacun, relance le plus ancien job Failed non couvert par un succes plus recent, avec la priorite la plus forte des echecs restants, et abandonne les autres echecs. Retourne le nombre de jobs relances. */
  restartFailedFinancialRecalculationJobs: Scalars['Int']['output'];
  /** Restart a QPI for the given investisseur ID. */
  restartInvestisseurQPI: InvestisseurQpi;
  /** Relance le traitement des données importées d'Ariane pour les job correspondant au filtre. */
  restartProcessArianeData: Scalars['String']['output'];
  /** Enregistre les réponses du questionnaire Connaissance et expérience v2 (calcul interne, sans Harvest). Requires the user to be a consultant and have rights on the specified investisseur. */
  saveConnaissanceExperience: InvestisseurQpi;
  /** Enregistre les réponses du questionnaire Tolérance au risque v2 (calcul interne, sans Harvest). Requires the user to be a consultant and have rights on the specified investisseur. */
  saveToleranceRisque: InvestisseurQpi;
  /** Planifie une page de jobs Bulk de recalcul de la synthese et du bilan financiers uniquement pour les investisseurs selectionnes. Les conjoints doivent etre explicitement inclus dans la selection. */
  scheduleInvestisseurFinancialRecalculation: FinancialRecalculationScheduleResult;
  /** Génère les documents manquants, les dépose dans la GED, crée les signatures et met à jour les documents de l'opération. */
  sendOperationSignatures: OperationData;
  /** Set all the actuelCommissionAdiType according to the commissionAdi type chosen by the consultants */
  setActuelByChoixCommissionAdi: Scalars['Boolean']['output'];
  /** Modifie les droits d'accès Minotaure pour les consultants du filtre */
  setConsultantsAccess: Scalars['String']['output'];
  /** Modifie les droits d'accès Minotaure pour les consultants d'une vague */
  setConsultantsAccessByWaveId: Scalars['String']['output'];
  /** Enregistre en base le nombre de workers financiers souhaite (1 a 20), conserve au redemarrage et applique par l'API d'import apres sa prochaine lecture, toutes les 5 secondes. Une diminution annule les traitements des workers retires. */
  setFinancialRecalculationWorkerCount: Scalars['Int']['output'];
  /** Sets batch the reference application for an Investisseur to given value */
  setReferenceAppForInvestisseursBatch: Scalars['Boolean']['output'];
  /** Set a Consultant's SouhaiteCollaborerAvecStelliumFi */
  setSouhaiteCollaborerAvecStelliumFiConsultant: Consultant;
  /** BackOffice action in order to stop overriding an habilitation status */
  stopOverridingHabilitationStatus: Scalars['Boolean']['output'];
  surAvenirContratUrl?: Maybe<Scalars['String']['output']>;
  /** Applique la sélection automatique des produits d'épargne d'après le recueil et renvoie les produits nouvellement sélectionnés. Requires the user to be a consultant and have rights on the specified investisseur. */
  synchroniserSelectionAutoRecueil: SelectionAutoRecueilResultatDto;
  /** Transfer Investisseur(s) from one Consultant to another */
  transfertClients: Scalars['Boolean']['output'];
  /** Updates ArianeIds for a newly created Investisseur or a couple of newly created Investisseurs */
  updateArianeIdsForCreatedInvestisseur: Scalars['Boolean']['output'];
  updateBudget: Array<Budget>;
  /** Update a CommissionAdiType as chosen by the consultant */
  updateChoixConsultantCommissionAdi: ConsultantCommissionAdi;
  updateClientSituationPersonnelleState?: Maybe<MetadatasConnaissanceClient>;
  updateDERStateFromConsultantData: Scalars['Boolean']['output'];
  /** Update a Consultant's DateDemission */
  updateDateDemissionConsultant: Consultant;
  /** Update a Consultant's DateFinValiditeAffiliation */
  updateDateFinValiditeAffiliationConsultant: Consultant;
  updateDateModificationFiche: Scalars['Boolean']['output'];
  updateEtiquettes: Array<EtiquetteDto>;
  updateFileMetadata?: Maybe<FileMetadata>;
  updateFoyerFiscalData?: Maybe<FoyerFiscal>;
  /** Met à jour la liste des galaxies dans les vagues de migration  non terminées. */
  updateGalaxyListInWaves: Scalars['Boolean']['output'];
  updateInvestisseurBilanFinancier?: Maybe<InvestisseurBilanFinancier>;
  updateInvestisseurDERState?: Maybe<MetadatasConnaissanceClient>;
  /** Update an investor Donation */
  updateInvestisseurDonation: Scalars['Boolean']['output'];
  updateInvestisseurPieceIdentiteState?: Maybe<MetadatasConnaissanceClient>;
  updateInvestisseurQPIState?: Maybe<MetadatasConnaissanceClient>;
  updateInvestisseurRecueilState?: Maybe<MetadatasConnaissanceClient>;
  /** Update an investor with his SituationPersonnelle */
  updateInvestisseurSituationPersonnelle: Scalars['Boolean']['output'];
  updateObjectifStep?: Maybe<Scalars['Boolean']['output']>;
  updateOperationAllocationConsultantFile: Scalars['Boolean']['output'];
  /** Met à jour la configuration et les données d'une opération, puis génère le rapport d'adéquation. */
  updateOperationAndGenerateAdequation: OperationAdequationPayload;
  /** Récupère les derniers snapshots disponibles des investisseurs liés et met à jour les données de l'opération. */
  updateOperationData?: Maybe<OperationData>;
  updateOperationProduit: Scalars['Boolean']['output'];
  updateOperationStatut: Scalars['Boolean']['output'];
  updatePatrimoineContrat?: Maybe<InvestisseurPatrimoine>;
  updateProjet: Projet;
  updateRecherche?: Maybe<RechercheSauvegarde>;
  updateSituationPersonnelle: Scalars['Boolean']['output'];
  /** Publie un template DOCX dans JSReport, en conserve une copie versionnée dans Blob et l'associe à une configuration d'opération. */
  uploadJsReportTemplate: ConfigTemplate;
  /** Creates or update an Investor with his RelationAutre */
  upsertInvestisseurRelationAutre: Scalars['Long']['output'];
  /** Creates or update an Investor with his RelationFamille */
  upsertInvestisseurRelationFamille: Scalars['Long']['output'];
  /** Crée ou met à jour les données d'une opération. Les valeurs nulles ne remplacent pas les données existantes. Un changement de mode de signature de souscription réinitialise côté serveur la date et le bulletin associés. */
  upsertOperationData: OperationData;
  /** Vérifie ensemble les allocations, options automatiques, fonds événementiels et configurations d'opération du fichier sans modifier les données métier. */
  verifyOperationConfigImport: OperationConfigImportVerificationResult;
  /** Passe tous les consultant d'une vague sur Minotaure et les synchronise avec le LDAP en arrière-plan, puis passe la vague en TODO */
  waveSyncBeforeLaunch: Scalars['String']['output'];
};


export type MutationAcknowledgeOperationSouscriptionBulletinDeletionArgs = {
  fileId: Scalars['String']['input'];
  operationId: Scalars['UUID']['input'];
  produitId: Scalars['Long']['input'];
};


export type MutationActivateOperationConfigArgs = {
  input: ActivateOperationConfigInput;
};


export type MutationAddOrUpdateCarteDemarchageArgs = {
  carteDemarchageData: CarteDemarchageInput;
};


export type MutationAddOrUpdatePieceJustificativeArgs = {
  pjData: PieceJustificativeInput;
};


export type MutationAddOrUpdateRcpArgs = {
  rcpData: PieceJustificativeRcpInput;
};


export type MutationAddRelationCoupleArgs = {
  forceDeleteExistingRelationCouple?: InputMaybe<Scalars['Boolean']['input']>;
  input: RelationCoupleInput;
};


export type MutationAddRelationCoupleAndUpdateConnaissanceClientArgs = {
  input: AddRelationCoupleInput;
};


export type MutationAffiliationConsultantArgs = {
  consultantData: FilleulDataInput;
};


export type MutationApicilSsoUrlArgs = {
  contratId: Scalars['String']['input'];
};


export type MutationApplyOperationConfigImportArgs = {
  expectedFileHash: Scalars['String']['input'];
  storageFileId: Scalars['String']['input'];
};


export type MutationAttachAllocationFileArgs = {
  allocationId: Scalars['String']['input'];
  storageFileId: Scalars['String']['input'];
};


export type MutationAttachProjetDocumentArgs = {
  fileId: Scalars['String']['input'];
  projetId: Scalars['Long']['input'];
};


export type MutationCalculateScoreCapacitePerteArgs = {
  investisseurPrincipalId: Scalars['Long']['input'];
};


export type MutationCalculateScoreEsgArgs = {
  formInput: QpiFormInput;
};


export type MutationCancelSignaturesArgs = {
  documentIds: Array<Scalars['String']['input']>;
};


export type MutationCheckInvestisseursArgs = {
  investisseurIds: Array<Scalars['Long']['input']>;
};


export type MutationComputeHabilitationsArgs = {
  idStatutJuridique: Scalars['Long']['input'];
  updateHabilitationFlags: Scalars['Boolean']['input'];
};


export type MutationComputeHabilitationsBatchArgs = {
  idsStatutsJuridiques: Array<Scalars['Long']['input']>;
  updateHabilitationFlags: Scalars['Boolean']['input'];
};


export type MutationComputeHabilitationsForActiveStatutsJuridiquesArgs = {
  applyLatestOriasStates: Scalars['Boolean']['input'];
  updateHabilitationFlags: Scalars['Boolean']['input'];
};


export type MutationComputeLatestHabilitationChangesArgs = {
  applyCciChanges: Scalars['Boolean']['input'];
  applyOriasChanges: Scalars['Boolean']['input'];
  updateHabilitationFlags: Scalars['Boolean']['input'];
};


export type MutationComputeRequiredHabilitationsArgs = {
  restrictToHabilitation: Scalars['Boolean']['input'];
  saveChanges: Scalars['Boolean']['input'];
  updateHabilitationFlags: Scalars['Boolean']['input'];
};


export type MutationCreateAllocationFileUploadArgs = {
  allocationId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationCreateBudgetArgs = {
  input: BudgetCreationInput;
};


export type MutationCreateConsultantFileMetadataArgs = {
  consultantId: Scalars['Long']['input'];
  dateDeDebutValidite?: InputMaybe<Scalars['DateTime']['input']>;
  dateFinValidite?: InputMaybe<Scalars['DateTime']['input']>;
  denomination: Scalars['String']['input'];
  nomDeFichier: Scalars['String']['input'];
  typeCode: Scalars['String']['input'];
};


export type MutationCreateContactArgs = {
  input: ContactCreationInput;
  isJumpContact?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateFicheConseilStorageFileArgs = {
  input: CreateStorageFileInput;
};


export type MutationCreateFileMetadataArgs = {
  categorieCode?: InputMaybe<GedCategory>;
  dateDeReference?: InputMaybe<Scalars['LocalDate']['input']>;
  dateFinValidite?: InputMaybe<Scalars['DateTime']['input']>;
  dateSignature?: InputMaybe<Scalars['DateTime']['input']>;
  denomination: Scalars['String']['input'];
  documentType?: InputMaybe<GedDocumentType>;
  investisseurId: Scalars['Long']['input'];
  investisseurIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  isHandwrittenSignature?: InputMaybe<Scalars['Boolean']['input']>;
  nomDeFichier: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  typeCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateInvestisseurArgs = {
  input: InvestisseurCreationInput;
};


export type MutationCreateJsReportTemplateFileArgs = {
  fileName: Scalars['String']['input'];
};


export type MutationCreateMigrationWaveJobArgs = {
  consultantCodes: Array<Scalars['String']['input']>;
  consultantIds: Array<Scalars['Long']['input']>;
  galaxyCodes: Array<Scalars['String']['input']>;
  galaxyIds: Array<Scalars['Long']['input']>;
  initialStatus: JobStatus;
  isPreImport: Scalars['Boolean']['input'];
  plannedStartMigrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  priority: Scalars['Int']['input'];
  shouldAutomaticallyProcess: Scalars['Boolean']['input'];
  waveLabel: Scalars['String']['input'];
};


export type MutationCreateMinotaureInvestisseurArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type MutationCreateOperationBoxPlacementArgs = {
  input: CreateOperationFromProxeemaInput;
};


export type MutationCreateOrUpdateConsultantPreferencesArgs = {
  input: ConsultantPreferencesInput;
};


export type MutationCreateOrUpdatePatrimoineArgs = {
  patrimoineInput: PatrimoineInput;
};


export type MutationCreateProjetArgs = {
  input: ProjectCreationInput;
};


export type MutationCreateRechercheArgs = {
  rechercheInput: CreateRechercheInput;
};


export type MutationCreateSignaturesArgs = {
  input: Array<DocumentSignatureInput>;
};


export type MutationCreateSouscriptionArgs = {
  input: SouscriptionCreationInput;
};


export type MutationDeleteAllocationFileArgs = {
  allocationId: Scalars['String']['input'];
};


export type MutationDeleteBudgetArgs = {
  budgetId: Scalars['Long']['input'];
};


export type MutationDeleteConsultantProspectArgs = {
  consultantCode: Scalars['String']['input'];
};


export type MutationDeleteDocumentArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationDeleteOperationArgs = {
  operationId: Scalars['UUID']['input'];
};


export type MutationDeletePatrimoineArgs = {
  id: Scalars['Long']['input'];
};


export type MutationDeleteProjetArgs = {
  projectId: Scalars['Long']['input'];
};


export type MutationDeleteProjetDocumentArgs = {
  projetDocumentId: Scalars['Long']['input'];
};


export type MutationDeleteRechercheArgs = {
  rechercheId: Scalars['Long']['input'];
};


export type MutationDeleteRelationAutreArgs = {
  input: DeleteRelationInput;
};


export type MutationDeleteRelationCoupleArgs = {
  input: DeleteRelationInput;
  shouldUpdateFoyerFiscal?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteRelationCoupleAndUpdateConnaissanceClientArgs = {
  input: DeleteRelationCoupleInput;
};


export type MutationDeleteRelationFamilleArgs = {
  input: DeleteRelationInput;
};


export type MutationDeprecateStorageFileArgs = {
  storageFileId: Scalars['String']['input'];
};


export type MutationDetachOperationSouscriptionBulletinArgs = {
  fileId: Scalars['String']['input'];
  operationId: Scalars['UUID']['input'];
  produitId: Scalars['Long']['input'];
};


export type MutationEnsureConnaissanceClientDataCoherenceArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type MutationEvaluateHabilitationExpirationsArgs = {
  timeBeforeHabilitationLossDueToFormationContinueOrInscription: Scalars['TimeSpan']['input'];
  timeBeforeHabilitationLossDueToRcpExpiry: Scalars['TimeSpan']['input'];
};


export type MutationExistingDerOrGenerateItArgs = {
  consultantCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExportWaveEcartInvestisseurUpdatedInArianeArgs = {
  waveMigrationJobId: Scalars['Long']['input'];
};


export type MutationExportWaveMigrationEcartInvestisseursArgs = {
  waveMigrationJobId: Scalars['Long']['input'];
};


export type MutationExportWaveMigrationJobDataArgs = {
  waveMigrationJobId: Scalars['Long']['input'];
};


export type MutationExportWaveMigrationPendingSignaturesArgs = {
  waveMigrationJobId: Scalars['Long']['input'];
};


export type MutationFillDataEcartInvestisseursArgs = {
  maxArianeCalls?: Scalars['Int']['input'];
  waveMigrationJobId: Scalars['Long']['input'];
};


export type MutationForceDerUpdateArgs = {
  consultantCode?: InputMaybe<Scalars['String']['input']>;
  investisseurId: Scalars['Long']['input'];
};


export type MutationForceRefreshUserAccessRightByConsultantCodeArgs = {
  consultantCode: Scalars['String']['input'];
};


export type MutationForceSyntheseFinanciereRecalculationArgs = {
  cursor?: InputMaybe<Scalars['Long']['input']>;
  maxCount?: Scalars['Int']['input'];
  where?: InputMaybe<MinotaureInvestisseurFilterInput>;
};


export type MutationGenerateContratsAgregationBackOfficeExportArgs = {
  filter: ContratBackOfficeFilterInput;
};


export type MutationGenerateContratsAgregationExportArgs = {
  filter: ContratConsultantFilterInput;
};


export type MutationGenerateContratsBySupportAgregationBackOfficeExportArgs = {
  filter: ContratBackOfficeFilterInput;
};


export type MutationGenerateContratsBySupportAgregationExportArgs = {
  filter: ContratConsultantFilterInput;
};


export type MutationGenerateCsvExportArgs = {
  order?: InputMaybe<Array<MinotaureInvestisseurSortInput>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<MinotaureInvestisseurFilterInput>;
};


export type MutationGenerateDocumentFromModelArgs = {
  coInvestisseurId?: InputMaybe<Scalars['Long']['input']>;
  consultantCode?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  investisseurId: Scalars['Long']['input'];
  template: Scalars['String']['input'];
};


export type MutationGenerateOperationAdequationArgs = {
  input: GenerateOperationAdequationInput;
};


export type MutationGenerateOperationConseilArgs = {
  operationId: Scalars['UUID']['input'];
};


export type MutationGenerateOperationConseilPreviewArgs = {
  operationId: Scalars['UUID']['input'];
};


export type MutationGenerateQpiArgs = {
  investisseurPrincipalId: Scalars['Long']['input'];
};


export type MutationGenerateRecueilArgs = {
  avecCoInvestisseur: Scalars['Boolean']['input'];
  investisseurPrincipalId: Scalars['Long']['input'];
  recueilMetadataId: Scalars['Long']['input'];
};


export type MutationGenerateSupportsAgregationBackOfficeExportArgs = {
  filter: SupportConsultantFilterInput;
};


export type MutationGenerateSupportsAgregationExportArgs = {
  filter: SupportConsultantFilterInput;
};


export type MutationGenerateSyntesePatrimonialArgs = {
  avecCoInvestisseur: Scalars['Boolean']['input'];
  consultantCode?: InputMaybe<Scalars['String']['input']>;
  investisseurId: Scalars['Long']['input'];
  pyramidChartImage?: InputMaybe<Scalars['String']['input']>;
  recueilMetadataId: Scalars['Long']['input'];
};


export type MutationInitInvestisseurQpiArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type MutationManageInvestisseurRetraiteArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type MutationOverrideHabilitationStatusArgs = {
  backOfficeAction: HabilitationStatusOverrideInput;
};


export type MutationPatchImportedDataArgs = {
  fieldsToPatch: Array<PatchFields>;
  where?: InputMaybe<ArianeDumpJobFilterInput>;
};


export type MutationProceedInvestisseurTransferArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  delayInHours?: Scalars['Float']['input'];
  skip?: Scalars['Int']['input'];
};


export type MutationRefreshStatutsCommerciauxAndHabilitationFlagsArgs = {
  consultantId?: InputMaybe<Scalars['Long']['input']>;
};


export type MutationRegisterEquivalenceDeFormationArgs = {
  equivalenceDeFormation: EquivalenceDeFormationInput;
};


export type MutationRegisterInscriptionImmoArgs = {
  computeHabilitationAndApplyChanges: Scalars['Boolean']['input'];
  inscriptionImmo: InscriptionImmoInput;
};


export type MutationRelanceSignaturesArgs = {
  documentIds: Array<Scalars['String']['input']>;
};


export type MutationRequestInvestisseurPurgeArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type MutationResetDataEcartInvestisseursArgs = {
  waveMigrationJobId: Scalars['Long']['input'];
};


export type MutationResetOperationSignatureArgs = {
  operationId: Scalars['UUID']['input'];
};


export type MutationResiliationConsultantArgs = {
  codeConsultant: Scalars['String']['input'];
};


export type MutationRestartArianeDumpArgs = {
  priority?: Scalars['Int']['input'];
  where?: InputMaybe<ArianeDumpJobFilterInput>;
};


export type MutationRestartFailedFinancialRecalculationJobArgs = {
  jobId: Scalars['Long']['input'];
};


export type MutationRestartFailedFinancialRecalculationJobsArgs = {
  where?: InputMaybe<FinancialRecalculationJobFilterInput>;
};


export type MutationRestartInvestisseurQpiArgs = {
  investisseurPrincipalId: Scalars['Long']['input'];
};


export type MutationRestartProcessArianeDataArgs = {
  priority?: Scalars['Int']['input'];
  where?: InputMaybe<ArianeProcessJobFilterInput>;
};


export type MutationSaveConnaissanceExperienceArgs = {
  input: ConnaissanceExperienceInput;
};


export type MutationSaveToleranceRisqueArgs = {
  input: ToleranceRisqueInput;
};


export type MutationScheduleInvestisseurFinancialRecalculationArgs = {
  cursor?: InputMaybe<Scalars['Long']['input']>;
  maxCount?: Scalars['Int']['input'];
  where?: InputMaybe<MinotaureInvestisseurFilterInput>;
};


export type MutationSendOperationSignaturesArgs = {
  operationId: Scalars['UUID']['input'];
};


export type MutationSetConsultantsAccessArgs = {
  isAccesDisabled: Scalars['Boolean']['input'];
  where?: InputMaybe<ImportConsultantFilterInput>;
};


export type MutationSetConsultantsAccessByWaveIdArgs = {
  isAccesDisabled: Scalars['Boolean']['input'];
  waveMigrationJobId: Scalars['Long']['input'];
};


export type MutationSetFinancialRecalculationWorkerCountArgs = {
  count: Scalars['Int']['input'];
};


export type MutationSetReferenceAppForInvestisseursBatchArgs = {
  appReference: AppReference;
  investisseurIds: Array<Scalars['Long']['input']>;
};


export type MutationSetSouhaiteCollaborerAvecStelliumFiConsultantArgs = {
  consultantCode: Scalars['String']['input'];
  souhaiteCollaborerAvecStelliumFi: Scalars['Boolean']['input'];
};


export type MutationStopOverridingHabilitationStatusArgs = {
  backOfficeAction: HabilitationStatusStopOverrideInput;
};


export type MutationSurAvenirContratUrlArgs = {
  idPersonnePartenaire: Scalars['String']['input'];
  numeroContrat: Scalars['String']['input'];
};


export type MutationSynchroniserSelectionAutoRecueilArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type MutationTransfertClientsArgs = {
  transfertData: TransfertClientDataInput;
};


export type MutationUpdateArianeIdsForCreatedInvestisseurArgs = {
  arianeInput: InvestisseurCreationArianeUpdateInput;
};


export type MutationUpdateBudgetArgs = {
  input: BudgetModificationInput;
};


export type MutationUpdateChoixConsultantCommissionAdiArgs = {
  choixTypeCommissionAdiCode: Scalars['Int']['input'];
  consultantId: Scalars['Long']['input'];
  dateChoixTypeCommissionAdi: Scalars['LocalDate']['input'];
};


export type MutationUpdateClientSituationPersonnelleStateArgs = {
  investisseurId: Scalars['Long']['input'];
  isCompleted: Scalars['Boolean']['input'];
};


export type MutationUpdateDateDemissionConsultantArgs = {
  consultantCode: Scalars['String']['input'];
  dateDemission: Scalars['LocalDate']['input'];
};


export type MutationUpdateDateFinValiditeAffiliationConsultantArgs = {
  consultantCode: Scalars['String']['input'];
  dateFinValiditeAffiliation: Scalars['LocalDate']['input'];
};


export type MutationUpdateDateModificationFicheArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type MutationUpdateEtiquettesArgs = {
  etiquetteInput: EtiquetteInput;
};


export type MutationUpdateFileMetadataArgs = {
  fileId: Scalars['String']['input'];
  newMetadata?: InputMaybe<UpdateDocumentMetadatasCommandInput>;
  newValue?: InputMaybe<FileMetadataUpdateInput>;
};


export type MutationUpdateFoyerFiscalDataArgs = {
  conjointInput?: InputMaybe<FoyerFiscalUpdateDataInput>;
  investisseurInput: FoyerFiscalUpdateDataInput;
};


export type MutationUpdateInvestisseurBilanFinancierArgs = {
  bilanFinancierInput: BilanFinancierInput;
};


export type MutationUpdateInvestisseurDerStateArgs = {
  applyAlsoToConjoint: Scalars['Boolean']['input'];
  documentId?: InputMaybe<Scalars['String']['input']>;
  investisseurId: Scalars['Long']['input'];
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
  trigger: DerStateTransitionTrigger;
};


export type MutationUpdateInvestisseurDonationArgs = {
  input: DonationInput;
  investisseurId: Scalars['Long']['input'];
};


export type MutationUpdateInvestisseurPieceIdentiteStateArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  investisseurId: Scalars['Long']['input'];
  isCompleted: Scalars['Boolean']['input'];
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationUpdateInvestisseurQpiStateArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  investisseurId: Scalars['Long']['input'];
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
  trigger: QpiStateTransitionTrigger;
};


export type MutationUpdateInvestisseurRecueilStateArgs = {
  applyAlsoToConjoint: Scalars['Boolean']['input'];
  documentId?: InputMaybe<Scalars['String']['input']>;
  investisseurId: Scalars['Long']['input'];
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
  trigger: RecueilStateTransitionTrigger;
};


export type MutationUpdateInvestisseurSituationPersonnelleArgs = {
  input: UpdateSituationPersonnelleInput;
};


export type MutationUpdateObjectifStepArgs = {
  input: UpdateObjectifStepInput;
};


export type MutationUpdateOperationAllocationConsultantFileArgs = {
  fileId?: InputMaybe<Scalars['String']['input']>;
  operationId: Scalars['UUID']['input'];
};


export type MutationUpdateOperationAndGenerateAdequationArgs = {
  input: GenerateOperationAdequationInput;
};


export type MutationUpdateOperationDataArgs = {
  operationId: Scalars['UUID']['input'];
};


export type MutationUpdateOperationProduitArgs = {
  operationId: Scalars['UUID']['input'];
  produitId: Scalars['Long']['input'];
};


export type MutationUpdateOperationStatutArgs = {
  newStatut: OperationState;
  operationId: Scalars['UUID']['input'];
};


export type MutationUpdatePatrimoineContratArgs = {
  patrimoineInput: PatrimoineInput;
};


export type MutationUpdateProjetArgs = {
  input: ProjetUpdateInput;
};


export type MutationUpdateRechercheArgs = {
  rechercheInput: UpdateRechercheInput;
};


export type MutationUpdateSituationPersonnelleArgs = {
  input: UpdateSituationPersonnelleInput;
};


export type MutationUploadJsReportTemplateArgs = {
  operationConfigId: Scalars['UUID']['input'];
  storageFileId: Scalars['String']['input'];
  templateName: Scalars['String']['input'];
};


export type MutationUpsertInvestisseurRelationAutreArgs = {
  input: InvestisseurRelationAutreInput;
};


export type MutationUpsertInvestisseurRelationFamilleArgs = {
  input: InvestisseurRelationFamilleInput;
};


export type MutationUpsertOperationDataArgs = {
  data: OperationDataInput;
  operationId: Scalars['UUID']['input'];
};


export type MutationVerifyOperationConfigImportArgs = {
  storageFileId: Scalars['String']['input'];
};


export type MutationWaveSyncBeforeLaunchArgs = {
  waveMigrationJobId: Scalars['Long']['input'];
};

export type MyStelliumDocumentRequest = {
  __typename?: 'MyStelliumDocumentRequest';
  createdAt: Scalars['DateTime']['output'];
  documentCategoryName?: Maybe<Scalars['String']['output']>;
  documentRequestTypes: Array<MyStelliumDocumentRequestType>;
  documentTypeName?: Maybe<Scalars['String']['output']>;
  documentUploads: Array<MyStelliumDocumentUpload>;
  followUpAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  investisseur?: Maybe<MyStelliumInvestisseur>;
  investisseurId: Scalars['Long']['output'];
  isFreeUpload: Scalars['Boolean']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: DocumentStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MyStelliumDocumentRequestDocumentRequestTypesArgs = {
  where?: InputMaybe<MyStelliumDocumentRequestTypeFilterInput>;
};


export type MyStelliumDocumentRequestDocumentUploadsArgs = {
  where?: InputMaybe<MyStelliumDocumentUploadFilterInput>;
};

export type MyStelliumDocumentRequestFilterInput = {
  and?: InputMaybe<Array<MyStelliumDocumentRequestFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  documentCategoryName?: InputMaybe<StringOperationFilterInput>;
  documentRequestTypes?: InputMaybe<ListFilterInputTypeOfMyStelliumDocumentRequestTypeFilterInput>;
  documentTypeName?: InputMaybe<StringOperationFilterInput>;
  documentUploads?: InputMaybe<ListFilterInputTypeOfMyStelliumDocumentUploadFilterInput>;
  followUpAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  investisseur?: InputMaybe<MyStelliumInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  isFreeUpload?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<MyStelliumDocumentRequestFilterInput>>;
  rejectionReason?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<DocumentStatusOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type MyStelliumDocumentRequestType = {
  __typename?: 'MyStelliumDocumentRequestType';
  documentRequest?: Maybe<MyStelliumDocumentRequest>;
  documentRequestId: Scalars['Int']['output'];
  documentTypeCode?: Maybe<Scalars['String']['output']>;
  documentTypeName?: Maybe<Scalars['String']['output']>;
  expectedDocumentCount: Scalars['Int']['output'];
  hasRectoVerso: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type MyStelliumDocumentRequestTypeFilterInput = {
  and?: InputMaybe<Array<MyStelliumDocumentRequestTypeFilterInput>>;
  documentRequest?: InputMaybe<MyStelliumDocumentRequestFilterInput>;
  documentRequestId?: InputMaybe<IntOperationFilterInput>;
  documentTypeCode?: InputMaybe<StringOperationFilterInput>;
  documentTypeName?: InputMaybe<StringOperationFilterInput>;
  expectedDocumentCount?: InputMaybe<IntOperationFilterInput>;
  hasRectoVerso?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<MyStelliumDocumentRequestTypeFilterInput>>;
};

export type MyStelliumDocumentUpload = {
  __typename?: 'MyStelliumDocumentUpload';
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentId: Scalars['String']['output'];
  documentRequest?: Maybe<MyStelliumDocumentRequest>;
  documentRequestId: Scalars['Int']['output'];
  documentTypeCode?: Maybe<Scalars['String']['output']>;
  fileExtension: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  side: DocumentUploadSide;
};

export type MyStelliumDocumentUploadFilterInput = {
  and?: InputMaybe<Array<MyStelliumDocumentUploadFilterInput>>;
  contentType?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  documentId?: InputMaybe<StringOperationFilterInput>;
  documentRequest?: InputMaybe<MyStelliumDocumentRequestFilterInput>;
  documentRequestId?: InputMaybe<IntOperationFilterInput>;
  documentTypeCode?: InputMaybe<StringOperationFilterInput>;
  fileExtension?: InputMaybe<StringOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  fileSize?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<MyStelliumDocumentUploadFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  side?: InputMaybe<DocumentUploadSideOperationFilterInput>;
};

export type MyStelliumInvestisseur = {
  __typename?: 'MyStelliumInvestisseur';
  accountStatus: AccountStatus;
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  connections: Array<MyStelliumInvestisseurConnection>;
  derId?: Maybe<Scalars['Int']['output']>;
  derStatus: DerStatus;
  derValidatedAt?: Maybe<Scalars['DateTime']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  documentRequests: Array<MyStelliumDocumentRequest>;
  entraObjectId?: Maybe<Scalars['UUID']['output']>;
  investisseurCode: Scalars['String']['output'];
  investisseurId: Scalars['Long']['output'];
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  magicLink?: Maybe<MyStelliumMagicLink>;
  recommendations: Array<MyStelliumRecommendation>;
};


export type MyStelliumInvestisseurConnectionsArgs = {
  where?: InputMaybe<MyStelliumInvestisseurConnectionFilterInput>;
};


export type MyStelliumInvestisseurDocumentRequestsArgs = {
  where?: InputMaybe<MyStelliumDocumentRequestFilterInput>;
};


export type MyStelliumInvestisseurRecommendationsArgs = {
  where?: InputMaybe<MyStelliumRecommendationFilterInput>;
};

export type MyStelliumInvestisseurConnection = {
  __typename?: 'MyStelliumInvestisseurConnection';
  connectedAt: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  investisseur?: Maybe<MyStelliumInvestisseur>;
  investisseurId: Scalars['Long']['output'];
  sessionId: Scalars['String']['output'];
};

export type MyStelliumInvestisseurConnectionFilterInput = {
  and?: InputMaybe<Array<MyStelliumInvestisseurConnectionFilterInput>>;
  connectedAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<MyStelliumInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<MyStelliumInvestisseurConnectionFilterInput>>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
};

export type MyStelliumInvestisseurFilterInput = {
  accountStatus?: InputMaybe<AccountStatusOperationFilterInput>;
  activatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<MyStelliumInvestisseurFilterInput>>;
  connections?: InputMaybe<ListFilterInputTypeOfMyStelliumInvestisseurConnectionFilterInput>;
  derId?: InputMaybe<IntOperationFilterInput>;
  derStatus?: InputMaybe<DerStatusOperationFilterInput>;
  derValidatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  disabledAt?: InputMaybe<DateTimeOperationFilterInput>;
  documentRequests?: InputMaybe<ListFilterInputTypeOfMyStelliumDocumentRequestFilterInput>;
  entraObjectId?: InputMaybe<UuidOperationFilterInput>;
  investisseurCode?: InputMaybe<StringOperationFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  invitedAt?: InputMaybe<DateTimeOperationFilterInput>;
  magicLink?: InputMaybe<MyStelliumMagicLinkFilterInput>;
  or?: InputMaybe<Array<MyStelliumInvestisseurFilterInput>>;
  recommendations?: InputMaybe<ListFilterInputTypeOfMyStelliumRecommendationFilterInput>;
};

export type MyStelliumInvestisseurSortInput = {
  accountStatus?: InputMaybe<SortEnumType>;
  activatedAt?: InputMaybe<SortEnumType>;
  derId?: InputMaybe<SortEnumType>;
  derStatus?: InputMaybe<SortEnumType>;
  derValidatedAt?: InputMaybe<SortEnumType>;
  disabledAt?: InputMaybe<SortEnumType>;
  entraObjectId?: InputMaybe<SortEnumType>;
  investisseurCode?: InputMaybe<SortEnumType>;
  investisseurId?: InputMaybe<SortEnumType>;
  invitedAt?: InputMaybe<SortEnumType>;
  magicLink?: InputMaybe<MyStelliumMagicLinkSortInput>;
};

export type MyStelliumMagicLink = {
  __typename?: 'MyStelliumMagicLink';
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  investisseur?: Maybe<MyStelliumInvestisseur>;
  investisseurId: Scalars['Long']['output'];
  key: Scalars['String']['output'];
};

export type MyStelliumMagicLinkFilterInput = {
  and?: InputMaybe<Array<MyStelliumMagicLinkFilterInput>>;
  expiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  investisseur?: InputMaybe<MyStelliumInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MyStelliumMagicLinkFilterInput>>;
};

export type MyStelliumMagicLinkSortInput = {
  expiresAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<MyStelliumInvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  key?: InputMaybe<SortEnumType>;
};

export type MyStelliumRecommendation = {
  __typename?: 'MyStelliumRecommendation';
  ageRange?: Maybe<RecommendationAgeRange>;
  civility: RecommendationCivility;
  consultantId: Scalars['Long']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  investisseur?: Maybe<MyStelliumInvestisseur>;
  investisseurId: Scalars['Long']['output'];
  lastName: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<RecommendationRelationship>;
};

export type MyStelliumRecommendationFilterInput = {
  ageRange?: InputMaybe<NullableOfRecommendationAgeRangeOperationFilterInput>;
  and?: InputMaybe<Array<MyStelliumRecommendationFilterInput>>;
  civility?: InputMaybe<RecommendationCivilityOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  investisseur?: InputMaybe<MyStelliumInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MyStelliumRecommendationFilterInput>>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  relationship?: InputMaybe<NullableOfRecommendationRelationshipOperationFilterInput>;
};

export type NatureMouvement = {
  __typename?: 'NatureMouvement';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  mouvement: Array<Mouvement>;
};


export type NatureMouvementMouvementArgs = {
  where?: InputMaybe<MouvementFilterInput>;
};

export type NatureMouvementFilterInput = {
  and?: InputMaybe<Array<NatureMouvementFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  mouvement?: InputMaybe<ListFilterInputTypeOfMouvementFilterInput>;
  or?: InputMaybe<Array<NatureMouvementFilterInput>>;
};

export type NatureMouvementSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type NatureOperation = {
  __typename?: 'NatureOperation';
  categorieNavigation?: Maybe<NatureOperationCategorie>;
  id: Scalars['Int']['output'];
  libelle: Scalars['String']['output'];
  natureOperationCategorieId: Scalars['Int']['output'];
};

export type NatureOperationCategorie = {
  __typename?: 'NatureOperationCategorie';
  id: Scalars['Int']['output'];
  libelle: Scalars['String']['output'];
};

export type NatureOperationCategorieFilterInput = {
  and?: InputMaybe<Array<NatureOperationCategorieFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NatureOperationCategorieFilterInput>>;
};

export type NatureOperationFilterInput = {
  and?: InputMaybe<Array<NatureOperationFilterInput>>;
  categorieNavigation?: InputMaybe<NatureOperationCategorieFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  natureOperationCategorieId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<NatureOperationFilterInput>>;
};

export type NaturePatrimoine = {
  __typename?: 'NaturePatrimoine';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  patrimoineActif: Array<PatrimoineActif>;
  patrimoineChargeRevenu: Array<PatrimoineChargeRevenu>;
  patrimoinePassif: Array<PatrimoinePassif>;
  type: Scalars['String']['output'];
};


export type NaturePatrimoinePatrimoineActifArgs = {
  where?: InputMaybe<PatrimoineActifFilterInput>;
};


export type NaturePatrimoinePatrimoineChargeRevenuArgs = {
  where?: InputMaybe<PatrimoineChargeRevenuFilterInput>;
};


export type NaturePatrimoinePatrimoinePassifArgs = {
  where?: InputMaybe<PatrimoinePassifFilterInput>;
};

export type NaturePatrimoineFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<NaturePatrimoineFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NaturePatrimoineFilterInput>>;
  patrimoineActif?: InputMaybe<ListFilterInputTypeOfPatrimoineActifFilterInput>;
  patrimoineChargeRevenu?: InputMaybe<ListFilterInputTypeOfPatrimoineChargeRevenuFilterInput>;
  patrimoinePassif?: InputMaybe<ListFilterInputTypeOfPatrimoinePassifFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type NatureRelationAutre = {
  __typename?: 'NatureRelationAutre';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  typeRelationAutre: Array<TypeRelationAutre>;
};


export type NatureRelationAutreTypeRelationAutreArgs = {
  where?: InputMaybe<TypeRelationAutreFilterInput>;
};

export type NatureRelationAutreFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<NatureRelationAutreFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NatureRelationAutreFilterInput>>;
  typeRelationAutre?: InputMaybe<ListFilterInputTypeOfTypeRelationAutreFilterInput>;
};

export type NatureRelationAutreSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export enum NiveauDeRisque {
  Dynamique = 'DYNAMIQUE',
  Equilibre = 'EQUILIBRE',
  Offensif = 'OFFENSIF',
  Prudent = 'PRUDENT',
  Securise = 'SECURISE'
}

export type NiveauDeRisqueOperationFilterInput = {
  eq?: InputMaybe<NiveauDeRisque>;
  in?: InputMaybe<Array<NiveauDeRisque>>;
  neq?: InputMaybe<NiveauDeRisque>;
  nin?: InputMaybe<Array<NiveauDeRisque>>;
};

export type NiveauEtude = {
  __typename?: 'NiveauEtude';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  relationFamille: Array<RelationFamille>;
};


export type NiveauEtudeRelationFamilleArgs = {
  where?: InputMaybe<RelationFamilleFilterInput>;
};

export type NiveauEtudeFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<NiveauEtudeFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NiveauEtudeFilterInput>>;
  relationFamille?: InputMaybe<ListFilterInputTypeOfRelationFamilleFilterInput>;
};

/** Nombre d'opérations réalisées sur les 24 derniers mois (Q18-bis) */
export enum NombreOperationsEnum {
  Aucune = 'AUCUNE',
  EntreUnEtTrois = 'ENTRE_UN_ET_TROIS',
  PlusDeTrois = 'PLUS_DE_TROIS'
}

export type NombreOperationsEnumOperationFilterInput = {
  eq?: InputMaybe<NombreOperationsEnum>;
  in?: InputMaybe<Array<NombreOperationsEnum>>;
  neq?: InputMaybe<NombreOperationsEnum>;
  nin?: InputMaybe<Array<NombreOperationsEnum>>;
};

/** Nombre d'opérations sur les 24 derniers mois (Q18-bis) */
export type NombreOperationsReferentielDto = {
  __typename?: 'NombreOperationsReferentielDto';
  code: NombreOperationsEnum;
  libelle: Scalars['String']['output'];
};

/** Nombre d'opérations sur les 24 derniers mois (Q18-bis) */
export type NombreOperationsReferentielDtoFilterInput = {
  and?: InputMaybe<Array<NombreOperationsReferentielDtoFilterInput>>;
  code?: InputMaybe<NombreOperationsEnumOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NombreOperationsReferentielDtoFilterInput>>;
};

export type Note = {
  __typename?: 'Note';
  adresse: Array<Adresse>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  disposition: Array<Disposition>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  email: Array<Email>;
  etatCivils: Array<EtatCivil>;
  facture: Array<Facture>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseur: Array<Investisseur>;
  note1: Scalars['String']['output'];
  relationCouples: Array<RelationCouple>;
  relationFamilles: Array<RelationFamille>;
  situationProfessionnelle: Array<SituationProfessionnelle>;
  telephone: Array<Telephone>;
  testaments: Array<Testament>;
};


export type NoteAdresseArgs = {
  where?: InputMaybe<AdresseFilterInput>;
};


export type NoteDispositionArgs = {
  where?: InputMaybe<DispositionFilterInput>;
};


export type NoteEmailArgs = {
  where?: InputMaybe<EmailFilterInput>;
};


export type NoteEtatCivilsArgs = {
  where?: InputMaybe<EtatCivilFilterInput>;
};


export type NoteFactureArgs = {
  where?: InputMaybe<FactureFilterInput>;
};


export type NoteInvestisseurArgs = {
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type NoteRelationCouplesArgs = {
  where?: InputMaybe<RelationCoupleFilterInput>;
};


export type NoteRelationFamillesArgs = {
  where?: InputMaybe<RelationFamilleFilterInput>;
};


export type NoteSituationProfessionnelleArgs = {
  where?: InputMaybe<SituationProfessionnelleFilterInput>;
};


export type NoteTelephoneArgs = {
  where?: InputMaybe<TelephoneFilterInput>;
};


export type NoteTestamentsArgs = {
  where?: InputMaybe<TestamentFilterInput>;
};

export type NoteFilterInput = {
  adresse?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  and?: InputMaybe<Array<NoteFilterInput>>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  disposition?: InputMaybe<ListFilterInputTypeOfDispositionFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<ListFilterInputTypeOfEmailFilterInput>;
  etatCivils?: InputMaybe<ListFilterInputTypeOfEtatCivilFilterInput>;
  facture?: InputMaybe<ListFilterInputTypeOfFactureFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseur?: InputMaybe<ListFilterInputTypeOfInvestisseurFilterInput>;
  note1?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NoteFilterInput>>;
  relationCouples?: InputMaybe<ListFilterInputTypeOfRelationCoupleFilterInput>;
  relationFamilles?: InputMaybe<ListFilterInputTypeOfRelationFamilleFilterInput>;
  situationProfessionnelle?: InputMaybe<ListFilterInputTypeOfSituationProfessionnelleFilterInput>;
  telephone?: InputMaybe<ListFilterInputTypeOfTelephoneFilterInput>;
  testaments?: InputMaybe<ListFilterInputTypeOfTestamentFilterInput>;
};

export type NoteSortInput = {
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  note1?: InputMaybe<SortEnumType>;
};

export type NullableOfAllocationPartenaireStatutOperationFilterInput = {
  eq?: InputMaybe<AllocationPartenaireStatut>;
  in?: InputMaybe<Array<InputMaybe<AllocationPartenaireStatut>>>;
  neq?: InputMaybe<AllocationPartenaireStatut>;
  nin?: InputMaybe<Array<InputMaybe<AllocationPartenaireStatut>>>;
};

export type NullableOfAllocationTransfertOptionOperationFilterInput = {
  eq?: InputMaybe<AllocationTransfertOption>;
  in?: InputMaybe<Array<InputMaybe<AllocationTransfertOption>>>;
  neq?: InputMaybe<AllocationTransfertOption>;
  nin?: InputMaybe<Array<InputMaybe<AllocationTransfertOption>>>;
};

export type NullableOfAllocationVersementOptionOperationFilterInput = {
  eq?: InputMaybe<AllocationVersementOption>;
  in?: InputMaybe<Array<InputMaybe<AllocationVersementOption>>>;
  neq?: InputMaybe<AllocationVersementOption>;
  nin?: InputMaybe<Array<InputMaybe<AllocationVersementOption>>>;
};

export type NullableOfApplicabilityTagOperationFilterInput = {
  eq?: InputMaybe<ApplicabilityTag>;
  in?: InputMaybe<Array<InputMaybe<ApplicabilityTag>>>;
  neq?: InputMaybe<ApplicabilityTag>;
  nin?: InputMaybe<Array<InputMaybe<ApplicabilityTag>>>;
};

export type NullableOfConsultantContratsGraphEnumOperationFilterInput = {
  eq?: InputMaybe<ConsultantContratsGraphEnum>;
  in?: InputMaybe<Array<InputMaybe<ConsultantContratsGraphEnum>>>;
  neq?: InputMaybe<ConsultantContratsGraphEnum>;
  nin?: InputMaybe<Array<InputMaybe<ConsultantContratsGraphEnum>>>;
};

export type NullableOfConsultantSupportsGraphEnumOperationFilterInput = {
  eq?: InputMaybe<ConsultantSupportsGraphEnum>;
  in?: InputMaybe<Array<InputMaybe<ConsultantSupportsGraphEnum>>>;
  neq?: InputMaybe<ConsultantSupportsGraphEnum>;
  nin?: InputMaybe<Array<InputMaybe<ConsultantSupportsGraphEnum>>>;
};

export type NullableOfContratDetailGraphEnumOperationFilterInput = {
  eq?: InputMaybe<ContratDetailGraphEnum>;
  in?: InputMaybe<Array<InputMaybe<ContratDetailGraphEnum>>>;
  neq?: InputMaybe<ContratDetailGraphEnum>;
  nin?: InputMaybe<Array<InputMaybe<ContratDetailGraphEnum>>>;
};

export type NullableOfDetentionProduitEnumOperationFilterInput = {
  eq?: InputMaybe<DetentionProduitEnum>;
  in?: InputMaybe<Array<InputMaybe<DetentionProduitEnum>>>;
  neq?: InputMaybe<DetentionProduitEnum>;
  nin?: InputMaybe<Array<InputMaybe<DetentionProduitEnum>>>;
};

export type NullableOfDisponibiliteEpargneOperationFilterInput = {
  eq?: InputMaybe<DisponibiliteEpargne>;
  in?: InputMaybe<Array<InputMaybe<DisponibiliteEpargne>>>;
  neq?: InputMaybe<DisponibiliteEpargne>;
  nin?: InputMaybe<Array<InputMaybe<DisponibiliteEpargne>>>;
};

export type NullableOfFileStorageStatusOperationFilterInput = {
  eq?: InputMaybe<FileStorageStatus>;
  in?: InputMaybe<Array<InputMaybe<FileStorageStatus>>>;
  neq?: InputMaybe<FileStorageStatus>;
  nin?: InputMaybe<Array<InputMaybe<FileStorageStatus>>>;
};

export type NullableOfFrequenceVersementOperationFilterInput = {
  eq?: InputMaybe<FrequenceVersement>;
  in?: InputMaybe<Array<InputMaybe<FrequenceVersement>>>;
  neq?: InputMaybe<FrequenceVersement>;
  nin?: InputMaybe<Array<InputMaybe<FrequenceVersement>>>;
};

export type NullableOfGedCategoryOperationFilterInput = {
  eq?: InputMaybe<GedCategory>;
  in?: InputMaybe<Array<InputMaybe<GedCategory>>>;
  neq?: InputMaybe<GedCategory>;
  nin?: InputMaybe<Array<InputMaybe<GedCategory>>>;
};

export type NullableOfGedDocumentTypeOperationFilterInput = {
  eq?: InputMaybe<GedDocumentType>;
  in?: InputMaybe<Array<InputMaybe<GedDocumentType>>>;
  neq?: InputMaybe<GedDocumentType>;
  nin?: InputMaybe<Array<InputMaybe<GedDocumentType>>>;
};

export type NullableOfHorizonPlacementEnumOperationFilterInput = {
  eq?: InputMaybe<HorizonPlacementEnum>;
  in?: InputMaybe<Array<InputMaybe<HorizonPlacementEnum>>>;
  neq?: InputMaybe<HorizonPlacementEnum>;
  nin?: InputMaybe<Array<InputMaybe<HorizonPlacementEnum>>>;
};

export type NullableOfImpactDiminutionFraisEnumOperationFilterInput = {
  eq?: InputMaybe<ImpactDiminutionFraisEnum>;
  in?: InputMaybe<Array<InputMaybe<ImpactDiminutionFraisEnum>>>;
  neq?: InputMaybe<ImpactDiminutionFraisEnum>;
  nin?: InputMaybe<Array<InputMaybe<ImpactDiminutionFraisEnum>>>;
};

export type NullableOfLevierTypeOperationFilterInput = {
  eq?: InputMaybe<LevierType>;
  in?: InputMaybe<Array<InputMaybe<LevierType>>>;
  neq?: InputMaybe<LevierType>;
  nin?: InputMaybe<Array<InputMaybe<LevierType>>>;
};

export type NullableOfModeGestionEpargneEnumOperationFilterInput = {
  eq?: InputMaybe<ModeGestionEpargneEnum>;
  in?: InputMaybe<Array<InputMaybe<ModeGestionEpargneEnum>>>;
  neq?: InputMaybe<ModeGestionEpargneEnum>;
  nin?: InputMaybe<Array<InputMaybe<ModeGestionEpargneEnum>>>;
};

export type NullableOfNiveauDeRisqueOperationFilterInput = {
  eq?: InputMaybe<NiveauDeRisque>;
  in?: InputMaybe<Array<InputMaybe<NiveauDeRisque>>>;
  neq?: InputMaybe<NiveauDeRisque>;
  nin?: InputMaybe<Array<InputMaybe<NiveauDeRisque>>>;
};

export type NullableOfNombreOperationsEnumOperationFilterInput = {
  eq?: InputMaybe<NombreOperationsEnum>;
  in?: InputMaybe<Array<InputMaybe<NombreOperationsEnum>>>;
  neq?: InputMaybe<NombreOperationsEnum>;
  nin?: InputMaybe<Array<InputMaybe<NombreOperationsEnum>>>;
};

export type NullableOfOperationSignatureModeOperationFilterInput = {
  eq?: InputMaybe<OperationSignatureMode>;
  in?: InputMaybe<Array<InputMaybe<OperationSignatureMode>>>;
  neq?: InputMaybe<OperationSignatureMode>;
  nin?: InputMaybe<Array<InputMaybe<OperationSignatureMode>>>;
};

export type NullableOfOperationStateOperationFilterInput = {
  eq?: InputMaybe<OperationState>;
  in?: InputMaybe<Array<InputMaybe<OperationState>>>;
  neq?: InputMaybe<OperationState>;
  nin?: InputMaybe<Array<InputMaybe<OperationState>>>;
};

export type NullableOfPatchFieldsOperationFilterInput = {
  eq?: InputMaybe<PatchFields>;
  in?: InputMaybe<Array<InputMaybe<PatchFields>>>;
  neq?: InputMaybe<PatchFields>;
  nin?: InputMaybe<Array<InputMaybe<PatchFields>>>;
};

export type NullableOfPermissionOperationFilterInput = {
  eq?: InputMaybe<Permission>;
  in?: InputMaybe<Array<InputMaybe<Permission>>>;
  neq?: InputMaybe<Permission>;
  nin?: InputMaybe<Array<InputMaybe<Permission>>>;
};

export type NullableOfPortefeuilleOptionOperationFilterInput = {
  eq?: InputMaybe<PortefeuilleOption>;
  in?: InputMaybe<Array<InputMaybe<PortefeuilleOption>>>;
  neq?: InputMaybe<PortefeuilleOption>;
  nin?: InputMaybe<Array<InputMaybe<PortefeuilleOption>>>;
};

export type NullableOfReactionPerteEnumOperationFilterInput = {
  eq?: InputMaybe<ReactionPerteEnum>;
  in?: InputMaybe<Array<InputMaybe<ReactionPerteEnum>>>;
  neq?: InputMaybe<ReactionPerteEnum>;
  nin?: InputMaybe<Array<InputMaybe<ReactionPerteEnum>>>;
};

export type NullableOfRecommendationAgeRangeOperationFilterInput = {
  eq?: InputMaybe<RecommendationAgeRange>;
  in?: InputMaybe<Array<InputMaybe<RecommendationAgeRange>>>;
  neq?: InputMaybe<RecommendationAgeRange>;
  nin?: InputMaybe<Array<InputMaybe<RecommendationAgeRange>>>;
};

export type NullableOfRecommendationRelationshipOperationFilterInput = {
  eq?: InputMaybe<RecommendationRelationship>;
  in?: InputMaybe<Array<InputMaybe<RecommendationRelationship>>>;
  neq?: InputMaybe<RecommendationRelationship>;
  nin?: InputMaybe<Array<InputMaybe<RecommendationRelationship>>>;
};

export type NullableOfSignatureStateOperationFilterInput = {
  eq?: InputMaybe<SignatureState>;
  in?: InputMaybe<Array<InputMaybe<SignatureState>>>;
  neq?: InputMaybe<SignatureState>;
  nin?: InputMaybe<Array<InputMaybe<SignatureState>>>;
};

export type NullableOfSousCategorie2BudgetEnumOperationFilterInput = {
  eq?: InputMaybe<SousCategorie2BudgetEnum>;
  in?: InputMaybe<Array<InputMaybe<SousCategorie2BudgetEnum>>>;
  neq?: InputMaybe<SousCategorie2BudgetEnum>;
  nin?: InputMaybe<Array<InputMaybe<SousCategorie2BudgetEnum>>>;
};

export type NullableOfSouscriptionSignatureModeOperationFilterInput = {
  eq?: InputMaybe<SouscriptionSignatureMode>;
  in?: InputMaybe<Array<InputMaybe<SouscriptionSignatureMode>>>;
  neq?: InputMaybe<SouscriptionSignatureMode>;
  nin?: InputMaybe<Array<InputMaybe<SouscriptionSignatureMode>>>;
};

export type NullableOfSouscriptionTransmissionOriginauxOperationFilterInput = {
  eq?: InputMaybe<SouscriptionTransmissionOriginaux>;
  in?: InputMaybe<Array<InputMaybe<SouscriptionTransmissionOriginaux>>>;
  neq?: InputMaybe<SouscriptionTransmissionOriginaux>;
  nin?: InputMaybe<Array<InputMaybe<SouscriptionTransmissionOriginaux>>>;
};

export type NullableOfSubCategory2EnumOperationFilterInput = {
  eq?: InputMaybe<SubCategory2Enum>;
  in?: InputMaybe<Array<InputMaybe<SubCategory2Enum>>>;
  neq?: InputMaybe<SubCategory2Enum>;
  nin?: InputMaybe<Array<InputMaybe<SubCategory2Enum>>>;
};

export type NullableOfSubCategoryEnumOperationFilterInput = {
  eq?: InputMaybe<SubCategoryEnum>;
  in?: InputMaybe<Array<InputMaybe<SubCategoryEnum>>>;
  neq?: InputMaybe<SubCategoryEnum>;
  nin?: InputMaybe<Array<InputMaybe<SubCategoryEnum>>>;
};

export type NullableOfToleranceRisqueOperationFilterInput = {
  eq?: InputMaybe<ToleranceRisque>;
  in?: InputMaybe<Array<InputMaybe<ToleranceRisque>>>;
  neq?: InputMaybe<ToleranceRisque>;
  nin?: InputMaybe<Array<InputMaybe<ToleranceRisque>>>;
};

export type NullableOfTransactionPersonnelleEnumOperationFilterInput = {
  eq?: InputMaybe<TransactionPersonnelleEnum>;
  in?: InputMaybe<Array<InputMaybe<TransactionPersonnelleEnum>>>;
  neq?: InputMaybe<TransactionPersonnelleEnum>;
  nin?: InputMaybe<Array<InputMaybe<TransactionPersonnelleEnum>>>;
};

export type NullableOfTypeActifEnumOperationFilterInput = {
  eq?: InputMaybe<TypeActifEnum>;
  in?: InputMaybe<Array<InputMaybe<TypeActifEnum>>>;
  neq?: InputMaybe<TypeActifEnum>;
  nin?: InputMaybe<Array<InputMaybe<TypeActifEnum>>>;
};

export type NullableOfTypeDetenteurEnumOperationFilterInput = {
  eq?: InputMaybe<TypeDetenteurEnum>;
  in?: InputMaybe<Array<InputMaybe<TypeDetenteurEnum>>>;
  neq?: InputMaybe<TypeDetenteurEnum>;
  nin?: InputMaybe<Array<InputMaybe<TypeDetenteurEnum>>>;
};

export type NullableOfTypeDetentionEnumOperationFilterInput = {
  eq?: InputMaybe<TypeDetentionEnum>;
  in?: InputMaybe<Array<InputMaybe<TypeDetentionEnum>>>;
  neq?: InputMaybe<TypeDetentionEnum>;
  nin?: InputMaybe<Array<InputMaybe<TypeDetentionEnum>>>;
};

export type NullableOfTypeLocationEnumOperationFilterInput = {
  eq?: InputMaybe<TypeLocationEnum>;
  in?: InputMaybe<Array<InputMaybe<TypeLocationEnum>>>;
  neq?: InputMaybe<TypeLocationEnum>;
  nin?: InputMaybe<Array<InputMaybe<TypeLocationEnum>>>;
};

export type NullableOfTypePassifOperationFilterInput = {
  eq?: InputMaybe<TypePassif>;
  in?: InputMaybe<Array<InputMaybe<TypePassif>>>;
  neq?: InputMaybe<TypePassif>;
  nin?: InputMaybe<Array<InputMaybe<TypePassif>>>;
};

export type NullableOfTypePersonneOperationFilterInput = {
  eq?: InputMaybe<TypePersonne>;
  in?: InputMaybe<Array<InputMaybe<TypePersonne>>>;
  neq?: InputMaybe<TypePersonne>;
  nin?: InputMaybe<Array<InputMaybe<TypePersonne>>>;
};

export type NullableOfTypePrevoyanceOperationFilterInput = {
  eq?: InputMaybe<TypePrevoyance>;
  in?: InputMaybe<Array<InputMaybe<TypePrevoyance>>>;
  neq?: InputMaybe<TypePrevoyance>;
  nin?: InputMaybe<Array<InputMaybe<TypePrevoyance>>>;
};

export type NullableOfTypeRegimeFiscalEnumOperationFilterInput = {
  eq?: InputMaybe<TypeRegimeFiscalEnum>;
  in?: InputMaybe<Array<InputMaybe<TypeRegimeFiscalEnum>>>;
  neq?: InputMaybe<TypeRegimeFiscalEnum>;
  nin?: InputMaybe<Array<InputMaybe<TypeRegimeFiscalEnum>>>;
};

export type NullableOfTypeScpiEnumOperationFilterInput = {
  eq?: InputMaybe<TypeScpiEnum>;
  in?: InputMaybe<Array<InputMaybe<TypeScpiEnum>>>;
  neq?: InputMaybe<TypeScpiEnum>;
  nin?: InputMaybe<Array<InputMaybe<TypeScpiEnum>>>;
};

export type NullableOfVpModeOptionsOperationFilterInput = {
  eq?: InputMaybe<VpModeOptions>;
  in?: InputMaybe<Array<InputMaybe<VpModeOptions>>>;
  neq?: InputMaybe<VpModeOptions>;
  nin?: InputMaybe<Array<InputMaybe<VpModeOptions>>>;
};

export type NullableOfVraiFauxEnumOperationFilterInput = {
  eq?: InputMaybe<VraiFauxEnum>;
  in?: InputMaybe<Array<InputMaybe<VraiFauxEnum>>>;
  neq?: InputMaybe<VraiFauxEnum>;
  nin?: InputMaybe<Array<InputMaybe<VraiFauxEnum>>>;
};

export type ObjectifCategorie = {
  __typename?: 'ObjectifCategorie';
  /** Donnée active ou non */
  actif: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
  objectifs: Array<ObjectifReference>;
  /** Ordre d'affichage */
  ordre: Scalars['Int']['output'];
};


export type ObjectifCategorieObjectifsArgs = {
  where?: InputMaybe<ObjectifReferenceFilterInput>;
};

export type ObjectifCategorieFilterInput = {
  /** Donnée active ou non */
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ObjectifCategorieFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  objectifs?: InputMaybe<ListFilterInputTypeOfObjectifReferenceFilterInput>;
  or?: InputMaybe<Array<ObjectifCategorieFilterInput>>;
  /** Ordre d'affichage */
  ordre?: InputMaybe<IntOperationFilterInput>;
};

/** Représente un objectif defini par l'investisseur */
export type ObjectifDefini = {
  __typename?: 'ObjectifDefini';
  arianeId?: Maybe<Scalars['String']['output']>;
  commentaire?: Maybe<Scalars['String']['output']>;
  /** Horizon en années */
  horizon?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Long']['output'];
  investisseurId: Scalars['Long']['output'];
  /** Montant mensuel */
  montant?: Maybe<Scalars['Decimal']['output']>;
  objectif: ObjectifReference;
  objectifReferenceCode: Scalars['String']['output'];
  /** Priorité Définie par l'investisseur */
  priorite?: Maybe<Scalars['Int']['output']>;
};

/** Représente un objectif defini par l'investisseur */
export type ObjectifDefiniFilterInput = {
  and?: InputMaybe<Array<ObjectifDefiniFilterInput>>;
  arianeId?: InputMaybe<StringOperationFilterInput>;
  commentaire?: InputMaybe<StringOperationFilterInput>;
  /** Horizon en années */
  horizon?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  /** Montant mensuel */
  montant?: InputMaybe<DecimalOperationFilterInput>;
  objectif?: InputMaybe<ObjectifReferenceFilterInput>;
  objectifReferenceCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ObjectifDefiniFilterInput>>;
  /** Priorité Définie par l'investisseur */
  priorite?: InputMaybe<IntOperationFilterInput>;
};

export type ObjectifDefinitionInput = {
  categorieCode: Scalars['String']['input'];
  commentaire?: InputMaybe<Scalars['String']['input']>;
  horizon?: InputMaybe<Scalars['Int']['input']>;
  investisseurId: Scalars['Long']['input'];
  isSelected: Scalars['Boolean']['input'];
  objectifCode: Scalars['String']['input'];
  priorite?: InputMaybe<Scalars['Int']['input']>;
};

export type ObjectifReference = {
  __typename?: 'ObjectifReference';
  actif?: Maybe<Scalars['Boolean']['output']>;
  categorie?: Maybe<ObjectifCategorie>;
  categorieCode: Scalars['String']['output'];
  code: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
  ordre: Scalars['Int']['output'];
};

export type ObjectifReferenceFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ObjectifReferenceFilterInput>>;
  categorie?: InputMaybe<ObjectifCategorieFilterInput>;
  categorieCode?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ObjectifReferenceFilterInput>>;
  ordre?: InputMaybe<IntOperationFilterInput>;
};

export type ObjectifStepDataInput = {
  capaciteFinanciereInput: UpdateCapaciteFinanciereInput;
  investisseurId: Scalars['Long']['input'];
  objectifInput: UpdateObjectifDefinisInput;
};

/** Représente une opération. */
export type Operation = {
  __typename?: 'Operation';
  allocationConsultantFile?: Maybe<StorageFile>;
  allocationConsultantFileId?: Maybe<Scalars['String']['output']>;
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  contratId?: Maybe<Scalars['Long']['output']>;
  dateCreation: Scalars['DateTime']['output'];
  dateModification: Scalars['DateTime']['output'];
  enveloppe: EnveloppeProduit;
  enveloppeId: Scalars['Byte']['output'];
  generatedConseilDocument?: Maybe<StorageFile>;
  generatedConseilDocumentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  natureOperation?: Maybe<NatureOperation>;
  natureOperationId?: Maybe<Scalars['Int']['output']>;
  numeroContrat?: Maybe<Scalars['String']['output']>;
  operationConfig?: Maybe<OperationConfig>;
  operationConfigId?: Maybe<Scalars['UUID']['output']>;
  operationData?: Maybe<OperationData>;
  operationInvestisseurs: Array<OperationInvestisseur>;
  produit?: Maybe<Produit>;
  produitId?: Maybe<Scalars['Long']['output']>;
  projet: Projet;
  projetId: Scalars['Long']['output'];
  statut: OperationState;
  title?: Maybe<Scalars['String']['output']>;
  typeInvestisseur: TypePersonne;
  versement?: Maybe<Scalars['Decimal']['output']>;
};


/** Représente une opération. */
export type OperationOperationInvestisseursArgs = {
  where?: InputMaybe<OperationInvestisseurFilterInput>;
};

/** Résultat explicable d'une règle, éventuellement propre à un investisseur du snapshot. */
export type OperationAdequationCheck = {
  __typename?: 'OperationAdequationCheck';
  /** Clé du contrôle, suffixée par l'identifiant investisseur si nécessaire. */
  checkKey: Scalars['String']['output'];
  /** Investisseur concerné ; null pour les contrôles communs à l'opération. */
  investisseurId?: Maybe<Scalars['Long']['output']>;
  /** Explication lisible ; un message de configuration peut remplacer celui d'un rejet. */
  message?: Maybe<Scalars['String']['output']>;
  /** Paramètres du validateur retenu dans la configuration effective. */
  parameters: Array<OperationAdequationParameter>;
  /** Code technique stable permettant d'expliquer un rejet ou une impossibilité d'évaluer. */
  reasonCode?: Maybe<Scalars['String']['output']>;
  /** Version de la règle élémentaire, distincte du jeton global RulesVersion. */
  ruleVersion: Scalars['Int']['output'];
  /** Blocking, Warning ou Information ; seuls les échecs et indéterminations bloquants dégradent l'agrégation. */
  severity: Scalars['String']['output'];
  /** Origine de la règle : EnvelopeConfig, ProductConfig ou BuiltIn. */
  source: Scalars['String']['output'];
  /** Conforme, NonConforme, NonApplicable ou NonEvaluable ; ce dernier signifie qu'aucune conclusion n'est possible. */
  status: Scalars['String']['output'];
  /** Clé du validateur configuré, ou nom de la règle intégrée. */
  validatorKey: Scalars['String']['output'];
};


/** Résultat explicable d'une règle, éventuellement propre à un investisseur du snapshot. */
export type OperationAdequationCheckParametersArgs = {
  where?: InputMaybe<OperationAdequationParameterFilterInput>;
};

/** Résultat explicable d'une règle, éventuellement propre à un investisseur du snapshot. */
export type OperationAdequationCheckFilterInput = {
  and?: InputMaybe<Array<OperationAdequationCheckFilterInput>>;
  /** Clé du contrôle, suffixée par l'identifiant investisseur si nécessaire. */
  checkKey?: InputMaybe<StringOperationFilterInput>;
  /** Investisseur concerné ; null pour les contrôles communs à l'opération. */
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  /** Explication lisible ; un message de configuration peut remplacer celui d'un rejet. */
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OperationAdequationCheckFilterInput>>;
  /** Paramètres du validateur retenu dans la configuration effective. */
  parameters?: InputMaybe<ListFilterInputTypeOfOperationAdequationParameterFilterInput>;
  /** Code technique stable permettant d'expliquer un rejet ou une impossibilité d'évaluer. */
  reasonCode?: InputMaybe<StringOperationFilterInput>;
  /** Version de la règle élémentaire, distincte du jeton global RulesVersion. */
  ruleVersion?: InputMaybe<IntOperationFilterInput>;
  /** Blocking, Warning ou Information ; seuls les échecs et indéterminations bloquants dégradent l'agrégation. */
  severity?: InputMaybe<StringOperationFilterInput>;
  /** Origine de la règle : EnvelopeConfig, ProductConfig ou BuiltIn. */
  source?: InputMaybe<StringOperationFilterInput>;
  /** Conforme, NonConforme, NonApplicable ou NonEvaluable ; ce dernier signifie qu'aucune conclusion n'est possible. */
  status?: InputMaybe<StringOperationFilterInput>;
  /** Clé du validateur configuré, ou nom de la règle intégrée. */
  validatorKey?: InputMaybe<StringOperationFilterInput>;
};

/** Traçabilité des configurations d'opération, de conseil, d'enveloppe et de surcharge produit. */
export type OperationAdequationConfiguration = {
  __typename?: 'OperationAdequationConfiguration';
  /** Configuration de conseil rattachée à la configuration d'opération. */
  conseilConfigId?: Maybe<Scalars['UUID']['output']>;
  /** Version déclarée de la configuration de conseil. */
  conseilConfigVersion?: Maybe<Scalars['Int']['output']>;
  /** Empreinte de la configuration résolue et du référentiel produit, même sans version déclarée par sous-objet. */
  effectiveFingerprint: Scalars['String']['output'];
  /** Configuration d'enveloppe fournissant les champs par défaut. */
  enveloppeConfigId?: Maybe<Scalars['Int']['output']>;
  /** Configuration associée à l'opération ; null si indisponible. */
  operationConfigId?: Maybe<Scalars['UUID']['output']>;
  /** Version déclarée de la configuration d'opération. */
  operationConfigVersion?: Maybe<Scalars['Int']['output']>;
  /** Configuration de champs du produit ; elle remplace les champs homonymes de l'enveloppe. */
  productAdequationConfigId?: Maybe<Scalars['Int']['output']>;
  /** Association sélectionnant la surcharge pour le produit de l'opération. */
  produitSpecificConfigId?: Maybe<Scalars['UUID']['output']>;
};

/** Traçabilité des configurations d'opération, de conseil, d'enveloppe et de surcharge produit. */
export type OperationAdequationConfigurationFilterInput = {
  and?: InputMaybe<Array<OperationAdequationConfigurationFilterInput>>;
  /** Configuration de conseil rattachée à la configuration d'opération. */
  conseilConfigId?: InputMaybe<UuidOperationFilterInput>;
  /** Version déclarée de la configuration de conseil. */
  conseilConfigVersion?: InputMaybe<IntOperationFilterInput>;
  /** Empreinte de la configuration résolue et du référentiel produit, même sans version déclarée par sous-objet. */
  effectiveFingerprint?: InputMaybe<StringOperationFilterInput>;
  /** Configuration d'enveloppe fournissant les champs par défaut. */
  enveloppeConfigId?: InputMaybe<IntOperationFilterInput>;
  /** Configuration associée à l'opération ; null si indisponible. */
  operationConfigId?: InputMaybe<UuidOperationFilterInput>;
  /** Version déclarée de la configuration d'opération. */
  operationConfigVersion?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OperationAdequationConfigurationFilterInput>>;
  /** Configuration de champs du produit ; elle remplace les champs homonymes de l'enveloppe. */
  productAdequationConfigId?: InputMaybe<IntOperationFilterInput>;
  /** Association sélectionnant la surcharge pour le produit de l'opération. */
  produitSpecificConfigId?: InputMaybe<UuidOperationFilterInput>;
};

/** Valeurs d'aiguillage des règles enregistrées pour expliquer le contrôle effectué. */
export type OperationAdequationEntryPoints = {
  __typename?: 'OperationAdequationEntryPoints';
  /** Enveloppe de l'opération. */
  enveloppeId: Scalars['Byte']['output'];
  /** Mode de gestion enregistré dans les données de l'opération. */
  modeDeGestion?: Maybe<Scalars['String']['output']>;
  /** Nature de l'opération contrôlée. */
  natureOperationId?: Maybe<Scalars['Int']['output']>;
  /** Opération à laquelle appartient le rapport. */
  operationId: Scalars['UUID']['output'];
  /** Produit sélectionné pour l'opération. */
  produitId?: Maybe<Scalars['Long']['output']>;
  /** Type d'investisseur déclaré sur l'opération. */
  typeInvestisseur: Scalars['String']['output'];
};

/** Valeurs d'aiguillage des règles enregistrées pour expliquer le contrôle effectué. */
export type OperationAdequationEntryPointsFilterInput = {
  and?: InputMaybe<Array<OperationAdequationEntryPointsFilterInput>>;
  /** Enveloppe de l'opération. */
  enveloppeId?: InputMaybe<ByteOperationFilterInput>;
  /** Mode de gestion enregistré dans les données de l'opération. */
  modeDeGestion?: InputMaybe<StringOperationFilterInput>;
  /** Nature de l'opération contrôlée. */
  natureOperationId?: InputMaybe<IntOperationFilterInput>;
  /** Opération à laquelle appartient le rapport. */
  operationId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<OperationAdequationEntryPointsFilterInput>>;
  /** Produit sélectionné pour l'opération. */
  produitId?: InputMaybe<LongOperationFilterInput>;
  /** Type d'investisseur déclaré sur l'opération. */
  typeInvestisseur?: InputMaybe<StringOperationFilterInput>;
};

export type OperationAdequationError = {
  __typename?: 'OperationAdequationError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Résultat agrégé des contrôles d'un champ ou d'un diagnostic global. */
export type OperationAdequationField = {
  __typename?: 'OperationAdequationField';
  /** Contrôles élémentaires expliquant le statut du champ. */
  checks: Array<OperationAdequationCheck>;
  /** Chemin canonique du champ ; les clés préfixées par $ représentent des diagnostics globaux. */
  fieldKey: Scalars['String']['output'];
  /** Agrégation des contrôles : non-conformité bloquante, puis indétermination, puis conformité ou non-applicabilité. */
  status: Scalars['String']['output'];
};


/** Résultat agrégé des contrôles d'un champ ou d'un diagnostic global. */
export type OperationAdequationFieldChecksArgs = {
  where?: InputMaybe<OperationAdequationCheckFilterInput>;
};

/** Résultat agrégé des contrôles d'un champ ou d'un diagnostic global. */
export type OperationAdequationFieldFilterInput = {
  and?: InputMaybe<Array<OperationAdequationFieldFilterInput>>;
  /** Contrôles élémentaires expliquant le statut du champ. */
  checks?: InputMaybe<ListFilterInputTypeOfOperationAdequationCheckFilterInput>;
  /** Chemin canonique du champ ; les clés préfixées par $ représentent des diagnostics globaux. */
  fieldKey?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OperationAdequationFieldFilterInput>>;
  /** Agrégation des contrôles : non-conformité bloquante, puis indétermination, puis conformité ou non-applicabilité. */
  status?: InputMaybe<StringOperationFilterInput>;
};

/** Condensats des entrées normalisées ; le rapport lui-même et la signature sont exclus des entrées. */
export type OperationAdequationFingerprints = {
  __typename?: 'OperationAdequationFingerprints';
  /** Algorithme de hachage employé. */
  algorithm: Scalars['String']['output'];
  /** Version des conventions de normalisation avant hachage. */
  canonicalizationVersion: Scalars['Int']['output'];
  /** Empreinte de la configuration résolue et des données du produit utilisées par les règles. */
  configuration: Scalars['String']['output'];
  /** Empreinte des données métier ; anonymisée car dérivée notamment des données investisseur. */
  data: Scalars['String']['output'];
  /** Empreinte combinant données, configuration, version du moteur et date métier si une règle d'âge est présente. */
  input: Scalars['String']['output'];
};

/** Condensats des entrées normalisées ; le rapport lui-même et la signature sont exclus des entrées. */
export type OperationAdequationFingerprintsFilterInput = {
  /** Algorithme de hachage employé. */
  algorithm?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<OperationAdequationFingerprintsFilterInput>>;
  /** Version des conventions de normalisation avant hachage. */
  canonicalizationVersion?: InputMaybe<IntOperationFilterInput>;
  /** Empreinte de la configuration résolue et des données du produit utilisées par les règles. */
  configuration?: InputMaybe<StringOperationFilterInput>;
  /** Empreinte des données métier ; anonymisée car dérivée notamment des données investisseur. */
  data?: InputMaybe<StringOperationFilterInput>;
  /** Empreinte combinant données, configuration, version du moteur et date métier si une règle d'âge est présente. */
  input?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OperationAdequationFingerprintsFilterInput>>;
};

/** Paramètre de configuration conservé sous sa représentation textuelle. */
export type OperationAdequationParameter = {
  __typename?: 'OperationAdequationParameter';
  /** Nom du paramètre attendu par le validateur. */
  key: Scalars['String']['output'];
  /** Valeur configurée, interprétée par le validateur concerné. */
  value: Scalars['String']['output'];
};

/** Paramètre de configuration conservé sous sa représentation textuelle. */
export type OperationAdequationParameterFilterInput = {
  and?: InputMaybe<Array<OperationAdequationParameterFilterInput>>;
  /** Nom du paramètre attendu par le validateur. */
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OperationAdequationParameterFilterInput>>;
  /** Valeur configurée, interprétée par le validateur concerné. */
  value?: InputMaybe<StringOperationFilterInput>;
};

export type OperationAdequationPayload = {
  __typename?: 'OperationAdequationPayload';
  errors: Array<OperationAdequationError>;
  isCurrent: Scalars['Boolean']['output'];
  report?: Maybe<OperationAdequationReport>;
  reused: Scalars['Boolean']['output'];
};

/** Dernier contrôle d'adéquation, conservé dans le snapshot JSON de l'opération sans historique. */
export type OperationAdequationReport = {
  __typename?: 'OperationAdequationReport';
  /** Conclusion globale : Conforme, NonConforme ou Indetermine ; indépendante de la fraîcheur du rapport. */
  conclusion: Scalars['String']['output'];
  /** Identifiants, versions disponibles et empreinte de la configuration réellement utilisée. */
  configuration: OperationAdequationConfiguration;
  /** Version du code du moteur ayant produit le résultat. */
  engineVersion: Scalars['String']['output'];
  /** Contexte de sélection des règles pour cette opération. */
  entryPoints: OperationAdequationEntryPoints;
  /** Instant précis d'exécution en UTC, destiné à la traçabilité et à l'affichage. */
  evaluatedAtUtc: Scalars['DateTime']['output'];
  /** Date métier en Europe/Paris utilisée pour les règles calendaires, notamment l'âge. Elle peut différer de la date UTC de l'instant d'exécution. */
  evaluationDate: Scalars['LocalDate']['output'];
  /** Détail des contrôles regroupés par chemin de champ, y compris les diagnostics globaux préfixés par $. */
  fields: Array<OperationAdequationField>;
  /** Empreintes permettant de comparer les entrées effectives avant de relancer le moteur. */
  fingerprints: OperationAdequationFingerprints;
  /** Révision technique des données de l'opération au moment du contrôle. */
  inputRevision: Scalars['Long']['output'];
  /** Jeton global des règles et référentiels au moment du contrôle ; changé lors de leur modification. */
  rulesVersion: Scalars['UUID']['output'];
  /** Version du format JSON du rapport ; distincte de la version des règles métier. */
  schemaVersion: Scalars['Int']['output'];
  /** Résultats agrégés par famille, projetés dans des colonnes SQL calculées et indexées. */
  search: OperationAdequationSearch;
  /** Nombre de contrôles par résultat, et non nombre de champs. */
  summary: OperationAdequationSummary;
  /** Échéance exclusive UTC de recalcul temporel : prochain minuit à Paris si un validateur d'âge visible est présent, sinon null. Les données ou règles peuvent invalider le rapport avant ; ce n'est pas une garantie de conformité future. */
  validUntilUtc?: Maybe<Scalars['DateTime']['output']>;
};


/** Dernier contrôle d'adéquation, conservé dans le snapshot JSON de l'opération sans historique. */
export type OperationAdequationReportFieldsArgs = {
  where?: InputMaybe<OperationAdequationFieldFilterInput>;
};

/** Dernier contrôle d'adéquation, conservé dans le snapshot JSON de l'opération sans historique. */
export type OperationAdequationReportFilterInput = {
  and?: InputMaybe<Array<OperationAdequationReportFilterInput>>;
  /** Conclusion globale : Conforme, NonConforme ou Indetermine ; indépendante de la fraîcheur du rapport. */
  conclusion?: InputMaybe<StringOperationFilterInput>;
  /** Identifiants, versions disponibles et empreinte de la configuration réellement utilisée. */
  configuration?: InputMaybe<OperationAdequationConfigurationFilterInput>;
  /** Version du code du moteur ayant produit le résultat. */
  engineVersion?: InputMaybe<StringOperationFilterInput>;
  /** Contexte de sélection des règles pour cette opération. */
  entryPoints?: InputMaybe<OperationAdequationEntryPointsFilterInput>;
  /** Instant précis d'exécution en UTC, destiné à la traçabilité et à l'affichage. */
  evaluatedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  /** Date métier en Europe/Paris utilisée pour les règles calendaires, notamment l'âge. Elle peut différer de la date UTC de l'instant d'exécution. */
  evaluationDate?: InputMaybe<LocalDateOperationFilterInput>;
  /** Détail des contrôles regroupés par chemin de champ, y compris les diagnostics globaux préfixés par $. */
  fields?: InputMaybe<ListFilterInputTypeOfOperationAdequationFieldFilterInput>;
  /** Empreintes permettant de comparer les entrées effectives avant de relancer le moteur. */
  fingerprints?: InputMaybe<OperationAdequationFingerprintsFilterInput>;
  /** Révision technique des données de l'opération au moment du contrôle. */
  inputRevision?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<OperationAdequationReportFilterInput>>;
  /** Jeton global des règles et référentiels au moment du contrôle ; changé lors de leur modification. */
  rulesVersion?: InputMaybe<UuidOperationFilterInput>;
  /** Version du format JSON du rapport ; distincte de la version des règles métier. */
  schemaVersion?: InputMaybe<IntOperationFilterInput>;
  /** Résultats agrégés par famille, projetés dans des colonnes SQL calculées et indexées. */
  search?: InputMaybe<OperationAdequationSearchFilterInput>;
  /** Nombre de contrôles par résultat, et non nombre de champs. */
  summary?: InputMaybe<OperationAdequationSummaryFilterInput>;
  /** Échéance exclusive UTC de recalcul temporel : prochain minuit à Paris si un validateur d'âge visible est présent, sinon null. Les données ou règles peuvent invalider le rapport avant ; ce n'est pas une garantie de conformité future. */
  validUntilUtc?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Statuts par famille : Conforme, NonConforme, NonApplicable ou Indetermine. */
export type OperationAdequationSearch = {
  __typename?: 'OperationAdequationSearch';
  /** Allocations sélectionnées. */
  allocation: Scalars['String']['output'];
  /** Disponibilité de l'épargne. */
  availability: Scalars['String']['output'];
  /** Frais de l'opération. */
  fees: Scalars['String']['output'];
  /** Horizon de placement. */
  horizon: Scalars['String']['output'];
  /** Objectifs de l'investissement. */
  objectives: Scalars['String']['output'];
  /** Options de gestion et fonds événementiels. */
  options: Scalars['String']['output'];
  /** Versements et conditions de versement. */
  payments: Scalars['String']['output'];
  /** Prérequis documentaires des investisseurs. */
  prerequisites: Scalars['String']['output'];
  /** Profil et niveau de risque. */
  risk: Scalars['String']['output'];
  /** Complétude de la souscription. Null dans les rapports antérieurs à l'ajout de cette famille. */
  subscription?: Maybe<Scalars['String']['output']>;
};

/** Statuts par famille : Conforme, NonConforme, NonApplicable ou Indetermine. */
export type OperationAdequationSearchFilterInput = {
  /** Allocations sélectionnées. */
  allocation?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<OperationAdequationSearchFilterInput>>;
  /** Disponibilité de l'épargne. */
  availability?: InputMaybe<StringOperationFilterInput>;
  /** Frais de l'opération. */
  fees?: InputMaybe<StringOperationFilterInput>;
  /** Horizon de placement. */
  horizon?: InputMaybe<StringOperationFilterInput>;
  /** Objectifs de l'investissement. */
  objectives?: InputMaybe<StringOperationFilterInput>;
  /** Options de gestion et fonds événementiels. */
  options?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OperationAdequationSearchFilterInput>>;
  /** Versements et conditions de versement. */
  payments?: InputMaybe<StringOperationFilterInput>;
  /** Prérequis documentaires des investisseurs. */
  prerequisites?: InputMaybe<StringOperationFilterInput>;
  /** Profil et niveau de risque. */
  risk?: InputMaybe<StringOperationFilterInput>;
  /** Complétude de la souscription. Null dans les rapports antérieurs à l'ajout de cette famille. */
  subscription?: InputMaybe<StringOperationFilterInput>;
};

export type OperationAdequationSearchInput = {
  conclusion?: InputMaybe<Scalars['String']['input']>;
  currentOnly?: Scalars['Boolean']['input'];
  family?: InputMaybe<Scalars['String']['input']>;
  familyStatus?: InputMaybe<Scalars['String']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldStatus?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};

export type OperationAdequationSearchItem = {
  __typename?: 'OperationAdequationSearchItem';
  conclusion: Scalars['String']['output'];
  evaluatedAtUtc: Scalars['DateTime']['output'];
  operationId: Scalars['UUID']['output'];
};

export type OperationAdequationSearchPage = {
  __typename?: 'OperationAdequationSearchPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<OperationAdequationSearchItem>;
};

/** Compteurs de contrôles élémentaires, tous champs et investisseurs confondus. */
export type OperationAdequationSummary = {
  __typename?: 'OperationAdequationSummary';
  /** Contrôles non conformes. */
  failed: Scalars['Int']['output'];
  /** Contrôles explicitement non applicables au contexte. */
  notApplicable: Scalars['Int']['output'];
  /** Contrôles impossibles à conclure, par exemple faute de données ou de règle implémentée. */
  notEvaluable: Scalars['Int']['output'];
  /** Contrôles conformes. */
  passed: Scalars['Int']['output'];
  /** Nombre total de contrôles émis. */
  total: Scalars['Int']['output'];
};

/** Compteurs de contrôles élémentaires, tous champs et investisseurs confondus. */
export type OperationAdequationSummaryFilterInput = {
  and?: InputMaybe<Array<OperationAdequationSummaryFilterInput>>;
  /** Contrôles non conformes. */
  failed?: InputMaybe<IntOperationFilterInput>;
  /** Contrôles explicitement non applicables au contexte. */
  notApplicable?: InputMaybe<IntOperationFilterInput>;
  /** Contrôles impossibles à conclure, par exemple faute de données ou de règle implémentée. */
  notEvaluable?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OperationAdequationSummaryFilterInput>>;
  /** Contrôles conformes. */
  passed?: InputMaybe<IntOperationFilterInput>;
  /** Nombre total de contrôles émis. */
  total?: InputMaybe<IntOperationFilterInput>;
};

/** Représente la configuration d'une opération. */
export type OperationConfig = {
  __typename?: 'OperationConfig';
  /** Critères d'applicabilité pour cette configuration. */
  applicabilityCriteria?: Maybe<ApplicabilityCriteria>;
  commentaireDeVersion?: Maybe<Scalars['String']['output']>;
  /** Configuration du conseil pour cette opération. */
  conseilConfig?: Maybe<OperationConseilConfig>;
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  statut: OperationConfigStatus;
  version: Scalars['Int']['output'];
};

export type OperationConfigActivationError = {
  __typename?: 'OperationConfigActivationError';
  code: OperationConfigActivationErrorCode;
  message: Scalars['String']['output'];
};

export enum OperationConfigActivationErrorCode {
  MissingConfiguration = 'MISSING_CONFIGURATION',
  NotFound = 'NOT_FOUND'
}

export type OperationConfigActivationOperation = {
  __typename?: 'OperationConfigActivationOperation';
  operationId: Scalars['UUID']['output'];
  outcome: OperationConfigMigrationOutcome;
  previousOperationConfigId: Scalars['UUID']['output'];
  statut: OperationState;
};

export type OperationConfigActivationReport = {
  __typename?: 'OperationConfigActivationReport';
  affectedOperationCount: Scalars['Int']['output'];
  alreadyActive: Scalars['Boolean']['output'];
  deactivatedConfigCount: Scalars['Int']['output'];
  deactivatedConfigs?: Maybe<DeactivatedConfigsConnection>;
  excludedOperationCount: Scalars['Int']['output'];
  migratedOperationCount: Scalars['Int']['output'];
  migrationRequested: Scalars['Boolean']['output'];
  operationConfigId: Scalars['UUID']['output'];
  operations?: Maybe<OperationsConnection>;
  operationsToUpdateCount: Scalars['Int']['output'];
  previousStatus: OperationConfigStatus;
  statut: OperationConfigStatus;
};


export type OperationConfigActivationReportDeactivatedConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type OperationConfigActivationReportOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Représente la configuration d'une opération. */
export type OperationConfigFilterInput = {
  and?: InputMaybe<Array<OperationConfigFilterInput>>;
  /** Critères d'applicabilité pour cette configuration. */
  applicabilityCriteria?: InputMaybe<ApplicabilityCriteriaFilterInput>;
  commentaireDeVersion?: InputMaybe<StringOperationFilterInput>;
  /** Configuration du conseil pour cette opération. */
  conseilConfig?: InputMaybe<OperationConseilConfigFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OperationConfigFilterInput>>;
  statut?: InputMaybe<OperationConfigStatusOperationFilterInput>;
  version?: InputMaybe<IntOperationFilterInput>;
};

export type OperationConfigImportApplyResult = {
  __typename?: 'OperationConfigImportApplyResult';
  addedAllocationAssociationCount: Scalars['Int']['output'];
  addedFondsEvenementielAssociationCount: Scalars['Int']['output'];
  addedOptionAssociationCount: Scalars['Int']['output'];
  allocationAssociationCount: Scalars['Int']['output'];
  allocationCount: Scalars['Int']['output'];
  deactivatedAllocationAssociationCount: Scalars['Int']['output'];
  deactivatedConfigCount: Scalars['Int']['output'];
  deactivatedOptionAssociationCount: Scalars['Int']['output'];
  deactivatedOptionCount: Scalars['Int']['output'];
  fieldConfigurationCount: Scalars['Int']['output'];
  fileHash: Scalars['String']['output'];
  fondsEvenementielAssociationCount: Scalars['Int']['output'];
  fondsEvenementielCount: Scalars['Int']['output'];
  hadMatchingCriteria: Scalars['Boolean']['output'];
  insertedAllocationCount: Scalars['Int']['output'];
  insertedFondsEvenementielCount: Scalars['Int']['output'];
  insertedOptionCount: Scalars['Int']['output'];
  operationConfigCount: Scalars['Int']['output'];
  operationConfigId?: Maybe<Scalars['UUID']['output']>;
  operationConfigIds: Array<Scalars['UUID']['output']>;
  optionAssociationCount: Scalars['Int']['output'];
  optionCount: Scalars['Int']['output'];
  productConfigurationCount: Scalars['Int']['output'];
  reactivatedAllocationAssociationCount: Scalars['Int']['output'];
  reactivatedOptionAssociationCount: Scalars['Int']['output'];
  removedFondsEvenementielAssociationCount: Scalars['Int']['output'];
  sourceId?: Maybe<Scalars['String']['output']>;
  statut: OperationConfigStatus;
  storageFileId: Scalars['String']['output'];
  updatedAllocationCount: Scalars['Int']['output'];
  updatedFondsEvenementielCount: Scalars['Int']['output'];
  updatedOptionCount: Scalars['Int']['output'];
  validatorCount: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};


export type OperationConfigImportApplyResultOperationConfigIdsArgs = {
  where?: InputMaybe<UuidOperationFilterInput>;
};

export type OperationConfigImportIssue = {
  __typename?: 'OperationConfigImportIssue';
  code: Scalars['String']['output'];
  configurationType?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  produitId?: Maybe<Scalars['Long']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
};

export type OperationConfigImportIssueFilterInput = {
  and?: InputMaybe<Array<OperationConfigImportIssueFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  configurationType?: InputMaybe<StringOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OperationConfigImportIssueFilterInput>>;
  produitId?: InputMaybe<LongOperationFilterInput>;
  sourceId?: InputMaybe<StringOperationFilterInput>;
};

export type OperationConfigImportVerificationResult = {
  __typename?: 'OperationConfigImportVerificationResult';
  allocationAssociationCount: Scalars['Int']['output'];
  allocationCount: Scalars['Int']['output'];
  canApply: Scalars['Boolean']['output'];
  errors: Array<OperationConfigImportIssue>;
  fieldConfigurationCount: Scalars['Int']['output'];
  fileHash: Scalars['String']['output'];
  fondsEvenementielAssociationCount: Scalars['Int']['output'];
  fondsEvenementielCount: Scalars['Int']['output'];
  operationConfigCount: Scalars['Int']['output'];
  optionAssociationCount: Scalars['Int']['output'];
  optionCount: Scalars['Int']['output'];
  productConfigurationCount: Scalars['Int']['output'];
  sourceId?: Maybe<Scalars['String']['output']>;
  storageFileId: Scalars['String']['output'];
  validatorCount: Scalars['Int']['output'];
  warnings: Array<OperationConfigImportIssue>;
};


export type OperationConfigImportVerificationResultErrorsArgs = {
  where?: InputMaybe<OperationConfigImportIssueFilterInput>;
};


export type OperationConfigImportVerificationResultWarningsArgs = {
  where?: InputMaybe<OperationConfigImportIssueFilterInput>;
};

export enum OperationConfigMigrationOutcome {
  Inactive = 'INACTIVE',
  Locked = 'LOCKED',
  Migrated = 'MIGRATED',
  PastSignature = 'PAST_SIGNATURE',
  UpdateRequired = 'UPDATE_REQUIRED'
}

export enum OperationConfigStatus {
  Actif = 'ACTIF',
  Brouillon = 'BROUILLON',
  Desactive = 'DESACTIVE'
}

export type OperationConfigStatusOperationFilterInput = {
  eq?: InputMaybe<OperationConfigStatus>;
  in?: InputMaybe<Array<OperationConfigStatus>>;
  neq?: InputMaybe<OperationConfigStatus>;
  nin?: InputMaybe<Array<OperationConfigStatus>>;
};

/** Représente la configuration du conseil une opération donnée. */
export type OperationConseilConfig = {
  __typename?: 'OperationConseilConfig';
  /** Configuration du conseil applicable par defaut à toutes les operations */
  enveloppeConfig: AdequationConfig;
  id: Scalars['UUID']['output'];
  lastUpdateDate: Scalars['DateTime']['output'];
  /** Configuration spécifique par produit. Cette vient surcharger les configurations par défaut définies dans EnveloppeConfig. */
  produitSpecificConfigs: Array<ProduitSpecificConfig>;
  /** Configuration du template JSReport applicable à ce conseil. */
  templateConfig?: Maybe<ConfigTemplate>;
  /** Types de documents requis pour cette configuration. */
  typesDocumentRequis: Array<DocumentType>;
  version: Scalars['Int']['output'];
};


/** Représente la configuration du conseil une opération donnée. */
export type OperationConseilConfigProduitSpecificConfigsArgs = {
  where?: InputMaybe<ProduitSpecificConfigFilterInput>;
};


/** Représente la configuration du conseil une opération donnée. */
export type OperationConseilConfigTypesDocumentRequisArgs = {
  where?: InputMaybe<DocumentTypeFilterInput>;
};

/** Représente la configuration du conseil une opération donnée. */
export type OperationConseilConfigFilterInput = {
  and?: InputMaybe<Array<OperationConseilConfigFilterInput>>;
  /** Configuration du conseil applicable par defaut à toutes les operations */
  enveloppeConfig?: InputMaybe<AdequationConfigFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdateDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<OperationConseilConfigFilterInput>>;
  /** Configuration spécifique par produit. Cette vient surcharger les configurations par défaut définies dans EnveloppeConfig. */
  produitSpecificConfigs?: InputMaybe<ListFilterInputTypeOfProduitSpecificConfigFilterInput>;
  /** Configuration du template JSReport applicable à ce conseil. */
  templateConfig?: InputMaybe<ConfigTemplateFilterInput>;
  /** Types de documents requis pour cette configuration. */
  typesDocumentRequis?: InputMaybe<ListFilterInputTypeOfDocumentTypeFilterInput>;
  version?: InputMaybe<IntOperationFilterInput>;
};

export type OperationData = {
  __typename?: 'OperationData';
  disponibiliteEpargneOptions: Array<DisponibiliteEpargneOption>;
  modeDeGestion?: Maybe<Scalars['String']['output']>;
  modeDeGestionNavigation?: Maybe<ModeDeGestion>;
  snapshotData?: Maybe<OperationSnapshotData>;
  toleranceRisqueOptions: Array<ToleranceRisqueOption>;
};

export type OperationDataFilterInput = {
  and?: InputMaybe<Array<OperationDataFilterInput>>;
  modeDeGestion?: InputMaybe<StringOperationFilterInput>;
  modeDeGestionNavigation?: InputMaybe<ModeDeGestionFilterInput>;
  or?: InputMaybe<Array<OperationDataFilterInput>>;
  snapshotData?: InputMaybe<OperationSnapshotDataFilterInput>;
};

export type OperationDataInput = {
  modeDeGestion?: InputMaybe<Scalars['String']['input']>;
  modeDeGestionNavigation?: InputMaybe<ModeDeGestionInput>;
  snapshotData?: InputMaybe<OperationSnapshotDataInput>;
};

/** Représente une opération. */
export type OperationFilterInput = {
  allocationConsultantFile?: InputMaybe<StorageFileFilterInput>;
  allocationConsultantFileId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<OperationFilterInput>>;
  consultant?: InputMaybe<MinotaureConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  contratId?: InputMaybe<LongOperationFilterInput>;
  dateCreation?: InputMaybe<DateTimeOperationFilterInput>;
  dateModification?: InputMaybe<DateTimeOperationFilterInput>;
  enveloppe?: InputMaybe<EnveloppeProduitFilterInput>;
  enveloppeId?: InputMaybe<ByteOperationFilterInput>;
  generatedConseilDocument?: InputMaybe<StorageFileFilterInput>;
  generatedConseilDocumentId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  natureOperation?: InputMaybe<NatureOperationFilterInput>;
  natureOperationId?: InputMaybe<IntOperationFilterInput>;
  numeroContrat?: InputMaybe<StringOperationFilterInput>;
  operationConfig?: InputMaybe<OperationConfigFilterInput>;
  operationConfigId?: InputMaybe<UuidOperationFilterInput>;
  operationData?: InputMaybe<OperationDataFilterInput>;
  operationInvestisseurs?: InputMaybe<ListFilterInputTypeOfOperationInvestisseurFilterInput>;
  or?: InputMaybe<Array<OperationFilterInput>>;
  produit?: InputMaybe<ProduitFilterInput>;
  produitId?: InputMaybe<LongOperationFilterInput>;
  projet?: InputMaybe<ProjetFilterInput>;
  projetId?: InputMaybe<LongOperationFilterInput>;
  statut?: InputMaybe<OperationStateOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  typeInvestisseur?: InputMaybe<TypePersonneOperationFilterInput>;
  versement?: InputMaybe<DecimalOperationFilterInput>;
};

export type OperationInvestisseur = {
  __typename?: 'OperationInvestisseur';
  id: Scalars['Long']['output'];
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  operation: Operation;
  operationId: Scalars['UUID']['output'];
};

export type OperationInvestisseurFilterInput = {
  and?: InputMaybe<Array<OperationInvestisseurFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<MinotaureInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  operation?: InputMaybe<OperationFilterInput>;
  operationId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<OperationInvestisseurFilterInput>>;
};

export type OperationSignatureDocumentMetadata = {
  __typename?: 'OperationSignatureDocumentMetadata';
  /** Indique si le document est actif dans la GED. */
  actif?: Maybe<Scalars['Boolean']['output']>;
  /** Date de création du document dans la GED. */
  dateDeCreation?: Maybe<Scalars['DateTime']['output']>;
  /** Date de dernière modification du document dans la GED. */
  dateDeDerniereModification?: Maybe<Scalars['DateTime']['output']>;
  /** Date de signature indiquée par les métadonnées GED. */
  dateSignature?: Maybe<Scalars['DateTime']['output']>;
  /** Dénomination du document telle qu'enregistrée dans la GED. */
  denomination?: Maybe<Scalars['String']['output']>;
  /** État de signature du document tel qu'indiqué par les métadonnées GED. */
  etatSignature?: Maybe<Scalars['String']['output']>;
  /** Extension du fichier, lorsqu'elle est fournie par la GED. */
  extension?: Maybe<Scalars['String']['output']>;
  /** Identifiant GED du document concerné. */
  fileId: Scalars['String']['output'];
  /** Nom du fichier tel qu'enregistré dans la GED. */
  fileName?: Maybe<Scalars['String']['output']>;
  /** Identifiant de l'investisseur associé au document, lorsqu'il n'y en a qu'un. */
  investisseurId?: Maybe<Scalars['Long']['output']>;
  /** Identifiants des investisseurs associés au document. */
  investisseurIds?: Maybe<Array<Scalars['Long']['output']>>;
  /** Signataires sélectionnés pour envoyer ce document en signature. */
  signataires?: Maybe<Array<OperationSignatureSignerMetadata>>;
  /** Identifiant GED du document source auquel ce fichier signé est associé, notamment le document original remplacé en signature manuscrite. Null si le fichier n'est pas le document signé d'une source. */
  sourceFileId?: Maybe<Scalars['String']['output']>;
  /** Code du type de document GED. */
  typeDocumentCode?: Maybe<Scalars['String']['output']>;
  /** Numéro de version du document dans la GED, lorsqu'il est disponible. */
  versionNumber?: Maybe<Scalars['Int']['output']>;
};


export type OperationSignatureDocumentMetadataInvestisseurIdsArgs = {
  where?: InputMaybe<LongOperationFilterInput>;
};


export type OperationSignatureDocumentMetadataSignatairesArgs = {
  where?: InputMaybe<OperationSignatureSignerMetadataFilterInput>;
};

export type OperationSignatureDocumentMetadataFilterInput = {
  /** Indique si le document est actif dans la GED. */
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<OperationSignatureDocumentMetadataFilterInput>>;
  /** Date de création du document dans la GED. */
  dateDeCreation?: InputMaybe<DateTimeOperationFilterInput>;
  /** Date de dernière modification du document dans la GED. */
  dateDeDerniereModification?: InputMaybe<DateTimeOperationFilterInput>;
  /** Date de signature indiquée par les métadonnées GED. */
  dateSignature?: InputMaybe<DateTimeOperationFilterInput>;
  /** Dénomination du document telle qu'enregistrée dans la GED. */
  denomination?: InputMaybe<StringOperationFilterInput>;
  /** État de signature du document tel qu'indiqué par les métadonnées GED. */
  etatSignature?: InputMaybe<StringOperationFilterInput>;
  /** Extension du fichier, lorsqu'elle est fournie par la GED. */
  extension?: InputMaybe<StringOperationFilterInput>;
  /** Identifiant GED du document concerné. */
  fileId?: InputMaybe<StringOperationFilterInput>;
  /** Nom du fichier tel qu'enregistré dans la GED. */
  fileName?: InputMaybe<StringOperationFilterInput>;
  /** Identifiant de l'investisseur associé au document, lorsqu'il n'y en a qu'un. */
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  /** Identifiants des investisseurs associés au document. */
  investisseurIds?: InputMaybe<ListLongOperationFilterInput>;
  or?: InputMaybe<Array<OperationSignatureDocumentMetadataFilterInput>>;
  /** Signataires sélectionnés pour envoyer ce document en signature. */
  signataires?: InputMaybe<ListFilterInputTypeOfOperationSignatureSignerMetadataFilterInput>;
  /** Identifiant GED du document source auquel ce fichier signé est associé, notamment le document original remplacé en signature manuscrite. Null si le fichier n'est pas le document signé d'une source. */
  sourceFileId?: InputMaybe<StringOperationFilterInput>;
  /** Code du type de document GED. */
  typeDocumentCode?: InputMaybe<StringOperationFilterInput>;
  /** Numéro de version du document dans la GED, lorsqu'il est disponible. */
  versionNumber?: InputMaybe<IntOperationFilterInput>;
};

export type OperationSignatureDocumentMetadataInput = {
  /** Indique si le document est actif dans la GED. */
  actif?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date de création du document dans la GED. */
  dateDeCreation?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date de dernière modification du document dans la GED. */
  dateDeDerniereModification?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date de signature indiquée par les métadonnées GED. */
  dateSignature?: InputMaybe<Scalars['DateTime']['input']>;
  /** Dénomination du document telle qu'enregistrée dans la GED. */
  denomination?: InputMaybe<Scalars['String']['input']>;
  /** État de signature du document tel qu'indiqué par les métadonnées GED. */
  etatSignature?: InputMaybe<Scalars['String']['input']>;
  /** Extension du fichier, lorsqu'elle est fournie par la GED. */
  extension?: InputMaybe<Scalars['String']['input']>;
  /** Identifiant GED du document concerné. */
  fileId: Scalars['String']['input'];
  /** Nom du fichier tel qu'enregistré dans la GED. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Identifiant de l'investisseur associé au document, lorsqu'il n'y en a qu'un. */
  investisseurId?: InputMaybe<Scalars['Long']['input']>;
  /** Identifiants des investisseurs associés au document. */
  investisseurIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  /** Signataires sélectionnés pour envoyer ce document en signature. */
  signataires?: InputMaybe<Array<OperationSignatureSignerMetadataInput>>;
  /** Identifiant GED du document source auquel ce fichier signé est associé, notamment le document original remplacé en signature manuscrite. Null si le fichier n'est pas le document signé d'une source. */
  sourceFileId?: InputMaybe<Scalars['String']['input']>;
  /** Code du type de document GED. */
  typeDocumentCode?: InputMaybe<Scalars['String']['input']>;
  /** Numéro de version du document dans la GED, lorsqu'il est disponible. */
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type OperationSignatureDocumentRequirement = {
  __typename?: 'OperationSignatureDocumentRequirement';
  investisseurIds: Array<Scalars['Long']['output']>;
  typeDocumentCode: Scalars['String']['output'];
};


export type OperationSignatureDocumentRequirementInvestisseurIdsArgs = {
  where?: InputMaybe<LongOperationFilterInput>;
};

export type OperationSignatureDocumentRequirementFilterInput = {
  and?: InputMaybe<Array<OperationSignatureDocumentRequirementFilterInput>>;
  investisseurIds?: InputMaybe<ListLongOperationFilterInput>;
  or?: InputMaybe<Array<OperationSignatureDocumentRequirementFilterInput>>;
  typeDocumentCode?: InputMaybe<StringOperationFilterInput>;
};

export type OperationSignatureDocumentRequirementInput = {
  investisseurIds: Array<Scalars['Long']['input']>;
  typeDocumentCode: Scalars['String']['input'];
};

export enum OperationSignatureMode {
  Electronique = 'ELECTRONIQUE',
  Manuscrit = 'MANUSCRIT'
}

export type OperationSignatureSignerMetadata = {
  __typename?: 'OperationSignatureSignerMetadata';
  /** Adresse e-mail du signataire. */
  email: Scalars['String']['output'];
  /** Prénom du signataire. */
  firstName: Scalars['String']['output'];
  /** Identifiant interne du signataire, lorsqu'il est connu. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** Nom du signataire. */
  lastName: Scalars['String']['output'];
  /** Téléphone du signataire. */
  phone: Scalars['String']['output'];
  /** Type de signataire. */
  type: OperationSignatureSignerType;
};

export type OperationSignatureSignerMetadataFilterInput = {
  and?: InputMaybe<Array<OperationSignatureSignerMetadataFilterInput>>;
  /** Adresse e-mail du signataire. */
  email?: InputMaybe<StringOperationFilterInput>;
  /** Prénom du signataire. */
  firstName?: InputMaybe<StringOperationFilterInput>;
  /** Identifiant interne du signataire, lorsqu'il est connu. */
  internalId?: InputMaybe<IntOperationFilterInput>;
  /** Nom du signataire. */
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OperationSignatureSignerMetadataFilterInput>>;
  /** Téléphone du signataire. */
  phone?: InputMaybe<StringOperationFilterInput>;
  /** Type de signataire. */
  type?: InputMaybe<OperationSignatureSignerTypeOperationFilterInput>;
};

export type OperationSignatureSignerMetadataInput = {
  /** Adresse e-mail du signataire. */
  email: Scalars['String']['input'];
  /** Prénom du signataire. */
  firstName: Scalars['String']['input'];
  /** Identifiant interne du signataire, lorsqu'il est connu. */
  internalId?: InputMaybe<Scalars['Int']['input']>;
  /** Nom du signataire. */
  lastName: Scalars['String']['input'];
  /** Téléphone du signataire. */
  phone: Scalars['String']['input'];
  /** Type de signataire. */
  type: OperationSignatureSignerType;
};

export enum OperationSignatureSignerType {
  Consultant = 'CONSULTANT',
  Investisseur = 'INVESTISSEUR'
}

export type OperationSignatureSignerTypeOperationFilterInput = {
  eq?: InputMaybe<OperationSignatureSignerType>;
  in?: InputMaybe<Array<OperationSignatureSignerType>>;
  neq?: InputMaybe<OperationSignatureSignerType>;
  nin?: InputMaybe<Array<OperationSignatureSignerType>>;
};

export type OperationSignatureSnapshot = {
  __typename?: 'OperationSignatureSnapshot';
  /** Documents GED concernés par la signature et métadonnées GED actualisées. */
  documents?: Maybe<Array<OperationSignatureDocumentMetadata>>;
  /** Étape à partir de laquelle les données de signature ont été invalidées. */
  invalidatedFromStep?: Maybe<OperationState>;
  /** Indique si l'étape et les étapes précédentes sont verrouillées pendant le traitement des signatures. */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** Mode de signature choisi pour l'opération : électronique ou manuscrit. */
  mode?: Maybe<OperationSignatureMode>;
  /** Documents réellement requis, recalculés à chaque updateOperationData selon la configuration et la validité du DER de chaque investisseur. Null pour un ancien snapshot non encore calculé ; liste vide si aucun document n'est requis. */
  requiredDocuments?: Maybe<Array<OperationSignatureDocumentRequirement>>;
};


export type OperationSignatureSnapshotDocumentsArgs = {
  where?: InputMaybe<OperationSignatureDocumentMetadataFilterInput>;
};


export type OperationSignatureSnapshotRequiredDocumentsArgs = {
  where?: InputMaybe<OperationSignatureDocumentRequirementFilterInput>;
};

export type OperationSignatureSnapshotFilterInput = {
  and?: InputMaybe<Array<OperationSignatureSnapshotFilterInput>>;
  /** Documents GED concernés par la signature et métadonnées GED actualisées. */
  documents?: InputMaybe<ListFilterInputTypeOfOperationSignatureDocumentMetadataFilterInput>;
  /** Étape à partir de laquelle les données de signature ont été invalidées. */
  invalidatedFromStep?: InputMaybe<NullableOfOperationStateOperationFilterInput>;
  /** Indique si l'étape et les étapes précédentes sont verrouillées pendant le traitement des signatures. */
  isLocked?: InputMaybe<BooleanOperationFilterInput>;
  /** Mode de signature choisi pour l'opération : électronique ou manuscrit. */
  mode?: InputMaybe<NullableOfOperationSignatureModeOperationFilterInput>;
  or?: InputMaybe<Array<OperationSignatureSnapshotFilterInput>>;
  /** Documents réellement requis, recalculés à chaque updateOperationData selon la configuration et la validité du DER de chaque investisseur. Null pour un ancien snapshot non encore calculé ; liste vide si aucun document n'est requis. */
  requiredDocuments?: InputMaybe<ListFilterInputTypeOfOperationSignatureDocumentRequirementFilterInput>;
};

export type OperationSignatureSnapshotInput = {
  /** Documents GED concernés par la signature et métadonnées GED actualisées. */
  documents?: InputMaybe<Array<OperationSignatureDocumentMetadataInput>>;
  /** Étape à partir de laquelle les données de signature ont été invalidées. */
  invalidatedFromStep?: InputMaybe<OperationState>;
  /** Indique si l'étape et les étapes précédentes sont verrouillées pendant le traitement des signatures. */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mode de signature choisi pour l'opération : électronique ou manuscrit. */
  mode?: InputMaybe<OperationSignatureMode>;
  /** Documents réellement requis, recalculés à chaque updateOperationData selon la configuration et la validité du DER de chaque investisseur. Null pour un ancien snapshot non encore calculé ; liste vide si aucun document n'est requis. */
  requiredDocuments?: InputMaybe<Array<OperationSignatureDocumentRequirementInput>>;
};

export type OperationSnapshotData = {
  __typename?: 'OperationSnapshotData';
  /** Dernier rapport d'adéquation enregistré avec les données de l'opération. Null avant le premier contrôle ; sa conclusion ne garantit pas qu'il est encore à jour. */
  adequationReport?: Maybe<OperationAdequationReport>;
  besoin?: Maybe<BesoinsOperation>;
  boxPlacementUrl?: Maybe<Scalars['String']['output']>;
  connaissanceClient?: Maybe<ConnaissanceClientData>;
  conseil?: Maybe<ConseilOperation>;
  /** Données de configuration et de suivi de la signature de l'opération. */
  signature?: Maybe<OperationSignatureSnapshot>;
  /** Brouillon de souscription du produit courant. Absent pour les opérations non encore renseignées. */
  souscription?: Maybe<OperationSouscriptionSnapshot>;
};

export type OperationSnapshotDataFilterInput = {
  /** Dernier rapport d'adéquation enregistré avec les données de l'opération. Null avant le premier contrôle ; sa conclusion ne garantit pas qu'il est encore à jour. */
  adequationReport?: InputMaybe<OperationAdequationReportFilterInput>;
  and?: InputMaybe<Array<OperationSnapshotDataFilterInput>>;
  besoin?: InputMaybe<BesoinsOperationFilterInput>;
  boxPlacementUrl?: InputMaybe<StringOperationFilterInput>;
  connaissanceClient?: InputMaybe<ConnaissanceClientDataFilterInput>;
  conseil?: InputMaybe<ConseilOperationFilterInput>;
  or?: InputMaybe<Array<OperationSnapshotDataFilterInput>>;
  /** Données de configuration et de suivi de la signature de l'opération. */
  signature?: InputMaybe<OperationSignatureSnapshotFilterInput>;
  /** Brouillon de souscription du produit courant. Absent pour les opérations non encore renseignées. */
  souscription?: InputMaybe<OperationSouscriptionSnapshotFilterInput>;
};

export type OperationSnapshotDataInput = {
  besoin?: InputMaybe<BesoinsOperationInput>;
  boxPlacementUrl?: InputMaybe<Scalars['String']['input']>;
  connaissanceClient?: InputMaybe<ConnaissanceClientDataInput>;
  conseil?: InputMaybe<ConseilOperationInput>;
  /** Données de configuration et de suivi de la signature de l'opération. */
  signature?: InputMaybe<OperationSignatureSnapshotInput>;
  /** Brouillon de souscription du produit courant. Absent pour les opérations non encore renseignées. */
  souscription?: InputMaybe<OperationSouscriptionSnapshotInput>;
};

export type OperationSouscriptionSnapshot = {
  __typename?: 'OperationSouscriptionSnapshot';
  bulletinFileId?: Maybe<Scalars['String']['output']>;
  /** Ancien bulletin détaché dont la suppression logique GED reste à acquitter. Permet la reprise après une interruption. */
  bulletinFileIdToDelete?: Maybe<Scalars['String']['output']>;
  commentaire?: Maybe<Scalars['String']['output']>;
  dateSignature?: Maybe<Scalars['DateTime']['output']>;
  modeSignature?: Maybe<SouscriptionSignatureMode>;
  produitId: Scalars['Long']['output'];
  transmissionOriginaux?: Maybe<SouscriptionTransmissionOriginaux>;
};

export type OperationSouscriptionSnapshotFilterInput = {
  and?: InputMaybe<Array<OperationSouscriptionSnapshotFilterInput>>;
  bulletinFileId?: InputMaybe<StringOperationFilterInput>;
  /** Ancien bulletin détaché dont la suppression logique GED reste à acquitter. Permet la reprise après une interruption. */
  bulletinFileIdToDelete?: InputMaybe<StringOperationFilterInput>;
  commentaire?: InputMaybe<StringOperationFilterInput>;
  dateSignature?: InputMaybe<DateTimeOperationFilterInput>;
  modeSignature?: InputMaybe<NullableOfSouscriptionSignatureModeOperationFilterInput>;
  or?: InputMaybe<Array<OperationSouscriptionSnapshotFilterInput>>;
  produitId?: InputMaybe<LongOperationFilterInput>;
  transmissionOriginaux?: InputMaybe<NullableOfSouscriptionTransmissionOriginauxOperationFilterInput>;
};

export type OperationSouscriptionSnapshotInput = {
  bulletinFileId?: InputMaybe<Scalars['String']['input']>;
  commentaire?: InputMaybe<Scalars['String']['input']>;
  dateSignature?: InputMaybe<Scalars['DateTime']['input']>;
  modeSignature?: InputMaybe<SouscriptionSignatureMode>;
  produitId: Scalars['Long']['input'];
  transmissionOriginaux?: InputMaybe<SouscriptionTransmissionOriginaux>;
};

export enum OperationState {
  Archived = 'ARCHIVED',
  BoxPlacement = 'BOX_PLACEMENT',
  Conseil = 'CONSEIL',
  ExigenceBesoins = 'EXIGENCE_BESOINS',
  Prerequis = 'PREREQUIS',
  Signature = 'SIGNATURE',
  Souscription = 'SOUSCRIPTION'
}

export type OperationStateOperationFilterInput = {
  eq?: InputMaybe<OperationState>;
  in?: InputMaybe<Array<OperationState>>;
  neq?: InputMaybe<OperationState>;
  nin?: InputMaybe<Array<OperationState>>;
};

export enum OperationType {
  ActeDeGestion = 'ACTE_DE_GESTION',
  Souscription = 'SOUSCRIPTION'
}

/** A connection to a list of items. */
export type OperationsConnection = {
  __typename?: 'OperationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OperationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OperationConfigActivationOperation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OperationsEdge = {
  __typename?: 'OperationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OperationConfigActivationOperation;
};

/** A segment of a collection. */
export type OperationsForConsultantCollectionSegment = {
  __typename?: 'OperationsForConsultantCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Operation>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type OperationsForConsultantEnveloppe = {
  __typename?: 'OperationsForConsultantEnveloppe';
  code: Scalars['Byte']['output'];
  libelle: Scalars['String']['output'];
};

export type OperationsForConsultantEnveloppeFilterInput = {
  and?: InputMaybe<Array<OperationsForConsultantEnveloppeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OperationsForConsultantEnveloppeFilterInput>>;
};

export type OperationsForConsultantFilterInput = {
  enveloppeIds?: InputMaybe<Array<Scalars['Byte']['input']>>;
  investisseurId?: InputMaybe<Scalars['Long']['input']>;
  natureOperationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  produitIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  statuts?: InputMaybe<Array<OperationState>>;
};

export type OperationsForConsultantFilterValues = {
  __typename?: 'OperationsForConsultantFilterValues';
  enveloppes: Array<OperationsForConsultantEnveloppe>;
  natureOperations: Array<OperationsForConsultantNatureOperation>;
  produits: Array<OperationsForConsultantProduit>;
};


export type OperationsForConsultantFilterValuesEnveloppesArgs = {
  where?: InputMaybe<OperationsForConsultantEnveloppeFilterInput>;
};


export type OperationsForConsultantFilterValuesNatureOperationsArgs = {
  where?: InputMaybe<OperationsForConsultantNatureOperationFilterInput>;
};


export type OperationsForConsultantFilterValuesProduitsArgs = {
  where?: InputMaybe<OperationsForConsultantProduitFilterInput>;
};

export type OperationsForConsultantNatureOperation = {
  __typename?: 'OperationsForConsultantNatureOperation';
  id: Scalars['Int']['output'];
  libelle: Scalars['String']['output'];
};

export type OperationsForConsultantNatureOperationFilterInput = {
  and?: InputMaybe<Array<OperationsForConsultantNatureOperationFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OperationsForConsultantNatureOperationFilterInput>>;
};

export type OperationsForConsultantProduit = {
  __typename?: 'OperationsForConsultantProduit';
  id: Scalars['Long']['output'];
  nom: Scalars['String']['output'];
};

export type OperationsForConsultantProduitFilterInput = {
  and?: InputMaybe<Array<OperationsForConsultantProduitFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OperationsForConsultantProduitFilterInput>>;
};

export type OptionAutomatique = {
  __typename?: 'OptionAutomatique';
  id: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
  modeDeGestion: ModeDeGestion;
  modeDeGestionCode: Scalars['String']['output'];
  ordre: Scalars['Int']['output'];
  produits: Array<Produit>;
  statut: OptionAutomatiqueStatut;
};


export type OptionAutomatiqueProduitsArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type OptionAutomatiqueData = {
  __typename?: 'OptionAutomatiqueData';
  id: Scalars['String']['output'];
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  libelle: Scalars['String']['output'];
};

export type OptionAutomatiqueDataFilterInput = {
  and?: InputMaybe<Array<OptionAutomatiqueDataFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  isSelected?: InputMaybe<BooleanOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OptionAutomatiqueDataFilterInput>>;
};

export type OptionAutomatiqueDataInput = {
  id: Scalars['String']['input'];
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  libelle: Scalars['String']['input'];
};

export type OptionAutomatiqueFilterInput = {
  and?: InputMaybe<Array<OptionAutomatiqueFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  modeDeGestion?: InputMaybe<ModeDeGestionFilterInput>;
  modeDeGestionCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OptionAutomatiqueFilterInput>>;
  ordre?: InputMaybe<IntOperationFilterInput>;
  produits?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
  statut?: InputMaybe<OptionAutomatiqueStatutOperationFilterInput>;
};

export enum OptionAutomatiqueStatut {
  Actif = 'ACTIF',
  Inactive = 'INACTIVE'
}

export type OptionAutomatiqueStatutOperationFilterInput = {
  eq?: InputMaybe<OptionAutomatiqueStatut>;
  in?: InputMaybe<Array<OptionAutomatiqueStatut>>;
  neq?: InputMaybe<OptionAutomatiqueStatut>;
  nin?: InputMaybe<Array<OptionAutomatiqueStatut>>;
};

/** Réponse possible à une question du questionnaire Tolérance au risque */
export type OptionToleranceDto = {
  __typename?: 'OptionToleranceDto';
  /** Code de la réponse (ex. Q1R3) */
  code: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
  /** Profil associé (1 = Sécurisé … 5 = Offensif) pour Q1 et Q2, utilisé pour l'intitulé de Q4 */
  profil?: Maybe<Scalars['Int']['output']>;
  /** Scénario illustré (Q2) */
  scenario?: Maybe<ScenarioToleranceDto>;
};

/** Réponse possible à une question du questionnaire Tolérance au risque */
export type OptionToleranceDtoFilterInput = {
  and?: InputMaybe<Array<OptionToleranceDtoFilterInput>>;
  /** Code de la réponse (ex. Q1R3) */
  code?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OptionToleranceDtoFilterInput>>;
  /** Profil associé (1 = Sécurisé … 5 = Offensif) pour Q1 et Q2, utilisé pour l'intitulé de Q4 */
  profil?: InputMaybe<IntOperationFilterInput>;
  /** Scénario illustré (Q2) */
  scenario?: InputMaybe<ScenarioToleranceDtoFilterInput>;
};

/** Option d'une question de vérification */
export type OptionVerificationDto = {
  __typename?: 'OptionVerificationDto';
  /** Code de la réponse (R1 à R4) */
  code: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
};

/** Option d'une question de vérification */
export type OptionVerificationDtoFilterInput = {
  and?: InputMaybe<Array<OptionVerificationDtoFilterInput>>;
  /** Code de la réponse (R1 à R4) */
  code?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OptionVerificationDtoFilterInput>>;
};

export type Organisme = {
  __typename?: 'Organisme';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantHabilitationInscription: Array<ConsultantHabilitationInscription>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  departementCci?: Maybe<Scalars['String']['output']>;
  departementCciNavigation?: Maybe<Departement>;
  habilitationInscription: Array<HabilitationInscription>;
  libelle?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};


export type OrganismeConsultantHabilitationInscriptionArgs = {
  where?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
};


export type OrganismeHabilitationInscriptionArgs = {
  where?: InputMaybe<HabilitationInscriptionFilterInput>;
};

export type OrganismeAssureurRcp = {
  __typename?: 'OrganismeAssureurRCP';
  adresse?: Maybe<Scalars['String']['output']>;
  consultantRcp: Array<ConsultantRcp>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  nom: Scalars['String']['output'];
};


export type OrganismeAssureurRcpConsultantRcpArgs = {
  where?: InputMaybe<ConsultantRcpFilterInput>;
};

export type OrganismeAssureurRcpFilterInput = {
  adresse?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<OrganismeAssureurRcpFilterInput>>;
  consultantRcp?: InputMaybe<ListFilterInputTypeOfConsultantRcpFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrganismeAssureurRcpFilterInput>>;
};

export type OrganismeFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<OrganismeFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantHabilitationInscription?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInscriptionFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  departementCci?: InputMaybe<StringOperationFilterInput>;
  departementCciNavigation?: InputMaybe<DepartementFilterInput>;
  habilitationInscription?: InputMaybe<ListFilterInputTypeOfHabilitationInscriptionFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrganismeFilterInput>>;
  type?: InputMaybe<IntOperationFilterInput>;
};

export type OrigineContact = {
  __typename?: 'OrigineContact';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  investisseur: Array<Investisseur>;
  libelle: Scalars['String']['output'];
};


export type OrigineContactInvestisseurArgs = {
  where?: InputMaybe<InvestisseurFilterInput>;
};

export type OrigineContactFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<OrigineContactFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  investisseur?: InputMaybe<ListFilterInputTypeOfInvestisseurFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrigineContactFilterInput>>;
};

export type OrigineContactSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type OrigineData = {
  __typename?: 'OrigineData';
  actionDeFormation: Array<ActionDeFormation>;
  code: Scalars['Byte']['output'];
  consultant: Array<Consultant>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  investisseur: Array<Investisseur>;
  libelle: Scalars['String']['output'];
};


export type OrigineDataActionDeFormationArgs = {
  where?: InputMaybe<ActionDeFormationFilterInput>;
};


export type OrigineDataConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type OrigineDataInvestisseurArgs = {
  where?: InputMaybe<InvestisseurFilterInput>;
};

export type OrigineDataFilterInput = {
  actionDeFormation?: InputMaybe<ListFilterInputTypeOfActionDeFormationFilterInput>;
  and?: InputMaybe<Array<OrigineDataFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  investisseur?: InputMaybe<ListFilterInputTypeOfInvestisseurFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrigineDataFilterInput>>;
};

export type OrigineDataSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginatedResultOfFileMetadata = {
  __typename?: 'PaginatedResultOfFileMetadata';
  continuationToken?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<FileMetadata>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type PaginatedResultOfFileMetadataDataArgs = {
  where?: InputMaybe<FileMetadataFilterInput>;
};

export type Partenaire = {
  __typename?: 'Partenaire';
  activiteRattachement?: Maybe<Scalars['Byte']['output']>;
  activiteRattachementNavigation?: Maybe<ActiviteRattachPartenaire>;
  codePartenaire?: Maybe<Scalars['String']['output']>;
  contact: Array<Contact>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  nom: Scalars['String']['output'];
  nomComplet?: Maybe<Scalars['String']['output']>;
  produit: Array<Produit>;
};


export type PartenaireContactArgs = {
  where?: InputMaybe<ContactFilterInput>;
};


export type PartenaireProduitArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type PartenaireAgregation = {
  __typename?: 'PartenaireAgregation';
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  idPartenaire: Scalars['String']['output'];
  libelleCourt?: Maybe<Scalars['String']['output']>;
  libelleLong?: Maybe<Scalars['String']['output']>;
  typePartenaire?: Maybe<Scalars['Int']['output']>;
};

export type PartenaireAgregationFilterInput = {
  and?: InputMaybe<Array<PartenaireAgregationFilterInput>>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  idPartenaire?: InputMaybe<StringOperationFilterInput>;
  libelleCourt?: InputMaybe<StringOperationFilterInput>;
  libelleLong?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PartenaireAgregationFilterInput>>;
  typePartenaire?: InputMaybe<IntOperationFilterInput>;
};

export type PartenaireAgregationSortInput = {
  dateChargement?: InputMaybe<SortEnumType>;
  idPartenaire?: InputMaybe<SortEnumType>;
  libelleCourt?: InputMaybe<SortEnumType>;
  libelleLong?: InputMaybe<SortEnumType>;
  typePartenaire?: InputMaybe<SortEnumType>;
};

export type PartenaireFilterInput = {
  and?: InputMaybe<Array<PartenaireFilterInput>>;
  codePartenaire?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  nomComplet?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PartenaireFilterInput>>;
  produit?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

export type PartenaireSortInput = {
  activiteRattachement?: InputMaybe<SortEnumType>;
  activiteRattachementNavigation?: InputMaybe<ActiviteRattachPartenaireSortInput>;
  codePartenaire?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
  nomComplet?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type PartenairesPaginatedCollectionSegment = {
  __typename?: 'PartenairesPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Partenaire>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Passif = {
  __typename?: 'Passif';
  arianeId?: Maybe<Scalars['String']['output']>;
  capitalRestantDu: Scalars['Decimal']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateDebut: Scalars['DateTime']['output'];
  dateFin: Scalars['DateTime']['output'];
  dernierMoisTraite?: Maybe<Scalars['Int']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  dureePremierPalier?: Maybe<Scalars['Int']['output']>;
  dureeRestante: Scalars['Int']['output'];
  dureeSecondPalier?: Maybe<Scalars['Int']['output']>;
  dureeTroisiemePalier?: Maybe<Scalars['Int']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  mensualite: Scalars['Decimal']['output'];
  mensualitePremierPalier?: Maybe<Scalars['Decimal']['output']>;
  mensualiteSecondPalier?: Maybe<Scalars['Decimal']['output']>;
  mensualiteTroisiemePalier?: Maybe<Scalars['Decimal']['output']>;
  montant: Scalars['Decimal']['output'];
  patrimoine: Patrimoine;
  patrimoineActif?: Maybe<Actif>;
  patrimoineActifId?: Maybe<Scalars['Long']['output']>;
  patrimoineId: Scalars['Long']['output'];
  tauxNominal: Scalars['Decimal']['output'];
  type?: Maybe<TypePassif>;
};

export type PassifFilterInput = {
  and?: InputMaybe<Array<PassifFilterInput>>;
  arianeId?: InputMaybe<StringOperationFilterInput>;
  capitalRestantDu?: InputMaybe<DecimalOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  dernierMoisTraite?: InputMaybe<IntOperationFilterInput>;
  designation?: InputMaybe<StringOperationFilterInput>;
  dureePremierPalier?: InputMaybe<IntOperationFilterInput>;
  dureeRestante?: InputMaybe<IntOperationFilterInput>;
  dureeSecondPalier?: InputMaybe<IntOperationFilterInput>;
  dureeTroisiemePalier?: InputMaybe<IntOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  mensualite?: InputMaybe<DecimalOperationFilterInput>;
  mensualitePremierPalier?: InputMaybe<DecimalOperationFilterInput>;
  mensualiteSecondPalier?: InputMaybe<DecimalOperationFilterInput>;
  mensualiteTroisiemePalier?: InputMaybe<DecimalOperationFilterInput>;
  montant?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<PassifFilterInput>>;
  patrimoine?: InputMaybe<PatrimoineFilterInput>;
  patrimoineActif?: InputMaybe<ActifFilterInput>;
  patrimoineActifId?: InputMaybe<LongOperationFilterInput>;
  patrimoineId?: InputMaybe<LongOperationFilterInput>;
  tauxNominal?: InputMaybe<DecimalOperationFilterInput>;
  type?: InputMaybe<NullableOfTypePassifOperationFilterInput>;
};

export type PassifSortInput = {
  arianeId?: InputMaybe<SortEnumType>;
  capitalRestantDu?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateDebut?: InputMaybe<SortEnumType>;
  dateFin?: InputMaybe<SortEnumType>;
  dernierMoisTraite?: InputMaybe<SortEnumType>;
  designation?: InputMaybe<SortEnumType>;
  dureePremierPalier?: InputMaybe<SortEnumType>;
  dureeRestante?: InputMaybe<SortEnumType>;
  dureeSecondPalier?: InputMaybe<SortEnumType>;
  dureeTroisiemePalier?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  mensualite?: InputMaybe<SortEnumType>;
  mensualitePremierPalier?: InputMaybe<SortEnumType>;
  mensualiteSecondPalier?: InputMaybe<SortEnumType>;
  mensualiteTroisiemePalier?: InputMaybe<SortEnumType>;
  montant?: InputMaybe<SortEnumType>;
  patrimoine?: InputMaybe<PatrimoineSortInput>;
  patrimoineActif?: InputMaybe<ActifSortInput>;
  patrimoineActifId?: InputMaybe<SortEnumType>;
  patrimoineId?: InputMaybe<SortEnumType>;
  tauxNominal?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum PatchFields {
  ActifDetentionPp = 'ACTIF_DETENTION_PP',
  ChargeCreditSimplifie = 'CHARGE_CREDIT_SIMPLIFIE',
  CreditSimplifie = 'CREDIT_SIMPLIFIE',
  DateFinCreditSimplifie = 'DATE_FIN_CREDIT_SIMPLIFIE',
  DocumentsTags = 'DOCUMENTS_TAGS',
  DonationDernierVivant = 'DONATION_DERNIER_VIVANT',
  EnfantACharge = 'ENFANT_A_CHARGE',
  EtatCni = 'ETAT_CNI',
  ExpirationDoc = 'EXPIRATION_DOC',
  GerePar = 'GERE_PAR',
  LoyerBrutAnnuelActifFoncier = 'LOYER_BRUT_ANNUEL_ACTIF_FONCIER',
  None = 'NONE',
  OrganismeActifFinancier = 'ORGANISME_ACTIF_FINANCIER',
  PassifDetention = 'PASSIF_DETENTION',
  PatrimoineAgregationV2 = 'PATRIMOINE_AGREGATION_V2',
  PatrimoineCategorieDemembrementScpi = 'PATRIMOINE_CATEGORIE_DEMEMBREMENT_SCPI',
  QpiHistory = 'QPI_HISTORY',
  RecommandePar = 'RECOMMANDE_PAR'
}

export type Patrimoine = {
  __typename?: 'Patrimoine';
  arianeId?: Maybe<Scalars['String']['output']>;
  categorieCode: Scalars['Long']['output'];
  commentaires?: Maybe<Array<CommentairePatrimoine>>;
  creationDate: Scalars['DateTime']['output'];
  designation?: Maybe<Scalars['String']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  investisseurPatrimoines: Array<InvestisseurPatrimoine>;
  patrimoineActif?: Maybe<Actif>;
  patrimoineBudgets?: Maybe<Array<PatrimoineBudget>>;
  patrimoineCategorie: PatrimoineCategorieReference;
  patrimoinePassif?: Maybe<Passif>;
  patrimoinePrevoyance?: Maybe<PatrimoinePrevoyance>;
};


export type PatrimoineCommentairesArgs = {
  where?: InputMaybe<CommentairePatrimoineFilterInput>;
};


export type PatrimoineInvestisseurPatrimoinesArgs = {
  where?: InputMaybe<InvestisseurPatrimoineFilterInput>;
};


export type PatrimoinePatrimoineBudgetsArgs = {
  where?: InputMaybe<PatrimoineBudgetFilterInput>;
};

export type PatrimoineActif = {
  __typename?: 'PatrimoineActif';
  arianeId?: Maybe<Scalars['Long']['output']>;
  autresChampsJson?: Maybe<Scalars['String']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['LocalDate']['output']>;
  dateNaissanceUsufruitier?: Maybe<Scalars['LocalDate']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  detenteurPatrimoineActif: Array<DetenteurPatrimoineActif>;
  detentionCode?: Maybe<Scalars['String']['output']>;
  detentionCodeNavigation?: Maybe<Detention>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  montant?: Maybe<Scalars['Decimal']['output']>;
  natureCode: Scalars['String']['output'];
  natureCodeNavigation: NaturePatrimoine;
  note?: Maybe<Scalars['String']['output']>;
  patrimoinePassif: Array<PatrimoinePassif>;
};


export type PatrimoineActifDetenteurPatrimoineActifArgs = {
  where?: InputMaybe<DetenteurPatrimoineActifFilterInput>;
};


export type PatrimoineActifPatrimoinePassifArgs = {
  where?: InputMaybe<PatrimoinePassifFilterInput>;
};

export type PatrimoineActifFilterInput = {
  and?: InputMaybe<Array<PatrimoineActifFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  autresChampsJson?: InputMaybe<StringOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  date?: InputMaybe<LocalDateOperationFilterInput>;
  dateNaissanceUsufruitier?: InputMaybe<LocalDateOperationFilterInput>;
  designation?: InputMaybe<StringOperationFilterInput>;
  detenteurPatrimoineActif?: InputMaybe<ListFilterInputTypeOfDetenteurPatrimoineActifFilterInput>;
  detentionCode?: InputMaybe<StringOperationFilterInput>;
  detentionCodeNavigation?: InputMaybe<DetentionFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  montant?: InputMaybe<DecimalOperationFilterInput>;
  natureCode?: InputMaybe<StringOperationFilterInput>;
  natureCodeNavigation?: InputMaybe<NaturePatrimoineFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatrimoineActifFilterInput>>;
  patrimoinePassif?: InputMaybe<ListFilterInputTypeOfPatrimoinePassifFilterInput>;
};

export type PatrimoineBudget = {
  __typename?: 'PatrimoineBudget';
  budget: Budget;
  budgetId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  patrimoine: Patrimoine;
  patrimoineId: Scalars['Long']['output'];
};

export type PatrimoineBudgetFilterInput = {
  and?: InputMaybe<Array<PatrimoineBudgetFilterInput>>;
  budget?: InputMaybe<BudgetFilterInput>;
  budgetId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<PatrimoineBudgetFilterInput>>;
  patrimoine?: InputMaybe<PatrimoineFilterInput>;
  patrimoineId?: InputMaybe<LongOperationFilterInput>;
};

export type PatrimoineCategorieReference = {
  __typename?: 'PatrimoineCategorieReference';
  categoryLibelle: Scalars['String']['output'];
  code: Scalars['Long']['output'];
  patrimoineCategory: PatrimoineCategoryEnum;
  subCategory?: Maybe<SubCategoryEnum>;
  subCategory2?: Maybe<SubCategory2Enum>;
  subCategory2Libelle?: Maybe<Scalars['String']['output']>;
  subCategoryLibelle?: Maybe<Scalars['String']['output']>;
};

export type PatrimoineCategorieReferenceFilterInput = {
  and?: InputMaybe<Array<PatrimoineCategorieReferenceFilterInput>>;
  categoryLibelle?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<PatrimoineCategorieReferenceFilterInput>>;
  patrimoineCategory?: InputMaybe<PatrimoineCategoryEnumOperationFilterInput>;
  subCategory?: InputMaybe<NullableOfSubCategoryEnumOperationFilterInput>;
  subCategory2?: InputMaybe<NullableOfSubCategory2EnumOperationFilterInput>;
  subCategory2Libelle?: InputMaybe<StringOperationFilterInput>;
  subCategoryLibelle?: InputMaybe<StringOperationFilterInput>;
};

export type PatrimoineCategorieReferenceSortInput = {
  categoryLibelle?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  patrimoineCategory?: InputMaybe<SortEnumType>;
  subCategory?: InputMaybe<SortEnumType>;
  subCategory2?: InputMaybe<SortEnumType>;
  subCategory2Libelle?: InputMaybe<SortEnumType>;
  subCategoryLibelle?: InputMaybe<SortEnumType>;
};

export enum PatrimoineCategoryEnum {
  Actifs = 'ACTIFS',
  Passif = 'PASSIF',
  Prevoyance = 'PREVOYANCE'
}

export type PatrimoineCategoryEnumOperationFilterInput = {
  eq?: InputMaybe<PatrimoineCategoryEnum>;
  in?: InputMaybe<Array<PatrimoineCategoryEnum>>;
  neq?: InputMaybe<PatrimoineCategoryEnum>;
  nin?: InputMaybe<Array<PatrimoineCategoryEnum>>;
};

export type PatrimoineChargeRevenu = {
  __typename?: 'PatrimoineChargeRevenu';
  arianeId?: Maybe<Scalars['Long']['output']>;
  autresChampsJson?: Maybe<Scalars['String']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  detenteurPatrimoineChargeRevenu: Array<DetenteurPatrimoineChargeRevenu>;
  detentionCode?: Maybe<Scalars['String']['output']>;
  detentionCodeNavigation?: Maybe<Detention>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseurId?: Maybe<Scalars['Long']['output']>;
  montant?: Maybe<Scalars['Decimal']['output']>;
  natureCode: Scalars['String']['output'];
  natureCodeNavigation: NaturePatrimoine;
  note?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};


export type PatrimoineChargeRevenuDetenteurPatrimoineChargeRevenuArgs = {
  where?: InputMaybe<DetenteurPatrimoineChargeRevenuFilterInput>;
};

export type PatrimoineChargeRevenuFilterInput = {
  and?: InputMaybe<Array<PatrimoineChargeRevenuFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  autresChampsJson?: InputMaybe<StringOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  designation?: InputMaybe<StringOperationFilterInput>;
  detenteurPatrimoineChargeRevenu?: InputMaybe<ListFilterInputTypeOfDetenteurPatrimoineChargeRevenuFilterInput>;
  detentionCode?: InputMaybe<StringOperationFilterInput>;
  detentionCodeNavigation?: InputMaybe<DetentionFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  montant?: InputMaybe<DecimalOperationFilterInput>;
  natureCode?: InputMaybe<StringOperationFilterInput>;
  natureCodeNavigation?: InputMaybe<NaturePatrimoineFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatrimoineChargeRevenuFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type PatrimoineFilterInput = {
  and?: InputMaybe<Array<PatrimoineFilterInput>>;
  arianeId?: InputMaybe<StringOperationFilterInput>;
  categorieCode?: InputMaybe<LongOperationFilterInput>;
  commentaires?: InputMaybe<ListFilterInputTypeOfCommentairePatrimoineFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  designation?: InputMaybe<StringOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseurPatrimoines?: InputMaybe<ListFilterInputTypeOfInvestisseurPatrimoineFilterInput>;
  or?: InputMaybe<Array<PatrimoineFilterInput>>;
  patrimoineActif?: InputMaybe<ActifFilterInput>;
  patrimoineBudgets?: InputMaybe<ListFilterInputTypeOfPatrimoineBudgetFilterInput>;
  patrimoineCategorie?: InputMaybe<PatrimoineCategorieReferenceFilterInput>;
  patrimoinePassif?: InputMaybe<PassifFilterInput>;
  patrimoinePrevoyance?: InputMaybe<PatrimoinePrevoyanceFilterInput>;
};

export type PatrimoineFiscalite = {
  __typename?: 'PatrimoineFiscalite';
  annee?: Maybe<Scalars['Int']['output']>;
  baseImposable?: Maybe<Scalars['Decimal']['output']>;
  chargesDeductibles?: Maybe<Scalars['Decimal']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  csAutresChampsJson?: Maybe<Scalars['String']['output']>;
  csTotalPrelevSociauxNet?: Maybe<Scalars['Decimal']['output']>;
  csgDeductible?: Maybe<Scalars['Decimal']['output']>;
  decote?: Maybe<Scalars['Decimal']['output']>;
  deficitFoncier?: Maybe<Scalars['Decimal']['output']>;
  disponibleFiscal?: Maybe<Scalars['Decimal']['output']>;
  droitsImmo?: Maybe<Scalars['Decimal']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  idSource?: Maybe<Scalars['String']['output']>;
  ifiAutresChampsJson?: Maybe<Scalars['String']['output']>;
  ifiNetAPayer?: Maybe<Scalars['Decimal']['output']>;
  ifiReduction?: Maybe<Scalars['Decimal']['output']>;
  ifiTmi?: Maybe<Scalars['Decimal']['output']>;
  immBatis?: Maybe<Scalars['Decimal']['output']>;
  immNonBatis?: Maybe<Scalars['Decimal']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  irAutresChampsJson?: Maybe<Scalars['String']['output']>;
  irNbParts?: Maybe<Scalars['Decimal']['output']>;
  irNetAvantCorrections?: Maybe<Scalars['Decimal']['output']>;
  irPlafondRetraite?: Maybe<Scalars['Decimal']['output']>;
  irRevenuImposable?: Maybe<Scalars['Decimal']['output']>;
  irSoumis?: Maybe<Scalars['Decimal']['output']>;
  irTauxImposition?: Maybe<Scalars['Decimal']['output']>;
  irTmi?: Maybe<Scalars['Decimal']['output']>;
  irTotalImpotNet?: Maybe<Scalars['Decimal']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  passifDeductible?: Maybe<Scalars['Decimal']['output']>;
  revenuBrutGlobal?: Maybe<Scalars['Decimal']['output']>;
  revenuFiscalDeRef?: Maybe<Scalars['Decimal']['output']>;
  totalCreditImpot?: Maybe<Scalars['Decimal']['output']>;
  totalReduImpots?: Maybe<Scalars['Decimal']['output']>;
  totalSalaireAssimile?: Maybe<Scalars['Decimal']['output']>;
};

export type PatrimoineFiscaliteFilterInput = {
  and?: InputMaybe<Array<PatrimoineFiscaliteFilterInput>>;
  annee?: InputMaybe<IntOperationFilterInput>;
  baseImposable?: InputMaybe<DecimalOperationFilterInput>;
  chargesDeductibles?: InputMaybe<DecimalOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  csAutresChampsJson?: InputMaybe<StringOperationFilterInput>;
  csTotalPrelevSociauxNet?: InputMaybe<DecimalOperationFilterInput>;
  csgDeductible?: InputMaybe<DecimalOperationFilterInput>;
  decote?: InputMaybe<DecimalOperationFilterInput>;
  deficitFoncier?: InputMaybe<DecimalOperationFilterInput>;
  disponibleFiscal?: InputMaybe<DecimalOperationFilterInput>;
  droitsImmo?: InputMaybe<DecimalOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  ifiAutresChampsJson?: InputMaybe<StringOperationFilterInput>;
  ifiNetAPayer?: InputMaybe<DecimalOperationFilterInput>;
  ifiReduction?: InputMaybe<DecimalOperationFilterInput>;
  ifiTmi?: InputMaybe<DecimalOperationFilterInput>;
  immBatis?: InputMaybe<DecimalOperationFilterInput>;
  immNonBatis?: InputMaybe<DecimalOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  irAutresChampsJson?: InputMaybe<StringOperationFilterInput>;
  irNbParts?: InputMaybe<DecimalOperationFilterInput>;
  irNetAvantCorrections?: InputMaybe<DecimalOperationFilterInput>;
  irPlafondRetraite?: InputMaybe<DecimalOperationFilterInput>;
  irRevenuImposable?: InputMaybe<DecimalOperationFilterInput>;
  irSoumis?: InputMaybe<DecimalOperationFilterInput>;
  irTauxImposition?: InputMaybe<DecimalOperationFilterInput>;
  irTmi?: InputMaybe<DecimalOperationFilterInput>;
  irTotalImpotNet?: InputMaybe<DecimalOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatrimoineFiscaliteFilterInput>>;
  passifDeductible?: InputMaybe<DecimalOperationFilterInput>;
  revenuBrutGlobal?: InputMaybe<DecimalOperationFilterInput>;
  revenuFiscalDeRef?: InputMaybe<DecimalOperationFilterInput>;
  totalCreditImpot?: InputMaybe<DecimalOperationFilterInput>;
  totalReduImpots?: InputMaybe<DecimalOperationFilterInput>;
  totalSalaireAssimile?: InputMaybe<DecimalOperationFilterInput>;
};

export type PatrimoineFiscaliteSortInput = {
  annee?: InputMaybe<SortEnumType>;
  baseImposable?: InputMaybe<SortEnumType>;
  chargesDeductibles?: InputMaybe<SortEnumType>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  csAutresChampsJson?: InputMaybe<SortEnumType>;
  csTotalPrelevSociauxNet?: InputMaybe<SortEnumType>;
  csgDeductible?: InputMaybe<SortEnumType>;
  decote?: InputMaybe<SortEnumType>;
  deficitFoncier?: InputMaybe<SortEnumType>;
  disponibleFiscal?: InputMaybe<SortEnumType>;
  droitsImmo?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  ifiAutresChampsJson?: InputMaybe<SortEnumType>;
  ifiNetAPayer?: InputMaybe<SortEnumType>;
  ifiReduction?: InputMaybe<SortEnumType>;
  ifiTmi?: InputMaybe<SortEnumType>;
  immBatis?: InputMaybe<SortEnumType>;
  immNonBatis?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  irAutresChampsJson?: InputMaybe<SortEnumType>;
  irNbParts?: InputMaybe<SortEnumType>;
  irNetAvantCorrections?: InputMaybe<SortEnumType>;
  irPlafondRetraite?: InputMaybe<SortEnumType>;
  irRevenuImposable?: InputMaybe<SortEnumType>;
  irSoumis?: InputMaybe<SortEnumType>;
  irTauxImposition?: InputMaybe<SortEnumType>;
  irTmi?: InputMaybe<SortEnumType>;
  irTotalImpotNet?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  passifDeductible?: InputMaybe<SortEnumType>;
  revenuBrutGlobal?: InputMaybe<SortEnumType>;
  revenuFiscalDeRef?: InputMaybe<SortEnumType>;
  totalCreditImpot?: InputMaybe<SortEnumType>;
  totalReduImpots?: InputMaybe<SortEnumType>;
  totalSalaireAssimile?: InputMaybe<SortEnumType>;
};

export type PatrimoineInput = {
  affecteA?: InputMaybe<Scalars['String']['input']>;
  associatedBudgets?: InputMaybe<Array<Scalars['Long']['input']>>;
  associatedPatrimoines?: InputMaybe<Array<Scalars['Long']['input']>>;
  benefiaires?: InputMaybe<Scalars['String']['input']>;
  capitalAssure?: InputMaybe<Scalars['Decimal']['input']>;
  capitalRestantDu?: InputMaybe<Scalars['Decimal']['input']>;
  categorieCode: Scalars['Long']['input'];
  chargesImmo?: InputMaybe<Scalars['Decimal']['input']>;
  commentaires?: InputMaybe<Scalars['String']['input']>;
  dateAcquisition?: InputMaybe<Scalars['DateTime']['input']>;
  dateDebut?: InputMaybe<Scalars['DateTime']['input']>;
  dateDebutDemembrement?: InputMaybe<Scalars['DateTime']['input']>;
  dateDisponibilite?: InputMaybe<Scalars['DateTime']['input']>;
  dateFin?: InputMaybe<Scalars['DateTime']['input']>;
  dateFinDemembrement?: InputMaybe<Scalars['DateTime']['input']>;
  dateOuverture?: InputMaybe<Scalars['DateTime']['input']>;
  debiteur?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  designationCredit?: InputMaybe<Scalars['String']['input']>;
  disponible?: InputMaybe<Scalars['Boolean']['input']>;
  dureePremierPalier?: InputMaybe<Scalars['Int']['input']>;
  dureeRestante?: InputMaybe<Scalars['Int']['input']>;
  dureeSecondPalier?: InputMaybe<Scalars['Int']['input']>;
  dureeTroisiemePalier?: InputMaybe<Scalars['Int']['input']>;
  epargneDisponible?: InputMaybe<Scalars['Decimal']['input']>;
  epargneNonDisponible?: InputMaybe<Scalars['Decimal']['input']>;
  epargnePrecaution?: InputMaybe<Scalars['Decimal']['input']>;
  epargneSecurise?: InputMaybe<Scalars['Decimal']['input']>;
  generatedBudgets?: InputMaybe<Array<GeneratedBudgetInput>>;
  investisseurInput: Array<InvestisseurInput>;
  loyerBrutsAnnuel?: InputMaybe<Scalars['Decimal']['input']>;
  loyersAnnuelBIC?: InputMaybe<Scalars['Decimal']['input']>;
  loyersAnnuelRevenusFonciers?: InputMaybe<Scalars['Decimal']['input']>;
  mensualite?: InputMaybe<Scalars['Decimal']['input']>;
  mensualitePremierPalier?: InputMaybe<Scalars['Decimal']['input']>;
  mensualiteSecondPalier?: InputMaybe<Scalars['Decimal']['input']>;
  mensualiteTroisiemePalier?: InputMaybe<Scalars['Decimal']['input']>;
  modeDetention?: InputMaybe<TypeDetentionEnum>;
  montant?: InputMaybe<Scalars['Decimal']['input']>;
  montantDisponible?: InputMaybe<Scalars['Decimal']['input']>;
  naturePassif?: InputMaybe<TypePassif>;
  numeroContrat?: InputMaybe<Scalars['String']['input']>;
  patrimoineId?: InputMaybe<Scalars['Long']['input']>;
  prixAcquisition?: InputMaybe<Scalars['Decimal']['input']>;
  regimeFiscal?: InputMaybe<TypeRegimeFiscalEnum>;
  revenuAnnuel?: InputMaybe<Scalars['Decimal']['input']>;
  sciImposableA?: InputMaybe<Scalars['Boolean']['input']>;
  tauxNominal?: InputMaybe<Scalars['Float']['input']>;
  taxeFonciere?: InputMaybe<Scalars['Decimal']['input']>;
  taxeHabitation?: InputMaybe<Scalars['Decimal']['input']>;
  typeActif?: InputMaybe<TypeActifEnum>;
  typeDePropriete?: InputMaybe<TypeDetentionEnum>;
  typeLocation?: InputMaybe<TypeLocationEnum>;
  typePrevoyance?: InputMaybe<TypePrevoyance>;
  typeSCPI?: InputMaybe<TypeScpiEnum>;
  valeurEstimee?: InputMaybe<Scalars['Decimal']['input']>;
  valeurEstimeePassifAutre?: InputMaybe<Scalars['Decimal']['input']>;
  valorisationDuDroitDemembre?: InputMaybe<Scalars['Decimal']['input']>;
  versementProgrammes?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PatrimoinePassif = {
  __typename?: 'PatrimoinePassif';
  actifLie?: Maybe<PatrimoineActif>;
  actifLieId?: Maybe<Scalars['Long']['output']>;
  arianeId?: Maybe<Scalars['Long']['output']>;
  autresChampsJson?: Maybe<Scalars['String']['output']>;
  capitalRestantDu?: Maybe<Scalars['Decimal']['output']>;
  commun?: Maybe<Scalars['UUID']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateSouscription?: Maybe<Scalars['LocalDate']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  detenteurPatrimoinePassif: Array<DetenteurPatrimoinePassif>;
  detentionCode?: Maybe<Scalars['String']['output']>;
  detentionCodeNavigation?: Maybe<Detention>;
  duree?: Maybe<Scalars['Int']['output']>;
  dureeRestante?: Maybe<Scalars['Int']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseurId?: Maybe<Scalars['Long']['output']>;
  mensualiteAdi?: Maybe<Scalars['Decimal']['output']>;
  montant?: Maybe<Scalars['Decimal']['output']>;
  natureCode: Scalars['String']['output'];
  natureCodeNavigation: NaturePatrimoine;
  note?: Maybe<Scalars['String']['output']>;
  quotePartAdi?: Maybe<Scalars['Decimal']['output']>;
  tauxAdi?: Maybe<Scalars['Decimal']['output']>;
  tauxDetention?: Maybe<Scalars['Decimal']['output']>;
  typeCredit?: Maybe<Scalars['String']['output']>;
  typeCreditNavigation?: Maybe<TypeCredit>;
};


export type PatrimoinePassifDetenteurPatrimoinePassifArgs = {
  where?: InputMaybe<DetenteurPatrimoinePassifFilterInput>;
};

export type PatrimoinePassifFilterInput = {
  actifLie?: InputMaybe<PatrimoineActifFilterInput>;
  actifLieId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<PatrimoinePassifFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  autresChampsJson?: InputMaybe<StringOperationFilterInput>;
  capitalRestantDu?: InputMaybe<DecimalOperationFilterInput>;
  commun?: InputMaybe<UuidOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateSouscription?: InputMaybe<LocalDateOperationFilterInput>;
  designation?: InputMaybe<StringOperationFilterInput>;
  detenteurPatrimoinePassif?: InputMaybe<ListFilterInputTypeOfDetenteurPatrimoinePassifFilterInput>;
  detentionCode?: InputMaybe<StringOperationFilterInput>;
  detentionCodeNavigation?: InputMaybe<DetentionFilterInput>;
  duree?: InputMaybe<IntOperationFilterInput>;
  dureeRestante?: InputMaybe<IntOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  mensualiteAdi?: InputMaybe<DecimalOperationFilterInput>;
  montant?: InputMaybe<DecimalOperationFilterInput>;
  natureCode?: InputMaybe<StringOperationFilterInput>;
  natureCodeNavigation?: InputMaybe<NaturePatrimoineFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatrimoinePassifFilterInput>>;
  quotePartAdi?: InputMaybe<DecimalOperationFilterInput>;
  tauxAdi?: InputMaybe<DecimalOperationFilterInput>;
  tauxDetention?: InputMaybe<DecimalOperationFilterInput>;
  typeCredit?: InputMaybe<StringOperationFilterInput>;
  typeCreditNavigation?: InputMaybe<TypeCreditFilterInput>;
};

export type PatrimoinePrevoyance = {
  __typename?: 'PatrimoinePrevoyance';
  benefiaires?: Maybe<Scalars['String']['output']>;
  capitalAssure: Scalars['Decimal']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  numeroContrat?: Maybe<Scalars['String']['output']>;
  patrimoine: Patrimoine;
  patrimoineId: Scalars['Long']['output'];
  type?: Maybe<TypePrevoyance>;
};

export type PatrimoinePrevoyanceFilterInput = {
  and?: InputMaybe<Array<PatrimoinePrevoyanceFilterInput>>;
  benefiaires?: InputMaybe<StringOperationFilterInput>;
  capitalAssure?: InputMaybe<DecimalOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  numeroContrat?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatrimoinePrevoyanceFilterInput>>;
  patrimoine?: InputMaybe<PatrimoineFilterInput>;
  patrimoineId?: InputMaybe<LongOperationFilterInput>;
  type?: InputMaybe<NullableOfTypePrevoyanceOperationFilterInput>;
};

export type PatrimoinePrevoyanceSortInput = {
  benefiaires?: InputMaybe<SortEnumType>;
  capitalAssure?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  numeroContrat?: InputMaybe<SortEnumType>;
  patrimoine?: InputMaybe<PatrimoineSortInput>;
  patrimoineId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type PatrimoineSortInput = {
  arianeId?: InputMaybe<SortEnumType>;
  categorieCode?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  designation?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  patrimoineActif?: InputMaybe<ActifSortInput>;
  patrimoineCategorie?: InputMaybe<PatrimoineCategorieReferenceSortInput>;
  patrimoinePassif?: InputMaybe<PassifSortInput>;
  patrimoinePrevoyance?: InputMaybe<PatrimoinePrevoyanceSortInput>;
};

export type Pays = {
  __typename?: 'Pays';
  actif?: Maybe<Scalars['Boolean']['output']>;
  adresse: Array<Adresse>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatCivil: Array<EtatCivil>;
  inverseNationaliteCodeNavigation: Array<Pays>;
  libelle: Scalars['String']['output'];
  nationalite?: Maybe<Scalars['String']['output']>;
  nationaliteCode: Scalars['String']['output'];
  nationaliteCodeNavigation: Pays;
  personnePhysiqueCodePaysNaissanceNavigation: Array<PersonnePhysique>;
  personnePhysiqueCodePaysNationaliteNavigation: Array<PersonnePhysique>;
  personnePhysiqueCodePaysNationaliteSecondaireNavigation: Array<PersonnePhysique>;
  reglementaireCodePaysFactaResidenceFiscaleNavigation: Array<Reglementaire>;
  reglementaireCodePaysPpeNavigation: Array<Reglementaire>;
};


export type PaysAdresseArgs = {
  where?: InputMaybe<AdresseFilterInput>;
};


export type PaysEtatCivilArgs = {
  where?: InputMaybe<EtatCivilFilterInput>;
};


export type PaysInverseNationaliteCodeNavigationArgs = {
  where?: InputMaybe<PaysFilterInput>;
};


export type PaysPersonnePhysiqueCodePaysNaissanceNavigationArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};


export type PaysPersonnePhysiqueCodePaysNationaliteNavigationArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};


export type PaysPersonnePhysiqueCodePaysNationaliteSecondaireNavigationArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};


export type PaysReglementaireCodePaysFactaResidenceFiscaleNavigationArgs = {
  where?: InputMaybe<ReglementaireFilterInput>;
};


export type PaysReglementaireCodePaysPpeNavigationArgs = {
  where?: InputMaybe<ReglementaireFilterInput>;
};

export type PaysFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  adresse?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  and?: InputMaybe<Array<PaysFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatCivil?: InputMaybe<ListFilterInputTypeOfEtatCivilFilterInput>;
  inverseNationaliteCodeNavigation?: InputMaybe<ListFilterInputTypeOfPaysFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  nationalite?: InputMaybe<StringOperationFilterInput>;
  nationaliteCode?: InputMaybe<StringOperationFilterInput>;
  nationaliteCodeNavigation?: InputMaybe<PaysFilterInput>;
  or?: InputMaybe<Array<PaysFilterInput>>;
  personnePhysiqueCodePaysNaissanceNavigation?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  personnePhysiqueCodePaysNationaliteNavigation?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  personnePhysiqueCodePaysNationaliteSecondaireNavigation?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  reglementaireCodePaysFactaResidenceFiscaleNavigation?: InputMaybe<ListFilterInputTypeOfReglementaireFilterInput>;
  reglementaireCodePaysPpeNavigation?: InputMaybe<ListFilterInputTypeOfReglementaireFilterInput>;
};

export type PaysSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  nationalite?: InputMaybe<SortEnumType>;
  nationaliteCode?: InputMaybe<SortEnumType>;
  nationaliteCodeNavigation?: InputMaybe<PaysSortInput>;
};

export type PeriodiciteMouvement = {
  __typename?: 'PeriodiciteMouvement';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  mouvement: Array<Mouvement>;
};


export type PeriodiciteMouvementMouvementArgs = {
  where?: InputMaybe<MouvementFilterInput>;
};

export type PeriodiciteMouvementFilterInput = {
  and?: InputMaybe<Array<PeriodiciteMouvementFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  mouvement?: InputMaybe<ListFilterInputTypeOfMouvementFilterInput>;
  or?: InputMaybe<Array<PeriodiciteMouvementFilterInput>>;
};

export type PeriodiciteMouvementSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type PeriodiciteVp = {
  __typename?: 'PeriodiciteVp';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  libelle?: Maybe<Scalars['String']['output']>;
};

export type PeriodiciteVpFilterInput = {
  and?: InputMaybe<Array<PeriodiciteVpFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PeriodiciteVpFilterInput>>;
};

export type PeriodiciteVpSortInput = {
  code?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export enum Permission {
  Read = 'READ',
  ReadWrite = 'READ_WRITE'
}

export type PersonneMorale = {
  __typename?: 'PersonneMorale';
  codeNafApe?: Maybe<Scalars['String']['output']>;
  contact: Array<Contact>;
  creationDate: Scalars['DateTime']['output'];
  denomination?: Maybe<Scalars['String']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  formeJuridique?: Maybe<FormeJuridique>;
  formeJuridiqueId?: Maybe<Scalars['Byte']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  personneMoraleAdresse: Array<PersonneMoraleAdresse>;
  personneMoraleTelephone: Array<PersonneMoraleTelephone>;
  siretSiren?: Maybe<Scalars['String']['output']>;
  siteInternet?: Maybe<Scalars['String']['output']>;
};


export type PersonneMoraleContactArgs = {
  where?: InputMaybe<ContactFilterInput>;
};


export type PersonneMoralePersonneMoraleAdresseArgs = {
  where?: InputMaybe<PersonneMoraleAdresseFilterInput>;
};


export type PersonneMoralePersonneMoraleTelephoneArgs = {
  where?: InputMaybe<PersonneMoraleTelephoneFilterInput>;
};

export type PersonneMoraleAdresse = {
  __typename?: 'PersonneMoraleAdresse';
  adresse: Adresse;
  adresseId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  personneMorale: PersonneMorale;
  personneMoraleId: Scalars['Long']['output'];
};

export type PersonneMoraleAdresseFilterInput = {
  adresse?: InputMaybe<AdresseFilterInput>;
  adresseId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<PersonneMoraleAdresseFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<PersonneMoraleAdresseFilterInput>>;
  personneMorale?: InputMaybe<PersonneMoraleFilterInput>;
  personneMoraleId?: InputMaybe<LongOperationFilterInput>;
};

export type PersonneMoraleFilterInput = {
  and?: InputMaybe<Array<PersonneMoraleFilterInput>>;
  codeNafApe?: InputMaybe<StringOperationFilterInput>;
  contact?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  denomination?: InputMaybe<StringOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  formeJuridique?: InputMaybe<FormeJuridiqueFilterInput>;
  formeJuridiqueId?: InputMaybe<ByteOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<PersonneMoraleFilterInput>>;
  personneMoraleAdresse?: InputMaybe<ListFilterInputTypeOfPersonneMoraleAdresseFilterInput>;
  personneMoraleTelephone?: InputMaybe<ListFilterInputTypeOfPersonneMoraleTelephoneFilterInput>;
  siretSiren?: InputMaybe<StringOperationFilterInput>;
  siteInternet?: InputMaybe<StringOperationFilterInput>;
};

export type PersonneMoraleTelephone = {
  __typename?: 'PersonneMoraleTelephone';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  personneMorale: PersonneMorale;
  personneMoraleId: Scalars['Long']['output'];
  telephone: Telephone;
  telephoneId: Scalars['Long']['output'];
};

export type PersonneMoraleTelephoneFilterInput = {
  and?: InputMaybe<Array<PersonneMoraleTelephoneFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<PersonneMoraleTelephoneFilterInput>>;
  personneMorale?: InputMaybe<PersonneMoraleFilterInput>;
  personneMoraleId?: InputMaybe<LongOperationFilterInput>;
  telephone?: InputMaybe<TelephoneFilterInput>;
  telephoneId?: InputMaybe<LongOperationFilterInput>;
};

export type PersonnePhysique = {
  __typename?: 'PersonnePhysique';
  adresse: Array<Adresse>;
  arianeId?: Maybe<Scalars['Long']['output']>;
  civiliteCode: Scalars['String']['output'];
  civiliteCodeNavigation: Civilite;
  code?: Maybe<Scalars['String']['output']>;
  codePaysNaissance?: Maybe<Scalars['String']['output']>;
  codePaysNaissanceNavigation?: Maybe<Pays>;
  codePaysNationalite?: Maybe<Scalars['String']['output']>;
  codePaysNationaliteNavigation?: Maybe<Pays>;
  codePaysNationaliteSecondaire?: Maybe<Scalars['String']['output']>;
  codePaysNationaliteSecondaireNavigation?: Maybe<Pays>;
  codePostaleNaissance?: Maybe<Scalars['String']['output']>;
  consultant: Array<Consultant>;
  contact: Array<Contact>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateNaissance?: Maybe<Scalars['LocalDate']['output']>;
  departementNaissance?: Maybe<Scalars['String']['output']>;
  departementNaissanceNavigation?: Maybe<Departement>;
  detenteurPatrimoineActif: Array<DetenteurPatrimoineActif>;
  deuxiemePrenom?: Maybe<Scalars['String']['output']>;
  disposition?: Maybe<Disposition>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  email: Array<Email>;
  etatCivil?: Maybe<EtatCivil>;
  fullNameSearchText?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseur: Array<Investisseur>;
  login?: Maybe<Scalars['String']['output']>;
  mesureProtectionDate?: Maybe<Scalars['LocalDate']['output']>;
  nom: Scalars['String']['output'];
  nomCompletDeuxiemeParent?: Maybe<Scalars['String']['output']>;
  nomCompletPremierParent?: Maybe<Scalars['String']['output']>;
  nomNaissance?: Maybe<Scalars['String']['output']>;
  nomNaissanceUniformise?: Maybe<Scalars['String']['output']>;
  nomUniformise: Scalars['String']['output'];
  personnePhysiqueDocument: Array<PersonnePhysiqueDocument>;
  prenom: Scalars['String']['output'];
  prenomUniformise: Scalars['String']['output'];
  reglementaire?: Maybe<Reglementaire>;
  relationAutrePersonnePhysique: Array<RelationAutreSimple>;
  relationAutrePersonnePhysique1: Array<RelationAutre>;
  relationAutrePersonnePhysique2: Array<RelationAutre>;
  relationAutrePersonnePhysiqueUnaccesible: Array<RelationSimpleUnaccesible>;
  relationCouplePersonnePhysique?: Maybe<RelationCoupleSimple>;
  relationCouplePersonnePhysique1: Array<RelationCouple>;
  relationCouplePersonnePhysique2: Array<RelationCouple>;
  relationCouplePersonnePhysiqueUnaccesible?: Maybe<RelationSimpleUnaccesible>;
  relationFamillePersonnePhysique: Array<RelationFamilleSimple>;
  relationFamillePersonnePhysique1: Array<RelationFamille>;
  relationFamillePersonnePhysique2: Array<RelationFamille>;
  relationFamillePersonnePhysiqueUnaccesible: Array<RelationSimpleUnaccesible>;
  situationProfessionnelle?: Maybe<SituationProfessionnelle>;
  telephone: Array<Telephone>;
  testament?: Maybe<Testament>;
  troisiemePrenom?: Maybe<Scalars['String']['output']>;
  typeMesureProtectionCode?: Maybe<Scalars['String']['output']>;
  typeMesureProtectionCodeNavigation?: Maybe<TypeMesureProtection>;
  villeNaissanceNom?: Maybe<Scalars['String']['output']>;
};


export type PersonnePhysiqueAdresseArgs = {
  where?: InputMaybe<AdresseFilterInput>;
};


export type PersonnePhysiqueConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type PersonnePhysiqueContactArgs = {
  where?: InputMaybe<ContactFilterInput>;
};


export type PersonnePhysiqueDetenteurPatrimoineActifArgs = {
  where?: InputMaybe<DetenteurPatrimoineActifFilterInput>;
};


export type PersonnePhysiqueEmailArgs = {
  where?: InputMaybe<EmailFilterInput>;
};


export type PersonnePhysiqueInvestisseurArgs = {
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type PersonnePhysiquePersonnePhysiqueDocumentArgs = {
  where?: InputMaybe<PersonnePhysiqueDocumentFilterInput>;
};


export type PersonnePhysiqueRelationAutrePersonnePhysique1Args = {
  where?: InputMaybe<RelationAutreFilterInput>;
};


export type PersonnePhysiqueRelationAutrePersonnePhysique2Args = {
  where?: InputMaybe<RelationAutreFilterInput>;
};


export type PersonnePhysiqueRelationCouplePersonnePhysique1Args = {
  where?: InputMaybe<RelationCoupleFilterInput>;
};


export type PersonnePhysiqueRelationCouplePersonnePhysique2Args = {
  where?: InputMaybe<RelationCoupleFilterInput>;
};


export type PersonnePhysiqueRelationFamillePersonnePhysique1Args = {
  where?: InputMaybe<RelationFamilleFilterInput>;
};


export type PersonnePhysiqueRelationFamillePersonnePhysique2Args = {
  where?: InputMaybe<RelationFamilleFilterInput>;
};


export type PersonnePhysiqueTelephoneArgs = {
  where?: InputMaybe<TelephoneFilterInput>;
};

export type PersonnePhysiqueDocument = {
  __typename?: 'PersonnePhysiqueDocument';
  codeTypeDocument: Scalars['String']['output'];
  codeTypeDocumentNavigation: GedTypeDocument;
  dateDebutValidite?: Maybe<Scalars['DateTime']['output']>;
  dateFinValidite?: Maybe<Scalars['DateTime']['output']>;
  documentId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['Long']['output'];
  person: PersonnePhysique;
  personId: Scalars['Long']['output'];
};

export type PersonnePhysiqueDocumentFilterInput = {
  and?: InputMaybe<Array<PersonnePhysiqueDocumentFilterInput>>;
  codeTypeDocument?: InputMaybe<StringOperationFilterInput>;
  codeTypeDocumentNavigation?: InputMaybe<GedTypeDocumentFilterInput>;
  dateDebutValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinValidite?: InputMaybe<DateTimeOperationFilterInput>;
  documentId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<PersonnePhysiqueDocumentFilterInput>>;
  person?: InputMaybe<PersonnePhysiqueFilterInput>;
  personId?: InputMaybe<LongOperationFilterInput>;
};

export type PersonnePhysiqueFilterInput = {
  adresse?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  and?: InputMaybe<Array<PersonnePhysiqueFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  civiliteCode?: InputMaybe<StringOperationFilterInput>;
  civiliteCodeNavigation?: InputMaybe<CiviliteFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  codePaysNaissance?: InputMaybe<StringOperationFilterInput>;
  codePaysNaissanceNavigation?: InputMaybe<PaysFilterInput>;
  codePaysNationalite?: InputMaybe<StringOperationFilterInput>;
  codePaysNationaliteNavigation?: InputMaybe<PaysFilterInput>;
  codePaysNationaliteSecondaire?: InputMaybe<StringOperationFilterInput>;
  codePaysNationaliteSecondaireNavigation?: InputMaybe<PaysFilterInput>;
  codePostaleNaissance?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  contact?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateNaissance?: InputMaybe<LocalDateOperationFilterInput>;
  departementNaissance?: InputMaybe<StringOperationFilterInput>;
  departementNaissanceNavigation?: InputMaybe<DepartementFilterInput>;
  detenteurPatrimoineActif?: InputMaybe<ListFilterInputTypeOfDetenteurPatrimoineActifFilterInput>;
  deuxiemePrenom?: InputMaybe<StringOperationFilterInput>;
  disposition?: InputMaybe<DispositionFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<ListFilterInputTypeOfEmailFilterInput>;
  etatCivil?: InputMaybe<EtatCivilFilterInput>;
  fullNameSearchText?: InputMaybe<StringOperationFilterInput>;
  genre?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseur?: InputMaybe<ListFilterInputTypeOfInvestisseurFilterInput>;
  login?: InputMaybe<StringOperationFilterInput>;
  mesureProtectionDate?: InputMaybe<LocalDateOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  nomCompletDeuxiemeParent?: InputMaybe<StringOperationFilterInput>;
  nomCompletPremierParent?: InputMaybe<StringOperationFilterInput>;
  nomNaissance?: InputMaybe<StringOperationFilterInput>;
  nomNaissanceUniformise?: InputMaybe<StringOperationFilterInput>;
  nomUniformise?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PersonnePhysiqueFilterInput>>;
  personnePhysiqueDocument?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueDocumentFilterInput>;
  prenom?: InputMaybe<StringOperationFilterInput>;
  prenomUniformise?: InputMaybe<StringOperationFilterInput>;
  reglementaire?: InputMaybe<ReglementaireFilterInput>;
  relationAutrePersonnePhysique1?: InputMaybe<ListFilterInputTypeOfRelationAutreFilterInput>;
  relationAutrePersonnePhysique2?: InputMaybe<ListFilterInputTypeOfRelationAutreFilterInput>;
  relationCouplePersonnePhysique1?: InputMaybe<ListFilterInputTypeOfRelationCoupleFilterInput>;
  relationCouplePersonnePhysique2?: InputMaybe<ListFilterInputTypeOfRelationCoupleFilterInput>;
  relationFamillePersonnePhysique1?: InputMaybe<ListFilterInputTypeOfRelationFamilleFilterInput>;
  relationFamillePersonnePhysique2?: InputMaybe<ListFilterInputTypeOfRelationFamilleFilterInput>;
  situationProfessionnelle?: InputMaybe<SituationProfessionnelleFilterInput>;
  telephone?: InputMaybe<ListFilterInputTypeOfTelephoneFilterInput>;
  testament?: InputMaybe<TestamentFilterInput>;
  troisiemePrenom?: InputMaybe<StringOperationFilterInput>;
  typeMesureProtectionCode?: InputMaybe<StringOperationFilterInput>;
  typeMesureProtectionCodeNavigation?: InputMaybe<TypeMesureProtectionFilterInput>;
  villeNaissanceNom?: InputMaybe<StringOperationFilterInput>;
};

export type PersonnePhysiqueSortInput = {
  arianeId?: InputMaybe<SortEnumType>;
  civiliteCode?: InputMaybe<SortEnumType>;
  civiliteCodeNavigation?: InputMaybe<CiviliteSortInput>;
  code?: InputMaybe<SortEnumType>;
  codePaysNaissance?: InputMaybe<SortEnumType>;
  codePaysNaissanceNavigation?: InputMaybe<PaysSortInput>;
  codePaysNationalite?: InputMaybe<SortEnumType>;
  codePaysNationaliteNavigation?: InputMaybe<PaysSortInput>;
  codePaysNationaliteSecondaire?: InputMaybe<SortEnumType>;
  codePaysNationaliteSecondaireNavigation?: InputMaybe<PaysSortInput>;
  codePostaleNaissance?: InputMaybe<SortEnumType>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateNaissance?: InputMaybe<SortEnumType>;
  departementNaissance?: InputMaybe<SortEnumType>;
  departementNaissanceNavigation?: InputMaybe<DepartementSortInput>;
  deuxiemePrenom?: InputMaybe<SortEnumType>;
  disposition?: InputMaybe<DispositionSortInput>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  etatCivil?: InputMaybe<EtatCivilSortInput>;
  fullNameSearchText?: InputMaybe<SortEnumType>;
  genre?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  login?: InputMaybe<SortEnumType>;
  mesureProtectionDate?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
  nomCompletDeuxiemeParent?: InputMaybe<SortEnumType>;
  nomCompletPremierParent?: InputMaybe<SortEnumType>;
  nomNaissance?: InputMaybe<SortEnumType>;
  nomNaissanceUniformise?: InputMaybe<SortEnumType>;
  nomUniformise?: InputMaybe<SortEnumType>;
  prenom?: InputMaybe<SortEnumType>;
  prenomUniformise?: InputMaybe<SortEnumType>;
  reglementaire?: InputMaybe<ReglementaireSortInput>;
  situationProfessionnelle?: InputMaybe<SituationProfessionnelleSortInput>;
  testament?: InputMaybe<TestamentSortInput>;
  troisiemePrenom?: InputMaybe<SortEnumType>;
  typeMesureProtectionCode?: InputMaybe<SortEnumType>;
  typeMesureProtectionCodeNavigation?: InputMaybe<TypeMesureProtectionSortInput>;
  villeNaissanceNom?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type PersonnePhysiquesPaginatedCollectionSegment = {
  __typename?: 'PersonnePhysiquesPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PersonnePhysique>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonneSituationPersonnelleInput = {
  adressses: Array<AdressePersonneInput>;
  civilite?: InputMaybe<Scalars['String']['input']>;
  codePostaleNaissance?: InputMaybe<Scalars['String']['input']>;
  commentaire?: InputMaybe<Scalars['String']['input']>;
  dateNaissance?: InputMaybe<Scalars['DateTime']['input']>;
  departementNaissance?: InputMaybe<Scalars['String']['input']>;
  deuxiemeNationalite?: InputMaybe<Scalars['String']['input']>;
  deuxiemePrenom?: InputMaybe<Scalars['String']['input']>;
  donation: DonationInput;
  emails?: InputMaybe<Array<EmailInput>>;
  etatCivil: EtatCivilInput;
  investisseurId: Scalars['Long']['input'];
  mesureProtection?: InputMaybe<Scalars['String']['input']>;
  mesureProtectionDate?: InputMaybe<Scalars['LocalDate']['input']>;
  nationalite?: InputMaybe<Scalars['String']['input']>;
  nom: Scalars['String']['input'];
  nomNaissance?: InputMaybe<Scalars['String']['input']>;
  origineContact?: InputMaybe<Scalars['String']['input']>;
  origineContactDateRecommandation?: InputMaybe<Scalars['DateTime']['input']>;
  origineContactInvestisseurId?: InputMaybe<Scalars['Long']['input']>;
  origineContactNom?: InputMaybe<Scalars['String']['input']>;
  origineSaisie: Scalars['Byte']['input'];
  paysNaissance?: InputMaybe<Scalars['String']['input']>;
  personnePhysiqueId: Scalars['Long']['input'];
  prenom: Scalars['String']['input'];
  reglementaire: ReglementaireInput;
  shouldIgnoreTelephonesEmailsAndAdresses?: InputMaybe<Scalars['Boolean']['input']>;
  situationProfessionnelle: ProfessionnelleInput;
  telephones?: InputMaybe<Array<TelephonePersonneInput>>;
  testament?: InputMaybe<TestamentInput>;
  troisiemePrenom?: InputMaybe<Scalars['String']['input']>;
  villeNaissance?: InputMaybe<Scalars['String']['input']>;
};

export type PieceJointeConsultant = {
  __typename?: 'PieceJointeConsultant';
  consultantContrat: Array<ConsultantContrat>;
  consultantHabilitationInscription: Array<ConsultantHabilitationInscription>;
  dateDebutValidite: Scalars['DateTime']['output'];
  dateFinValidite: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  lienGed?: Maybe<Scalars['String']['output']>;
  typePieceJointeCode: Scalars['String']['output'];
  typePieceJointeCodeNavigation: TypePieceJointe;
};


export type PieceJointeConsultantConsultantContratArgs = {
  where?: InputMaybe<ConsultantContratFilterInput>;
};


export type PieceJointeConsultantConsultantHabilitationInscriptionArgs = {
  where?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
};

export type PieceJointeConsultantFilterInput = {
  and?: InputMaybe<Array<PieceJointeConsultantFilterInput>>;
  consultantContrat?: InputMaybe<ListFilterInputTypeOfConsultantContratFilterInput>;
  consultantHabilitationInscription?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInscriptionFilterInput>;
  dateDebutValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinValidite?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lienGed?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PieceJointeConsultantFilterInput>>;
  typePieceJointeCode?: InputMaybe<StringOperationFilterInput>;
  typePieceJointeCodeNavigation?: InputMaybe<TypePieceJointeFilterInput>;
};

export type PieceJustificativeInput = {
  consultantId: Scalars['Long']['input'];
  documentId: Scalars['String']['input'];
  statutJuridiqueId?: InputMaybe<Scalars['Long']['input']>;
};

export type PieceJustificativeRcpInput = {
  consultantId: Scalars['Long']['input'];
  documentId: Scalars['String']['input'];
  organismeAssureurId: Scalars['Long']['input'];
  rcpGarantieMontantParSinistre: Scalars['Decimal']['input'];
  rcpOrganismeAssureurAdresse: Scalars['String']['input'];
  statutJuridiqueId?: InputMaybe<Scalars['Long']['input']>;
  typeRcp: TypeRcpCode;
};

export enum PortefeuilleOption {
  AvecAnnexe = 'AVEC_ANNEXE',
  SansAnnexe = 'SANS_ANNEXE'
}

export type PresettedConsultant = {
  __typename?: 'PresettedConsultant';
  civiliteCode?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  dateNaissance?: Maybe<Scalars['LocalDate']['output']>;
  habilitationCodes?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Long']['output'];
  nom?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  qualificationCode?: Maybe<Scalars['String']['output']>;
  qualificationLibelle?: Maybe<Scalars['String']['output']>;
};

export type PresettedInvestisseur = {
  __typename?: 'PresettedInvestisseur';
  civiliteCode?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  dateNaissance?: Maybe<Scalars['LocalDate']['output']>;
  denomination?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  nom?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  type: InvestisseurType;
};

export type PresettedPartenaire = {
  __typename?: 'PresettedPartenaire';
  activiteRattachementCode?: Maybe<Scalars['Byte']['output']>;
  activiteRattachementLibelle?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  nom: Scalars['String']['output'];
};

export type PresettedProduit = {
  __typename?: 'PresettedProduit';
  enveloppeCode?: Maybe<Scalars['Byte']['output']>;
  enveloppeLibelle?: Maybe<Scalars['String']['output']>;
  etatCode?: Maybe<Scalars['Byte']['output']>;
  etatLibelle?: Maybe<Scalars['String']['output']>;
  habilitationCode?: Maybe<Scalars['String']['output']>;
  habilitationLibelle?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  nom: Scalars['String']['output'];
  nomTechniqueProduitBox?: Maybe<Scalars['String']['output']>;
  partenaireId?: Maybe<Scalars['Long']['output']>;
  partenaireLibelle?: Maybe<Scalars['String']['output']>;
};

export type Produit = {
  __typename?: 'Produit';
  commande: Array<Commande>;
  creationDate: Scalars['DateTime']['output'];
  dateCloture?: Maybe<Scalars['DateTime']['output']>;
  dateInitialisation?: Maybe<Scalars['DateTime']['output']>;
  dateLancementInterne?: Maybe<Scalars['DateTime']['output']>;
  dateOuverture?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  enveloppe?: Maybe<Scalars['Byte']['output']>;
  enveloppeNavigation?: Maybe<EnveloppeProduit>;
  etat?: Maybe<Scalars['Byte']['output']>;
  etatNavigation?: Maybe<EtatProduit>;
  filialeFacturation?: Maybe<Scalars['Byte']['output']>;
  filialeFacturationNavigation?: Maybe<FilialeFacturation>;
  fondEvenementielExtension: FondsEvenementielExtension;
  habilitation?: Maybe<Scalars['Long']['output']>;
  habilitationNavigation?: Maybe<Habilitation>;
  id: Scalars['Long']['output'];
  idPartenaire?: Maybe<Scalars['Long']['output']>;
  idPartenaireNavigation?: Maybe<Partenaire>;
  idSource?: Maybe<Scalars['Long']['output']>;
  nom: Scalars['String']['output'];
  nomTechniqueProduitBox?: Maybe<Scalars['String']['output']>;
  produitExtension: ProduitExtension;
  typeProduit: Scalars['Byte']['output'];
  typeProduitNavigation: TypeProduit;
};

export type ProduitAgregation = {
  __typename?: 'ProduitAgregation';
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  enveloppe?: Maybe<Enveloppe>;
  flagMultiSupport?: Maybe<Scalars['Boolean']['output']>;
  idProduit: Scalars['String']['output'];
  partenaire?: Maybe<PartenaireAgregation>;
  refCodeEnveloppe?: Maybe<Scalars['String']['output']>;
  refCodeTypeProduit?: Maybe<Scalars['String']['output']>;
  refIdPartenaire?: Maybe<Scalars['String']['output']>;
  typeProduit?: Maybe<TypeProduitAgregation>;
};

export type ProduitAgregationFilterInput = {
  and?: InputMaybe<Array<ProduitAgregationFilterInput>>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  designation?: InputMaybe<StringOperationFilterInput>;
  enveloppe?: InputMaybe<EnveloppeFilterInput>;
  flagMultiSupport?: InputMaybe<BooleanOperationFilterInput>;
  idProduit?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProduitAgregationFilterInput>>;
  partenaire?: InputMaybe<PartenaireAgregationFilterInput>;
  refCodeEnveloppe?: InputMaybe<StringOperationFilterInput>;
  refCodeTypeProduit?: InputMaybe<StringOperationFilterInput>;
  refIdPartenaire?: InputMaybe<StringOperationFilterInput>;
  typeProduit?: InputMaybe<TypeProduitAgregationFilterInput>;
};

export type ProduitAgregationSortInput = {
  dateChargement?: InputMaybe<SortEnumType>;
  designation?: InputMaybe<SortEnumType>;
  enveloppe?: InputMaybe<EnveloppeSortInput>;
  flagMultiSupport?: InputMaybe<SortEnumType>;
  idProduit?: InputMaybe<SortEnumType>;
  partenaire?: InputMaybe<PartenaireAgregationSortInput>;
  refCodeEnveloppe?: InputMaybe<SortEnumType>;
  refCodeTypeProduit?: InputMaybe<SortEnumType>;
  refIdPartenaire?: InputMaybe<SortEnumType>;
  typeProduit?: InputMaybe<TypeProduitAgregationSortInput>;
};

/** Produits d'épargne du questionnaire Connaissance et expérience (Q1 à Q8) */
export enum ProduitEpargneEnum {
  AssuranceVie = 'ASSURANCE_VIE',
  CapitalInvestissement = 'CAPITAL_INVESTISSEMENT',
  ComptesLivrets = 'COMPTES_LIVRETS',
  ContratCapitalisation = 'CONTRAT_CAPITALISATION',
  EpargneRetraite = 'EPARGNE_RETRAITE',
  EpargneSalariale = 'EPARGNE_SALARIALE',
  ImmobilierLocatif = 'IMMOBILIER_LOCATIF',
  Scpi = 'SCPI'
}

export type ProduitEpargneEnumOperationFilterInput = {
  eq?: InputMaybe<ProduitEpargneEnum>;
  in?: InputMaybe<Array<ProduitEpargneEnum>>;
  neq?: InputMaybe<ProduitEpargneEnum>;
  nin?: InputMaybe<Array<ProduitEpargneEnum>>;
};

/** Réponse saisie pour une ligne du tableau des produits d'épargne */
export type ProduitEpargneInput = {
  detention?: InputMaybe<DetentionProduitEnum>;
  produit: ProduitEpargneEnum;
  /** Code de la réponse à la question de vérification (R1 à R4) */
  verification?: InputMaybe<Scalars['String']['input']>;
};

/** Ligne du tableau des produits d'épargne */
export type ProduitEpargneReferentielDto = {
  __typename?: 'ProduitEpargneReferentielDto';
  libelle: Scalars['String']['output'];
  /** Options de la question de vérification dans leur ordre d'affichage (vide si le produit n'a pas de question) */
  optionsVerification: Array<OptionVerificationDto>;
  produit: ProduitEpargneEnum;
  /** Code de la question dans la matrice (Q1 à Q8) */
  question: Scalars['String']['output'];
};


/** Ligne du tableau des produits d'épargne */
export type ProduitEpargneReferentielDtoOptionsVerificationArgs = {
  where?: InputMaybe<OptionVerificationDtoFilterInput>;
};

/** Ligne du tableau des produits d'épargne */
export type ProduitEpargneReferentielDtoFilterInput = {
  and?: InputMaybe<Array<ProduitEpargneReferentielDtoFilterInput>>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  /** Options de la question de vérification dans leur ordre d'affichage (vide si le produit n'a pas de question) */
  optionsVerification?: InputMaybe<ListFilterInputTypeOfOptionVerificationDtoFilterInput>;
  or?: InputMaybe<Array<ProduitEpargneReferentielDtoFilterInput>>;
  produit?: InputMaybe<ProduitEpargneEnumOperationFilterInput>;
  /** Code de la question dans la matrice (Q1 à Q8) */
  question?: InputMaybe<StringOperationFilterInput>;
};

/** Réponse à une ligne du tableau des produits d'épargne */
export type ProduitEpargneReponse = {
  __typename?: 'ProduitEpargneReponse';
  detention?: Maybe<DetentionProduitEnum>;
  produit: ProduitEpargneEnum;
  /** Code de la question dans la matrice (Q1 à Q8) */
  question: Scalars['String']['output'];
  /** Indique que la détention a été sélectionnée automatiquement d'après les actifs du recueil */
  selectionAutoRecueil: Scalars['Boolean']['output'];
  verification?: Maybe<VerificationReponse>;
};

/** Réponse à une ligne du tableau des produits d'épargne */
export type ProduitEpargneReponseFilterInput = {
  and?: InputMaybe<Array<ProduitEpargneReponseFilterInput>>;
  detention?: InputMaybe<NullableOfDetentionProduitEnumOperationFilterInput>;
  or?: InputMaybe<Array<ProduitEpargneReponseFilterInput>>;
  produit?: InputMaybe<ProduitEpargneEnumOperationFilterInput>;
  /** Code de la question dans la matrice (Q1 à Q8) */
  question?: InputMaybe<StringOperationFilterInput>;
  /** Indique que la détention a été sélectionnée automatiquement d'après les actifs du recueil */
  selectionAutoRecueil?: InputMaybe<BooleanOperationFilterInput>;
  verification?: InputMaybe<VerificationReponseFilterInput>;
};

export type ProduitExtension = {
  __typename?: 'ProduitExtension';
  id: Scalars['Long']['output'];
};

export type ProduitFilterInput = {
  and?: InputMaybe<Array<ProduitFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateCloture?: InputMaybe<DateTimeOperationFilterInput>;
  dateInitialisation?: InputMaybe<DateTimeOperationFilterInput>;
  dateLancementInterne?: InputMaybe<DateTimeOperationFilterInput>;
  dateOuverture?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  enveloppe?: InputMaybe<ByteOperationFilterInput>;
  enveloppeNavigation?: InputMaybe<EnveloppeProduitFilterInput>;
  etat?: InputMaybe<ByteOperationFilterInput>;
  etatNavigation?: InputMaybe<EtatProduitFilterInput>;
  filialeFacturation?: InputMaybe<ByteOperationFilterInput>;
  filialeFacturationNavigation?: InputMaybe<FilialeFacturationFilterInput>;
  habilitation?: InputMaybe<LongOperationFilterInput>;
  habilitationNavigation?: InputMaybe<HabilitationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idPartenaire?: InputMaybe<LongOperationFilterInput>;
  idPartenaireNavigation?: InputMaybe<PartenaireFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  nomTechniqueProduitBox?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProduitFilterInput>>;
  typeProduit?: InputMaybe<ByteOperationFilterInput>;
};

export type ProduitOperationExtension = {
  __typename?: 'ProduitOperationExtension';
  /** Liste des allocations pour le produit. */
  allocations?: Maybe<Array<Allocation>>;
  /** Liste des fonds évenèmentiels pour le produit. */
  fondsEvenementiels?: Maybe<Array<FondsEvenementiel>>;
  /** Liste des modes de gestion possibles pour le produit. */
  gestionPossibles?: Maybe<Array<ModeDeGestionConfig>>;
  id: Scalars['Long']['output'];
  /** Liste des options automatiques pour le produit. */
  optionsAutomatiques?: Maybe<Array<OptionAutomatique>>;
};


export type ProduitOperationExtensionAllocationsArgs = {
  where?: InputMaybe<AllocationFilterInput>;
};


export type ProduitOperationExtensionFondsEvenementielsArgs = {
  where?: InputMaybe<FondsEvenementielFilterInput>;
};


export type ProduitOperationExtensionGestionPossiblesArgs = {
  where?: InputMaybe<ModeDeGestionConfigFilterInput>;
};


export type ProduitOperationExtensionOptionsAutomatiquesArgs = {
  where?: InputMaybe<OptionAutomatiqueFilterInput>;
};

export type ProduitOperationExtensionFilterInput = {
  /** Liste des allocations pour le produit. */
  allocations?: InputMaybe<ListFilterInputTypeOfAllocationFilterInput>;
  and?: InputMaybe<Array<ProduitOperationExtensionFilterInput>>;
  /** Liste des fonds évenèmentiels pour le produit. */
  fondsEvenementiels?: InputMaybe<ListFilterInputTypeOfFondsEvenementielFilterInput>;
  /** Liste des modes de gestion possibles pour le produit. */
  gestionPossibles?: InputMaybe<ListFilterInputTypeOfModeDeGestionConfigFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  /** Liste des options automatiques pour le produit. */
  optionsAutomatiques?: InputMaybe<ListFilterInputTypeOfOptionAutomatiqueFilterInput>;
  or?: InputMaybe<Array<ProduitOperationExtensionFilterInput>>;
};

export type ProduitSortInput = {
  creationDate?: InputMaybe<SortEnumType>;
  dateCloture?: InputMaybe<SortEnumType>;
  dateInitialisation?: InputMaybe<SortEnumType>;
  dateLancementInterne?: InputMaybe<SortEnumType>;
  dateOuverture?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  enveloppe?: InputMaybe<SortEnumType>;
  enveloppeNavigation?: InputMaybe<EnveloppeProduitSortInput>;
  etat?: InputMaybe<SortEnumType>;
  etatNavigation?: InputMaybe<EtatProduitSortInput>;
  filialeFacturation?: InputMaybe<SortEnumType>;
  filialeFacturationNavigation?: InputMaybe<FilialeFacturationSortInput>;
  habilitation?: InputMaybe<SortEnumType>;
  habilitationNavigation?: InputMaybe<HabilitationSortInput>;
  id?: InputMaybe<SortEnumType>;
  idPartenaire?: InputMaybe<SortEnumType>;
  idPartenaireNavigation?: InputMaybe<PartenaireSortInput>;
  idSource?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
  nomTechniqueProduitBox?: InputMaybe<SortEnumType>;
  typeProduit?: InputMaybe<SortEnumType>;
  typeProduitNavigation?: InputMaybe<TypeProduitSortInput>;
};

export type ProduitSpecificConfig = {
  __typename?: 'ProduitSpecificConfig';
  config: AdequationConfig;
  extranetPartenaireUrl?: Maybe<Scalars['String']['output']>;
  ficheProduitUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  produit: ProduitOperationExtension;
  produitAtlas: Produit;
  produitId: Scalars['Long']['output'];
};

export type ProduitSpecificConfigFilterInput = {
  and?: InputMaybe<Array<ProduitSpecificConfigFilterInput>>;
  config?: InputMaybe<AdequationConfigFilterInput>;
  extranetPartenaireUrl?: InputMaybe<StringOperationFilterInput>;
  ficheProduitUrl?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ProduitSpecificConfigFilterInput>>;
  produit?: InputMaybe<ProduitOperationExtensionFilterInput>;
  produitAtlas?: InputMaybe<ProduitFilterInput>;
  produitId?: InputMaybe<LongOperationFilterInput>;
};

/** A segment of a collection. */
export type ProduitsPaginatedCollectionSegment = {
  __typename?: 'ProduitsPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Produit>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfessionLiberaleInput = {
  numeroTva: Scalars['String']['input'];
  siret: Scalars['String']['input'];
  villeSiret: Scalars['String']['input'];
};

export type ProfessionnelleInput = {
  categorieSocioProfessionnelleCodeAtlas?: InputMaybe<Scalars['Byte']['input']>;
  commentaire?: InputMaybe<Scalars['String']['input']>;
  dateDebut?: InputMaybe<Scalars['DateTime']['input']>;
  dateDepartRetraite?: InputMaybe<Scalars['DateTime']['input']>;
  nomSociete?: InputMaybe<Scalars['String']['input']>;
  origineRevenus?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  regimeActivite?: InputMaybe<Scalars['Int']['input']>;
  secteurActivite?: InputMaybe<Scalars['Int']['input']>;
  situation?: InputMaybe<Scalars['Int']['input']>;
  statut?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfilEsg = {
  __typename?: 'ProfilESG';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Byte']['output'];
  libelle: Scalars['String']['output'];
  profilInvestisseur: Array<ProfilInvestisseur>;
};


export type ProfilEsgProfilInvestisseurArgs = {
  where?: InputMaybe<ProfilInvestisseurFilterInput>;
};

export type ProfilEsgFilterInput = {
  and?: InputMaybe<Array<ProfilEsgFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<ByteOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProfilEsgFilterInput>>;
  profilInvestisseur?: InputMaybe<ListFilterInputTypeOfProfilInvestisseurFilterInput>;
};

export type ProfilInvestisseur = {
  __typename?: 'ProfilInvestisseur';
  capacitePerteSupportee?: Maybe<Scalars['Boolean']['output']>;
  connaissanceExperience?: Maybe<ConnaissanceExperience>;
  connaissanceExperienceId?: Maybe<Scalars['Byte']['output']>;
  creationDate: Scalars['DateTime']['output'];
  dateDerniereActualisation?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  profilESG?: Maybe<ProfilEsg>;
  profilESGId?: Maybe<Scalars['Byte']['output']>;
  typeInvestisseur?: Maybe<TypeInvestisseur>;
  typeInvestisseurId?: Maybe<Scalars['Byte']['output']>;
};

export type ProfilInvestisseurData = {
  __typename?: 'ProfilInvestisseurData';
  /** Résultat du questionnaire de capacité de perte (1 à 5) */
  resultatCapacitePerte?: Maybe<Scalars['Int']['output']>;
  /** Résultat du questionnaire de connaissance du client (1 à 3) */
  resultatConnaissance?: Maybe<Scalars['Int']['output']>;
  /** Profil de risque global: minimum entre Tolerance au risque et Capacité à supporter des pertes (1 à 5) */
  resultatProfilDeRisque?: Maybe<Scalars['Int']['output']>;
  /** Résultat du questionnaire de sensibilité extra-financière (0 à 3) */
  resultatSensibiliteExtraFinanciere?: Maybe<Scalars['Int']['output']>;
  /** Résultat du questionnaire de tolérance au risque (1 à 5) */
  resultatToleranceAuRisque?: Maybe<Scalars['Int']['output']>;
};

export type ProfilInvestisseurDataFilterInput = {
  and?: InputMaybe<Array<ProfilInvestisseurDataFilterInput>>;
  or?: InputMaybe<Array<ProfilInvestisseurDataFilterInput>>;
  /** Résultat du questionnaire de capacité de perte (1 à 5) */
  resultatCapacitePerte?: InputMaybe<IntOperationFilterInput>;
  /** Résultat du questionnaire de connaissance du client (1 à 3) */
  resultatConnaissance?: InputMaybe<IntOperationFilterInput>;
  /** Profil de risque global: minimum entre Tolerance au risque et Capacité à supporter des pertes (1 à 5) */
  resultatProfilDeRisque?: InputMaybe<IntOperationFilterInput>;
  /** Résultat du questionnaire de sensibilité extra-financière (0 à 3) */
  resultatSensibiliteExtraFinanciere?: InputMaybe<IntOperationFilterInput>;
  /** Résultat du questionnaire de tolérance au risque (1 à 5) */
  resultatToleranceAuRisque?: InputMaybe<IntOperationFilterInput>;
};

export type ProfilInvestisseurDataInput = {
  /** Résultat du questionnaire de capacité de perte (1 à 5) */
  resultatCapacitePerte?: InputMaybe<Scalars['Int']['input']>;
  /** Résultat du questionnaire de connaissance du client (1 à 3) */
  resultatConnaissance?: InputMaybe<Scalars['Int']['input']>;
  /** Profil de risque global: minimum entre Tolerance au risque et Capacité à supporter des pertes (1 à 5) */
  resultatProfilDeRisque?: InputMaybe<Scalars['Int']['input']>;
  /** Résultat du questionnaire de sensibilité extra-financière (0 à 3) */
  resultatSensibiliteExtraFinanciere?: InputMaybe<Scalars['Int']['input']>;
  /** Résultat du questionnaire de tolérance au risque (1 à 5) */
  resultatToleranceAuRisque?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfilInvestisseurFilterInput = {
  and?: InputMaybe<Array<ProfilInvestisseurFilterInput>>;
  capacitePerteSupportee?: InputMaybe<BooleanOperationFilterInput>;
  connaissanceExperience?: InputMaybe<ConnaissanceExperienceFilterInput>;
  connaissanceExperienceId?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDerniereActualisation?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ProfilInvestisseurFilterInput>>;
  profilESG?: InputMaybe<ProfilEsgFilterInput>;
  profilESGId?: InputMaybe<ByteOperationFilterInput>;
  typeInvestisseur?: InputMaybe<TypeInvestisseurFilterInput>;
  typeInvestisseurId?: InputMaybe<ByteOperationFilterInput>;
};

export type ProfilQpi = {
  __typename?: 'ProfilQpi';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  investisseurQpiProfilCalculCodeNavigation: Array<InvestisseurQpi>;
  investisseurQpiProfilDerogationCodeNavigation: Array<InvestisseurQpi>;
  libelle: Scalars['String']['output'];
  libelleAlternatif?: Maybe<Scalars['String']['output']>;
};

export type ProfilQpiFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProfilQpiFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  investisseurQpiProfilCalculCodeNavigation?: InputMaybe<ListFilterInputTypeOfInvestisseurQpiFilterInput>;
  investisseurQpiProfilDerogationCodeNavigation?: InputMaybe<ListFilterInputTypeOfInvestisseurQpiFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  libelleAlternatif?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProfilQpiFilterInput>>;
};

export type ProfilQpiSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  libelleAlternatif?: InputMaybe<SortEnumType>;
};

export type ProjectCreationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  investisseurIds: Array<Scalars['Long']['input']>;
  nom: Scalars['String']['input'];
  souscriptions?: InputMaybe<Array<SouscriptionCreationInput>>;
};

export type Projet = {
  __typename?: 'Projet';
  creationDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<ProjetDocument>;
  editionDate: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  nom: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  operations: Array<Operation>;
  projetsUtilisateurs: Array<ProjetInvestisseur>;
};


export type ProjetDocumentsArgs = {
  where?: InputMaybe<ProjetDocumentFilterInput>;
};


export type ProjetOperationsArgs = {
  where?: InputMaybe<OperationFilterInput>;
};


export type ProjetProjetsUtilisateursArgs = {
  where?: InputMaybe<ProjetInvestisseurFilterInput>;
};

/** Document GED joint à un projet (simulation, etc.). Le document est stocké dans la GED sans tag, il n'apparaît donc pas dans les documents de l'investisseur. */
export type ProjetDocument = {
  __typename?: 'ProjetDocument';
  creationDate: Scalars['DateTime']['output'];
  /** Identifiant du document dans la GED. */
  fileId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  projetId: Scalars['Long']['output'];
  /** Code du type de document GED */
  typeDocumentCode: Scalars['String']['output'];
};

/** Document GED joint à un projet (simulation, etc.). Le document est stocké dans la GED sans tag, il n'apparaît donc pas dans les documents de l'investisseur. */
export type ProjetDocumentFilterInput = {
  and?: InputMaybe<Array<ProjetDocumentFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Identifiant du document dans la GED. */
  fileId?: InputMaybe<StringOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ProjetDocumentFilterInput>>;
  projetId?: InputMaybe<LongOperationFilterInput>;
  /** Code du type de document GED */
  typeDocumentCode?: InputMaybe<StringOperationFilterInput>;
};

export type ProjetFilterInput = {
  and?: InputMaybe<Array<ProjetFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  documents?: InputMaybe<ListFilterInputTypeOfProjetDocumentFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  operations?: InputMaybe<ListFilterInputTypeOfOperationFilterInput>;
  or?: InputMaybe<Array<ProjetFilterInput>>;
  projetsUtilisateurs?: InputMaybe<ListFilterInputTypeOfProjetInvestisseurFilterInput>;
};

export type ProjetInvestisseur = {
  __typename?: 'ProjetInvestisseur';
  id: Scalars['Long']['output'];
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  projet: Projet;
  projetId: Scalars['Long']['output'];
};

export type ProjetInvestisseurFilterInput = {
  and?: InputMaybe<Array<ProjetInvestisseurFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<MinotaureInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ProjetInvestisseurFilterInput>>;
  projet?: InputMaybe<ProjetFilterInput>;
  projetId?: InputMaybe<LongOperationFilterInput>;
};

export type ProjetUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Long']['input'];
  nom: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export enum Provider {
  Fake = 'FAKE',
  Signatureit = 'SIGNATUREIT',
  UniversignU1 = 'UNIVERSIGN_U1'
}

export type ProviderSettingsInput = {
  providerContextId: Scalars['String']['input'];
  providerId: Provider;
};

export type QpiCritereInput = {
  id: Scalars['String']['input'];
  valeur: Scalars['String']['input'];
};

export type QpiFormInput = {
  criteres: Array<QpiCritereInput>;
  investisseurId: Scalars['Long']['input'];
  isComplete: Scalars['Boolean']['input'];
};

export enum QpiStateTransitionTrigger {
  ConsultantHasUploadedSignedQpi = 'CONSULTANT_HAS_UPLOADED_SIGNED_QPI',
  ConsultantStartsQpiSignatureProcess = 'CONSULTANT_STARTS_QPI_SIGNATURE_PROCESS',
  QpiFormHasBeenCompleted = 'QPI_FORM_HAS_BEEN_COMPLETED',
  QpiFormHasBeenUncompleted = 'QPI_FORM_HAS_BEEN_UNCOMPLETED',
  QpiHasBeenSigned = 'QPI_HAS_BEEN_SIGNED',
  QpiHasExpired = 'QPI_HAS_EXPIRED',
  QpiSignatureIsCancelled = 'QPI_SIGNATURE_IS_CANCELLED'
}

export type Qcm = {
  __typename?: 'Qcm';
  codeFamille?: Maybe<Scalars['Byte']['output']>;
  consultantId: Scalars['Long']['output'];
  cursus: Scalars['String']['output'];
  dateValidationFormation?: Maybe<Scalars['DateTime']['output']>;
  formationValide?: Maybe<Scalars['Byte']['output']>;
  nomADF: Scalars['String']['output'];
  nomSession: Scalars['String']['output'];
  referenceActionDeFormation: Scalars['String']['output'];
  typesHabilitations?: Maybe<Array<TypeHabilitation>>;
};


export type QcmTypesHabilitationsArgs = {
  where?: InputMaybe<TypeHabilitationOperationFilterInput>;
};

export type QcmFilterInput = {
  and?: InputMaybe<Array<QcmFilterInput>>;
  codeFamille?: InputMaybe<ByteOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  cursus?: InputMaybe<StringOperationFilterInput>;
  dateValidationFormation?: InputMaybe<DateTimeOperationFilterInput>;
  formationValide?: InputMaybe<ByteOperationFilterInput>;
  nomADF?: InputMaybe<StringOperationFilterInput>;
  nomSession?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<QcmFilterInput>>;
  referenceActionDeFormation?: InputMaybe<StringOperationFilterInput>;
  typesHabilitations?: InputMaybe<ListTypeHabilitationOperationFilterInput>;
};

export type QcmSortInput = {
  codeFamille?: InputMaybe<SortEnumType>;
  consultantId?: InputMaybe<SortEnumType>;
  cursus?: InputMaybe<SortEnumType>;
  dateValidationFormation?: InputMaybe<SortEnumType>;
  formationValide?: InputMaybe<SortEnumType>;
  nomADF?: InputMaybe<SortEnumType>;
  nomSession?: InputMaybe<SortEnumType>;
  referenceActionDeFormation?: InputMaybe<SortEnumType>;
};

export type QualificationConsultant = {
  __typename?: 'QualificationConsultant';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultant: Array<Consultant>;
  consultantOrganisation: Array<ConsultantOrganisation>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type QualificationConsultantConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type QualificationConsultantConsultantOrganisationArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};

export type QualificationConsultantFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<QualificationConsultantFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  consultantOrganisation?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<QualificationConsultantFilterInput>>;
};

export type QualificationConsultantSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type Query = {
  __typename?: 'Query';
  allSupportsBackOffice: Array<ConsultantRepartitionSupport>;
  allSupportsConsultant: Array<ConsultantRepartitionSupport>;
  allWaveMigrationJobs: Array<WaveMigrationJob>;
  /** Liste les allocations avec leur fichier d'allocation rattaché, pour l'administration des fiches conseil. */
  allocationsFiles: Array<Allocation>;
  /** Renvoie la liste des paramètres in DB de l'application */
  applicationSettings: Array<ApplicationSetting>;
  budgetById: Array<Budget>;
  categorieSocioProfessionnelles: Array<CategorieSocioProfessionnelle>;
  cessionHistoInvestisseurPaginated?: Maybe<CessionHistoInvestisseurPaginatedCollectionSegment>;
  checkDoublonInvestisseur?: Maybe<DoublonInvestisseurCheckResult>;
  commandeById?: Maybe<Commande>;
  commandesByIds?: Maybe<Array<Commande>>;
  commandesFinancieresPaginated?: Maybe<CommandesFinancieresPaginatedCollectionSegment>;
  /** Atlas Commande paginated. Max page size is 100. If no order is specified in query, result are sorted by Id. If you provide an order in query, this order should be desterministic because DB request is splitted to avoid cartesian explosion. */
  commandesPaginated?: Maybe<CommandesPaginatedCollectionSegment>;
  /** Technical operation : get compute habilitations for active statuts juridiques state */
  computeHabilitationsForActiveStatutsJuridiquesState: Scalars['String']['output'];
  /** Technical operation : get latest habilitation changes computation state */
  computeLatestHabilitationChangesState: Scalars['String']['output'];
  /** Référentiel du questionnaire Connaissance et expérience v2 : produits, libellés et questions de vérification (sans barème ni bonnes réponses) */
  connaissanceExperienceReferentiel: ConnaissanceExperienceReferentielDto;
  consultantByCode?: Maybe<Consultant>;
  consultantEtiquettes: Array<Etiquette>;
  consultantFiles: Array<FileMetadata>;
  consultantHabilitationActionsBackOffice: Array<ConsultantHabilitationActionBackOffice>;
  consultantHabilitationStatutChanges: Array<ConsultantHabilitationStatutChange>;
  consultantPreferences: Array<ConsultantPreferences>;
  consultantStatutJuridiqueChanges: Array<ConsultantStatutJuridiqueChange>;
  consultants: Array<Consultant>;
  consultantsAgregation?: Maybe<ConsultantsAgregationCollectionSegment>;
  consultantsByName: Array<Consultant>;
  /** Atlas search consultants by free text. Search use fulltext index on FullNameSearchText field of PersonnePhysique.Max page size is 100. If no order is specified in query, result are sorted by Id.If you provide an order in query, this order should be desterministic because DB request is splitted to avoid cartesian explosion. */
  consultantsByNamePaginated?: Maybe<ConsultantsByNamePaginatedCollectionSegment>;
  consultantsPaginated?: Maybe<ConsultantsPaginatedCollectionSegment>;
  contratBackOffice: Array<ContratsInvestisseur>;
  contratsBackOffice?: Maybe<ContratsBackOfficeCollectionSegment>;
  contratsConsultant?: Maybe<ContratsConsultantCollectionSegment>;
  contratsInvestisseur: Array<ContratsInvestisseur>;
  disponibiliteEpargneOptions: Array<DisponibiliteEpargneOption>;
  documentCategories: Array<DocumentCategory>;
  documentTypes: Array<DocumentType>;
  enveloppeProduitById?: Maybe<EnveloppeProduit>;
  enveloppeProduits: Array<EnveloppeProduit>;
  enveloppeProduitsByIds: Array<EnveloppeProduit>;
  enveloppeServiceMapping: Array<ServiceByEnveloppeCode>;
  /** Récupère les enveloppes disponibles pour le consultant connecté */
  enveloppesProduitForConsultant: Array<EnveloppeProduit>;
  equivalencesFormationsContinues: Array<EquivalenceFormationContinue>;
  etiquetteIndicateurs: Array<EtiquetteIndicateurDto>;
  /** Technical operation : get evaluate habilitation expirations state */
  evaluateHabilitationExpirationsState: Scalars['String']['output'];
  /** Jobs actuellement Failed pour une priorite. Filtre sur la creation entre begin inclus et end exclu ; sans bornes, tout l'historique. Erreur issue du log Failed de la tentative courante. */
  failedFinancialRecalculationJobs?: Maybe<FailedFinancialRecalculationJobsCollectionSegment>;
  /** Get files metadata by filters. Access rules are applied. Backoffice and technical users can see all documents. Consultants can only see documents they have created. */
  fileMetadataByFilters: Array<FileMetadata>;
  /** Get files metadata by filters paginated. Access rules are applied. Backoffice and technical users can see all documents. Consultants can only see documents they have created. */
  fileMetadataByFiltersPaginated: PaginatedResultOfFileMetadata;
  fileMetadataById?: Maybe<FileMetadata>;
  /** Get number of files metadata by filters. Access rules are applied. Backoffice and technical users can see all documents. Consultants can only see documents they have created. */
  fileMetadataCountByFilters: Scalars['Int']['output'];
  fileUploadUriById: Scalars['String']['output'];
  /** Statistiques des jobs crees entre start inclus et end exclu, par priorite. Reussites mesurees depuis CompletedAtUtc et le debut de tentative ; echecs mesures depuis leur log. */
  financialRecalculationJobStats: FinancialRecalculationJobStats;
  /** Nombre souhaite de workers financiers partage en base (1 a 20, defaut 1). Ne mesure pas les workers effectivement demarres ; l'API d'import applique les changements apres sa prochaine lecture, toutes les 5 secondes. */
  financialRecalculationWorkerCount: Scalars['Int']['output'];
  formationsContinues: Array<FormationContinue>;
  formationsHabilitantes: Array<FormationHabilitante>;
  formeJuridiqueByCode?: Maybe<FormeJuridique>;
  formeJuridiques: Array<FormeJuridique>;
  gedCategories: Array<GedCategorie>;
  gedTypeDocumentByCode?: Maybe<GedTypeDocument>;
  gedTypeDocuments: Array<GedTypeDocument>;
  habilitationById?: Maybe<Habilitation>;
  habilitations: Array<Habilitation>;
  habilitationsByIds: Array<Habilitation>;
  importConsultant?: Maybe<ImportConsultantCollectionSegment>;
  importGalaxy?: Maybe<ImportGalaxyCollectionSegment>;
  importInvestisseurs?: Maybe<ImportInvestisseursCollectionSegment>;
  importLogs?: Maybe<ImportLogsCollectionSegment>;
  /** Atlas investisseurs Duplicates (same Nom, Prenom and DateNaissance (2 out 3 criteria) ) of the given Investisseur (investisseurId), in respect of access rules, including the given Investisseur. */
  investisseurAndDuplicatesById?: Maybe<Array<Investisseur>>;
  investisseurByArianeId?: Maybe<Investisseur>;
  investisseurByCode?: Maybe<Investisseur>;
  investisseurById?: Maybe<Investisseur>;
  investisseurConsultantPaginated?: Maybe<InvestisseurConsultantPaginatedCollectionSegment>;
  investisseurFiles: Array<FileMetadata>;
  investisseurObjectifsByInvestisseurId: Array<InvestisseurObjectif>;
  investisseurPatrimoineById: Array<InvestisseurPatrimoine>;
  /** Vérifie si la purge RGPD DoublonsBuster peut être demandée pour l'investisseur. */
  investisseurPurgeCheck: InvestorPurgeCheckResponse;
  /** Récupère l'exécution de purge RGPD DoublonsBuster active ou la plus récente pour l'investisseur. */
  investisseurPurgeExecution?: Maybe<InvestorPurgeExecutionResponse>;
  investisseursByIds?: Maybe<Array<Investisseur>>;
  investisseursByName: Array<Investisseur>;
  investisseursByNameOrCode: Array<Investisseur>;
  /** Atlas search investisseurs by free text. if searchText contains one word, return all investisseur with first or last name starting with this word.if searchText contains N  words, return all investisseurs with first or last name starting with the N-1 first words and last /repectively first name contains the last word.. Search is case insensitive. Max page size is 100. If no order is specified in query, result are sorted by Id. If you provide an order in query, this order should be desterministic because DB request is splitted to avoid cartesian explosion. */
  investisseursByNamePaginated?: Maybe<InvestisseursByNamePaginatedCollectionSegment>;
  investisseursByNameWithFilterPaginated?: Maybe<InvestisseursByNameWithFilterPaginatedCollectionSegment>;
  investisseursFromMinotaurePaginated?: Maybe<InvestisseursFromMinotaurePaginatedCollectionSegment>;
  /** Atlas investisseurs paginated. Max page size is 100. If no order is specified in query, result are sorted by Id. If you provide an order in query, this order should be desterministic because DB request is splitted to avoid cartesian explosion. */
  investisseursPaginated?: Maybe<InvestisseursPaginatedCollectionSegment>;
  /** Atlas search investisseurs by free text. if searchText contains one word, return all investisseur with first or last name starting with this word.if searchText contains N  words, return all investisseurs with first or last name starting with the N-1 first words and last /repectively first name contains the last word.. Search is case insensitive. Max page size is 100. If no order is specified in query, result are sorted by Id. If you provide an order in query, this order should be desterministic because DB request is splitted to avoid cartesian explosion. */
  investisseursPersonnesMoralesByNamePaginated?: Maybe<InvestisseursPersonnesMoralesByNamePaginatedCollectionSegment>;
  /** Atlas search investisseurs by free text. if searchText contains one word, return all investisseur with first or last name starting with this word.if searchText contains N  words, return all investisseurs with first or last name starting with the N-1 first words and last /repectively first name contains the last word.. Search is case insensitive. Max page size is 100. If no order is specified in query, result are sorted by Id. If you provide an order in query, this order should be desterministic because DB request is splitted to avoid cartesian explosion. */
  investisseursPersonnesPhysiquesByNamePaginated?: Maybe<InvestisseursPersonnesPhysiquesByNamePaginatedCollectionSegment>;
  managersGalaxie: Array<ConsultantAgregation>;
  /** Renvoie si le consultant connecté peut acceder au front Minotaure. */
  minotaureAppAccessRight: Scalars['Boolean']['output'];
  modelesDocuments: Array<ModeleDocument>;
  mouvementById?: Maybe<Mouvement>;
  mouvementsPaginated?: Maybe<MouvementsPaginatedCollectionSegment>;
  natureOperationById?: Maybe<NatureOperation>;
  natureOperations: Array<NatureOperation>;
  natureOperationsByIds: Array<NatureOperation>;
  objectifReferentiels: Array<ObjectifReference>;
  objectifsReferentiel: Array<TypeObjectifInvestisseur>;
  /** Rapport enregistré et état de fraîcheur ; report vaut null si aucun contrôle n'a été exécuté. */
  operationAdequation: OperationAdequationPayload;
  /** Recherche paginée des rapports accessibles, à jour par défaut. Au plus 100 éléments par page. */
  operationAdequations: OperationAdequationSearchPage;
  operationById?: Maybe<Operation>;
  /** Suivi des opérations actives visibles par l'utilisateur */
  operationsForConsultant?: Maybe<OperationsForConsultantCollectionSegment>;
  /** Valeurs proposées par les filtres du suivi des opérations. */
  operationsForConsultantFilterValues: OperationsForConsultantFilterValues;
  partenaireById?: Maybe<Partenaire>;
  partenaires: Array<Partenaire>;
  partenairesPaginated?: Maybe<PartenairesPaginatedCollectionSegment>;
  patrimoineCategoriePerefences: Array<PatrimoineCategorieReference>;
  pays: Array<Pays>;
  personnePhysiquesPaginated?: Maybe<PersonnePhysiquesPaginatedCollectionSegment>;
  presettedConsultantById?: Maybe<PresettedConsultant>;
  presettedInvestisseurById?: Maybe<PresettedInvestisseur>;
  presettedInvestisseursByIds: Array<Maybe<PresettedInvestisseur>>;
  presettedPartenaireById?: Maybe<PresettedPartenaire>;
  presettedProduitById?: Maybe<PresettedProduit>;
  produitById?: Maybe<Produit>;
  produits: Array<Produit>;
  produitsByIds: Array<Produit>;
  /** Produits d'épargne du questionnaire Connaissance et expérience détenus par l'investisseur d'après les actifs du recueil */
  produitsEpargneDetenusRecueil: Array<ProduitEpargneEnum>;
  produitsPaginated?: Maybe<ProduitsPaginatedCollectionSegment>;
  projetById: Array<Projet>;
  projetsByInvestisseur: Array<Projet>;
  qcms: Array<Qcm>;
  qpiResultsByInvestisseurId?: Maybe<InvestisseurQpi>;
  rechercheForConsultant: Array<RechercheSauvegarde>;
  /** Technical operation : get refresh statuts commerciaux and habilitation flags state */
  refreshStatutsCommerciauxAndHabilitationFlagsState: Scalars['String']['output'];
  regimeActivites: Array<RegimeActivite>;
  repartitionClasseActifsBackOffice: Array<ConsultantRepartitionClasseActif>;
  repartitionClasseActifsConsultant: Array<ConsultantRepartitionClasseActif>;
  repartitionEnveloppesBackOffice: Array<ConsultantRepartitionEnveloppe>;
  repartitionEnveloppesConsultant: Array<ConsultantRepartitionEnveloppe>;
  repartitionEsgsBackOffice: Array<ConsultantRepartitionEsg>;
  repartitionEsgsConsultant: Array<ConsultantRepartitionEsg>;
  repartitionPartenairesBackOffice: Array<ConsultantRepartitionPartenaire>;
  repartitionPartenairesConsultant: Array<ConsultantRepartitionPartenaire>;
  repartitionProduitsBackOffice: Array<ConsultantRepartitionProduit>;
  repartitionProduitsConsultant: Array<ConsultantRepartitionProduit>;
  repartitionSocieteGestionsBackOffice: Array<ConsultantRepartitionSocieteGestion>;
  repartitionSocieteGestionsConsultant: Array<ConsultantRepartitionSocieteGestion>;
  repartitionSrisBackOffice: Array<ConsultantRepartitionSri>;
  repartitionSrisConsultant: Array<ConsultantRepartitionSri>;
  secteurActivites: Array<SecteurActivite>;
  /** Get signature document filter values. Consultants can only see documents they have created. */
  signatureDocumentFilterValues: SignatureDocumentFilterValues;
  storageFile?: Maybe<StorageFile>;
  supportsBackOffice?: Maybe<SupportsBackOfficeCollectionSegment>;
  supportsConsultant?: Maybe<SupportsConsultantCollectionSegment>;
  toleranceRisqueOptions: Array<ToleranceRisqueOption>;
  /** Référentiel du questionnaire Tolérance au risque v2 : questions, réponses et scénarios (sans barème) */
  toleranceRisqueReferentiel: ToleranceRisqueReferentielDto;
  totalContratsBackOffice: Scalars['Decimal']['output'];
  totalContratsConsultant: Scalars['Decimal']['output'];
  transfertClients: Array<TransfertClient>;
  typeAvantageMatrimoniaux: Array<TypeAvantageMatrimonial>;
  typePpeMotifs: Array<TypePpeMotif>;
  typePpeRelations: Array<TypePpeRelation>;
  typeRelationAutres: Array<TypeRelationAutre>;
  typeSituationProfessionnelles: Array<TypeSituationProfessionnelle>;
  typeStatutProfessionnels: Array<TypeStatutProfessionnel>;
  typesBudgets: Array<TypeBudget>;
  userAccessRight: UserAccessRight;
  visionGlobaleBackOffice?: Maybe<ConsultantVisionGlobale>;
  visionGlobaleConsultant?: Maybe<ConsultantVisionGlobale>;
  waveMigrationStats: WaveTrackingStats;
};


export type QueryAllSupportsBackOfficeArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionSupportSortInput>>;
  where?: InputMaybe<ConsultantRepartitionSupportFilterInput>;
};


export type QueryAllSupportsConsultantArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionSupportSortInput>>;
  where?: InputMaybe<ConsultantRepartitionSupportFilterInput>;
};


export type QueryAllWaveMigrationJobsArgs = {
  where?: InputMaybe<WaveMigrationJobFilterInput>;
};


export type QueryAllocationsFilesArgs = {
  order?: InputMaybe<Array<AllocationSortInput>>;
  where?: InputMaybe<AllocationFilterInput>;
};


export type QueryBudgetByIdArgs = {
  id: Scalars['Long']['input'];
};


export type QueryCategorieSocioProfessionnellesArgs = {
  order?: InputMaybe<Array<CategorieSocioProfessionnelleSortInput>>;
  where?: InputMaybe<CategorieSocioProfessionnelleFilterInput>;
};


export type QueryCessionHistoInvestisseurPaginatedArgs = {
  order?: InputMaybe<Array<CessionHistoInvestisseurSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CessionHistoInvestisseurFilterInput>;
};


export type QueryCheckDoublonInvestisseurArgs = {
  consultantId?: InputMaybe<Scalars['Long']['input']>;
  dateNaissance: Scalars['LocalDate']['input'];
  editedInvestisseurId?: InputMaybe<Scalars['Long']['input']>;
  nom: Scalars['String']['input'];
  prenom: Scalars['String']['input'];
};


export type QueryCommandeByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryCommandesByIdsArgs = {
  ids: Array<Scalars['Long']['input']>;
};


export type QueryCommandesFinancieresPaginatedArgs = {
  order?: InputMaybe<Array<CommandeSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommandeFilterInput>;
};


export type QueryCommandesPaginatedArgs = {
  order?: InputMaybe<Array<CommandeSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommandeFilterInput>;
};


export type QueryComputeHabilitationsForActiveStatutsJuridiquesStateArgs = {
  id: Scalars['String']['input'];
};


export type QueryComputeLatestHabilitationChangesStateArgs = {
  id: Scalars['String']['input'];
};


export type QueryConsultantByCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryConsultantEtiquettesArgs = {
  consultantCode?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<EtiquetteSortInput>>;
  where?: InputMaybe<EtiquetteFilterInput>;
};


export type QueryConsultantFilesArgs = {
  consultantId: Scalars['Long']['input'];
  where?: InputMaybe<FileMetadataFilterInput>;
};


export type QueryConsultantHabilitationActionsBackOfficeArgs = {
  where?: InputMaybe<ConsultantHabilitationActionBackOfficeFilterInput>;
};


export type QueryConsultantHabilitationStatutChangesArgs = {
  where?: InputMaybe<ConsultantHabilitationStatutChangeFilterInput>;
};


export type QueryConsultantPreferencesArgs = {
  order?: InputMaybe<Array<ConsultantPreferencesSortInput>>;
  where?: InputMaybe<ConsultantPreferencesFilterInput>;
};


export type QueryConsultantStatutJuridiqueChangesArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueChangeFilterInput>;
};


export type QueryConsultantsArgs = {
  order?: InputMaybe<Array<ConsultantSortInput>>;
  where?: InputMaybe<ConsultantFilterInput>;
};


export type QueryConsultantsAgregationArgs = {
  filter: Scalars['String']['input'];
  order?: InputMaybe<Array<ConsultantAgregationSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConsultantAgregationFilterInput>;
};


export type QueryConsultantsByNameArgs = {
  order?: InputMaybe<Array<ConsultantSortInput>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ConsultantFilterInput>;
};


export type QueryConsultantsByNamePaginatedArgs = {
  order?: InputMaybe<Array<ConsultantSortInput>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConsultantFilterInput>;
};


export type QueryConsultantsPaginatedArgs = {
  order?: InputMaybe<Array<ConsultantSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConsultantFilterInput>;
};


export type QueryContratBackOfficeArgs = {
  idContrat: Scalars['String']['input'];
  order?: InputMaybe<Array<ContratsInvestisseurSortInput>>;
  where?: InputMaybe<ContratsInvestisseurFilterInput>;
};


export type QueryContratsBackOfficeArgs = {
  filter: ContratBackOfficeFilterInput;
  order?: InputMaybe<ContratBackOfficeOrderInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContratFilterInput>;
};


export type QueryContratsConsultantArgs = {
  filter: ContratConsultantFilterInput;
  order?: InputMaybe<ContratConsultantOrderInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContratFilterInput>;
};


export type QueryContratsInvestisseurArgs = {
  codeInvestisseur: Scalars['String']['input'];
  order?: InputMaybe<Array<ContratsInvestisseurSortInput>>;
  where?: InputMaybe<ContratsInvestisseurFilterInput>;
};


export type QueryDocumentCategoriesArgs = {
  order?: InputMaybe<Array<DocumentCategorySortInput>>;
  where?: InputMaybe<DocumentCategoryFilterInput>;
};


export type QueryDocumentTypesArgs = {
  order?: InputMaybe<Array<DocumentTypeSortInput>>;
  where?: InputMaybe<DocumentTypeFilterInput>;
};


export type QueryEnveloppeProduitByIdArgs = {
  code: Scalars['Byte']['input'];
};


export type QueryEnveloppeProduitsArgs = {
  where?: InputMaybe<EnveloppeProduitFilterInput>;
};


export type QueryEnveloppeProduitsByIdsArgs = {
  codes: Array<Scalars['Byte']['input']>;
};


export type QueryEnveloppeServiceMappingArgs = {
  where?: InputMaybe<ServiceByEnveloppeCodeFilterInput>;
};


export type QueryEquivalencesFormationsContinuesArgs = {
  consultantCode: Scalars['String']['input'];
  millesime: Scalars['Int']['input'];
  order?: InputMaybe<Array<EquivalenceFormationContinueSortInput>>;
  where?: InputMaybe<EquivalenceFormationContinueFilterInput>;
};


export type QueryEtiquetteIndicateursArgs = {
  minotaureOnly?: Scalars['Boolean']['input'];
  order?: InputMaybe<Array<EtiquetteIndicateurDtoSortInput>>;
  where?: InputMaybe<EtiquetteIndicateurDtoFilterInput>;
};


export type QueryEvaluateHabilitationExpirationsStateArgs = {
  id: Scalars['String']['input'];
};


export type QueryFailedFinancialRecalculationJobsArgs = {
  begin?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  priority: FinancialRecalculationPriority;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFileMetadataByFiltersArgs = {
  documentFilterConfiguration: DocumentFilterConfigurationInput;
};


export type QueryFileMetadataByFiltersPaginatedArgs = {
  documentFilterConfiguration: DocumentFilterConfigurationInput;
};


export type QueryFileMetadataByIdArgs = {
  fileId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFileMetadataCountByFiltersArgs = {
  documentFilterConfiguration: DocumentFilterConfigurationInput;
};


export type QueryFileUploadUriByIdArgs = {
  fileId: Scalars['String']['input'];
};


export type QueryFinancialRecalculationJobStatsArgs = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};


export type QueryFormationsContinuesArgs = {
  consultantCode: Scalars['String']['input'];
  millesime: Scalars['Int']['input'];
  order?: InputMaybe<Array<FormationContinueSortInput>>;
  where?: InputMaybe<FormationContinueFilterInput>;
};


export type QueryFormationsHabilitantesArgs = {
  consultantCode: Scalars['String']['input'];
  order?: InputMaybe<Array<FormationHabilitanteSortInput>>;
  where?: InputMaybe<FormationHabilitanteFilterInput>;
};


export type QueryFormeJuridiqueByCodeArgs = {
  code: Scalars['Byte']['input'];
};


export type QueryFormeJuridiquesArgs = {
  where?: InputMaybe<FormeJuridiqueFilterInput>;
};


export type QueryGedCategoriesArgs = {
  where?: InputMaybe<GedCategorieFilterInput>;
};


export type QueryGedTypeDocumentByCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGedTypeDocumentsArgs = {
  where?: InputMaybe<GedTypeDocumentFilterInput>;
};


export type QueryHabilitationByIdArgs = {
  id: Scalars['Long']['input'];
};


export type QueryHabilitationsArgs = {
  where?: InputMaybe<HabilitationFilterInput>;
};


export type QueryHabilitationsByIdsArgs = {
  ids: Array<Scalars['Long']['input']>;
};


export type QueryImportConsultantArgs = {
  order?: InputMaybe<Array<ImportConsultantSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImportConsultantFilterInput>;
};


export type QueryImportGalaxyArgs = {
  order?: InputMaybe<Array<ImportGalaxySortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImportGalaxyFilterInput>;
};


export type QueryImportInvestisseursArgs = {
  order?: InputMaybe<Array<ImportInvestisseurSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImportInvestisseurFilterInput>;
};


export type QueryImportLogsArgs = {
  order?: InputMaybe<Array<ArianeImportLogSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArianeImportLogFilterInput>;
};


export type QueryInvestisseurAndDuplicatesByIdArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type QueryInvestisseurByArianeIdArgs = {
  arianeId: Scalars['Long']['input'];
};


export type QueryInvestisseurByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryInvestisseurByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryInvestisseurConsultantPaginatedArgs = {
  order?: InputMaybe<Array<InvestisseurConsultantSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestisseurConsultantFilterInput>;
};


export type QueryInvestisseurFilesArgs = {
  investisseurId: Scalars['Long']['input'];
  order?: InputMaybe<Array<FileMetadataSortInput>>;
  where?: InputMaybe<FileMetadataFilterInput>;
};


export type QueryInvestisseurObjectifsByInvestisseurIdArgs = {
  investisseurId: Scalars['Long']['input'];
  order?: InputMaybe<Array<InvestisseurObjectifSortInput>>;
  where?: InputMaybe<InvestisseurObjectifFilterInput>;
};


export type QueryInvestisseurPatrimoineByIdArgs = {
  id: Scalars['Long']['input'];
  order?: InputMaybe<Array<InvestisseurPatrimoineSortInput>>;
  where?: InputMaybe<InvestisseurPatrimoineFilterInput>;
};


export type QueryInvestisseurPurgeCheckArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type QueryInvestisseurPurgeExecutionArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type QueryInvestisseursByIdsArgs = {
  ids: Array<Scalars['Long']['input']>;
};


export type QueryInvestisseursByNameArgs = {
  order?: InputMaybe<Array<InvestisseurSortInput>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type QueryInvestisseursByNameOrCodeArgs = {
  order?: InputMaybe<Array<InvestisseurSortInput>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type QueryInvestisseursByNamePaginatedArgs = {
  order?: InputMaybe<Array<InvestisseurSortInput>>;
  searchText: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type QueryInvestisseursByNameWithFilterPaginatedArgs = {
  order?: InputMaybe<Array<MinotaureInvestisseurSortInput>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MinotaureInvestisseurFilterInput>;
};


export type QueryInvestisseursFromMinotaurePaginatedArgs = {
  order?: InputMaybe<Array<MinotaureInvestisseurSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MinotaureInvestisseurFilterInput>;
};


export type QueryInvestisseursPaginatedArgs = {
  order?: InputMaybe<Array<InvestisseurSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type QueryInvestisseursPersonnesMoralesByNamePaginatedArgs = {
  order?: InputMaybe<Array<InvestisseurSortInput>>;
  searchText: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type QueryInvestisseursPersonnesPhysiquesByNamePaginatedArgs = {
  order?: InputMaybe<Array<InvestisseurSortInput>>;
  searchText: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type QueryManagersGalaxieArgs = {
  order?: InputMaybe<Array<ConsultantAgregationSortInput>>;
  where?: InputMaybe<ConsultantAgregationFilterInput>;
};


export type QueryModelesDocumentsArgs = {
  codeConsultant?: InputMaybe<Scalars['String']['input']>;
  investisseurCouple: Scalars['Boolean']['input'];
  order?: InputMaybe<Array<ModeleDocumentSortInput>>;
  where?: InputMaybe<ModeleDocumentFilterInput>;
};


export type QueryMouvementByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryMouvementsPaginatedArgs = {
  order?: InputMaybe<Array<MouvementSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MouvementFilterInput>;
};


export type QueryNatureOperationByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNatureOperationsArgs = {
  where?: InputMaybe<NatureOperationFilterInput>;
};


export type QueryNatureOperationsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryObjectifsReferentielArgs = {
  order?: InputMaybe<Array<TypeObjectifInvestisseurSortInput>>;
  where?: InputMaybe<TypeObjectifInvestisseurFilterInput>;
};


export type QueryOperationAdequationArgs = {
  operationId: Scalars['UUID']['input'];
};


export type QueryOperationAdequationsArgs = {
  input: OperationAdequationSearchInput;
};


export type QueryOperationByIdArgs = {
  operationId: Scalars['UUID']['input'];
};


export type QueryOperationsForConsultantArgs = {
  filter?: InputMaybe<OperationsForConsultantFilterInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartenaireByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryPartenairesArgs = {
  order?: InputMaybe<Array<PartenaireSortInput>>;
  where?: InputMaybe<PartenaireFilterInput>;
};


export type QueryPartenairesPaginatedArgs = {
  order?: InputMaybe<Array<PartenaireSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PartenaireFilterInput>;
};


export type QueryPatrimoineCategoriePerefencesArgs = {
  order?: InputMaybe<Array<PatrimoineCategorieReferenceSortInput>>;
  where?: InputMaybe<PatrimoineCategorieReferenceFilterInput>;
};


export type QueryPaysArgs = {
  order?: InputMaybe<Array<PaysSortInput>>;
  where?: InputMaybe<PaysFilterInput>;
};


export type QueryPersonnePhysiquesPaginatedArgs = {
  order?: InputMaybe<Array<PersonnePhysiqueSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};


export type QueryPresettedConsultantByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryPresettedInvestisseurByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryPresettedInvestisseursByIdsArgs = {
  ids: Array<InputMaybe<Scalars['Long']['input']>>;
};


export type QueryPresettedPartenaireByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryPresettedProduitByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryProduitByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryProduitsArgs = {
  order?: InputMaybe<Array<ProduitSortInput>>;
  where?: InputMaybe<ProduitFilterInput>;
};


export type QueryProduitsByIdsArgs = {
  ids: Array<Scalars['Long']['input']>;
};


export type QueryProduitsEpargneDetenusRecueilArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type QueryProduitsPaginatedArgs = {
  order?: InputMaybe<Array<ProduitSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProduitFilterInput>;
};


export type QueryProjetByIdArgs = {
  projetId: Scalars['Int']['input'];
};


export type QueryProjetsByInvestisseurArgs = {
  investisseurId: Scalars['Int']['input'];
};


export type QueryQcmsArgs = {
  consultantCode: Scalars['String']['input'];
  order?: InputMaybe<Array<QcmSortInput>>;
  where?: InputMaybe<QcmFilterInput>;
};


export type QueryQpiResultsByInvestisseurIdArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type QueryRechercheForConsultantArgs = {
  order?: InputMaybe<Array<RechercheSauvegardeSortInput>>;
  where?: InputMaybe<RechercheSauvegardeFilterInput>;
};


export type QueryRefreshStatutsCommerciauxAndHabilitationFlagsStateArgs = {
  id: Scalars['String']['input'];
};


export type QueryRegimeActivitesArgs = {
  order?: InputMaybe<Array<RegimeActiviteSortInput>>;
  where?: InputMaybe<RegimeActiviteFilterInput>;
};


export type QueryRepartitionClasseActifsBackOfficeArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionClasseActifSortInput>>;
  where?: InputMaybe<ConsultantRepartitionClasseActifFilterInput>;
};


export type QueryRepartitionClasseActifsConsultantArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionClasseActifSortInput>>;
  where?: InputMaybe<ConsultantRepartitionClasseActifFilterInput>;
};


export type QueryRepartitionEnveloppesBackOfficeArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionEnveloppeSortInput>>;
  where?: InputMaybe<ConsultantRepartitionEnveloppeFilterInput>;
};


export type QueryRepartitionEnveloppesConsultantArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionEnveloppeSortInput>>;
  where?: InputMaybe<ConsultantRepartitionEnveloppeFilterInput>;
};


export type QueryRepartitionEsgsBackOfficeArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionEsgSortInput>>;
  where?: InputMaybe<ConsultantRepartitionEsgFilterInput>;
};


export type QueryRepartitionEsgsConsultantArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionEsgSortInput>>;
  where?: InputMaybe<ConsultantRepartitionEsgFilterInput>;
};


export type QueryRepartitionPartenairesBackOfficeArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionPartenaireSortInput>>;
  where?: InputMaybe<ConsultantRepartitionPartenaireFilterInput>;
};


export type QueryRepartitionPartenairesConsultantArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionPartenaireSortInput>>;
  where?: InputMaybe<ConsultantRepartitionPartenaireFilterInput>;
};


export type QueryRepartitionProduitsBackOfficeArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionProduitSortInput>>;
  where?: InputMaybe<ConsultantRepartitionProduitFilterInput>;
};


export type QueryRepartitionProduitsConsultantArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionProduitSortInput>>;
  where?: InputMaybe<ConsultantRepartitionProduitFilterInput>;
};


export type QueryRepartitionSocieteGestionsBackOfficeArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionSocieteGestionSortInput>>;
  where?: InputMaybe<ConsultantRepartitionSocieteGestionFilterInput>;
};


export type QueryRepartitionSocieteGestionsConsultantArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionSocieteGestionSortInput>>;
  where?: InputMaybe<ConsultantRepartitionSocieteGestionFilterInput>;
};


export type QueryRepartitionSrisBackOfficeArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionSriSortInput>>;
  where?: InputMaybe<ConsultantRepartitionSriFilterInput>;
};


export type QueryRepartitionSrisConsultantArgs = {
  order?: InputMaybe<Array<ConsultantRepartitionSriSortInput>>;
  where?: InputMaybe<ConsultantRepartitionSriFilterInput>;
};


export type QuerySecteurActivitesArgs = {
  order?: InputMaybe<Array<SecteurActiviteSortInput>>;
  where?: InputMaybe<SecteurActiviteFilterInput>;
};


export type QuerySignatureDocumentFilterValuesArgs = {
  documentFilterConfiguration: DocumentFilterConfigurationInput;
};


export type QueryStorageFileArgs = {
  storageFileId: Scalars['String']['input'];
};


export type QuerySupportsBackOfficeArgs = {
  filter: SupportConsultantFilterInput;
  order?: InputMaybe<SupportConsultantOrderInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConsultantRepartitionSupportFilterInput>;
};


export type QuerySupportsConsultantArgs = {
  filter: SupportConsultantFilterInput;
  order?: InputMaybe<SupportConsultantOrderInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConsultantRepartitionSupportFilterInput>;
};


export type QueryTotalContratsBackOfficeArgs = {
  filter: ContratBackOfficeFilterInput;
};


export type QueryTotalContratsConsultantArgs = {
  filter: ContratConsultantFilterInput;
};


export type QueryTransfertClientsArgs = {
  order?: InputMaybe<Array<TransfertClientSortInput>>;
  where?: InputMaybe<TransfertClientFilterInput>;
};


export type QueryTypeAvantageMatrimoniauxArgs = {
  order?: InputMaybe<Array<TypeAvantageMatrimonialSortInput>>;
  where?: InputMaybe<TypeAvantageMatrimonialFilterInput>;
};


export type QueryTypePpeMotifsArgs = {
  order?: InputMaybe<Array<TypePpeMotifSortInput>>;
  where?: InputMaybe<TypePpeMotifFilterInput>;
};


export type QueryTypePpeRelationsArgs = {
  order?: InputMaybe<Array<TypePpeRelationSortInput>>;
  where?: InputMaybe<TypePpeRelationFilterInput>;
};


export type QueryTypeRelationAutresArgs = {
  order?: InputMaybe<Array<TypeRelationAutreSortInput>>;
  where?: InputMaybe<TypeRelationAutreFilterInput>;
};


export type QueryTypeSituationProfessionnellesArgs = {
  order?: InputMaybe<Array<TypeSituationProfessionnelleSortInput>>;
  where?: InputMaybe<TypeSituationProfessionnelleFilterInput>;
};


export type QueryTypeStatutProfessionnelsArgs = {
  order?: InputMaybe<Array<TypeStatutProfessionnelSortInput>>;
  where?: InputMaybe<TypeStatutProfessionnelFilterInput>;
};


export type QueryTypesBudgetsArgs = {
  order?: InputMaybe<Array<TypeBudgetSortInput>>;
  where?: InputMaybe<TypeBudgetFilterInput>;
};


export type QueryWaveMigrationStatsArgs = {
  waveId: Scalars['Long']['input'];
};

/** Question du questionnaire Tolérance au risque */
export type QuestionToleranceDto = {
  __typename?: 'QuestionToleranceDto';
  /** Code de la question (Q1 à Q9) */
  code: Scalars['String']['output'];
  intitule: Scalars['String']['output'];
  /** Réponses dans leur ordre d'affichage */
  options: Array<OptionToleranceDto>;
};


/** Question du questionnaire Tolérance au risque */
export type QuestionToleranceDtoOptionsArgs = {
  where?: InputMaybe<OptionToleranceDtoFilterInput>;
};

/** Question du questionnaire Tolérance au risque */
export type QuestionToleranceDtoFilterInput = {
  and?: InputMaybe<Array<QuestionToleranceDtoFilterInput>>;
  /** Code de la question (Q1 à Q9) */
  code?: InputMaybe<StringOperationFilterInput>;
  intitule?: InputMaybe<StringOperationFilterInput>;
  /** Réponses dans leur ordre d'affichage */
  options?: InputMaybe<ListFilterInputTypeOfOptionToleranceDtoFilterInput>;
  or?: InputMaybe<Array<QuestionToleranceDtoFilterInput>>;
};

/** Réaction face à une perte sur les placements financiers (Q19-bis) */
export enum ReactionPerteEnum {
  Patience = 'PATIENCE',
  Reinvestissement = 'REINVESTISSEMENT',
  VenteImmediate = 'VENTE_IMMEDIATE'
}

export type ReactionPerteEnumOperationFilterInput = {
  eq?: InputMaybe<ReactionPerteEnum>;
  in?: InputMaybe<Array<ReactionPerteEnum>>;
  neq?: InputMaybe<ReactionPerteEnum>;
  nin?: InputMaybe<Array<ReactionPerteEnum>>;
};

/** Réaction face à une perte (Q19-bis) */
export type ReactionPerteReferentielDto = {
  __typename?: 'ReactionPerteReferentielDto';
  code: ReactionPerteEnum;
  libelle: Scalars['String']['output'];
};

/** Réaction face à une perte (Q19-bis) */
export type ReactionPerteReferentielDtoFilterInput = {
  and?: InputMaybe<Array<ReactionPerteReferentielDtoFilterInput>>;
  code?: InputMaybe<ReactionPerteEnumOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReactionPerteReferentielDtoFilterInput>>;
};

export type RechercheSauvegarde = {
  __typename?: 'RechercheSauvegarde';
  consultantId: Scalars['Long']['output'];
  dateModification: Scalars['DateTime']['output'];
  filtres: Array<FiltreSetting>;
  id: Scalars['Long']['output'];
  label: Scalars['String']['output'];
};


export type RechercheSauvegardeFiltresArgs = {
  where?: InputMaybe<FiltreSettingFilterInput>;
};

export type RechercheSauvegardeFilterInput = {
  and?: InputMaybe<Array<RechercheSauvegardeFilterInput>>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  dateModification?: InputMaybe<DateTimeOperationFilterInput>;
  filtres?: InputMaybe<ListFilterInputTypeOfFiltreSettingFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RechercheSauvegardeFilterInput>>;
};

export type RechercheSauvegardeSortInput = {
  consultantId?: InputMaybe<SortEnumType>;
  dateModification?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  label?: InputMaybe<SortEnumType>;
};

export enum RecommendationAgeRange {
  From18To29 = 'FROM18_TO29',
  From30To39 = 'FROM30_TO39',
  From40To49 = 'FROM40_TO49',
  From50To64 = 'FROM50_TO64',
  From65AndOver = 'FROM65_AND_OVER'
}

export enum RecommendationCivility {
  Madame = 'MADAME',
  Monsieur = 'MONSIEUR'
}

export type RecommendationCivilityOperationFilterInput = {
  eq?: InputMaybe<RecommendationCivility>;
  in?: InputMaybe<Array<RecommendationCivility>>;
  neq?: InputMaybe<RecommendationCivility>;
  nin?: InputMaybe<Array<RecommendationCivility>>;
};

export enum RecommendationRelationship {
  Acquaintance = 'ACQUAINTANCE',
  Family = 'FAMILY',
  Friend = 'FRIEND'
}

export enum RecueilStateTransitionTrigger {
  ConsultantHasUploadedSignedRecueil = 'CONSULTANT_HAS_UPLOADED_SIGNED_RECUEIL',
  ConsultantStartsRecueilSignatureProcess = 'CONSULTANT_STARTS_RECUEIL_SIGNATURE_PROCESS',
  RecueilFormHasBeenCompleted = 'RECUEIL_FORM_HAS_BEEN_COMPLETED',
  RecueilFormHasBeenUncompleted = 'RECUEIL_FORM_HAS_BEEN_UNCOMPLETED',
  RecueilHasBeenSigned = 'RECUEIL_HAS_BEEN_SIGNED',
  RecueilHasExpired = 'RECUEIL_HAS_EXPIRED',
  RecueilSignatureIsCancelled = 'RECUEIL_SIGNATURE_IS_CANCELLED'
}

export enum RecueilStepState {
  Completed = 'COMPLETED',
  Incomplete = 'INCOMPLETE',
  NotStarted = 'NOT_STARTED'
}

export type RecueilStepStateOperationFilterInput = {
  eq?: InputMaybe<RecueilStepState>;
  in?: InputMaybe<Array<RecueilStepState>>;
  neq?: InputMaybe<RecueilStepState>;
  nin?: InputMaybe<Array<RecueilStepState>>;
};

export type RegimeActivite = {
  __typename?: 'RegimeActivite';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['Int']['output'];
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  situationProfessionnelles: Array<SituationProfessionnelle>;
};


export type RegimeActiviteSituationProfessionnellesArgs = {
  where?: InputMaybe<SituationProfessionnelleFilterInput>;
};

export type RegimeActiviteFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<RegimeActiviteFilterInput>>;
  code?: InputMaybe<IntOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RegimeActiviteFilterInput>>;
  situationProfessionnelles?: InputMaybe<ListFilterInputTypeOfSituationProfessionnelleFilterInput>;
};

export type RegimeActiviteSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type Reglementaire = {
  __typename?: 'Reglementaire';
  codePaysFactaResidenceFiscale?: Maybe<Scalars['String']['output']>;
  codePaysFactaResidenceFiscaleNavigation?: Maybe<Pays>;
  codePaysPpe?: Maybe<Scalars['String']['output']>;
  codePaysPpeNavigation?: Maybe<Pays>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  factaStatut?: Maybe<Scalars['Boolean']['output']>;
  factaTinCode?: Maybe<Scalars['String']['output']>;
  idSource?: Maybe<Scalars['String']['output']>;
  nifCode?: Maybe<Scalars['String']['output']>;
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
  ppeAnciennete?: Maybe<Scalars['LocalDate']['output']>;
  ppeStatut?: Maybe<Scalars['Boolean']['output']>;
  typePpeMotifCode?: Maybe<Scalars['String']['output']>;
  typePpeMotifCodeNavigation?: Maybe<TypePpeMotif>;
  typePpeRelationCode?: Maybe<Scalars['String']['output']>;
  typePpeRelationCodeNavigation?: Maybe<TypePpeRelation>;
};

export type ReglementaireFilterInput = {
  and?: InputMaybe<Array<ReglementaireFilterInput>>;
  codePaysFactaResidenceFiscale?: InputMaybe<StringOperationFilterInput>;
  codePaysFactaResidenceFiscaleNavigation?: InputMaybe<PaysFilterInput>;
  codePaysPpe?: InputMaybe<StringOperationFilterInput>;
  codePaysPpeNavigation?: InputMaybe<PaysFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  factaStatut?: InputMaybe<BooleanOperationFilterInput>;
  factaTinCode?: InputMaybe<StringOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  nifCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReglementaireFilterInput>>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  ppeAnciennete?: InputMaybe<LocalDateOperationFilterInput>;
  ppeStatut?: InputMaybe<BooleanOperationFilterInput>;
  typePpeMotifCode?: InputMaybe<StringOperationFilterInput>;
  typePpeMotifCodeNavigation?: InputMaybe<TypePpeMotifFilterInput>;
  typePpeRelationCode?: InputMaybe<StringOperationFilterInput>;
  typePpeRelationCodeNavigation?: InputMaybe<TypePpeRelationFilterInput>;
};

export type ReglementaireInput = {
  codeNIF?: InputMaybe<Scalars['String']['input']>;
  codePaysResidentFiscal?: InputMaybe<Scalars['String']['input']>;
  codeTIN?: InputMaybe<Scalars['String']['input']>;
  dateDebutExercice?: InputMaybe<Scalars['DateTime']['input']>;
  exposePolitique: Scalars['Boolean']['input'];
  fonction?: InputMaybe<Scalars['String']['input']>;
  paysExercice?: InputMaybe<Scalars['String']['input']>;
  typePpeRelationCode?: InputMaybe<Scalars['String']['input']>;
};

export type ReglementaireSortInput = {
  codePaysFactaResidenceFiscale?: InputMaybe<SortEnumType>;
  codePaysFactaResidenceFiscaleNavigation?: InputMaybe<PaysSortInput>;
  codePaysPpe?: InputMaybe<SortEnumType>;
  codePaysPpeNavigation?: InputMaybe<PaysSortInput>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  factaStatut?: InputMaybe<SortEnumType>;
  factaTinCode?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  nifCode?: InputMaybe<SortEnumType>;
  personnePhysique?: InputMaybe<PersonnePhysiqueSortInput>;
  personnePhysiqueId?: InputMaybe<SortEnumType>;
  ppeAnciennete?: InputMaybe<SortEnumType>;
  ppeStatut?: InputMaybe<SortEnumType>;
  typePpeMotifCode?: InputMaybe<SortEnumType>;
  typePpeMotifCodeNavigation?: InputMaybe<TypePpeMotifSortInput>;
  typePpeRelationCode?: InputMaybe<SortEnumType>;
  typePpeRelationCodeNavigation?: InputMaybe<TypePpeRelationSortInput>;
};

export type RelationAutre = {
  __typename?: 'RelationAutre';
  arianeId?: Maybe<Scalars['Long']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  personnePhysique1: PersonnePhysique;
  personnePhysique1Id: Scalars['Long']['output'];
  personnePhysique2: PersonnePhysique;
  personnePhysique2Id: Scalars['Long']['output'];
  typeRelationAutre?: Maybe<Scalars['String']['output']>;
  typeRelationAutreCode: Scalars['String']['output'];
  typeRelationAutreCodeNavigation: TypeRelationAutre;
  typeRelationAutreCodeRev: Scalars['String']['output'];
  typeRelationAutreCodeRevNavigation: TypeRelationAutre;
};

export type RelationAutreFilterInput = {
  and?: InputMaybe<Array<RelationAutreFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<RelationAutreFilterInput>>;
  personnePhysique1?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysique1Id?: InputMaybe<LongOperationFilterInput>;
  personnePhysique2?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysique2Id?: InputMaybe<LongOperationFilterInput>;
  typeRelationAutre?: InputMaybe<StringOperationFilterInput>;
  typeRelationAutreCode?: InputMaybe<StringOperationFilterInput>;
  typeRelationAutreCodeNavigation?: InputMaybe<TypeRelationAutreFilterInput>;
  typeRelationAutreCodeRev?: InputMaybe<StringOperationFilterInput>;
  typeRelationAutreCodeRevNavigation?: InputMaybe<TypeRelationAutreFilterInput>;
};

export type RelationAutreSimple = {
  __typename?: 'RelationAutreSimple';
  arianeId?: Maybe<Scalars['Long']['output']>;
  autrePersonnePhysique?: Maybe<PersonnePhysique>;
  autrePersonnePhysiqueId?: Maybe<Scalars['Long']['output']>;
  /** Indique si l’utilisateur est autorisé à accéder aux données de l’investisseur associé. */
  clientCanAccessData?: Maybe<Scalars['Boolean']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  typeRelationAutre?: Maybe<Scalars['String']['output']>;
  typeRelationAutreCode: Scalars['String']['output'];
  typeRelationAutreCodeNavigation: TypeRelationAutre;
};

export type RelationCouple = {
  __typename?: 'RelationCouple';
  arianeId?: Maybe<Scalars['Long']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  idSource?: Maybe<Scalars['Long']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  personnePhysique1: PersonnePhysique;
  personnePhysique1Id: Scalars['Long']['output'];
  personnePhysique2: PersonnePhysique;
  personnePhysique2Id: Scalars['Long']['output'];
  typeRelationCoupleCode: Scalars['String']['output'];
  typeRelationCoupleCodeNavigation: TypeRelationCouple;
};

export type RelationCoupleFilterInput = {
  and?: InputMaybe<Array<RelationCoupleFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  note?: InputMaybe<NoteFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<RelationCoupleFilterInput>>;
  personnePhysique1?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysique1Id?: InputMaybe<LongOperationFilterInput>;
  personnePhysique2?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysique2Id?: InputMaybe<LongOperationFilterInput>;
  typeRelationCoupleCode?: InputMaybe<StringOperationFilterInput>;
  typeRelationCoupleCodeNavigation?: InputMaybe<TypeRelationCoupleFilterInput>;
};

export type RelationCoupleInput = {
  arianeId?: InputMaybe<Scalars['Long']['input']>;
  personnePhysique1Id: Scalars['Long']['input'];
  personnePhysique2Id: Scalars['Long']['input'];
  typeRelationCoupleCode: Scalars['String']['input'];
};

export type RelationCoupleSimple = {
  __typename?: 'RelationCoupleSimple';
  arianeId?: Maybe<Scalars['Long']['output']>;
  autrePersonnePhysique?: Maybe<PersonnePhysique>;
  autrePersonnePhysiqueId?: Maybe<Scalars['Long']['output']>;
  /** Indique si l’utilisateur est autorisé à accéder aux données de l’investisseur associé. */
  clientCanAccessData?: Maybe<Scalars['Boolean']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  idSource?: Maybe<Scalars['Long']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  typeRelationCoupleCode: Scalars['String']['output'];
  typeRelationCoupleCodeNavigation: TypeRelationCouple;
};

export type RelationFamille = {
  __typename?: 'RelationFamille';
  arianeId?: Maybe<Scalars['Long']['output']>;
  autoriteParentale: Scalars['Boolean']['output'];
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateFinChargeFiscale?: Maybe<Scalars['LocalDate']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  enfantACharge?: Maybe<Scalars['Boolean']['output']>;
  enfantAdopte?: Maybe<Scalars['Boolean']['output']>;
  estTypeRelation: Scalars['Boolean']['output'];
  gardeAlternee?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  niveauEtudeCode?: Maybe<Scalars['String']['output']>;
  niveauEtudeCodeNavigation?: Maybe<NiveauEtude>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  personnePhysique1: PersonnePhysique;
  personnePhysique1Id: Scalars['Long']['output'];
  personnePhysique2: PersonnePhysique;
  personnePhysique2Id: Scalars['Long']['output'];
  typeAdoptionCode?: Maybe<Scalars['String']['output']>;
  typeAdoptionCodeNavigation?: Maybe<TypeAdoption>;
  typeRelationFamilleCode: Scalars['String']['output'];
  typeRelationFamilleCodeNavigation: TypeRelationFamille;
  typeRelationFamilleCodeRev: Scalars['String']['output'];
  typeRelationFamilleCodeRevNavigation: TypeRelationFamille;
};

export type RelationFamilleFilterInput = {
  and?: InputMaybe<Array<RelationFamilleFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  autoriteParentale?: InputMaybe<BooleanOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinChargeFiscale?: InputMaybe<LocalDateOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  enfantACharge?: InputMaybe<BooleanOperationFilterInput>;
  enfantAdopte?: InputMaybe<BooleanOperationFilterInput>;
  estTypeRelation?: InputMaybe<BooleanOperationFilterInput>;
  gardeAlternee?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  niveauEtudeCode?: InputMaybe<StringOperationFilterInput>;
  niveauEtudeCodeNavigation?: InputMaybe<NiveauEtudeFilterInput>;
  note?: InputMaybe<NoteFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<RelationFamilleFilterInput>>;
  personnePhysique1?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysique1Id?: InputMaybe<LongOperationFilterInput>;
  personnePhysique2?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysique2Id?: InputMaybe<LongOperationFilterInput>;
  typeAdoptionCode?: InputMaybe<StringOperationFilterInput>;
  typeAdoptionCodeNavigation?: InputMaybe<TypeAdoptionFilterInput>;
  typeRelationFamilleCode?: InputMaybe<StringOperationFilterInput>;
  typeRelationFamilleCodeNavigation?: InputMaybe<TypeRelationFamilleFilterInput>;
  typeRelationFamilleCodeRev?: InputMaybe<StringOperationFilterInput>;
  typeRelationFamilleCodeRevNavigation?: InputMaybe<TypeRelationFamilleFilterInput>;
};

export type RelationFamilleSimple = {
  __typename?: 'RelationFamilleSimple';
  arianeId?: Maybe<Scalars['Long']['output']>;
  autoriteParentale?: Maybe<Scalars['Boolean']['output']>;
  autrePersonnePhysique?: Maybe<PersonnePhysique>;
  autrePersonnePhysiqueId?: Maybe<Scalars['Long']['output']>;
  /** Indique si l’utilisateur est autorisé à accéder aux données de l’investisseur associé. */
  clientCanAccessData?: Maybe<Scalars['Boolean']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateFinChargeFiscale?: Maybe<Scalars['LocalDate']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  enfantACharge?: Maybe<Scalars['Boolean']['output']>;
  enfantAdopte?: Maybe<Scalars['Boolean']['output']>;
  estTypeRelation?: Maybe<Scalars['Boolean']['output']>;
  gardeAlternee?: Maybe<Scalars['Boolean']['output']>;
  idSource?: Maybe<Scalars['Long']['output']>;
  niveauEtudeCode?: Maybe<Scalars['String']['output']>;
  niveauEtudeCodeNavigation?: Maybe<NiveauEtude>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  typeAdoptionCode?: Maybe<Scalars['String']['output']>;
  typeAdoptionCodeNavigation?: Maybe<TypeAdoption>;
  typeRelationFamilleCode: Scalars['String']['output'];
  typeRelationFamilleCodeNavigation: TypeRelationFamille;
};

export type RelationSimpleUnaccesible = {
  __typename?: 'RelationSimpleUnaccesible';
  nom?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  typeRelationCode: Scalars['String']['output'];
  typeRelationLibelle: Scalars['String']['output'];
};

export type ReponseReadhesion = {
  __typename?: 'ReponseReadhesion';
  adhesionConsultant: Array<AdhesionConsultant>;
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type ReponseReadhesionAdhesionConsultantArgs = {
  where?: InputMaybe<AdhesionConsultantFilterInput>;
};

export type ReponseReadhesionFilterInput = {
  adhesionConsultant?: InputMaybe<ListFilterInputTypeOfAdhesionConsultantFilterInput>;
  and?: InputMaybe<Array<ReponseReadhesionFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReponseReadhesionFilterInput>>;
};

/** Réponses au questionnaire courant du profil investisseur, par section */
export type ReponsesProfilInvestisseur = {
  __typename?: 'ReponsesProfilInvestisseur';
  /** Réponses au questionnaire Connaissance et expérience (null tant que la section n'a pas été enregistrée) */
  connaissanceExperience?: Maybe<ConnaissanceExperienceReponses>;
  /** Réponses au questionnaire Tolérance au risque (null tant que la section n'a pas été enregistrée) */
  toleranceRisque?: Maybe<ToleranceRisqueReponses>;
};

/** Réponses au questionnaire courant du profil investisseur, par section */
export type ReponsesProfilInvestisseurFilterInput = {
  and?: InputMaybe<Array<ReponsesProfilInvestisseurFilterInput>>;
  /** Réponses au questionnaire Connaissance et expérience (null tant que la section n'a pas été enregistrée) */
  connaissanceExperience?: InputMaybe<ConnaissanceExperienceReponsesFilterInput>;
  or?: InputMaybe<Array<ReponsesProfilInvestisseurFilterInput>>;
  /** Réponses au questionnaire Tolérance au risque (null tant que la section n'a pas été enregistrée) */
  toleranceRisque?: InputMaybe<ToleranceRisqueReponsesFilterInput>;
};

/** Réponses au questionnaire courant du profil investisseur, par section */
export type ReponsesProfilInvestisseurSortInput = {
  /** Réponses au questionnaire Connaissance et expérience (null tant que la section n'a pas été enregistrée) */
  connaissanceExperience?: InputMaybe<ConnaissanceExperienceReponsesSortInput>;
  /** Réponses au questionnaire Tolérance au risque (null tant que la section n'a pas été enregistrée) */
  toleranceRisque?: InputMaybe<ToleranceRisqueReponsesSortInput>;
};

export type ResiliationPaiementB2S = {
  __typename?: 'ResiliationPaiementB2S';
  creationDate: Scalars['DateTime']['output'];
  dateProchainPaiement?: Maybe<Scalars['DateTime']['output']>;
  editionDate: Scalars['DateTime']['output'];
  etat: Scalars['String']['output'];
  etatNavigation: EtatResiliationB2S;
  id: Scalars['Long']['output'];
  idConsultant: Scalars['Long']['output'];
  idConsultantNavigation: Consultant;
  messageRetour?: Maybe<Scalars['String']['output']>;
};

export type ResiliationPaiementB2SFilterInput = {
  and?: InputMaybe<Array<ResiliationPaiementB2SFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateProchainPaiement?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etat?: InputMaybe<StringOperationFilterInput>;
  etatNavigation?: InputMaybe<EtatResiliationB2SFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idConsultant?: InputMaybe<LongOperationFilterInput>;
  idConsultantNavigation?: InputMaybe<ConsultantFilterInput>;
  messageRetour?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ResiliationPaiementB2SFilterInput>>;
};

/** Scénario illustré d'une réponse : gain potentiel à 8 ans et baisse maximale en cours de vie */
export type ScenarioToleranceDto = {
  __typename?: 'ScenarioToleranceDto';
  baissePourcent: Scalars['Int']['output'];
  gainPourcent: Scalars['Int']['output'];
  titre: Scalars['String']['output'];
};

/** Scénario illustré d'une réponse : gain potentiel à 8 ans et baisse maximale en cours de vie */
export type ScenarioToleranceDtoFilterInput = {
  and?: InputMaybe<Array<ScenarioToleranceDtoFilterInput>>;
  baissePourcent?: InputMaybe<IntOperationFilterInput>;
  gainPourcent?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ScenarioToleranceDtoFilterInput>>;
  titre?: InputMaybe<StringOperationFilterInput>;
};

export type SeanceSession = {
  __typename?: 'SeanceSession';
  codeEtat?: Maybe<Scalars['Byte']['output']>;
  codeEtatNavigation?: Maybe<SeanceSessionEtat>;
  creationDate: Scalars['DateTime']['output'];
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  nombreHeures?: Maybe<Scalars['Decimal']['output']>;
  session?: Maybe<Session>;
  sessionId?: Maybe<Scalars['Long']['output']>;
};

export type SeanceSessionEtat = {
  __typename?: 'SeanceSessionEtat';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  seanceSession: Array<SeanceSession>;
};


export type SeanceSessionEtatSeanceSessionArgs = {
  where?: InputMaybe<SeanceSessionFilterInput>;
};

export type SeanceSessionEtatFilterInput = {
  and?: InputMaybe<Array<SeanceSessionEtatFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SeanceSessionEtatFilterInput>>;
  seanceSession?: InputMaybe<ListFilterInputTypeOfSeanceSessionFilterInput>;
};

export type SeanceSessionFilterInput = {
  and?: InputMaybe<Array<SeanceSessionFilterInput>>;
  codeEtat?: InputMaybe<ByteOperationFilterInput>;
  codeEtatNavigation?: InputMaybe<SeanceSessionEtatFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  nombreHeures?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<SeanceSessionFilterInput>>;
  session?: InputMaybe<SessionFilterInput>;
  sessionId?: InputMaybe<LongOperationFilterInput>;
};

export type SecteurActivite = {
  __typename?: 'SecteurActivite';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['Int']['output'];
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  situationProfessionnelles: Array<SituationProfessionnelle>;
};


export type SecteurActiviteSituationProfessionnellesArgs = {
  where?: InputMaybe<SituationProfessionnelleFilterInput>;
};

export type SecteurActiviteFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<SecteurActiviteFilterInput>>;
  code?: InputMaybe<IntOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SecteurActiviteFilterInput>>;
  situationProfessionnelles?: InputMaybe<ListFilterInputTypeOfSituationProfessionnelleFilterInput>;
};

export type SecteurActiviteSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

/** Résultat de la synchronisation de la sélection automatique des produits d'épargne avec le recueil */
export type SelectionAutoRecueilResultatDto = {
  __typename?: 'SelectionAutoRecueilResultatDto';
  /** Indique que le questionnaire Connaissance et expérience est complet après la mise à jour */
  isComplete: Scalars['Boolean']['output'];
  /** Libellés des produits nouvellement sélectionnés automatiquement (réponse écrasée en « Je détiens ») */
  produitsAjoutes: Array<Scalars['String']['output']>;
};


/** Résultat de la synchronisation de la sélection automatique des produits d'épargne avec le recueil */
export type SelectionAutoRecueilResultatDtoProduitsAjoutesArgs = {
  where?: InputMaybe<StringOperationFilterInput>;
};

export type ServiceByEnveloppeCode = {
  __typename?: 'ServiceByEnveloppeCode';
  enveloppeCode: Scalars['Byte']['output'];
  service: BackOfficeService;
};

export type ServiceByEnveloppeCodeFilterInput = {
  and?: InputMaybe<Array<ServiceByEnveloppeCodeFilterInput>>;
  enveloppeCode?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<ServiceByEnveloppeCodeFilterInput>>;
  service?: InputMaybe<BackOfficeServiceOperationFilterInput>;
};

export type Session = {
  __typename?: 'Session';
  actionDeFormationSession: Array<ActionDeFormationSession>;
  codeEtat?: Maybe<Scalars['Byte']['output']>;
  codeEtatNavigation?: Maybe<SessionEtat>;
  codeGenre?: Maybe<Scalars['Byte']['output']>;
  codeGenreNavigation?: Maybe<SessionGenre>;
  creationDate: Scalars['DateTime']['output'];
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  dureeHeure?: Maybe<Scalars['Decimal']['output']>;
  dureeJour?: Maybe<Scalars['Decimal']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  inscriptionSession: Array<InscriptionSession>;
  nom: Scalars['String']['output'];
  seanceSession: Array<SeanceSession>;
};


export type SessionActionDeFormationSessionArgs = {
  where?: InputMaybe<ActionDeFormationSessionFilterInput>;
};


export type SessionInscriptionSessionArgs = {
  where?: InputMaybe<InscriptionSessionFilterInput>;
};


export type SessionSeanceSessionArgs = {
  where?: InputMaybe<SeanceSessionFilterInput>;
};

export type SessionEtat = {
  __typename?: 'SessionEtat';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  cycleCourt: Array<CycleCourt>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  session: Array<Session>;
};


export type SessionEtatCycleCourtArgs = {
  where?: InputMaybe<CycleCourtFilterInput>;
};


export type SessionEtatSessionArgs = {
  where?: InputMaybe<SessionFilterInput>;
};

export type SessionEtatFilterInput = {
  and?: InputMaybe<Array<SessionEtatFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cycleCourt?: InputMaybe<ListFilterInputTypeOfCycleCourtFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SessionEtatFilterInput>>;
  session?: InputMaybe<ListFilterInputTypeOfSessionFilterInput>;
};

export type SessionFilterInput = {
  actionDeFormationSession?: InputMaybe<ListFilterInputTypeOfActionDeFormationSessionFilterInput>;
  and?: InputMaybe<Array<SessionFilterInput>>;
  codeEtat?: InputMaybe<ByteOperationFilterInput>;
  codeEtatNavigation?: InputMaybe<SessionEtatFilterInput>;
  codeGenre?: InputMaybe<ByteOperationFilterInput>;
  codeGenreNavigation?: InputMaybe<SessionGenreFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  dureeHeure?: InputMaybe<DecimalOperationFilterInput>;
  dureeJour?: InputMaybe<DecimalOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  inscriptionSession?: InputMaybe<ListFilterInputTypeOfInscriptionSessionFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SessionFilterInput>>;
  seanceSession?: InputMaybe<ListFilterInputTypeOfSeanceSessionFilterInput>;
};

export type SessionGenre = {
  __typename?: 'SessionGenre';
  code: Scalars['Byte']['output'];
  codeSource: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  cycleCourt: Array<CycleCourt>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  session: Array<Session>;
};


export type SessionGenreCycleCourtArgs = {
  where?: InputMaybe<CycleCourtFilterInput>;
};


export type SessionGenreSessionArgs = {
  where?: InputMaybe<SessionFilterInput>;
};

export type SessionGenreFilterInput = {
  and?: InputMaybe<Array<SessionGenreFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  codeSource?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cycleCourt?: InputMaybe<ListFilterInputTypeOfCycleCourtFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SessionGenreFilterInput>>;
  session?: InputMaybe<ListFilterInputTypeOfSessionFilterInput>;
};

export type SignataireInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  internalId?: InputMaybe<Scalars['Int']['input']>;
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  type: SignataireType;
};

export enum SignataireType {
  Consultant = 'CONSULTANT',
  Investisseur = 'INVESTISSEUR',
  None = 'NONE'
}

export type SignatureDocumentFilterValues = {
  __typename?: 'SignatureDocumentFilterValues';
  etatSignatures: Array<SignatureState>;
  typeDocumentCodes: Array<Scalars['String']['output']>;
};


export type SignatureDocumentFilterValuesEtatSignaturesArgs = {
  where?: InputMaybe<SignatureStateOperationFilterInput>;
};


export type SignatureDocumentFilterValuesTypeDocumentCodesArgs = {
  where?: InputMaybe<StringOperationFilterInput>;
};

export enum SignatureState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
  ValeurNonSupportee = 'VALEUR_NON_SUPPORTEE'
}

export type SignatureStateOperationFilterInput = {
  eq?: InputMaybe<SignatureState>;
  in?: InputMaybe<Array<SignatureState>>;
  neq?: InputMaybe<SignatureState>;
  nin?: InputMaybe<Array<SignatureState>>;
};

export enum SignerStateStatusEnum {
  Failure = 'FAILURE',
  NotFound = 'NOT_FOUND',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

export type SignerStates = {
  __typename?: 'SignerStates';
  actionDate: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  internalId?: Maybe<Scalars['Int']['output']>;
  lastName: Scalars['String']['output'];
  signatureState: SignerStatus;
  type?: Maybe<SignataireType>;
};

export type SignerStatesResponse = {
  __typename?: 'SignerStatesResponse';
  documentIds: Array<Scalars['String']['output']>;
  requestStatus: SignerStateStatusEnum;
  states?: Maybe<Array<SignerStates>>;
};

export enum SignerStatus {
  Accessed = 'ACCESSED',
  Canceled = 'CANCELED',
  CodeSent = 'CODE_SENT',
  Failed = 'FAILED',
  PendingIdDocs = 'PENDING_ID_DOCS',
  PendingValidation = 'PENDING_VALIDATION',
  Ready = 'READY',
  Signed = 'SIGNED',
  Unknown = 'UNKNOWN',
  Waiting = 'WAITING'
}

export type SituationPatrimoineData = {
  __typename?: 'SituationPatrimoineData';
  capaciteEpargneMensuel?: Maybe<Scalars['Decimal']['output']>;
  dateMiseAJourAtlas?: Maybe<Scalars['DateTime']['output']>;
  epargneFinanceMontantTotal?: Maybe<Scalars['Decimal']['output']>;
  epargneImmoMontantHorsRP?: Maybe<Scalars['Decimal']['output']>;
  revenuAnnuelTotal?: Maybe<Scalars['Decimal']['output']>;
};

export type SituationPatrimoineDataFilterInput = {
  and?: InputMaybe<Array<SituationPatrimoineDataFilterInput>>;
  capaciteEpargneMensuel?: InputMaybe<DecimalOperationFilterInput>;
  dateMiseAJourAtlas?: InputMaybe<DateTimeOperationFilterInput>;
  epargneFinanceMontantTotal?: InputMaybe<DecimalOperationFilterInput>;
  epargneImmoMontantHorsRP?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<SituationPatrimoineDataFilterInput>>;
  revenuAnnuelTotal?: InputMaybe<DecimalOperationFilterInput>;
};

export type SituationPatrimoineDataInput = {
  capaciteEpargneMensuel?: InputMaybe<Scalars['Decimal']['input']>;
  dateMiseAJourAtlas?: InputMaybe<Scalars['DateTime']['input']>;
  epargneFinanceMontantTotal?: InputMaybe<Scalars['Decimal']['input']>;
  epargneImmoMontantHorsRP?: InputMaybe<Scalars['Decimal']['input']>;
  revenuAnnuelTotal?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SituationPersonnelleData = {
  __typename?: 'SituationPersonnelleData';
  categorieSocioProfessionnelleCode?: Maybe<Scalars['Byte']['output']>;
  categorieSocioProfessionnelleLibelle?: Maybe<Scalars['String']['output']>;
  dateMiseAJourAtlas?: Maybe<Scalars['DateTime']['output']>;
  enfantACharge?: Maybe<Scalars['Int']['output']>;
  etatCivilDisplay?: Maybe<Scalars['String']['output']>;
  etatCivilTypeCode?: Maybe<Scalars['String']['output']>;
  etatCivilTypeLibelle?: Maybe<Scalars['String']['output']>;
  etatCivilTypeRegimeCode?: Maybe<Scalars['String']['output']>;
  etatCivilTypeRegimeLibelle?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
};

export type SituationPersonnelleDataFilterInput = {
  and?: InputMaybe<Array<SituationPersonnelleDataFilterInput>>;
  categorieSocioProfessionnelleCode?: InputMaybe<ByteOperationFilterInput>;
  categorieSocioProfessionnelleLibelle?: InputMaybe<StringOperationFilterInput>;
  dateMiseAJourAtlas?: InputMaybe<DateTimeOperationFilterInput>;
  enfantACharge?: InputMaybe<IntOperationFilterInput>;
  etatCivilDisplay?: InputMaybe<StringOperationFilterInput>;
  etatCivilTypeCode?: InputMaybe<StringOperationFilterInput>;
  etatCivilTypeLibelle?: InputMaybe<StringOperationFilterInput>;
  etatCivilTypeRegimeCode?: InputMaybe<StringOperationFilterInput>;
  etatCivilTypeRegimeLibelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SituationPersonnelleDataFilterInput>>;
  profession?: InputMaybe<StringOperationFilterInput>;
};

export type SituationPersonnelleDataInput = {
  categorieSocioProfessionnelleCode?: InputMaybe<Scalars['Byte']['input']>;
  categorieSocioProfessionnelleLibelle?: InputMaybe<Scalars['String']['input']>;
  dateMiseAJourAtlas?: InputMaybe<Scalars['DateTime']['input']>;
  enfantACharge?: InputMaybe<Scalars['Int']['input']>;
  etatCivilDisplay?: InputMaybe<Scalars['String']['input']>;
  etatCivilTypeCode?: InputMaybe<Scalars['String']['input']>;
  etatCivilTypeLibelle?: InputMaybe<Scalars['String']['input']>;
  etatCivilTypeRegimeCode?: InputMaybe<Scalars['String']['input']>;
  etatCivilTypeRegimeLibelle?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
};

export type SituationProfessionnelle = {
  __typename?: 'SituationProfessionnelle';
  anciennete?: Maybe<Scalars['LocalDate']['output']>;
  categorieSocioProfessionnelleCode?: Maybe<Scalars['String']['output']>;
  categorieSocioProfessionnelleCodeAtlas?: Maybe<Scalars['Byte']['output']>;
  categorieSocioProfessionnelleCodeAtlasNavigation?: Maybe<CategorieSocioProfessionnelle>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateDepartRetraite?: Maybe<Scalars['LocalDate']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  idSource?: Maybe<Scalars['String']['output']>;
  nomSociete?: Maybe<Scalars['String']['output']>;
  note: Array<Note>;
  origineRevenus?: Maybe<Scalars['String']['output']>;
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
  profession?: Maybe<Scalars['String']['output']>;
  regimeActiviteCode?: Maybe<Scalars['Int']['output']>;
  regimeActiviteCodeNavigation?: Maybe<RegimeActivite>;
  secteurActiviteCode?: Maybe<Scalars['Int']['output']>;
  secteurActiviteCodeNavigation?: Maybe<SecteurActivite>;
  typeSituationProfessionnelleCode?: Maybe<Scalars['Int']['output']>;
  typeSituationProfessionnelleCodeNavigation?: Maybe<TypeSituationProfessionnelle>;
  typeStatutProfessionnelCode?: Maybe<Scalars['Int']['output']>;
  typeStatutProfessionnelCodeNavigation?: Maybe<TypeStatutProfessionnel>;
};


export type SituationProfessionnelleNoteArgs = {
  where?: InputMaybe<NoteFilterInput>;
};

export type SituationProfessionnelleFilterInput = {
  anciennete?: InputMaybe<LocalDateOperationFilterInput>;
  and?: InputMaybe<Array<SituationProfessionnelleFilterInput>>;
  categorieSocioProfessionnelleCode?: InputMaybe<StringOperationFilterInput>;
  categorieSocioProfessionnelleCodeAtlas?: InputMaybe<ByteOperationFilterInput>;
  categorieSocioProfessionnelleCodeAtlasNavigation?: InputMaybe<CategorieSocioProfessionnelleFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDepartRetraite?: InputMaybe<LocalDateOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  nomSociete?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<ListFilterInputTypeOfNoteFilterInput>;
  or?: InputMaybe<Array<SituationProfessionnelleFilterInput>>;
  origineRevenus?: InputMaybe<StringOperationFilterInput>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  profession?: InputMaybe<StringOperationFilterInput>;
  regimeActiviteCode?: InputMaybe<IntOperationFilterInput>;
  regimeActiviteCodeNavigation?: InputMaybe<RegimeActiviteFilterInput>;
  secteurActiviteCode?: InputMaybe<IntOperationFilterInput>;
  secteurActiviteCodeNavigation?: InputMaybe<SecteurActiviteFilterInput>;
  typeSituationProfessionnelleCode?: InputMaybe<IntOperationFilterInput>;
  typeSituationProfessionnelleCodeNavigation?: InputMaybe<TypeSituationProfessionnelleFilterInput>;
  typeStatutProfessionnelCode?: InputMaybe<IntOperationFilterInput>;
  typeStatutProfessionnelCodeNavigation?: InputMaybe<TypeStatutProfessionnelFilterInput>;
};

export type SituationProfessionnelleSortInput = {
  anciennete?: InputMaybe<SortEnumType>;
  categorieSocioProfessionnelleCode?: InputMaybe<SortEnumType>;
  categorieSocioProfessionnelleCodeAtlas?: InputMaybe<SortEnumType>;
  categorieSocioProfessionnelleCodeAtlasNavigation?: InputMaybe<CategorieSocioProfessionnelleSortInput>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateDepartRetraite?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  nomSociete?: InputMaybe<SortEnumType>;
  origineRevenus?: InputMaybe<SortEnumType>;
  personnePhysique?: InputMaybe<PersonnePhysiqueSortInput>;
  personnePhysiqueId?: InputMaybe<SortEnumType>;
  profession?: InputMaybe<SortEnumType>;
  regimeActiviteCode?: InputMaybe<SortEnumType>;
  regimeActiviteCodeNavigation?: InputMaybe<RegimeActiviteSortInput>;
  secteurActiviteCode?: InputMaybe<SortEnumType>;
  secteurActiviteCodeNavigation?: InputMaybe<SecteurActiviteSortInput>;
  typeSituationProfessionnelleCode?: InputMaybe<SortEnumType>;
  typeSituationProfessionnelleCodeNavigation?: InputMaybe<TypeSituationProfessionnelleSortInput>;
  typeStatutProfessionnelCode?: InputMaybe<SortEnumType>;
  typeStatutProfessionnelCodeNavigation?: InputMaybe<TypeStatutProfessionnelSortInput>;
};

export type SocieteInput = {
  adresse: AdresseInput;
  numeroImmatriculationRCS: Scalars['String']['input'];
  numeroTva: Scalars['String']['input'];
  raisonSociale: Scalars['String']['input'];
  siret: Scalars['String']['input'];
  typeStatutJuridique: Scalars['String']['input'];
  villeSiret: Scalars['String']['input'];
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SousCategorie2BudgetEnum {
  AutoEntrepreneur = 'AUTO_ENTREPRENEUR',
  AutresChargesEpargnes = 'AUTRES_CHARGES_EPARGNES',
  AutresChargesImmobilieres = 'AUTRES_CHARGES_IMMOBILIERES',
  AutreDeduction = 'AUTRE_DEDUCTION',
  AutreDepense = 'AUTRE_DEPENSE',
  AutrePensionEtRenteImposable = 'AUTRE_PENSION_ET_RENTE_IMPOSABLE',
  AutreReductionImpots = 'AUTRE_REDUCTION_IMPOTS',
  AutreRevenu = 'AUTRE_REVENU',
  BicBa = 'BIC_BA',
  BicNonPro = 'BIC_NON_PRO',
  BicPro = 'BIC_PRO',
  BncNonPro = 'BNC_NON_PRO',
  BncPro = 'BNC_PRO',
  CotisationsSyndicales = 'COTISATIONS_SYNDICALES',
  DepenseAccessoire = 'DEPENSE_ACCESSOIRE',
  DepenseEssentielle = 'DEPENSE_ESSENTIELLE',
  Dividende = 'DIVIDENDE',
  DonAideAuxPersonnesEnDifficulte = 'DON_AIDE_AUX_PERSONNES_EN_DIFFICULTE',
  DonAssociationUtilisePubliqueOuInteretGeneral = 'DON_ASSOCIATION_UTILISE_PUBLIQUE_OU_INTERET_GENERAL',
  DonEtCotisationVerseeAuxPartisPolitiques = 'DON_ET_COTISATION_VERSEE_AUX_PARTIS_POLITIQUES',
  EmploiSalarieADomicile = 'EMPLOI_SALARIE_A_DOMICILE',
  FraisDeGarde = 'FRAIS_DE_GARDE',
  Loyer = 'LOYER',
  MensualiteCredit = 'MENSUALITE_CREDIT',
  PensionAlimentaire = 'PENSION_ALIMENTAIRE',
  PensionEtRenteViagereExoneree = 'PENSION_ET_RENTE_VIAGERE_EXONEREE',
  RenteInvalidite = 'RENTE_INVALIDITE',
  RenteViagereATitreOnereux = 'RENTE_VIAGERE_A_TITRE_ONEREUX',
  Retraite = 'RETRAITE',
  RevenuEpargne = 'REVENU_EPARGNE',
  RevenuFoncier = 'REVENU_FONCIER',
  RevenuFoncierOuBic = 'REVENU_FONCIER_OU_BIC',
  RevenuProfessionnel = 'REVENU_PROFESSIONNEL',
  Salaires = 'SALAIRES',
  TaxeFonciere = 'TAXE_FONCIERE',
  TaxeHabitation = 'TAXE_HABITATION'
}

export enum SousCategorieBudgetEnum {
  Activites = 'ACTIVITES',
  ChargesFixes = 'CHARGES_FIXES',
  DepensesCourantes = 'DEPENSES_COURANTES',
  Epargne = 'EPARGNE',
  Immobilier = 'IMMOBILIER',
  Impots = 'IMPOTS',
  PensionsRentes = 'PENSIONS_RENTES',
  Professionnel = 'PROFESSIONNEL'
}

export type SousCategorieBudgetEnumOperationFilterInput = {
  eq?: InputMaybe<SousCategorieBudgetEnum>;
  in?: InputMaybe<Array<SousCategorieBudgetEnum>>;
  neq?: InputMaybe<SousCategorieBudgetEnum>;
  nin?: InputMaybe<Array<SousCategorieBudgetEnum>>;
};

export type SouscriptionCreationInput = {
  enveloppeId: Scalars['Byte']['input'];
  investisseurIds: Array<Scalars['Long']['input']>;
  projetId: Scalars['Long']['input'];
  versement?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum SouscriptionSignatureMode {
  ExtranetPartenaire = 'EXTRANET_PARTENAIRE',
  Manuscrite = 'MANUSCRITE'
}

export enum SouscriptionTransmissionOriginaux {
  EnvoiPostal = 'ENVOI_POSTAL',
  SansEnvoiPostal = 'SANS_ENVOI_POSTAL'
}

export type StatutCommercial = {
  __typename?: 'StatutCommercial';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantStatutCommercial: Array<ConsultantStatutCommercial>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type StatutCommercialConsultantStatutCommercialArgs = {
  where?: InputMaybe<ConsultantStatutCommercialFilterInput>;
};

export type StatutCommercialFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<StatutCommercialFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantStatutCommercial?: InputMaybe<ListFilterInputTypeOfConsultantStatutCommercialFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StatutCommercialFilterInput>>;
};

export type StatutConsultant = {
  __typename?: 'StatutConsultant';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultant: Array<Consultant>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type StatutConsultantConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};

export type StatutConsultantFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<StatutConsultantFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StatutConsultantFilterInput>>;
};

export type StatutConsultantSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type StatutDistinction = {
  __typename?: 'StatutDistinction';
  code: Scalars['Byte']['output'];
  consultantDistinction: Array<ConsultantDistinction>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type StatutDistinctionConsultantDistinctionArgs = {
  where?: InputMaybe<ConsultantDistinctionFilterInput>;
};

export type StatutDistinctionFilterInput = {
  and?: InputMaybe<Array<StatutDistinctionFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  consultantDistinction?: InputMaybe<ListFilterInputTypeOfConsultantDistinctionFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StatutDistinctionFilterInput>>;
};

export type StatutJuridique = {
  __typename?: 'StatutJuridique';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantStatutJuridique: Array<ConsultantStatutJuridique>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type StatutJuridiqueConsultantStatutJuridiqueArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};

export type StatutJuridiqueFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<StatutJuridiqueFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantStatutJuridique?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StatutJuridiqueFilterInput>>;
};

export type StorageFile = {
  __typename?: 'StorageFile';
  /** Optionnal code of consultant owning this file. If empty this file is available for everyone. */
  consultantCode?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  denomination?: Maybe<Scalars['String']['output']>;
  documentType: DocumentTypeEnum;
  fileConnectionInfo?: Maybe<StorageFileConnectionInfo>;
  /** Extension of the file without dot (for example 'pdf' for a .pdf file). */
  fileExtension: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileNameWithExtension?: Maybe<Scalars['String']['output']>;
  /** parseable MIME type of the file (for example 'application/pdf' for a PDF file) see https://mimesniff.spec.whatwg.org/#parsable-mime-type. */
  fileType: Scalars['String']['output'];
  /** Unique identifier of the file in the storage system. This is the same as the blob storage file id. */
  id: Scalars['String']['output'];
  /** True if the file is saved in blob storage, false if it is saved in FileShare container. */
  isBlob: Scalars['Boolean']['output'];
  /** True if the file is temporary. Temporary files are automatically deleted after 1 day. */
  isTemporary?: Maybe<Scalars['Boolean']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Optionnal code of personne physique owning this file. */
  personnePhysiqueCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FileStorageStatus>;
};

export type StorageFileConnectionInfo = {
  __typename?: 'StorageFileConnectionInfo';
  blobFileId: Scalars['String']['output'];
  /** Expiration date of the SAS URL. After this date, the SAS URL will no longer be valid. */
  expiration: Scalars['DateTime']['output'];
  /** List of permissions granted to the SAS URL. */
  permissions: Array<BlobFilesPermissionDs>;
  /** SAS URL to access the file in blob storage. This URL is valid until the Expiration date. */
  sasUrl: Scalars['String']['output'];
};


export type StorageFileConnectionInfoPermissionsArgs = {
  where?: InputMaybe<BlobFilesPermissionDsOperationFilterInput>;
};

export type StorageFileFilterInput = {
  and?: InputMaybe<Array<StorageFileFilterInput>>;
  /** Optionnal code of consultant owning this file. If empty this file is available for everyone. */
  consultantCode?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  denomination?: InputMaybe<StringOperationFilterInput>;
  documentType?: InputMaybe<DocumentTypeEnumOperationFilterInput>;
  /** Extension of the file without dot (for example 'pdf' for a .pdf file). */
  fileExtension?: InputMaybe<StringOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  /** parseable MIME type of the file (for example 'application/pdf' for a PDF file) see https://mimesniff.spec.whatwg.org/#parsable-mime-type. */
  fileType?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier of the file in the storage system. This is the same as the blob storage file id. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** True if the file is saved in blob storage, false if it is saved in FileShare container. */
  isBlob?: InputMaybe<BooleanOperationFilterInput>;
  /** True if the file is temporary. Temporary files are automatically deleted after 1 day. */
  isTemporary?: InputMaybe<BooleanOperationFilterInput>;
  lastModificationDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<StorageFileFilterInput>>;
  /** Optionnal code of personne physique owning this file. */
  personnePhysiqueCode?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<NullableOfFileStorageStatusOperationFilterInput>;
};

export type StorageFileSortInput = {
  /** Optionnal code of consultant owning this file. If empty this file is available for everyone. */
  consultantCode?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  denomination?: InputMaybe<SortEnumType>;
  documentType?: InputMaybe<SortEnumType>;
  /** Extension of the file without dot (for example 'pdf' for a .pdf file). */
  fileExtension?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  /** parseable MIME type of the file (for example 'application/pdf' for a PDF file) see https://mimesniff.spec.whatwg.org/#parsable-mime-type. */
  fileType?: InputMaybe<SortEnumType>;
  /** Unique identifier of the file in the storage system. This is the same as the blob storage file id. */
  id?: InputMaybe<SortEnumType>;
  /** True if the file is saved in blob storage, false if it is saved in FileShare container. */
  isBlob?: InputMaybe<SortEnumType>;
  /** True if the file is temporary. Temporary files are automatically deleted after 1 day. */
  isTemporary?: InputMaybe<SortEnumType>;
  lastModificationDate?: InputMaybe<SortEnumType>;
  /** Optionnal code of personne physique owning this file. */
  personnePhysiqueCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type StorageFileWithConnectionInfo = {
  __typename?: 'StorageFileWithConnectionInfo';
  connectionInfo?: Maybe<StorageFileConnectionInfo>;
  /** Optionnal code of consultant owning this file. If empty this file is available for everyone. */
  consultantCode?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  denomination?: Maybe<Scalars['String']['output']>;
  documentType: DocumentTypeEnum;
  fileConnectionInfo?: Maybe<StorageFileConnectionInfo>;
  /** Extension of the file without dot (for example 'pdf' for a .pdf file). */
  fileExtension: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileNameWithExtension?: Maybe<Scalars['String']['output']>;
  /** parseable MIME type of the file (for example 'application/pdf' for a PDF file) see https://mimesniff.spec.whatwg.org/#parsable-mime-type. */
  fileType: Scalars['String']['output'];
  /** Unique identifier of the file in the storage system. This is the same as the blob storage file id. */
  id: Scalars['String']['output'];
  /** True if the file is saved in blob storage, false if it is saved in FileShare container. */
  isBlob: Scalars['Boolean']['output'];
  /** True if the file is temporary. Temporary files are automatically deleted after 1 day. */
  isTemporary?: Maybe<Scalars['Boolean']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Optionnal code of personne physique owning this file. */
  personnePhysiqueCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FileStorageStatus>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum SubCategory2Enum {
  AutresFinancier = 'AUTRES_FINANCIER',
  AutreCredit = 'AUTRE_CREDIT',
  Avance = 'AVANCE',
  CreditConso = 'CREDIT_CONSO',
  CreditImmo = 'CREDIT_IMMO',
  Dettes = 'DETTES',
  Diversification = 'DIVERSIFICATION',
  EpargneBancaire = 'EPARGNE_BANCAIRE',
  EpargneFinanciere = 'EPARGNE_FINANCIERE',
  EpargneImmobiliere = 'EPARGNE_IMMOBILIERE',
  EpargneRetraite = 'EPARGNE_RETRAITE',
  Foncier = 'FONCIER',
  ImmoJouissance = 'IMMO_JOUISSANCE',
  ImmoLocatif = 'IMMO_LOCATIF'
}

export enum SubCategoryEnum {
  AutresBiensMeubles = 'AUTRES_BIENS_MEUBLES',
  AutresPassif = 'AUTRES_PASSIF',
  BiensProfessionnels = 'BIENS_PROFESSIONNELS',
  Credits = 'CREDITS',
  Financier = 'FINANCIER',
  Immobilier = 'IMMOBILIER'
}

export type SupportConsultantFilterInput = {
  classesActif?: InputMaybe<Array<Scalars['String']['input']>>;
  encoursMax?: InputMaybe<Scalars['Decimal']['input']>;
  encoursMin?: InputMaybe<Scalars['Decimal']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  societesGestion?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SupportConsultantOrderInput = {
  descending: Scalars['Boolean']['input'];
  field?: InputMaybe<SupportOrderField>;
};

/** Supports et solutions d'investissement du questionnaire Connaissance et expérience (Q9 à Q16) */
export enum SupportInvestissementEnum {
  Fcpr = 'FCPR',
  FondsActions = 'FONDS_ACTIONS',
  FondsEuros = 'FONDS_EUROS',
  FondsImmobiliers = 'FONDS_IMMOBILIERS',
  FondsMonetaires = 'FONDS_MONETAIRES',
  FondsObligataires = 'FONDS_OBLIGATAIRES',
  StructuresCapitalGaranti = 'STRUCTURES_CAPITAL_GARANTI',
  StructuresCapitalProtege = 'STRUCTURES_CAPITAL_PROTEGE'
}

export type SupportInvestissementEnumOperationFilterInput = {
  eq?: InputMaybe<SupportInvestissementEnum>;
  in?: InputMaybe<Array<SupportInvestissementEnum>>;
  neq?: InputMaybe<SupportInvestissementEnum>;
  nin?: InputMaybe<Array<SupportInvestissementEnum>>;
};

/** Réponse saisie pour une ligne du tableau des supports et solutions d'investissement */
export type SupportInvestissementInput = {
  detention?: InputMaybe<DetentionProduitEnum>;
  support: SupportInvestissementEnum;
  /** Code de la réponse à la question de vérification (R1 à R4) */
  verification?: InputMaybe<Scalars['String']['input']>;
};

/** Ligne du tableau des supports et solutions d'investissement */
export type SupportInvestissementReferentielDto = {
  __typename?: 'SupportInvestissementReferentielDto';
  libelle: Scalars['String']['output'];
  /** Options de la question de vérification dans leur ordre d'affichage */
  optionsVerification: Array<OptionVerificationDto>;
  /** Code de la question dans la matrice (Q9 à Q16) */
  question: Scalars['String']['output'];
  support: SupportInvestissementEnum;
};


/** Ligne du tableau des supports et solutions d'investissement */
export type SupportInvestissementReferentielDtoOptionsVerificationArgs = {
  where?: InputMaybe<OptionVerificationDtoFilterInput>;
};

/** Ligne du tableau des supports et solutions d'investissement */
export type SupportInvestissementReferentielDtoFilterInput = {
  and?: InputMaybe<Array<SupportInvestissementReferentielDtoFilterInput>>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  /** Options de la question de vérification dans leur ordre d'affichage */
  optionsVerification?: InputMaybe<ListFilterInputTypeOfOptionVerificationDtoFilterInput>;
  or?: InputMaybe<Array<SupportInvestissementReferentielDtoFilterInput>>;
  /** Code de la question dans la matrice (Q9 à Q16) */
  question?: InputMaybe<StringOperationFilterInput>;
  support?: InputMaybe<SupportInvestissementEnumOperationFilterInput>;
};

/** Réponse à une ligne du tableau des supports et solutions d'investissement */
export type SupportInvestissementReponse = {
  __typename?: 'SupportInvestissementReponse';
  detention?: Maybe<DetentionProduitEnum>;
  /** Code de la question dans la matrice (Q9 à Q16) */
  question: Scalars['String']['output'];
  support: SupportInvestissementEnum;
  verification?: Maybe<VerificationReponse>;
};

/** Réponse à une ligne du tableau des supports et solutions d'investissement */
export type SupportInvestissementReponseFilterInput = {
  and?: InputMaybe<Array<SupportInvestissementReponseFilterInput>>;
  detention?: InputMaybe<NullableOfDetentionProduitEnumOperationFilterInput>;
  or?: InputMaybe<Array<SupportInvestissementReponseFilterInput>>;
  /** Code de la question dans la matrice (Q9 à Q16) */
  question?: InputMaybe<StringOperationFilterInput>;
  support?: InputMaybe<SupportInvestissementEnumOperationFilterInput>;
  verification?: InputMaybe<VerificationReponseFilterInput>;
};

export enum SupportOrderField {
  Categorie = 'CATEGORIE',
  ClasseActif = 'CLASSE_ACTIF',
  DateCotation = 'DATE_COTATION',
  EnCours = 'EN_COURS',
  Esg = 'ESG',
  NbContrats = 'NB_CONTRATS',
  Poids = 'POIDS',
  Sri = 'SRI',
  Valeur = 'VALEUR'
}

/** A segment of a collection. */
export type SupportsBackOfficeCollectionSegment = {
  __typename?: 'SupportsBackOfficeCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ConsultantRepartitionSupport>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type SupportsClassesActif = {
  __typename?: 'SupportsClassesActif';
  categorieQuantalys?: Maybe<Scalars['String']['output']>;
  classeActif?: Maybe<Scalars['String']['output']>;
  codeIsin: Scalars['String']['output'];
  esg?: Maybe<Scalars['String']['output']>;
  estFondEuro?: Maybe<Scalars['Boolean']['output']>;
  libelleSupport?: Maybe<Scalars['String']['output']>;
  societeGestion?: Maybe<Scalars['String']['output']>;
  sousClasseActif?: Maybe<Scalars['String']['output']>;
  sri?: Maybe<Scalars['Int']['output']>;
};

export type SupportsClassesActifFilterInput = {
  and?: InputMaybe<Array<SupportsClassesActifFilterInput>>;
  categorieQuantalys?: InputMaybe<StringOperationFilterInput>;
  classeActif?: InputMaybe<StringOperationFilterInput>;
  codeIsin?: InputMaybe<StringOperationFilterInput>;
  esg?: InputMaybe<StringOperationFilterInput>;
  estFondEuro?: InputMaybe<BooleanOperationFilterInput>;
  libelleSupport?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SupportsClassesActifFilterInput>>;
  societeGestion?: InputMaybe<StringOperationFilterInput>;
  sousClasseActif?: InputMaybe<StringOperationFilterInput>;
  sri?: InputMaybe<IntOperationFilterInput>;
};

export type SupportsClassesActifSortInput = {
  categorieQuantalys?: InputMaybe<SortEnumType>;
  classeActif?: InputMaybe<SortEnumType>;
  codeIsin?: InputMaybe<SortEnumType>;
  esg?: InputMaybe<SortEnumType>;
  estFondEuro?: InputMaybe<SortEnumType>;
  libelleSupport?: InputMaybe<SortEnumType>;
  societeGestion?: InputMaybe<SortEnumType>;
  sousClasseActif?: InputMaybe<SortEnumType>;
  sri?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type SupportsConsultantCollectionSegment = {
  __typename?: 'SupportsConsultantCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ConsultantRepartitionSupport>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type SupportsGen = {
  __typename?: 'SupportsGen';
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  idSupportInfoGen: Scalars['String']['output'];
  isin?: Maybe<Scalars['String']['output']>;
  supportsClassesActif?: Maybe<SupportsClassesActif>;
};

export type SupportsGenFilterInput = {
  and?: InputMaybe<Array<SupportsGenFilterInput>>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  idSupportInfoGen?: InputMaybe<StringOperationFilterInput>;
  isin?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SupportsGenFilterInput>>;
  supportsClassesActif?: InputMaybe<SupportsClassesActifFilterInput>;
};

export type SyntheseEpargne = {
  __typename?: 'SyntheseEpargne';
  /** Somme des valeurs estimées de l'épargne bancaire et de l'épargne financière */
  disponible: Scalars['Decimal']['output'];
  /** Somme de la valeur estimée de l'épargne bancaire  et de l'épargne sécurisé de l'épargne financière */
  disponibleDePrecaution: Scalars['Decimal']['output'];
  /** Somme des valeurs estimées de l'épargne */
  epargneTotale: Scalars['Decimal']['output'];
  /** Somme des valeurs estimées  de l'épargne retraite et salariale, de l'épargne de diversification, et des autres épargnes */
  nonDisponible: Scalars['Decimal']['output'];
};

export type TauxRemunerationConsultant = {
  __typename?: 'TauxRemunerationConsultant';
  actif?: Maybe<Scalars['Boolean']['output']>;
  consultantOrganisation: Array<ConsultantOrganisation>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  libelle: Scalars['String']['output'];
};


export type TauxRemunerationConsultantConsultantOrganisationArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};

export type TauxRemunerationConsultantFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TauxRemunerationConsultantFilterInput>>;
  consultantOrganisation?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TauxRemunerationConsultantFilterInput>>;
};

export type TauxRemunerationConsultantSortInput = {
  actif?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type Telephone = {
  __typename?: 'Telephone';
  arianeId?: Maybe<Scalars['Long']['output']>;
  consultant: Array<Consultant>;
  contact: Array<Contact>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  estNumeroCorrespondance?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  numero: Scalars['String']['output'];
  personneMoraleTelephone: Array<PersonneMoraleTelephone>;
  personnePhysique: Array<PersonnePhysique>;
  prefixe?: Maybe<Scalars['String']['output']>;
  typeTelephoneCode: Scalars['String']['output'];
  typeTelephoneCodeNavigation: TypeTelephone;
};


export type TelephoneConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type TelephoneContactArgs = {
  where?: InputMaybe<ContactFilterInput>;
};


export type TelephonePersonneMoraleTelephoneArgs = {
  where?: InputMaybe<PersonneMoraleTelephoneFilterInput>;
};


export type TelephonePersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type TelephoneFilterInput = {
  and?: InputMaybe<Array<TelephoneFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  contact?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  estNumeroCorrespondance?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<NoteFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  numero?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TelephoneFilterInput>>;
  personneMoraleTelephone?: InputMaybe<ListFilterInputTypeOfPersonneMoraleTelephoneFilterInput>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  prefixe?: InputMaybe<StringOperationFilterInput>;
  typeTelephoneCode?: InputMaybe<StringOperationFilterInput>;
  typeTelephoneCodeNavigation?: InputMaybe<TypeTelephoneFilterInput>;
};

export type TelephoneInput = {
  numero: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
};

export type TelephonePersonneInput = {
  estNumeroCorrespondance?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  numero: Scalars['String']['input'];
  typeTelephoneCode?: InputMaybe<Scalars['String']['input']>;
};

export enum TermeEnum {
  CourtTerme = 'COURT_TERME',
  LongTerme = 'LONG_TERME',
  MoyenTerme = 'MOYEN_TERME',
  TresCourtTerme = 'TRES_COURT_TERME',
  TresLongTerme = 'TRES_LONG_TERME'
}

export type TermeEnumOperationFilterInput = {
  eq?: InputMaybe<TermeEnum>;
  in?: InputMaybe<Array<TermeEnum>>;
  neq?: InputMaybe<TermeEnum>;
  nin?: InputMaybe<Array<TermeEnum>>;
};

export type Testament = {
  __typename?: 'Testament';
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
  testamentRedige?: Maybe<Scalars['Boolean']['output']>;
};

export type TestamentFilterInput = {
  and?: InputMaybe<Array<TestamentFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  note?: InputMaybe<NoteFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<TestamentFilterInput>>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  testamentRedige?: InputMaybe<BooleanOperationFilterInput>;
};

export type TestamentInput = {
  commentaire?: InputMaybe<Scalars['String']['input']>;
  testamentRedige: Scalars['Boolean']['input'];
};

export type TestamentSortInput = {
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  note?: InputMaybe<NoteSortInput>;
  noteId?: InputMaybe<SortEnumType>;
  personnePhysique?: InputMaybe<PersonnePhysiqueSortInput>;
  personnePhysiqueId?: InputMaybe<SortEnumType>;
  testamentRedige?: InputMaybe<SortEnumType>;
};

export type TitreConsultant = {
  __typename?: 'TitreConsultant';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultant: Array<Consultant>;
  consultantOrganisation: Array<ConsultantOrganisation>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type TitreConsultantConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type TitreConsultantConsultantOrganisationArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};

export type TitreConsultantFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TitreConsultantFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  consultantOrganisation?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TitreConsultantFilterInput>>;
};

export type TitreConsultantSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export enum ToleranceRisque {
  Dynamique = 'DYNAMIQUE',
  Equilibre = 'EQUILIBRE',
  Offensif = 'OFFENSIF',
  Prudent = 'PRUDENT',
  Securise = 'SECURISE'
}

/** Réponses saisies au questionnaire Tolérance au risque (version 2) */
export type ToleranceRisqueInput = {
  investisseurId: Scalars['Long']['input'];
  reponses: Array<ToleranceRisqueReponseInput>;
};

export type ToleranceRisqueOption = {
  __typename?: 'ToleranceRisqueOption';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: ToleranceRisque;
};

/** Référentiel du questionnaire Tolérance au risque v2 (sans barème) */
export type ToleranceRisqueReferentielDto = {
  __typename?: 'ToleranceRisqueReferentielDto';
  /** Intitulés de la question Q4 selon le profil maximal de Q1/Q2 (Q4 n'est pas posée pour le profil Sécurisé) */
  intitulesQ4: Array<IntituleParProfilDto>;
  /** Questions dans l'ordre d'affichage */
  questions: Array<QuestionToleranceDto>;
};


/** Référentiel du questionnaire Tolérance au risque v2 (sans barème) */
export type ToleranceRisqueReferentielDtoIntitulesQ4Args = {
  where?: InputMaybe<IntituleParProfilDtoFilterInput>;
};


/** Référentiel du questionnaire Tolérance au risque v2 (sans barème) */
export type ToleranceRisqueReferentielDtoQuestionsArgs = {
  where?: InputMaybe<QuestionToleranceDtoFilterInput>;
};

/** Réponse à une question du questionnaire Tolérance au risque */
export type ToleranceRisqueReponse = {
  __typename?: 'ToleranceRisqueReponse';
  /** Code de la question dans la matrice (Q1 à Q9) */
  question: Scalars['String']['output'];
  /** Code de la réponse dans la matrice (ex. Q1R3) */
  reponse: Scalars['String']['output'];
};

/** Réponse à une question du questionnaire Tolérance au risque */
export type ToleranceRisqueReponseFilterInput = {
  and?: InputMaybe<Array<ToleranceRisqueReponseFilterInput>>;
  or?: InputMaybe<Array<ToleranceRisqueReponseFilterInput>>;
  /** Code de la question dans la matrice (Q1 à Q9) */
  question?: InputMaybe<StringOperationFilterInput>;
  /** Code de la réponse dans la matrice (ex. Q1R3) */
  reponse?: InputMaybe<StringOperationFilterInput>;
};

/** Réponse saisie à une question du questionnaire Tolérance au risque */
export type ToleranceRisqueReponseInput = {
  /** Code de la question (Q1 à Q9) */
  question: Scalars['String']['input'];
  /** Code de la réponse (ex. Q1R3) */
  reponse?: InputMaybe<Scalars['String']['input']>;
};

/** Réponses au questionnaire Tolérance au risque (version 2) */
export type ToleranceRisqueReponses = {
  __typename?: 'ToleranceRisqueReponses';
  /** Faux si les réponses aux questions Q1 et Q2 sont incohérentes (« aucun risque » sur l'une seulement, ou au moins deux niveaux de profil d'écart) : le calcul est alors bloqué */
  isCoherent: Scalars['Boolean']['output'];
  /** Indique que toutes les questions affichées ont une réponse et que les réponses sont cohérentes */
  isComplete: Scalars['Boolean']['output'];
  /** Niveau de tolérance au risque (1 = Sécurisé, 2 = Prudent, 3 = Équilibré, 4 = Dynamique, 5 = Offensif), null tant que le questionnaire est incomplet ou incohérent */
  niveau?: Maybe<Scalars['Int']['output']>;
  /** Réponses aux questions affichées, dans l'ordre du questionnaire */
  reponses: Array<ToleranceRisqueReponse>;
  /** Score total du questionnaire (de -90 à 117) */
  totalPoints: Scalars['Int']['output'];
};


/** Réponses au questionnaire Tolérance au risque (version 2) */
export type ToleranceRisqueReponsesReponsesArgs = {
  where?: InputMaybe<ToleranceRisqueReponseFilterInput>;
};

/** Réponses au questionnaire Tolérance au risque (version 2) */
export type ToleranceRisqueReponsesFilterInput = {
  and?: InputMaybe<Array<ToleranceRisqueReponsesFilterInput>>;
  /** Faux si les réponses aux questions Q1 et Q2 sont incohérentes (« aucun risque » sur l'une seulement, ou au moins deux niveaux de profil d'écart) : le calcul est alors bloqué */
  isCoherent?: InputMaybe<BooleanOperationFilterInput>;
  /** Indique que toutes les questions affichées ont une réponse et que les réponses sont cohérentes */
  isComplete?: InputMaybe<BooleanOperationFilterInput>;
  /** Niveau de tolérance au risque (1 = Sécurisé, 2 = Prudent, 3 = Équilibré, 4 = Dynamique, 5 = Offensif), null tant que le questionnaire est incomplet ou incohérent */
  niveau?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ToleranceRisqueReponsesFilterInput>>;
  /** Réponses aux questions affichées, dans l'ordre du questionnaire */
  reponses?: InputMaybe<ListFilterInputTypeOfToleranceRisqueReponseFilterInput>;
  /** Score total du questionnaire (de -90 à 117) */
  totalPoints?: InputMaybe<IntOperationFilterInput>;
};

/** Réponses au questionnaire Tolérance au risque (version 2) */
export type ToleranceRisqueReponsesSortInput = {
  /** Faux si les réponses aux questions Q1 et Q2 sont incohérentes (« aucun risque » sur l'une seulement, ou au moins deux niveaux de profil d'écart) : le calcul est alors bloqué */
  isCoherent?: InputMaybe<SortEnumType>;
  /** Indique que toutes les questions affichées ont une réponse et que les réponses sont cohérentes */
  isComplete?: InputMaybe<SortEnumType>;
  /** Niveau de tolérance au risque (1 = Sécurisé, 2 = Prudent, 3 = Équilibré, 4 = Dynamique, 5 = Offensif), null tant que le questionnaire est incomplet ou incohérent */
  niveau?: InputMaybe<SortEnumType>;
  /** Score total du questionnaire (de -90 à 117) */
  totalPoints?: InputMaybe<SortEnumType>;
};

export enum TransactionPersonnelleEnum {
  AutoSouscription = 'AUTO_SOUSCRIPTION',
  AutoSouscriptionAvecProches = 'AUTO_SOUSCRIPTION_AVEC_PROCHES',
  Non = 'NON',
  PourProches = 'POUR_PROCHES',
  PourSalaries = 'POUR_SALARIES'
}

export type TransfertClient = {
  __typename?: 'TransfertClient';
  consultantBeneficiaireCode: Scalars['String']['output'];
  consultantSourceCode: Scalars['String']['output'];
  dateDemande: Scalars['DateTime']['output'];
  detailsErreur?: Maybe<Scalars['String']['output']>;
  etatTransfertCode: Scalars['String']['output'];
  etatTransfertCodeNavigation: EtatTransfertClient;
  id: Scalars['Long']['output'];
  investisseurCode: Scalars['String']['output'];
  typeTransfertCode: Scalars['String']['output'];
  typeTransfertCodeNavigation: TypeTransfertClient;
};

export type TransfertClientDataInput = {
  consultantBeneficiaireCode: Scalars['String']['input'];
  consultantSourceCode: Scalars['String']['input'];
  investisseurCode?: InputMaybe<Scalars['String']['input']>;
  isResiliation: Scalars['Boolean']['input'];
};

export type TransfertClientFilterInput = {
  and?: InputMaybe<Array<TransfertClientFilterInput>>;
  consultantBeneficiaireCode?: InputMaybe<StringOperationFilterInput>;
  consultantSourceCode?: InputMaybe<StringOperationFilterInput>;
  dateDemande?: InputMaybe<DateTimeOperationFilterInput>;
  detailsErreur?: InputMaybe<StringOperationFilterInput>;
  etatTransfertCode?: InputMaybe<StringOperationFilterInput>;
  etatTransfertCodeNavigation?: InputMaybe<EtatTransfertClientFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseurCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TransfertClientFilterInput>>;
  typeTransfertCode?: InputMaybe<StringOperationFilterInput>;
  typeTransfertCodeNavigation?: InputMaybe<TypeTransfertClientFilterInput>;
};

export type TransfertClientSortInput = {
  consultantBeneficiaireCode?: InputMaybe<SortEnumType>;
  consultantSourceCode?: InputMaybe<SortEnumType>;
  dateDemande?: InputMaybe<SortEnumType>;
  detailsErreur?: InputMaybe<SortEnumType>;
  etatTransfertCode?: InputMaybe<SortEnumType>;
  etatTransfertCodeNavigation?: InputMaybe<EtatTransfertClientSortInput>;
  id?: InputMaybe<SortEnumType>;
  investisseurCode?: InputMaybe<SortEnumType>;
  typeTransfertCode?: InputMaybe<SortEnumType>;
  typeTransfertCodeNavigation?: InputMaybe<TypeTransfertClientSortInput>;
};

export type Type2Produit = {
  __typename?: 'Type2Produit';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  enveloppeProduit: Array<EnveloppeProduit>;
  gamme: Scalars['Byte']['output'];
  gammeNavigation: GammeProduit;
  libelle: Scalars['String']['output'];
};

export type Type2ProduitFilterInput = {
  and?: InputMaybe<Array<Type2ProduitFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  enveloppeProduit?: InputMaybe<ListFilterInputTypeOfEnveloppeProduitFilterInput>;
  gamme?: InputMaybe<ByteOperationFilterInput>;
  gammeNavigation?: InputMaybe<GammeProduitFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Type2ProduitFilterInput>>;
};

export type Type2ProduitSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  gamme?: InputMaybe<SortEnumType>;
  gammeNavigation?: InputMaybe<GammeProduitSortInput>;
  libelle?: InputMaybe<SortEnumType>;
};

export enum TypeActifEnum {
  Article39 = 'ARTICLE39',
  Article82 = 'ARTICLE82',
  Article83 = 'ARTICLE83',
  AssuranceVie = 'ASSURANCE_VIE',
  AssuranceVieApbDifferee = 'ASSURANCE_VIE_APB_DIFFEREE',
  AutresTitresNonCotes = 'AUTRES_TITRES_NON_COTES',
  AutreEpargne = 'AUTRE_EPARGNE',
  AutreFoncierNonBati = 'AUTRE_FONCIER_NON_BATI',
  AutreLiquidite = 'AUTRE_LIQUIDITE',
  AutrePlacement = 'AUTRE_PLACEMENT',
  AutreValeurMobilier = 'AUTRE_VALEUR_MOBILIER',
  Besson = 'BESSON',
  BienImmobilier = 'BIEN_IMMOBILIER',
  BienRuralBailALongTerme = 'BIEN_RURAL_BAIL_A_LONG_TERME',
  Bijoux = 'BIJOUX',
  BoisEtPartsDeGff = 'BOIS_ET_PARTS_DE_GFF',
  Borloo = 'BORLOO',
  CapitalRisque = 'CAPITAL_RISQUE',
  Cat = 'CAT',
  Cel = 'CEL',
  Classique = 'CLASSIQUE',
  ClienteleCivile = 'CLIENTELE_CIVILE',
  CompteCourant = 'COMPTE_COURANT',
  CompteTitresCto = 'COMPTE_TITRES_CTO',
  ContratDeCapitalisation = 'CONTRAT_DE_CAPITALISATION',
  ContratTontinier = 'CONTRAT_TONTINIER',
  Cpti = 'CPTI',
  Creance = 'CREANCE',
  DemembrementTemporaire = 'DEMEMBREMENT_TEMPORAIRE',
  Duflot = 'DUFLOT',
  Eip = 'EIP',
  Elt = 'ELT',
  EpargnePension = 'EPARGNE_PENSION',
  Fcpi = 'FCPI',
  Fcpr = 'FCPR',
  Fip = 'FIP',
  FipCorse = 'FIP_CORSE',
  FipOutreMer = 'FIP_OUTRE_MER',
  FondsDeCommerce = 'FONDS_DE_COMMERCE',
  Girardin = 'GIRARDIN',
  Holding = 'HOLDING',
  Inami = 'INAMI',
  Ldd = 'LDD',
  Lep = 'LEP',
  LivretA = 'LIVRET_A',
  LivretBleu = 'LIVRET_BLEU',
  LivretClassique = 'LIVRET_CLASSIQUE',
  LivretJeune = 'LIVRET_JEUNE',
  LmnpCensi = 'LMNP_CENSI',
  LmnpClassique = 'LMNP_CLASSIQUE',
  Lmp = 'LMP',
  LoiJego = 'LOI_JEGO',
  Madelin = 'MADELIN',
  Malraux = 'MALRAUX',
  MaterielProfessionnel = 'MATERIEL_PROFESSIONNEL',
  MetauxPrecieux = 'METAUX_PRECIEUX',
  Meuble = 'MEUBLE',
  MonumentHistorique = 'MONUMENT_HISTORIQUE',
  ObjetDArtAntiquiteCollection = 'OBJET_D_ART_ANTIQUITE_COLLECTION',
  Opci = 'OPCI',
  Participation = 'PARTICIPATION',
  PartsDeGfa = 'PARTS_DE_GFA',
  PartsDeSociete = 'PARTS_DE_SOCIETE',
  PartsGfv = 'PARTS_GFV',
  Pea = 'PEA',
  Peapme = 'PEAPME',
  Pee = 'PEE',
  Pel = 'PEL',
  PepAssuranceVie = 'PEP_ASSURANCE_VIE',
  PepBancaire = 'PEP_BANCAIRE',
  Per = 'PER',
  Perco = 'PERCO',
  Perissol = 'PERISSOL',
  Perp = 'PERP',
  Pinel = 'PINEL',
  Plci = 'PLCI',
  Pme = 'PME',
  Prefon = 'PREFON',
  RenteUniverselle = 'RENTE_UNIVERSELLE',
  ResidencePrincipale = 'RESIDENCE_PRINCIPALE',
  ResidenceSecondaire = 'RESIDENCE_SECONDAIRE',
  Robien = 'ROBIEN',
  Scellier = 'SCELLIER',
  Scpi = 'SCPI',
  ScIouSarlDeFamille = 'SC_IOU_SARL_DE_FAMILLE',
  SecteurTouristique = 'SECTEUR_TOURISTIQUE',
  Sofica = 'SOFICA',
  TerrainABatir = 'TERRAIN_A_BATIR',
  TerrainDAgrement = 'TERRAIN_D_AGREMENT',
  TerreAgricole = 'TERRE_AGRICOLE',
  Vehicules = 'VEHICULES',
  VehiculeProfessionnel = 'VEHICULE_PROFESSIONNEL'
}

export type TypeAdoption = {
  __typename?: 'TypeAdoption';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  relationFamille: Array<RelationFamille>;
};


export type TypeAdoptionRelationFamilleArgs = {
  where?: InputMaybe<RelationFamilleFilterInput>;
};

export type TypeAdoptionFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeAdoptionFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeAdoptionFilterInput>>;
  relationFamille?: InputMaybe<ListFilterInputTypeOfRelationFamilleFilterInput>;
};

export type TypeAdresse = {
  __typename?: 'TypeAdresse';
  actif?: Maybe<Scalars['Boolean']['output']>;
  adresse: Array<Adresse>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type TypeAdresseAdresseArgs = {
  where?: InputMaybe<AdresseFilterInput>;
};

export type TypeAdresseFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  adresse?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  and?: InputMaybe<Array<TypeAdresseFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeAdresseFilterInput>>;
};

export type TypeAvantageMatrimonial = {
  __typename?: 'TypeAvantageMatrimonial';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  etatCivil: Array<EtatCivil>;
  libelle: Scalars['String']['output'];
};


export type TypeAvantageMatrimonialEtatCivilArgs = {
  where?: InputMaybe<EtatCivilFilterInput>;
};

export type TypeAvantageMatrimonialFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeAvantageMatrimonialFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  etatCivil?: InputMaybe<ListFilterInputTypeOfEtatCivilFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeAvantageMatrimonialFilterInput>>;
};

export type TypeAvantageMatrimonialSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeBudget = {
  __typename?: 'TypeBudget';
  /** Revenu/Charge */
  categorie: CategorieBudgetEnum;
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** true si le type de budget est un revenu, false s'il s'agit d'une charge */
  isRevenu: Scalars['Boolean']['output'];
  sousCategorie: SousCategorieBudgetEnum;
  sousCategorie2?: Maybe<SousCategorie2BudgetEnum>;
};

export type TypeBudgetFilterInput = {
  and?: InputMaybe<Array<TypeBudgetFilterInput>>;
  /** Revenu/Charge */
  categorie?: InputMaybe<CategorieBudgetEnumOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  /** true si le type de budget est un revenu, false s'il s'agit d'une charge */
  isRevenu?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<TypeBudgetFilterInput>>;
  sousCategorie?: InputMaybe<SousCategorieBudgetEnumOperationFilterInput>;
  sousCategorie2?: InputMaybe<NullableOfSousCategorie2BudgetEnumOperationFilterInput>;
};

export type TypeBudgetSortInput = {
  /** Revenu/Charge */
  categorie?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** true si le type de budget est un revenu, false s'il s'agit d'une charge */
  isRevenu?: InputMaybe<SortEnumType>;
  sousCategorie?: InputMaybe<SortEnumType>;
  sousCategorie2?: InputMaybe<SortEnumType>;
};

export type TypeCategorieObjectifInvestisseur = {
  __typename?: 'TypeCategorieObjectifInvestisseur';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  typeObjectifInvestisseur: Array<TypeObjectifInvestisseur>;
};


export type TypeCategorieObjectifInvestisseurTypeObjectifInvestisseurArgs = {
  where?: InputMaybe<TypeObjectifInvestisseurFilterInput>;
};

export type TypeCategorieObjectifInvestisseurFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeCategorieObjectifInvestisseurFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeCategorieObjectifInvestisseurFilterInput>>;
  typeObjectifInvestisseur?: InputMaybe<ListFilterInputTypeOfTypeObjectifInvestisseurFilterInput>;
};

export type TypeCategorieObjectifInvestisseurSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeCommande = {
  __typename?: 'TypeCommande';
  code: Scalars['Byte']['output'];
  commande: Array<Commande>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};

export type TypeCommandeFilterInput = {
  and?: InputMaybe<Array<TypeCommandeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  commande?: InputMaybe<ListFilterInputTypeOfCommandeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeCommandeFilterInput>>;
};

export type TypeCommandeSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeConseillerCommande = {
  __typename?: 'TypeConseillerCommande';
  code: Scalars['Byte']['output'];
  conseillerCommande: Array<ConseillerCommande>;
  consultantMouvement: Array<ConsultantMouvement>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type TypeConseillerCommandeConseillerCommandeArgs = {
  where?: InputMaybe<ConseillerCommandeFilterInput>;
};


export type TypeConseillerCommandeConsultantMouvementArgs = {
  where?: InputMaybe<ConsultantMouvementFilterInput>;
};

export type TypeConseillerCommandeFilterInput = {
  and?: InputMaybe<Array<TypeConseillerCommandeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  conseillerCommande?: InputMaybe<ListFilterInputTypeOfConseillerCommandeFilterInput>;
  consultantMouvement?: InputMaybe<ListFilterInputTypeOfConsultantMouvementFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeConseillerCommandeFilterInput>>;
};

export type TypeContrat = {
  __typename?: 'TypeContrat';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantContrat: Array<ConsultantContrat>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type TypeContratConsultantContratArgs = {
  where?: InputMaybe<ConsultantContratFilterInput>;
};

export type TypeContratFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeContratFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantContrat?: InputMaybe<ListFilterInputTypeOfConsultantContratFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeContratFilterInput>>;
};

export type TypeCredit = {
  __typename?: 'TypeCredit';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  patrimoinePassif: Array<PatrimoinePassif>;
};


export type TypeCreditPatrimoinePassifArgs = {
  where?: InputMaybe<PatrimoinePassifFilterInput>;
};

export type TypeCreditFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeCreditFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeCreditFilterInput>>;
  patrimoinePassif?: InputMaybe<ListFilterInputTypeOfPatrimoinePassifFilterInput>;
};

export enum TypeDetenteurEnum {
  Investisseur = 'INVESTISSEUR',
  LaCommunaute = 'LA_COMMUNAUTE',
  Multiproprietaires = 'MULTIPROPRIETAIRES',
  RelationFamille = 'RELATION_FAMILLE'
}

export enum TypeDetentionEnum {
  NuePropriete = 'NUE_PROPRIETE',
  PleinePropriete = 'PLEINE_PROPRIETE',
  Usufruit = 'USUFRUIT'
}

export type TypeEdition = {
  __typename?: 'TypeEdition';
  actif: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  commune: Scalars['Boolean']['output'];
  dateMaj: Scalars['DateTime']['output'];
  domaine: Scalars['String']['output'];
  domaineNavigation: TypeEditionDomaine;
  edition: Array<Edition>;
  frequenceMaj?: Maybe<Scalars['Int']['output']>;
  libelle: Scalars['String']['output'];
  libelleFichier: Scalars['String']['output'];
  ordre?: Maybe<Scalars['Int']['output']>;
};


export type TypeEditionEditionArgs = {
  where?: InputMaybe<EditionFilterInput>;
};

export type TypeEditionDomaine = {
  __typename?: 'TypeEditionDomaine';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  typeEdition: Array<TypeEdition>;
};


export type TypeEditionDomaineTypeEditionArgs = {
  where?: InputMaybe<TypeEditionFilterInput>;
};

export type TypeEditionDomaineFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeEditionDomaineFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeEditionDomaineFilterInput>>;
  typeEdition?: InputMaybe<ListFilterInputTypeOfTypeEditionFilterInput>;
};

export type TypeEditionFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeEditionFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  commune?: InputMaybe<BooleanOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  domaine?: InputMaybe<StringOperationFilterInput>;
  domaineNavigation?: InputMaybe<TypeEditionDomaineFilterInput>;
  edition?: InputMaybe<ListFilterInputTypeOfEditionFilterInput>;
  frequenceMaj?: InputMaybe<IntOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  libelleFichier?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeEditionFilterInput>>;
  ordre?: InputMaybe<IntOperationFilterInput>;
};

export type TypeEmail = {
  __typename?: 'TypeEmail';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  email: Array<Email>;
  libelle: Scalars['String']['output'];
};


export type TypeEmailEmailArgs = {
  where?: InputMaybe<EmailFilterInput>;
};

export type TypeEmailFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeEmailFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<ListFilterInputTypeOfEmailFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeEmailFilterInput>>;
};

export type TypeFormeJuridique = {
  __typename?: 'TypeFormeJuridique';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  formeJuridique: Array<FormeJuridique>;
  libelle: Scalars['String']['output'];
};


export type TypeFormeJuridiqueFormeJuridiqueArgs = {
  where?: InputMaybe<FormeJuridiqueFilterInput>;
};

export type TypeFormeJuridiqueFilterInput = {
  and?: InputMaybe<Array<TypeFormeJuridiqueFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  formeJuridique?: InputMaybe<ListFilterInputTypeOfFormeJuridiqueFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeFormeJuridiqueFilterInput>>;
};

export enum TypeHabilitation {
  Alpsi = 'ALPSI',
  Assu = 'ASSU',
  Cif = 'CIF',
  Epa = 'EPA',
  Finan = 'FINAN',
  Immo = 'IMMO',
  Iob = 'IOB'
}

export type TypeHabilitationOperationFilterInput = {
  eq?: InputMaybe<TypeHabilitation>;
  in?: InputMaybe<Array<TypeHabilitation>>;
  neq?: InputMaybe<TypeHabilitation>;
  nin?: InputMaybe<Array<TypeHabilitation>>;
};

export type TypeInvestisseur = {
  __typename?: 'TypeInvestisseur';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Byte']['output'];
  libelle: Scalars['String']['output'];
  profilInvestisseur: Array<ProfilInvestisseur>;
};


export type TypeInvestisseurProfilInvestisseurArgs = {
  where?: InputMaybe<ProfilInvestisseurFilterInput>;
};

export type TypeInvestisseurFilterInput = {
  and?: InputMaybe<Array<TypeInvestisseurFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<ByteOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeInvestisseurFilterInput>>;
  profilInvestisseur?: InputMaybe<ListFilterInputTypeOfProfilInvestisseurFilterInput>;
};

export type TypeJustificationFormation = {
  __typename?: 'TypeJustificationFormation';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  equivalenceDeFormation: Array<EquivalenceDeFormation>;
  libelle: Scalars['String']['output'];
};


export type TypeJustificationFormationEquivalenceDeFormationArgs = {
  where?: InputMaybe<EquivalenceDeFormationFilterInput>;
};

export type TypeJustificationFormationFilterInput = {
  and?: InputMaybe<Array<TypeJustificationFormationFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  equivalenceDeFormation?: InputMaybe<ListFilterInputTypeOfEquivalenceDeFormationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeJustificationFormationFilterInput>>;
};

export enum TypeLocationEnum {
  LocationMeublees = 'LOCATION_MEUBLEES',
  LocationNues = 'LOCATION_NUES'
}

export type TypeMesureProtection = {
  __typename?: 'TypeMesureProtection';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  personnePhysique: Array<PersonnePhysique>;
};


export type TypeMesureProtectionPersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type TypeMesureProtectionFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeMesureProtectionFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeMesureProtectionFilterInput>>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
};

export type TypeMesureProtectionSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export enum TypeMissingFieldEnum {
  Prodemial = 'PRODEMIAL',
  Shm = 'SHM'
}

export type TypeMissingFieldEnumOperationFilterInput = {
  eq?: InputMaybe<TypeMissingFieldEnum>;
  in?: InputMaybe<Array<TypeMissingFieldEnum>>;
  neq?: InputMaybe<TypeMissingFieldEnum>;
  nin?: InputMaybe<Array<TypeMissingFieldEnum>>;
};

export type TypeMotifAnnulationMouvement = {
  __typename?: 'TypeMotifAnnulationMouvement';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  motifAnnulationCommande: Array<MotifAnnulationCommande>;
};


export type TypeMotifAnnulationMouvementMotifAnnulationCommandeArgs = {
  where?: InputMaybe<MotifAnnulationCommandeFilterInput>;
};

export type TypeMotifAnnulationMouvementFilterInput = {
  and?: InputMaybe<Array<TypeMotifAnnulationMouvementFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  motifAnnulationCommande?: InputMaybe<ListFilterInputTypeOfMotifAnnulationCommandeFilterInput>;
  or?: InputMaybe<Array<TypeMotifAnnulationMouvementFilterInput>>;
};

export type TypeMotifAnnulationMouvementSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeMotifCession = {
  __typename?: 'TypeMotifCession';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  motifCession: Array<MotifCession>;
};


export type TypeMotifCessionMotifCessionArgs = {
  where?: InputMaybe<MotifCessionFilterInput>;
};

export type TypeMotifCessionFilterInput = {
  and?: InputMaybe<Array<TypeMotifCessionFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  motifCession?: InputMaybe<ListFilterInputTypeOfMotifCessionFilterInput>;
  or?: InputMaybe<Array<TypeMotifCessionFilterInput>>;
};

export type TypeMotifCessionSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeObjectifInvestisseur = {
  __typename?: 'TypeObjectifInvestisseur';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  typeCategorieObjectifInvestisseurCode: Scalars['String']['output'];
  typeCategorieObjectifInvestisseurCodeNavigation: TypeCategorieObjectifInvestisseur;
};

export type TypeObjectifInvestisseurFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeObjectifInvestisseurFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  investisseurObjectif?: InputMaybe<ListFilterInputTypeOfInvestisseurObjectifFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeObjectifInvestisseurFilterInput>>;
  typeCategorieObjectifInvestisseurCode?: InputMaybe<StringOperationFilterInput>;
  typeCategorieObjectifInvestisseurCodeNavigation?: InputMaybe<TypeCategorieObjectifInvestisseurFilterInput>;
};

export type TypeObjectifInvestisseurSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  typeCategorieObjectifInvestisseurCode?: InputMaybe<SortEnumType>;
  typeCategorieObjectifInvestisseurCodeNavigation?: InputMaybe<TypeCategorieObjectifInvestisseurSortInput>;
};

export enum TypePassif {
  Amortissable = 'AMORTISSABLE',
  InFine = 'IN_FINE',
  ParPalier = 'PAR_PALIER',
  Simplifie = 'SIMPLIFIE'
}

export enum TypePersonne {
  PersonneMorale = 'PERSONNE_MORALE',
  PersonnePhysique = 'PERSONNE_PHYSIQUE'
}

export type TypePersonneOperationFilterInput = {
  eq?: InputMaybe<TypePersonne>;
  in?: InputMaybe<Array<TypePersonne>>;
  neq?: InputMaybe<TypePersonne>;
  nin?: InputMaybe<Array<TypePersonne>>;
};

export type TypePieceJointe = {
  __typename?: 'TypePieceJointe';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expirationCode: Scalars['String']['output'];
  expirationCodeNavigation: Expiration;
  libelle: Scalars['String']['output'];
  pieceJointeConsultant: Array<PieceJointeConsultant>;
  type: Scalars['Int']['output'];
};


export type TypePieceJointePieceJointeConsultantArgs = {
  where?: InputMaybe<PieceJointeConsultantFilterInput>;
};

export type TypePieceJointeFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypePieceJointeFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  expirationCode?: InputMaybe<StringOperationFilterInput>;
  expirationCodeNavigation?: InputMaybe<ExpirationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypePieceJointeFilterInput>>;
  pieceJointeConsultant?: InputMaybe<ListFilterInputTypeOfPieceJointeConsultantFilterInput>;
  type?: InputMaybe<IntOperationFilterInput>;
};

export type TypePpeMotif = {
  __typename?: 'TypePpeMotif';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  reglementaire: Array<Reglementaire>;
};


export type TypePpeMotifReglementaireArgs = {
  where?: InputMaybe<ReglementaireFilterInput>;
};

export type TypePpeMotifFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypePpeMotifFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypePpeMotifFilterInput>>;
  reglementaire?: InputMaybe<ListFilterInputTypeOfReglementaireFilterInput>;
};

export type TypePpeMotifSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypePpeRelation = {
  __typename?: 'TypePpeRelation';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  reglementaire: Array<Reglementaire>;
};


export type TypePpeRelationReglementaireArgs = {
  where?: InputMaybe<ReglementaireFilterInput>;
};

export type TypePpeRelationFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypePpeRelationFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypePpeRelationFilterInput>>;
  reglementaire?: InputMaybe<ListFilterInputTypeOfReglementaireFilterInput>;
};

export type TypePpeRelationSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export enum TypePrevoyance {
  Autre = 'AUTRE',
  CapitalDiffere = 'CAPITAL_DIFFERE',
  ContratDePrevoyanceIndividuel = 'CONTRAT_DE_PREVOYANCE_INDIVIDUEL',
  TemporaireDeces = 'TEMPORAIRE_DECES',
  VieEntiere = 'VIE_ENTIERE'
}

export type TypeProduit = {
  __typename?: 'TypeProduit';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate: Scalars['DateTime']['output'];
  libelle: Scalars['String']['output'];
  produit: Array<Produit>;
};


export type TypeProduitProduitArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type TypeProduitAgregation = {
  __typename?: 'TypeProduitAgregation';
  code: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  libelle?: Maybe<Scalars['String']['output']>;
};

export type TypeProduitAgregationFilterInput = {
  and?: InputMaybe<Array<TypeProduitAgregationFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeProduitAgregationFilterInput>>;
};

export type TypeProduitAgregationSortInput = {
  code?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeProduitSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeRcp = {
  __typename?: 'TypeRcp';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantRcp: Array<ConsultantRcp>;
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  habilitationRcp: Array<HabilitationRcp>;
  libelle?: Maybe<Scalars['String']['output']>;
};


export type TypeRcpConsultantRcpArgs = {
  where?: InputMaybe<ConsultantRcpFilterInput>;
};


export type TypeRcpHabilitationRcpArgs = {
  where?: InputMaybe<HabilitationRcpFilterInput>;
};

export enum TypeRcpCode {
  GarantieFinanciereImmobilier = 'GARANTIE_FINANCIERE_IMMOBILIER',
  RcpAssurance = 'RCP_ASSURANCE',
  RcpCif = 'RCP_CIF',
  RcpImmobilier = 'RCP_IMMOBILIER',
  RcpIob = 'RCP_IOB'
}

export type TypeRcpFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeRcpFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantRcp?: InputMaybe<ListFilterInputTypeOfConsultantRcpFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  habilitationRcp?: InputMaybe<ListFilterInputTypeOfHabilitationRcpFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeRcpFilterInput>>;
};

export enum TypeRegimeFiscalEnum {
  MicroFoncier = 'MICRO_FONCIER',
  Reel = 'REEL'
}

export type TypeRegimeSituationEtatCivil = {
  __typename?: 'TypeRegimeSituationEtatCivil';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  etatCivil: Array<EtatCivil>;
  libelle: Scalars['String']['output'];
  type: Scalars['String']['output'];
};


export type TypeRegimeSituationEtatCivilEtatCivilArgs = {
  where?: InputMaybe<EtatCivilFilterInput>;
};

export type TypeRegimeSituationEtatCivilFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeRegimeSituationEtatCivilFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  etatCivil?: InputMaybe<ListFilterInputTypeOfEtatCivilFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeRegimeSituationEtatCivilFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type TypeRegimeSituationEtatCivilSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type TypeRelationAutre = {
  __typename?: 'TypeRelationAutre';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  codeRev: Scalars['String']['output'];
  codeRevNavigation: TypeRelationAutre;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  inverseCodeRevNavigation: Array<TypeRelationAutre>;
  libelle: Scalars['String']['output'];
  natureRelationAutreCode: Scalars['String']['output'];
  natureRelationAutreCodeNavigation: NatureRelationAutre;
  relationAutreTypeRelationAutreCodeNavigation: Array<RelationAutre>;
  relationAutreTypeRelationAutreCodeRevNavigation: Array<RelationAutre>;
};


export type TypeRelationAutreInverseCodeRevNavigationArgs = {
  where?: InputMaybe<TypeRelationAutreFilterInput>;
};


export type TypeRelationAutreRelationAutreTypeRelationAutreCodeNavigationArgs = {
  where?: InputMaybe<RelationAutreFilterInput>;
};


export type TypeRelationAutreRelationAutreTypeRelationAutreCodeRevNavigationArgs = {
  where?: InputMaybe<RelationAutreFilterInput>;
};

export type TypeRelationAutreFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeRelationAutreFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  codeRev?: InputMaybe<StringOperationFilterInput>;
  codeRevNavigation?: InputMaybe<TypeRelationAutreFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  inverseCodeRevNavigation?: InputMaybe<ListFilterInputTypeOfTypeRelationAutreFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  natureRelationAutreCode?: InputMaybe<StringOperationFilterInput>;
  natureRelationAutreCodeNavigation?: InputMaybe<NatureRelationAutreFilterInput>;
  or?: InputMaybe<Array<TypeRelationAutreFilterInput>>;
  relationAutreTypeRelationAutreCodeNavigation?: InputMaybe<ListFilterInputTypeOfRelationAutreFilterInput>;
  relationAutreTypeRelationAutreCodeRevNavigation?: InputMaybe<ListFilterInputTypeOfRelationAutreFilterInput>;
};

export type TypeRelationAutreSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  codeRev?: InputMaybe<SortEnumType>;
  codeRevNavigation?: InputMaybe<TypeRelationAutreSortInput>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  natureRelationAutreCode?: InputMaybe<SortEnumType>;
  natureRelationAutreCodeNavigation?: InputMaybe<NatureRelationAutreSortInput>;
};

export type TypeRelationCouple = {
  __typename?: 'TypeRelationCouple';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  relationCouple: Array<RelationCouple>;
  relationCouples: Array<AtlasRelationCouple>;
};


export type TypeRelationCoupleRelationCoupleArgs = {
  where?: InputMaybe<RelationCoupleFilterInput>;
};


export type TypeRelationCoupleRelationCouplesArgs = {
  where?: InputMaybe<AtlasRelationCoupleFilterInput>;
};

export type TypeRelationCoupleFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeRelationCoupleFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeRelationCoupleFilterInput>>;
};

export type TypeRelationFamille = {
  __typename?: 'TypeRelationFamille';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  codeRev: Scalars['String']['output'];
  codeRevNavigation: TypeRelationFamille;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  inverseCodeRevNavigation: Array<TypeRelationFamille>;
  libelle: Scalars['String']['output'];
  relationEnfant: Scalars['Boolean']['output'];
  relationFamilleTypeRelationFamilleCodeNavigation: Array<RelationFamille>;
  relationFamilleTypeRelationFamilleCodeRevNavigation: Array<RelationFamille>;
};


export type TypeRelationFamilleInverseCodeRevNavigationArgs = {
  where?: InputMaybe<TypeRelationFamilleFilterInput>;
};


export type TypeRelationFamilleRelationFamilleTypeRelationFamilleCodeNavigationArgs = {
  where?: InputMaybe<RelationFamilleFilterInput>;
};


export type TypeRelationFamilleRelationFamilleTypeRelationFamilleCodeRevNavigationArgs = {
  where?: InputMaybe<RelationFamilleFilterInput>;
};

export type TypeRelationFamilleFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeRelationFamilleFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  codeRev?: InputMaybe<StringOperationFilterInput>;
  codeRevNavigation?: InputMaybe<TypeRelationFamilleFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  inverseCodeRevNavigation?: InputMaybe<ListFilterInputTypeOfTypeRelationFamilleFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeRelationFamilleFilterInput>>;
  relationEnfant?: InputMaybe<BooleanOperationFilterInput>;
  relationFamilleTypeRelationFamilleCodeNavigation?: InputMaybe<ListFilterInputTypeOfRelationFamilleFilterInput>;
  relationFamilleTypeRelationFamilleCodeRevNavigation?: InputMaybe<ListFilterInputTypeOfRelationFamilleFilterInput>;
};

export type TypeRelationInvestisseurConsultant = {
  __typename?: 'TypeRelationInvestisseurConsultant';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  investisseurConsultant: Array<InvestisseurConsultant>;
  libelle: Scalars['String']['output'];
};


export type TypeRelationInvestisseurConsultantInvestisseurConsultantArgs = {
  where?: InputMaybe<InvestisseurConsultantFilterInput>;
};

export type TypeRelationInvestisseurConsultantFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeRelationInvestisseurConsultantFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  investisseurConsultant?: InputMaybe<ListFilterInputTypeOfInvestisseurConsultantFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeRelationInvestisseurConsultantFilterInput>>;
};

export type TypeRelationInvestisseurConsultantSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export enum TypeScpiEnum {
  ScpiDenomandie = 'SCPI_DENOMANDIE',
  ScpiDeCapitalisation = 'SCPI_DE_CAPITALISATION',
  ScpiDeRendement = 'SCPI_DE_RENDEMENT',
  ScpiFiscaleAutres = 'SCPI_FISCALE_AUTRES',
  ScpiFiscaleDeficitFoncier = 'SCPI_FISCALE_DEFICIT_FONCIER',
  ScpiFiscaleMalraux = 'SCPI_FISCALE_MALRAUX',
  ScpiFiscaleMonumentsHistoriques = 'SCPI_FISCALE_MONUMENTS_HISTORIQUES',
  ScpiFiscalePinel = 'SCPI_FISCALE_PINEL'
}

export type TypeSituationEtatCivil = {
  __typename?: 'TypeSituationEtatCivil';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  etatCivil: Array<EtatCivil>;
  libelle: Scalars['String']['output'];
};


export type TypeSituationEtatCivilEtatCivilArgs = {
  where?: InputMaybe<EtatCivilFilterInput>;
};

export type TypeSituationEtatCivilFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeSituationEtatCivilFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  etatCivil?: InputMaybe<ListFilterInputTypeOfEtatCivilFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeSituationEtatCivilFilterInput>>;
};

export type TypeSituationEtatCivilSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeSituationProfessionnelle = {
  __typename?: 'TypeSituationProfessionnelle';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['Int']['output'];
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  situationProfessionnelles: Array<SituationProfessionnelle>;
};


export type TypeSituationProfessionnelleSituationProfessionnellesArgs = {
  where?: InputMaybe<SituationProfessionnelleFilterInput>;
};

export type TypeSituationProfessionnelleFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeSituationProfessionnelleFilterInput>>;
  code?: InputMaybe<IntOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeSituationProfessionnelleFilterInput>>;
  situationProfessionnelles?: InputMaybe<ListFilterInputTypeOfSituationProfessionnelleFilterInput>;
};

export type TypeSituationProfessionnelleSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeSociete = {
  __typename?: 'TypeSociete';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantStatutJuridique: Array<ConsultantStatutJuridique>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle?: Maybe<Scalars['String']['output']>;
};


export type TypeSocieteConsultantStatutJuridiqueArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};

export type TypeSocieteFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeSocieteFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantStatutJuridique?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeSocieteFilterInput>>;
};

export type TypeStatutInvestisseur = {
  __typename?: 'TypeStatutInvestisseur';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  investisseur: Array<Investisseur>;
  libelle: Scalars['String']['output'];
};


export type TypeStatutInvestisseurInvestisseurArgs = {
  where?: InputMaybe<InvestisseurFilterInput>;
};

export type TypeStatutInvestisseurFilterInput = {
  and?: InputMaybe<Array<TypeStatutInvestisseurFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeStatutInvestisseurFilterInput>>;
};

export type TypeStatutInvestisseurInput = {
  code: Scalars['String']['input'];
  libelle: Scalars['String']['input'];
};

export type TypeStatutInvestisseurSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export enum TypeStatutJuridique {
  AgentCommercial = 'AGENT_COMMERCIAL',
  ProfessionLiberale = 'PROFESSION_LIBERALE',
  Societe = 'SOCIETE'
}

export type TypeStatutProfessionnel = {
  __typename?: 'TypeStatutProfessionnel';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['Int']['output'];
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  situationProfessionnelles: Array<SituationProfessionnelle>;
};


export type TypeStatutProfessionnelSituationProfessionnellesArgs = {
  where?: InputMaybe<SituationProfessionnelleFilterInput>;
};

export type TypeStatutProfessionnelFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeStatutProfessionnelFilterInput>>;
  code?: InputMaybe<IntOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeStatutProfessionnelFilterInput>>;
  situationProfessionnelles?: InputMaybe<ListFilterInputTypeOfSituationProfessionnelleFilterInput>;
};

export type TypeStatutProfessionnelSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeTelephone = {
  __typename?: 'TypeTelephone';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  telephone: Array<Telephone>;
};


export type TypeTelephoneTelephoneArgs = {
  where?: InputMaybe<TelephoneFilterInput>;
};

export type TypeTelephoneFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeTelephoneFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeTelephoneFilterInput>>;
  telephone?: InputMaybe<ListFilterInputTypeOfTelephoneFilterInput>;
};

export type TypeTransfertClient = {
  __typename?: 'TypeTransfertClient';
  code: Scalars['String']['output'];
  transfertClient: Array<TransfertClient>;
};


export type TypeTransfertClientTransfertClientArgs = {
  where?: InputMaybe<TransfertClientFilterInput>;
};

export type TypeTransfertClientFilterInput = {
  and?: InputMaybe<Array<TypeTransfertClientFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeTransfertClientFilterInput>>;
  transfertClient?: InputMaybe<ListFilterInputTypeOfTransfertClientFilterInput>;
};

export type TypeTransfertClientSortInput = {
  code?: InputMaybe<SortEnumType>;
};

export type UpdateCapaciteFinanciereInput = {
  commentaire?: InputMaybe<Scalars['String']['input']>;
  effortEpargne?: InputMaybe<Scalars['Decimal']['input']>;
  epargnePrecautionCible?: InputMaybe<Scalars['Decimal']['input']>;
  investisseurId: Scalars['Long']['input'];
  levierType?: InputMaybe<LevierType>;
};

export type UpdateDocumentMetadatasCommandInput = {
  clearContratId?: InputMaybe<Scalars['Boolean']['input']>;
  clearPatrimoineId?: InputMaybe<Scalars['Boolean']['input']>;
  contratId?: InputMaybe<Scalars['String']['input']>;
  dateDeDebutValidite?: InputMaybe<Scalars['DateTime']['input']>;
  dateDeFinValidite?: InputMaybe<Scalars['DateTime']['input']>;
  dateDeReference?: InputMaybe<Scalars['LocalDate']['input']>;
  dateSignature?: InputMaybe<Scalars['DateTime']['input']>;
  denomination?: InputMaybe<Scalars['String']['input']>;
  derniereModificationPar: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  extension?: InputMaybe<Scalars['String']['input']>;
  investisseurId?: InputMaybe<Scalars['String']['input']>;
  investisseurIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isHandwrittenSignature?: InputMaybe<Scalars['Boolean']['input']>;
  nomDeFichier?: InputMaybe<Scalars['String']['input']>;
  patrimoineId?: InputMaybe<Scalars['String']['input']>;
  signatureState?: InputMaybe<SignatureState>;
  statutJuridiqueId?: InputMaybe<Scalars['Int']['input']>;
  subTypeCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  typeDocumentCode?: InputMaybe<GedDocumentType>;
};

export type UpdateObjectifDefinisInput = {
  investisseurId: Scalars['Long']['input'];
  objectifs: Array<ObjectifDefinitionInput>;
};

export type UpdateObjectifStepInput = {
  conjointInput?: InputMaybe<ObjectifStepDataInput>;
  investisseurInput: ObjectifStepDataInput;
};

export type UpdateRechercheInput = {
  filtres: Array<FiltreSettingInput>;
  label: Scalars['String']['input'];
  rechercheId: Scalars['Long']['input'];
};

export type UpdateSituationPersonnelleInput = {
  personne1: PersonneSituationPersonnelleInput;
  personne2?: InputMaybe<PersonneSituationPersonnelleInput>;
};

export type UserAccessRight = {
  __typename?: 'UserAccessRight';
  authorizedConsultantIds: Array<Scalars['Long']['output']>;
  authorizedInvestisseurIds: Array<Scalars['Long']['output']>;
  consultantHabilitationIds: Array<Scalars['Long']['output']>;
  consultantHabilitations: Array<Maybe<Scalars['String']['output']>>;
  consultantId?: Maybe<Scalars['Long']['output']>;
  hasFullAccess: Scalars['Boolean']['output'];
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type VeElement = {
  __typename?: 'VEElement';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type VeElementFilterInput = {
  and?: InputMaybe<Array<VeElementFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VeElementFilterInput>>;
  title?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<DecimalOperationFilterInput>;
};

export type VeObjectif = {
  __typename?: 'VEObjectif';
  horizon?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<Array<Scalars['Long']['output']>>;
};


export type VeObjectifOwnerArgs = {
  where?: InputMaybe<LongOperationFilterInput>;
};

export type VeObjectifFilterInput = {
  and?: InputMaybe<Array<VeObjectifFilterInput>>;
  horizon?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VeObjectifFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  owner?: InputMaybe<ListLongOperationFilterInput>;
};

export type VeProfilInvestisseur = {
  __typename?: 'VEProfilInvestisseur';
  connaissanceExperiences?: Maybe<Scalars['Int']['output']>;
  esg?: Maybe<Scalars['Int']['output']>;
  pertes?: Maybe<Scalars['Int']['output']>;
  profilDeRisque?: Maybe<Scalars['Int']['output']>;
  reponseESG?: Maybe<Scalars['Int']['output']>;
};

export type VeSituation = {
  __typename?: 'VESituation';
  elements?: Maybe<Array<VeElement>>;
  situationType: TermeEnum;
  totalCategory?: Maybe<Scalars['Decimal']['output']>;
};


export type VeSituationElementsArgs = {
  where?: InputMaybe<VeElementFilterInput>;
};

export type VeSituationFilterInput = {
  and?: InputMaybe<Array<VeSituationFilterInput>>;
  elements?: InputMaybe<ListFilterInputTypeOfVeElementFilterInput>;
  or?: InputMaybe<Array<VeSituationFilterInput>>;
  situationType?: InputMaybe<TermeEnumOperationFilterInput>;
  totalCategory?: InputMaybe<DecimalOperationFilterInput>;
};

export type VeSituationFinanciere = {
  __typename?: 'VESituationFinanciere';
  categoryTitle: Scalars['String']['output'];
  elements?: Maybe<Array<VeElement>>;
  filiale?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<Scalars['String']['output']>;
  totalCategory?: Maybe<Scalars['Decimal']['output']>;
};


export type VeSituationFinanciereElementsArgs = {
  where?: InputMaybe<VeElementFilterInput>;
};

export type VeSituationFinanciereFilterInput = {
  and?: InputMaybe<Array<VeSituationFinanciereFilterInput>>;
  categoryTitle?: InputMaybe<StringOperationFilterInput>;
  elements?: InputMaybe<ListFilterInputTypeOfVeElementFilterInput>;
  filiale?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VeSituationFinanciereFilterInput>>;
  subCategory?: InputMaybe<StringOperationFilterInput>;
  totalCategory?: InputMaybe<DecimalOperationFilterInput>;
};

/** Réponse à la question de vérification d'un produit ou d'un support */
export type VerificationReponse = {
  __typename?: 'VerificationReponse';
  /** Code de la réponse choisie (R1 à R4) */
  reponse: Scalars['String']['output'];
};

/** Réponse à la question de vérification d'un produit ou d'un support */
export type VerificationReponseFilterInput = {
  and?: InputMaybe<Array<VerificationReponseFilterInput>>;
  or?: InputMaybe<Array<VerificationReponseFilterInput>>;
  /** Code de la réponse choisie (R1 à R4) */
  reponse?: InputMaybe<StringOperationFilterInput>;
};

export type Versement = {
  __typename?: 'Versement';
  fraisVersement?: Maybe<Scalars['Decimal']['output']>;
  montantBrut?: Maybe<Scalars['Decimal']['output']>;
  niveauDeRisque?: Maybe<NiveauDeRisque>;
};

export type VersementFilterInput = {
  and?: InputMaybe<Array<VersementFilterInput>>;
  fraisVersement?: InputMaybe<DecimalOperationFilterInput>;
  montantBrut?: InputMaybe<DecimalOperationFilterInput>;
  niveauDeRisque?: InputMaybe<NullableOfNiveauDeRisqueOperationFilterInput>;
  or?: InputMaybe<Array<VersementFilterInput>>;
};

export type VersementInput = {
  fraisVersement?: InputMaybe<Scalars['Decimal']['input']>;
  montantBrut?: InputMaybe<Scalars['Decimal']['input']>;
  niveauDeRisque?: InputMaybe<NiveauDeRisque>;
};

export type VersementProgramme = {
  __typename?: 'VersementProgramme';
  avecChangementAllocation?: Maybe<Scalars['Boolean']['output']>;
  avecChangementCoordonneesBancaires?: Maybe<Scalars['Boolean']['output']>;
  frequence?: Maybe<FrequenceVersement>;
  isFraisVersementEditable?: Maybe<Scalars['Boolean']['output']>;
  isFrequenceEditable?: Maybe<Scalars['Boolean']['output']>;
  isMontantBrutEditable?: Maybe<Scalars['Boolean']['output']>;
  versement: Versement;
};

export type VersementProgrammeFilterInput = {
  and?: InputMaybe<Array<VersementProgrammeFilterInput>>;
  avecChangementAllocation?: InputMaybe<BooleanOperationFilterInput>;
  avecChangementCoordonneesBancaires?: InputMaybe<BooleanOperationFilterInput>;
  frequence?: InputMaybe<NullableOfFrequenceVersementOperationFilterInput>;
  isFraisVersementEditable?: InputMaybe<BooleanOperationFilterInput>;
  isFrequenceEditable?: InputMaybe<BooleanOperationFilterInput>;
  isMontantBrutEditable?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<VersementProgrammeFilterInput>>;
  versement?: InputMaybe<VersementFilterInput>;
};

export type VersementProgrammeInput = {
  avecChangementAllocation?: InputMaybe<Scalars['Boolean']['input']>;
  avecChangementCoordonneesBancaires?: InputMaybe<Scalars['Boolean']['input']>;
  frequence?: InputMaybe<FrequenceVersement>;
  isFraisVersementEditable?: InputMaybe<Scalars['Boolean']['input']>;
  isFrequenceEditable?: InputMaybe<Scalars['Boolean']['input']>;
  isMontantBrutEditable?: InputMaybe<Scalars['Boolean']['input']>;
  versement: VersementInput;
};

export type Versements = {
  __typename?: 'Versements';
  avecVersementProgramme: Scalars['Boolean']['output'];
  souscriptionAvecTransfert?: Maybe<Scalars['Boolean']['output']>;
  versementComplementaire?: Maybe<Versement>;
  versementInitial?: Maybe<Versement>;
  versementProgramme?: Maybe<VersementProgramme>;
};

export type VersementsFilterInput = {
  and?: InputMaybe<Array<VersementsFilterInput>>;
  avecVersementProgramme?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<VersementsFilterInput>>;
  souscriptionAvecTransfert?: InputMaybe<BooleanOperationFilterInput>;
  versementComplementaire?: InputMaybe<VersementFilterInput>;
  versementInitial?: InputMaybe<VersementFilterInput>;
  versementProgramme?: InputMaybe<VersementProgrammeFilterInput>;
};

export type VersementsInput = {
  avecVersementProgramme: Scalars['Boolean']['input'];
  souscriptionAvecTransfert?: InputMaybe<Scalars['Boolean']['input']>;
  versementComplementaire?: InputMaybe<VersementInput>;
  versementInitial?: InputMaybe<VersementInput>;
  versementProgramme?: InputMaybe<VersementProgrammeInput>;
};

export enum VpModeOptions {
  MiseEnPlace = 'MISE_EN_PLACE',
  Modification = 'MODIFICATION'
}

export enum VraiFauxEnum {
  Faux = 'FAUX',
  Vrai = 'VRAI'
}

export type VueDEnsembleResult = {
  __typename?: 'VueDEnsembleResult';
  capaciteEpargne?: Maybe<Scalars['Decimal']['output']>;
  capaciteEpargneCoInvestisseur?: Maybe<Scalars['Decimal']['output']>;
  capaciteEpargneInvestisseur?: Maybe<Scalars['Decimal']['output']>;
  capaciteRemboursementEmpruntRestant?: Maybe<Scalars['Decimal']['output']>;
  capaciteRemboursementEmpruntRestantCoInvestisseur?: Maybe<Scalars['Decimal']['output']>;
  capaciteRemboursementEmpruntRestantInvestisseur?: Maybe<Scalars['Decimal']['output']>;
  dateCalculIndicateur?: Maybe<Scalars['DateTime']['output']>;
  effortEpargne?: Maybe<Scalars['Decimal']['output']>;
  epargneDisponible?: Maybe<Scalars['Decimal']['output']>;
  epargnePrecautionReelle?: Maybe<Scalars['Decimal']['output']>;
  epargnePrecautionSouhaitee?: Maybe<Scalars['Decimal']['output']>;
  impotNetIFI?: Maybe<Scalars['Decimal']['output']>;
  impotNetIR?: Maybe<Scalars['Decimal']['output']>;
  montantRemboursement?: Maybe<Scalars['Decimal']['output']>;
  montantRemboursementCoInvestisseur?: Maybe<Scalars['Decimal']['output']>;
  montantRemboursementInvestisseur?: Maybe<Scalars['Decimal']['output']>;
  patrimoines?: Maybe<Array<VeSituationFinanciere>>;
  prochaineDateEcheance?: Maybe<Scalars['DateTime']['output']>;
  profilCoInvestisseur?: Maybe<VeProfilInvestisseur>;
  profilInvestisseur?: Maybe<VeProfilInvestisseur>;
  repartitions?: Maybe<Array<VeSituationFinanciere>>;
  revenusCharges?: Maybe<Array<VeSituationFinanciere>>;
  situations?: Maybe<Array<VeSituation>>;
  soitParMois?: Maybe<Scalars['Decimal']['output']>;
  soldeBudgetaire?: Maybe<Scalars['Decimal']['output']>;
  soldeBudgetaireCoInvestisseur?: Maybe<Scalars['Decimal']['output']>;
  soldeBudgetaireInvestisseur?: Maybe<Scalars['Decimal']['output']>;
  tauxEndetement?: Maybe<Scalars['Float']['output']>;
  tauxMarginalImposition?: Maybe<Scalars['Float']['output']>;
  tauxMarginalImpositionCoInvestisseur?: Maybe<Scalars['Float']['output']>;
  vueObjectifs?: Maybe<Array<VeObjectif>>;
};


export type VueDEnsembleResultPatrimoinesArgs = {
  where?: InputMaybe<VeSituationFinanciereFilterInput>;
};


export type VueDEnsembleResultRepartitionsArgs = {
  where?: InputMaybe<VeSituationFinanciereFilterInput>;
};


export type VueDEnsembleResultRevenusChargesArgs = {
  where?: InputMaybe<VeSituationFinanciereFilterInput>;
};


export type VueDEnsembleResultSituationsArgs = {
  where?: InputMaybe<VeSituationFilterInput>;
};


export type VueDEnsembleResultVueObjectifsArgs = {
  where?: InputMaybe<VeObjectifFilterInput>;
};

export type WaveMigrationJob = {
  __typename?: 'WaveMigrationJob';
  consultantMigrationJobs: Array<ConsultantMigrationJob>;
  consultants: Array<ImportConsultantWaveMigrationJob>;
  createdAt: Scalars['DateTime']['output'];
  galaxies: Array<ImportGalaxyWaveMigrationJob>;
  galaxyMigrationJobs: Array<GalaxyMigrationJob>;
  id: Scalars['Long']['output'];
  isActive: Scalars['Boolean']['output'];
  isPreImport: Scalars['Boolean']['output'];
  plannedStartMigrationDate?: Maybe<Scalars['DateTime']['output']>;
  priority: Scalars['Int']['output'];
  shouldAutomaticallyProcess: Scalars['Boolean']['output'];
  startMigrationTimeStamp?: Maybe<Scalars['DateTime']['output']>;
  status: JobStatus;
  syncs: Array<WavePreLaunchSync>;
  waveLabel: Scalars['String']['output'];
};


export type WaveMigrationJobConsultantMigrationJobsArgs = {
  where?: InputMaybe<ConsultantMigrationJobFilterInput>;
};


export type WaveMigrationJobConsultantsArgs = {
  where?: InputMaybe<ImportConsultantWaveMigrationJobFilterInput>;
};


export type WaveMigrationJobGalaxiesArgs = {
  where?: InputMaybe<ImportGalaxyWaveMigrationJobFilterInput>;
};


export type WaveMigrationJobGalaxyMigrationJobsArgs = {
  where?: InputMaybe<GalaxyMigrationJobFilterInput>;
};


export type WaveMigrationJobSyncsArgs = {
  where?: InputMaybe<WavePreLaunchSyncFilterInput>;
};

export type WaveMigrationJobFilterInput = {
  and?: InputMaybe<Array<WaveMigrationJobFilterInput>>;
  consultantMigrationJobs?: InputMaybe<ListFilterInputTypeOfConsultantMigrationJobFilterInput>;
  consultants?: InputMaybe<ListFilterInputTypeOfImportConsultantWaveMigrationJobFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  galaxies?: InputMaybe<ListFilterInputTypeOfImportGalaxyWaveMigrationJobFilterInput>;
  galaxyMigrationJobs?: InputMaybe<ListFilterInputTypeOfGalaxyMigrationJobFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isPreImport?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WaveMigrationJobFilterInput>>;
  plannedStartMigrationDate?: InputMaybe<DateTimeOperationFilterInput>;
  priority?: InputMaybe<IntOperationFilterInput>;
  shouldAutomaticallyProcess?: InputMaybe<BooleanOperationFilterInput>;
  startMigrationTimeStamp?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<JobStatusOperationFilterInput>;
  syncs?: InputMaybe<ListFilterInputTypeOfWavePreLaunchSyncFilterInput>;
  waveLabel?: InputMaybe<StringOperationFilterInput>;
};

export type WaveMigrationJobSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isPreImport?: InputMaybe<SortEnumType>;
  plannedStartMigrationDate?: InputMaybe<SortEnumType>;
  priority?: InputMaybe<SortEnumType>;
  shouldAutomaticallyProcess?: InputMaybe<SortEnumType>;
  startMigrationTimeStamp?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  waveLabel?: InputMaybe<SortEnumType>;
};

export type WavePreLaunchSync = {
  __typename?: 'WavePreLaunchSync';
  consultantApiSyncErrorCount: Scalars['Int']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  refAppSwitchErrorCount: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  totalSuccessCount: Scalars['Int']['output'];
  totalToProcess: Scalars['Int']['output'];
  waveMigrationJob: WaveMigrationJob;
  waveMigrationJobId: Scalars['Long']['output'];
};

export type WavePreLaunchSyncFilterInput = {
  and?: InputMaybe<Array<WavePreLaunchSyncFilterInput>>;
  consultantApiSyncErrorCount?: InputMaybe<IntOperationFilterInput>;
  finishedAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<WavePreLaunchSyncFilterInput>>;
  refAppSwitchErrorCount?: InputMaybe<IntOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  totalSuccessCount?: InputMaybe<IntOperationFilterInput>;
  totalToProcess?: InputMaybe<IntOperationFilterInput>;
  waveMigrationJob?: InputMaybe<WaveMigrationJobFilterInput>;
  waveMigrationJobId?: InputMaybe<LongOperationFilterInput>;
};

export type WaveTrackingStats = {
  __typename?: 'WaveTrackingStats';
  consultantJobs: JobLevelStats;
  createdAt: Scalars['DateTime']['output'];
  dumpJobs: JobLevelStats;
  galaxyJobs: JobLevelStats;
  isActive: Scalars['Boolean']['output'];
  isPreImport: Scalars['Boolean']['output'];
  plannedStartMigrationDate?: Maybe<Scalars['DateTime']['output']>;
  preLaunchSync?: Maybe<WavePreLaunchSync>;
  priority: Scalars['Int']['output'];
  processJobs: JobLevelStats;
  shouldAutomaticallyProcess: Scalars['Boolean']['output'];
  startMigrationTimeStamp?: Maybe<Scalars['DateTime']['output']>;
  status: JobStatus;
  waveLabel: Scalars['String']['output'];
  waveMigrationJobId: Scalars['Long']['output'];
};

export type GenerateContratsAgregationBackOfficeExportMutationVariables = Exact<{
  filter: ContratBackOfficeFilterInput;
}>;


export type GenerateContratsAgregationBackOfficeExportMutation = { __typename?: 'Mutation', generateContratsAgregationBackOfficeExport?: { __typename?: 'AgregationStorageFileModel', fileName: string, sasUrl?: string | null } | null };

export type GenerateContratsBySupportAgregationBackOfficeExportMutationVariables = Exact<{
  filter: ContratBackOfficeFilterInput;
}>;


export type GenerateContratsBySupportAgregationBackOfficeExportMutation = { __typename?: 'Mutation', generateContratsBySupportAgregationBackOfficeExport?: { __typename?: 'AgregationStorageFileModel', fileName: string, sasUrl?: string | null } | null };

export type GenerateSupportsAgregationBackOfficeExportMutationVariables = Exact<{
  filter: SupportConsultantFilterInput;
}>;


export type GenerateSupportsAgregationBackOfficeExportMutation = { __typename?: 'Mutation', generateSupportsAgregationBackOfficeExport?: { __typename?: 'AgregationStorageFileModel', fileName: string, sasUrl?: string | null } | null };

export type ConsultantsFilterQueryVariables = Exact<{
  filter: Scalars['String']['input'];
}>;


export type ConsultantsFilterQuery = { __typename?: 'Query', consultantsAgregation?: { __typename?: 'ConsultantsAgregationCollectionSegment', items?: Array<{ __typename?: 'ConsultantAgregation', codeConsultant: string, nom?: string | null, prenom?: string | null }> | null } | null };

export type ContratsBackOfficeQueryVariables = Exact<{ [key: string]: never; }>;


export type ContratsBackOfficeQuery = { __typename?: 'Query', visionGlobaleBackOffice?: { __typename?: 'ConsultantVisionGlobale', encoursTotal?: any | null, encoursMoyenContrat?: any | null, nbContrats?: number | null, encoursMoyenClient?: any | null, nbClients?: number | null, encoursMoyenSupport?: any | null, nbSupports?: number | null, encoursMoyenSocieteGestion?: any | null, nbSocietesGestions?: number | null } | null, repartitionProduitsBackOffice: Array<{ __typename?: 'ConsultantRepartitionProduit', nbContrats?: number | null, encours?: any | null, poidsProduitEncours?: any | null, produit?: { __typename?: 'ProduitAgregation', designation?: string | null } | null }>, repartitionEnveloppesBackOffice: Array<{ __typename?: 'ConsultantRepartitionEnveloppe', nbContrats?: number | null, encours?: any | null, poidsEnveloppeEncours?: any | null, enveloppeAgregation?: { __typename?: 'Enveloppe', code: string, libelle?: string | null } | null }>, repartitionPartenairesBackOffice: Array<{ __typename?: 'ConsultantRepartitionPartenaire', nbContrats?: number | null, encours?: any | null, poidsPartenaireEncours?: any | null, partenaireAgregation?: { __typename?: 'PartenaireAgregation', idPartenaire: string, libelleLong?: string | null } | null }>, repartitionSocieteGestionsBackOffice: Array<{ __typename?: 'ConsultantRepartitionSocieteGestion', encours?: any | null, poidsSocieteGestion?: any | null, societeGestion: string }>, repartitionClasseActifsBackOffice: Array<{ __typename?: 'ConsultantRepartitionClasseActif', encours?: any | null, poidsClasseActif?: any | null, poidsSousClasseActif?: any | null, classeActif?: string | null, sousClasseActif: string }>, repartitionSrisBackOffice: Array<{ __typename?: 'ConsultantRepartitionSri', encours?: any | null, poidsSri?: any | null, sri: number }>, repartitionEsgsBackOffice: Array<{ __typename?: 'ConsultantRepartitionEsg', encours?: any | null, poidsEsg?: any | null, esg: string }>, allSupportsBackOffice: Array<{ __typename?: 'ConsultantRepartitionSupport', codeIsin: string, supportClasseActif?: { __typename?: 'SupportsClassesActif', libelleSupport?: string | null } | null }> };

export type ContratsBackOfficeListeQueryVariables = Exact<{
  filter: ContratBackOfficeFilterInput;
  order?: InputMaybe<ContratBackOfficeOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContratsBackOfficeListeQuery = { __typename?: 'Query', totalContratsBackOffice: any, contratsBackOffice?: { __typename?: 'ContratsBackOfficeCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Contrat', idContrat: string, numeroContrat?: string | null, valorisation?: any | null, dateDebutContrat?: any | null, dateValorisation?: any | null, cumulVersementsNets?: any | null, perfPlusMoinsValueFinanciereNette?: any | null, flagVp?: boolean | null, vpMontantUnitaire?: any | null, periodiciteVp?: { __typename?: 'PeriodiciteVp', libelle?: string | null } | null, produit?: { __typename?: 'ProduitAgregation', designation?: string | null, enveloppe?: { __typename?: 'Enveloppe', libelle?: string | null } | null, partenaire?: { __typename?: 'PartenaireAgregation', libelleLong?: string | null } | null } | null, contratsInvestisseurs?: Array<{ __typename?: 'ContratsInvestisseur', codeInvestisseur?: string | null, investisseur?: { __typename?: 'InvestisseurAgregation', nom?: string | null, prenom?: string | null } | null, consultant?: { __typename?: 'ConsultantAgregation', nom?: string | null, prenom?: string | null, galaxieConsultant?: { __typename?: 'ConsultantAgregation', nom?: string | null, prenom?: string | null } | null } | null }> | null }> | null } | null };

export type ManagersGalaxieQueryVariables = Exact<{ [key: string]: never; }>;


export type ManagersGalaxieQuery = { __typename?: 'Query', managersGalaxie: Array<{ __typename?: 'ConsultantAgregation', idConsultant?: string | null, nom?: string | null, prenom?: string | null }> };

export type SupportsBackOfficeListeQueryVariables = Exact<{
  filter: SupportConsultantFilterInput;
  order?: InputMaybe<SupportConsultantOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SupportsBackOfficeListeQuery = { __typename?: 'Query', supportsBackOffice?: { __typename?: 'SupportsBackOfficeCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ConsultantRepartitionSupport', codeIsin: string, encours?: any | null, poidsSupport?: any | null, valeurLiquidative?: any | null, dateCotation?: any | null, nbContrats?: number | null, supportClasseActif?: { __typename?: 'SupportsClassesActif', libelleSupport?: string | null, classeActif?: string | null, sousClasseActif?: string | null, societeGestion?: string | null, categorieQuantalys?: string | null, sri?: number | null, esg?: string | null } | null }> | null } | null };

export type AttachAllocationFileMutationVariables = Exact<{
  allocationId: Scalars['String']['input'];
  storageFileId: Scalars['String']['input'];
}>;


export type AttachAllocationFileMutation = { __typename?: 'Mutation', attachAllocationFile: { __typename?: 'Allocation', id: string, dateModification?: any | null, storageFile?: { __typename?: 'StorageFile', id: string, fileNameWithExtension?: string | null, lastModificationDate?: any | null } | null } };

export type CreateAllocationFileUploadMutationVariables = Exact<{
  allocationId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type CreateAllocationFileUploadMutation = { __typename?: 'Mutation', createAllocationFileUpload: { __typename?: 'StorageFileWithConnectionInfo', id: string, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', sasUrl: string } | null } };

export type DeleteAllocationFileMutationVariables = Exact<{
  allocationId: Scalars['String']['input'];
}>;


export type DeleteAllocationFileMutation = { __typename?: 'Mutation', deleteAllocationFile: { __typename?: 'Allocation', id: string, dateModification?: any | null, storageFile?: { __typename?: 'StorageFile', id: string } | null } };

export type AllocationStorageFileQueryVariables = Exact<{
  storageFileId: Scalars['String']['input'];
}>;


export type AllocationStorageFileQuery = { __typename?: 'Query', storageFile?: { __typename?: 'StorageFile', id: string, fileName: string, fileType: string, fileNameWithExtension?: string | null, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', sasUrl: string } | null } | null };

export type AllocationsFilesQueryVariables = Exact<{
  where?: InputMaybe<AllocationFilterInput>;
}>;


export type AllocationsFilesQuery = { __typename?: 'Query', allocationsFiles: Array<{ __typename?: 'Allocation', id: string, libelle: string, niveauDeRisque: NiveauDeRisque, dateModification?: any | null, storageFile?: { __typename?: 'StorageFile', id: string, fileNameWithExtension?: string | null, lastModificationDate?: any | null } | null }> };

export type ConsultantCodeAndNameFragment = { __typename?: 'Consultant', id: any, code: string, arianeId?: any | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> };

export type MigrationConsultantItemFragment = { __typename?: 'Consultant', id: any, code: string, arianeId?: any | null, isDisabled: boolean, waveLabel?: string | null, gerePar: AppReference, qualificationCode?: string | null, galaxyId?: any | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, telephone: Array<{ __typename?: 'Telephone', numero: string }>, email: Array<{ __typename?: 'Email', adresse: string }> }>, qualificationCodeNavigation?: { __typename?: 'QualificationConsultant', libelle: string } | null, galaxy?: { __typename?: 'Consultant', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, minotaureImportProgress?: { __typename?: 'MinotaureImportProgress', minotaureInvestisseurs: any, totalInvestisseurs: any } | null };

export type WaveDetailsFragment = { __typename?: 'WaveMigrationJob', id: any, waveLabel: string, isPreImport: boolean, createdAt: any, priority: number, plannedStartMigrationDate?: any | null, startMigrationTimeStamp?: any | null, status: JobStatus, isActive: boolean, consultantMigrationJobs: Array<{ __typename?: 'ConsultantMigrationJob', consultantId: any }> };

export type CreateMigrationWaveJobMutationVariables = Exact<{
  waveLabel: Scalars['String']['input'];
  galaxyIds: Array<Scalars['Long']['input']> | Scalars['Long']['input'];
  consultantIds: Array<Scalars['Long']['input']> | Scalars['Long']['input'];
  isPreImport: Scalars['Boolean']['input'];
  shouldAutomaticallyProcess: Scalars['Boolean']['input'];
  priority: Scalars['Int']['input'];
  initialStatus: JobStatus;
  plannedStartMigrationDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CreateMigrationWaveJobMutation = { __typename?: 'Mutation', createMigrationWaveJob?: { __typename?: 'WaveMigrationJob', id: any, waveLabel: string, isPreImport: boolean, createdAt: any, priority: number, plannedStartMigrationDate?: any | null, startMigrationTimeStamp?: any | null, status: JobStatus, isActive: boolean, consultantMigrationJobs: Array<{ __typename?: 'ConsultantMigrationJob', consultantId: any }> } | null };

export type ExportMigrationPlanningAllConsultantsMutationVariables = Exact<{ [key: string]: never; }>;


export type ExportMigrationPlanningAllConsultantsMutation = { __typename?: 'Mutation', exportMigrationPlanningAllConsultants?: { __typename?: 'StorageFile', fileName: string, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', sasUrl: string } | null } | null };

export type UpdateGalaxyListInWavesMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateGalaxyListInWavesMutation = { __typename?: 'Mutation', updateGalaxyListInWaves: boolean };

export type AllConsultantMigrationsPaginatedQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConsultantFilterInput>;
}>;


export type AllConsultantMigrationsPaginatedQuery = { __typename?: 'Query', consultantsPaginated?: { __typename?: 'ConsultantsPaginatedCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Consultant', id: any, code: string, arianeId?: any | null, isDisabled: boolean, waveLabel?: string | null, gerePar: AppReference, qualificationCode?: string | null, galaxyId?: any | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, telephone: Array<{ __typename?: 'Telephone', numero: string }>, email: Array<{ __typename?: 'Email', adresse: string }> }>, qualificationCodeNavigation?: { __typename?: 'QualificationConsultant', libelle: string } | null, galaxy?: { __typename?: 'Consultant', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, minotaureImportProgress?: { __typename?: 'MinotaureImportProgress', minotaureInvestisseurs: any, totalInvestisseurs: any } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type ConsultantsByNamePaginatedQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConsultantFilterInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConsultantsByNamePaginatedQuery = { __typename?: 'Query', consultantsByNamePaginated?: { __typename?: 'ConsultantsByNamePaginatedCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Consultant', id: any, code: string, arianeId?: any | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GalaxyManagerQueryVariables = Exact<{ [key: string]: never; }>;


export type GalaxyManagerQuery = { __typename?: 'Query', consultantsPaginated?: { __typename?: 'ConsultantsPaginatedCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Consultant', id: any, code: string, arianeId?: any | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> }> | null } | null };

export type ConsultantMigrationsByNamePaginatedQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConsultantFilterInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConsultantMigrationsByNamePaginatedQuery = { __typename?: 'Query', consultantsByNamePaginated?: { __typename?: 'ConsultantsByNamePaginatedCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Consultant', id: any, code: string, arianeId?: any | null, isDisabled: boolean, waveLabel?: string | null, gerePar: AppReference, qualificationCode?: string | null, galaxyId?: any | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, telephone: Array<{ __typename?: 'Telephone', numero: string }>, email: Array<{ __typename?: 'Email', adresse: string }> }>, qualificationCodeNavigation?: { __typename?: 'QualificationConsultant', libelle: string } | null, galaxy?: { __typename?: 'Consultant', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, minotaureImportProgress?: { __typename?: 'MinotaureImportProgress', minotaureInvestisseurs: any, totalInvestisseurs: any } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type AllWaveMigrationJobsQueryVariables = Exact<{
  where?: InputMaybe<WaveMigrationJobFilterInput>;
}>;


export type AllWaveMigrationJobsQuery = { __typename?: 'Query', allWaveMigrationJobs: Array<{ __typename?: 'WaveMigrationJob', id: any, waveLabel: string, isPreImport: boolean, createdAt: any, priority: number, plannedStartMigrationDate?: any | null, startMigrationTimeStamp?: any | null, status: JobStatus, isActive: boolean, consultantMigrationJobs: Array<{ __typename?: 'ConsultantMigrationJob', consultantId: any }> }> };

export type MigrationConsultantWaveItemFragment = { __typename?: 'Consultant', id: any, code: string, waveLabel?: string | null, arianeId?: any | null, isDisabled: boolean, gerePar: AppReference, qualificationCode?: string | null, galaxyId?: any | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, telephone: Array<{ __typename?: 'Telephone', numero: string }>, email: Array<{ __typename?: 'Email', adresse: string }> }>, qualificationCodeNavigation?: { __typename?: 'QualificationConsultant', libelle: string } | null, galaxy?: { __typename?: 'Consultant', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, minotaureImportProgress?: { __typename?: 'MinotaureImportProgress', minotaureInvestisseurs: any, totalInvestisseurs: any } | null };

export type MigrationInvestisseurItemFragment = { __typename?: 'Investisseur', id: any, code: string, arianeId?: any | null, gerePar: AppReference, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }>, importInvestisseur?: { __typename?: 'ImportInvestisseur', id: any, arianeId?: any | null, activeInvestisseurDumpJob?: { __typename?: 'ArianeDumpJob', id: any, isPreImport: boolean, status: JobStatus, atlasId?: any | null } | null, activeInvestisseurProcessJob?: { __typename?: 'ArianeProcessJob', id: any, statut: JobStatus, isPreImport: boolean, investisseurId: any } | null } | null, importHistories?: Array<{ __typename?: 'ImportHistory', id: any, date: any, isPreImport: boolean, investisseurId: any, logs: Array<{ __typename?: 'ImportLog', logLevel: ImportLogLevel, logIdentifier?: string | null, message: string }> }> | null };

export type RestartArianeDumpMutationVariables = Exact<{
  priority: Scalars['Int']['input'];
  where?: InputMaybe<ArianeDumpJobFilterInput>;
}>;


export type RestartArianeDumpMutation = { __typename?: 'Mutation', restartArianeDump: string };

export type RestartProcessArianeDataMutationVariables = Exact<{
  priority: Scalars['Int']['input'];
  where?: InputMaybe<ArianeProcessJobFilterInput>;
}>;


export type RestartProcessArianeDataMutation = { __typename?: 'Mutation', restartProcessArianeData: string };

export type MigrationConsultantByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type MigrationConsultantByCodeQuery = { __typename?: 'Query', consultantByCode?: { __typename?: 'Consultant', id: any, code: string, waveLabel?: string | null, arianeId?: any | null, isDisabled: boolean, gerePar: AppReference, qualificationCode?: string | null, galaxyId?: any | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, telephone: Array<{ __typename?: 'Telephone', numero: string }>, email: Array<{ __typename?: 'Email', adresse: string }> }>, qualificationCodeNavigation?: { __typename?: 'QualificationConsultant', libelle: string } | null, galaxy?: { __typename?: 'Consultant', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, minotaureImportProgress?: { __typename?: 'MinotaureImportProgress', minotaureInvestisseurs: any, totalInvestisseurs: any } | null } | null };

export type MigrationInvestisseursPaginatedQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestisseurFilterInput>;
}>;


export type MigrationInvestisseursPaginatedQuery = { __typename?: 'Query', investisseursPaginated?: { __typename?: 'InvestisseursPaginatedCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Investisseur', id: any, code: string, arianeId?: any | null, gerePar: AppReference, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }>, importInvestisseur?: { __typename?: 'ImportInvestisseur', id: any, arianeId?: any | null, activeInvestisseurDumpJob?: { __typename?: 'ArianeDumpJob', id: any, isPreImport: boolean, status: JobStatus, atlasId?: any | null } | null, activeInvestisseurProcessJob?: { __typename?: 'ArianeProcessJob', id: any, statut: JobStatus, isPreImport: boolean, investisseurId: any } | null } | null, importHistories?: Array<{ __typename?: 'ImportHistory', id: any, date: any, isPreImport: boolean, investisseurId: any, logs: Array<{ __typename?: 'ImportLog', logLevel: ImportLogLevel, logIdentifier?: string | null, message: string }> }> | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type MigrationInvestisseursByNamePaginatedQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestisseurFilterInput>;
  searchText: Scalars['String']['input'];
}>;


export type MigrationInvestisseursByNamePaginatedQuery = { __typename?: 'Query', investisseursByNamePaginated?: { __typename?: 'InvestisseursByNamePaginatedCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Investisseur', id: any, code: string, arianeId?: any | null, gerePar: AppReference, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }>, importInvestisseur?: { __typename?: 'ImportInvestisseur', id: any, arianeId?: any | null, activeInvestisseurDumpJob?: { __typename?: 'ArianeDumpJob', id: any, isPreImport: boolean, status: JobStatus, atlasId?: any | null } | null, activeInvestisseurProcessJob?: { __typename?: 'ArianeProcessJob', id: any, statut: JobStatus, isPreImport: boolean, investisseurId: any } | null } | null, importHistories?: Array<{ __typename?: 'ImportHistory', id: any, date: any, isPreImport: boolean, investisseurId: any, logs: Array<{ __typename?: 'ImportLog', logLevel: ImportLogLevel, logIdentifier?: string | null, message: string }> }> | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type SyncEcartResultFragment = { __typename?: 'EcartInvestisseurSyncResult', status: EcartInvestisseurSyncStatus, isStop: boolean, updatedCount: number, errorCount: number, unprocessedItems: number, remainingServiceCalls: number, errorIds: Array<any> };

export type StorageFileInfoFragment = { __typename?: 'StorageFile', fileName: string, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', sasUrl: string } | null };

export type FullWaveTrackingStatFragment = { __typename?: 'WaveTrackingStats', waveMigrationJobId: any, createdAt: any, isPreImport: boolean, shouldAutomaticallyProcess: boolean, waveLabel: string, plannedStartMigrationDate?: any | null, priority: number, startMigrationTimeStamp?: any | null, status: JobStatus, isActive: boolean, preLaunchSync?: { __typename?: 'WavePreLaunchSync', startedAt: any, finishedAt?: any | null, totalToProcess: number, consultantApiSyncErrorCount: number, refAppSwitchErrorCount: number, totalSuccessCount: number } | null, galaxyJobs: { __typename?: 'JobLevelStats', todoCount: number, activeTodoCount: number, completedCount: number, activeCompletedCount: number, failedCount: number, activeFailedCount: number, totalCount: number, activeTotalCount: number, failedItems: Array<{ __typename?: 'FailedJobItem', jobId: any, galaxyId?: any | null, consultantId?: any | null, investisseurId?: any | null, createdAt: any, isActive: boolean, errorMessage?: string | null, errorLogs: Array<{ __typename?: 'ErrorLogDetail', logIdentifier?: string | null, message: string }>, galaxy?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, consultant?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, investisseur?: { __typename?: 'Investisseur', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }> }, consultantJobs: { __typename?: 'JobLevelStats', todoCount: number, activeTodoCount: number, completedCount: number, activeCompletedCount: number, failedCount: number, activeFailedCount: number, totalCount: number, activeTotalCount: number, failedItems: Array<{ __typename?: 'FailedJobItem', jobId: any, galaxyId?: any | null, consultantId?: any | null, investisseurId?: any | null, createdAt: any, isActive: boolean, errorMessage?: string | null, errorLogs: Array<{ __typename?: 'ErrorLogDetail', logIdentifier?: string | null, message: string }>, galaxy?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, consultant?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, investisseur?: { __typename?: 'Investisseur', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }> }, dumpJobs: { __typename?: 'JobLevelStats', todoCount: number, activeTodoCount: number, completedCount: number, activeCompletedCount: number, failedCount: number, activeFailedCount: number, totalCount: number, activeTotalCount: number, failedItems: Array<{ __typename?: 'FailedJobItem', jobId: any, galaxyId?: any | null, consultantId?: any | null, investisseurId?: any | null, createdAt: any, isActive: boolean, errorMessage?: string | null, errorLogs: Array<{ __typename?: 'ErrorLogDetail', logIdentifier?: string | null, message: string }>, galaxy?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, consultant?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, investisseur?: { __typename?: 'Investisseur', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }> }, processJobs: { __typename?: 'JobLevelStats', todoCount: number, activeTodoCount: number, completedCount: number, activeCompletedCount: number, failedCount: number, activeFailedCount: number, totalCount: number, activeTotalCount: number, failedItems: Array<{ __typename?: 'FailedJobItem', jobId: any, galaxyId?: any | null, consultantId?: any | null, investisseurId?: any | null, createdAt: any, isActive: boolean, errorMessage?: string | null, errorLogs: Array<{ __typename?: 'ErrorLogDetail', logIdentifier?: string | null, message: string }>, galaxy?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, consultant?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, investisseur?: { __typename?: 'Investisseur', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }> } };

export type JobLevelStatsFragment = { __typename?: 'JobLevelStats', todoCount: number, activeTodoCount: number, completedCount: number, activeCompletedCount: number, failedCount: number, activeFailedCount: number, totalCount: number, activeTotalCount: number, failedItems: Array<{ __typename?: 'FailedJobItem', jobId: any, galaxyId?: any | null, consultantId?: any | null, investisseurId?: any | null, createdAt: any, isActive: boolean, errorMessage?: string | null, errorLogs: Array<{ __typename?: 'ErrorLogDetail', logIdentifier?: string | null, message: string }>, galaxy?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, consultant?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, investisseur?: { __typename?: 'Investisseur', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }> };

export type FailedJobItemFragment = { __typename?: 'FailedJobItem', jobId: any, galaxyId?: any | null, consultantId?: any | null, investisseurId?: any | null, createdAt: any, isActive: boolean, errorMessage?: string | null, errorLogs: Array<{ __typename?: 'ErrorLogDetail', logIdentifier?: string | null, message: string }>, galaxy?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, consultant?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, investisseur?: { __typename?: 'Investisseur', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null };

export type AllowWaveConsultantsInMinotaureMutationVariables = Exact<{
  waveId: Scalars['Long']['input'];
}>;


export type AllowWaveConsultantsInMinotaureMutation = { __typename?: 'Mutation', setConsultantsAccessByWaveId: string };

export type ExportWaveMigrationPendingSignaturesMutationVariables = Exact<{
  waveId: Scalars['Long']['input'];
}>;


export type ExportWaveMigrationPendingSignaturesMutation = { __typename?: 'Mutation', exportWaveMigrationPendingSignatures?: { __typename?: 'StorageFile', fileName: string, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', sasUrl: string } | null } | null };

export type ExportWaveEcartInvestisseurUpdatedInArianeMutationVariables = Exact<{
  waveId: Scalars['Long']['input'];
}>;


export type ExportWaveEcartInvestisseurUpdatedInArianeMutation = { __typename?: 'Mutation', exportWaveEcartInvestisseurUpdatedInAriane?: { __typename?: 'StorageFile', fileName: string, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', sasUrl: string } | null } | null };

export type ExportWaveMigrationJobDataMutationVariables = Exact<{
  waveId: Scalars['Long']['input'];
}>;


export type ExportWaveMigrationJobDataMutation = { __typename?: 'Mutation', exportWaveMigrationJobData?: { __typename?: 'StorageFile', fileName: string, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', sasUrl: string } | null } | null };

export type ExportWaveMigrationEcartInvestisseursMutationVariables = Exact<{
  waveId: Scalars['Long']['input'];
}>;


export type ExportWaveMigrationEcartInvestisseursMutation = { __typename?: 'Mutation', exportWaveMigrationEcartInvestisseurs?: { __typename?: 'StorageFile', fileName: string, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', sasUrl: string } | null } | null };

export type FilldataMutationVariables = Exact<{
  waveId: Scalars['Long']['input'];
}>;


export type FilldataMutation = { __typename?: 'Mutation', fillDataEcartInvestisseurs: { __typename?: 'EcartInvestisseurSyncResult', status: EcartInvestisseurSyncStatus, isStop: boolean, updatedCount: number, errorCount: number, unprocessedItems: number, remainingServiceCalls: number, errorIds: Array<any> } };

export type ResetDataEcartInvestisseursMutationVariables = Exact<{
  waveId: Scalars['Long']['input'];
}>;


export type ResetDataEcartInvestisseursMutation = { __typename?: 'Mutation', resetDataEcartInvestisseurs: boolean };

export type RestartFailedFinancialRecalculationJobMutationVariables = Exact<{
  jobId: Scalars['Long']['input'];
}>;


export type RestartFailedFinancialRecalculationJobMutation = { __typename?: 'Mutation', restartFailedFinancialRecalculationJob: boolean };

export type RestartFailedFinancialRecalculationJobsMutationVariables = Exact<{
  where: FinancialRecalculationJobFilterInput;
}>;


export type RestartFailedFinancialRecalculationJobsMutation = { __typename?: 'Mutation', restartFailedFinancialRecalculationJobs: number };

export type WaveSyncBeforeLaunchMutationVariables = Exact<{
  waveId: Scalars['Long']['input'];
}>;


export type WaveSyncBeforeLaunchMutation = { __typename?: 'Mutation', waveSyncBeforeLaunch: string };

export type ConsultantsFilteredQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConsultantsFilteredQuery = { __typename?: 'Query', consultantsByNamePaginated?: { __typename?: 'ConsultantsByNamePaginatedCollectionSegment', items?: Array<{ __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> }> | null } | null };

export type FailedFinancialRecalculationDashboardJobsQueryVariables = Exact<{
  priority: FinancialRecalculationPriority;
  begin?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type FailedFinancialRecalculationDashboardJobsQuery = { __typename?: 'Query', jobs?: { __typename?: 'FailedFinancialRecalculationJobsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'FailedFinancialRecalculationJob', jobId: any, priority: FinancialRecalculationPriority, createdAtUtc: any, failedAtUtc?: any | null, message: string, exceptionType?: string | null, exceptionMessage?: string | null, investisseur: { __typename?: 'FinancialRecalculationJobIdentity', id?: any | null, code: string, nom: string, prenom: string }, consultantPrimaire: { __typename?: 'FinancialRecalculationJobIdentity', id?: any | null, code: string, nom: string, prenom: string } }> | null } | null };

export type FinancialRecalculationDashboardQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;


export type FinancialRecalculationDashboardQuery = { __typename?: 'Query', workerCount: number, stats: { __typename?: 'FinancialRecalculationJobStats', start: any, end: any, priorities: Array<{ __typename?: 'FinancialRecalculationJobPriorityStats', priority: FinancialRecalculationPriority, statusCounts: Array<{ __typename?: 'FinancialRecalculationJobStatusCount', status: FinancialRecalculationJobStatus, count: any }>, completed: { __typename?: 'FinancialRecalculationJobOutcomeStats', elapsedSinceCreation: { __typename?: 'FinancialRecalculationDurationStats', sampleCount: any, averageSeconds?: number | null, minimumSeconds?: number | null, maximumSeconds?: number | null }, processing: { __typename?: 'FinancialRecalculationDurationStats', sampleCount: any, averageSeconds?: number | null, minimumSeconds?: number | null, maximumSeconds?: number | null } }, failed: { __typename?: 'FinancialRecalculationJobOutcomeStats', elapsedSinceCreation: { __typename?: 'FinancialRecalculationDurationStats', sampleCount: any, averageSeconds?: number | null, minimumSeconds?: number | null, maximumSeconds?: number | null }, processing: { __typename?: 'FinancialRecalculationDurationStats', sampleCount: any, averageSeconds?: number | null, minimumSeconds?: number | null, maximumSeconds?: number | null } } }> } };

export type SetFinancialRecalculationWorkerCountMutationVariables = Exact<{
  count: Scalars['Int']['input'];
}>;


export type SetFinancialRecalculationWorkerCountMutation = { __typename?: 'Mutation', setFinancialRecalculationWorkerCount: number };

export type FinancialDashboardDurationFragment = { __typename?: 'FinancialRecalculationDurationStats', sampleCount: any, averageSeconds?: number | null, minimumSeconds?: number | null, maximumSeconds?: number | null };

export type GetWaveStatsQueryVariables = Exact<{
  waveId: Scalars['Long']['input'];
}>;


export type GetWaveStatsQuery = { __typename?: 'Query', waveMigrationStats: { __typename?: 'WaveTrackingStats', waveMigrationJobId: any, createdAt: any, isPreImport: boolean, shouldAutomaticallyProcess: boolean, waveLabel: string, plannedStartMigrationDate?: any | null, priority: number, startMigrationTimeStamp?: any | null, status: JobStatus, isActive: boolean, preLaunchSync?: { __typename?: 'WavePreLaunchSync', startedAt: any, finishedAt?: any | null, totalToProcess: number, consultantApiSyncErrorCount: number, refAppSwitchErrorCount: number, totalSuccessCount: number } | null, galaxyJobs: { __typename?: 'JobLevelStats', todoCount: number, activeTodoCount: number, completedCount: number, activeCompletedCount: number, failedCount: number, activeFailedCount: number, totalCount: number, activeTotalCount: number, failedItems: Array<{ __typename?: 'FailedJobItem', jobId: any, galaxyId?: any | null, consultantId?: any | null, investisseurId?: any | null, createdAt: any, isActive: boolean, errorMessage?: string | null, errorLogs: Array<{ __typename?: 'ErrorLogDetail', logIdentifier?: string | null, message: string }>, galaxy?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, consultant?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, investisseur?: { __typename?: 'Investisseur', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }> }, consultantJobs: { __typename?: 'JobLevelStats', todoCount: number, activeTodoCount: number, completedCount: number, activeCompletedCount: number, failedCount: number, activeFailedCount: number, totalCount: number, activeTotalCount: number, failedItems: Array<{ __typename?: 'FailedJobItem', jobId: any, galaxyId?: any | null, consultantId?: any | null, investisseurId?: any | null, createdAt: any, isActive: boolean, errorMessage?: string | null, errorLogs: Array<{ __typename?: 'ErrorLogDetail', logIdentifier?: string | null, message: string }>, galaxy?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, consultant?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, investisseur?: { __typename?: 'Investisseur', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }> }, dumpJobs: { __typename?: 'JobLevelStats', todoCount: number, activeTodoCount: number, completedCount: number, activeCompletedCount: number, failedCount: number, activeFailedCount: number, totalCount: number, activeTotalCount: number, failedItems: Array<{ __typename?: 'FailedJobItem', jobId: any, galaxyId?: any | null, consultantId?: any | null, investisseurId?: any | null, createdAt: any, isActive: boolean, errorMessage?: string | null, errorLogs: Array<{ __typename?: 'ErrorLogDetail', logIdentifier?: string | null, message: string }>, galaxy?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, consultant?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, investisseur?: { __typename?: 'Investisseur', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }> }, processJobs: { __typename?: 'JobLevelStats', todoCount: number, activeTodoCount: number, completedCount: number, activeCompletedCount: number, failedCount: number, activeFailedCount: number, totalCount: number, activeTotalCount: number, failedItems: Array<{ __typename?: 'FailedJobItem', jobId: any, galaxyId?: any | null, consultantId?: any | null, investisseurId?: any | null, createdAt: any, isActive: boolean, errorMessage?: string | null, errorLogs: Array<{ __typename?: 'ErrorLogDetail', logIdentifier?: string | null, message: string }>, galaxy?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, consultant?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null, investisseur?: { __typename?: 'Investisseur', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }> } } };

export type GenerateContratsAgregationExportMutationVariables = Exact<{
  filter: ContratConsultantFilterInput;
}>;


export type GenerateContratsAgregationExportMutation = { __typename?: 'Mutation', generateContratsAgregationExport?: { __typename?: 'AgregationStorageFileModel', fileName: string, sasUrl?: string | null } | null };

export type GenerateContratsBySupportAgregationExportMutationVariables = Exact<{
  filter: ContratConsultantFilterInput;
}>;


export type GenerateContratsBySupportAgregationExportMutation = { __typename?: 'Mutation', generateContratsBySupportAgregationExport?: { __typename?: 'AgregationStorageFileModel', fileName: string, sasUrl?: string | null } | null };

export type GenerateSupportsAgregationExportMutationVariables = Exact<{
  filter: SupportConsultantFilterInput;
}>;


export type GenerateSupportsAgregationExportMutation = { __typename?: 'Mutation', generateSupportsAgregationExport?: { __typename?: 'AgregationStorageFileModel', fileName: string, sasUrl?: string | null } | null };

export type ContratsConsultantQueryVariables = Exact<{ [key: string]: never; }>;


export type ContratsConsultantQuery = { __typename?: 'Query', visionGlobaleConsultant?: { __typename?: 'ConsultantVisionGlobale', encoursTotal?: any | null, encoursMoyenContrat?: any | null, nbContrats?: number | null, encoursMoyenClient?: any | null, nbClients?: number | null, encoursMoyenSupport?: any | null, nbSupports?: number | null, encoursMoyenSocieteGestion?: any | null, nbSocietesGestions?: number | null } | null, repartitionProduitsConsultant: Array<{ __typename?: 'ConsultantRepartitionProduit', nbContrats?: number | null, encours?: any | null, poidsProduitEncours?: any | null, produit?: { __typename?: 'ProduitAgregation', designation?: string | null } | null }>, repartitionEnveloppesConsultant: Array<{ __typename?: 'ConsultantRepartitionEnveloppe', nbContrats?: number | null, encours?: any | null, poidsEnveloppeEncours?: any | null, enveloppeAgregation?: { __typename?: 'Enveloppe', code: string, libelle?: string | null } | null }>, repartitionPartenairesConsultant: Array<{ __typename?: 'ConsultantRepartitionPartenaire', nbContrats?: number | null, encours?: any | null, poidsPartenaireEncours?: any | null, partenaireAgregation?: { __typename?: 'PartenaireAgregation', idPartenaire: string, libelleLong?: string | null } | null }>, repartitionSocieteGestionsConsultant: Array<{ __typename?: 'ConsultantRepartitionSocieteGestion', encours?: any | null, poidsSocieteGestion?: any | null, societeGestion: string }>, repartitionClasseActifsConsultant: Array<{ __typename?: 'ConsultantRepartitionClasseActif', encours?: any | null, poidsClasseActif?: any | null, poidsSousClasseActif?: any | null, classeActif?: string | null, sousClasseActif: string }>, repartitionSrisConsultant: Array<{ __typename?: 'ConsultantRepartitionSri', encours?: any | null, poidsSri?: any | null, sri: number }>, repartitionEsgsConsultant: Array<{ __typename?: 'ConsultantRepartitionEsg', encours?: any | null, poidsEsg?: any | null, esg: string }>, allSupportsConsultant: Array<{ __typename?: 'ConsultantRepartitionSupport', codeIsin: string, supportClasseActif?: { __typename?: 'SupportsClassesActif', libelleSupport?: string | null } | null }> };

export type ContratsConsultantListeQueryVariables = Exact<{
  filter: ContratConsultantFilterInput;
  order?: InputMaybe<ContratConsultantOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContratsConsultantListeQuery = { __typename?: 'Query', totalContratsConsultant: any, contratsConsultant?: { __typename?: 'ContratsConsultantCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Contrat', idContrat: string, numeroContrat?: string | null, valorisation?: any | null, dateDebutContrat?: any | null, dateValorisation?: any | null, cumulVersementsNets?: any | null, perfPlusMoinsValueFinanciereNette?: any | null, flagVp?: boolean | null, vpMontantUnitaire?: any | null, periodiciteVp?: { __typename?: 'PeriodiciteVp', libelle?: string | null } | null, produit?: { __typename?: 'ProduitAgregation', designation?: string | null, enveloppe?: { __typename?: 'Enveloppe', libelle?: string | null } | null, partenaire?: { __typename?: 'PartenaireAgregation', libelleLong?: string | null } | null } | null, contratsInvestisseurs?: Array<{ __typename?: 'ContratsInvestisseur', codeInvestisseur?: string | null, investisseur?: { __typename?: 'InvestisseurAgregation', nom?: string | null, prenom?: string | null } | null }> | null }> | null } | null };

export type SupportsConsultantListeQueryVariables = Exact<{
  filter: SupportConsultantFilterInput;
  order?: InputMaybe<SupportConsultantOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SupportsConsultantListeQuery = { __typename?: 'Query', supportsConsultant?: { __typename?: 'SupportsConsultantCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ConsultantRepartitionSupport', codeIsin: string, encours?: any | null, poidsSupport?: any | null, valeurLiquidative?: any | null, dateCotation?: any | null, nbContrats?: number | null, supportClasseActif?: { __typename?: 'SupportsClassesActif', libelleSupport?: string | null, classeActif?: string | null, sousClasseActif?: string | null, societeGestion?: string | null, categorieQuantalys?: string | null, sri?: number | null, esg?: string | null } | null }> | null } | null };

export type CreateContactMutationVariables = Exact<{
  input: ContactCreationInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: Array<string> };

export type CheckDoublonInvestisseurQueryVariables = Exact<{
  nom: Scalars['String']['input'];
  prenom: Scalars['String']['input'];
  dateNaissance: Scalars['LocalDate']['input'];
  editedInvestisseurId?: InputMaybe<Scalars['Long']['input']>;
}>;


export type CheckDoublonInvestisseurQuery = { __typename?: 'Query', checkDoublonInvestisseur?: { __typename?: 'DoublonInvestisseurCheckResult', canBeCreated: boolean, existingRelationInvestisseurId?: any | null, isDoublon: boolean, isInOwnPortefeuille: boolean, isOtherConsultantContact: boolean, isOtherConsultantSigned: boolean } | null };

export type DoublonResultFragment = { __typename?: 'DoublonInvestisseurCheckResult', canBeCreated: boolean, existingRelationInvestisseurId?: any | null, isDoublon: boolean, isInOwnPortefeuille: boolean, isOtherConsultantContact: boolean, isOtherConsultantSigned: boolean };

export type GetBasicDashBoardCountersQueryVariables = Exact<{
  contacts?: InputMaybe<MinotaureInvestisseurFilterInput>;
  prospects?: InputMaybe<MinotaureInvestisseurFilterInput>;
  clients?: InputMaybe<MinotaureInvestisseurFilterInput>;
  connaissanceClientToUpdate?: InputMaybe<MinotaureInvestisseurFilterInput>;
  mystelliumToActivate?: InputMaybe<MinotaureInvestisseurFilterInput>;
  mystelliumInvitationSent?: InputMaybe<MinotaureInvestisseurFilterInput>;
}>;


export type GetBasicDashBoardCountersQuery = { __typename?: 'Query', contacts?: { __typename?: 'InvestisseursFromMinotaurePaginatedCollectionSegment', totalCount: number } | null, prospects?: { __typename?: 'InvestisseursFromMinotaurePaginatedCollectionSegment', totalCount: number } | null, clients?: { __typename?: 'InvestisseursFromMinotaurePaginatedCollectionSegment', totalCount: number } | null, cc_expired?: { __typename?: 'InvestisseursFromMinotaurePaginatedCollectionSegment', totalCount: number } | null, mystellium_to_activate?: { __typename?: 'InvestisseursFromMinotaurePaginatedCollectionSegment', totalCount: number } | null, mystellium_invitation_sent?: { __typename?: 'InvestisseursFromMinotaurePaginatedCollectionSegment', totalCount: number } | null };

export type GetEtiquetteIndicateursQueryVariables = Exact<{
  minotaureOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetEtiquetteIndicateursQuery = { __typename?: 'Query', etiquetteIndicateurs: Array<{ __typename?: 'EtiquetteIndicateurDto', color: string, count: number, id: any, label: string }> };

export type GetMinotaureCounterQueryVariables = Exact<{
  where?: InputMaybe<MinotaureInvestisseurFilterInput>;
}>;


export type GetMinotaureCounterQuery = { __typename?: 'Query', investisseursFromMinotaurePaginated?: { __typename?: 'InvestisseursFromMinotaurePaginatedCollectionSegment', totalCount: number } | null };

export type InvestisseursGetInvestisseursByNamePaginatedQueryVariables = Exact<{
  order?: InputMaybe<Array<InvestisseurSortInput> | InvestisseurSortInput>;
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  where?: InputMaybe<InvestisseurFilterInput>;
  searchText: Scalars['String']['input'];
}>;


export type InvestisseursGetInvestisseursByNamePaginatedQuery = { __typename?: 'Query', investisseursByNamePaginated?: { __typename?: 'InvestisseursByNamePaginatedCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Investisseur', code: string, id: any, dateSuppression?: any | null, statutCode: string, origineContactCode?: string | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, dateNaissance?: any | null, id: any, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null, id: any }>, telephone: Array<{ __typename?: 'Telephone', numero: string, estNumeroCorrespondance?: boolean | null, id: any }>, adresse: Array<{ __typename?: 'Adresse', adresse1?: string | null, adresse2?: string | null, adresse3?: string | null, codePostalCode?: string | null, paysCode?: string | null, typeAdresseCode: string, villeNom?: string | null, paysCodeNavigation?: { __typename?: 'Pays', libelle: string } | null }>, relationCouplePersonnePhysique?: { __typename?: 'RelationCoupleSimple', autrePersonnePhysiqueId?: any | null } | null }>, avancementConnaissanceClientInvestisseur?: { __typename?: 'AvancementConnaissanceClientInvestisseur', budgetState: RecueilStepState, cnIdocumentID?: string | null, cniEtat: EtatCni, cniLastChangeDate: any, cniReferenceDate?: any | null, deRdocumentID?: string | null, derEtat: EtatDer, derLastChangeDate: any, derReferenceDate?: any | null, etatGlobal: EtatGlobalInvestisseur, etatGlobalLastChangeDate: any, fiscaliteState: RecueilStepState, id: any, investisseurId: any, isRecueilFormCompleted: boolean, lastChangeDate: any, metadatasConnaissanceClientId: any, objectifsState: RecueilStepState, patrimoineState: RecueilStepState, qpIdocumentID?: string | null, qpiEtat: EtatQpi, qpiLastChangeDate: any, qpiReferenceDate?: any | null, recueildocumentID?: string | null, recueilEtat: EtatRecueil, recueilLastChangeDate: any, recueilReferenceDate?: any | null, situationPersonnelleState: RecueilStepState, statutFormulaireQPI: FormulaireStatut, statutFormulaireRecueil: FormulaireStatut, metadatasConnaissanceClient: { __typename?: 'MetadatasConnaissanceClient', id: any } } | null, etiquettes?: Array<{ __typename?: 'Etiquette', color: string, id: any, label: string }> | null, engagementBudgetaire?: { __typename?: 'EngagementBudgetaire', dateProchaineEcheanceCredit?: any | null, tauxEndettement?: number | null, capaciteRemboursementRestanteMensuel: number } | null, capaciteEpargne?: { __typename?: 'CapaciteEpargneDetail', capaciteEpargneMensuelle: any } | null, syntheseEpargne?: { __typename?: 'SyntheseEpargne', disponible: any, epargneTotale: any } | null, foyerFiscal?: { __typename?: 'FoyerFiscal', impotRevenuBrut?: number | null, impotRevenuTauxMarginal?: number | null } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetInvestisseursPhysiqueFiltresPaginatedQueryVariables = Exact<{
  order?: InputMaybe<Array<MinotaureInvestisseurSortInput> | MinotaureInvestisseurSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MinotaureInvestisseurFilterInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetInvestisseursPhysiqueFiltresPaginatedQuery = { __typename?: 'Query', investisseursByNameWithFilterPaginated?: { __typename?: 'InvestisseursByNameWithFilterPaginatedCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Investisseur', code: string, id: any, dateSuppression?: any | null, statutCode: string, origineContactCode?: string | null, recommandeParNom?: string | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, dateNaissance?: any | null, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null }>, telephone: Array<{ __typename?: 'Telephone', numero: string, estNumeroCorrespondance?: boolean | null }>, adresse: Array<{ __typename?: 'Adresse', adresse1?: string | null, adresse2?: string | null, adresse3?: string | null, codePostalCode?: string | null, paysCode?: string | null, typeAdresseCode: string, villeNom?: string | null, paysCodeNavigation?: { __typename?: 'Pays', libelle: string } | null }>, relationCouplePersonnePhysique?: { __typename?: 'RelationCoupleSimple', autrePersonnePhysiqueId?: any | null } | null }>, avancementConnaissanceClientInvestisseur?: { __typename?: 'AvancementConnaissanceClientInvestisseur', budgetState: RecueilStepState, cnIdocumentID?: string | null, cniEtat: EtatCni, cniLastChangeDate: any, cniReferenceDate?: any | null, deRdocumentID?: string | null, derEtat: EtatDer, derLastChangeDate: any, derReferenceDate?: any | null, etatGlobal: EtatGlobalInvestisseur, etatGlobalLastChangeDate: any, fiscaliteState: RecueilStepState, id: any, investisseurId: any, isRecueilFormCompleted: boolean, lastChangeDate: any, metadatasConnaissanceClientId: any, objectifsState: RecueilStepState, patrimoineState: RecueilStepState, qpIdocumentID?: string | null, qpiEtat: EtatQpi, qpiLastChangeDate: any, qpiReferenceDate?: any | null, recueildocumentID?: string | null, recueilEtat: EtatRecueil, recueilLastChangeDate: any, recueilReferenceDate?: any | null, situationPersonnelleState: RecueilStepState, statutFormulaireQPI: FormulaireStatut, statutFormulaireRecueil: FormulaireStatut, metadatasConnaissanceClient: { __typename?: 'MetadatasConnaissanceClient', id: any } } | null, etiquettes?: Array<{ __typename?: 'Etiquette', color: string, id: any, label: string }> | null, foyerFiscal?: { __typename?: 'FoyerFiscal', impotRevenuBrut?: number | null, impotRevenuTauxMarginal?: number | null } | null, investisseurConsultantRelations?: Array<{ __typename?: 'InvestisseurRelationConsultant', consultantCode?: string | null, consultantId: any, nom?: string | null, prenom?: string | null, typeRelationInvestisseurConsultantCode?: string | null }> | null, syntheseFinanciere?: { __typename?: 'InvestisseurSyntheseFinanciere', epargneTotaleInvestisseur: any, epargneDisponibleInvestisseur: any, effortEpargneInvestisseur: any, capaciteEpargneMensuelleInvestisseur: any, capaciteRemboursementRestanteMensuelInvestisseur: number, tauxEndettementInvestisseur?: number | null, dateProchaineEcheanceCreditInvestisseur?: any | null } | null, myStelliumInvestisseur?: { __typename?: 'MyStelliumInvestisseur', accountStatus: AccountStatus, invitedAt?: any | null, derStatus: DerStatus } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type OperationsForConsultantFilterValuesQueryVariables = Exact<{ [key: string]: never; }>;


export type OperationsForConsultantFilterValuesQuery = { __typename?: 'Query', operationsForConsultantFilterValues: { __typename?: 'OperationsForConsultantFilterValues', natureOperations: Array<{ __typename?: 'OperationsForConsultantNatureOperation', id: number, libelle: string }>, enveloppes: Array<{ __typename?: 'OperationsForConsultantEnveloppe', code: any, libelle: string }>, produits: Array<{ __typename?: 'OperationsForConsultantProduit', id: any, nom: string }> } };

export type OperationsForConsultantQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  filter?: InputMaybe<OperationsForConsultantFilterInput>;
}>;


export type OperationsForConsultantQuery = { __typename?: 'Query', operationsForConsultant?: { __typename?: 'OperationsForConsultantCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'Operation', id: any, statut: OperationState, versement?: any | null, numeroContrat?: string | null, dateModification: any, projet: { __typename?: 'Projet', id: any, nom: string, description?: string | null }, natureOperation?: { __typename?: 'NatureOperation', libelle: string } | null, enveloppe: { __typename?: 'EnveloppeProduit', libelle: string }, produit?: { __typename?: 'Produit', nom: string } | null, operationInvestisseurs: Array<{ __typename?: 'OperationInvestisseur', investisseur: { __typename?: 'Investisseur', id: any, code: string, type: TypePersonne, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } }> }> | null } | null };

export type RechercheSauvegardeFragmentFragment = { __typename?: 'RechercheSauvegarde', id: any, label: string, dateModification: any, filtres: Array<{ __typename?: 'FiltreSetting', builderCode: string, operator: string, value: string }> };

export type CreateRechercheMutationVariables = Exact<{
  rechercheInput: CreateRechercheInput;
}>;


export type CreateRechercheMutation = { __typename?: 'Mutation', createRecherche?: { __typename?: 'RechercheSauvegarde', id: any, label: string, dateModification: any, filtres: Array<{ __typename?: 'FiltreSetting', builderCode: string, operator: string, value: string }> } | null };

export type DeleteRechercheMutationVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type DeleteRechercheMutation = { __typename?: 'Mutation', deleteRecherche: boolean };

export type GenerateExportCsvMutationVariables = Exact<{
  order?: InputMaybe<Array<MinotaureInvestisseurSortInput> | MinotaureInvestisseurSortInput>;
  where?: InputMaybe<MinotaureInvestisseurFilterInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateExportCsvMutation = { __typename?: 'Mutation', generateCsvExport?: { __typename?: 'StorageFile', consultantCode?: string | null, createdDate?: any | null, denomination?: string | null, documentType: DocumentTypeEnum, fileExtension: string, fileName: string, fileType: string, id: string, isBlob: boolean, status?: FileStorageStatus | null, fileNameWithExtension?: string | null, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', expiration: any, permissions: Array<BlobFilesPermissionDs>, sasUrl: string } | null } | null };

export type UpdateConsultantPreferencesMutationVariables = Exact<{
  input: ConsultantPreferencesInput;
}>;


export type UpdateConsultantPreferencesMutation = { __typename?: 'Mutation', createOrUpdateConsultantPreferences: Array<{ __typename?: 'ConsultantPreferences', graphType1?: ContratDetailGraphEnum | null, graphType2?: ContratDetailGraphEnum | null, contratsGraphType1?: ConsultantContratsGraphEnum | null, contratsGraphType2?: ConsultantContratsGraphEnum | null, supportsGraphType1?: ConsultantSupportsGraphEnum | null, supportsGraphType2?: ConsultantSupportsGraphEnum | null }> };

export type UpdateDateModificationFicheMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
}>;


export type UpdateDateModificationFicheMutation = { __typename?: 'Mutation', updateDateModificationFiche: boolean };

export type UpdateDerStateFromConsultantDataMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateDerStateFromConsultantDataMutation = { __typename?: 'Mutation', updateDERStateFromConsultantData: boolean };

export type UpdateDerStateMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
  trigger: DerStateTransitionTrigger;
  applyAlsoToConjoint: Scalars['Boolean']['input'];
  documentId?: InputMaybe<Scalars['String']['input']>;
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UpdateDerStateMutation = { __typename?: 'Mutation', updateInvestisseurDERState?: { __typename?: 'MetadatasConnaissanceClient', id: any } | null };

export type UpdateEtiquettesMutationVariables = Exact<{
  etiquetteInput: EtiquetteInput;
}>;


export type UpdateEtiquettesMutation = { __typename?: 'Mutation', updateEtiquettes: Array<{ __typename?: 'EtiquetteDto', id: any, label: string, color: string, selectedInvestisseurIds: Array<any> }> };

export type UpdatePieceIdentiteStateMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
  isCompleted: Scalars['Boolean']['input'];
  documentId?: InputMaybe<Scalars['String']['input']>;
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UpdatePieceIdentiteStateMutation = { __typename?: 'Mutation', updateInvestisseurPieceIdentiteState?: { __typename?: 'MetadatasConnaissanceClient', id: any } | null };

export type UpdateQpiStateMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
  documentId?: InputMaybe<Scalars['String']['input']>;
  trigger: QpiStateTransitionTrigger;
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UpdateQpiStateMutation = { __typename?: 'Mutation', updateInvestisseurQPIState?: { __typename?: 'MetadatasConnaissanceClient', id: any } | null };

export type UpdateRechercheMutationVariables = Exact<{
  rechercheInput: UpdateRechercheInput;
}>;


export type UpdateRechercheMutation = { __typename?: 'Mutation', updateRecherche?: { __typename?: 'RechercheSauvegarde', id: any, label: string, dateModification: any, filtres: Array<{ __typename?: 'FiltreSetting', builderCode: string, operator: string, value: string }> } | null };

export type UpdateRecueilStateMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
  trigger: RecueilStateTransitionTrigger;
  documentId?: InputMaybe<Scalars['String']['input']>;
  applyAlsoToConjoint: Scalars['Boolean']['input'];
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UpdateRecueilStateMutation = { __typename?: 'Mutation', updateInvestisseurRecueilState?: { __typename?: 'MetadatasConnaissanceClient', id: any } | null };

export type UpdateSituationPersonnelleStateMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
  isCompleted: Scalars['Boolean']['input'];
}>;


export type UpdateSituationPersonnelleStateMutation = { __typename?: 'Mutation', investisseur?: { __typename?: 'MetadatasConnaissanceClient', id: any, avancementsConnaissanceClientInvestisseurs: Array<{ __typename?: 'AvancementConnaissanceClientInvestisseur', budgetState: RecueilStepState, cnIdocumentID?: string | null, cniEtat: EtatCni, cniLastChangeDate: any, cniReferenceDate?: any | null, deRdocumentID?: string | null, derEtat: EtatDer, derLastChangeDate: any, derReferenceDate?: any | null, etatGlobal: EtatGlobalInvestisseur, etatGlobalLastChangeDate: any, fiscaliteState: RecueilStepState, id: any, investisseurId: any, isRecueilFormCompleted: boolean, lastChangeDate: any, metadatasConnaissanceClientId: any, objectifsState: RecueilStepState, patrimoineState: RecueilStepState, qpIdocumentID?: string | null, qpiEtat: EtatQpi, qpiLastChangeDate: any, qpiReferenceDate?: any | null, recueildocumentID?: string | null, recueilEtat: EtatRecueil, recueilLastChangeDate: any, recueilReferenceDate?: any | null, situationPersonnelleState: RecueilStepState, statutFormulaireQPI: FormulaireStatut, statutFormulaireRecueil: FormulaireStatut, metadatasConnaissanceClient: { __typename?: 'MetadatasConnaissanceClient', id: any } }> } | null };

export type UpdateSituationPersonnelleWithConjointStateMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
  conjointId: Scalars['Long']['input'];
  isCompleted: Scalars['Boolean']['input'];
}>;


export type UpdateSituationPersonnelleWithConjointStateMutation = { __typename?: 'Mutation', conjoint?: { __typename?: 'MetadatasConnaissanceClient', id: any, avancementsConnaissanceClientInvestisseurs: Array<{ __typename?: 'AvancementConnaissanceClientInvestisseur', budgetState: RecueilStepState, cnIdocumentID?: string | null, cniEtat: EtatCni, cniLastChangeDate: any, cniReferenceDate?: any | null, deRdocumentID?: string | null, derEtat: EtatDer, derLastChangeDate: any, derReferenceDate?: any | null, etatGlobal: EtatGlobalInvestisseur, etatGlobalLastChangeDate: any, fiscaliteState: RecueilStepState, id: any, investisseurId: any, isRecueilFormCompleted: boolean, lastChangeDate: any, metadatasConnaissanceClientId: any, objectifsState: RecueilStepState, patrimoineState: RecueilStepState, qpIdocumentID?: string | null, qpiEtat: EtatQpi, qpiLastChangeDate: any, qpiReferenceDate?: any | null, recueildocumentID?: string | null, recueilEtat: EtatRecueil, recueilLastChangeDate: any, recueilReferenceDate?: any | null, situationPersonnelleState: RecueilStepState, statutFormulaireQPI: FormulaireStatut, statutFormulaireRecueil: FormulaireStatut, metadatasConnaissanceClient: { __typename?: 'MetadatasConnaissanceClient', id: any } }> } | null, investisseur?: { __typename?: 'MetadatasConnaissanceClient', id: any, avancementsConnaissanceClientInvestisseurs: Array<{ __typename?: 'AvancementConnaissanceClientInvestisseur', budgetState: RecueilStepState, cnIdocumentID?: string | null, cniEtat: EtatCni, cniLastChangeDate: any, cniReferenceDate?: any | null, deRdocumentID?: string | null, derEtat: EtatDer, derLastChangeDate: any, derReferenceDate?: any | null, etatGlobal: EtatGlobalInvestisseur, etatGlobalLastChangeDate: any, fiscaliteState: RecueilStepState, id: any, investisseurId: any, isRecueilFormCompleted: boolean, lastChangeDate: any, metadatasConnaissanceClientId: any, objectifsState: RecueilStepState, patrimoineState: RecueilStepState, qpIdocumentID?: string | null, qpiEtat: EtatQpi, qpiLastChangeDate: any, qpiReferenceDate?: any | null, recueildocumentID?: string | null, recueilEtat: EtatRecueil, recueilLastChangeDate: any, recueilReferenceDate?: any | null, situationPersonnelleState: RecueilStepState, statutFormulaireQPI: FormulaireStatut, statutFormulaireRecueil: FormulaireStatut, metadatasConnaissanceClient: { __typename?: 'MetadatasConnaissanceClient', id: any } }> } | null };

export type GetApplicationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApplicationSettingsQuery = { __typename?: 'Query', applicationSettings: Array<{ __typename?: 'ApplicationSetting', key: string, value?: string | null }> };

export type ConsultantEtiquettesQueryVariables = Exact<{
  consultantCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConsultantEtiquettesQuery = { __typename?: 'Query', consultantEtiquettes: Array<{ __typename?: 'Etiquette', id: any, label: string, color: string }> };

export type ConsultantPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsultantPreferencesQuery = { __typename?: 'Query', consultantPreferences: Array<{ __typename?: 'ConsultantPreferences', graphType1?: ContratDetailGraphEnum | null, graphType2?: ContratDetailGraphEnum | null, contratsGraphType1?: ConsultantContratsGraphEnum | null, contratsGraphType2?: ConsultantContratsGraphEnum | null, supportsGraphType1?: ConsultantSupportsGraphEnum | null, supportsGraphType2?: ConsultantSupportsGraphEnum | null }> };

export type RechercheForConsultantQueryVariables = Exact<{
  order?: InputMaybe<Array<RechercheSauvegardeSortInput> | RechercheSauvegardeSortInput>;
}>;


export type RechercheForConsultantQuery = { __typename?: 'Query', rechercheForConsultant: Array<{ __typename?: 'RechercheSauvegarde', id: any, label: string, dateModification: any, filtres: Array<{ __typename?: 'FiltreSetting', builderCode: string, operator: string, value: string }> }> };

export type GenerateRecueilMutationVariables = Exact<{
  recueilMetadataId: Scalars['Long']['input'];
  investisseurPrincipalId: Scalars['Long']['input'];
  avecCoInvestisseur: Scalars['Boolean']['input'];
}>;


export type GenerateRecueilMutation = { __typename?: 'Mutation', generateRecueil?: { __typename?: 'StorageFile', createdDate?: any | null, denomination?: string | null, documentType: DocumentTypeEnum, fileExtension: string, fileName: string, fileType: string, id: string, isBlob: boolean, isTemporary?: boolean | null, lastModificationDate?: any | null, status?: FileStorageStatus | null, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', blobFileId: string, expiration: any, permissions: Array<BlobFilesPermissionDs>, sasUrl: string } | null } | null };

export type GetRecueilStateQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetRecueilStateQuery = { __typename?: 'Query', investisseurByCode?: { __typename?: 'Investisseur', avancementConnaissanceClientInvestisseur?: { __typename?: 'AvancementConnaissanceClientInvestisseur', budgetState: RecueilStepState, cnIdocumentID?: string | null, cniEtat: EtatCni, cniLastChangeDate: any, cniReferenceDate?: any | null, deRdocumentID?: string | null, derEtat: EtatDer, derLastChangeDate: any, derReferenceDate?: any | null, etatGlobal: EtatGlobalInvestisseur, etatGlobalLastChangeDate: any, fiscaliteState: RecueilStepState, id: any, investisseurId: any, isRecueilFormCompleted: boolean, lastChangeDate: any, metadatasConnaissanceClientId: any, objectifsState: RecueilStepState, patrimoineState: RecueilStepState, qpIdocumentID?: string | null, qpiEtat: EtatQpi, qpiLastChangeDate: any, qpiReferenceDate?: any | null, recueildocumentID?: string | null, recueilEtat: EtatRecueil, recueilLastChangeDate: any, recueilReferenceDate?: any | null, situationPersonnelleState: RecueilStepState, statutFormulaireQPI: FormulaireStatut, statutFormulaireRecueil: FormulaireStatut, metadatasConnaissanceClient: { __typename?: 'MetadatasConnaissanceClient', id: any } } | null } | null };

export type InvestisseurByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type InvestisseurByCodeQuery = { __typename?: 'Query', investisseurByCode?: { __typename?: 'Investisseur', code: string, id: any, pendingPurge: boolean, statutCode: string, avancementConnaissanceClientInvestisseur?: { __typename?: 'AvancementConnaissanceClientInvestisseur', budgetState: RecueilStepState, cnIdocumentID?: string | null, cniEtat: EtatCni, cniLastChangeDate: any, cniReferenceDate?: any | null, deRdocumentID?: string | null, derEtat: EtatDer, derLastChangeDate: any, derReferenceDate?: any | null, etatGlobal: EtatGlobalInvestisseur, etatGlobalLastChangeDate: any, fiscaliteState: RecueilStepState, id: any, investisseurId: any, isRecueilFormCompleted: boolean, lastChangeDate: any, metadatasConnaissanceClientId: any, objectifsState: RecueilStepState, patrimoineState: RecueilStepState, qpIdocumentID?: string | null, qpiEtat: EtatQpi, qpiLastChangeDate: any, qpiReferenceDate?: any | null, recueildocumentID?: string | null, recueilEtat: EtatRecueil, recueilLastChangeDate: any, recueilReferenceDate?: any | null, situationPersonnelleState: RecueilStepState, statutFormulaireQPI: FormulaireStatut, statutFormulaireRecueil: FormulaireStatut, metadatasConnaissanceClient: { __typename?: 'MetadatasConnaissanceClient', id: any } } | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', id: any, dateNaissance?: any | null, nom: string, prenom: string, nomNaissance?: string | null, villeNaissanceNom?: string | null, departementNaissance?: string | null, codePaysNaissance?: string | null, codePaysNaissanceNavigation?: { __typename?: 'Pays', libelle: string } | null, email: Array<{ __typename?: 'Email', id: any, adresse: string, estAdresseCorrespondance?: boolean | null }>, adresse: Array<{ __typename?: 'Adresse', adresse1?: string | null, adresse2?: string | null, adresse3?: string | null, complement?: string | null, codePostalCode?: string | null, villeNom?: string | null, paysCode?: string | null, typeAdresseCode: string, paysCodeNavigation?: { __typename?: 'Pays', libelle: string } | null }>, telephone: Array<{ __typename?: 'Telephone', id: any, numero: string, estNumeroCorrespondance?: boolean | null }>, etatCivil?: { __typename?: 'EtatCivil', personnePhysiqueId: any, typeSituationEtatCivilCode?: string | null, regimePacsIndivision?: boolean | null, typeRegimeSituationEtatCivilCode?: string | null, nombreEnfantACharge?: any | null, typeSituationEtatCivilCodeNavigation?: { __typename?: 'TypeSituationEtatCivil', libelle: string, actif?: boolean | null } | null, typeRegimeSituationEtatCivilCodeNavigation?: { __typename?: 'TypeRegimeSituationEtatCivil', libelle: string } | null } | null, situationProfessionnelle?: { __typename?: 'SituationProfessionnelle', profession?: string | null, origineRevenus?: string | null, nomSociete?: string | null, categorieSocioProfessionnelleCodeAtlas?: any | null, note: Array<{ __typename?: 'Note', note1: string }>, categorieSocioProfessionnelleCodeAtlasNavigation?: { __typename?: 'CategorieSocioProfessionnelle', parent?: any | null } | null } | null, relationFamillePersonnePhysique: Array<{ __typename?: 'RelationFamilleSimple', typeRelationFamilleCode: string, autrePersonnePhysique?: { __typename?: 'PersonnePhysique', investisseur: Array<{ __typename?: 'Investisseur', code: string, id: any }> } | null }>, relationCouplePersonnePhysique?: { __typename?: 'RelationCoupleSimple', typeRelationCoupleCode: string, autrePersonnePhysiqueId?: any | null, autrePersonnePhysique?: { __typename?: 'PersonnePhysique', nom: string, prenom: string, nomNaissance?: string | null, dateNaissance?: any | null, villeNaissanceNom?: string | null, departementNaissance?: string | null, codePaysNaissance?: string | null, codePaysNaissanceNavigation?: { __typename?: 'Pays', libelle: string } | null, adresse: Array<{ __typename?: 'Adresse', adresse1?: string | null, adresse2?: string | null, adresse3?: string | null, complement?: string | null, codePostalCode?: string | null, villeNom?: string | null, paysCode?: string | null, typeAdresseCode: string, paysCodeNavigation?: { __typename?: 'Pays', libelle: string } | null }>, situationProfessionnelle?: { __typename?: 'SituationProfessionnelle', profession?: string | null, origineRevenus?: string | null, nomSociete?: string | null, categorieSocioProfessionnelleCodeAtlas?: any | null, note: Array<{ __typename?: 'Note', note1: string }>, categorieSocioProfessionnelleCodeAtlasNavigation?: { __typename?: 'CategorieSocioProfessionnelle', parent?: any | null } | null } | null, etatCivil?: { __typename?: 'EtatCivil', personnePhysiqueId: any, typeSituationEtatCivilCode?: string | null, nombreEnfantACharge?: any | null, typeSituationEtatCivilCodeNavigation?: { __typename?: 'TypeSituationEtatCivil', libelle: string, actif?: boolean | null } | null, typeRegimeSituationEtatCivilCodeNavigation?: { __typename?: 'TypeRegimeSituationEtatCivil', libelle: string } | null } | null, investisseur: Array<{ __typename?: 'Investisseur', code: string, id: any, statutCode: string, avancementConnaissanceClientInvestisseur?: { __typename?: 'AvancementConnaissanceClientInvestisseur', id: any, cnIdocumentID?: string | null, cniEtat: EtatCni, cniLastChangeDate: any, derEtat: EtatDer, deRdocumentID?: string | null, qpiEtat: EtatQpi, qpIdocumentID?: string | null, isRecueilFormCompleted: boolean, recueilEtat: EtatRecueil, recueildocumentID?: string | null, metadatasConnaissanceClient: { __typename?: 'MetadatasConnaissanceClient', id: any } } | null }>, telephone: Array<{ __typename?: 'Telephone', numero: string, estNumeroCorrespondance?: boolean | null }>, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null }> } | null } | null }>, etiquettes?: Array<{ __typename?: 'Etiquette', color: string, id: any, label: string }> | null, investisseurConsultantRelations?: Array<{ __typename?: 'InvestisseurRelationConsultant', consultantCode?: string | null, consultantId: any, nom?: string | null, prenom?: string | null, typeRelationInvestisseurConsultantCode?: string | null }> | null } | null };

export type GetInvestisseurCodeByIdQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type GetInvestisseurCodeByIdQuery = { __typename?: 'Query', investisseurById?: { __typename?: 'Investisseur', code: string } | null };

export type InvestisseurDoublonKeyByIdQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type InvestisseurDoublonKeyByIdQuery = { __typename?: 'Query', investisseurById?: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, dateNaissance?: any | null }> } | null };

export type UpdateInvestisseurBilanFinancierMutationVariables = Exact<{
  bilan: BilanFinancierInput;
}>;


export type UpdateInvestisseurBilanFinancierMutation = { __typename?: 'Mutation', updateInvestisseurBilanFinancier?: { __typename?: 'InvestisseurBilanFinancier', id: number, investisseurId: any, manuelActif: any, manuelPassif: any, manuelPrevoyance: any, manuelRevenus: any, manuelCharges: any, computedActif: any, computedPassif: any, computedPrevoyance: any, computedRevenus: any, computedCharges: any } | null };

export type InvestisseurBilanFinancierByIdQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type InvestisseurBilanFinancierByIdQuery = { __typename?: 'Query', investisseurById?: { __typename?: 'Investisseur', bilanFinancier?: { __typename?: 'InvestisseurBilanFinancier', id: number, investisseurId: any, manuelActif: any, manuelPassif: any, manuelPrevoyance: any, manuelRevenus: any, manuelCharges: any, computedActif: any, computedPassif: any, computedPrevoyance: any, computedRevenus: any, computedCharges: any, effectiveActif: any, effectivePassif: any, effectivePrevoyance: any, effectiveRevenus: any, effectiveCharges: any, dateProchaineEcheance?: any | null, aCreditEnCours: boolean } | null } | null };

export type InvestisseurRelationDeCoupleByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type InvestisseurRelationDeCoupleByCodeQuery = { __typename?: 'Query', investisseurByCode?: { __typename: 'Investisseur', id: any, personnePhysique: Array<{ __typename?: 'PersonnePhysique', id: any, nom: string, prenom: string, relationCouplePersonnePhysique?: { __typename?: 'RelationCoupleSimple', autrePersonnePhysique?: { __typename?: 'PersonnePhysique', id: any, nom: string, prenom: string, investisseur: Array<{ __typename: 'Investisseur', id: any, code: string }> } | null } | null }> } | null };

export type RelationsFragmentFragment = { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', id: any, relationFamillePersonnePhysique: Array<{ __typename?: 'RelationFamilleSimple', typeRelationFamilleCode: string, autoriteParentale?: boolean | null, autrePersonnePhysique?: { __typename?: 'PersonnePhysique', code?: string | null, id: any, nom: string, prenom: string, dateNaissance?: any | null, etatCivil?: { __typename?: 'EtatCivil', typeSituationEtatCivilCode?: string | null } | null, investisseur: Array<{ __typename?: 'Investisseur', id: any, statutCode: string }>, telephone: Array<{ __typename?: 'Telephone', numero: string, estNumeroCorrespondance?: boolean | null }>, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null }> } | null }>, relationFamillePersonnePhysique1: Array<{ __typename?: 'RelationFamille', typeRelationFamilleCode: string, autoriteParentale: boolean, personnePhysique1: { __typename?: 'PersonnePhysique', id: any }, personnePhysique2: { __typename?: 'PersonnePhysique', id: any } }>, relationFamillePersonnePhysique2: Array<{ __typename?: 'RelationFamille', typeRelationFamilleCode: string, autoriteParentale: boolean, personnePhysique1: { __typename?: 'PersonnePhysique', id: any }, personnePhysique2: { __typename?: 'PersonnePhysique', id: any } }>, relationAutrePersonnePhysique: Array<{ __typename?: 'RelationAutreSimple', typeRelationAutreCode: string, autrePersonnePhysique?: { __typename?: 'PersonnePhysique', code?: string | null, id: any, nom: string, prenom: string, dateNaissance?: any | null, etatCivil?: { __typename?: 'EtatCivil', typeSituationEtatCivilCode?: string | null } | null, investisseur: Array<{ __typename?: 'Investisseur', id: any, statutCode: string }>, telephone: Array<{ __typename?: 'Telephone', numero: string, estNumeroCorrespondance?: boolean | null }>, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null }> } | null }> }> };

export type InvestisseurRelationByCodeQueryVariables = Exact<{
  investisseurCode: Scalars['String']['input'];
  hasCoInvestisseur?: Scalars['Boolean']['input'];
  coInvestisseurCode?: Scalars['String']['input'];
}>;


export type InvestisseurRelationByCodeQuery = { __typename?: 'Query', investisseur?: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', id: any, relationFamillePersonnePhysique: Array<{ __typename?: 'RelationFamilleSimple', typeRelationFamilleCode: string, autoriteParentale?: boolean | null, autrePersonnePhysique?: { __typename?: 'PersonnePhysique', code?: string | null, id: any, nom: string, prenom: string, dateNaissance?: any | null, etatCivil?: { __typename?: 'EtatCivil', typeSituationEtatCivilCode?: string | null } | null, investisseur: Array<{ __typename?: 'Investisseur', id: any, statutCode: string }>, telephone: Array<{ __typename?: 'Telephone', numero: string, estNumeroCorrespondance?: boolean | null }>, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null }> } | null }>, relationFamillePersonnePhysique1: Array<{ __typename?: 'RelationFamille', typeRelationFamilleCode: string, autoriteParentale: boolean, personnePhysique1: { __typename?: 'PersonnePhysique', id: any }, personnePhysique2: { __typename?: 'PersonnePhysique', id: any } }>, relationFamillePersonnePhysique2: Array<{ __typename?: 'RelationFamille', typeRelationFamilleCode: string, autoriteParentale: boolean, personnePhysique1: { __typename?: 'PersonnePhysique', id: any }, personnePhysique2: { __typename?: 'PersonnePhysique', id: any } }>, relationAutrePersonnePhysique: Array<{ __typename?: 'RelationAutreSimple', typeRelationAutreCode: string, autrePersonnePhysique?: { __typename?: 'PersonnePhysique', code?: string | null, id: any, nom: string, prenom: string, dateNaissance?: any | null, etatCivil?: { __typename?: 'EtatCivil', typeSituationEtatCivilCode?: string | null } | null, investisseur: Array<{ __typename?: 'Investisseur', id: any, statutCode: string }>, telephone: Array<{ __typename?: 'Telephone', numero: string, estNumeroCorrespondance?: boolean | null }>, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null }> } | null }> }> } | null, coInvestisseur?: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', id: any, relationFamillePersonnePhysique: Array<{ __typename?: 'RelationFamilleSimple', typeRelationFamilleCode: string, autoriteParentale?: boolean | null, autrePersonnePhysique?: { __typename?: 'PersonnePhysique', code?: string | null, id: any, nom: string, prenom: string, dateNaissance?: any | null, etatCivil?: { __typename?: 'EtatCivil', typeSituationEtatCivilCode?: string | null } | null, investisseur: Array<{ __typename?: 'Investisseur', id: any, statutCode: string }>, telephone: Array<{ __typename?: 'Telephone', numero: string, estNumeroCorrespondance?: boolean | null }>, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null }> } | null }>, relationFamillePersonnePhysique1: Array<{ __typename?: 'RelationFamille', typeRelationFamilleCode: string, autoriteParentale: boolean, personnePhysique1: { __typename?: 'PersonnePhysique', id: any }, personnePhysique2: { __typename?: 'PersonnePhysique', id: any } }>, relationFamillePersonnePhysique2: Array<{ __typename?: 'RelationFamille', typeRelationFamilleCode: string, autoriteParentale: boolean, personnePhysique1: { __typename?: 'PersonnePhysique', id: any }, personnePhysique2: { __typename?: 'PersonnePhysique', id: any } }>, relationAutrePersonnePhysique: Array<{ __typename?: 'RelationAutreSimple', typeRelationAutreCode: string, autrePersonnePhysique?: { __typename?: 'PersonnePhysique', code?: string | null, id: any, nom: string, prenom: string, dateNaissance?: any | null, etatCivil?: { __typename?: 'EtatCivil', typeSituationEtatCivilCode?: string | null } | null, investisseur: Array<{ __typename?: 'Investisseur', id: any, statutCode: string }>, telephone: Array<{ __typename?: 'Telephone', numero: string, estNumeroCorrespondance?: boolean | null }>, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null }> } | null }> }> } | null };

export type BudgetDtoDetailFragment = { __typename?: 'BudgetDto', budgetId: any, designation?: string | null, patrimoineId?: any | null, foyerFiscalId: any, montant: any, typeBudgetCode: string, isGenerated: boolean, dureeRestante?: number | null, dateFin?: any | null, capitalRestantDu?: any | null, commentaire?: string | null, budgetInvestisseurs: Array<{ __typename?: 'BudgetInvestisseurDto', investisseurId: any, pourcentageDetention: any, investisseur?: { __typename?: 'Investisseur', id: any, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }> };

export type AllBudgetDtoInvestisseursFragment = { __typename?: 'Investisseur', id: any, code: string, foyerFiscalId?: any | null, allBudgets?: Array<{ __typename?: 'BudgetDto', budgetId: any, designation?: string | null, patrimoineId?: any | null, foyerFiscalId: any, montant: any, typeBudgetCode: string, isGenerated: boolean, dureeRestante?: number | null, dateFin?: any | null, capitalRestantDu?: any | null, commentaire?: string | null, budgetInvestisseurs: Array<{ __typename?: 'BudgetInvestisseurDto', investisseurId: any, pourcentageDetention: any, investisseur?: { __typename?: 'Investisseur', id: any, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }> }> | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', relationCouplePersonnePhysique?: { __typename?: 'RelationCoupleSimple', autrePersonnePhysique?: { __typename?: 'PersonnePhysique', investisseur: Array<{ __typename?: 'Investisseur', allBudgets?: Array<{ __typename?: 'BudgetDto', budgetId: any, designation?: string | null, patrimoineId?: any | null, foyerFiscalId: any, montant: any, typeBudgetCode: string, isGenerated: boolean, dureeRestante?: number | null, dateFin?: any | null, capitalRestantDu?: any | null, commentaire?: string | null, budgetInvestisseurs: Array<{ __typename?: 'BudgetInvestisseurDto', investisseurId: any, pourcentageDetention: any, investisseur?: { __typename?: 'Investisseur', id: any, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }> }> | null }> } | null } | null }> };

export type PatrimoineAssocieBudgetFragmentFragment = { __typename?: 'PatrimoineBudget', patrimoine: { __typename?: 'Patrimoine', creationDate: any, categorieCode: any, designation?: string | null, id: any, patrimoineCategorie: { __typename?: 'PatrimoineCategorieReference', categoryLibelle: string, subCategoryLibelle?: string | null, subCategory2Libelle?: string | null }, investisseurPatrimoines: Array<{ __typename?: 'InvestisseurPatrimoine', id: any, investisseurId?: any | null, detentionPP?: any | null, detentionNP?: any | null, detentionUS?: any | null, investisseur?: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }>, patrimoineActif?: { __typename?: 'Actif', id: any, type?: TypeActifEnum | null, modeDetention?: TypeDetentionEnum | null, valeurEstimee: any } | null, patrimoinePassif?: { __typename?: 'Passif', id: any, montant: any } | null, patrimoinePrevoyance?: { __typename?: 'PatrimoinePrevoyance', capitalAssure: any, id: any } | null } };

export type BudgetDetailFragmentFragment = { __typename?: 'Budget', id: any, designation?: string | null, montantAnnuel: any, typeBudgetId: number, commentaire?: string | null, typeBudget: { __typename?: 'TypeBudget', id: number, code: string }, budgetInvestisseurs: Array<{ __typename?: 'BudgetInvestisseur', investisseurId: any, investisseur: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } }>, patrimoineBudget?: { __typename?: 'PatrimoineBudget', patrimoine: { __typename?: 'Patrimoine', creationDate: any, categorieCode: any, designation?: string | null, id: any, patrimoineCategorie: { __typename?: 'PatrimoineCategorieReference', categoryLibelle: string, subCategoryLibelle?: string | null, subCategory2Libelle?: string | null }, investisseurPatrimoines: Array<{ __typename?: 'InvestisseurPatrimoine', id: any, investisseurId?: any | null, detentionPP?: any | null, detentionNP?: any | null, detentionUS?: any | null, investisseur?: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }>, patrimoineActif?: { __typename?: 'Actif', id: any, type?: TypeActifEnum | null, modeDetention?: TypeDetentionEnum | null, valeurEstimee: any } | null, patrimoinePassif?: { __typename?: 'Passif', id: any, montant: any } | null, patrimoinePrevoyance?: { __typename?: 'PatrimoinePrevoyance', capitalAssure: any, id: any } | null } } | null };

export type CreateBudgetMutationVariables = Exact<{
  input: BudgetCreationInput;
}>;


export type CreateBudgetMutation = { __typename?: 'Mutation', createBudget: Array<{ __typename?: 'Budget', id: any }> };

export type DeleteBudgetMutationVariables = Exact<{
  budgetId: Scalars['Long']['input'];
}>;


export type DeleteBudgetMutation = { __typename?: 'Mutation', deleteBudget: boolean };

export type UpdateBudgetMutationVariables = Exact<{
  input: BudgetModificationInput;
}>;


export type UpdateBudgetMutation = { __typename?: 'Mutation', updateBudget: Array<{ __typename?: 'Budget', id: any }> };

export type BudgetByIdQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type BudgetByIdQuery = { __typename?: 'Query', budget: Array<{ __typename?: 'Budget', id: any, designation?: string | null, montantAnnuel: any, typeBudgetId: number, commentaire?: string | null, typeBudget: { __typename?: 'TypeBudget', id: number, code: string }, budgetInvestisseurs: Array<{ __typename?: 'BudgetInvestisseur', investisseurId: any, investisseur: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } }>, patrimoineBudget?: { __typename?: 'PatrimoineBudget', patrimoine: { __typename?: 'Patrimoine', creationDate: any, categorieCode: any, designation?: string | null, id: any, patrimoineCategorie: { __typename?: 'PatrimoineCategorieReference', categoryLibelle: string, subCategoryLibelle?: string | null, subCategory2Libelle?: string | null }, investisseurPatrimoines: Array<{ __typename?: 'InvestisseurPatrimoine', id: any, investisseurId?: any | null, detentionPP?: any | null, detentionNP?: any | null, detentionUS?: any | null, investisseur?: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }>, patrimoineActif?: { __typename?: 'Actif', id: any, type?: TypeActifEnum | null, modeDetention?: TypeDetentionEnum | null, valeurEstimee: any } | null, patrimoinePassif?: { __typename?: 'Passif', id: any, montant: any } | null, patrimoinePrevoyance?: { __typename?: 'PatrimoinePrevoyance', capitalAssure: any, id: any } | null } } | null }> };

export type GetBudgetByInvestisseurQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetBudgetByInvestisseurQuery = { __typename?: 'Query', investisseur?: { __typename?: 'Investisseur', id: any, code: string, foyerFiscalId?: any | null, allBudgets?: Array<{ __typename?: 'BudgetDto', budgetId: any, designation?: string | null, patrimoineId?: any | null, foyerFiscalId: any, montant: any, typeBudgetCode: string, isGenerated: boolean, dureeRestante?: number | null, dateFin?: any | null, capitalRestantDu?: any | null, commentaire?: string | null, budgetInvestisseurs: Array<{ __typename?: 'BudgetInvestisseurDto', investisseurId: any, pourcentageDetention: any, investisseur?: { __typename?: 'Investisseur', id: any, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }> }> | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', relationCouplePersonnePhysique?: { __typename?: 'RelationCoupleSimple', autrePersonnePhysique?: { __typename?: 'PersonnePhysique', investisseur: Array<{ __typename?: 'Investisseur', allBudgets?: Array<{ __typename?: 'BudgetDto', budgetId: any, designation?: string | null, patrimoineId?: any | null, foyerFiscalId: any, montant: any, typeBudgetCode: string, isGenerated: boolean, dureeRestante?: number | null, dateFin?: any | null, capitalRestantDu?: any | null, commentaire?: string | null, budgetInvestisseurs: Array<{ __typename?: 'BudgetInvestisseurDto', investisseurId: any, pourcentageDetention: any, investisseur?: { __typename?: 'Investisseur', id: any, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }> }> | null }> } | null } | null }> } | null, typesBudgets: Array<{ __typename?: 'TypeBudget', id: number, code: string, categorie: CategorieBudgetEnum, sousCategorie: SousCategorieBudgetEnum, sousCategorie2?: SousCategorie2BudgetEnum | null, isRevenu: boolean }> };

export type CoupleInvestisseurQueryVariables = Exact<{
  code: Scalars['String']['input'];
  consultantId: Scalars['Long']['input'];
}>;


export type CoupleInvestisseurQuery = { __typename?: 'Query', investisseur?: { __typename?: 'Investisseur', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', code?: string | null, nom: string, prenom: string, relationCouplePersonnePhysique?: { __typename?: 'RelationCoupleSimple', autrePersonnePhysique?: { __typename?: 'PersonnePhysique', id: any, code?: string | null, nom: string, prenom: string, investisseur: Array<{ __typename?: 'Investisseur', id: any, code: string }> } | null } | null }> } | null };

export type TypesBudgetsQueryVariables = Exact<{
  order?: InputMaybe<Array<TypeBudgetSortInput> | TypeBudgetSortInput>;
  where?: InputMaybe<TypeBudgetFilterInput>;
}>;


export type TypesBudgetsQuery = { __typename?: 'Query', typesBudgets: Array<{ __typename?: 'TypeBudget', categorie: CategorieBudgetEnum, code: string, id: number, isRevenu: boolean, sousCategorie: SousCategorieBudgetEnum, sousCategorie2?: SousCategorie2BudgetEnum | null }> };

export type FetchDerMutationVariables = Exact<{
  consultantCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchDerMutation = { __typename?: 'Mutation', existingDEROrGenerateIt?: { __typename?: 'DERResponse', isGestionPrivee: boolean, fieldsToComplete?: Array<{ __typename?: 'FieldToComplete', type: TypeMissingFieldEnum, message: string }> | null, storageFiles?: Array<{ __typename?: 'StorageFile', consultantCode?: string | null, createdDate?: any | null, denomination?: string | null, documentType: DocumentTypeEnum, fileExtension: string, fileName: string, fileType: string, id: string, isBlob: boolean, status?: FileStorageStatus | null, fileNameWithExtension?: string | null, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', expiration: any, permissions: Array<BlobFilesPermissionDs>, sasUrl: string } | null }> | null } | null };

export type ForceDerUpdateMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
  consultantCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ForceDerUpdateMutation = { __typename?: 'Mutation', forceDERUpdate?: { __typename?: 'DERResponse', fieldsToComplete?: Array<{ __typename?: 'FieldToComplete', type: TypeMissingFieldEnum, message: string }> | null, storageFiles?: Array<{ __typename?: 'StorageFile', consultantCode?: string | null, createdDate?: any | null, denomination?: string | null, documentType: DocumentTypeEnum, fileExtension: string, fileName: string, fileType: string, id: string, isBlob: boolean, status?: FileStorageStatus | null, fileNameWithExtension?: string | null, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', expiration: any, permissions: Array<BlobFilesPermissionDs>, sasUrl: string } | null }> | null } | null };

export type CheckInvestisseurMutationVariables = Exact<{
  investisseurIds: Array<Scalars['Long']['input']> | Scalars['Long']['input'];
}>;


export type CheckInvestisseurMutation = { __typename?: 'Mutation', checkInvestisseurs: Array<{ __typename?: 'Investisseur', id: any, foyerFiscal?: { __typename?: 'FoyerFiscal', id: any, imposableImpotFortuneImmo: boolean, imposableImpotRevenu: boolean, impotAnneeRevenus?: number | null, totalSalairesAssimiles?: any | null, revenusBrutGlobal?: any | null, impotAutre?: number | null, impotAutreCommentaire?: string | null, impotFortuneAnneeRevenus?: number | null, impotFortuneImmoCommentaire?: string | null, impotFortuneImmoNet?: number | null, impotRevenuBrut?: number | null, impotRevenuCommentaire?: string | null, impotRevenuNet?: number | null, impotRevenuTauxMarginal?: number | null, impotRevenuTotalCredit?: any | null, impotRevenuTotalReduction?: any | null, impotTotalAvantCreditsImpot?: any | null, csgDeductible?: any | null, chargesDeductiblesDuRevenuGlobal?: any | null, totalDesPrelevementsSociaux?: any | null, isCompleted: boolean, nbParts?: any | null, plafondEpargneRetraireNonUtilise?: any | null } | null }> };

export type UpdateFoyerFiscalDataMutationVariables = Exact<{
  input: FoyerFiscalUpdateDataInput;
}>;


export type UpdateFoyerFiscalDataMutation = { __typename?: 'Mutation', updateFoyerFiscalData?: { __typename?: 'FoyerFiscal', id: any, imposableImpotFortuneImmo: boolean, imposableImpotRevenu: boolean, impotAnneeRevenus?: number | null, totalSalairesAssimiles?: any | null, revenusBrutGlobal?: any | null, impotAutre?: number | null, impotAutreCommentaire?: string | null, impotFortuneAnneeRevenus?: number | null, impotFortuneImmoCommentaire?: string | null, impotFortuneImmoNet?: number | null, impotRevenuBrut?: number | null, impotRevenuCommentaire?: string | null, impotRevenuNet?: number | null, impotRevenuTauxMarginal?: number | null, impotRevenuTotalCredit?: any | null, impotRevenuTotalReduction?: any | null, impotTotalAvantCreditsImpot?: any | null, csgDeductible?: any | null, chargesDeductiblesDuRevenuGlobal?: any | null, totalDesPrelevementsSociaux?: any | null, isCompleted: boolean, nbParts?: any | null, plafondEpargneRetraireNonUtilise?: any | null } | null };

export type UpdateFoyerFiscalSeparateDataMutationVariables = Exact<{
  foyerInvestisseur: FoyerFiscalUpdateDataInput;
  foyerConjoint: FoyerFiscalUpdateDataInput;
}>;


export type UpdateFoyerFiscalSeparateDataMutation = { __typename?: 'Mutation', conjoint?: { __typename?: 'FoyerFiscal', id: any, imposableImpotFortuneImmo: boolean, imposableImpotRevenu: boolean, impotAnneeRevenus?: number | null, totalSalairesAssimiles?: any | null, revenusBrutGlobal?: any | null, impotAutre?: number | null, impotAutreCommentaire?: string | null, impotFortuneAnneeRevenus?: number | null, impotFortuneImmoCommentaire?: string | null, impotFortuneImmoNet?: number | null, impotRevenuBrut?: number | null, impotRevenuCommentaire?: string | null, impotRevenuNet?: number | null, impotRevenuTauxMarginal?: number | null, impotRevenuTotalCredit?: any | null, impotRevenuTotalReduction?: any | null, impotTotalAvantCreditsImpot?: any | null, csgDeductible?: any | null, chargesDeductiblesDuRevenuGlobal?: any | null, totalDesPrelevementsSociaux?: any | null, isCompleted: boolean, nbParts?: any | null, plafondEpargneRetraireNonUtilise?: any | null } | null, investisseur?: { __typename?: 'FoyerFiscal', id: any, imposableImpotFortuneImmo: boolean, imposableImpotRevenu: boolean, impotAnneeRevenus?: number | null, totalSalairesAssimiles?: any | null, revenusBrutGlobal?: any | null, impotAutre?: number | null, impotAutreCommentaire?: string | null, impotFortuneAnneeRevenus?: number | null, impotFortuneImmoCommentaire?: string | null, impotFortuneImmoNet?: number | null, impotRevenuBrut?: number | null, impotRevenuCommentaire?: string | null, impotRevenuNet?: number | null, impotRevenuTauxMarginal?: number | null, impotRevenuTotalCredit?: any | null, impotRevenuTotalReduction?: any | null, impotTotalAvantCreditsImpot?: any | null, csgDeductible?: any | null, chargesDeductiblesDuRevenuGlobal?: any | null, totalDesPrelevementsSociaux?: any | null, isCompleted: boolean, nbParts?: any | null, plafondEpargneRetraireNonUtilise?: any | null } | null };

export type InvestisseurFoyerFiscalQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type InvestisseurFoyerFiscalQuery = { __typename?: 'Query', investisseur?: { __typename?: 'Investisseur', id: any, code: string, foyerFiscal?: { __typename?: 'FoyerFiscal', id: any, imposableImpotFortuneImmo: boolean, imposableImpotRevenu: boolean, impotAnneeRevenus?: number | null, totalSalairesAssimiles?: any | null, revenusBrutGlobal?: any | null, impotAutre?: number | null, impotAutreCommentaire?: string | null, impotFortuneAnneeRevenus?: number | null, impotFortuneImmoCommentaire?: string | null, impotFortuneImmoNet?: number | null, impotRevenuBrut?: number | null, impotRevenuCommentaire?: string | null, impotRevenuNet?: number | null, impotRevenuTauxMarginal?: number | null, impotRevenuTotalCredit?: any | null, impotRevenuTotalReduction?: any | null, impotTotalAvantCreditsImpot?: any | null, csgDeductible?: any | null, chargesDeductiblesDuRevenuGlobal?: any | null, totalDesPrelevementsSociaux?: any | null, isCompleted: boolean, nbParts?: any | null, plafondEpargneRetraireNonUtilise?: any | null } | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, relationCouplePersonnePhysique?: { __typename?: 'RelationCoupleSimple', typeRelationCoupleCode: string, autrePersonnePhysique?: { __typename?: 'PersonnePhysique', nom: string, prenom: string, investisseur: Array<{ __typename?: 'Investisseur', id: any, code: string, foyerFiscal?: { __typename?: 'FoyerFiscal', id: any, imposableImpotFortuneImmo: boolean, imposableImpotRevenu: boolean, impotAnneeRevenus?: number | null, totalSalairesAssimiles?: any | null, revenusBrutGlobal?: any | null, impotAutre?: number | null, impotAutreCommentaire?: string | null, impotFortuneAnneeRevenus?: number | null, impotFortuneImmoCommentaire?: string | null, impotFortuneImmoNet?: number | null, impotRevenuBrut?: number | null, impotRevenuCommentaire?: string | null, impotRevenuNet?: number | null, impotRevenuTauxMarginal?: number | null, impotRevenuTotalCredit?: any | null, impotRevenuTotalReduction?: any | null, impotTotalAvantCreditsImpot?: any | null, csgDeductible?: any | null, chargesDeductiblesDuRevenuGlobal?: any | null, totalDesPrelevementsSociaux?: any | null, isCompleted: boolean, nbParts?: any | null, plafondEpargneRetraireNonUtilise?: any | null } | null }> } | null } | null }> } | null };

export type ObjectifStepDetailsFragmentFragment = { __typename?: 'Investisseur', id: any, code: string, objectifDefinis?: Array<{ __typename?: 'ObjectifDefini', priorite?: number | null, horizon?: number | null, objectifReferenceCode: string, commentaire?: string | null, objectif: { __typename?: 'ObjectifReference', categorieCode: string, code: string, libelle: string } }> | null, capaciteFinanciere?: { __typename?: 'CapaciteFinanciere', commentaire?: string | null, epargnePrecautionCible?: any | null, effortEpargne?: any | null, levierType?: LevierType | null } | null, engagementBudgetaire?: { __typename?: 'EngagementBudgetaire', mensualiteCreditTotale: number, tauxEndettement?: number | null, capaciteRemboursementRestanteMensuel: number, soldeBudgetMensuel: any } | null, capaciteEpargne?: { __typename?: 'CapaciteEpargneDetail', capaciteEpargneMensuelle: any } | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, relationCouplePersonnePhysique?: { __typename?: 'RelationCoupleSimple', autrePersonnePhysique?: { __typename?: 'PersonnePhysique', nom: string, prenom: string, investisseur: Array<{ __typename?: 'Investisseur', id: any, code: string, objectifDefinis?: Array<{ __typename?: 'ObjectifDefini', priorite?: number | null, horizon?: number | null, objectifReferenceCode: string, commentaire?: string | null, objectif: { __typename?: 'ObjectifReference', categorieCode: string, code: string, libelle: string } }> | null, capaciteFinanciere?: { __typename?: 'CapaciteFinanciere', commentaire?: string | null, epargnePrecautionCible?: any | null, effortEpargne?: any | null } | null, engagementBudgetaire?: { __typename?: 'EngagementBudgetaire', mensualiteCreditTotale: number, tauxEndettement?: number | null, capaciteRemboursementRestanteMensuel: number, soldeBudgetMensuel: any } | null, capaciteEpargne?: { __typename?: 'CapaciteEpargneDetail', capaciteEpargneMensuelle: any } | null }> } | null } | null }> };

export type ObjectifRefFragmentFragment = { __typename?: 'ObjectifReference', code: string, ordre: number, libelle: string, categorieCode: string, categorie?: { __typename?: 'ObjectifCategorie', code: string, libelle: string, ordre: number } | null };

export type UpdateObjectifStepMutationVariables = Exact<{
  input: UpdateObjectifStepInput;
}>;


export type UpdateObjectifStepMutation = { __typename?: 'Mutation', updateObjectifStep?: boolean | null };

export type KycObjectifInvestisseurQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type KycObjectifInvestisseurQuery = { __typename?: 'Query', investisseur?: { __typename?: 'Investisseur', id: any, code: string, objectifDefinis?: Array<{ __typename?: 'ObjectifDefini', priorite?: number | null, horizon?: number | null, objectifReferenceCode: string, commentaire?: string | null, objectif: { __typename?: 'ObjectifReference', categorieCode: string, code: string, libelle: string } }> | null, capaciteFinanciere?: { __typename?: 'CapaciteFinanciere', commentaire?: string | null, epargnePrecautionCible?: any | null, effortEpargne?: any | null, levierType?: LevierType | null } | null, engagementBudgetaire?: { __typename?: 'EngagementBudgetaire', mensualiteCreditTotale: number, tauxEndettement?: number | null, capaciteRemboursementRestanteMensuel: number, soldeBudgetMensuel: any } | null, capaciteEpargne?: { __typename?: 'CapaciteEpargneDetail', capaciteEpargneMensuelle: any } | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, relationCouplePersonnePhysique?: { __typename?: 'RelationCoupleSimple', autrePersonnePhysique?: { __typename?: 'PersonnePhysique', nom: string, prenom: string, investisseur: Array<{ __typename?: 'Investisseur', id: any, code: string, objectifDefinis?: Array<{ __typename?: 'ObjectifDefini', priorite?: number | null, horizon?: number | null, objectifReferenceCode: string, commentaire?: string | null, objectif: { __typename?: 'ObjectifReference', categorieCode: string, code: string, libelle: string } }> | null, capaciteFinanciere?: { __typename?: 'CapaciteFinanciere', commentaire?: string | null, epargnePrecautionCible?: any | null, effortEpargne?: any | null } | null, engagementBudgetaire?: { __typename?: 'EngagementBudgetaire', mensualiteCreditTotale: number, tauxEndettement?: number | null, capaciteRemboursementRestanteMensuel: number, soldeBudgetMensuel: any } | null, capaciteEpargne?: { __typename?: 'CapaciteEpargneDetail', capaciteEpargneMensuelle: any } | null }> } | null } | null }> } | null };

export type ObjectifReferenceListQueryVariables = Exact<{ [key: string]: never; }>;


export type ObjectifReferenceListQuery = { __typename?: 'Query', objectifReferentiels: Array<{ __typename?: 'ObjectifReference', code: string, ordre: number, libelle: string, categorieCode: string, categorie?: { __typename?: 'ObjectifCategorie', code: string, libelle: string, ordre: number } | null }> };

export type CreateOrUpdatePatrimoineMutationVariables = Exact<{
  patrimoineInput: PatrimoineInput;
}>;


export type CreateOrUpdatePatrimoineMutation = { __typename?: 'Mutation', createOrUpdatePatrimoine: { __typename?: 'InvestisseurPatrimoine', id: any, investisseurId?: any | null, patrimoineId: any, patrimoine: { __typename?: 'Patrimoine', categorieCode: any, id: any } } };

export type DeletePatrimoineMutationVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type DeletePatrimoineMutation = { __typename?: 'Mutation', deletePatrimoine: boolean };

export type ManageInvestisseurRetraiteMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
}>;


export type ManageInvestisseurRetraiteMutation = { __typename?: 'Mutation', manageInvestisseurRetraite: boolean };

export type UpdatePatrimoineContratMutationVariables = Exact<{
  patrimoineInput: PatrimoineInput;
}>;


export type UpdatePatrimoineContratMutation = { __typename?: 'Mutation', updatePatrimoineContrat?: { __typename?: 'InvestisseurPatrimoine', id: any, investisseurId?: any | null, patrimoineId: any, patrimoine: { __typename?: 'Patrimoine', categorieCode: any, id: any } } | null };

export type GetPatrimoineBudgetQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type GetPatrimoineBudgetQuery = { __typename?: 'Query', budgetById: Array<{ __typename?: 'Budget', commentaire?: string | null, creationDate: any, designation?: string | null, editionDate: any, id: any, montantAnnuel: any }> };

export type GetInvestisseurBudgetQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetInvestisseurBudgetQuery = { __typename?: 'Query', investisseurByCode?: { __typename?: 'Investisseur', budgetInvestisseurs?: Array<{ __typename?: 'BudgetInvestisseur', budgetId: any, id: any, investisseurId: any, tauxDetention: any, investisseur: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> }, budget: { __typename?: 'Budget', commentaire?: string | null, designation?: string | null, id: any, montantAnnuel: any, typeBudgetId: number, patrimoineBudget?: { __typename?: 'PatrimoineBudget', budgetId: any, creationDate: any, editionDate?: any | null, id: any, patrimoineId: any } | null } }> | null } | null };

export type GetInvestisseurPatrimoineByIdQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type GetInvestisseurPatrimoineByIdQuery = { __typename?: 'Query', investisseurPatrimoineById: Array<{ __typename?: 'InvestisseurPatrimoine', creationDate: any, editionDate?: any | null, id: any, investisseurId?: any | null, patrimoineId: any, detentionPP?: any | null, detentionNP?: any | null, detentionUS?: any | null, typeDetenteur?: TypeDetenteurEnum | null, quotePartADI?: any | null, patrimoine: { __typename?: 'Patrimoine', categorieCode: any, creationDate: any, designation?: string | null, editionDate?: any | null, id: any, investisseurPatrimoines: Array<{ __typename?: 'InvestisseurPatrimoine', creationDate: any, editionDate?: any | null, id: any, investisseurId?: any | null, patrimoineId: any, detentionPP?: any | null, detentionNP?: any | null, detentionUS?: any | null, typeDetenteur?: TypeDetenteurEnum | null, quotePartADI?: any | null, investisseur?: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null }>, commentaires?: Array<{ __typename?: 'CommentairePatrimoine', text: string }> | null, patrimoineActif?: { __typename?: 'Actif', creationDate: any, dateAcquisition?: any | null, editionDate?: any | null, epargneSecurise?: any | null, id: any, loyerBrutsAnnuel?: any | null, sciImposableA?: boolean | null, modeDetention?: TypeDetentionEnum | null, patrimoineId: any, prixAcquisition?: any | null, regimeFiscal?: TypeRegimeFiscalEnum | null, taxeFonciere?: any | null, type?: TypeActifEnum | null, typeLocation?: TypeLocationEnum | null, typeSCPI?: TypeScpiEnum | null, valeurEstimee: any, dateDebutDemembrement?: any | null, dateFinDemembrement?: any | null, typeDePropriete?: TypeDetentionEnum | null, valorisationDuDroitDemembre?: any | null, actifFinancier?: { __typename?: 'ActifFinancier', dateDisponibilite?: any | null, dateOuverture?: any | null, disponible?: boolean | null, epargneDisponible: any, epargneNonDisponible: any, epargnePrecaution: any, id: any, montantDisponible?: any | null, versementProgrammes?: any | null } | null, patrimoinesPassifs?: Array<{ __typename?: 'Passif', capitalRestantDu: any, creationDate: any, dateDebut: any, dateFin: any, designation?: string | null, dureePremierPalier?: number | null, dureeRestante: number, dureeSecondPalier?: number | null, dureeTroisiemePalier?: number | null, editionDate?: any | null, id: any, mensualite: any, mensualitePremierPalier?: any | null, mensualiteSecondPalier?: any | null, mensualiteTroisiemePalier?: any | null, montant: any, patrimoineActifId?: any | null, patrimoineId: any, tauxNominal: any, type?: TypePassif | null }> | null, patrimoine: { __typename?: 'Patrimoine', categorieCode: any, creationDate: any, designation?: string | null, editionDate?: any | null, id: any } } | null, patrimoinePassif?: { __typename?: 'Passif', capitalRestantDu: any, creationDate: any, dateDebut: any, dateFin: any, designation?: string | null, dureePremierPalier?: number | null, dureeRestante: number, dureeSecondPalier?: number | null, dureeTroisiemePalier?: number | null, editionDate?: any | null, id: any, mensualite: any, mensualitePremierPalier?: any | null, mensualiteSecondPalier?: any | null, mensualiteTroisiemePalier?: any | null, montant: any, patrimoineId: any, patrimoineActifId?: any | null, tauxNominal: any, type?: TypePassif | null } | null, patrimoinePrevoyance?: { __typename?: 'PatrimoinePrevoyance', benefiaires?: string | null, capitalAssure: any, creationDate: any, editionDate?: any | null, id: any, patrimoineId: any, type?: TypePrevoyance | null } | null, patrimoineBudgets?: Array<{ __typename?: 'PatrimoineBudget', budgetId: any, creationDate: any, editionDate?: any | null, id: any, patrimoineId: any, budget: { __typename?: 'Budget', id: any, designation?: string | null, montantAnnuel: any, commentaire?: string | null, typeBudgetId: number, budgetInvestisseurs: Array<{ __typename?: 'BudgetInvestisseur', investisseurId: any, investisseur: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } }> } }> | null, patrimoineCategorie: { __typename?: 'PatrimoineCategorieReference', categoryLibelle: string, code: any, patrimoineCategory: PatrimoineCategoryEnum, subCategory?: SubCategoryEnum | null, subCategory2?: SubCategory2Enum | null, subCategory2Libelle?: string | null, subCategoryLibelle?: string | null } } }> };

export type InvestisseurPatrimoinesByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type InvestisseurPatrimoinesByCodeQuery = { __typename?: 'Query', investisseurByCode?: { __typename?: 'Investisseur', syntheseEpargne?: { __typename?: 'SyntheseEpargne', disponible: any, nonDisponible: any, disponibleDePrecaution: any, epargneTotale: any } | null, investisseurPatrimoines?: Array<{ __typename?: 'InvestisseurPatrimoine', id: any, investisseurId?: any | null, detentionPP?: any | null, detentionNP?: any | null, detentionUS?: any | null, typeDetenteur?: TypeDetenteurEnum | null, quotePartADI?: any | null, dateNaissance?: any | null, patrimoine: { __typename?: 'Patrimoine', categorieCode: any, designation?: string | null, id: any, patrimoineCategorie: { __typename?: 'PatrimoineCategorieReference', categoryLibelle: string, code: any, patrimoineCategory: PatrimoineCategoryEnum, subCategory?: SubCategoryEnum | null, subCategory2?: SubCategory2Enum | null, subCategory2Libelle?: string | null, subCategoryLibelle?: string | null }, investisseurPatrimoines: Array<{ __typename?: 'InvestisseurPatrimoine', id: any, detentionPP?: any | null, detentionNP?: any | null, detentionUS?: any | null, typeDetenteur?: TypeDetenteurEnum | null, quotePartADI?: any | null, investisseurId?: any | null, dateNaissance?: any | null, investisseur?: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, dateNaissance?: any | null }> } | null }>, commentaires?: Array<{ __typename?: 'CommentairePatrimoine', text: string }> | null, patrimoineActif?: { __typename?: 'Actif', modeDetention?: TypeDetentionEnum | null, prixAcquisition?: any | null, type?: TypeActifEnum | null, typeLocation?: TypeLocationEnum | null, typeSCPI?: TypeScpiEnum | null, valeurEstimee: any, epargneSecurise?: any | null, loyerBrutsAnnuel?: any | null, dateAcquisition?: any | null, taxeFonciere?: any | null, regimeFiscal?: TypeRegimeFiscalEnum | null, numeroContrat?: string | null, contratAgregationId?: string | null, taxeHabitation?: any | null, chargesImmo?: any | null, revenuAnnuel?: any | null, dateDebutDemembrement?: any | null, dateFinDemembrement?: any | null, typeDePropriete?: TypeDetentionEnum | null, sciImposableA?: boolean | null, valorisationDuDroitDemembre?: any | null, actifFinancier?: { __typename?: 'ActifFinancier', epargneDisponible: any, epargneNonDisponible: any, dateOuverture?: any | null, dateDisponibilite?: any | null, epargnePrecaution: any, disponible?: boolean | null, id: any, montantDisponible?: any | null, versementProgrammes?: any | null } | null, patrimoinesPassifs?: Array<{ __typename?: 'Passif', id: any, patrimoineId: any, type?: TypePassif | null, capitalRestantDu: any, montant: any, patrimoine: { __typename?: 'Patrimoine', categorieCode: any, designation?: string | null } }> | null } | null, patrimoinePassif?: { __typename?: 'Passif', designation?: string | null, id: any, montant: any, type?: TypePassif | null, tauxNominal: any, dateDebut: any, dateFin: any, dureeRestante: number, mensualite: any, capitalRestantDu: any, dureePremierPalier?: number | null, mensualitePremierPalier?: any | null, dureeSecondPalier?: number | null, mensualiteSecondPalier?: any | null, dureeTroisiemePalier?: number | null, mensualiteTroisiemePalier?: any | null, patrimoineActif?: { __typename?: 'Actif', id: any, patrimoineId: any, type?: TypeActifEnum | null, valeurEstimee: any, patrimoine: { __typename?: 'Patrimoine', categorieCode: any, designation?: string | null } } | null } | null, patrimoinePrevoyance?: { __typename?: 'PatrimoinePrevoyance', benefiaires?: string | null, capitalAssure: any, id: any, type?: TypePrevoyance | null } | null, patrimoineBudgets?: Array<{ __typename?: 'PatrimoineBudget', budgetId: any, creationDate: any, editionDate?: any | null, id: any, patrimoineId: any, budget: { __typename?: 'Budget', id: any, designation?: string | null, montantAnnuel: any, commentaire?: string | null, typeBudgetId: number, typeBudget: { __typename?: 'TypeBudget', id: number, code: string }, budgetInvestisseurs: Array<{ __typename?: 'BudgetInvestisseur', investisseurId: any, investisseur: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } }> } }> | null } }> | null } | null };

export type GetPatrimoineCaregorieReferenceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatrimoineCaregorieReferenceQuery = { __typename?: 'Query', patrimoineCategoriePerefences: Array<{ __typename?: 'PatrimoineCategorieReference', categoryLibelle: string, code: any, patrimoineCategory: PatrimoineCategoryEnum, subCategory?: SubCategoryEnum | null, subCategory2?: SubCategory2Enum | null, subCategory2Libelle?: string | null, subCategoryLibelle?: string | null }> };

export type DeleteDocumentByIdMutationVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type DeleteDocumentByIdMutation = { __typename?: 'Mutation', deleteDocument: boolean };

export type CalculateScoreCapacitePerteMutationVariables = Exact<{
  investisseurPrincipalId: Scalars['Long']['input'];
}>;


export type CalculateScoreCapacitePerteMutation = { __typename?: 'Mutation', calculateScoreCapacitePerte: { __typename?: 'CapaciteSupportPertesDetail', epargneBancaire: any, epargneFinanciere: any, epargneFinanciereSecurise: any, epargneFinanciereNbActifsIncomplets: number, epargneRetraiteSalariale: any, epargneRetraiteSalarialeDisponible: any, epargneRetraiteSalarialeDisponibleSecurise: any, epargneRetraiteSalarialeNbActifsIncomplets: number, diversification: any, revenus: any, chargesFixes: any, depensesCourantes: any, impots: any, capaciteEpargne: any, score: number, isValid: boolean, isMinor: boolean, missingFields: Array<string> } };

export type CalculateScoreEsgMutationVariables = Exact<{
  formInput: QpiFormInput;
}>;


export type CalculateScoreEsgMutation = { __typename?: 'Mutation', calculateScoreESG: { __typename?: 'InvestisseurQpi', id: any, resultatSensibiliteExtraFinanciere?: number | null, reponsesSensibiliteExtraFinanciereJson?: string | null, investisseurId: any } };

export type ConnaissanceExperienceReponsesFieldsFragment = { __typename?: 'ConnaissanceExperienceReponses', totalPoints: number, niveau?: number | null, isComplete: boolean, produitsEpargne: Array<{ __typename?: 'ProduitEpargneReponse', produit: ProduitEpargneEnum, question: string, detention?: DetentionProduitEnum | null, selectionAutoRecueil: boolean, verification?: { __typename?: 'VerificationReponse', reponse: string } | null }>, supportsInvestissement: Array<{ __typename?: 'SupportInvestissementReponse', support: SupportInvestissementEnum, question: string, detention?: DetentionProduitEnum | null, verification?: { __typename?: 'VerificationReponse', reponse: string } | null }>, pedagogie: Array<{ __typename?: 'AffirmationPedagogieReponse', affirmation: AffirmationPedagogieEnum, reponse?: VraiFauxEnum | null }>, experience: { __typename?: 'ExperienceReponse', modeGestion?: ModeGestionEpargneEnum | null, nombreOperations?: NombreOperationsEnum | null, pertesSubies?: boolean | null, reactionPerte?: ReactionPerteEnum | null } };

export type GenerateQpiMutationVariables = Exact<{
  investisseurPrincipalId: Scalars['Long']['input'];
}>;


export type GenerateQpiMutation = { __typename?: 'Mutation', generateQPI?: { __typename?: 'StorageFile', createdDate?: any | null, denomination?: string | null, documentType: DocumentTypeEnum, fileExtension: string, fileName: string, fileType: string, id: string, isBlob: boolean, isTemporary?: boolean | null, lastModificationDate?: any | null, status?: FileStorageStatus | null, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', blobFileId: string, expiration: any, permissions: Array<BlobFilesPermissionDs>, sasUrl: string } | null } | null };

export type GetConnaissanceExperienceReferentielQueryVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
}>;


export type GetConnaissanceExperienceReferentielQuery = { __typename?: 'Query', produitsEpargneDetenusRecueil: Array<ProduitEpargneEnum>, connaissanceExperienceReferentiel: { __typename?: 'ConnaissanceExperienceReferentielDto', produitsEpargne: Array<{ __typename?: 'ProduitEpargneReferentielDto', produit: ProduitEpargneEnum, question: string, libelle: string, optionsVerification: Array<{ __typename?: 'OptionVerificationDto', code: string, libelle: string }> }>, supportsInvestissement: Array<{ __typename?: 'SupportInvestissementReferentielDto', support: SupportInvestissementEnum, question: string, libelle: string, optionsVerification: Array<{ __typename?: 'OptionVerificationDto', code: string, libelle: string }> }>, affirmationsPedagogie: Array<{ __typename?: 'AffirmationPedagogieReferentielDto', affirmation: AffirmationPedagogieEnum, libelle: string }>, modesGestion: Array<{ __typename?: 'ModeGestionReferentielDto', code: ModeGestionEpargneEnum, libelle: string, afficheNombreOperations: boolean }>, nombresOperations: Array<{ __typename?: 'NombreOperationsReferentielDto', code: NombreOperationsEnum, libelle: string }>, reactionsPerte: Array<{ __typename?: 'ReactionPerteReferentielDto', code: ReactionPerteEnum, libelle: string }> } };

export type GetQpiResultsByInvestisseurIdQueryVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
}>;


export type GetQpiResultsByInvestisseurIdQuery = { __typename?: 'Query', qpiResultsByInvestisseurId?: { __typename?: 'InvestisseurQpi', id: any, resultatConnaissance?: number | null, resultatProfilDeRisque?: number | null, resultatToleranceAuRisque?: number | null, resultatCapacitePerte?: number | null, resultatSensibiliteExtraFinanciere?: number | null, versionProfil: number, versionProfilObsolete: boolean, isVersionProfilCourante: boolean, reponsesSensibiliteExtraFinanciereJson?: string | null, investisseurId: any, isImportedFromAriane: boolean, reponsesProfil?: { __typename?: 'ReponsesProfilInvestisseur', connaissanceExperience?: { __typename?: 'ConnaissanceExperienceReponses', totalPoints: number, niveau?: number | null, isComplete: boolean, produitsEpargne: Array<{ __typename?: 'ProduitEpargneReponse', produit: ProduitEpargneEnum, question: string, detention?: DetentionProduitEnum | null, selectionAutoRecueil: boolean, verification?: { __typename?: 'VerificationReponse', reponse: string } | null }>, supportsInvestissement: Array<{ __typename?: 'SupportInvestissementReponse', support: SupportInvestissementEnum, question: string, detention?: DetentionProduitEnum | null, verification?: { __typename?: 'VerificationReponse', reponse: string } | null }>, pedagogie: Array<{ __typename?: 'AffirmationPedagogieReponse', affirmation: AffirmationPedagogieEnum, reponse?: VraiFauxEnum | null }>, experience: { __typename?: 'ExperienceReponse', modeGestion?: ModeGestionEpargneEnum | null, nombreOperations?: NombreOperationsEnum | null, pertesSubies?: boolean | null, reactionPerte?: ReactionPerteEnum | null } } | null, toleranceRisque?: { __typename?: 'ToleranceRisqueReponses', isCoherent: boolean, totalPoints: number, niveau?: number | null, isComplete: boolean, reponses: Array<{ __typename?: 'ToleranceRisqueReponse', question: string, reponse: string }> } | null } | null, capaciteSupportPertesDetail?: { __typename?: 'CapaciteSupportPertesDetail', score: number, isValid: boolean, isMinor: boolean } | null } | null };

export type GetToleranceRisqueReferentielQueryVariables = Exact<{ [key: string]: never; }>;


export type GetToleranceRisqueReferentielQuery = { __typename?: 'Query', toleranceRisqueReferentiel: { __typename?: 'ToleranceRisqueReferentielDto', questions: Array<{ __typename?: 'QuestionToleranceDto', code: string, intitule: string, options: Array<{ __typename?: 'OptionToleranceDto', code: string, libelle: string, profil?: number | null, scenario?: { __typename?: 'ScenarioToleranceDto', titre: string, gainPourcent: number, baissePourcent: number } | null }> }>, intitulesQ4: Array<{ __typename?: 'IntituleParProfilDto', profil: number, intitule: string }> } };

export type InitInvestisseurQpiMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
}>;


export type InitInvestisseurQpiMutation = { __typename?: 'Mutation', initInvestisseurQpi: { __typename?: 'InvestisseurQpi', id: any, resultatConnaissance?: number | null, resultatProfilDeRisque?: number | null, resultatToleranceAuRisque?: number | null, resultatCapacitePerte?: number | null, resultatSensibiliteExtraFinanciere?: number | null, versionProfil: number, versionProfilObsolete: boolean, isVersionProfilCourante: boolean, reponsesSensibiliteExtraFinanciereJson?: string | null, investisseurId: any, isImportedFromAriane: boolean, reponsesProfil?: { __typename?: 'ReponsesProfilInvestisseur', connaissanceExperience?: { __typename?: 'ConnaissanceExperienceReponses', totalPoints: number, niveau?: number | null, isComplete: boolean, produitsEpargne: Array<{ __typename?: 'ProduitEpargneReponse', produit: ProduitEpargneEnum, question: string, detention?: DetentionProduitEnum | null, selectionAutoRecueil: boolean, verification?: { __typename?: 'VerificationReponse', reponse: string } | null }>, supportsInvestissement: Array<{ __typename?: 'SupportInvestissementReponse', support: SupportInvestissementEnum, question: string, detention?: DetentionProduitEnum | null, verification?: { __typename?: 'VerificationReponse', reponse: string } | null }>, pedagogie: Array<{ __typename?: 'AffirmationPedagogieReponse', affirmation: AffirmationPedagogieEnum, reponse?: VraiFauxEnum | null }>, experience: { __typename?: 'ExperienceReponse', modeGestion?: ModeGestionEpargneEnum | null, nombreOperations?: NombreOperationsEnum | null, pertesSubies?: boolean | null, reactionPerte?: ReactionPerteEnum | null } } | null, toleranceRisque?: { __typename?: 'ToleranceRisqueReponses', isCoherent: boolean, totalPoints: number, niveau?: number | null, isComplete: boolean, reponses: Array<{ __typename?: 'ToleranceRisqueReponse', question: string, reponse: string }> } | null } | null, capaciteSupportPertesDetail?: { __typename?: 'CapaciteSupportPertesDetail', score: number, isValid: boolean, isMinor: boolean } | null } };

export type RestartInvestisseurQpiMutationVariables = Exact<{
  investisseurPrincipalId: Scalars['Long']['input'];
}>;


export type RestartInvestisseurQpiMutation = { __typename?: 'Mutation', restartInvestisseurQPI: { __typename?: 'InvestisseurQpi', id: any } };

export type SaveConnaissanceExperienceMutationVariables = Exact<{
  input: ConnaissanceExperienceInput;
}>;


export type SaveConnaissanceExperienceMutation = { __typename?: 'Mutation', saveConnaissanceExperience: { __typename?: 'InvestisseurQpi', id: any, investisseurId: any, versionProfil: number, resultatConnaissance?: number | null, reponsesProfil?: { __typename?: 'ReponsesProfilInvestisseur', connaissanceExperience?: { __typename?: 'ConnaissanceExperienceReponses', totalPoints: number, niveau?: number | null, isComplete: boolean, produitsEpargne: Array<{ __typename?: 'ProduitEpargneReponse', produit: ProduitEpargneEnum, question: string, detention?: DetentionProduitEnum | null, selectionAutoRecueil: boolean, verification?: { __typename?: 'VerificationReponse', reponse: string } | null }>, supportsInvestissement: Array<{ __typename?: 'SupportInvestissementReponse', support: SupportInvestissementEnum, question: string, detention?: DetentionProduitEnum | null, verification?: { __typename?: 'VerificationReponse', reponse: string } | null }>, pedagogie: Array<{ __typename?: 'AffirmationPedagogieReponse', affirmation: AffirmationPedagogieEnum, reponse?: VraiFauxEnum | null }>, experience: { __typename?: 'ExperienceReponse', modeGestion?: ModeGestionEpargneEnum | null, nombreOperations?: NombreOperationsEnum | null, pertesSubies?: boolean | null, reactionPerte?: ReactionPerteEnum | null } } | null } | null } };

export type SaveToleranceRisqueMutationVariables = Exact<{
  input: ToleranceRisqueInput;
}>;


export type SaveToleranceRisqueMutation = { __typename?: 'Mutation', saveToleranceRisque: { __typename?: 'InvestisseurQpi', id: any, investisseurId: any, versionProfil: number, resultatToleranceAuRisque?: number | null, resultatProfilDeRisque?: number | null, reponsesProfil?: { __typename?: 'ReponsesProfilInvestisseur', toleranceRisque?: { __typename?: 'ToleranceRisqueReponses', isCoherent: boolean, totalPoints: number, niveau?: number | null, isComplete: boolean, reponses: Array<{ __typename?: 'ToleranceRisqueReponse', question: string, reponse: string }> } | null } | null } };

export type SynchroniserSelectionAutoRecueilMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
}>;


export type SynchroniserSelectionAutoRecueilMutation = { __typename?: 'Mutation', synchroniserSelectionAutoRecueil: { __typename?: 'SelectionAutoRecueilResultatDto', produitsAjoutes: Array<string>, isComplete: boolean } };

export type ToleranceRisqueReponsesFieldsFragment = { __typename?: 'ToleranceRisqueReponses', isCoherent: boolean, totalPoints: number, niveau?: number | null, isComplete: boolean, reponses: Array<{ __typename?: 'ToleranceRisqueReponse', question: string, reponse: string }> };

export type EnsureConnaissanceClientDataCoherenceMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
}>;


export type EnsureConnaissanceClientDataCoherenceMutation = { __typename?: 'Mutation', ensureConnaissanceClientDataCoherence: boolean };

export type InvestisseurNameByIdQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type InvestisseurNameByIdQuery = { __typename?: 'Query', investisseurById?: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string }> } | null };

export type InvestisseurPersonnePhysiqueIdByInvestisseurCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type InvestisseurPersonnePhysiqueIdByInvestisseurCodeQuery = { __typename?: 'Query', investisseurByCode?: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', id: any, email: Array<{ __typename?: 'Email', id: any }>, telephone: Array<{ __typename?: 'Telephone', id: any }>, adresse: Array<{ __typename?: 'Adresse', id: any, typeAdresseCode: string }> }> } | null };

export type RelationPersonnePhysiqueIdByInvestisseurIdQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type RelationPersonnePhysiqueIdByInvestisseurIdQuery = { __typename?: 'Query', investisseurById?: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', id: any, email: Array<{ __typename?: 'Email', id: any }>, telephone: Array<{ __typename?: 'Telephone', id: any }>, adresse: Array<{ __typename?: 'Adresse', id: any }> }> } | null };

export type AddRelationCoupleMutationVariables = Exact<{
  input: AddRelationCoupleInput;
}>;


export type AddRelationCoupleMutation = { __typename?: 'Mutation', addRelationCoupleAndUpdateConnaissanceClient: boolean };

export type CreateMinotaureInvestisseurMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
}>;


export type CreateMinotaureInvestisseurMutation = { __typename?: 'Mutation', createMinotaureInvestisseur: boolean };

export type DeleteRelationAutreMutationVariables = Exact<{
  input: DeleteRelationInput;
}>;


export type DeleteRelationAutreMutation = { __typename?: 'Mutation', deleteRelationAutre?: number | null };

export type DeleteRelationCoupleMutationVariables = Exact<{
  input: DeleteRelationCoupleInput;
}>;


export type DeleteRelationCoupleMutation = { __typename?: 'Mutation', deleteRelationCoupleAndUpdateConnaissanceClient: boolean };

export type DeleteRelationFamilleMutationVariables = Exact<{
  input: DeleteRelationInput;
}>;


export type DeleteRelationFamilleMutation = { __typename?: 'Mutation', deleteRelationFamille?: number | null };

export type UpdateSituationPersonnelleMinotaureMutationVariables = Exact<{
  input: UpdateSituationPersonnelleInput;
}>;


export type UpdateSituationPersonnelleMinotaureMutation = { __typename?: 'Mutation', updateSituationPersonnelle: boolean };

export type UpsertInvestisseurRelationAutreMutationVariables = Exact<{
  input: InvestisseurRelationAutreInput;
}>;


export type UpsertInvestisseurRelationAutreMutation = { __typename?: 'Mutation', upsertInvestisseurRelationAutre: any };

export type UpsertInvestisseurRelationFamilleMutationVariables = Exact<{
  input: InvestisseurRelationFamilleInput;
}>;


export type UpsertInvestisseurRelationFamilleMutation = { __typename?: 'Mutation', upsertInvestisseurRelationFamille: any };

export type InvestisseurByCodeNewRelationQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type InvestisseurByCodeNewRelationQuery = { __typename?: 'Query', investisseurByCode?: { __typename?: 'Investisseur', code: string, id: any, statutCode: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', civiliteCode: string, id: any, dateNaissance?: any | null, deuxiemePrenom?: string | null, nom: string, nomNaissance?: string | null, prenom: string, troisiemePrenom?: string | null, villeNaissanceNom?: string | null, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null, id: any, noteId?: any | null, typeEmailCode: string }>, telephone: Array<{ __typename?: 'Telephone', estNumeroCorrespondance?: boolean | null, id: any, noteId?: any | null, numero: string, prefixe?: string | null, typeTelephoneCode: string }> }> } | null };

export type InvestisseurByCodeSituationPersonnelleQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type InvestisseurByCodeSituationPersonnelleQuery = { __typename?: 'Query', investisseurByCode?: { __typename?: 'Investisseur', code: string, id: any, statutCode: string, origineContactCode?: string | null, origineSaisie?: any | null, recommandeParId?: any | null, dateConnaissance?: any | null, recommandeParNom?: string | null, note: Array<{ __typename?: 'Note', note1: string }>, recommandePar?: { __typename?: 'Investisseur', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, id: any }> } | null, investisseurConsultant: Array<{ __typename?: 'InvestisseurConsultant', consultantId: any, typeRelationInvestisseurConsultantCode: string, actif: number, consultant?: { __typename?: 'Consultant', personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, creationDate?: any | null }> } | null }>, personnePhysique: Array<{ __typename?: 'PersonnePhysique', civiliteCode: string, id: any, codePaysNaissance?: string | null, codePaysNationalite?: string | null, codePaysNationaliteSecondaire?: string | null, dateNaissance?: any | null, deuxiemePrenom?: string | null, nom: string, nomNaissance?: string | null, prenom: string, troisiemePrenom?: string | null, typeMesureProtectionCode?: string | null, mesureProtectionDate?: any | null, villeNaissanceNom?: string | null, codePostaleNaissance?: string | null, relationAutrePersonnePhysique: Array<{ __typename?: 'RelationAutreSimple', id: any, autrePersonnePhysiqueId?: any | null, typeRelationAutreCode: string, typeRelationAutre?: string | null, autrePersonnePhysique?: { __typename?: 'PersonnePhysique', civiliteCode: string, id: any, nom: string, nomNaissance?: string | null, prenom: string, dateNaissance?: any | null, investisseur: Array<{ __typename?: 'Investisseur', code: string }>, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null, id: any, noteId?: any | null, typeEmailCode: string }>, telephone: Array<{ __typename?: 'Telephone', estNumeroCorrespondance?: boolean | null, id: any, noteId?: any | null, numero: string, prefixe?: string | null, typeTelephoneCode: string }>, adresse: Array<{ __typename?: 'Adresse', adresse1?: string | null, adresse2?: string | null, adresse3?: string | null, codePostalCode?: string | null, complement?: string | null, id: any, modeLogement?: string | null, noteId?: any | null, paysCode?: string | null, typeAdresseCode: string, villeNom?: string | null, note?: { __typename?: 'Note', note1: string } | null }> } | null }>, relationAutrePersonnePhysiqueUnaccesible: Array<{ __typename?: 'RelationSimpleUnaccesible', typeRelationCode: string, nom?: string | null, prenom?: string | null, typeRelationLibelle: string }>, disposition?: { __typename?: 'Disposition', autresDispositions?: boolean | null, beneficiaire?: string | null, dateDonation?: any | null, forme?: string | null, montant?: number | null, objet?: string | null, demembrement?: string | null, personnePhysiqueId: any, donationDernierVivant?: boolean | null, note: Array<{ __typename?: 'Note', note1: string }> } | null, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null, id: any, noteId?: any | null, typeEmailCode: string }>, etatCivil?: { __typename?: 'EtatCivil', personnePhysiqueId: any, codePaysResidenceStableCouple?: string | null, dateChangementSituation?: any | null, dateContratUnion?: any | null, regimePacsIndivision?: boolean | null, typeAvantageMatrimonialCode?: string | null, typeRegimeSituationEtatCivilCode?: string | null, typeSituationEtatCivilCode?: string | null, lieuContratUnion?: string | null, foyerFiscalIdentique: boolean, nombreEnfantACharge?: any | null, note?: { __typename?: 'Note', note1: string } | null } | null, reglementaire?: { __typename?: 'Reglementaire', personnePhysiqueId: any, codePaysFactaResidenceFiscale?: string | null, codePaysPpe?: string | null, creationDate?: any | null, factaStatut?: boolean | null, factaTinCode?: string | null, nifCode?: string | null, ppeAnciennete?: any | null, ppeStatut?: boolean | null, typePpeMotifCode?: string | null, typePpeRelationCode?: string | null } | null, relationCouplePersonnePhysique?: { __typename?: 'RelationCoupleSimple', autrePersonnePhysiqueId?: any | null, typeRelationCoupleCode: string, autrePersonnePhysique?: { __typename?: 'PersonnePhysique', id: any, investisseur: Array<{ __typename?: 'Investisseur', id: any, code: string, foyerFiscal?: { __typename?: 'FoyerFiscal', id: any, imposableImpotFortuneImmo: boolean, imposableImpotRevenu: boolean, impotAnneeRevenus?: number | null, totalSalairesAssimiles?: any | null, revenusBrutGlobal?: any | null, impotAutre?: number | null, impotAutreCommentaire?: string | null, impotFortuneAnneeRevenus?: number | null, impotFortuneImmoCommentaire?: string | null, impotFortuneImmoNet?: number | null, impotRevenuBrut?: number | null, impotRevenuCommentaire?: string | null, impotRevenuNet?: number | null, impotRevenuTauxMarginal?: number | null, impotRevenuTotalCredit?: any | null, impotRevenuTotalReduction?: any | null, impotTotalAvantCreditsImpot?: any | null, csgDeductible?: any | null, chargesDeductiblesDuRevenuGlobal?: any | null, totalDesPrelevementsSociaux?: any | null, isCompleted: boolean, nbParts?: any | null, plafondEpargneRetraireNonUtilise?: any | null } | null, objectifDefinis?: Array<{ __typename?: 'ObjectifDefini', priorite?: number | null, horizon?: number | null, objectifReferenceCode: string, commentaire?: string | null, objectif: { __typename?: 'ObjectifReference', categorieCode: string, code: string, libelle: string } }> | null, capaciteFinanciere?: { __typename?: 'CapaciteFinanciere', commentaire?: string | null, epargnePrecautionCible?: any | null, effortEpargne?: any | null, levierType?: LevierType | null } | null, engagementBudgetaire?: { __typename?: 'EngagementBudgetaire', mensualiteCreditTotale: number, tauxEndettement?: number | null, capaciteRemboursementRestanteMensuel: number, soldeBudgetMensuel: any } | null, capaciteEpargne?: { __typename?: 'CapaciteEpargneDetail', capaciteEpargneMensuelle: any } | null }>, disposition?: { __typename?: 'Disposition', autresDispositions?: boolean | null, beneficiaire?: string | null, dateDonation?: any | null, forme?: string | null, montant?: number | null, objet?: string | null, demembrement?: string | null, personnePhysiqueId: any, donationDernierVivant?: boolean | null, note: Array<{ __typename?: 'Note', note1: string }> } | null, testament?: { __typename?: 'Testament', personnePhysiqueId: any, testamentRedige?: boolean | null, note?: { __typename?: 'Note', note1: string } | null } | null } | null, note?: { __typename?: 'Note', note1: string } | null } | null, relationCouplePersonnePhysiqueUnaccesible?: { __typename?: 'RelationSimpleUnaccesible', typeRelationCode: string, nom?: string | null, prenom?: string | null, typeRelationLibelle: string } | null, relationFamillePersonnePhysique: Array<{ __typename?: 'RelationFamilleSimple', autrePersonnePhysiqueId?: any | null, enfantAdopte?: boolean | null, gardeAlternee?: boolean | null, typeAdoptionCode?: string | null, typeRelationFamilleCode: string, niveauEtudeCode?: string | null, autoriteParentale?: boolean | null, estTypeRelation?: boolean | null, dateFinChargeFiscale?: any | null, enfantACharge?: boolean | null, note?: { __typename?: 'Note', note1: string } | null, autrePersonnePhysique?: { __typename?: 'PersonnePhysique', civiliteCode: string, id: any, dateNaissance?: any | null, deuxiemePrenom?: string | null, nom: string, nomNaissance?: string | null, prenom: string, troisiemePrenom?: string | null, investisseur: Array<{ __typename?: 'Investisseur', code: string }>, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null, id: any, noteId?: any | null, typeEmailCode: string }>, telephone: Array<{ __typename?: 'Telephone', estNumeroCorrespondance?: boolean | null, id: any, noteId?: any | null, numero: string, prefixe?: string | null, typeTelephoneCode: string }> } | null }>, relationFamillePersonnePhysiqueUnaccesible: Array<{ __typename?: 'RelationSimpleUnaccesible', typeRelationCode: string, nom?: string | null, prenom?: string | null, typeRelationLibelle: string }>, situationProfessionnelle?: { __typename?: 'SituationProfessionnelle', personnePhysiqueId: any, anciennete?: any | null, categorieSocioProfessionnelleCode?: string | null, nomSociete?: string | null, profession?: string | null, origineRevenus?: string | null, categorieSocioProfessionnelleCodeAtlas?: any | null, typeStatutProfessionnelCode?: number | null, typeSituationProfessionnelleCode?: number | null, secteurActiviteCode?: number | null, regimeActiviteCode?: number | null, dateDepartRetraite?: any | null, note: Array<{ __typename?: 'Note', note1: string }>, categorieSocioProfessionnelleCodeAtlasNavigation?: { __typename?: 'CategorieSocioProfessionnelle', parent?: any | null } | null } | null, telephone: Array<{ __typename?: 'Telephone', estNumeroCorrespondance?: boolean | null, id: any, noteId?: any | null, numero: string, prefixe?: string | null, typeTelephoneCode: string }>, adresse: Array<{ __typename?: 'Adresse', adresse1?: string | null, adresse2?: string | null, adresse3?: string | null, codePostalCode?: string | null, complement?: string | null, id: any, modeLogement?: string | null, noteId?: any | null, paysCode?: string | null, typeAdresseCode: string, villeNom?: string | null, note?: { __typename?: 'Note', note1: string } | null }>, testament?: { __typename?: 'Testament', personnePhysiqueId: any, testamentRedige?: boolean | null, note?: { __typename?: 'Note', note1: string } | null } | null }>, foyerFiscal?: { __typename?: 'FoyerFiscal', id: any, imposableImpotFortuneImmo: boolean, imposableImpotRevenu: boolean, impotAnneeRevenus?: number | null, totalSalairesAssimiles?: any | null, revenusBrutGlobal?: any | null, impotAutre?: number | null, impotAutreCommentaire?: string | null, impotFortuneAnneeRevenus?: number | null, impotFortuneImmoCommentaire?: string | null, impotFortuneImmoNet?: number | null, impotRevenuBrut?: number | null, impotRevenuCommentaire?: string | null, impotRevenuNet?: number | null, impotRevenuTauxMarginal?: number | null, impotRevenuTotalCredit?: any | null, impotRevenuTotalReduction?: any | null, impotTotalAvantCreditsImpot?: any | null, csgDeductible?: any | null, chargesDeductiblesDuRevenuGlobal?: any | null, totalDesPrelevementsSociaux?: any | null, isCompleted: boolean, nbParts?: any | null, plafondEpargneRetraireNonUtilise?: any | null } | null, objectifDefinis?: Array<{ __typename?: 'ObjectifDefini', priorite?: number | null, horizon?: number | null, objectifReferenceCode: string, commentaire?: string | null, objectif: { __typename?: 'ObjectifReference', categorieCode: string, code: string, libelle: string } }> | null, capaciteFinanciere?: { __typename?: 'CapaciteFinanciere', commentaire?: string | null, epargnePrecautionCible?: any | null, effortEpargne?: any | null, levierType?: LevierType | null } | null, engagementBudgetaire?: { __typename?: 'EngagementBudgetaire', mensualiteCreditTotale: number, tauxEndettement?: number | null, capaciteRemboursementRestanteMensuel: number, soldeBudgetMensuel: any } | null, capaciteEpargne?: { __typename?: 'CapaciteEpargneDetail', capaciteEpargneMensuelle: any } | null } | null };

export type ApicilSsoUrlMutationVariables = Exact<{
  contratId: Scalars['String']['input'];
}>;


export type ApicilSsoUrlMutation = { __typename?: 'Mutation', apicilSsoUrl?: string | null };

export type SuravenirExtranetMutationVariables = Exact<{
  numeroContrat: Scalars['String']['input'];
  idPersonnePartenaire: Scalars['String']['input'];
}>;


export type SuravenirExtranetMutation = { __typename?: 'Mutation', surAvenirContratUrl?: string | null };

export type ContratsDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  codeInvestisseur: Scalars['String']['input'];
}>;


export type ContratsDetailsQuery = { __typename?: 'Query', contratsInvestisseur: Array<{ __typename?: 'ContratsInvestisseur', idContrat: string, idPartenaire: string, codeInvestisseur?: string | null, idPersonnePartenaire?: string | null, contrat?: { __typename?: 'Contrat', idContrat: string, numeroContrat?: string | null, dateDebutContrat?: any | null, codeModeGestion?: string | null, vpMontantUnitaire?: any | null, flagEpargneHandicap?: boolean | null, flagRpp?: boolean | null, clauseBeneficiaire?: string | null, dateValorisation?: any | null, valorisation?: any | null, perfPlusMoinsValueFinanciereNette?: any | null, cumulVersementsNets?: any | null, cumulRachats?: any | null, modeGestion?: { __typename?: 'ModeGestion', libelle?: string | null } | null, periodiciteVp?: { __typename?: 'PeriodiciteVp', libelle?: string | null } | null, produit?: { __typename?: 'ProduitAgregation', designation?: string | null, enveloppe?: { __typename?: 'Enveloppe', libelle?: string | null } | null, partenaire?: { __typename?: 'PartenaireAgregation', libelleCourt?: string | null, libelleLong?: string | null } | null } | null, contratsSupports?: Array<{ __typename?: 'ContratsSupport', poidsSupportDansContrat?: any | null, valorisation?: any | null, dateCotation?: any | null, nombreParts?: any | null, valeurLiquidative?: any | null, perfPlusMoinsValueFinanciere?: any | null, supportGen?: { __typename?: 'SupportsGen', isin?: string | null, supportsClassesActif?: { __typename?: 'SupportsClassesActif', libelleSupport?: string | null, societeGestion?: string | null, classeActif?: string | null, sousClasseActif?: string | null, sri?: number | null, esg?: string | null, estFondEuro?: boolean | null } | null } | null }> | null } | null, investisseur?: { __typename?: 'InvestisseurAgregation', nom?: string | null, prenom?: string | null } | null, autresInvestisseurs: Array<{ __typename?: 'ContratsInvestisseur', codeInvestisseur?: string | null, investisseur?: { __typename?: 'InvestisseurAgregation', nom?: string | null, prenom?: string | null } | null }> }> };

export type ContratsDetailsBackOfficeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ContratsDetailsBackOfficeQuery = { __typename?: 'Query', contratBackOffice: Array<{ __typename?: 'ContratsInvestisseur', idContrat: string, idPartenaire: string, codeInvestisseur?: string | null, idPersonnePartenaire?: string | null, contrat?: { __typename?: 'Contrat', idContrat: string, numeroContrat?: string | null, dateDebutContrat?: any | null, codeModeGestion?: string | null, vpMontantUnitaire?: any | null, flagEpargneHandicap?: boolean | null, flagRpp?: boolean | null, clauseBeneficiaire?: string | null, dateValorisation?: any | null, valorisation?: any | null, perfPlusMoinsValueFinanciereNette?: any | null, cumulVersementsNets?: any | null, cumulRachats?: any | null, modeGestion?: { __typename?: 'ModeGestion', libelle?: string | null } | null, periodiciteVp?: { __typename?: 'PeriodiciteVp', libelle?: string | null } | null, produit?: { __typename?: 'ProduitAgregation', designation?: string | null, enveloppe?: { __typename?: 'Enveloppe', libelle?: string | null } | null, partenaire?: { __typename?: 'PartenaireAgregation', libelleCourt?: string | null, libelleLong?: string | null } | null } | null, contratsSupports?: Array<{ __typename?: 'ContratsSupport', poidsSupportDansContrat?: any | null, valorisation?: any | null, dateCotation?: any | null, nombreParts?: any | null, valeurLiquidative?: any | null, perfPlusMoinsValueFinanciere?: any | null, supportGen?: { __typename?: 'SupportsGen', isin?: string | null, supportsClassesActif?: { __typename?: 'SupportsClassesActif', libelleSupport?: string | null, societeGestion?: string | null, classeActif?: string | null, sousClasseActif?: string | null, sri?: number | null, esg?: string | null, estFondEuro?: boolean | null } | null } | null }> | null } | null, investisseur?: { __typename?: 'InvestisseurAgregation', nom?: string | null, prenom?: string | null } | null, autresInvestisseurs: Array<{ __typename?: 'ContratsInvestisseur', codeInvestisseur?: string | null, investisseur?: { __typename?: 'InvestisseurAgregation', nom?: string | null, prenom?: string | null } | null }> }> };

export type ContratDetailsFragmentFragment = { __typename?: 'ContratsInvestisseur', idContrat: string, idPartenaire: string, codeInvestisseur?: string | null, idPersonnePartenaire?: string | null, contrat?: { __typename?: 'Contrat', idContrat: string, numeroContrat?: string | null, dateDebutContrat?: any | null, codeModeGestion?: string | null, vpMontantUnitaire?: any | null, flagEpargneHandicap?: boolean | null, flagRpp?: boolean | null, clauseBeneficiaire?: string | null, dateValorisation?: any | null, valorisation?: any | null, perfPlusMoinsValueFinanciereNette?: any | null, cumulVersementsNets?: any | null, cumulRachats?: any | null, modeGestion?: { __typename?: 'ModeGestion', libelle?: string | null } | null, periodiciteVp?: { __typename?: 'PeriodiciteVp', libelle?: string | null } | null, produit?: { __typename?: 'ProduitAgregation', designation?: string | null, enveloppe?: { __typename?: 'Enveloppe', libelle?: string | null } | null, partenaire?: { __typename?: 'PartenaireAgregation', libelleCourt?: string | null, libelleLong?: string | null } | null } | null, contratsSupports?: Array<{ __typename?: 'ContratsSupport', poidsSupportDansContrat?: any | null, valorisation?: any | null, dateCotation?: any | null, nombreParts?: any | null, valeurLiquidative?: any | null, perfPlusMoinsValueFinanciere?: any | null, supportGen?: { __typename?: 'SupportsGen', isin?: string | null, supportsClassesActif?: { __typename?: 'SupportsClassesActif', libelleSupport?: string | null, societeGestion?: string | null, classeActif?: string | null, sousClasseActif?: string | null, sri?: number | null, esg?: string | null, estFondEuro?: boolean | null } | null } | null }> | null } | null, investisseur?: { __typename?: 'InvestisseurAgregation', nom?: string | null, prenom?: string | null } | null, autresInvestisseurs: Array<{ __typename?: 'ContratsInvestisseur', codeInvestisseur?: string | null, investisseur?: { __typename?: 'InvestisseurAgregation', nom?: string | null, prenom?: string | null } | null }> };

export type ContratsInvestisseursQueryVariables = Exact<{
  codeInvestisseur: Scalars['String']['input'];
}>;


export type ContratsInvestisseursQuery = { __typename?: 'Query', contratsInvestisseur: Array<{ __typename?: 'ContratsInvestisseur', idContrat: string, idPartenaire: string, codeInvestisseur?: string | null, contrat?: { __typename?: 'Contrat', idContrat: string, idPartenaire: string, numeroContrat?: string | null, valorisation?: any | null, cumulVersementsNets?: any | null, dateDebutContrat?: any | null, dateValorisation?: any | null, flagVp?: boolean | null, vpMontantUnitaire?: any | null, perfPlusMoinsValueFinanciereNette?: any | null, produit?: { __typename?: 'ProduitAgregation', designation?: string | null, enveloppe?: { __typename?: 'Enveloppe', libelle?: string | null } | null, partenaire?: { __typename?: 'PartenaireAgregation', libelleLong?: string | null } | null } | null } | null, investisseur?: { __typename?: 'InvestisseurAgregation', nom?: string | null, prenom?: string | null } | null, autresInvestisseurs: Array<{ __typename?: 'ContratsInvestisseur', codeInvestisseur?: string | null, investisseur?: { __typename?: 'InvestisseurAgregation', nom?: string | null, prenom?: string | null } | null }> }> };

export type ModelesDocumentsQueryVariables = Exact<{
  investisseurCouple: Scalars['Boolean']['input'];
  codeConsultant?: InputMaybe<Scalars['String']['input']>;
}>;


export type ModelesDocumentsQuery = { __typename?: 'Query', modelesDocuments: Array<{ __typename?: 'ModeleDocument', id: number, categorie: string, nom: string, template?: string | null }> };

export type GenerateDocumentFromModelMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  investisseurId: Scalars['Long']['input'];
  template: Scalars['String']['input'];
  coInvestisseurId?: InputMaybe<Scalars['Long']['input']>;
  consultantCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateDocumentFromModelMutation = { __typename?: 'Mutation', generateDocumentFromModel?: { __typename?: 'StorageFile', createdDate?: any | null, denomination?: string | null, documentType: DocumentTypeEnum, fileExtension: string, fileName: string, fileType: string, id: string, isBlob: boolean, isTemporary?: boolean | null, lastModificationDate?: any | null, status?: FileStorageStatus | null, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', blobFileId: string, expiration: any, permissions: Array<BlobFilesPermissionDs>, sasUrl: string } | null } | null };

export type GenerateSyntesePatrimonialMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
  recueilMetadataId: Scalars['Long']['input'];
  avecCoInvestisseur: Scalars['Boolean']['input'];
  consultantCode?: InputMaybe<Scalars['String']['input']>;
  pyramidChartImage?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateSyntesePatrimonialMutation = { __typename?: 'Mutation', generateSyntesePatrimonial?: { __typename?: 'StorageFile', consultantCode?: string | null, createdDate?: any | null, denomination?: string | null, documentType: DocumentTypeEnum, fileExtension: string, fileName: string, fileNameWithExtension?: string | null, fileType: string, id: string, isBlob: boolean, isTemporary?: boolean | null, lastModificationDate?: any | null, status?: FileStorageStatus | null, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', blobFileId: string, expiration: any, permissions: Array<BlobFilesPermissionDs>, sasUrl: string } | null } | null };

export type VueDEnsembleDetailsFragment = { __typename?: 'VueDEnsembleResult', dateCalculIndicateur?: any | null, capaciteEpargne?: any | null, capaciteRemboursementEmpruntRestant?: any | null, epargneDisponible?: any | null, epargnePrecautionReelle?: any | null, epargnePrecautionSouhaitee?: any | null, effortEpargne?: any | null, impotNetIFI?: any | null, impotNetIR?: any | null, montantRemboursement?: any | null, prochaineDateEcheance?: any | null, soldeBudgetaire?: any | null, tauxEndetement?: number | null, soitParMois?: any | null, tauxMarginalImposition?: number | null, tauxMarginalImpositionCoInvestisseur?: number | null, profilInvestisseur?: { __typename?: 'VEProfilInvestisseur', profilDeRisque?: number | null, connaissanceExperiences?: number | null, esg?: number | null, reponseESG?: number | null } | null, profilCoInvestisseur?: { __typename?: 'VEProfilInvestisseur', profilDeRisque?: number | null, connaissanceExperiences?: number | null, esg?: number | null, reponseESG?: number | null } | null, patrimoines?: Array<{ __typename?: 'VESituationFinanciere', categoryTitle: string, subCategory?: string | null, filiale?: string | null, totalCategory?: any | null, elements?: Array<{ __typename?: 'VEElement', description: string, title: string, value?: any | null }> | null }> | null, repartitions?: Array<{ __typename?: 'VESituationFinanciere', categoryTitle: string, subCategory?: string | null, filiale?: string | null, totalCategory?: any | null, elements?: Array<{ __typename?: 'VEElement', description: string, title: string, value?: any | null }> | null }> | null, revenusCharges?: Array<{ __typename?: 'VESituationFinanciere', categoryTitle: string, subCategory?: string | null, filiale?: string | null, totalCategory?: any | null, elements?: Array<{ __typename?: 'VEElement', description: string, title: string, value?: any | null }> | null }> | null, vueObjectifs?: Array<{ __typename?: 'VEObjectif', horizon?: number | null, name: string, owner?: Array<any> | null, order?: number | null }> | null, situations?: Array<{ __typename?: 'VESituation', situationType: TermeEnum, totalCategory?: any | null, elements?: Array<{ __typename?: 'VEElement', description: string, title: string, value?: any | null }> | null }> | null };

export type GetVueDEnsemmbleByInvestisseurIdQueryVariables = Exact<{
  id: Scalars['Long']['input'];
  avecCoInvestisseur?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetVueDEnsemmbleByInvestisseurIdQuery = { __typename?: 'Query', investisseurById?: { __typename?: 'Investisseur', id: any, vueDEnsemble: { __typename?: 'VueDEnsembleResult', dateCalculIndicateur?: any | null, capaciteEpargne?: any | null, capaciteRemboursementEmpruntRestant?: any | null, epargneDisponible?: any | null, epargnePrecautionReelle?: any | null, epargnePrecautionSouhaitee?: any | null, effortEpargne?: any | null, impotNetIFI?: any | null, impotNetIR?: any | null, montantRemboursement?: any | null, prochaineDateEcheance?: any | null, soldeBudgetaire?: any | null, tauxEndetement?: number | null, soitParMois?: any | null, tauxMarginalImposition?: number | null, tauxMarginalImpositionCoInvestisseur?: number | null, profilInvestisseur?: { __typename?: 'VEProfilInvestisseur', profilDeRisque?: number | null, connaissanceExperiences?: number | null, esg?: number | null, reponseESG?: number | null } | null, profilCoInvestisseur?: { __typename?: 'VEProfilInvestisseur', profilDeRisque?: number | null, connaissanceExperiences?: number | null, esg?: number | null, reponseESG?: number | null } | null, patrimoines?: Array<{ __typename?: 'VESituationFinanciere', categoryTitle: string, subCategory?: string | null, filiale?: string | null, totalCategory?: any | null, elements?: Array<{ __typename?: 'VEElement', description: string, title: string, value?: any | null }> | null }> | null, repartitions?: Array<{ __typename?: 'VESituationFinanciere', categoryTitle: string, subCategory?: string | null, filiale?: string | null, totalCategory?: any | null, elements?: Array<{ __typename?: 'VEElement', description: string, title: string, value?: any | null }> | null }> | null, revenusCharges?: Array<{ __typename?: 'VESituationFinanciere', categoryTitle: string, subCategory?: string | null, filiale?: string | null, totalCategory?: any | null, elements?: Array<{ __typename?: 'VEElement', description: string, title: string, value?: any | null }> | null }> | null, vueObjectifs?: Array<{ __typename?: 'VEObjectif', horizon?: number | null, name: string, owner?: Array<any> | null, order?: number | null }> | null, situations?: Array<{ __typename?: 'VESituation', situationType: TermeEnum, totalCategory?: any | null, elements?: Array<{ __typename?: 'VEElement', description: string, title: string, value?: any | null }> | null }> | null } } | null };

export type AvancementConnaissanceClientFragmentFragment = { __typename?: 'AvancementConnaissanceClientInvestisseur', budgetState: RecueilStepState, cnIdocumentID?: string | null, cniEtat: EtatCni, cniLastChangeDate: any, cniReferenceDate?: any | null, deRdocumentID?: string | null, derEtat: EtatDer, derLastChangeDate: any, derReferenceDate?: any | null, etatGlobal: EtatGlobalInvestisseur, etatGlobalLastChangeDate: any, fiscaliteState: RecueilStepState, id: any, investisseurId: any, isRecueilFormCompleted: boolean, lastChangeDate: any, metadatasConnaissanceClientId: any, objectifsState: RecueilStepState, patrimoineState: RecueilStepState, qpIdocumentID?: string | null, qpiEtat: EtatQpi, qpiLastChangeDate: any, qpiReferenceDate?: any | null, recueildocumentID?: string | null, recueilEtat: EtatRecueil, recueilLastChangeDate: any, recueilReferenceDate?: any | null, situationPersonnelleState: RecueilStepState, statutFormulaireQPI: FormulaireStatut, statutFormulaireRecueil: FormulaireStatut, metadatasConnaissanceClient: { __typename?: 'MetadatasConnaissanceClient', id: any } };

export type MetadatasConnaissanceClientStateFragmentFragment = { __typename?: 'MetadatasConnaissanceClient', id: any };

export type MetadatasConnaissanceClientStateDetailledFragmentFragment = { __typename?: 'MetadatasConnaissanceClient', id: any, avancementsConnaissanceClientInvestisseurs: Array<{ __typename?: 'AvancementConnaissanceClientInvestisseur', budgetState: RecueilStepState, cnIdocumentID?: string | null, cniEtat: EtatCni, cniLastChangeDate: any, cniReferenceDate?: any | null, deRdocumentID?: string | null, derEtat: EtatDer, derLastChangeDate: any, derReferenceDate?: any | null, etatGlobal: EtatGlobalInvestisseur, etatGlobalLastChangeDate: any, fiscaliteState: RecueilStepState, id: any, investisseurId: any, isRecueilFormCompleted: boolean, lastChangeDate: any, metadatasConnaissanceClientId: any, objectifsState: RecueilStepState, patrimoineState: RecueilStepState, qpIdocumentID?: string | null, qpiEtat: EtatQpi, qpiLastChangeDate: any, qpiReferenceDate?: any | null, recueildocumentID?: string | null, recueilEtat: EtatRecueil, recueilLastChangeDate: any, recueilReferenceDate?: any | null, situationPersonnelleState: RecueilStepState, statutFormulaireQPI: FormulaireStatut, statutFormulaireRecueil: FormulaireStatut, metadatasConnaissanceClient: { __typename?: 'MetadatasConnaissanceClient', id: any } }> };

export type EtiquetteFragmentFragment = { __typename?: 'Etiquette', color: string, id: any, label: string };

export type DetailedInvestisseurFragment = { __typename?: 'Investisseur', code: string, id: any, pendingPurge: boolean, statutCode: string, avancementConnaissanceClientInvestisseur?: { __typename?: 'AvancementConnaissanceClientInvestisseur', budgetState: RecueilStepState, cnIdocumentID?: string | null, cniEtat: EtatCni, cniLastChangeDate: any, cniReferenceDate?: any | null, deRdocumentID?: string | null, derEtat: EtatDer, derLastChangeDate: any, derReferenceDate?: any | null, etatGlobal: EtatGlobalInvestisseur, etatGlobalLastChangeDate: any, fiscaliteState: RecueilStepState, id: any, investisseurId: any, isRecueilFormCompleted: boolean, lastChangeDate: any, metadatasConnaissanceClientId: any, objectifsState: RecueilStepState, patrimoineState: RecueilStepState, qpIdocumentID?: string | null, qpiEtat: EtatQpi, qpiLastChangeDate: any, qpiReferenceDate?: any | null, recueildocumentID?: string | null, recueilEtat: EtatRecueil, recueilLastChangeDate: any, recueilReferenceDate?: any | null, situationPersonnelleState: RecueilStepState, statutFormulaireQPI: FormulaireStatut, statutFormulaireRecueil: FormulaireStatut, metadatasConnaissanceClient: { __typename?: 'MetadatasConnaissanceClient', id: any } } | null, personnePhysique: Array<{ __typename?: 'PersonnePhysique', id: any, dateNaissance?: any | null, nom: string, prenom: string, nomNaissance?: string | null, villeNaissanceNom?: string | null, departementNaissance?: string | null, codePaysNaissance?: string | null, codePaysNaissanceNavigation?: { __typename?: 'Pays', libelle: string } | null, email: Array<{ __typename?: 'Email', id: any, adresse: string, estAdresseCorrespondance?: boolean | null }>, adresse: Array<{ __typename?: 'Adresse', adresse1?: string | null, adresse2?: string | null, adresse3?: string | null, complement?: string | null, codePostalCode?: string | null, villeNom?: string | null, paysCode?: string | null, typeAdresseCode: string, paysCodeNavigation?: { __typename?: 'Pays', libelle: string } | null }>, telephone: Array<{ __typename?: 'Telephone', id: any, numero: string, estNumeroCorrespondance?: boolean | null }>, etatCivil?: { __typename?: 'EtatCivil', personnePhysiqueId: any, typeSituationEtatCivilCode?: string | null, regimePacsIndivision?: boolean | null, typeRegimeSituationEtatCivilCode?: string | null, nombreEnfantACharge?: any | null, typeSituationEtatCivilCodeNavigation?: { __typename?: 'TypeSituationEtatCivil', libelle: string, actif?: boolean | null } | null, typeRegimeSituationEtatCivilCodeNavigation?: { __typename?: 'TypeRegimeSituationEtatCivil', libelle: string } | null } | null, situationProfessionnelle?: { __typename?: 'SituationProfessionnelle', profession?: string | null, origineRevenus?: string | null, nomSociete?: string | null, categorieSocioProfessionnelleCodeAtlas?: any | null, note: Array<{ __typename?: 'Note', note1: string }>, categorieSocioProfessionnelleCodeAtlasNavigation?: { __typename?: 'CategorieSocioProfessionnelle', parent?: any | null } | null } | null, relationFamillePersonnePhysique: Array<{ __typename?: 'RelationFamilleSimple', typeRelationFamilleCode: string, autrePersonnePhysique?: { __typename?: 'PersonnePhysique', investisseur: Array<{ __typename?: 'Investisseur', code: string, id: any }> } | null }>, relationCouplePersonnePhysique?: { __typename?: 'RelationCoupleSimple', typeRelationCoupleCode: string, autrePersonnePhysiqueId?: any | null, autrePersonnePhysique?: { __typename?: 'PersonnePhysique', nom: string, prenom: string, nomNaissance?: string | null, dateNaissance?: any | null, villeNaissanceNom?: string | null, departementNaissance?: string | null, codePaysNaissance?: string | null, codePaysNaissanceNavigation?: { __typename?: 'Pays', libelle: string } | null, adresse: Array<{ __typename?: 'Adresse', adresse1?: string | null, adresse2?: string | null, adresse3?: string | null, complement?: string | null, codePostalCode?: string | null, villeNom?: string | null, paysCode?: string | null, typeAdresseCode: string, paysCodeNavigation?: { __typename?: 'Pays', libelle: string } | null }>, situationProfessionnelle?: { __typename?: 'SituationProfessionnelle', profession?: string | null, origineRevenus?: string | null, nomSociete?: string | null, categorieSocioProfessionnelleCodeAtlas?: any | null, note: Array<{ __typename?: 'Note', note1: string }>, categorieSocioProfessionnelleCodeAtlasNavigation?: { __typename?: 'CategorieSocioProfessionnelle', parent?: any | null } | null } | null, etatCivil?: { __typename?: 'EtatCivil', personnePhysiqueId: any, typeSituationEtatCivilCode?: string | null, nombreEnfantACharge?: any | null, typeSituationEtatCivilCodeNavigation?: { __typename?: 'TypeSituationEtatCivil', libelle: string, actif?: boolean | null } | null, typeRegimeSituationEtatCivilCodeNavigation?: { __typename?: 'TypeRegimeSituationEtatCivil', libelle: string } | null } | null, investisseur: Array<{ __typename?: 'Investisseur', code: string, id: any, statutCode: string, avancementConnaissanceClientInvestisseur?: { __typename?: 'AvancementConnaissanceClientInvestisseur', id: any, cnIdocumentID?: string | null, cniEtat: EtatCni, cniLastChangeDate: any, derEtat: EtatDer, deRdocumentID?: string | null, qpiEtat: EtatQpi, qpIdocumentID?: string | null, isRecueilFormCompleted: boolean, recueilEtat: EtatRecueil, recueildocumentID?: string | null, metadatasConnaissanceClient: { __typename?: 'MetadatasConnaissanceClient', id: any } } | null }>, telephone: Array<{ __typename?: 'Telephone', numero: string, estNumeroCorrespondance?: boolean | null }>, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null }> } | null } | null }>, etiquettes?: Array<{ __typename?: 'Etiquette', color: string, id: any, label: string }> | null, investisseurConsultantRelations?: Array<{ __typename?: 'InvestisseurRelationConsultant', consultantCode?: string | null, consultantId: any, nom?: string | null, prenom?: string | null, typeRelationInvestisseurConsultantCode?: string | null }> | null };

export type PreferencesSettingsFragmentFragment = { __typename?: 'ConsultantPreferences', ordreSignature: ConsultantOrdreSignatureEnum, generationRecueilType: GenerationRecueilTypeEnum, recueilChampsComplementairesVisible: boolean };

export type CancelSignaturesMutationVariables = Exact<{
  documentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CancelSignaturesMutation = { __typename?: 'Mutation', cancelSignatures: Array<string> };

export type CreateSignaturesMutationVariables = Exact<{
  input: Array<DocumentSignatureInput> | DocumentSignatureInput;
}>;


export type CreateSignaturesMutation = { __typename?: 'Mutation', createSignatures: Array<string> };

export type DeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument: boolean };

export type GedCreateEmptyGedFileMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  dateFinValidite?: InputMaybe<Scalars['DateTime']['input']>;
  documentType?: InputMaybe<GedDocumentType>;
  denomination: Scalars['String']['input'];
  investisseurId: Scalars['Long']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  dateSignature?: InputMaybe<Scalars['DateTime']['input']>;
  isHandwrittenSignature?: InputMaybe<Scalars['Boolean']['input']>;
  investisseurIds?: InputMaybe<Array<Scalars['Long']['input']> | Scalars['Long']['input']>;
  categorieCode?: InputMaybe<GedCategory>;
  dateDeReference?: InputMaybe<Scalars['LocalDate']['input']>;
}>;


export type GedCreateEmptyGedFileMutation = { __typename?: 'Mutation', createFileMetadata: { __typename?: 'FileMetadata', fileId?: string | null, versionNumber?: number | null, url?: string | null, investisseurId?: any | null, extension?: string | null, denomination?: string | null, typeDocumentCode?: string | null, dateDeCreation: any, creePar?: string | null, dateDeDerniereModification: any, derniereModificationPar?: string | null, fileName?: string | null, dateSignature?: any | null, urlExpireDate?: any | null, permission?: Permission | null, typeLibelle?: string | null } };

export type RelanceSignaturesMutationVariables = Exact<{
  documentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RelanceSignaturesMutation = { __typename?: 'Mutation', relanceSignatures: boolean };

export type RequestInvestisseurPurgeMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
}>;


export type RequestInvestisseurPurgeMutation = { __typename?: 'Mutation', requestInvestisseurPurge: { __typename?: 'InvestorPurgeRequestResult', investorId: any, isBlocked: boolean, check: { __typename?: 'InvestorPurgeCheckResponse', investorId: any, canPurge: boolean, blockingIssueCount: number, warningCount: number, checks: Array<{ __typename?: 'InvestorPurgeCheckItemResponse', key: string, label: string, severity: string, isOk: boolean, message: string, familyRelations: Array<{ __typename?: 'InvestorPurgeFamilyRelationResponse', relationId?: any | null, relationTypeCode?: string | null, relatedInvestorId: any, relatedInvestorCode: string, relatedInvestorDisplayName: string, relatedInvestorStatusCode?: string | null }> }> }, execution?: { __typename?: 'InvestorPurgeExecutionResponse', investorId: any, executionId: string, isInProgress: boolean, statusLevel: string, status?: string | null, startedAtUtc: any, lastStatusCheckedAtUtc?: any | null, completedAtUtc?: any | null } | null } };

export type UpdateConsultantPreferencesSettingsMutationVariables = Exact<{
  input: ConsultantPreferencesInput;
}>;


export type UpdateConsultantPreferencesSettingsMutation = { __typename?: 'Mutation', createOrUpdateConsultantPreferences: Array<{ __typename?: 'ConsultantPreferences', ordreSignature: ConsultantOrdreSignatureEnum, generationRecueilType: GenerationRecueilTypeEnum, recueilChampsComplementairesVisible: boolean }> };

export type UpdateFileMetadataMutationVariables = Exact<{
  fileId: Scalars['String']['input'];
  newMetadata: UpdateDocumentMetadatasCommandInput;
}>;


export type UpdateFileMetadataMutation = { __typename?: 'Mutation', updateFileMetadata?: { __typename?: 'FileMetadata', fileId?: string | null } | null };

export type CanAccessMinotaureAppQueryVariables = Exact<{ [key: string]: never; }>;


export type CanAccessMinotaureAppQuery = { __typename?: 'Query', minotaureAppAccessRight: boolean };

export type CategorieSocioProfessionnellesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorieSocioProfessionnellesQuery = { __typename?: 'Query', categorieSocioProfessionnelles: Array<{ __typename?: 'CategorieSocioProfessionnelle', code: any, libelle: string, parent?: any | null, parentNavigation?: { __typename?: 'CategorieSocioProfessionnelle', code: any, libelle: string } | null, inverseParentNavigation: Array<{ __typename?: 'CategorieSocioProfessionnelle', code: any, libelle: string }> }> };

export type ConsultantPreferencesSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsultantPreferencesSettingsQuery = { __typename?: 'Query', consultantPreferences: Array<{ __typename?: 'ConsultantPreferences', ordreSignature: ConsultantOrdreSignatureEnum, generationRecueilType: GenerationRecueilTypeEnum, recueilChampsComplementairesVisible: boolean }> };

export type ConsultantByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ConsultantByCodeQuery = { __typename?: 'Query', consultantByCode?: { __typename?: 'Consultant', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', code?: string | null, nom: string, prenom: string, personnePhysiqueDocument: Array<{ __typename?: 'PersonnePhysiqueDocument', codeTypeDocument: string, documentId?: any | null, id: any }>, email: Array<{ __typename?: 'Email', id: any, adresse: string, estAdresseCorrespondance?: boolean | null }>, telephone: Array<{ __typename?: 'Telephone', id: any, numero: string, estNumeroCorrespondance?: boolean | null }> }>, consultantHabilitations: Array<{ __typename?: 'ConsultantHabilitation', id: any, habilitationId?: any | null, dateDebut?: any | null, dateFin?: any | null, consultantId?: any | null, codeHabilitation?: string | null, statut?: number | null, cifPartenaireCode?: string | null, habilitation?: { __typename?: 'Habilitation', id: any, code?: string | null, libelle?: string | null } | null }>, email: Array<{ __typename?: 'Email', id: any, adresse: string, estAdresseCorrespondance?: boolean | null }>, telephone: Array<{ __typename?: 'Telephone', id: any, numero: string, estNumeroCorrespondance?: boolean | null }>, abonnementConsultant: Array<{ __typename?: 'AbonnementConsultant', expirationAcces?: any | null, referenceProduit: string }> } | null };

export type DocumentCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentCategoriesQuery = { __typename?: 'Query', documentCategories: Array<{ __typename?: 'DocumentCategory', id: number, label: string, gedCategoryCode: string }> };

export type DocumentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentTypesQuery = { __typename?: 'Query', documentTypes: Array<{ __typename?: 'DocumentType', id: number, label: string, gedTypeCode: string, isDeprecated?: boolean | null, replacementGedTypeCode?: string | null, availableForRequest: boolean, groupName?: string | null, hasRectoVerso?: boolean | null, maxExpectedDocument?: number | null, hasReferenceDate?: boolean | null, hasExpirationDate?: boolean | null, fileNamePrefix: string, documentCategory: { __typename?: 'DocumentCategory', gedCategoryCode: string, id: number } }> };

export type DocumentsGetDocumentMedatadasByIdQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type DocumentsGetDocumentMedatadasByIdQuery = { __typename?: 'Query', fileMetadataById?: { __typename?: 'FileMetadata', fileId?: string | null, dateDeDerniereModification: any, dateDeCreation: any, denomination?: string | null, extension?: string | null, fileName?: string | null, typeLibelle?: string | null, url?: string | null, urlExpireDate?: any | null, isHandwrittenSignature: boolean, typeDocumentCode?: string | null, dateDeFinValidite?: any | null, dateDeReference?: any | null } | null };

export type DocumentsGetDocumentUploadUriByIdQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type DocumentsGetDocumentUploadUriByIdQuery = { __typename?: 'Query', fileUploadUriById: string };

export type DocumentsByFilterQueryVariables = Exact<{
  documentFilterConfiguration: DocumentFilterConfigurationInput;
}>;


export type DocumentsByFilterQuery = { __typename?: 'Query', fileMetadataByFilters: Array<{ __typename?: 'FileMetadata', consultantId?: any | null, contratId?: string | null, creePar?: string | null, dateDeCreation: any, dateDeDerniereModification: any, dateDeFinValidite?: any | null, dateDeReference?: any | null, dateSignature?: any | null, denomination?: string | null, derniereModificationPar?: string | null, documentIdentifier?: string | null, etatSignature?: SignatureState | null, extension?: string | null, fileId?: string | null, fileName?: string | null, investisseurId?: any | null, investisseurIds?: Array<any> | null, isHandwrittenSignature: boolean, patrimoineId?: string | null, tags?: Array<string> | null, typeDocumentCode?: string | null, url?: string | null, categorieCode?: GedCategory | null, signatureId?: string | null, signatureOrder?: number | null }> };

export type DocumentsByFilterPaginatedQueryVariables = Exact<{
  documentFilterConfiguration: DocumentFilterConfigurationInput;
}>;


export type DocumentsByFilterPaginatedQuery = { __typename?: 'Query', fileMetadataByFiltersPaginated: { __typename?: 'PaginatedResultOfFileMetadata', continuationToken?: string | null, totalCount?: number | null, data?: Array<{ __typename?: 'FileMetadata', consultantId?: any | null, contratId?: string | null, creePar?: string | null, dateDeCreation: any, dateDeDerniereModification: any, dateDeFinValidite?: any | null, dateDeReference?: any | null, dateSignature?: any | null, denomination?: string | null, derniereModificationPar?: string | null, documentIdentifier?: string | null, etatSignature?: SignatureState | null, extension?: string | null, fileId?: string | null, fileName?: string | null, investisseurId?: any | null, investisseurIds?: Array<any> | null, isHandwrittenSignature: boolean, patrimoineId?: string | null, tags?: Array<string> | null, typeDocumentCode?: string | null, url?: string | null, categorieCode?: GedCategory | null, signatureId?: string | null, signatureOrder?: number | null, investisseurs: Array<{ __typename?: 'FileInvestisseur', id: any, code?: string | null, nom?: string | null, prenom?: string | null } | null> }> | null } };

export type DocumentsCountByFilterQueryVariables = Exact<{
  documentFilterConfiguration: DocumentFilterConfigurationInput;
}>;


export type DocumentsCountByFilterQuery = { __typename?: 'Query', fileMetadataCountByFilters: number };

export type DocumentsSignatureStateByFilterQueryVariables = Exact<{
  documentFilterConfiguration: DocumentFilterConfigurationInput;
}>;


export type DocumentsSignatureStateByFilterQuery = { __typename?: 'Query', fileMetadataByFilters: Array<{ __typename?: 'FileMetadata', fileId?: string | null, signatureStates?: { __typename?: 'SignerStatesResponse', requestStatus: SignerStateStatusEnum, states?: Array<{ __typename?: 'SignerStates', actionDate: any, email: string, firstName: string, lastName: string, signatureState: SignerStatus, internalId?: number | null, type?: SignataireType | null }> | null } | null }> };

export type InvestisseurPurgeCheckQueryVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
}>;


export type InvestisseurPurgeCheckQuery = { __typename?: 'Query', investisseurPurgeCheck: { __typename?: 'InvestorPurgeCheckResponse', investorId: any, canPurge: boolean, blockingIssueCount: number, warningCount: number, checks: Array<{ __typename?: 'InvestorPurgeCheckItemResponse', key: string, label: string, severity: string, isOk: boolean, message: string, familyRelations: Array<{ __typename?: 'InvestorPurgeFamilyRelationResponse', relationId?: any | null, relationTypeCode?: string | null, relatedInvestorId: any, relatedInvestorCode: string, relatedInvestorDisplayName: string, relatedInvestorStatusCode?: string | null }> }> } };

export type InvestisseurPurgeExecutionQueryVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
}>;


export type InvestisseurPurgeExecutionQuery = { __typename?: 'Query', investisseurPurgeExecution?: { __typename?: 'InvestorPurgeExecutionResponse', investorId: any, executionId: string, isInProgress: boolean, statusLevel: string, status?: string | null, startedAtUtc: any, lastStatusCheckedAtUtc?: any | null, completedAtUtc?: any | null } | null };

export type InvestisseurAutoCompleteByNamePaginatedQueryVariables = Exact<{
  order?: InputMaybe<Array<InvestisseurSortInput> | InvestisseurSortInput>;
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  where?: InputMaybe<InvestisseurFilterInput>;
  searchText: Scalars['String']['input'];
}>;


export type InvestisseurAutoCompleteByNamePaginatedQuery = { __typename?: 'Query', investisseursByNamePaginated?: { __typename?: 'InvestisseursByNamePaginatedCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Investisseur', code: string, id: any, statutCode: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', civiliteCode: string, nom: string, prenom: string, dateNaissance?: any | null, id: any }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type InvestisseurNameAndCodeFragment = { __typename?: 'Investisseur', code: string, id: any, statutCode: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', civiliteCode: string, nom: string, prenom: string, dateNaissance?: any | null, id: any }> };

export type InvestisseurDocumentsQueryVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
  where?: InputMaybe<FileMetadataFilterInput>;
}>;


export type InvestisseurDocumentsQuery = { __typename?: 'Query', investisseurFiles: Array<{ __typename?: 'FileMetadata', consultantId?: any | null, contratId?: string | null, creePar?: string | null, dateDeCreation: any, dateDeDerniereModification: any, dateDeFinValidite?: any | null, dateDeReference?: any | null, dateSignature?: any | null, denomination?: string | null, derniereModificationPar?: string | null, documentIdentifier?: string | null, etatSignature?: SignatureState | null, extension?: string | null, fileId?: string | null, fileName?: string | null, investisseurId?: any | null, investisseurIds?: Array<any> | null, isHandwrittenSignature: boolean, patrimoineId?: string | null, tags?: Array<string> | null, typeDocumentCode?: string | null, url?: string | null, categorieCode?: GedCategory | null, signatureId?: string | null, signatureOrder?: number | null }> };

export type PaysQueryVariables = Exact<{ [key: string]: never; }>;


export type PaysQuery = { __typename?: 'Query', pays: Array<{ __typename?: 'Pays', code: string, libelle: string, nationalite?: string | null, nationaliteCode: string }> };

export type RegimeActivitesQueryVariables = Exact<{ [key: string]: never; }>;


export type RegimeActivitesQuery = { __typename?: 'Query', regimeActivites: Array<{ __typename?: 'RegimeActivite', code: number, libelle: string }> };

export type SecteurActivitesQueryVariables = Exact<{ [key: string]: never; }>;


export type SecteurActivitesQuery = { __typename?: 'Query', secteurActivites: Array<{ __typename?: 'SecteurActivite', code: number, libelle: string }> };

export type SignatureDocumentsFilterValuesQueryVariables = Exact<{
  documentFilterConfiguration: DocumentFilterConfigurationInput;
}>;


export type SignatureDocumentsFilterValuesQuery = { __typename?: 'Query', signatureDocumentFilterValues: { __typename?: 'SignatureDocumentFilterValues', typeDocumentCodes: Array<string>, etatSignatures: Array<SignatureState> } };

export type TypeAvantageMatrimoniauxQueryVariables = Exact<{ [key: string]: never; }>;


export type TypeAvantageMatrimoniauxQuery = { __typename?: 'Query', typeAvantageMatrimoniaux: Array<{ __typename?: 'TypeAvantageMatrimonial', code: string, libelle: string }> };

export type TypePpeMotifsQueryVariables = Exact<{ [key: string]: never; }>;


export type TypePpeMotifsQuery = { __typename?: 'Query', typePpeMotifs: Array<{ __typename?: 'TypePpeMotif', code: string, libelle: string }> };

export type TypePpeRelationsQueryVariables = Exact<{ [key: string]: never; }>;


export type TypePpeRelationsQuery = { __typename?: 'Query', typePpeRelations: Array<{ __typename?: 'TypePpeRelation', code: string, libelle: string }> };

export type TypeRelationAutresQueryVariables = Exact<{ [key: string]: never; }>;


export type TypeRelationAutresQuery = { __typename?: 'Query', typeRelationAutres: Array<{ __typename?: 'TypeRelationAutre', code: string, libelle: string }> };

export type TypeSituationProfessionnellesQueryVariables = Exact<{ [key: string]: never; }>;


export type TypeSituationProfessionnellesQuery = { __typename?: 'Query', typeSituationProfessionnelles: Array<{ __typename?: 'TypeSituationProfessionnelle', code: number, libelle: string }> };

export type TypeStatutProfessionnelsQueryVariables = Exact<{ [key: string]: never; }>;


export type TypeStatutProfessionnelsQuery = { __typename?: 'Query', typeStatutProfessionnels: Array<{ __typename?: 'TypeStatutProfessionnel', code: number, libelle: string }> };

export type OperationConfigFieldsFragment = { __typename?: 'OperationConfig', conseilConfig?: { __typename?: 'OperationConseilConfig', typesDocumentRequis: Array<{ __typename?: 'DocumentType', fileNamePrefix: string, gedTypeCode: string, label: string, documentCategory: { __typename?: 'DocumentCategory', label: string, gedCategoryCode: string } }>, enveloppeConfig: { __typename?: 'AdequationConfig', fieldConfigs: Array<{ __typename?: 'FieldConfig', fieldKey: string, isVisible: boolean, visibilityCondition?: { __typename?: 'FieldVisibilityCondition', fieldKey: string, operator: FieldVisibilityOperator, value?: string | null } | null, validators: Array<{ __typename?: 'FieldValidatorConfig', errorMessage: string, validatorKey: string, parameters: Array<{ __typename?: 'FieldValidatorConfigParameter', id: string, key: string, value: string }> }> }> }, produitSpecificConfigs: Array<{ __typename?: 'ProduitSpecificConfig', produitId: any, ficheProduitUrl?: string | null, extranetPartenaireUrl?: string | null, produitAtlas: { __typename?: 'Produit', nom: string }, config: { __typename?: 'AdequationConfig', fieldConfigs: Array<{ __typename?: 'FieldConfig', fieldKey: string, isVisible: boolean, visibilityCondition?: { __typename?: 'FieldVisibilityCondition', fieldKey: string, operator: FieldVisibilityOperator, value?: string | null } | null, validators: Array<{ __typename?: 'FieldValidatorConfig', errorMessage: string, validatorKey: string, parameters: Array<{ __typename?: 'FieldValidatorConfigParameter', id: string, key: string, value: string }> }> }> }, produit: { __typename?: 'ProduitOperationExtension', gestionPossibles?: Array<{ __typename?: 'ModeDeGestionConfig', modeDeGestionId: string, modeDeGestion?: { __typename?: 'ModeDeGestion', libelle?: string | null } | null, conditionVersementInitial?: { __typename?: 'ConditionVersementInitial', montantMinSouscription?: number | null, montantMinAvecVP?: number | null, montantMinAvecTransfert?: number | null } | null, conditionVersementProgramme?: { __typename?: 'ConditionVersementProgramme', montantMinMensuel?: number | null, montantMinTrimestriel?: number | null, montantMinSemestriel?: number | null, montantMinAnnuel?: number | null } | null }> | null, fondsEvenementiels?: Array<{ __typename?: 'FondsEvenementiel', id: string, code: string, libelle: string, ordre: number }> | null, optionsAutomatiques?: Array<{ __typename?: 'OptionAutomatique', id: string, libelle: string, modeDeGestionCode: string, ordre: number }> | null, allocations?: Array<{ __typename?: 'Allocation', id: string, libelle: string, modeDeGestionId: string, statut?: AllocationPartenaireStatut | null, niveauDeRisque: NiveauDeRisque, storageFile?: { __typename?: 'StorageFile', id: string, fileName: string, fileType: string } | null }> | null } }> } | null };

export type OperationDataFieldsFragment = { __typename?: 'OperationData', modeDeGestion?: string | null, disponibiliteEpargneOptions: Array<{ __typename?: 'DisponibiliteEpargneOption', id: string, label: string, value: DisponibiliteEpargne }>, modeDeGestionNavigation?: { __typename?: 'ModeDeGestion', id: string } | null, toleranceRisqueOptions: Array<{ __typename?: 'ToleranceRisqueOption', id: string, label: string, value: ToleranceRisque }>, snapshotData?: { __typename?: 'OperationSnapshotData', boxPlacementUrl?: string | null, souscription?: { __typename?: 'OperationSouscriptionSnapshot', produitId: any, modeSignature?: SouscriptionSignatureMode | null, transmissionOriginaux?: SouscriptionTransmissionOriginaux | null, dateSignature?: any | null, bulletinFileId?: string | null, bulletinFileIdToDelete?: string | null, commentaire?: string | null } | null, besoin?: { __typename?: 'BesoinsOperation', motivationOperation?: string | null, selectedObjectifCodes: Array<string>, disponibiliteEpargne?: DisponibiliteEpargne | null, toleranceRisque?: ToleranceRisque | null, horizonPlacement?: { __typename?: 'HorizonPlacement', horizonRetraite?: any | null, justification?: string | null, value?: HorizonPlacementEnum | null } | null } | null, connaissanceClient?: { __typename?: 'ConnaissanceClientData', toleranceRisque?: ToleranceRisque | null, investisseurs: Array<{ __typename?: 'InvestisseurOperationData', civiliteCode?: string | null, code?: string | null, creationDate?: any | null, dateNaissance?: any | null, denomination?: string | null, displayName?: string | null, id: any, nom?: string | null, prenom?: string | null, patrimoine?: { __typename?: 'SituationPatrimoineData', capaciteEpargneMensuel?: any | null, dateMiseAJourAtlas?: any | null, epargneFinanceMontantTotal?: any | null, epargneImmoMontantHorsRP?: any | null, revenuAnnuelTotal?: any | null } | null, profil?: { __typename?: 'ProfilInvestisseurData', resultatCapacitePerte?: number | null, resultatConnaissance?: number | null, resultatProfilDeRisque?: number | null, resultatSensibiliteExtraFinanciere?: number | null, resultatToleranceAuRisque?: number | null } | null, situationPersonnelle?: { __typename?: 'SituationPersonnelleData', categorieSocioProfessionnelleCode?: any | null, categorieSocioProfessionnelleLibelle?: string | null, dateMiseAJourAtlas?: any | null, enfantACharge?: number | null, etatCivilDisplay?: string | null, etatCivilTypeCode?: string | null, etatCivilTypeLibelle?: string | null, etatCivilTypeRegimeCode?: string | null, etatCivilTypeRegimeLibelle?: string | null, profession?: string | null } | null, statutCodeNavigation?: { __typename?: 'TypeStatutInvestisseur', code: string, libelle: string } | null }>, objectifs: Array<{ __typename?: 'InvestisseurObjectifData', categorieCode?: string | null, categorieLibelle: string, id: string, isSelected: boolean, objectifCode?: string | null, objectifLibelle: string }> } | null, conseil?: { __typename?: 'ConseilOperation', allocationPrecision?: string | null, allocationTransfertOption?: AllocationTransfertOption | null, allocationVersementOption?: AllocationVersementOption | null, arbitrageLibreSupportsEntrants?: string | null, arbitrageLibreSupportsSortants?: string | null, avecArbitragesProgrammes?: boolean | null, avecMiseEnPlaceOuModificationVP?: boolean | null, portefeuilleOption?: PortefeuilleOption | null, transactionPersonnelle?: TransactionPersonnelleEnum | null, vpModeOptions?: VpModeOptions | null, autoSouscription?: boolean | null, impactDiminutionFrais?: ImpactDiminutionFraisEnum | null, fondsEvenementiels: Array<{ __typename?: 'FondsEvenementielData', id: string, code: string, libelle: string, isSelected?: boolean | null }>, optionsAutomatiques: Array<{ __typename?: 'OptionAutomatiqueData', id: string, libelle: string, isSelected?: boolean | null }>, allocation?: { __typename?: 'AllocationConseil', id: string, libelle: string, modeDeGestionCode: string, niveauDeRisque: NiveauDeRisque } | null, arbitrageDuplicationContext?: { __typename?: 'ArbitrageDuplicationContext', objectifsIntersectionApplied?: boolean | null, sourceFicheId: string } | null, precisionComplementaire?: { __typename?: 'AdditionalDetails', commentaireAllocation?: string | null, commentaireAutre?: string | null, commentaireEnveloppe?: string | null } | null, versements: { __typename?: 'Versements', avecVersementProgramme: boolean, souscriptionAvecTransfert?: boolean | null, versementInitial?: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } | null, versementProgramme?: { __typename?: 'VersementProgramme', frequence?: FrequenceVersement | null, versement: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } } | null } } | null, signature?: { __typename?: 'OperationSignatureSnapshot', mode?: OperationSignatureMode | null, isLocked?: boolean | null, invalidatedFromStep?: OperationState | null, requiredDocuments?: Array<{ __typename?: 'OperationSignatureDocumentRequirement', typeDocumentCode: string, investisseurIds: Array<any> }> | null, documents?: Array<{ __typename?: 'OperationSignatureDocumentMetadata', fileId: string, sourceFileId?: string | null, versionNumber?: number | null, investisseurId?: any | null, investisseurIds?: Array<any> | null, extension?: string | null, actif?: boolean | null, denomination?: string | null, typeDocumentCode?: string | null, dateDeCreation?: any | null, dateDeDerniereModification?: any | null, etatSignature?: string | null, fileName?: string | null, dateSignature?: any | null, signataires?: Array<{ __typename?: 'OperationSignatureSignerMetadata', email: string, firstName: string, internalId?: number | null, lastName: string, phone: string, type: OperationSignatureSignerType }> | null }> | null } | null } | null };

export type ProjetDocumentFieldsFragment = { __typename?: 'ProjetDocument', id: any, fileId: string, typeDocumentCode: string, fileName: string, creationDate: any };

export type AcknowledgeOperationSouscriptionBulletinDeletionMutationVariables = Exact<{
  operationId: Scalars['UUID']['input'];
  produitId: Scalars['Long']['input'];
  fileId: Scalars['String']['input'];
}>;


export type AcknowledgeOperationSouscriptionBulletinDeletionMutation = { __typename?: 'Mutation', acknowledgeOperationSouscriptionBulletinDeletion: { __typename?: 'OperationData', modeDeGestion?: string | null, disponibiliteEpargneOptions: Array<{ __typename?: 'DisponibiliteEpargneOption', id: string, label: string, value: DisponibiliteEpargne }>, modeDeGestionNavigation?: { __typename?: 'ModeDeGestion', id: string } | null, toleranceRisqueOptions: Array<{ __typename?: 'ToleranceRisqueOption', id: string, label: string, value: ToleranceRisque }>, snapshotData?: { __typename?: 'OperationSnapshotData', boxPlacementUrl?: string | null, souscription?: { __typename?: 'OperationSouscriptionSnapshot', produitId: any, modeSignature?: SouscriptionSignatureMode | null, transmissionOriginaux?: SouscriptionTransmissionOriginaux | null, dateSignature?: any | null, bulletinFileId?: string | null, bulletinFileIdToDelete?: string | null, commentaire?: string | null } | null, besoin?: { __typename?: 'BesoinsOperation', motivationOperation?: string | null, selectedObjectifCodes: Array<string>, disponibiliteEpargne?: DisponibiliteEpargne | null, toleranceRisque?: ToleranceRisque | null, horizonPlacement?: { __typename?: 'HorizonPlacement', horizonRetraite?: any | null, justification?: string | null, value?: HorizonPlacementEnum | null } | null } | null, connaissanceClient?: { __typename?: 'ConnaissanceClientData', toleranceRisque?: ToleranceRisque | null, investisseurs: Array<{ __typename?: 'InvestisseurOperationData', civiliteCode?: string | null, code?: string | null, creationDate?: any | null, dateNaissance?: any | null, denomination?: string | null, displayName?: string | null, id: any, nom?: string | null, prenom?: string | null, patrimoine?: { __typename?: 'SituationPatrimoineData', capaciteEpargneMensuel?: any | null, dateMiseAJourAtlas?: any | null, epargneFinanceMontantTotal?: any | null, epargneImmoMontantHorsRP?: any | null, revenuAnnuelTotal?: any | null } | null, profil?: { __typename?: 'ProfilInvestisseurData', resultatCapacitePerte?: number | null, resultatConnaissance?: number | null, resultatProfilDeRisque?: number | null, resultatSensibiliteExtraFinanciere?: number | null, resultatToleranceAuRisque?: number | null } | null, situationPersonnelle?: { __typename?: 'SituationPersonnelleData', categorieSocioProfessionnelleCode?: any | null, categorieSocioProfessionnelleLibelle?: string | null, dateMiseAJourAtlas?: any | null, enfantACharge?: number | null, etatCivilDisplay?: string | null, etatCivilTypeCode?: string | null, etatCivilTypeLibelle?: string | null, etatCivilTypeRegimeCode?: string | null, etatCivilTypeRegimeLibelle?: string | null, profession?: string | null } | null, statutCodeNavigation?: { __typename?: 'TypeStatutInvestisseur', code: string, libelle: string } | null }>, objectifs: Array<{ __typename?: 'InvestisseurObjectifData', categorieCode?: string | null, categorieLibelle: string, id: string, isSelected: boolean, objectifCode?: string | null, objectifLibelle: string }> } | null, conseil?: { __typename?: 'ConseilOperation', allocationPrecision?: string | null, allocationTransfertOption?: AllocationTransfertOption | null, allocationVersementOption?: AllocationVersementOption | null, arbitrageLibreSupportsEntrants?: string | null, arbitrageLibreSupportsSortants?: string | null, avecArbitragesProgrammes?: boolean | null, avecMiseEnPlaceOuModificationVP?: boolean | null, portefeuilleOption?: PortefeuilleOption | null, transactionPersonnelle?: TransactionPersonnelleEnum | null, vpModeOptions?: VpModeOptions | null, autoSouscription?: boolean | null, impactDiminutionFrais?: ImpactDiminutionFraisEnum | null, fondsEvenementiels: Array<{ __typename?: 'FondsEvenementielData', id: string, code: string, libelle: string, isSelected?: boolean | null }>, optionsAutomatiques: Array<{ __typename?: 'OptionAutomatiqueData', id: string, libelle: string, isSelected?: boolean | null }>, allocation?: { __typename?: 'AllocationConseil', id: string, libelle: string, modeDeGestionCode: string, niveauDeRisque: NiveauDeRisque } | null, arbitrageDuplicationContext?: { __typename?: 'ArbitrageDuplicationContext', objectifsIntersectionApplied?: boolean | null, sourceFicheId: string } | null, precisionComplementaire?: { __typename?: 'AdditionalDetails', commentaireAllocation?: string | null, commentaireAutre?: string | null, commentaireEnveloppe?: string | null } | null, versements: { __typename?: 'Versements', avecVersementProgramme: boolean, souscriptionAvecTransfert?: boolean | null, versementInitial?: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } | null, versementProgramme?: { __typename?: 'VersementProgramme', frequence?: FrequenceVersement | null, versement: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } } | null } } | null, signature?: { __typename?: 'OperationSignatureSnapshot', mode?: OperationSignatureMode | null, isLocked?: boolean | null, invalidatedFromStep?: OperationState | null, requiredDocuments?: Array<{ __typename?: 'OperationSignatureDocumentRequirement', typeDocumentCode: string, investisseurIds: Array<any> }> | null, documents?: Array<{ __typename?: 'OperationSignatureDocumentMetadata', fileId: string, sourceFileId?: string | null, versionNumber?: number | null, investisseurId?: any | null, investisseurIds?: Array<any> | null, extension?: string | null, actif?: boolean | null, denomination?: string | null, typeDocumentCode?: string | null, dateDeCreation?: any | null, dateDeDerniereModification?: any | null, etatSignature?: string | null, fileName?: string | null, dateSignature?: any | null, signataires?: Array<{ __typename?: 'OperationSignatureSignerMetadata', email: string, firstName: string, internalId?: number | null, lastName: string, phone: string, type: OperationSignatureSignerType }> | null }> | null } | null } | null } };

export type AttachProjetDocumentMutationVariables = Exact<{
  projetId: Scalars['Long']['input'];
  fileId: Scalars['String']['input'];
}>;


export type AttachProjetDocumentMutation = { __typename?: 'Mutation', attachProjetDocument: { __typename?: 'ProjetDocument', id: any, fileId: string, typeDocumentCode: string, fileName: string, creationDate: any } };

export type CreateOperationBoxPlacementMutationVariables = Exact<{
  input: CreateOperationFromProxeemaInput;
}>;


export type CreateOperationBoxPlacementMutation = { __typename?: 'Mutation', createOperationBoxPlacement?: { __typename?: 'CreateOperationBoxPlacementResult', operationId: number, operationGroupId: number, statutId: number, resumePath: string, resumeUrl: string } | null };

export type CreateProjetMutationVariables = Exact<{
  input: ProjectCreationInput;
}>;


export type CreateProjetMutation = { __typename?: 'Mutation', createProjet: any };

export type CreateSouscriptionMutationVariables = Exact<{
  input: SouscriptionCreationInput;
}>;


export type CreateSouscriptionMutation = { __typename?: 'Mutation', createSouscription: any };

export type DeleteOperationMutationVariables = Exact<{
  operationId: Scalars['UUID']['input'];
}>;


export type DeleteOperationMutation = { __typename?: 'Mutation', deleteOperation: boolean };

export type DeleteProjetMutationVariables = Exact<{
  projectId: Scalars['Long']['input'];
}>;


export type DeleteProjetMutation = { __typename?: 'Mutation', deleteProjet: boolean };

export type DeleteProjetDocumentMutationVariables = Exact<{
  projetDocumentId: Scalars['Long']['input'];
}>;


export type DeleteProjetDocumentMutation = { __typename?: 'Mutation', deleteProjetDocument: boolean };

export type DetachOperationSouscriptionBulletinMutationVariables = Exact<{
  operationId: Scalars['UUID']['input'];
  produitId: Scalars['Long']['input'];
  fileId: Scalars['String']['input'];
}>;


export type DetachOperationSouscriptionBulletinMutation = { __typename?: 'Mutation', detachOperationSouscriptionBulletin: { __typename?: 'OperationData', modeDeGestion?: string | null, disponibiliteEpargneOptions: Array<{ __typename?: 'DisponibiliteEpargneOption', id: string, label: string, value: DisponibiliteEpargne }>, modeDeGestionNavigation?: { __typename?: 'ModeDeGestion', id: string } | null, toleranceRisqueOptions: Array<{ __typename?: 'ToleranceRisqueOption', id: string, label: string, value: ToleranceRisque }>, snapshotData?: { __typename?: 'OperationSnapshotData', boxPlacementUrl?: string | null, souscription?: { __typename?: 'OperationSouscriptionSnapshot', produitId: any, modeSignature?: SouscriptionSignatureMode | null, transmissionOriginaux?: SouscriptionTransmissionOriginaux | null, dateSignature?: any | null, bulletinFileId?: string | null, bulletinFileIdToDelete?: string | null, commentaire?: string | null } | null, besoin?: { __typename?: 'BesoinsOperation', motivationOperation?: string | null, selectedObjectifCodes: Array<string>, disponibiliteEpargne?: DisponibiliteEpargne | null, toleranceRisque?: ToleranceRisque | null, horizonPlacement?: { __typename?: 'HorizonPlacement', horizonRetraite?: any | null, justification?: string | null, value?: HorizonPlacementEnum | null } | null } | null, connaissanceClient?: { __typename?: 'ConnaissanceClientData', toleranceRisque?: ToleranceRisque | null, investisseurs: Array<{ __typename?: 'InvestisseurOperationData', civiliteCode?: string | null, code?: string | null, creationDate?: any | null, dateNaissance?: any | null, denomination?: string | null, displayName?: string | null, id: any, nom?: string | null, prenom?: string | null, patrimoine?: { __typename?: 'SituationPatrimoineData', capaciteEpargneMensuel?: any | null, dateMiseAJourAtlas?: any | null, epargneFinanceMontantTotal?: any | null, epargneImmoMontantHorsRP?: any | null, revenuAnnuelTotal?: any | null } | null, profil?: { __typename?: 'ProfilInvestisseurData', resultatCapacitePerte?: number | null, resultatConnaissance?: number | null, resultatProfilDeRisque?: number | null, resultatSensibiliteExtraFinanciere?: number | null, resultatToleranceAuRisque?: number | null } | null, situationPersonnelle?: { __typename?: 'SituationPersonnelleData', categorieSocioProfessionnelleCode?: any | null, categorieSocioProfessionnelleLibelle?: string | null, dateMiseAJourAtlas?: any | null, enfantACharge?: number | null, etatCivilDisplay?: string | null, etatCivilTypeCode?: string | null, etatCivilTypeLibelle?: string | null, etatCivilTypeRegimeCode?: string | null, etatCivilTypeRegimeLibelle?: string | null, profession?: string | null } | null, statutCodeNavigation?: { __typename?: 'TypeStatutInvestisseur', code: string, libelle: string } | null }>, objectifs: Array<{ __typename?: 'InvestisseurObjectifData', categorieCode?: string | null, categorieLibelle: string, id: string, isSelected: boolean, objectifCode?: string | null, objectifLibelle: string }> } | null, conseil?: { __typename?: 'ConseilOperation', allocationPrecision?: string | null, allocationTransfertOption?: AllocationTransfertOption | null, allocationVersementOption?: AllocationVersementOption | null, arbitrageLibreSupportsEntrants?: string | null, arbitrageLibreSupportsSortants?: string | null, avecArbitragesProgrammes?: boolean | null, avecMiseEnPlaceOuModificationVP?: boolean | null, portefeuilleOption?: PortefeuilleOption | null, transactionPersonnelle?: TransactionPersonnelleEnum | null, vpModeOptions?: VpModeOptions | null, autoSouscription?: boolean | null, impactDiminutionFrais?: ImpactDiminutionFraisEnum | null, fondsEvenementiels: Array<{ __typename?: 'FondsEvenementielData', id: string, code: string, libelle: string, isSelected?: boolean | null }>, optionsAutomatiques: Array<{ __typename?: 'OptionAutomatiqueData', id: string, libelle: string, isSelected?: boolean | null }>, allocation?: { __typename?: 'AllocationConseil', id: string, libelle: string, modeDeGestionCode: string, niveauDeRisque: NiveauDeRisque } | null, arbitrageDuplicationContext?: { __typename?: 'ArbitrageDuplicationContext', objectifsIntersectionApplied?: boolean | null, sourceFicheId: string } | null, precisionComplementaire?: { __typename?: 'AdditionalDetails', commentaireAllocation?: string | null, commentaireAutre?: string | null, commentaireEnveloppe?: string | null } | null, versements: { __typename?: 'Versements', avecVersementProgramme: boolean, souscriptionAvecTransfert?: boolean | null, versementInitial?: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } | null, versementProgramme?: { __typename?: 'VersementProgramme', frequence?: FrequenceVersement | null, versement: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } } | null } } | null, signature?: { __typename?: 'OperationSignatureSnapshot', mode?: OperationSignatureMode | null, isLocked?: boolean | null, invalidatedFromStep?: OperationState | null, requiredDocuments?: Array<{ __typename?: 'OperationSignatureDocumentRequirement', typeDocumentCode: string, investisseurIds: Array<any> }> | null, documents?: Array<{ __typename?: 'OperationSignatureDocumentMetadata', fileId: string, sourceFileId?: string | null, versionNumber?: number | null, investisseurId?: any | null, investisseurIds?: Array<any> | null, extension?: string | null, actif?: boolean | null, denomination?: string | null, typeDocumentCode?: string | null, dateDeCreation?: any | null, dateDeDerniereModification?: any | null, etatSignature?: string | null, fileName?: string | null, dateSignature?: any | null, signataires?: Array<{ __typename?: 'OperationSignatureSignerMetadata', email: string, firstName: string, internalId?: number | null, lastName: string, phone: string, type: OperationSignatureSignerType }> | null }> | null } | null } | null } };

export type GenerateOperationConseilMutationVariables = Exact<{
  operationId: Scalars['UUID']['input'];
}>;


export type GenerateOperationConseilMutation = { __typename?: 'Mutation', generateOperationConseil?: { __typename?: 'StorageFile', id: string, createdDate?: any | null, denomination?: string | null, documentType: DocumentTypeEnum, fileExtension: string, fileName: string, fileType: string, isBlob: boolean, isTemporary?: boolean | null, lastModificationDate?: any | null, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', blobFileId: string, expiration: any, permissions: Array<BlobFilesPermissionDs>, sasUrl: string } | null } | null };

export type GenerateOperationConseilPreviewMutationVariables = Exact<{
  operationId: Scalars['UUID']['input'];
}>;


export type GenerateOperationConseilPreviewMutation = { __typename?: 'Mutation', generateOperationConseilPreview?: { __typename?: 'StorageFile', id: string, fileName: string, fileConnectionInfo?: { __typename?: 'StorageFileConnectionInfo', sasUrl: string } | null } | null };

export type ResetOperationSignatureMutationVariables = Exact<{
  operationId: Scalars['UUID']['input'];
}>;


export type ResetOperationSignatureMutation = { __typename?: 'Mutation', resetOperationSignature: { __typename?: 'OperationData', modeDeGestion?: string | null, disponibiliteEpargneOptions: Array<{ __typename?: 'DisponibiliteEpargneOption', id: string, label: string, value: DisponibiliteEpargne }>, modeDeGestionNavigation?: { __typename?: 'ModeDeGestion', id: string } | null, toleranceRisqueOptions: Array<{ __typename?: 'ToleranceRisqueOption', id: string, label: string, value: ToleranceRisque }>, snapshotData?: { __typename?: 'OperationSnapshotData', boxPlacementUrl?: string | null, souscription?: { __typename?: 'OperationSouscriptionSnapshot', produitId: any, modeSignature?: SouscriptionSignatureMode | null, transmissionOriginaux?: SouscriptionTransmissionOriginaux | null, dateSignature?: any | null, bulletinFileId?: string | null, bulletinFileIdToDelete?: string | null, commentaire?: string | null } | null, besoin?: { __typename?: 'BesoinsOperation', motivationOperation?: string | null, selectedObjectifCodes: Array<string>, disponibiliteEpargne?: DisponibiliteEpargne | null, toleranceRisque?: ToleranceRisque | null, horizonPlacement?: { __typename?: 'HorizonPlacement', horizonRetraite?: any | null, justification?: string | null, value?: HorizonPlacementEnum | null } | null } | null, connaissanceClient?: { __typename?: 'ConnaissanceClientData', toleranceRisque?: ToleranceRisque | null, investisseurs: Array<{ __typename?: 'InvestisseurOperationData', civiliteCode?: string | null, code?: string | null, creationDate?: any | null, dateNaissance?: any | null, denomination?: string | null, displayName?: string | null, id: any, nom?: string | null, prenom?: string | null, patrimoine?: { __typename?: 'SituationPatrimoineData', capaciteEpargneMensuel?: any | null, dateMiseAJourAtlas?: any | null, epargneFinanceMontantTotal?: any | null, epargneImmoMontantHorsRP?: any | null, revenuAnnuelTotal?: any | null } | null, profil?: { __typename?: 'ProfilInvestisseurData', resultatCapacitePerte?: number | null, resultatConnaissance?: number | null, resultatProfilDeRisque?: number | null, resultatSensibiliteExtraFinanciere?: number | null, resultatToleranceAuRisque?: number | null } | null, situationPersonnelle?: { __typename?: 'SituationPersonnelleData', categorieSocioProfessionnelleCode?: any | null, categorieSocioProfessionnelleLibelle?: string | null, dateMiseAJourAtlas?: any | null, enfantACharge?: number | null, etatCivilDisplay?: string | null, etatCivilTypeCode?: string | null, etatCivilTypeLibelle?: string | null, etatCivilTypeRegimeCode?: string | null, etatCivilTypeRegimeLibelle?: string | null, profession?: string | null } | null, statutCodeNavigation?: { __typename?: 'TypeStatutInvestisseur', code: string, libelle: string } | null }>, objectifs: Array<{ __typename?: 'InvestisseurObjectifData', categorieCode?: string | null, categorieLibelle: string, id: string, isSelected: boolean, objectifCode?: string | null, objectifLibelle: string }> } | null, conseil?: { __typename?: 'ConseilOperation', allocationPrecision?: string | null, allocationTransfertOption?: AllocationTransfertOption | null, allocationVersementOption?: AllocationVersementOption | null, arbitrageLibreSupportsEntrants?: string | null, arbitrageLibreSupportsSortants?: string | null, avecArbitragesProgrammes?: boolean | null, avecMiseEnPlaceOuModificationVP?: boolean | null, portefeuilleOption?: PortefeuilleOption | null, transactionPersonnelle?: TransactionPersonnelleEnum | null, vpModeOptions?: VpModeOptions | null, autoSouscription?: boolean | null, impactDiminutionFrais?: ImpactDiminutionFraisEnum | null, fondsEvenementiels: Array<{ __typename?: 'FondsEvenementielData', id: string, code: string, libelle: string, isSelected?: boolean | null }>, optionsAutomatiques: Array<{ __typename?: 'OptionAutomatiqueData', id: string, libelle: string, isSelected?: boolean | null }>, allocation?: { __typename?: 'AllocationConseil', id: string, libelle: string, modeDeGestionCode: string, niveauDeRisque: NiveauDeRisque } | null, arbitrageDuplicationContext?: { __typename?: 'ArbitrageDuplicationContext', objectifsIntersectionApplied?: boolean | null, sourceFicheId: string } | null, precisionComplementaire?: { __typename?: 'AdditionalDetails', commentaireAllocation?: string | null, commentaireAutre?: string | null, commentaireEnveloppe?: string | null } | null, versements: { __typename?: 'Versements', avecVersementProgramme: boolean, souscriptionAvecTransfert?: boolean | null, versementInitial?: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } | null, versementProgramme?: { __typename?: 'VersementProgramme', frequence?: FrequenceVersement | null, versement: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } } | null } } | null, signature?: { __typename?: 'OperationSignatureSnapshot', mode?: OperationSignatureMode | null, isLocked?: boolean | null, invalidatedFromStep?: OperationState | null, requiredDocuments?: Array<{ __typename?: 'OperationSignatureDocumentRequirement', typeDocumentCode: string, investisseurIds: Array<any> }> | null, documents?: Array<{ __typename?: 'OperationSignatureDocumentMetadata', fileId: string, sourceFileId?: string | null, versionNumber?: number | null, investisseurId?: any | null, investisseurIds?: Array<any> | null, extension?: string | null, actif?: boolean | null, denomination?: string | null, typeDocumentCode?: string | null, dateDeCreation?: any | null, dateDeDerniereModification?: any | null, etatSignature?: string | null, fileName?: string | null, dateSignature?: any | null, signataires?: Array<{ __typename?: 'OperationSignatureSignerMetadata', email: string, firstName: string, internalId?: number | null, lastName: string, phone: string, type: OperationSignatureSignerType }> | null }> | null } | null } | null } };

export type UpdateOperationAdequationMutationVariables = Exact<{
  input: GenerateOperationAdequationInput;
}>;


export type UpdateOperationAdequationMutation = { __typename?: 'Mutation', updateOperationAndGenerateAdequation: { __typename?: 'OperationAdequationPayload', isCurrent: boolean, reused: boolean, report?: { __typename?: 'OperationAdequationReport', schemaVersion: number, engineVersion: string, evaluatedAtUtc: any, evaluationDate: any, validUntilUtc?: any | null, inputRevision: any, rulesVersion: any, conclusion: string, configuration: { __typename?: 'OperationAdequationConfiguration', operationConfigId?: any | null, operationConfigVersion?: number | null, conseilConfigId?: any | null, conseilConfigVersion?: number | null, enveloppeConfigId?: number | null, produitSpecificConfigId?: any | null, productAdequationConfigId?: number | null, effectiveFingerprint: string }, entryPoints: { __typename?: 'OperationAdequationEntryPoints', operationId: any, produitId?: any | null, natureOperationId?: number | null, enveloppeId: any, typeInvestisseur: string, modeDeGestion?: string | null }, fingerprints: { __typename?: 'OperationAdequationFingerprints', algorithm: string, canonicalizationVersion: number, data: string, configuration: string, input: string }, summary: { __typename?: 'OperationAdequationSummary', total: number, passed: number, failed: number, notApplicable: number, notEvaluable: number }, search: { __typename?: 'OperationAdequationSearch', objectives: string, availability: string, horizon: string, prerequisites: string, payments: string, fees: string, risk: string, allocation: string, options: string, subscription?: string | null }, fields: Array<{ __typename?: 'OperationAdequationField', fieldKey: string, status: string, checks: Array<{ __typename?: 'OperationAdequationCheck', checkKey: string, validatorKey: string, ruleVersion: number, status: string, severity: string, reasonCode?: string | null, message?: string | null, investisseurId?: any | null, source: string, parameters: Array<{ __typename?: 'OperationAdequationParameter', key: string, value: string }> }> }> } | null, errors: Array<{ __typename?: 'OperationAdequationError', code: string, message: string }> } };

export type UpdateOperationAllocationConsultantFileMutationVariables = Exact<{
  operationId: Scalars['UUID']['input'];
  fileId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOperationAllocationConsultantFileMutation = { __typename?: 'Mutation', updateOperationAllocationConsultantFile: boolean };

export type UpdateOperationDataMutationVariables = Exact<{
  operationId: Scalars['UUID']['input'];
}>;


export type UpdateOperationDataMutation = { __typename?: 'Mutation', updateOperationData?: { __typename?: 'OperationData', modeDeGestion?: string | null, disponibiliteEpargneOptions: Array<{ __typename?: 'DisponibiliteEpargneOption', id: string, label: string, value: DisponibiliteEpargne }>, modeDeGestionNavigation?: { __typename?: 'ModeDeGestion', id: string } | null, toleranceRisqueOptions: Array<{ __typename?: 'ToleranceRisqueOption', id: string, label: string, value: ToleranceRisque }>, snapshotData?: { __typename?: 'OperationSnapshotData', boxPlacementUrl?: string | null, souscription?: { __typename?: 'OperationSouscriptionSnapshot', produitId: any, modeSignature?: SouscriptionSignatureMode | null, transmissionOriginaux?: SouscriptionTransmissionOriginaux | null, dateSignature?: any | null, bulletinFileId?: string | null, bulletinFileIdToDelete?: string | null, commentaire?: string | null } | null, besoin?: { __typename?: 'BesoinsOperation', motivationOperation?: string | null, selectedObjectifCodes: Array<string>, disponibiliteEpargne?: DisponibiliteEpargne | null, toleranceRisque?: ToleranceRisque | null, horizonPlacement?: { __typename?: 'HorizonPlacement', horizonRetraite?: any | null, justification?: string | null, value?: HorizonPlacementEnum | null } | null } | null, connaissanceClient?: { __typename?: 'ConnaissanceClientData', toleranceRisque?: ToleranceRisque | null, investisseurs: Array<{ __typename?: 'InvestisseurOperationData', civiliteCode?: string | null, code?: string | null, creationDate?: any | null, dateNaissance?: any | null, denomination?: string | null, displayName?: string | null, id: any, nom?: string | null, prenom?: string | null, patrimoine?: { __typename?: 'SituationPatrimoineData', capaciteEpargneMensuel?: any | null, dateMiseAJourAtlas?: any | null, epargneFinanceMontantTotal?: any | null, epargneImmoMontantHorsRP?: any | null, revenuAnnuelTotal?: any | null } | null, profil?: { __typename?: 'ProfilInvestisseurData', resultatCapacitePerte?: number | null, resultatConnaissance?: number | null, resultatProfilDeRisque?: number | null, resultatSensibiliteExtraFinanciere?: number | null, resultatToleranceAuRisque?: number | null } | null, situationPersonnelle?: { __typename?: 'SituationPersonnelleData', categorieSocioProfessionnelleCode?: any | null, categorieSocioProfessionnelleLibelle?: string | null, dateMiseAJourAtlas?: any | null, enfantACharge?: number | null, etatCivilDisplay?: string | null, etatCivilTypeCode?: string | null, etatCivilTypeLibelle?: string | null, etatCivilTypeRegimeCode?: string | null, etatCivilTypeRegimeLibelle?: string | null, profession?: string | null } | null, statutCodeNavigation?: { __typename?: 'TypeStatutInvestisseur', code: string, libelle: string } | null }>, objectifs: Array<{ __typename?: 'InvestisseurObjectifData', categorieCode?: string | null, categorieLibelle: string, id: string, isSelected: boolean, objectifCode?: string | null, objectifLibelle: string }> } | null, conseil?: { __typename?: 'ConseilOperation', allocationPrecision?: string | null, allocationTransfertOption?: AllocationTransfertOption | null, allocationVersementOption?: AllocationVersementOption | null, arbitrageLibreSupportsEntrants?: string | null, arbitrageLibreSupportsSortants?: string | null, avecArbitragesProgrammes?: boolean | null, avecMiseEnPlaceOuModificationVP?: boolean | null, portefeuilleOption?: PortefeuilleOption | null, transactionPersonnelle?: TransactionPersonnelleEnum | null, vpModeOptions?: VpModeOptions | null, autoSouscription?: boolean | null, impactDiminutionFrais?: ImpactDiminutionFraisEnum | null, fondsEvenementiels: Array<{ __typename?: 'FondsEvenementielData', id: string, code: string, libelle: string, isSelected?: boolean | null }>, optionsAutomatiques: Array<{ __typename?: 'OptionAutomatiqueData', id: string, libelle: string, isSelected?: boolean | null }>, allocation?: { __typename?: 'AllocationConseil', id: string, libelle: string, modeDeGestionCode: string, niveauDeRisque: NiveauDeRisque } | null, arbitrageDuplicationContext?: { __typename?: 'ArbitrageDuplicationContext', objectifsIntersectionApplied?: boolean | null, sourceFicheId: string } | null, precisionComplementaire?: { __typename?: 'AdditionalDetails', commentaireAllocation?: string | null, commentaireAutre?: string | null, commentaireEnveloppe?: string | null } | null, versements: { __typename?: 'Versements', avecVersementProgramme: boolean, souscriptionAvecTransfert?: boolean | null, versementInitial?: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } | null, versementProgramme?: { __typename?: 'VersementProgramme', frequence?: FrequenceVersement | null, versement: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } } | null } } | null, signature?: { __typename?: 'OperationSignatureSnapshot', mode?: OperationSignatureMode | null, isLocked?: boolean | null, invalidatedFromStep?: OperationState | null, requiredDocuments?: Array<{ __typename?: 'OperationSignatureDocumentRequirement', typeDocumentCode: string, investisseurIds: Array<any> }> | null, documents?: Array<{ __typename?: 'OperationSignatureDocumentMetadata', fileId: string, sourceFileId?: string | null, versionNumber?: number | null, investisseurId?: any | null, investisseurIds?: Array<any> | null, extension?: string | null, actif?: boolean | null, denomination?: string | null, typeDocumentCode?: string | null, dateDeCreation?: any | null, dateDeDerniereModification?: any | null, etatSignature?: string | null, fileName?: string | null, dateSignature?: any | null, signataires?: Array<{ __typename?: 'OperationSignatureSignerMetadata', email: string, firstName: string, internalId?: number | null, lastName: string, phone: string, type: OperationSignatureSignerType }> | null }> | null } | null } | null } | null };

export type UpdateOperationProduitMutationVariables = Exact<{
  operationId: Scalars['UUID']['input'];
  produitId: Scalars['Long']['input'];
}>;


export type UpdateOperationProduitMutation = { __typename?: 'Mutation', updateOperationProduit: boolean };

export type UpdateOperationStatutMutationVariables = Exact<{
  operationId: Scalars['UUID']['input'];
  newStatut: OperationState;
}>;


export type UpdateOperationStatutMutation = { __typename?: 'Mutation', updateOperationStatut: boolean };

export type UpdateProjetMutationVariables = Exact<{
  input: ProjetUpdateInput;
}>;


export type UpdateProjetMutation = { __typename?: 'Mutation', updateProjet: { __typename?: 'Projet', id: any, nom: string, description?: string | null, notes?: string | null, creationDate: any, editionDate: any } };

export type UpsertOperationDataMutationVariables = Exact<{
  operationId: Scalars['UUID']['input'];
  data: OperationDataInput;
}>;


export type UpsertOperationDataMutation = { __typename?: 'Mutation', upsertOperationData: { __typename?: 'OperationData', modeDeGestion?: string | null, disponibiliteEpargneOptions: Array<{ __typename?: 'DisponibiliteEpargneOption', id: string, label: string, value: DisponibiliteEpargne }>, modeDeGestionNavigation?: { __typename?: 'ModeDeGestion', id: string } | null, toleranceRisqueOptions: Array<{ __typename?: 'ToleranceRisqueOption', id: string, label: string, value: ToleranceRisque }>, snapshotData?: { __typename?: 'OperationSnapshotData', boxPlacementUrl?: string | null, souscription?: { __typename?: 'OperationSouscriptionSnapshot', produitId: any, modeSignature?: SouscriptionSignatureMode | null, transmissionOriginaux?: SouscriptionTransmissionOriginaux | null, dateSignature?: any | null, bulletinFileId?: string | null, bulletinFileIdToDelete?: string | null, commentaire?: string | null } | null, besoin?: { __typename?: 'BesoinsOperation', motivationOperation?: string | null, selectedObjectifCodes: Array<string>, disponibiliteEpargne?: DisponibiliteEpargne | null, toleranceRisque?: ToleranceRisque | null, horizonPlacement?: { __typename?: 'HorizonPlacement', horizonRetraite?: any | null, justification?: string | null, value?: HorizonPlacementEnum | null } | null } | null, connaissanceClient?: { __typename?: 'ConnaissanceClientData', toleranceRisque?: ToleranceRisque | null, investisseurs: Array<{ __typename?: 'InvestisseurOperationData', civiliteCode?: string | null, code?: string | null, creationDate?: any | null, dateNaissance?: any | null, denomination?: string | null, displayName?: string | null, id: any, nom?: string | null, prenom?: string | null, patrimoine?: { __typename?: 'SituationPatrimoineData', capaciteEpargneMensuel?: any | null, dateMiseAJourAtlas?: any | null, epargneFinanceMontantTotal?: any | null, epargneImmoMontantHorsRP?: any | null, revenuAnnuelTotal?: any | null } | null, profil?: { __typename?: 'ProfilInvestisseurData', resultatCapacitePerte?: number | null, resultatConnaissance?: number | null, resultatProfilDeRisque?: number | null, resultatSensibiliteExtraFinanciere?: number | null, resultatToleranceAuRisque?: number | null } | null, situationPersonnelle?: { __typename?: 'SituationPersonnelleData', categorieSocioProfessionnelleCode?: any | null, categorieSocioProfessionnelleLibelle?: string | null, dateMiseAJourAtlas?: any | null, enfantACharge?: number | null, etatCivilDisplay?: string | null, etatCivilTypeCode?: string | null, etatCivilTypeLibelle?: string | null, etatCivilTypeRegimeCode?: string | null, etatCivilTypeRegimeLibelle?: string | null, profession?: string | null } | null, statutCodeNavigation?: { __typename?: 'TypeStatutInvestisseur', code: string, libelle: string } | null }>, objectifs: Array<{ __typename?: 'InvestisseurObjectifData', categorieCode?: string | null, categorieLibelle: string, id: string, isSelected: boolean, objectifCode?: string | null, objectifLibelle: string }> } | null, conseil?: { __typename?: 'ConseilOperation', allocationPrecision?: string | null, allocationTransfertOption?: AllocationTransfertOption | null, allocationVersementOption?: AllocationVersementOption | null, arbitrageLibreSupportsEntrants?: string | null, arbitrageLibreSupportsSortants?: string | null, avecArbitragesProgrammes?: boolean | null, avecMiseEnPlaceOuModificationVP?: boolean | null, portefeuilleOption?: PortefeuilleOption | null, transactionPersonnelle?: TransactionPersonnelleEnum | null, vpModeOptions?: VpModeOptions | null, autoSouscription?: boolean | null, impactDiminutionFrais?: ImpactDiminutionFraisEnum | null, fondsEvenementiels: Array<{ __typename?: 'FondsEvenementielData', id: string, code: string, libelle: string, isSelected?: boolean | null }>, optionsAutomatiques: Array<{ __typename?: 'OptionAutomatiqueData', id: string, libelle: string, isSelected?: boolean | null }>, allocation?: { __typename?: 'AllocationConseil', id: string, libelle: string, modeDeGestionCode: string, niveauDeRisque: NiveauDeRisque } | null, arbitrageDuplicationContext?: { __typename?: 'ArbitrageDuplicationContext', objectifsIntersectionApplied?: boolean | null, sourceFicheId: string } | null, precisionComplementaire?: { __typename?: 'AdditionalDetails', commentaireAllocation?: string | null, commentaireAutre?: string | null, commentaireEnveloppe?: string | null } | null, versements: { __typename?: 'Versements', avecVersementProgramme: boolean, souscriptionAvecTransfert?: boolean | null, versementInitial?: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } | null, versementProgramme?: { __typename?: 'VersementProgramme', frequence?: FrequenceVersement | null, versement: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } } | null } } | null, signature?: { __typename?: 'OperationSignatureSnapshot', mode?: OperationSignatureMode | null, isLocked?: boolean | null, invalidatedFromStep?: OperationState | null, requiredDocuments?: Array<{ __typename?: 'OperationSignatureDocumentRequirement', typeDocumentCode: string, investisseurIds: Array<any> }> | null, documents?: Array<{ __typename?: 'OperationSignatureDocumentMetadata', fileId: string, sourceFileId?: string | null, versionNumber?: number | null, investisseurId?: any | null, investisseurIds?: Array<any> | null, extension?: string | null, actif?: boolean | null, denomination?: string | null, typeDocumentCode?: string | null, dateDeCreation?: any | null, dateDeDerniereModification?: any | null, etatSignature?: string | null, fileName?: string | null, dateSignature?: any | null, signataires?: Array<{ __typename?: 'OperationSignatureSignerMetadata', email: string, firstName: string, internalId?: number | null, lastName: string, phone: string, type: OperationSignatureSignerType }> | null }> | null } | null } | null } };

export type DisponibiliteEpargneOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DisponibiliteEpargneOptionsQuery = { __typename?: 'Query', disponibiliteEpargneOptions: Array<{ __typename?: 'DisponibiliteEpargneOption', id: string, label: string, value: DisponibiliteEpargne }> };

export type EnveloppesQueryVariables = Exact<{ [key: string]: never; }>;


export type EnveloppesQuery = { __typename?: 'Query', enveloppeProduits: Array<{ __typename?: 'EnveloppeProduit', code: any, libelle: string }> };

export type OperationByIdQueryVariables = Exact<{
  operationId: Scalars['UUID']['input'];
}>;


export type OperationByIdQuery = { __typename?: 'Query', operationById?: { __typename?: 'Operation', id: any, statut: OperationState, projetId: any, natureOperationId?: number | null, produitId?: any | null, allocationConsultantFileId?: string | null, versement?: any | null, produit?: { __typename?: 'Produit', nom: string } | null, allocationConsultantFile?: { __typename?: 'StorageFile', fileName: string, fileType: string, id: string, fileExtension: string, isBlob: boolean } | null, projet: { __typename?: 'Projet', nom: string }, enveloppe: { __typename?: 'EnveloppeProduit', code: any, libelle: string }, operationConfig?: { __typename?: 'OperationConfig', conseilConfig?: { __typename?: 'OperationConseilConfig', typesDocumentRequis: Array<{ __typename?: 'DocumentType', fileNamePrefix: string, gedTypeCode: string, label: string, documentCategory: { __typename?: 'DocumentCategory', label: string, gedCategoryCode: string } }>, enveloppeConfig: { __typename?: 'AdequationConfig', fieldConfigs: Array<{ __typename?: 'FieldConfig', fieldKey: string, isVisible: boolean, visibilityCondition?: { __typename?: 'FieldVisibilityCondition', fieldKey: string, operator: FieldVisibilityOperator, value?: string | null } | null, validators: Array<{ __typename?: 'FieldValidatorConfig', errorMessage: string, validatorKey: string, parameters: Array<{ __typename?: 'FieldValidatorConfigParameter', id: string, key: string, value: string }> }> }> }, produitSpecificConfigs: Array<{ __typename?: 'ProduitSpecificConfig', produitId: any, ficheProduitUrl?: string | null, extranetPartenaireUrl?: string | null, produitAtlas: { __typename?: 'Produit', nom: string }, config: { __typename?: 'AdequationConfig', fieldConfigs: Array<{ __typename?: 'FieldConfig', fieldKey: string, isVisible: boolean, visibilityCondition?: { __typename?: 'FieldVisibilityCondition', fieldKey: string, operator: FieldVisibilityOperator, value?: string | null } | null, validators: Array<{ __typename?: 'FieldValidatorConfig', errorMessage: string, validatorKey: string, parameters: Array<{ __typename?: 'FieldValidatorConfigParameter', id: string, key: string, value: string }> }> }> }, produit: { __typename?: 'ProduitOperationExtension', gestionPossibles?: Array<{ __typename?: 'ModeDeGestionConfig', modeDeGestionId: string, modeDeGestion?: { __typename?: 'ModeDeGestion', libelle?: string | null } | null, conditionVersementInitial?: { __typename?: 'ConditionVersementInitial', montantMinSouscription?: number | null, montantMinAvecVP?: number | null, montantMinAvecTransfert?: number | null } | null, conditionVersementProgramme?: { __typename?: 'ConditionVersementProgramme', montantMinMensuel?: number | null, montantMinTrimestriel?: number | null, montantMinSemestriel?: number | null, montantMinAnnuel?: number | null } | null }> | null, fondsEvenementiels?: Array<{ __typename?: 'FondsEvenementiel', id: string, code: string, libelle: string, ordre: number }> | null, optionsAutomatiques?: Array<{ __typename?: 'OptionAutomatique', id: string, libelle: string, modeDeGestionCode: string, ordre: number }> | null, allocations?: Array<{ __typename?: 'Allocation', id: string, libelle: string, modeDeGestionId: string, statut?: AllocationPartenaireStatut | null, niveauDeRisque: NiveauDeRisque, storageFile?: { __typename?: 'StorageFile', id: string, fileName: string, fileType: string } | null }> | null } }> } | null } | null, operationInvestisseurs: Array<{ __typename?: 'OperationInvestisseur', investisseur: { __typename?: 'Investisseur', id: any, code: string, personnePhysique: Array<{ __typename?: 'PersonnePhysique', nom: string, prenom: string, dateNaissance?: any | null, email: Array<{ __typename?: 'Email', adresse: string, estAdresseCorrespondance?: boolean | null }>, telephone: Array<{ __typename?: 'Telephone', numero: string, estNumeroCorrespondance?: boolean | null }> }>, avancementConnaissanceClientInvestisseur?: { __typename?: 'AvancementConnaissanceClientInvestisseur', investisseurId: any, derEtat: EtatDer, recueilEtat: EtatRecueil, recueilLastChangeDate: any, isRecueilFormCompleted: boolean, qpiEtat: EtatQpi, qpiLastChangeDate: any } | null, currentQPI?: { __typename?: 'InvestisseurQpi', resultatProfilDeRisque?: number | null, resultatConnaissance?: number | null, resultatSensibiliteExtraFinanciere?: number | null, reponseESG?: number | null } | null } }>, operationData?: { __typename?: 'OperationData', modeDeGestion?: string | null, disponibiliteEpargneOptions: Array<{ __typename?: 'DisponibiliteEpargneOption', id: string, label: string, value: DisponibiliteEpargne }>, modeDeGestionNavigation?: { __typename?: 'ModeDeGestion', id: string } | null, toleranceRisqueOptions: Array<{ __typename?: 'ToleranceRisqueOption', id: string, label: string, value: ToleranceRisque }>, snapshotData?: { __typename?: 'OperationSnapshotData', boxPlacementUrl?: string | null, souscription?: { __typename?: 'OperationSouscriptionSnapshot', produitId: any, modeSignature?: SouscriptionSignatureMode | null, transmissionOriginaux?: SouscriptionTransmissionOriginaux | null, dateSignature?: any | null, bulletinFileId?: string | null, bulletinFileIdToDelete?: string | null, commentaire?: string | null } | null, besoin?: { __typename?: 'BesoinsOperation', motivationOperation?: string | null, selectedObjectifCodes: Array<string>, disponibiliteEpargne?: DisponibiliteEpargne | null, toleranceRisque?: ToleranceRisque | null, horizonPlacement?: { __typename?: 'HorizonPlacement', horizonRetraite?: any | null, justification?: string | null, value?: HorizonPlacementEnum | null } | null } | null, connaissanceClient?: { __typename?: 'ConnaissanceClientData', toleranceRisque?: ToleranceRisque | null, investisseurs: Array<{ __typename?: 'InvestisseurOperationData', civiliteCode?: string | null, code?: string | null, creationDate?: any | null, dateNaissance?: any | null, denomination?: string | null, displayName?: string | null, id: any, nom?: string | null, prenom?: string | null, patrimoine?: { __typename?: 'SituationPatrimoineData', capaciteEpargneMensuel?: any | null, dateMiseAJourAtlas?: any | null, epargneFinanceMontantTotal?: any | null, epargneImmoMontantHorsRP?: any | null, revenuAnnuelTotal?: any | null } | null, profil?: { __typename?: 'ProfilInvestisseurData', resultatCapacitePerte?: number | null, resultatConnaissance?: number | null, resultatProfilDeRisque?: number | null, resultatSensibiliteExtraFinanciere?: number | null, resultatToleranceAuRisque?: number | null } | null, situationPersonnelle?: { __typename?: 'SituationPersonnelleData', categorieSocioProfessionnelleCode?: any | null, categorieSocioProfessionnelleLibelle?: string | null, dateMiseAJourAtlas?: any | null, enfantACharge?: number | null, etatCivilDisplay?: string | null, etatCivilTypeCode?: string | null, etatCivilTypeLibelle?: string | null, etatCivilTypeRegimeCode?: string | null, etatCivilTypeRegimeLibelle?: string | null, profession?: string | null } | null, statutCodeNavigation?: { __typename?: 'TypeStatutInvestisseur', code: string, libelle: string } | null }>, objectifs: Array<{ __typename?: 'InvestisseurObjectifData', categorieCode?: string | null, categorieLibelle: string, id: string, isSelected: boolean, objectifCode?: string | null, objectifLibelle: string }> } | null, conseil?: { __typename?: 'ConseilOperation', allocationPrecision?: string | null, allocationTransfertOption?: AllocationTransfertOption | null, allocationVersementOption?: AllocationVersementOption | null, arbitrageLibreSupportsEntrants?: string | null, arbitrageLibreSupportsSortants?: string | null, avecArbitragesProgrammes?: boolean | null, avecMiseEnPlaceOuModificationVP?: boolean | null, portefeuilleOption?: PortefeuilleOption | null, transactionPersonnelle?: TransactionPersonnelleEnum | null, vpModeOptions?: VpModeOptions | null, autoSouscription?: boolean | null, impactDiminutionFrais?: ImpactDiminutionFraisEnum | null, fondsEvenementiels: Array<{ __typename?: 'FondsEvenementielData', id: string, code: string, libelle: string, isSelected?: boolean | null }>, optionsAutomatiques: Array<{ __typename?: 'OptionAutomatiqueData', id: string, libelle: string, isSelected?: boolean | null }>, allocation?: { __typename?: 'AllocationConseil', id: string, libelle: string, modeDeGestionCode: string, niveauDeRisque: NiveauDeRisque } | null, arbitrageDuplicationContext?: { __typename?: 'ArbitrageDuplicationContext', objectifsIntersectionApplied?: boolean | null, sourceFicheId: string } | null, precisionComplementaire?: { __typename?: 'AdditionalDetails', commentaireAllocation?: string | null, commentaireAutre?: string | null, commentaireEnveloppe?: string | null } | null, versements: { __typename?: 'Versements', avecVersementProgramme: boolean, souscriptionAvecTransfert?: boolean | null, versementInitial?: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } | null, versementProgramme?: { __typename?: 'VersementProgramme', frequence?: FrequenceVersement | null, versement: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } } | null } } | null, signature?: { __typename?: 'OperationSignatureSnapshot', mode?: OperationSignatureMode | null, isLocked?: boolean | null, invalidatedFromStep?: OperationState | null, requiredDocuments?: Array<{ __typename?: 'OperationSignatureDocumentRequirement', typeDocumentCode: string, investisseurIds: Array<any> }> | null, documents?: Array<{ __typename?: 'OperationSignatureDocumentMetadata', fileId: string, sourceFileId?: string | null, versionNumber?: number | null, investisseurId?: any | null, investisseurIds?: Array<any> | null, extension?: string | null, actif?: boolean | null, denomination?: string | null, typeDocumentCode?: string | null, dateDeCreation?: any | null, dateDeDerniereModification?: any | null, etatSignature?: string | null, fileName?: string | null, dateSignature?: any | null, signataires?: Array<{ __typename?: 'OperationSignatureSignerMetadata', email: string, firstName: string, internalId?: number | null, lastName: string, phone: string, type: OperationSignatureSignerType }> | null }> | null } | null } | null } | null } | null };

export type ProjetByIdQueryVariables = Exact<{
  projetId: Scalars['Int']['input'];
}>;


export type ProjetByIdQuery = { __typename?: 'Query', projetById: Array<{ __typename?: 'Projet', id: any, nom: string, description?: string | null, notes?: string | null, creationDate: any, editionDate: any, projetsUtilisateurs: Array<{ __typename?: 'ProjetInvestisseur', investisseurId: any }>, documents: Array<{ __typename?: 'ProjetDocument', id: any, fileId: string, typeDocumentCode: string, fileName: string, creationDate: any }>, operations: Array<{ __typename?: 'Operation', id: any, natureOperationId?: number | null, statut: OperationState, versement?: any | null, dateModification: any, operationConfig?: { __typename?: 'OperationConfig', conseilConfig?: { __typename?: 'OperationConseilConfig', typesDocumentRequis: Array<{ __typename?: 'DocumentType', fileNamePrefix: string, gedTypeCode: string, label: string, documentCategory: { __typename?: 'DocumentCategory', label: string, gedCategoryCode: string } }>, enveloppeConfig: { __typename?: 'AdequationConfig', fieldConfigs: Array<{ __typename?: 'FieldConfig', fieldKey: string, isVisible: boolean, visibilityCondition?: { __typename?: 'FieldVisibilityCondition', fieldKey: string, operator: FieldVisibilityOperator, value?: string | null } | null, validators: Array<{ __typename?: 'FieldValidatorConfig', errorMessage: string, validatorKey: string, parameters: Array<{ __typename?: 'FieldValidatorConfigParameter', id: string, key: string, value: string }> }> }> }, produitSpecificConfigs: Array<{ __typename?: 'ProduitSpecificConfig', produitId: any, ficheProduitUrl?: string | null, extranetPartenaireUrl?: string | null, produitAtlas: { __typename?: 'Produit', nom: string }, config: { __typename?: 'AdequationConfig', fieldConfigs: Array<{ __typename?: 'FieldConfig', fieldKey: string, isVisible: boolean, visibilityCondition?: { __typename?: 'FieldVisibilityCondition', fieldKey: string, operator: FieldVisibilityOperator, value?: string | null } | null, validators: Array<{ __typename?: 'FieldValidatorConfig', errorMessage: string, validatorKey: string, parameters: Array<{ __typename?: 'FieldValidatorConfigParameter', id: string, key: string, value: string }> }> }> }, produit: { __typename?: 'ProduitOperationExtension', gestionPossibles?: Array<{ __typename?: 'ModeDeGestionConfig', modeDeGestionId: string, modeDeGestion?: { __typename?: 'ModeDeGestion', libelle?: string | null } | null, conditionVersementInitial?: { __typename?: 'ConditionVersementInitial', montantMinSouscription?: number | null, montantMinAvecVP?: number | null, montantMinAvecTransfert?: number | null } | null, conditionVersementProgramme?: { __typename?: 'ConditionVersementProgramme', montantMinMensuel?: number | null, montantMinTrimestriel?: number | null, montantMinSemestriel?: number | null, montantMinAnnuel?: number | null } | null }> | null, fondsEvenementiels?: Array<{ __typename?: 'FondsEvenementiel', id: string, code: string, libelle: string, ordre: number }> | null, optionsAutomatiques?: Array<{ __typename?: 'OptionAutomatique', id: string, libelle: string, modeDeGestionCode: string, ordre: number }> | null, allocations?: Array<{ __typename?: 'Allocation', id: string, libelle: string, modeDeGestionId: string, statut?: AllocationPartenaireStatut | null, niveauDeRisque: NiveauDeRisque, storageFile?: { __typename?: 'StorageFile', id: string, fileName: string, fileType: string } | null }> | null } }> } | null } | null, enveloppe: { __typename?: 'EnveloppeProduit', code: any, libelle: string }, operationInvestisseurs: Array<{ __typename?: 'OperationInvestisseur', investisseurId: any }>, operationData?: { __typename?: 'OperationData', modeDeGestion?: string | null, disponibiliteEpargneOptions: Array<{ __typename?: 'DisponibiliteEpargneOption', id: string, label: string, value: DisponibiliteEpargne }>, modeDeGestionNavigation?: { __typename?: 'ModeDeGestion', id: string } | null, toleranceRisqueOptions: Array<{ __typename?: 'ToleranceRisqueOption', id: string, label: string, value: ToleranceRisque }>, snapshotData?: { __typename?: 'OperationSnapshotData', boxPlacementUrl?: string | null, souscription?: { __typename?: 'OperationSouscriptionSnapshot', produitId: any, modeSignature?: SouscriptionSignatureMode | null, transmissionOriginaux?: SouscriptionTransmissionOriginaux | null, dateSignature?: any | null, bulletinFileId?: string | null, bulletinFileIdToDelete?: string | null, commentaire?: string | null } | null, besoin?: { __typename?: 'BesoinsOperation', motivationOperation?: string | null, selectedObjectifCodes: Array<string>, disponibiliteEpargne?: DisponibiliteEpargne | null, toleranceRisque?: ToleranceRisque | null, horizonPlacement?: { __typename?: 'HorizonPlacement', horizonRetraite?: any | null, justification?: string | null, value?: HorizonPlacementEnum | null } | null } | null, connaissanceClient?: { __typename?: 'ConnaissanceClientData', toleranceRisque?: ToleranceRisque | null, investisseurs: Array<{ __typename?: 'InvestisseurOperationData', civiliteCode?: string | null, code?: string | null, creationDate?: any | null, dateNaissance?: any | null, denomination?: string | null, displayName?: string | null, id: any, nom?: string | null, prenom?: string | null, patrimoine?: { __typename?: 'SituationPatrimoineData', capaciteEpargneMensuel?: any | null, dateMiseAJourAtlas?: any | null, epargneFinanceMontantTotal?: any | null, epargneImmoMontantHorsRP?: any | null, revenuAnnuelTotal?: any | null } | null, profil?: { __typename?: 'ProfilInvestisseurData', resultatCapacitePerte?: number | null, resultatConnaissance?: number | null, resultatProfilDeRisque?: number | null, resultatSensibiliteExtraFinanciere?: number | null, resultatToleranceAuRisque?: number | null } | null, situationPersonnelle?: { __typename?: 'SituationPersonnelleData', categorieSocioProfessionnelleCode?: any | null, categorieSocioProfessionnelleLibelle?: string | null, dateMiseAJourAtlas?: any | null, enfantACharge?: number | null, etatCivilDisplay?: string | null, etatCivilTypeCode?: string | null, etatCivilTypeLibelle?: string | null, etatCivilTypeRegimeCode?: string | null, etatCivilTypeRegimeLibelle?: string | null, profession?: string | null } | null, statutCodeNavigation?: { __typename?: 'TypeStatutInvestisseur', code: string, libelle: string } | null }>, objectifs: Array<{ __typename?: 'InvestisseurObjectifData', categorieCode?: string | null, categorieLibelle: string, id: string, isSelected: boolean, objectifCode?: string | null, objectifLibelle: string }> } | null, conseil?: { __typename?: 'ConseilOperation', allocationPrecision?: string | null, allocationTransfertOption?: AllocationTransfertOption | null, allocationVersementOption?: AllocationVersementOption | null, arbitrageLibreSupportsEntrants?: string | null, arbitrageLibreSupportsSortants?: string | null, avecArbitragesProgrammes?: boolean | null, avecMiseEnPlaceOuModificationVP?: boolean | null, portefeuilleOption?: PortefeuilleOption | null, transactionPersonnelle?: TransactionPersonnelleEnum | null, vpModeOptions?: VpModeOptions | null, autoSouscription?: boolean | null, impactDiminutionFrais?: ImpactDiminutionFraisEnum | null, fondsEvenementiels: Array<{ __typename?: 'FondsEvenementielData', id: string, code: string, libelle: string, isSelected?: boolean | null }>, optionsAutomatiques: Array<{ __typename?: 'OptionAutomatiqueData', id: string, libelle: string, isSelected?: boolean | null }>, allocation?: { __typename?: 'AllocationConseil', id: string, libelle: string, modeDeGestionCode: string, niveauDeRisque: NiveauDeRisque } | null, arbitrageDuplicationContext?: { __typename?: 'ArbitrageDuplicationContext', objectifsIntersectionApplied?: boolean | null, sourceFicheId: string } | null, precisionComplementaire?: { __typename?: 'AdditionalDetails', commentaireAllocation?: string | null, commentaireAutre?: string | null, commentaireEnveloppe?: string | null } | null, versements: { __typename?: 'Versements', avecVersementProgramme: boolean, souscriptionAvecTransfert?: boolean | null, versementInitial?: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } | null, versementProgramme?: { __typename?: 'VersementProgramme', frequence?: FrequenceVersement | null, versement: { __typename?: 'Versement', montantBrut?: any | null, fraisVersement?: any | null, niveauDeRisque?: NiveauDeRisque | null } } | null } } | null, signature?: { __typename?: 'OperationSignatureSnapshot', mode?: OperationSignatureMode | null, isLocked?: boolean | null, invalidatedFromStep?: OperationState | null, requiredDocuments?: Array<{ __typename?: 'OperationSignatureDocumentRequirement', typeDocumentCode: string, investisseurIds: Array<any> }> | null, documents?: Array<{ __typename?: 'OperationSignatureDocumentMetadata', fileId: string, sourceFileId?: string | null, versionNumber?: number | null, investisseurId?: any | null, investisseurIds?: Array<any> | null, extension?: string | null, actif?: boolean | null, denomination?: string | null, typeDocumentCode?: string | null, dateDeCreation?: any | null, dateDeDerniereModification?: any | null, etatSignature?: string | null, fileName?: string | null, dateSignature?: any | null, signataires?: Array<{ __typename?: 'OperationSignatureSignerMetadata', email: string, firstName: string, internalId?: number | null, lastName: string, phone: string, type: OperationSignatureSignerType }> | null }> | null } | null } | null } | null }> }> };

export type ProjetsByInvestisseurQueryVariables = Exact<{
  investisseurId: Scalars['Int']['input'];
}>;


export type ProjetsByInvestisseurQuery = { __typename?: 'Query', projetsByInvestisseur: Array<{ __typename?: 'Projet', id: any, nom: string, description?: string | null, editionDate: any, operations: Array<{ __typename?: 'Operation', versement?: any | null, statut: OperationState, dateModification: any, natureOperation?: { __typename?: 'NatureOperation', libelle: string } | null, enveloppe: { __typename?: 'EnveloppeProduit', libelle: string } }> }> };

export type ToleranceRisqueOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ToleranceRisqueOptionsQuery = { __typename?: 'Query', toleranceRisqueOptions: Array<{ __typename?: 'ToleranceRisqueOption', id: string, label: string, value: ToleranceRisque }> };

export const ConsultantCodeAndNameFragmentDoc = gql`
    fragment consultantCodeAndName on Consultant {
  id
  code
  arianeId
  personnePhysique {
    nom
    prenom
  }
}
    `;
export const MigrationConsultantItemFragmentDoc = gql`
    fragment migrationConsultantItem on Consultant {
  id
  code
  arianeId
  isDisabled
  waveLabel
  personnePhysique {
    nom
    prenom
    telephone {
      numero
    }
    email {
      adresse
    }
  }
  gerePar
  qualificationCode
  qualificationCodeNavigation {
    libelle
  }
  galaxyId
  galaxy {
    personnePhysique {
      nom
      prenom
    }
  }
  minotaureImportProgress {
    minotaureInvestisseurs
    totalInvestisseurs
  }
}
    `;
export const WaveDetailsFragmentDoc = gql`
    fragment waveDetails on WaveMigrationJob {
  id
  waveLabel
  isPreImport
  createdAt
  priority
  plannedStartMigrationDate
  startMigrationTimeStamp
  status
  consultantMigrationJobs {
    consultantId
  }
  isActive
}
    `;
export const MigrationConsultantWaveItemFragmentDoc = gql`
    fragment migrationConsultantWaveItem on Consultant {
  id
  code
  waveLabel
  arianeId
  isDisabled
  personnePhysique {
    nom
    prenom
    telephone {
      numero
    }
    email {
      adresse
    }
  }
  gerePar
  qualificationCode
  qualificationCodeNavigation {
    libelle
  }
  galaxyId
  galaxy {
    personnePhysique {
      nom
      prenom
    }
  }
  minotaureImportProgress {
    minotaureInvestisseurs
    totalInvestisseurs
  }
}
    `;
export const MigrationInvestisseurItemFragmentDoc = gql`
    fragment migrationInvestisseurItem on Investisseur {
  id
  code
  arianeId
  gerePar
  personnePhysique {
    nom
    prenom
  }
  importInvestisseur {
    activeInvestisseurDumpJob {
      id
      isPreImport
      status
      atlasId
    }
    activeInvestisseurProcessJob {
      id
      statut
      isPreImport
      investisseurId
    }
    id
    arianeId
  }
  importHistories(where: {isPreImport: {eq: false}}) {
    id
    date
    isPreImport
    investisseurId
    logs {
      logLevel
      logIdentifier
      message
    }
  }
}
    `;
export const SyncEcartResultFragmentDoc = gql`
    fragment syncEcartResult on EcartInvestisseurSyncResult {
  status
  isStop
  updatedCount
  errorCount
  unprocessedItems
  remainingServiceCalls
  errorIds
}
    `;
export const StorageFileInfoFragmentDoc = gql`
    fragment storageFileInfo on StorageFile {
  fileName
  fileConnectionInfo {
    sasUrl
  }
}
    `;
export const FailedJobItemFragmentDoc = gql`
    fragment failedJobItem on FailedJobItem {
  jobId
  galaxyId
  consultantId
  investisseurId
  createdAt
  isActive
  errorMessage
  errorLogs {
    logIdentifier
    message
  }
  galaxy {
    id
    code
    personnePhysique {
      nom
      prenom
    }
  }
  consultant {
    id
    code
    personnePhysique {
      nom
      prenom
    }
  }
  investisseur {
    id
    code
    personnePhysique {
      nom
      prenom
    }
  }
}
    `;
export const JobLevelStatsFragmentDoc = gql`
    fragment jobLevelStats on JobLevelStats {
  todoCount
  activeTodoCount
  completedCount
  activeCompletedCount
  failedCount
  activeFailedCount
  totalCount
  activeTotalCount
  failedItems {
    ...failedJobItem
  }
}
    ${FailedJobItemFragmentDoc}`;
export const FullWaveTrackingStatFragmentDoc = gql`
    fragment fullWaveTrackingStat on WaveTrackingStats {
  waveMigrationJobId
  createdAt
  isPreImport
  shouldAutomaticallyProcess
  waveLabel
  plannedStartMigrationDate
  priority
  startMigrationTimeStamp
  status
  isActive
  preLaunchSync {
    startedAt
    finishedAt
    totalToProcess
    consultantApiSyncErrorCount
    refAppSwitchErrorCount
    totalSuccessCount
  }
  galaxyJobs {
    ...jobLevelStats
  }
  consultantJobs {
    ...jobLevelStats
  }
  dumpJobs {
    ...jobLevelStats
  }
  processJobs {
    ...jobLevelStats
  }
}
    ${JobLevelStatsFragmentDoc}`;
export const FinancialDashboardDurationFragmentDoc = gql`
    fragment FinancialDashboardDuration on FinancialRecalculationDurationStats {
  sampleCount
  averageSeconds
  minimumSeconds
  maximumSeconds
}
    `;
export const DoublonResultFragmentDoc = gql`
    fragment DoublonResult on DoublonInvestisseurCheckResult {
  canBeCreated
  existingRelationInvestisseurId
  isDoublon
  isInOwnPortefeuille
  isOtherConsultantContact
  isOtherConsultantSigned
}
    `;
export const RechercheSauvegardeFragmentFragmentDoc = gql`
    fragment RechercheSauvegardeFragment on RechercheSauvegarde {
  id
  label
  dateModification
  filtres {
    builderCode
    operator
    value
  }
}
    `;
export const RelationsFragmentFragmentDoc = gql`
    fragment relationsFragment on Investisseur {
  personnePhysique {
    id
    relationFamillePersonnePhysique {
      typeRelationFamilleCode
      autoriteParentale
      autrePersonnePhysique {
        code
        id
        nom
        prenom
        dateNaissance
        etatCivil {
          typeSituationEtatCivilCode
        }
        investisseur {
          id
          statutCode
        }
        telephone {
          numero
          estNumeroCorrespondance
        }
        email {
          adresse
          estAdresseCorrespondance
        }
      }
    }
    relationFamillePersonnePhysique1 {
      typeRelationFamilleCode
      autoriteParentale
      personnePhysique1 {
        id
      }
      personnePhysique2 {
        id
      }
    }
    relationFamillePersonnePhysique2 {
      typeRelationFamilleCode
      autoriteParentale
      personnePhysique1 {
        id
      }
      personnePhysique2 {
        id
      }
    }
    relationAutrePersonnePhysique {
      typeRelationAutreCode
      autrePersonnePhysique {
        code
        id
        nom
        prenom
        dateNaissance
        etatCivil {
          typeSituationEtatCivilCode
        }
        investisseur {
          id
          statutCode
        }
        telephone {
          numero
          estNumeroCorrespondance
        }
        email {
          adresse
          estAdresseCorrespondance
        }
      }
    }
  }
}
    `;
export const BudgetDtoDetailFragmentDoc = gql`
    fragment budgetDtoDetail on BudgetDto {
  budgetId
  designation
  patrimoineId
  foyerFiscalId
  montant
  typeBudgetCode
  isGenerated
  dureeRestante
  dateFin
  capitalRestantDu
  budgetInvestisseurs {
    investisseurId
    pourcentageDetention
    investisseur {
      id
      personnePhysique {
        nom
        prenom
      }
    }
  }
  commentaire
}
    `;
export const AllBudgetDtoInvestisseursFragmentDoc = gql`
    fragment allBudgetDtoInvestisseurs on Investisseur {
  id
  code
  foyerFiscalId
  allBudgets {
    ...budgetDtoDetail
  }
  personnePhysique {
    relationCouplePersonnePhysique {
      autrePersonnePhysique {
        investisseur {
          allBudgets {
            ...budgetDtoDetail
          }
        }
      }
    }
  }
}
    ${BudgetDtoDetailFragmentDoc}`;
export const PatrimoineAssocieBudgetFragmentFragmentDoc = gql`
    fragment PatrimoineAssocieBudgetFragment on PatrimoineBudget {
  patrimoine {
    creationDate
    categorieCode
    designation
    id
    patrimoineCategorie {
      categoryLibelle
      subCategoryLibelle
      subCategory2Libelle
    }
    investisseurPatrimoines {
      id
      investisseurId
      investisseur {
        personnePhysique {
          nom
          prenom
        }
      }
      detentionPP
      detentionNP
      detentionUS
    }
    patrimoineActif {
      id
      type
      modeDetention
      valeurEstimee
    }
    patrimoinePassif {
      id
      montant
    }
    patrimoinePrevoyance {
      capitalAssure
      id
    }
  }
}
    `;
export const BudgetDetailFragmentFragmentDoc = gql`
    fragment BudgetDetailFragment on Budget {
  id
  designation
  montantAnnuel
  typeBudgetId
  commentaire
  typeBudget {
    id
    code
  }
  budgetInvestisseurs {
    investisseurId
    investisseur {
      personnePhysique {
        nom
        prenom
      }
    }
  }
  patrimoineBudget {
    ...PatrimoineAssocieBudgetFragment
  }
}
    ${PatrimoineAssocieBudgetFragmentFragmentDoc}`;
export const ObjectifStepDetailsFragmentFragmentDoc = gql`
    fragment ObjectifStepDetailsFragment on Investisseur {
  id
  code
  objectifDefinis {
    objectif {
      categorieCode
      code
      libelle
    }
    priorite
    horizon
    objectifReferenceCode
    commentaire
  }
  capaciteFinanciere {
    commentaire
    epargnePrecautionCible
    effortEpargne
    levierType
  }
  engagementBudgetaire {
    mensualiteCreditTotale
    tauxEndettement
    capaciteRemboursementRestanteMensuel
    soldeBudgetMensuel
  }
  capaciteEpargne {
    capaciteEpargneMensuelle
  }
  personnePhysique {
    nom
    prenom
    relationCouplePersonnePhysique {
      autrePersonnePhysique {
        nom
        prenom
        investisseur {
          id
          code
          objectifDefinis {
            objectif {
              categorieCode
              code
              libelle
            }
            priorite
            horizon
            objectifReferenceCode
            commentaire
          }
          capaciteFinanciere {
            commentaire
            epargnePrecautionCible
            effortEpargne
          }
          engagementBudgetaire {
            mensualiteCreditTotale
            tauxEndettement
            capaciteRemboursementRestanteMensuel
            soldeBudgetMensuel
          }
          capaciteEpargne {
            capaciteEpargneMensuelle
          }
        }
      }
    }
  }
}
    `;
export const ObjectifRefFragmentFragmentDoc = gql`
    fragment objectifRefFragment on ObjectifReference {
  code
  ordre
  libelle
  categorieCode
  categorie {
    code
    libelle
    ordre
  }
}
    `;
export const ConnaissanceExperienceReponsesFieldsFragmentDoc = gql`
    fragment ConnaissanceExperienceReponsesFields on ConnaissanceExperienceReponses {
  produitsEpargne {
    produit
    question
    detention
    selectionAutoRecueil
    verification {
      reponse
    }
  }
  supportsInvestissement {
    support
    question
    detention
    verification {
      reponse
    }
  }
  pedagogie {
    affirmation
    reponse
  }
  experience {
    modeGestion
    nombreOperations
    pertesSubies
    reactionPerte
  }
  totalPoints
  niveau
  isComplete
}
    `;
export const ToleranceRisqueReponsesFieldsFragmentDoc = gql`
    fragment ToleranceRisqueReponsesFields on ToleranceRisqueReponses {
  reponses {
    question
    reponse
  }
  isCoherent
  totalPoints
  niveau
  isComplete
}
    `;
export const ContratDetailsFragmentFragmentDoc = gql`
    fragment contratDetailsFragment on ContratsInvestisseur {
  idContrat
  idPartenaire
  codeInvestisseur
  idPersonnePartenaire
  contrat {
    idContrat
    numeroContrat
    dateDebutContrat
    codeModeGestion
    vpMontantUnitaire
    flagEpargneHandicap
    flagRpp
    clauseBeneficiaire
    dateValorisation
    valorisation
    perfPlusMoinsValueFinanciereNette
    cumulVersementsNets
    cumulRachats
    modeGestion {
      libelle
    }
    periodiciteVp {
      libelle
    }
    produit {
      designation
      enveloppe {
        libelle
      }
      partenaire {
        libelleCourt
        libelleLong
      }
    }
    contratsSupports {
      poidsSupportDansContrat
      valorisation
      dateCotation
      nombreParts
      valeurLiquidative
      perfPlusMoinsValueFinanciere
      supportGen {
        isin
        supportsClassesActif {
          libelleSupport
          societeGestion
          classeActif
          sousClasseActif
          sri
          esg
          estFondEuro
        }
      }
    }
  }
  investisseur {
    nom
    prenom
  }
  autresInvestisseurs {
    codeInvestisseur
    investisseur {
      nom
      prenom
    }
  }
}
    `;
export const VueDEnsembleDetailsFragmentDoc = gql`
    fragment vueDEnsembleDetails on VueDEnsembleResult {
  dateCalculIndicateur
  capaciteEpargne
  capaciteRemboursementEmpruntRestant
  epargneDisponible
  epargnePrecautionReelle
  epargnePrecautionSouhaitee
  effortEpargne
  impotNetIFI
  impotNetIR
  montantRemboursement
  prochaineDateEcheance
  soldeBudgetaire
  tauxEndetement
  soitParMois
  tauxMarginalImposition
  tauxMarginalImpositionCoInvestisseur
  profilInvestisseur {
    profilDeRisque
    connaissanceExperiences
    esg
    reponseESG
  }
  profilCoInvestisseur {
    profilDeRisque
    connaissanceExperiences
    esg
    reponseESG
  }
  patrimoines {
    categoryTitle
    subCategory
    filiale
    totalCategory
    elements {
      description
      title
      value
    }
  }
  repartitions {
    categoryTitle
    subCategory
    filiale
    totalCategory
    elements {
      description
      title
      value
    }
  }
  revenusCharges {
    categoryTitle
    subCategory
    filiale
    totalCategory
    elements {
      description
      title
      value
    }
  }
  vueObjectifs {
    horizon
    name
    owner
    order
  }
  situations {
    situationType
    totalCategory
    elements {
      description
      title
      value
    }
  }
}
    `;
export const MetadatasConnaissanceClientStateDetailledFragmentFragmentDoc = gql`
    fragment MetadatasConnaissanceClientStateDetailledFragment on MetadatasConnaissanceClient {
  id
  avancementsConnaissanceClientInvestisseurs {
    budgetState
    cnIdocumentID
    cniEtat
    cniLastChangeDate
    cniReferenceDate
    deRdocumentID
    derEtat
    derLastChangeDate
    derReferenceDate
    etatGlobal
    etatGlobalLastChangeDate
    fiscaliteState
    id
    investisseurId
    isRecueilFormCompleted
    lastChangeDate
    metadatasConnaissanceClientId
    objectifsState
    patrimoineState
    qpIdocumentID
    qpiEtat
    qpiLastChangeDate
    qpiReferenceDate
    recueildocumentID
    recueilEtat
    recueilLastChangeDate
    recueilReferenceDate
    situationPersonnelleState
    statutFormulaireQPI
    statutFormulaireRecueil
    metadatasConnaissanceClient {
      id
    }
  }
}
    `;
export const MetadatasConnaissanceClientStateFragmentFragmentDoc = gql`
    fragment MetadatasConnaissanceClientStateFragment on MetadatasConnaissanceClient {
  id
}
    `;
export const AvancementConnaissanceClientFragmentFragmentDoc = gql`
    fragment AvancementConnaissanceClientFragment on AvancementConnaissanceClientInvestisseur {
  budgetState
  cnIdocumentID
  cniEtat
  cniLastChangeDate
  cniReferenceDate
  deRdocumentID
  derEtat
  derLastChangeDate
  derReferenceDate
  etatGlobal
  etatGlobalLastChangeDate
  fiscaliteState
  id
  investisseurId
  isRecueilFormCompleted
  lastChangeDate
  metadatasConnaissanceClientId
  objectifsState
  patrimoineState
  qpIdocumentID
  qpiEtat
  qpiLastChangeDate
  qpiReferenceDate
  recueildocumentID
  recueilEtat
  recueilLastChangeDate
  recueilReferenceDate
  situationPersonnelleState
  statutFormulaireQPI
  statutFormulaireRecueil
  metadatasConnaissanceClient {
    ...MetadatasConnaissanceClientStateFragment
  }
}
    ${MetadatasConnaissanceClientStateFragmentFragmentDoc}`;
export const EtiquetteFragmentFragmentDoc = gql`
    fragment EtiquetteFragment on Etiquette {
  color
  id
  label
}
    `;
export const DetailedInvestisseurFragmentDoc = gql`
    fragment DetailedInvestisseur on Investisseur {
  code
  id
  pendingPurge
  statutCode
  avancementConnaissanceClientInvestisseur {
    ...AvancementConnaissanceClientFragment
  }
  personnePhysique {
    id
    dateNaissance
    nom
    prenom
    nomNaissance
    villeNaissanceNom
    departementNaissance
    codePaysNaissance
    codePaysNaissanceNavigation {
      libelle
    }
    email {
      id
      adresse
      estAdresseCorrespondance
    }
    adresse {
      adresse1
      adresse2
      adresse3
      complement
      codePostalCode
      villeNom
      paysCode
      paysCodeNavigation {
        libelle
      }
      typeAdresseCode
    }
    telephone {
      id
      numero
      estNumeroCorrespondance
    }
    etatCivil {
      personnePhysiqueId
      typeSituationEtatCivilCode
      typeSituationEtatCivilCodeNavigation {
        libelle
        actif
      }
      regimePacsIndivision
      typeRegimeSituationEtatCivilCode
      typeRegimeSituationEtatCivilCodeNavigation {
        libelle
      }
      nombreEnfantACharge
    }
    situationProfessionnelle {
      profession
      origineRevenus
      nomSociete
      note {
        note1
      }
      categorieSocioProfessionnelleCodeAtlas
      categorieSocioProfessionnelleCodeAtlasNavigation {
        parent
      }
    }
    relationFamillePersonnePhysique {
      typeRelationFamilleCode
      autrePersonnePhysique {
        investisseur {
          code
          id
        }
      }
    }
    relationCouplePersonnePhysique {
      typeRelationCoupleCode
      autrePersonnePhysiqueId
      autrePersonnePhysique {
        nom
        prenom
        nomNaissance
        dateNaissance
        villeNaissanceNom
        departementNaissance
        codePaysNaissance
        codePaysNaissanceNavigation {
          libelle
        }
        adresse {
          adresse1
          adresse2
          adresse3
          complement
          codePostalCode
          villeNom
          paysCode
          paysCodeNavigation {
            libelle
          }
          typeAdresseCode
        }
        situationProfessionnelle {
          profession
          origineRevenus
          note {
            note1
          }
          nomSociete
          categorieSocioProfessionnelleCodeAtlas
          categorieSocioProfessionnelleCodeAtlasNavigation {
            parent
          }
        }
        etatCivil {
          personnePhysiqueId
          typeSituationEtatCivilCode
          typeSituationEtatCivilCodeNavigation {
            libelle
            actif
          }
          typeRegimeSituationEtatCivilCodeNavigation {
            libelle
          }
          nombreEnfantACharge
        }
        investisseur {
          code
          id
          statutCode
          avancementConnaissanceClientInvestisseur {
            id
            cnIdocumentID
            cniEtat
            cniLastChangeDate
            derEtat
            deRdocumentID
            qpiEtat
            qpIdocumentID
            isRecueilFormCompleted
            recueilEtat
            recueildocumentID
            metadatasConnaissanceClient {
              id
            }
          }
        }
        telephone {
          numero
          estNumeroCorrespondance
        }
        email {
          adresse
          estAdresseCorrespondance
        }
      }
    }
  }
  etiquettes {
    ...EtiquetteFragment
  }
  investisseurConsultantRelations {
    consultantCode
    consultantId
    nom
    prenom
    typeRelationInvestisseurConsultantCode
  }
}
    ${AvancementConnaissanceClientFragmentFragmentDoc}
${EtiquetteFragmentFragmentDoc}`;
export const PreferencesSettingsFragmentFragmentDoc = gql`
    fragment preferencesSettingsFragment on ConsultantPreferences {
  ordreSignature
  generationRecueilType
  recueilChampsComplementairesVisible
}
    `;
export const InvestisseurNameAndCodeFragmentDoc = gql`
    fragment investisseurNameAndCode on Investisseur {
  code
  id
  personnePhysique {
    civiliteCode
    nom
    prenom
    dateNaissance
    id
  }
  statutCode
}
    `;
export const OperationConfigFieldsFragmentDoc = gql`
    fragment OperationConfigFields on OperationConfig {
  conseilConfig {
    typesDocumentRequis {
      fileNamePrefix
      documentCategory {
        label
        gedCategoryCode
      }
      gedTypeCode
      label
    }
    enveloppeConfig {
      fieldConfigs {
        fieldKey
        isVisible
        visibilityCondition {
          fieldKey
          operator
          value
        }
        validators {
          errorMessage
          validatorKey
          parameters {
            id
            key
            value
          }
        }
      }
    }
    produitSpecificConfigs {
      produitId
      ficheProduitUrl
      extranetPartenaireUrl
      produitAtlas {
        nom
      }
      config {
        fieldConfigs {
          fieldKey
          isVisible
          visibilityCondition {
            fieldKey
            operator
            value
          }
          validators {
            errorMessage
            validatorKey
            parameters {
              id
              key
              value
            }
          }
        }
      }
      produit {
        gestionPossibles {
          modeDeGestionId
          modeDeGestion {
            libelle
          }
          conditionVersementInitial {
            montantMinSouscription
            montantMinAvecVP
            montantMinAvecTransfert
          }
          conditionVersementProgramme {
            montantMinMensuel
            montantMinTrimestriel
            montantMinSemestriel
            montantMinAnnuel
          }
        }
        fondsEvenementiels {
          id
          code
          libelle
          ordre
        }
        optionsAutomatiques {
          id
          libelle
          modeDeGestionCode
          ordre
        }
        allocations {
          id
          libelle
          modeDeGestionId
          statut
          niveauDeRisque
          storageFile {
            id
            fileName
            fileType
          }
        }
      }
    }
  }
}
    `;
export const OperationDataFieldsFragmentDoc = gql`
    fragment OperationDataFields on OperationData {
  modeDeGestion
  disponibiliteEpargneOptions {
    id
    label
    value
  }
  modeDeGestionNavigation {
    id
  }
  toleranceRisqueOptions {
    id
    label
    value
  }
  snapshotData {
    boxPlacementUrl
    souscription {
      produitId
      modeSignature
      transmissionOriginaux
      dateSignature
      bulletinFileId
      bulletinFileIdToDelete
      commentaire
    }
    besoin {
      motivationOperation
      selectedObjectifCodes
      disponibiliteEpargne
      horizonPlacement {
        horizonRetraite
        justification
        value
      }
      toleranceRisque
    }
    connaissanceClient {
      toleranceRisque
      investisseurs {
        civiliteCode
        code
        creationDate
        dateNaissance
        denomination
        displayName
        id
        nom
        prenom
        patrimoine {
          capaciteEpargneMensuel
          dateMiseAJourAtlas
          epargneFinanceMontantTotal
          epargneImmoMontantHorsRP
          revenuAnnuelTotal
        }
        profil {
          resultatCapacitePerte
          resultatConnaissance
          resultatProfilDeRisque
          resultatSensibiliteExtraFinanciere
          resultatToleranceAuRisque
        }
        situationPersonnelle {
          categorieSocioProfessionnelleCode
          categorieSocioProfessionnelleLibelle
          dateMiseAJourAtlas
          enfantACharge
          etatCivilDisplay
          etatCivilTypeCode
          etatCivilTypeLibelle
          etatCivilTypeRegimeCode
          etatCivilTypeRegimeLibelle
          profession
        }
        statutCodeNavigation {
          code
          libelle
        }
      }
      objectifs {
        categorieCode
        categorieLibelle
        id
        isSelected
        objectifCode
        objectifLibelle
      }
    }
    conseil {
      fondsEvenementiels {
        id
        code
        libelle
        isSelected
      }
      optionsAutomatiques {
        id
        libelle
        isSelected
      }
      allocation {
        id
        libelle
        modeDeGestionCode
        niveauDeRisque
      }
      allocationPrecision
      allocationTransfertOption
      allocationVersementOption
      arbitrageLibreSupportsEntrants
      arbitrageLibreSupportsSortants
      avecArbitragesProgrammes
      avecMiseEnPlaceOuModificationVP
      portefeuilleOption
      transactionPersonnelle
      vpModeOptions
      autoSouscription
      impactDiminutionFrais
      arbitrageDuplicationContext {
        objectifsIntersectionApplied
        sourceFicheId
      }
      precisionComplementaire {
        commentaireAllocation
        commentaireAutre
        commentaireEnveloppe
      }
      versements {
        avecVersementProgramme
        souscriptionAvecTransfert
        versementInitial {
          montantBrut
          fraisVersement
          niveauDeRisque
        }
        versementProgramme {
          frequence
          versement {
            montantBrut
            fraisVersement
            niveauDeRisque
          }
        }
      }
    }
    signature {
      requiredDocuments {
        typeDocumentCode
        investisseurIds
      }
      mode
      documents {
        fileId
        sourceFileId
        versionNumber
        investisseurId
        investisseurIds
        extension
        actif
        denomination
        typeDocumentCode
        dateDeCreation
        dateDeDerniereModification
        etatSignature
        fileName
        dateSignature
        signataires {
          email
          firstName
          internalId
          lastName
          phone
          type
        }
      }
      isLocked
      invalidatedFromStep
    }
  }
}
    `;
export const ProjetDocumentFieldsFragmentDoc = gql`
    fragment ProjetDocumentFields on ProjetDocument {
  id
  fileId
  typeDocumentCode
  fileName
  creationDate
}
    `;
export const GenerateContratsAgregationBackOfficeExportDocument = gql`
    mutation GenerateContratsAgregationBackOfficeExport($filter: ContratBackOfficeFilterInput!) {
  generateContratsAgregationBackOfficeExport(filter: $filter) {
    fileName
    sasUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateContratsAgregationBackOfficeExportGQL extends Apollo.Mutation<GenerateContratsAgregationBackOfficeExportMutation, GenerateContratsAgregationBackOfficeExportMutationVariables> {
    document = GenerateContratsAgregationBackOfficeExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateContratsBySupportAgregationBackOfficeExportDocument = gql`
    mutation GenerateContratsBySupportAgregationBackOfficeExport($filter: ContratBackOfficeFilterInput!) {
  generateContratsBySupportAgregationBackOfficeExport(filter: $filter) {
    fileName
    sasUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateContratsBySupportAgregationBackOfficeExportGQL extends Apollo.Mutation<GenerateContratsBySupportAgregationBackOfficeExportMutation, GenerateContratsBySupportAgregationBackOfficeExportMutationVariables> {
    document = GenerateContratsBySupportAgregationBackOfficeExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateSupportsAgregationBackOfficeExportDocument = gql`
    mutation GenerateSupportsAgregationBackOfficeExport($filter: SupportConsultantFilterInput!) {
  generateSupportsAgregationBackOfficeExport(filter: $filter) {
    fileName
    sasUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateSupportsAgregationBackOfficeExportGQL extends Apollo.Mutation<GenerateSupportsAgregationBackOfficeExportMutation, GenerateSupportsAgregationBackOfficeExportMutationVariables> {
    document = GenerateSupportsAgregationBackOfficeExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConsultantsFilterDocument = gql`
    query consultantsFilter($filter: String!) {
  consultantsAgregation(filter: $filter, take: 25, skip: 0) {
    items {
      codeConsultant
      nom
      prenom
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConsultantsFilterGQL extends Apollo.Query<ConsultantsFilterQuery, ConsultantsFilterQueryVariables> {
    document = ConsultantsFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContratsBackOfficeDocument = gql`
    query contratsBackOffice {
  visionGlobaleBackOffice {
    encoursTotal
    encoursMoyenContrat
    nbContrats
    encoursMoyenClient
    nbClients
    encoursMoyenSupport
    nbSupports
    encoursMoyenSocieteGestion
    nbSocietesGestions
  }
  repartitionProduitsBackOffice(
    where: {nbContrats: {gt: 0}}
    order: {poidsProduitEncours: DESC}
  ) {
    nbContrats
    encours
    poidsProduitEncours
    produit {
      designation
    }
  }
  repartitionEnveloppesBackOffice(
    where: {nbContrats: {gt: 0}}
    order: {poidsEnveloppeEncours: DESC}
  ) {
    nbContrats
    encours
    poidsEnveloppeEncours
    enveloppeAgregation {
      code
      libelle
    }
  }
  repartitionPartenairesBackOffice(
    where: {nbContrats: {gt: 0}}
    order: {poidsPartenaireEncours: DESC}
  ) {
    nbContrats
    encours
    poidsPartenaireEncours
    partenaireAgregation {
      idPartenaire
      libelleLong
    }
  }
  repartitionSocieteGestionsBackOffice(
    where: {societeGestion: {neq: ""}}
    order: {poidsSocieteGestion: DESC}
  ) {
    encours
    poidsSocieteGestion
    societeGestion
  }
  repartitionClasseActifsBackOffice(
    where: {classeActif: {neq: null}}
    order: {poidsSousClasseActif: DESC}
  ) {
    encours
    poidsClasseActif
    poidsSousClasseActif
    classeActif
    sousClasseActif
  }
  repartitionSrisBackOffice(where: {sri: {neq: 0}}, order: {poidsSri: DESC}) {
    encours
    poidsSri
    sri
  }
  repartitionEsgsBackOffice(order: {poidsEsg: DESC}) {
    encours
    poidsEsg
    esg
  }
  allSupportsBackOffice(
    where: {supportClasseActif: {libelleSupport: {neq: null}}}
    order: {supportClasseActif: {libelleSupport: ASC}}
  ) {
    codeIsin
    supportClasseActif {
      libelleSupport
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContratsBackOfficeGQL extends Apollo.Query<ContratsBackOfficeQuery, ContratsBackOfficeQueryVariables> {
    document = ContratsBackOfficeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContratsBackOfficeListeDocument = gql`
    query contratsBackOfficeListe($filter: ContratBackOfficeFilterInput!, $order: ContratBackOfficeOrderInput, $take: Int, $skip: Int) {
  contratsBackOffice(filter: $filter, order: $order, take: $take, skip: $skip) {
    totalCount
    items {
      idContrat
      numeroContrat
      valorisation
      dateDebutContrat
      dateValorisation
      cumulVersementsNets
      perfPlusMoinsValueFinanciereNette
      flagVp
      vpMontantUnitaire
      periodiciteVp {
        libelle
      }
      produit {
        designation
        enveloppe {
          libelle
        }
        partenaire {
          libelleLong
        }
      }
      contratsInvestisseurs {
        codeInvestisseur
        investisseur {
          nom
          prenom
        }
        consultant {
          nom
          prenom
          galaxieConsultant {
            nom
            prenom
          }
        }
      }
    }
  }
  totalContratsBackOffice(filter: $filter)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContratsBackOfficeListeGQL extends Apollo.Query<ContratsBackOfficeListeQuery, ContratsBackOfficeListeQueryVariables> {
    document = ContratsBackOfficeListeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManagersGalaxieDocument = gql`
    query managersGalaxie {
  managersGalaxie(order: {nom: ASC, prenom: ASC}) {
    idConsultant
    nom
    prenom
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManagersGalaxieGQL extends Apollo.Query<ManagersGalaxieQuery, ManagersGalaxieQueryVariables> {
    document = ManagersGalaxieDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SupportsBackOfficeListeDocument = gql`
    query supportsBackOfficeListe($filter: SupportConsultantFilterInput!, $order: SupportConsultantOrderInput, $take: Int, $skip: Int) {
  supportsBackOffice(filter: $filter, order: $order, take: $take, skip: $skip) {
    totalCount
    items {
      codeIsin
      encours
      poidsSupport
      valeurLiquidative
      dateCotation
      nbContrats
      supportClasseActif {
        libelleSupport
        classeActif
        sousClasseActif
        societeGestion
        categorieQuantalys
        sri
        esg
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SupportsBackOfficeListeGQL extends Apollo.Query<SupportsBackOfficeListeQuery, SupportsBackOfficeListeQueryVariables> {
    document = SupportsBackOfficeListeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AttachAllocationFileDocument = gql`
    mutation attachAllocationFile($allocationId: String!, $storageFileId: String!) {
  attachAllocationFile(allocationId: $allocationId, storageFileId: $storageFileId) {
    id
    dateModification
    storageFile {
      id
      fileNameWithExtension
      lastModificationDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AttachAllocationFileGQL extends Apollo.Mutation<AttachAllocationFileMutation, AttachAllocationFileMutationVariables> {
    document = AttachAllocationFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAllocationFileUploadDocument = gql`
    mutation createAllocationFileUpload($allocationId: String!, $fileName: String!) {
  createAllocationFileUpload(allocationId: $allocationId, fileName: $fileName) {
    id
    fileConnectionInfo {
      sasUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAllocationFileUploadGQL extends Apollo.Mutation<CreateAllocationFileUploadMutation, CreateAllocationFileUploadMutationVariables> {
    document = CreateAllocationFileUploadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAllocationFileDocument = gql`
    mutation deleteAllocationFile($allocationId: String!) {
  deleteAllocationFile(allocationId: $allocationId) {
    id
    dateModification
    storageFile {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAllocationFileGQL extends Apollo.Mutation<DeleteAllocationFileMutation, DeleteAllocationFileMutationVariables> {
    document = DeleteAllocationFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllocationStorageFileDocument = gql`
    query allocationStorageFile($storageFileId: String!) {
  storageFile(storageFileId: $storageFileId) {
    id
    fileName
    fileType
    fileNameWithExtension
    fileConnectionInfo {
      sasUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllocationStorageFileGQL extends Apollo.Query<AllocationStorageFileQuery, AllocationStorageFileQueryVariables> {
    document = AllocationStorageFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllocationsFilesDocument = gql`
    query allocationsFiles($where: AllocationFilterInput) {
  allocationsFiles(where: $where, order: {libelle: ASC}) {
    id
    libelle
    niveauDeRisque
    dateModification
    storageFile {
      id
      fileNameWithExtension
      lastModificationDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllocationsFilesGQL extends Apollo.Query<AllocationsFilesQuery, AllocationsFilesQueryVariables> {
    document = AllocationsFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMigrationWaveJobDocument = gql`
    mutation createMigrationWaveJob($waveLabel: String!, $galaxyIds: [Long!]!, $consultantIds: [Long!]!, $isPreImport: Boolean!, $shouldAutomaticallyProcess: Boolean!, $priority: Int!, $initialStatus: JobStatus!, $plannedStartMigrationDate: DateTime) {
  createMigrationWaveJob(
    waveLabel: $waveLabel
    galaxyIds: $galaxyIds
    galaxyCodes: []
    consultantIds: $consultantIds
    consultantCodes: []
    isPreImport: $isPreImport
    shouldAutomaticallyProcess: $shouldAutomaticallyProcess
    priority: $priority
    initialStatus: $initialStatus
    plannedStartMigrationDate: $plannedStartMigrationDate
  ) {
    ...waveDetails
  }
}
    ${WaveDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMigrationWaveJobGQL extends Apollo.Mutation<CreateMigrationWaveJobMutation, CreateMigrationWaveJobMutationVariables> {
    document = CreateMigrationWaveJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportMigrationPlanningAllConsultantsDocument = gql`
    mutation exportMigrationPlanningAllConsultants {
  exportMigrationPlanningAllConsultants {
    fileName
    fileConnectionInfo {
      sasUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportMigrationPlanningAllConsultantsGQL extends Apollo.Mutation<ExportMigrationPlanningAllConsultantsMutation, ExportMigrationPlanningAllConsultantsMutationVariables> {
    document = ExportMigrationPlanningAllConsultantsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateGalaxyListInWavesDocument = gql`
    mutation updateGalaxyListInWaves {
  updateGalaxyListInWaves
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateGalaxyListInWavesGQL extends Apollo.Mutation<UpdateGalaxyListInWavesMutation, UpdateGalaxyListInWavesMutationVariables> {
    document = UpdateGalaxyListInWavesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllConsultantMigrationsPaginatedDocument = gql`
    query allConsultantMigrationsPaginated($take: Int, $skip: Int, $where: ConsultantFilterInput) {
  consultantsPaginated(take: $take, skip: $skip, where: $where) {
    totalCount
    items {
      ...migrationConsultantItem
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${MigrationConsultantItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AllConsultantMigrationsPaginatedGQL extends Apollo.Query<AllConsultantMigrationsPaginatedQuery, AllConsultantMigrationsPaginatedQueryVariables> {
    document = AllConsultantMigrationsPaginatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConsultantsByNamePaginatedDocument = gql`
    query consultantsByNamePaginated($take: Int, $skip: Int, $where: ConsultantFilterInput, $searchText: String) {
  consultantsByNamePaginated(
    take: $take
    skip: $skip
    where: $where
    searchText: $searchText
  ) {
    totalCount
    items {
      ...consultantCodeAndName
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ConsultantCodeAndNameFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConsultantsByNamePaginatedGQL extends Apollo.Query<ConsultantsByNamePaginatedQuery, ConsultantsByNamePaginatedQueryVariables> {
    document = ConsultantsByNamePaginatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GalaxyManagerDocument = gql`
    query galaxyManager {
  consultantsPaginated(
    where: {and: [{qualificationCode: {eq: "8"}}, {statutCode: {eq: "1"}}]}
    skip: 0
    take: 500
  ) {
    totalCount
    items {
      ...consultantCodeAndName
    }
  }
}
    ${ConsultantCodeAndNameFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GalaxyManagerGQL extends Apollo.Query<GalaxyManagerQuery, GalaxyManagerQueryVariables> {
    document = GalaxyManagerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConsultantMigrationsByNamePaginatedDocument = gql`
    query consultantMigrationsByNamePaginated($take: Int, $skip: Int, $where: ConsultantFilterInput, $searchText: String) {
  consultantsByNamePaginated(
    take: $take
    skip: $skip
    where: $where
    searchText: $searchText
  ) {
    totalCount
    items {
      ...migrationConsultantItem
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${MigrationConsultantItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConsultantMigrationsByNamePaginatedGQL extends Apollo.Query<ConsultantMigrationsByNamePaginatedQuery, ConsultantMigrationsByNamePaginatedQueryVariables> {
    document = ConsultantMigrationsByNamePaginatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllWaveMigrationJobsDocument = gql`
    query allWaveMigrationJobs($where: WaveMigrationJobFilterInput) {
  allWaveMigrationJobs(where: $where) {
    ...waveDetails
  }
}
    ${WaveDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AllWaveMigrationJobsGQL extends Apollo.Query<AllWaveMigrationJobsQuery, AllWaveMigrationJobsQueryVariables> {
    document = AllWaveMigrationJobsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestartArianeDumpDocument = gql`
    mutation restartArianeDump($priority: Int!, $where: ArianeDumpJobFilterInput) {
  restartArianeDump(priority: $priority, where: $where)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestartArianeDumpGQL extends Apollo.Mutation<RestartArianeDumpMutation, RestartArianeDumpMutationVariables> {
    document = RestartArianeDumpDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestartProcessArianeDataDocument = gql`
    mutation restartProcessArianeData($priority: Int!, $where: ArianeProcessJobFilterInput) {
  restartProcessArianeData(priority: $priority, where: $where)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestartProcessArianeDataGQL extends Apollo.Mutation<RestartProcessArianeDataMutation, RestartProcessArianeDataMutationVariables> {
    document = RestartProcessArianeDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MigrationConsultantByCodeDocument = gql`
    query migrationConsultantByCode($code: String!) {
  consultantByCode(code: $code) {
    ...migrationConsultantWaveItem
  }
}
    ${MigrationConsultantWaveItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MigrationConsultantByCodeGQL extends Apollo.Query<MigrationConsultantByCodeQuery, MigrationConsultantByCodeQueryVariables> {
    document = MigrationConsultantByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MigrationInvestisseursPaginatedDocument = gql`
    query migrationInvestisseursPaginated($take: Int, $skip: Int, $where: InvestisseurFilterInput) {
  investisseursPaginated(take: $take, skip: $skip, where: $where) {
    totalCount
    items {
      ...migrationInvestisseurItem
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${MigrationInvestisseurItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MigrationInvestisseursPaginatedGQL extends Apollo.Query<MigrationInvestisseursPaginatedQuery, MigrationInvestisseursPaginatedQueryVariables> {
    document = MigrationInvestisseursPaginatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MigrationInvestisseursByNamePaginatedDocument = gql`
    query migrationInvestisseursByNamePaginated($take: Int, $skip: Int, $where: InvestisseurFilterInput, $searchText: String!) {
  investisseursByNamePaginated(
    take: $take
    skip: $skip
    where: $where
    searchText: $searchText
  ) {
    totalCount
    items {
      ...migrationInvestisseurItem
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${MigrationInvestisseurItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MigrationInvestisseursByNamePaginatedGQL extends Apollo.Query<MigrationInvestisseursByNamePaginatedQuery, MigrationInvestisseursByNamePaginatedQueryVariables> {
    document = MigrationInvestisseursByNamePaginatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllowWaveConsultantsInMinotaureDocument = gql`
    mutation AllowWaveConsultantsInMinotaure($waveId: Long!) {
  setConsultantsAccessByWaveId(
    waveMigrationJobId: $waveId
    isAccesDisabled: false
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllowWaveConsultantsInMinotaureGQL extends Apollo.Mutation<AllowWaveConsultantsInMinotaureMutation, AllowWaveConsultantsInMinotaureMutationVariables> {
    document = AllowWaveConsultantsInMinotaureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportWaveMigrationPendingSignaturesDocument = gql`
    mutation exportWaveMigrationPendingSignatures($waveId: Long!) {
  exportWaveMigrationPendingSignatures(waveMigrationJobId: $waveId) {
    fileName
    fileConnectionInfo {
      sasUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportWaveMigrationPendingSignaturesGQL extends Apollo.Mutation<ExportWaveMigrationPendingSignaturesMutation, ExportWaveMigrationPendingSignaturesMutationVariables> {
    document = ExportWaveMigrationPendingSignaturesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportWaveEcartInvestisseurUpdatedInArianeDocument = gql`
    mutation exportWaveEcartInvestisseurUpdatedInAriane($waveId: Long!) {
  exportWaveEcartInvestisseurUpdatedInAriane(waveMigrationJobId: $waveId) {
    ...storageFileInfo
  }
}
    ${StorageFileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportWaveEcartInvestisseurUpdatedInArianeGQL extends Apollo.Mutation<ExportWaveEcartInvestisseurUpdatedInArianeMutation, ExportWaveEcartInvestisseurUpdatedInArianeMutationVariables> {
    document = ExportWaveEcartInvestisseurUpdatedInArianeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportWaveMigrationJobDataDocument = gql`
    mutation ExportWaveMigrationJobData($waveId: Long!) {
  exportWaveMigrationJobData(waveMigrationJobId: $waveId) {
    ...storageFileInfo
  }
}
    ${StorageFileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportWaveMigrationJobDataGQL extends Apollo.Mutation<ExportWaveMigrationJobDataMutation, ExportWaveMigrationJobDataMutationVariables> {
    document = ExportWaveMigrationJobDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportWaveMigrationEcartInvestisseursDocument = gql`
    mutation ExportWaveMigrationEcartInvestisseurs($waveId: Long!) {
  exportWaveMigrationEcartInvestisseurs(waveMigrationJobId: $waveId) {
    ...storageFileInfo
  }
}
    ${StorageFileInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportWaveMigrationEcartInvestisseursGQL extends Apollo.Mutation<ExportWaveMigrationEcartInvestisseursMutation, ExportWaveMigrationEcartInvestisseursMutationVariables> {
    document = ExportWaveMigrationEcartInvestisseursDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FilldataDocument = gql`
    mutation filldata($waveId: Long!) {
  fillDataEcartInvestisseurs(waveMigrationJobId: $waveId) {
    ...syncEcartResult
  }
}
    ${SyncEcartResultFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FilldataGQL extends Apollo.Mutation<FilldataMutation, FilldataMutationVariables> {
    document = FilldataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetDataEcartInvestisseursDocument = gql`
    mutation resetDataEcartInvestisseurs($waveId: Long!) {
  resetDataEcartInvestisseurs(waveMigrationJobId: $waveId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetDataEcartInvestisseursGQL extends Apollo.Mutation<ResetDataEcartInvestisseursMutation, ResetDataEcartInvestisseursMutationVariables> {
    document = ResetDataEcartInvestisseursDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestartFailedFinancialRecalculationJobDocument = gql`
    mutation RestartFailedFinancialRecalculationJob($jobId: Long!) {
  restartFailedFinancialRecalculationJob(jobId: $jobId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestartFailedFinancialRecalculationJobGQL extends Apollo.Mutation<RestartFailedFinancialRecalculationJobMutation, RestartFailedFinancialRecalculationJobMutationVariables> {
    document = RestartFailedFinancialRecalculationJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestartFailedFinancialRecalculationJobsDocument = gql`
    mutation RestartFailedFinancialRecalculationJobs($where: FinancialRecalculationJobFilterInput!) {
  restartFailedFinancialRecalculationJobs(where: $where)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestartFailedFinancialRecalculationJobsGQL extends Apollo.Mutation<RestartFailedFinancialRecalculationJobsMutation, RestartFailedFinancialRecalculationJobsMutationVariables> {
    document = RestartFailedFinancialRecalculationJobsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WaveSyncBeforeLaunchDocument = gql`
    mutation waveSyncBeforeLaunch($waveId: Long!) {
  waveSyncBeforeLaunch(waveMigrationJobId: $waveId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WaveSyncBeforeLaunchGQL extends Apollo.Mutation<WaveSyncBeforeLaunchMutation, WaveSyncBeforeLaunchMutationVariables> {
    document = WaveSyncBeforeLaunchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConsultantsFilteredDocument = gql`
    query consultantsFiltered($filter: String) {
  consultantsByNamePaginated(searchText: $filter, take: 15, skip: 0) {
    items {
      id
      code
      personnePhysique {
        nom
        prenom
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConsultantsFilteredGQL extends Apollo.Query<ConsultantsFilteredQuery, ConsultantsFilteredQueryVariables> {
    document = ConsultantsFilteredDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FailedFinancialRecalculationDashboardJobsDocument = gql`
    query FailedFinancialRecalculationDashboardJobs($priority: FinancialRecalculationPriority!, $begin: DateTime, $end: DateTime, $skip: Int!, $take: Int!) {
  jobs: failedFinancialRecalculationJobs(
    priority: $priority
    begin: $begin
    end: $end
    skip: $skip
    take: $take
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      jobId
      priority
      createdAtUtc
      failedAtUtc
      message
      exceptionType
      exceptionMessage
      investisseur {
        id
        code
        nom
        prenom
      }
      consultantPrimaire {
        id
        code
        nom
        prenom
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FailedFinancialRecalculationDashboardJobsGQL extends Apollo.Query<FailedFinancialRecalculationDashboardJobsQuery, FailedFinancialRecalculationDashboardJobsQueryVariables> {
    document = FailedFinancialRecalculationDashboardJobsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinancialRecalculationDashboardDocument = gql`
    query FinancialRecalculationDashboard($start: DateTime!, $end: DateTime!) {
  workerCount: financialRecalculationWorkerCount
  stats: financialRecalculationJobStats(start: $start, end: $end) {
    start
    end
    priorities {
      priority
      statusCounts {
        status
        count
      }
      completed {
        elapsedSinceCreation {
          ...FinancialDashboardDuration
        }
        processing {
          ...FinancialDashboardDuration
        }
      }
      failed {
        elapsedSinceCreation {
          ...FinancialDashboardDuration
        }
        processing {
          ...FinancialDashboardDuration
        }
      }
    }
  }
}
    ${FinancialDashboardDurationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FinancialRecalculationDashboardGQL extends Apollo.Query<FinancialRecalculationDashboardQuery, FinancialRecalculationDashboardQueryVariables> {
    document = FinancialRecalculationDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetFinancialRecalculationWorkerCountDocument = gql`
    mutation SetFinancialRecalculationWorkerCount($count: Int!) {
  setFinancialRecalculationWorkerCount(count: $count)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetFinancialRecalculationWorkerCountGQL extends Apollo.Mutation<SetFinancialRecalculationWorkerCountMutation, SetFinancialRecalculationWorkerCountMutationVariables> {
    document = SetFinancialRecalculationWorkerCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWaveStatsDocument = gql`
    query GetWaveStats($waveId: Long!) {
  waveMigrationStats(waveId: $waveId) {
    ...fullWaveTrackingStat
  }
}
    ${FullWaveTrackingStatFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWaveStatsGQL extends Apollo.Query<GetWaveStatsQuery, GetWaveStatsQueryVariables> {
    document = GetWaveStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateContratsAgregationExportDocument = gql`
    mutation GenerateContratsAgregationExport($filter: ContratConsultantFilterInput!) {
  generateContratsAgregationExport(filter: $filter) {
    fileName
    sasUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateContratsAgregationExportGQL extends Apollo.Mutation<GenerateContratsAgregationExportMutation, GenerateContratsAgregationExportMutationVariables> {
    document = GenerateContratsAgregationExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateContratsBySupportAgregationExportDocument = gql`
    mutation GenerateContratsBySupportAgregationExport($filter: ContratConsultantFilterInput!) {
  generateContratsBySupportAgregationExport(filter: $filter) {
    fileName
    sasUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateContratsBySupportAgregationExportGQL extends Apollo.Mutation<GenerateContratsBySupportAgregationExportMutation, GenerateContratsBySupportAgregationExportMutationVariables> {
    document = GenerateContratsBySupportAgregationExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateSupportsAgregationExportDocument = gql`
    mutation GenerateSupportsAgregationExport($filter: SupportConsultantFilterInput!) {
  generateSupportsAgregationExport(filter: $filter) {
    fileName
    sasUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateSupportsAgregationExportGQL extends Apollo.Mutation<GenerateSupportsAgregationExportMutation, GenerateSupportsAgregationExportMutationVariables> {
    document = GenerateSupportsAgregationExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContratsConsultantDocument = gql`
    query contratsConsultant {
  visionGlobaleConsultant {
    encoursTotal
    encoursMoyenContrat
    nbContrats
    encoursMoyenClient
    nbClients
    encoursMoyenSupport
    nbSupports
    encoursMoyenSocieteGestion
    nbSocietesGestions
  }
  repartitionProduitsConsultant(
    where: {nbContrats: {gt: 0}}
    order: {poidsProduitEncours: DESC}
  ) {
    nbContrats
    encours
    poidsProduitEncours
    produit {
      designation
    }
  }
  repartitionEnveloppesConsultant(
    where: {nbContrats: {gt: 0}}
    order: {poidsEnveloppeEncours: DESC}
  ) {
    nbContrats
    encours
    poidsEnveloppeEncours
    enveloppeAgregation {
      code
      libelle
    }
  }
  repartitionPartenairesConsultant(
    where: {nbContrats: {gt: 0}}
    order: {poidsPartenaireEncours: DESC}
  ) {
    nbContrats
    encours
    poidsPartenaireEncours
    partenaireAgregation {
      idPartenaire
      libelleLong
    }
  }
  repartitionSocieteGestionsConsultant(
    where: {societeGestion: {neq: ""}}
    order: {poidsSocieteGestion: DESC}
  ) {
    encours
    poidsSocieteGestion
    societeGestion
  }
  repartitionClasseActifsConsultant(
    where: {classeActif: {neq: null}}
    order: {poidsSousClasseActif: DESC}
  ) {
    encours
    poidsClasseActif
    poidsSousClasseActif
    classeActif
    sousClasseActif
  }
  repartitionSrisConsultant(where: {sri: {neq: 0}}, order: {poidsSri: DESC}) {
    encours
    poidsSri
    sri
  }
  repartitionEsgsConsultant(order: {poidsEsg: DESC}) {
    encours
    poidsEsg
    esg
  }
  allSupportsConsultant(
    where: {supportClasseActif: {libelleSupport: {neq: null}}}
    order: {supportClasseActif: {libelleSupport: ASC}}
  ) {
    codeIsin
    supportClasseActif {
      libelleSupport
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContratsConsultantGQL extends Apollo.Query<ContratsConsultantQuery, ContratsConsultantQueryVariables> {
    document = ContratsConsultantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContratsConsultantListeDocument = gql`
    query contratsConsultantListe($filter: ContratConsultantFilterInput!, $order: ContratConsultantOrderInput, $take: Int, $skip: Int) {
  contratsConsultant(filter: $filter, order: $order, take: $take, skip: $skip) {
    totalCount
    items {
      idContrat
      numeroContrat
      valorisation
      dateDebutContrat
      dateValorisation
      cumulVersementsNets
      perfPlusMoinsValueFinanciereNette
      flagVp
      vpMontantUnitaire
      periodiciteVp {
        libelle
      }
      produit {
        designation
        enveloppe {
          libelle
        }
        partenaire {
          libelleLong
        }
      }
      contratsInvestisseurs {
        codeInvestisseur
        investisseur {
          nom
          prenom
        }
      }
    }
  }
  totalContratsConsultant(filter: $filter)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContratsConsultantListeGQL extends Apollo.Query<ContratsConsultantListeQuery, ContratsConsultantListeQueryVariables> {
    document = ContratsConsultantListeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SupportsConsultantListeDocument = gql`
    query supportsConsultantListe($filter: SupportConsultantFilterInput!, $order: SupportConsultantOrderInput, $take: Int, $skip: Int) {
  supportsConsultant(filter: $filter, order: $order, take: $take, skip: $skip) {
    totalCount
    items {
      codeIsin
      encours
      poidsSupport
      valeurLiquidative
      dateCotation
      nbContrats
      supportClasseActif {
        libelleSupport
        classeActif
        sousClasseActif
        societeGestion
        categorieQuantalys
        sri
        esg
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SupportsConsultantListeGQL extends Apollo.Query<SupportsConsultantListeQuery, SupportsConsultantListeQueryVariables> {
    document = SupportsConsultantListeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateContactDocument = gql`
    mutation createContact($input: ContactCreationInput!) {
  createContact(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateContactGQL extends Apollo.Mutation<CreateContactMutation, CreateContactMutationVariables> {
    document = CreateContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckDoublonInvestisseurDocument = gql`
    query checkDoublonInvestisseur($nom: String!, $prenom: String!, $dateNaissance: LocalDate!, $editedInvestisseurId: Long) {
  checkDoublonInvestisseur(
    nom: $nom
    prenom: $prenom
    dateNaissance: $dateNaissance
    editedInvestisseurId: $editedInvestisseurId
  ) {
    ...DoublonResult
  }
}
    ${DoublonResultFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckDoublonInvestisseurGQL extends Apollo.Query<CheckDoublonInvestisseurQuery, CheckDoublonInvestisseurQueryVariables> {
    document = CheckDoublonInvestisseurDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBasicDashBoardCountersDocument = gql`
    query GetBasicDashBoardCounters($contacts: MinotaureInvestisseurFilterInput, $prospects: MinotaureInvestisseurFilterInput, $clients: MinotaureInvestisseurFilterInput, $connaissanceClientToUpdate: MinotaureInvestisseurFilterInput, $mystelliumToActivate: MinotaureInvestisseurFilterInput, $mystelliumInvitationSent: MinotaureInvestisseurFilterInput) {
  contacts: investisseursFromMinotaurePaginated(where: $contacts) {
    totalCount
  }
  prospects: investisseursFromMinotaurePaginated(where: $prospects) {
    totalCount
  }
  clients: investisseursFromMinotaurePaginated(where: $clients) {
    totalCount
  }
  cc_expired: investisseursFromMinotaurePaginated(
    where: $connaissanceClientToUpdate
  ) {
    totalCount
  }
  mystellium_to_activate: investisseursFromMinotaurePaginated(
    where: $mystelliumToActivate
  ) {
    totalCount
  }
  mystellium_invitation_sent: investisseursFromMinotaurePaginated(
    where: $mystelliumInvitationSent
  ) {
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBasicDashBoardCountersGQL extends Apollo.Query<GetBasicDashBoardCountersQuery, GetBasicDashBoardCountersQueryVariables> {
    document = GetBasicDashBoardCountersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEtiquetteIndicateursDocument = gql`
    query getEtiquetteIndicateurs($minotaureOnly: Boolean) {
  etiquetteIndicateurs(minotaureOnly: $minotaureOnly) {
    color
    count
    id
    label
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEtiquetteIndicateursGQL extends Apollo.Query<GetEtiquetteIndicateursQuery, GetEtiquetteIndicateursQueryVariables> {
    document = GetEtiquetteIndicateursDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMinotaureCounterDocument = gql`
    query getMinotaureCounter($where: MinotaureInvestisseurFilterInput) {
  investisseursFromMinotaurePaginated(where: $where) {
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMinotaureCounterGQL extends Apollo.Query<GetMinotaureCounterQuery, GetMinotaureCounterQueryVariables> {
    document = GetMinotaureCounterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseursGetInvestisseursByNamePaginatedDocument = gql`
    query InvestisseursGetInvestisseursByNamePaginated($order: [InvestisseurSortInput!], $skip: Int!, $take: Int!, $where: InvestisseurFilterInput, $searchText: String!) {
  investisseursByNamePaginated(
    order: $order
    skip: $skip
    take: $take
    where: $where
    searchText: $searchText
  ) {
    totalCount
    items {
      code
      id
      dateSuppression
      personnePhysique {
        email {
          adresse
          estAdresseCorrespondance
          id
        }
        telephone {
          numero
          estNumeroCorrespondance
          id
        }
        nom
        prenom
        dateNaissance
        id
        adresse {
          adresse1
          adresse2
          adresse3
          codePostalCode
          paysCode
          paysCodeNavigation {
            libelle
          }
          typeAdresseCode
          villeNom
        }
        relationCouplePersonnePhysique {
          autrePersonnePhysiqueId
        }
      }
      statutCode
      origineContactCode
      avancementConnaissanceClientInvestisseur {
        ...AvancementConnaissanceClientFragment
      }
      etiquettes {
        ...EtiquetteFragment
      }
      engagementBudgetaire {
        dateProchaineEcheanceCredit
        tauxEndettement
        capaciteRemboursementRestanteMensuel
      }
      capaciteEpargne {
        capaciteEpargneMensuelle
      }
      syntheseEpargne {
        disponible
        epargneTotale
      }
      foyerFiscal {
        impotRevenuBrut
        impotRevenuTauxMarginal
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${AvancementConnaissanceClientFragmentFragmentDoc}
${EtiquetteFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseursGetInvestisseursByNamePaginatedGQL extends Apollo.Query<InvestisseursGetInvestisseursByNamePaginatedQuery, InvestisseursGetInvestisseursByNamePaginatedQueryVariables> {
    document = InvestisseursGetInvestisseursByNamePaginatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInvestisseursPhysiqueFiltresPaginatedDocument = gql`
    query GetInvestisseursPhysiqueFiltresPaginated($order: [MinotaureInvestisseurSortInput!], $skip: Int, $take: Int, $where: MinotaureInvestisseurFilterInput, $searchText: String) {
  investisseursByNameWithFilterPaginated(
    order: $order
    skip: $skip
    take: $take
    where: $where
    searchText: $searchText
  ) {
    totalCount
    items {
      code
      id
      dateSuppression
      personnePhysique {
        email {
          adresse
          estAdresseCorrespondance
        }
        telephone {
          numero
          estNumeroCorrespondance
        }
        nom
        prenom
        dateNaissance
        adresse {
          adresse1
          adresse2
          adresse3
          codePostalCode
          paysCode
          paysCodeNavigation {
            libelle
          }
          typeAdresseCode
          villeNom
        }
        relationCouplePersonnePhysique {
          autrePersonnePhysiqueId
        }
      }
      statutCode
      origineContactCode
      recommandeParNom
      avancementConnaissanceClientInvestisseur {
        ...AvancementConnaissanceClientFragment
      }
      etiquettes {
        ...EtiquetteFragment
      }
      foyerFiscal {
        impotRevenuBrut
        impotRevenuTauxMarginal
      }
      investisseurConsultantRelations {
        consultantCode
        consultantId
        nom
        prenom
        typeRelationInvestisseurConsultantCode
      }
      syntheseFinanciere {
        epargneTotaleInvestisseur
        epargneDisponibleInvestisseur
        effortEpargneInvestisseur
        capaciteEpargneMensuelleInvestisseur
        capaciteRemboursementRestanteMensuelInvestisseur
        tauxEndettementInvestisseur
        dateProchaineEcheanceCreditInvestisseur
      }
      myStelliumInvestisseur {
        accountStatus
        invitedAt
        derStatus
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${AvancementConnaissanceClientFragmentFragmentDoc}
${EtiquetteFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInvestisseursPhysiqueFiltresPaginatedGQL extends Apollo.Query<GetInvestisseursPhysiqueFiltresPaginatedQuery, GetInvestisseursPhysiqueFiltresPaginatedQueryVariables> {
    document = GetInvestisseursPhysiqueFiltresPaginatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OperationsForConsultantFilterValuesDocument = gql`
    query OperationsForConsultantFilterValues {
  operationsForConsultantFilterValues {
    natureOperations {
      id
      libelle
    }
    enveloppes {
      code
      libelle
    }
    produits {
      id
      nom
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OperationsForConsultantFilterValuesGQL extends Apollo.Query<OperationsForConsultantFilterValuesQuery, OperationsForConsultantFilterValuesQueryVariables> {
    document = OperationsForConsultantFilterValuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OperationsForConsultantDocument = gql`
    query OperationsForConsultant($skip: Int!, $take: Int!, $filter: OperationsForConsultantFilterInput) {
  operationsForConsultant(skip: $skip, take: $take, filter: $filter) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      statut
      versement
      numeroContrat
      dateModification
      projet {
        id
        nom
        description
      }
      natureOperation {
        libelle
      }
      enveloppe {
        libelle
      }
      produit {
        nom
      }
      operationInvestisseurs {
        investisseur {
          id
          code
          type
          personnePhysique {
            nom
            prenom
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OperationsForConsultantGQL extends Apollo.Query<OperationsForConsultantQuery, OperationsForConsultantQueryVariables> {
    document = OperationsForConsultantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRechercheDocument = gql`
    mutation createRecherche($rechercheInput: CreateRechercheInput!) {
  createRecherche(rechercheInput: $rechercheInput) {
    ...RechercheSauvegardeFragment
  }
}
    ${RechercheSauvegardeFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRechercheGQL extends Apollo.Mutation<CreateRechercheMutation, CreateRechercheMutationVariables> {
    document = CreateRechercheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRechercheDocument = gql`
    mutation deleteRecherche($id: Long!) {
  deleteRecherche(rechercheId: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRechercheGQL extends Apollo.Mutation<DeleteRechercheMutation, DeleteRechercheMutationVariables> {
    document = DeleteRechercheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateExportCsvDocument = gql`
    mutation generateExportCSV($order: [MinotaureInvestisseurSortInput!], $where: MinotaureInvestisseurFilterInput, $searchText: String) {
  generateCsvExport(order: $order, where: $where, searchText: $searchText) {
    consultantCode
    createdDate
    denomination
    documentType
    fileExtension
    fileName
    fileType
    id
    isBlob
    status
    fileNameWithExtension
    fileConnectionInfo {
      expiration
      permissions
      sasUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateExportCsvGQL extends Apollo.Mutation<GenerateExportCsvMutation, GenerateExportCsvMutationVariables> {
    document = GenerateExportCsvDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateConsultantPreferencesDocument = gql`
    mutation UpdateConsultantPreferences($input: ConsultantPreferencesInput!) {
  createOrUpdateConsultantPreferences(input: $input) {
    graphType1
    graphType2
    contratsGraphType1
    contratsGraphType2
    supportsGraphType1
    supportsGraphType2
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateConsultantPreferencesGQL extends Apollo.Mutation<UpdateConsultantPreferencesMutation, UpdateConsultantPreferencesMutationVariables> {
    document = UpdateConsultantPreferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDateModificationFicheDocument = gql`
    mutation updateDateModificationFiche($investisseurId: Long!) {
  updateDateModificationFiche(investisseurId: $investisseurId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDateModificationFicheGQL extends Apollo.Mutation<UpdateDateModificationFicheMutation, UpdateDateModificationFicheMutationVariables> {
    document = UpdateDateModificationFicheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDerStateFromConsultantDataDocument = gql`
    mutation updateDERStateFromConsultantData {
  updateDERStateFromConsultantData
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDerStateFromConsultantDataGQL extends Apollo.Mutation<UpdateDerStateFromConsultantDataMutation, UpdateDerStateFromConsultantDataMutationVariables> {
    document = UpdateDerStateFromConsultantDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDerStateDocument = gql`
    mutation updateDERState($investisseurId: Long!, $trigger: DERStateTransitionTrigger!, $applyAlsoToConjoint: Boolean!, $documentId: String, $referenceDate: DateTime) {
  updateInvestisseurDERState(
    investisseurId: $investisseurId
    trigger: $trigger
    applyAlsoToConjoint: $applyAlsoToConjoint
    documentId: $documentId
    referenceDate: $referenceDate
  ) {
    ...MetadatasConnaissanceClientStateFragment
  }
}
    ${MetadatasConnaissanceClientStateFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDerStateGQL extends Apollo.Mutation<UpdateDerStateMutation, UpdateDerStateMutationVariables> {
    document = UpdateDerStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEtiquettesDocument = gql`
    mutation updateEtiquettes($etiquetteInput: EtiquetteInput!) {
  updateEtiquettes(etiquetteInput: $etiquetteInput) {
    id
    label
    color
    selectedInvestisseurIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEtiquettesGQL extends Apollo.Mutation<UpdateEtiquettesMutation, UpdateEtiquettesMutationVariables> {
    document = UpdateEtiquettesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePieceIdentiteStateDocument = gql`
    mutation updatePieceIdentiteState($investisseurId: Long!, $isCompleted: Boolean!, $documentId: String, $referenceDate: DateTime) {
  updateInvestisseurPieceIdentiteState(
    investisseurId: $investisseurId
    isCompleted: $isCompleted
    documentId: $documentId
    referenceDate: $referenceDate
  ) {
    ...MetadatasConnaissanceClientStateFragment
  }
}
    ${MetadatasConnaissanceClientStateFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePieceIdentiteStateGQL extends Apollo.Mutation<UpdatePieceIdentiteStateMutation, UpdatePieceIdentiteStateMutationVariables> {
    document = UpdatePieceIdentiteStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateQpiStateDocument = gql`
    mutation updateQPIState($investisseurId: Long!, $documentId: String, $trigger: QPIStateTransitionTrigger!, $referenceDate: DateTime) {
  updateInvestisseurQPIState(
    investisseurId: $investisseurId
    documentId: $documentId
    trigger: $trigger
    referenceDate: $referenceDate
  ) {
    ...MetadatasConnaissanceClientStateFragment
  }
}
    ${MetadatasConnaissanceClientStateFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateQpiStateGQL extends Apollo.Mutation<UpdateQpiStateMutation, UpdateQpiStateMutationVariables> {
    document = UpdateQpiStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRechercheDocument = gql`
    mutation updateRecherche($rechercheInput: UpdateRechercheInput!) {
  updateRecherche(rechercheInput: $rechercheInput) {
    ...RechercheSauvegardeFragment
  }
}
    ${RechercheSauvegardeFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRechercheGQL extends Apollo.Mutation<UpdateRechercheMutation, UpdateRechercheMutationVariables> {
    document = UpdateRechercheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRecueilStateDocument = gql`
    mutation updateRecueilState($investisseurId: Long!, $trigger: RecueilStateTransitionTrigger!, $documentId: String, $applyAlsoToConjoint: Boolean!, $referenceDate: DateTime) {
  updateInvestisseurRecueilState(
    investisseurId: $investisseurId
    trigger: $trigger
    documentId: $documentId
    applyAlsoToConjoint: $applyAlsoToConjoint
    referenceDate: $referenceDate
  ) {
    ...MetadatasConnaissanceClientStateFragment
  }
}
    ${MetadatasConnaissanceClientStateFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRecueilStateGQL extends Apollo.Mutation<UpdateRecueilStateMutation, UpdateRecueilStateMutationVariables> {
    document = UpdateRecueilStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSituationPersonnelleStateDocument = gql`
    mutation updateSituationPersonnelleState($investisseurId: Long!, $isCompleted: Boolean!) {
  investisseur: updateClientSituationPersonnelleState(
    investisseurId: $investisseurId
    isCompleted: $isCompleted
  ) {
    ...MetadatasConnaissanceClientStateDetailledFragment
  }
}
    ${MetadatasConnaissanceClientStateDetailledFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSituationPersonnelleStateGQL extends Apollo.Mutation<UpdateSituationPersonnelleStateMutation, UpdateSituationPersonnelleStateMutationVariables> {
    document = UpdateSituationPersonnelleStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSituationPersonnelleWithConjointStateDocument = gql`
    mutation updateSituationPersonnelleWithConjointState($investisseurId: Long!, $conjointId: Long!, $isCompleted: Boolean!) {
  conjoint: updateClientSituationPersonnelleState(
    investisseurId: $conjointId
    isCompleted: $isCompleted
  ) {
    ...MetadatasConnaissanceClientStateDetailledFragment
  }
  investisseur: updateClientSituationPersonnelleState(
    investisseurId: $investisseurId
    isCompleted: $isCompleted
  ) {
    ...MetadatasConnaissanceClientStateDetailledFragment
  }
}
    ${MetadatasConnaissanceClientStateDetailledFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSituationPersonnelleWithConjointStateGQL extends Apollo.Mutation<UpdateSituationPersonnelleWithConjointStateMutation, UpdateSituationPersonnelleWithConjointStateMutationVariables> {
    document = UpdateSituationPersonnelleWithConjointStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetApplicationSettingsDocument = gql`
    query GetApplicationSettings {
  applicationSettings {
    key
    value
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetApplicationSettingsGQL extends Apollo.Query<GetApplicationSettingsQuery, GetApplicationSettingsQueryVariables> {
    document = GetApplicationSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConsultantEtiquettesDocument = gql`
    query consultantEtiquettes($consultantCode: String) {
  consultantEtiquettes(consultantCode: $consultantCode) {
    id
    label
    color
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConsultantEtiquettesGQL extends Apollo.Query<ConsultantEtiquettesQuery, ConsultantEtiquettesQueryVariables> {
    document = ConsultantEtiquettesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConsultantPreferencesDocument = gql`
    query consultantPreferences {
  consultantPreferences {
    graphType1
    graphType2
    contratsGraphType1
    contratsGraphType2
    supportsGraphType1
    supportsGraphType2
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConsultantPreferencesGQL extends Apollo.Query<ConsultantPreferencesQuery, ConsultantPreferencesQueryVariables> {
    document = ConsultantPreferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RechercheForConsultantDocument = gql`
    query rechercheForConsultant($order: [RechercheSauvegardeSortInput!]) {
  rechercheForConsultant(order: $order) {
    ...RechercheSauvegardeFragment
  }
}
    ${RechercheSauvegardeFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RechercheForConsultantGQL extends Apollo.Query<RechercheForConsultantQuery, RechercheForConsultantQueryVariables> {
    document = RechercheForConsultantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateRecueilDocument = gql`
    mutation generateRecueil($recueilMetadataId: Long!, $investisseurPrincipalId: Long!, $avecCoInvestisseur: Boolean!) {
  generateRecueil(
    recueilMetadataId: $recueilMetadataId
    investisseurPrincipalId: $investisseurPrincipalId
    avecCoInvestisseur: $avecCoInvestisseur
  ) {
    createdDate
    denomination
    documentType
    fileExtension
    fileName
    fileType
    id
    isBlob
    isTemporary
    lastModificationDate
    status
    fileConnectionInfo {
      blobFileId
      expiration
      permissions
      sasUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateRecueilGQL extends Apollo.Mutation<GenerateRecueilMutation, GenerateRecueilMutationVariables> {
    document = GenerateRecueilDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRecueilStateDocument = gql`
    query getRecueilState($code: String!) {
  investisseurByCode(code: $code) {
    avancementConnaissanceClientInvestisseur {
      ...AvancementConnaissanceClientFragment
    }
  }
}
    ${AvancementConnaissanceClientFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRecueilStateGQL extends Apollo.Query<GetRecueilStateQuery, GetRecueilStateQueryVariables> {
    document = GetRecueilStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurByCodeDocument = gql`
    query investisseurByCode($code: String!) {
  investisseurByCode(code: $code) {
    ...DetailedInvestisseur
  }
}
    ${DetailedInvestisseurFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurByCodeGQL extends Apollo.Query<InvestisseurByCodeQuery, InvestisseurByCodeQueryVariables> {
    document = InvestisseurByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInvestisseurCodeByIdDocument = gql`
    query getInvestisseurCodeById($id: Long!) {
  investisseurById(id: $id) {
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInvestisseurCodeByIdGQL extends Apollo.Query<GetInvestisseurCodeByIdQuery, GetInvestisseurCodeByIdQueryVariables> {
    document = GetInvestisseurCodeByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurDoublonKeyByIdDocument = gql`
    query InvestisseurDoublonKeyById($id: Long!) {
  investisseurById(id: $id) {
    personnePhysique {
      nom
      prenom
      dateNaissance
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurDoublonKeyByIdGQL extends Apollo.Query<InvestisseurDoublonKeyByIdQuery, InvestisseurDoublonKeyByIdQueryVariables> {
    document = InvestisseurDoublonKeyByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateInvestisseurBilanFinancierDocument = gql`
    mutation UpdateInvestisseurBilanFinancier($bilan: BilanFinancierInput!) {
  updateInvestisseurBilanFinancier(bilanFinancierInput: $bilan) {
    id
    investisseurId
    manuelActif
    manuelPassif
    manuelPrevoyance
    manuelRevenus
    manuelCharges
    computedActif
    computedPassif
    computedPrevoyance
    computedRevenus
    computedCharges
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInvestisseurBilanFinancierGQL extends Apollo.Mutation<UpdateInvestisseurBilanFinancierMutation, UpdateInvestisseurBilanFinancierMutationVariables> {
    document = UpdateInvestisseurBilanFinancierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurBilanFinancierByIdDocument = gql`
    query InvestisseurBilanFinancierById($id: Long!) {
  investisseurById(id: $id) {
    bilanFinancier {
      id
      investisseurId
      manuelActif
      manuelPassif
      manuelPrevoyance
      manuelRevenus
      manuelCharges
      computedActif
      computedPassif
      computedPrevoyance
      computedRevenus
      computedCharges
      effectiveActif
      effectivePassif
      effectivePrevoyance
      effectiveRevenus
      effectiveCharges
      dateProchaineEcheance
      aCreditEnCours
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurBilanFinancierByIdGQL extends Apollo.Query<InvestisseurBilanFinancierByIdQuery, InvestisseurBilanFinancierByIdQueryVariables> {
    document = InvestisseurBilanFinancierByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurRelationDeCoupleByCodeDocument = gql`
    query InvestisseurRelationDeCoupleByCode($code: String!) {
  investisseurByCode(code: $code) {
    __typename
    id
    personnePhysique {
      id
      nom
      prenom
      relationCouplePersonnePhysique {
        autrePersonnePhysique {
          id
          nom
          prenom
          investisseur {
            __typename
            id
            code
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurRelationDeCoupleByCodeGQL extends Apollo.Query<InvestisseurRelationDeCoupleByCodeQuery, InvestisseurRelationDeCoupleByCodeQueryVariables> {
    document = InvestisseurRelationDeCoupleByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurRelationByCodeDocument = gql`
    query InvestisseurRelationByCode($investisseurCode: String!, $hasCoInvestisseur: Boolean! = false, $coInvestisseurCode: String! = "") {
  investisseur: investisseurByCode(code: $investisseurCode) {
    ...relationsFragment
  }
  coInvestisseur: investisseurByCode(code: $coInvestisseurCode) @include(if: $hasCoInvestisseur) {
    ...relationsFragment
  }
}
    ${RelationsFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurRelationByCodeGQL extends Apollo.Query<InvestisseurRelationByCodeQuery, InvestisseurRelationByCodeQueryVariables> {
    document = InvestisseurRelationByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBudgetDocument = gql`
    mutation createBudget($input: BudgetCreationInput!) {
  createBudget(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBudgetGQL extends Apollo.Mutation<CreateBudgetMutation, CreateBudgetMutationVariables> {
    document = CreateBudgetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteBudgetDocument = gql`
    mutation deleteBudget($budgetId: Long!) {
  deleteBudget(budgetId: $budgetId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteBudgetGQL extends Apollo.Mutation<DeleteBudgetMutation, DeleteBudgetMutationVariables> {
    document = DeleteBudgetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBudgetDocument = gql`
    mutation updateBudget($input: BudgetModificationInput!) {
  updateBudget(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBudgetGQL extends Apollo.Mutation<UpdateBudgetMutation, UpdateBudgetMutationVariables> {
    document = UpdateBudgetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetByIdDocument = gql`
    query BudgetById($id: Long!) {
  budget: budgetById(id: $id) {
    ...BudgetDetailFragment
  }
}
    ${BudgetDetailFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetByIdGQL extends Apollo.Query<BudgetByIdQuery, BudgetByIdQueryVariables> {
    document = BudgetByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBudgetByInvestisseurDocument = gql`
    query getBudgetByInvestisseur($code: String!) {
  investisseur: investisseurByCode(code: $code) {
    ...allBudgetDtoInvestisseurs
  }
  typesBudgets: typesBudgets {
    id
    code
    categorie
    sousCategorie
    sousCategorie2
    isRevenu
  }
}
    ${AllBudgetDtoInvestisseursFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBudgetByInvestisseurGQL extends Apollo.Query<GetBudgetByInvestisseurQuery, GetBudgetByInvestisseurQueryVariables> {
    document = GetBudgetByInvestisseurDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CoupleInvestisseurDocument = gql`
    query CoupleInvestisseur($code: String!, $consultantId: Long!) {
  investisseur: investisseurByCode(code: $code) {
    id
    code
    personnePhysique {
      code
      nom
      prenom
      relationCouplePersonnePhysique {
        autrePersonnePhysique {
          id
          code
          nom
          prenom
          investisseur(
            where: {investisseurConsultant: {some: {and: [{actif: {eq: 1}}, {consultantId: {eq: $consultantId}}]}}}
          ) {
            id
            code
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CoupleInvestisseurGQL extends Apollo.Query<CoupleInvestisseurQuery, CoupleInvestisseurQueryVariables> {
    document = CoupleInvestisseurDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TypesBudgetsDocument = gql`
    query TypesBudgets($order: [TypeBudgetSortInput!], $where: TypeBudgetFilterInput) {
  typesBudgets(order: $order, where: $where) {
    categorie
    code
    id
    isRevenu
    sousCategorie
    sousCategorie2
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TypesBudgetsGQL extends Apollo.Query<TypesBudgetsQuery, TypesBudgetsQueryVariables> {
    document = TypesBudgetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchDerDocument = gql`
    mutation fetchDER($consultantCode: String) {
  existingDEROrGenerateIt(consultantCode: $consultantCode) {
    fieldsToComplete {
      type
      message
    }
    isGestionPrivee
    storageFiles {
      consultantCode
      createdDate
      denomination
      documentType
      fileExtension
      fileName
      fileType
      id
      isBlob
      status
      fileNameWithExtension
      fileConnectionInfo {
        expiration
        permissions
        sasUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchDerGQL extends Apollo.Mutation<FetchDerMutation, FetchDerMutationVariables> {
    document = FetchDerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForceDerUpdateDocument = gql`
    mutation forceDERUpdate($investisseurId: Long!, $consultantCode: String) {
  forceDERUpdate(investisseurId: $investisseurId, consultantCode: $consultantCode) {
    fieldsToComplete {
      type
      message
    }
    storageFiles {
      consultantCode
      createdDate
      denomination
      documentType
      fileExtension
      fileName
      fileType
      id
      isBlob
      status
      fileNameWithExtension
      fileConnectionInfo {
        expiration
        permissions
        sasUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForceDerUpdateGQL extends Apollo.Mutation<ForceDerUpdateMutation, ForceDerUpdateMutationVariables> {
    document = ForceDerUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckInvestisseurDocument = gql`
    mutation checkInvestisseur($investisseurIds: [Long!]!) {
  checkInvestisseurs(investisseurIds: $investisseurIds) {
    id
    foyerFiscal {
      id
      imposableImpotFortuneImmo
      imposableImpotRevenu
      impotAnneeRevenus
      totalSalairesAssimiles
      revenusBrutGlobal
      impotAutre
      impotAutreCommentaire
      impotFortuneAnneeRevenus
      impotFortuneImmoCommentaire
      impotFortuneImmoNet
      impotRevenuBrut
      impotRevenuCommentaire
      impotRevenuNet
      impotRevenuTauxMarginal
      impotRevenuTotalCredit
      impotRevenuTotalReduction
      impotTotalAvantCreditsImpot
      csgDeductible
      chargesDeductiblesDuRevenuGlobal
      totalDesPrelevementsSociaux
      isCompleted
      nbParts
      plafondEpargneRetraireNonUtilise
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckInvestisseurGQL extends Apollo.Mutation<CheckInvestisseurMutation, CheckInvestisseurMutationVariables> {
    document = CheckInvestisseurDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFoyerFiscalDataDocument = gql`
    mutation updateFoyerFiscalData($input: FoyerFiscalUpdateDataInput!) {
  updateFoyerFiscalData(investisseurInput: $input) {
    id
    imposableImpotFortuneImmo
    imposableImpotRevenu
    impotAnneeRevenus
    totalSalairesAssimiles
    revenusBrutGlobal
    impotAutre
    impotAutreCommentaire
    impotFortuneAnneeRevenus
    impotFortuneImmoCommentaire
    impotFortuneImmoNet
    impotRevenuBrut
    impotRevenuCommentaire
    impotRevenuNet
    impotRevenuTauxMarginal
    impotRevenuTotalCredit
    impotRevenuTotalReduction
    impotTotalAvantCreditsImpot
    csgDeductible
    chargesDeductiblesDuRevenuGlobal
    totalDesPrelevementsSociaux
    isCompleted
    nbParts
    plafondEpargneRetraireNonUtilise
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFoyerFiscalDataGQL extends Apollo.Mutation<UpdateFoyerFiscalDataMutation, UpdateFoyerFiscalDataMutationVariables> {
    document = UpdateFoyerFiscalDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFoyerFiscalSeparateDataDocument = gql`
    mutation updateFoyerFiscalSeparateData($foyerInvestisseur: FoyerFiscalUpdateDataInput!, $foyerConjoint: FoyerFiscalUpdateDataInput!) {
  conjoint: updateFoyerFiscalData(investisseurInput: $foyerConjoint) {
    id
    imposableImpotFortuneImmo
    imposableImpotRevenu
    impotAnneeRevenus
    totalSalairesAssimiles
    revenusBrutGlobal
    impotAutre
    impotAutreCommentaire
    impotFortuneAnneeRevenus
    impotFortuneImmoCommentaire
    impotFortuneImmoNet
    impotRevenuBrut
    impotRevenuCommentaire
    impotRevenuNet
    impotRevenuTauxMarginal
    impotRevenuTotalCredit
    impotRevenuTotalReduction
    impotTotalAvantCreditsImpot
    csgDeductible
    chargesDeductiblesDuRevenuGlobal
    totalDesPrelevementsSociaux
    isCompleted
    nbParts
    plafondEpargneRetraireNonUtilise
  }
  investisseur: updateFoyerFiscalData(investisseurInput: $foyerInvestisseur) {
    id
    imposableImpotFortuneImmo
    imposableImpotRevenu
    impotAnneeRevenus
    totalSalairesAssimiles
    revenusBrutGlobal
    impotAutre
    impotAutreCommentaire
    impotFortuneAnneeRevenus
    impotFortuneImmoCommentaire
    impotFortuneImmoNet
    impotRevenuBrut
    impotRevenuCommentaire
    impotRevenuNet
    impotRevenuTauxMarginal
    impotRevenuTotalCredit
    impotRevenuTotalReduction
    impotTotalAvantCreditsImpot
    csgDeductible
    chargesDeductiblesDuRevenuGlobal
    totalDesPrelevementsSociaux
    isCompleted
    nbParts
    plafondEpargneRetraireNonUtilise
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFoyerFiscalSeparateDataGQL extends Apollo.Mutation<UpdateFoyerFiscalSeparateDataMutation, UpdateFoyerFiscalSeparateDataMutationVariables> {
    document = UpdateFoyerFiscalSeparateDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurFoyerFiscalDocument = gql`
    query investisseurFoyerFiscal($code: String!) {
  investisseur: investisseurByCode(code: $code) {
    id
    code
    foyerFiscal {
      id
      imposableImpotFortuneImmo
      imposableImpotRevenu
      impotAnneeRevenus
      totalSalairesAssimiles
      revenusBrutGlobal
      impotAutre
      impotAutreCommentaire
      impotFortuneAnneeRevenus
      impotFortuneImmoCommentaire
      impotFortuneImmoNet
      impotRevenuBrut
      impotRevenuCommentaire
      impotRevenuNet
      impotRevenuTauxMarginal
      impotRevenuTotalCredit
      impotRevenuTotalReduction
      impotTotalAvantCreditsImpot
      csgDeductible
      chargesDeductiblesDuRevenuGlobal
      totalDesPrelevementsSociaux
      isCompleted
      nbParts
      plafondEpargneRetraireNonUtilise
    }
    personnePhysique {
      nom
      prenom
      relationCouplePersonnePhysique {
        typeRelationCoupleCode
        autrePersonnePhysique {
          nom
          prenom
          investisseur {
            id
            code
            foyerFiscal {
              id
              imposableImpotFortuneImmo
              imposableImpotRevenu
              impotAnneeRevenus
              totalSalairesAssimiles
              revenusBrutGlobal
              impotAutre
              impotAutreCommentaire
              impotFortuneAnneeRevenus
              impotFortuneImmoCommentaire
              impotFortuneImmoNet
              impotRevenuBrut
              impotRevenuCommentaire
              impotRevenuNet
              impotRevenuTauxMarginal
              impotRevenuTotalCredit
              impotRevenuTotalReduction
              impotTotalAvantCreditsImpot
              csgDeductible
              chargesDeductiblesDuRevenuGlobal
              totalDesPrelevementsSociaux
              isCompleted
              nbParts
              plafondEpargneRetraireNonUtilise
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurFoyerFiscalGQL extends Apollo.Query<InvestisseurFoyerFiscalQuery, InvestisseurFoyerFiscalQueryVariables> {
    document = InvestisseurFoyerFiscalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateObjectifStepDocument = gql`
    mutation updateObjectifStep($input: UpdateObjectifStepInput!) {
  updateObjectifStep(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateObjectifStepGQL extends Apollo.Mutation<UpdateObjectifStepMutation, UpdateObjectifStepMutationVariables> {
    document = UpdateObjectifStepDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const KycObjectifInvestisseurDocument = gql`
    query kycObjectifInvestisseur($code: String!) {
  investisseur: investisseurByCode(code: $code) {
    ...ObjectifStepDetailsFragment
  }
}
    ${ObjectifStepDetailsFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class KycObjectifInvestisseurGQL extends Apollo.Query<KycObjectifInvestisseurQuery, KycObjectifInvestisseurQueryVariables> {
    document = KycObjectifInvestisseurDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ObjectifReferenceListDocument = gql`
    query objectifReferenceList {
  objectifReferentiels {
    ...objectifRefFragment
  }
}
    ${ObjectifRefFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ObjectifReferenceListGQL extends Apollo.Query<ObjectifReferenceListQuery, ObjectifReferenceListQueryVariables> {
    document = ObjectifReferenceListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrUpdatePatrimoineDocument = gql`
    mutation CreateOrUpdatePatrimoine($patrimoineInput: PatrimoineInput!) {
  createOrUpdatePatrimoine(patrimoineInput: $patrimoineInput) {
    id
    investisseurId
    patrimoineId
    patrimoine {
      categorieCode
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrUpdatePatrimoineGQL extends Apollo.Mutation<CreateOrUpdatePatrimoineMutation, CreateOrUpdatePatrimoineMutationVariables> {
    document = CreateOrUpdatePatrimoineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePatrimoineDocument = gql`
    mutation DeletePatrimoine($id: Long!) {
  deletePatrimoine(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePatrimoineGQL extends Apollo.Mutation<DeletePatrimoineMutation, DeletePatrimoineMutationVariables> {
    document = DeletePatrimoineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageInvestisseurRetraiteDocument = gql`
    mutation ManageInvestisseurRetraite($investisseurId: Long!) {
  manageInvestisseurRetraite(investisseurId: $investisseurId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageInvestisseurRetraiteGQL extends Apollo.Mutation<ManageInvestisseurRetraiteMutation, ManageInvestisseurRetraiteMutationVariables> {
    document = ManageInvestisseurRetraiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePatrimoineContratDocument = gql`
    mutation UpdatePatrimoineContrat($patrimoineInput: PatrimoineInput!) {
  updatePatrimoineContrat(patrimoineInput: $patrimoineInput) {
    id
    investisseurId
    patrimoineId
    patrimoine {
      categorieCode
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePatrimoineContratGQL extends Apollo.Mutation<UpdatePatrimoineContratMutation, UpdatePatrimoineContratMutationVariables> {
    document = UpdatePatrimoineContratDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatrimoineBudgetDocument = gql`
    query GetPatrimoineBudget($id: Long!) {
  budgetById(id: $id) {
    commentaire
    creationDate
    designation
    editionDate
    id
    montantAnnuel
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPatrimoineBudgetGQL extends Apollo.Query<GetPatrimoineBudgetQuery, GetPatrimoineBudgetQueryVariables> {
    document = GetPatrimoineBudgetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInvestisseurBudgetDocument = gql`
    query GetInvestisseurBudget($code: String!) {
  investisseurByCode(code: $code) {
    budgetInvestisseurs {
      budgetId
      id
      investisseurId
      tauxDetention
      investisseur {
        personnePhysique {
          nom
          prenom
        }
      }
      budget {
        commentaire
        designation
        id
        montantAnnuel
        typeBudgetId
        patrimoineBudget {
          budgetId
          creationDate
          editionDate
          id
          patrimoineId
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInvestisseurBudgetGQL extends Apollo.Query<GetInvestisseurBudgetQuery, GetInvestisseurBudgetQueryVariables> {
    document = GetInvestisseurBudgetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInvestisseurPatrimoineByIdDocument = gql`
    query GetInvestisseurPatrimoineById($id: Long!) {
  investisseurPatrimoineById(id: $id) {
    creationDate
    editionDate
    id
    investisseurId
    patrimoineId
    detentionPP
    detentionNP
    detentionUS
    typeDetenteur
    quotePartADI
    patrimoine {
      categorieCode
      creationDate
      designation
      editionDate
      id
      investisseurPatrimoines {
        creationDate
        editionDate
        id
        investisseurId
        patrimoineId
        detentionPP
        detentionNP
        detentionUS
        typeDetenteur
        quotePartADI
        investisseur {
          personnePhysique {
            nom
            prenom
          }
        }
      }
      commentaires {
        text
      }
      patrimoineActif {
        creationDate
        dateAcquisition
        editionDate
        epargneSecurise
        id
        loyerBrutsAnnuel
        sciImposableA
        modeDetention
        patrimoineId
        prixAcquisition
        regimeFiscal
        taxeFonciere
        type
        typeLocation
        typeSCPI
        valeurEstimee
        dateDebutDemembrement
        dateFinDemembrement
        typeDePropriete
        valorisationDuDroitDemembre
        actifFinancier {
          dateDisponibilite
          dateOuverture
          disponible
          epargneDisponible
          epargneNonDisponible
          epargnePrecaution
          id
          montantDisponible
          versementProgrammes
        }
        patrimoinesPassifs {
          capitalRestantDu
          creationDate
          dateDebut
          dateFin
          designation
          dureePremierPalier
          dureeRestante
          dureeSecondPalier
          dureeTroisiemePalier
          editionDate
          id
          mensualite
          mensualitePremierPalier
          mensualiteSecondPalier
          mensualiteTroisiemePalier
          montant
          patrimoineActifId
          patrimoineId
          tauxNominal
          type
        }
        patrimoine {
          categorieCode
          creationDate
          designation
          editionDate
          id
        }
      }
      patrimoinePassif {
        capitalRestantDu
        creationDate
        dateDebut
        dateFin
        designation
        dureePremierPalier
        dureeRestante
        dureeSecondPalier
        dureeTroisiemePalier
        editionDate
        id
        mensualite
        mensualitePremierPalier
        mensualiteSecondPalier
        mensualiteTroisiemePalier
        montant
        patrimoineId
        patrimoineActifId
        tauxNominal
        type
      }
      patrimoinePrevoyance {
        benefiaires
        capitalAssure
        creationDate
        editionDate
        id
        patrimoineId
        type
      }
      patrimoineBudgets {
        budgetId
        creationDate
        editionDate
        id
        patrimoineId
        budget {
          id
          designation
          montantAnnuel
          commentaire
          typeBudgetId
          budgetInvestisseurs {
            investisseurId
            investisseur {
              personnePhysique {
                nom
                prenom
              }
            }
          }
        }
      }
      patrimoineCategorie {
        categoryLibelle
        code
        patrimoineCategory
        subCategory
        subCategory2
        subCategory2Libelle
        subCategoryLibelle
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInvestisseurPatrimoineByIdGQL extends Apollo.Query<GetInvestisseurPatrimoineByIdQuery, GetInvestisseurPatrimoineByIdQueryVariables> {
    document = GetInvestisseurPatrimoineByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurPatrimoinesByCodeDocument = gql`
    query InvestisseurPatrimoinesByCode($code: String!) {
  investisseurByCode(code: $code) {
    syntheseEpargne {
      disponible
      nonDisponible
      disponibleDePrecaution
      epargneTotale
    }
    investisseurPatrimoines {
      id
      investisseurId
      detentionPP
      detentionNP
      detentionUS
      typeDetenteur
      quotePartADI
      dateNaissance
      patrimoine {
        categorieCode
        designation
        id
        patrimoineCategorie {
          categoryLibelle
          code
          patrimoineCategory
          subCategory
          subCategory2
          subCategory2Libelle
          subCategoryLibelle
        }
        investisseurPatrimoines {
          id
          detentionPP
          detentionNP
          detentionUS
          typeDetenteur
          quotePartADI
          investisseurId
          dateNaissance
          investisseur {
            personnePhysique {
              nom
              prenom
              dateNaissance
            }
          }
        }
        commentaires {
          text
        }
        patrimoineActif {
          modeDetention
          prixAcquisition
          type
          typeLocation
          typeSCPI
          valeurEstimee
          epargneSecurise
          loyerBrutsAnnuel
          dateAcquisition
          taxeFonciere
          regimeFiscal
          numeroContrat
          contratAgregationId
          taxeHabitation
          chargesImmo
          revenuAnnuel
          dateDebutDemembrement
          dateFinDemembrement
          typeDePropriete
          sciImposableA
          valorisationDuDroitDemembre
          actifFinancier {
            epargneDisponible
            epargneNonDisponible
            dateOuverture
            dateDisponibilite
            epargnePrecaution
            disponible
            id
            montantDisponible
            versementProgrammes
          }
          patrimoinesPassifs {
            id
            patrimoineId
            type
            capitalRestantDu
            montant
            patrimoine {
              categorieCode
              designation
            }
          }
        }
        patrimoinePassif {
          designation
          id
          montant
          type
          tauxNominal
          dateDebut
          dateFin
          dureeRestante
          mensualite
          capitalRestantDu
          dureePremierPalier
          mensualitePremierPalier
          dureeSecondPalier
          mensualiteSecondPalier
          dureeTroisiemePalier
          mensualiteTroisiemePalier
          patrimoineActif {
            id
            patrimoineId
            type
            valeurEstimee
            patrimoine {
              categorieCode
              designation
            }
          }
        }
        patrimoinePrevoyance {
          benefiaires
          capitalAssure
          id
          type
        }
        patrimoineBudgets {
          budgetId
          creationDate
          editionDate
          id
          patrimoineId
          budget {
            id
            designation
            montantAnnuel
            commentaire
            typeBudgetId
            typeBudget {
              id
              code
            }
            budgetInvestisseurs {
              investisseurId
              investisseur {
                personnePhysique {
                  nom
                  prenom
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurPatrimoinesByCodeGQL extends Apollo.Query<InvestisseurPatrimoinesByCodeQuery, InvestisseurPatrimoinesByCodeQueryVariables> {
    document = InvestisseurPatrimoinesByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatrimoineCaregorieReferenceDocument = gql`
    query GetPatrimoineCaregorieReference {
  patrimoineCategoriePerefences {
    categoryLibelle
    code
    patrimoineCategory
    subCategory
    subCategory2
    subCategory2Libelle
    subCategoryLibelle
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPatrimoineCaregorieReferenceGQL extends Apollo.Query<GetPatrimoineCaregorieReferenceQuery, GetPatrimoineCaregorieReferenceQueryVariables> {
    document = GetPatrimoineCaregorieReferenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDocumentByIdDocument = gql`
    mutation DeleteDocumentById($fileId: String!) {
  deleteDocument(documentId: $fileId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDocumentByIdGQL extends Apollo.Mutation<DeleteDocumentByIdMutation, DeleteDocumentByIdMutationVariables> {
    document = DeleteDocumentByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalculateScoreCapacitePerteDocument = gql`
    mutation CalculateScoreCapacitePerte($investisseurPrincipalId: Long!) {
  calculateScoreCapacitePerte(investisseurPrincipalId: $investisseurPrincipalId) {
    epargneBancaire
    epargneFinanciere
    epargneFinanciereSecurise
    epargneFinanciereNbActifsIncomplets
    epargneRetraiteSalariale
    epargneRetraiteSalarialeDisponible
    epargneRetraiteSalarialeDisponibleSecurise
    epargneRetraiteSalarialeNbActifsIncomplets
    diversification
    revenus
    chargesFixes
    depensesCourantes
    impots
    capaciteEpargne
    score
    isValid
    isMinor
    missingFields
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalculateScoreCapacitePerteGQL extends Apollo.Mutation<CalculateScoreCapacitePerteMutation, CalculateScoreCapacitePerteMutationVariables> {
    document = CalculateScoreCapacitePerteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalculateScoreEsgDocument = gql`
    mutation CalculateScoreESG($formInput: QPIFormInput!) {
  calculateScoreESG(formInput: $formInput) {
    id
    resultatSensibiliteExtraFinanciere
    reponsesSensibiliteExtraFinanciereJson
    investisseurId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalculateScoreEsgGQL extends Apollo.Mutation<CalculateScoreEsgMutation, CalculateScoreEsgMutationVariables> {
    document = CalculateScoreEsgDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateQpiDocument = gql`
    mutation GenerateQPI($investisseurPrincipalId: Long!) {
  generateQPI(investisseurPrincipalId: $investisseurPrincipalId) {
    createdDate
    denomination
    documentType
    fileExtension
    fileName
    fileType
    id
    isBlob
    isTemporary
    lastModificationDate
    status
    fileConnectionInfo {
      blobFileId
      expiration
      permissions
      sasUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateQpiGQL extends Apollo.Mutation<GenerateQpiMutation, GenerateQpiMutationVariables> {
    document = GenerateQpiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConnaissanceExperienceReferentielDocument = gql`
    query GetConnaissanceExperienceReferentiel($investisseurId: Long!) {
  connaissanceExperienceReferentiel {
    produitsEpargne {
      produit
      question
      libelle
      optionsVerification {
        code
        libelle
      }
    }
    supportsInvestissement {
      support
      question
      libelle
      optionsVerification {
        code
        libelle
      }
    }
    affirmationsPedagogie {
      affirmation
      libelle
    }
    modesGestion {
      code
      libelle
      afficheNombreOperations
    }
    nombresOperations {
      code
      libelle
    }
    reactionsPerte {
      code
      libelle
    }
  }
  produitsEpargneDetenusRecueil(investisseurId: $investisseurId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConnaissanceExperienceReferentielGQL extends Apollo.Query<GetConnaissanceExperienceReferentielQuery, GetConnaissanceExperienceReferentielQueryVariables> {
    document = GetConnaissanceExperienceReferentielDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetQpiResultsByInvestisseurIdDocument = gql`
    query GetQpiResultsByInvestisseurId($investisseurId: Long!) {
  qpiResultsByInvestisseurId(investisseurId: $investisseurId) {
    id
    resultatConnaissance
    resultatProfilDeRisque
    resultatToleranceAuRisque
    resultatCapacitePerte
    resultatSensibiliteExtraFinanciere
    versionProfil
    versionProfilObsolete
    isVersionProfilCourante
    reponsesProfil {
      connaissanceExperience {
        ...ConnaissanceExperienceReponsesFields
      }
      toleranceRisque {
        ...ToleranceRisqueReponsesFields
      }
    }
    reponsesSensibiliteExtraFinanciereJson
    capaciteSupportPertesDetail {
      score
      isValid
      isMinor
    }
    investisseurId
    isImportedFromAriane
  }
}
    ${ConnaissanceExperienceReponsesFieldsFragmentDoc}
${ToleranceRisqueReponsesFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetQpiResultsByInvestisseurIdGQL extends Apollo.Query<GetQpiResultsByInvestisseurIdQuery, GetQpiResultsByInvestisseurIdQueryVariables> {
    document = GetQpiResultsByInvestisseurIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetToleranceRisqueReferentielDocument = gql`
    query GetToleranceRisqueReferentiel {
  toleranceRisqueReferentiel {
    questions {
      code
      intitule
      options {
        code
        libelle
        profil
        scenario {
          titre
          gainPourcent
          baissePourcent
        }
      }
    }
    intitulesQ4 {
      profil
      intitule
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetToleranceRisqueReferentielGQL extends Apollo.Query<GetToleranceRisqueReferentielQuery, GetToleranceRisqueReferentielQueryVariables> {
    document = GetToleranceRisqueReferentielDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InitInvestisseurQpiDocument = gql`
    mutation InitInvestisseurQpi($investisseurId: Long!) {
  initInvestisseurQpi(investisseurId: $investisseurId) {
    id
    resultatConnaissance
    resultatProfilDeRisque
    resultatToleranceAuRisque
    resultatCapacitePerte
    resultatSensibiliteExtraFinanciere
    versionProfil
    versionProfilObsolete
    isVersionProfilCourante
    reponsesProfil {
      connaissanceExperience {
        ...ConnaissanceExperienceReponsesFields
      }
      toleranceRisque {
        ...ToleranceRisqueReponsesFields
      }
    }
    reponsesSensibiliteExtraFinanciereJson
    capaciteSupportPertesDetail {
      score
      isValid
      isMinor
    }
    investisseurId
    isImportedFromAriane
  }
}
    ${ConnaissanceExperienceReponsesFieldsFragmentDoc}
${ToleranceRisqueReponsesFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InitInvestisseurQpiGQL extends Apollo.Mutation<InitInvestisseurQpiMutation, InitInvestisseurQpiMutationVariables> {
    document = InitInvestisseurQpiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestartInvestisseurQpiDocument = gql`
    mutation RestartInvestisseurQPI($investisseurPrincipalId: Long!) {
  restartInvestisseurQPI(investisseurPrincipalId: $investisseurPrincipalId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestartInvestisseurQpiGQL extends Apollo.Mutation<RestartInvestisseurQpiMutation, RestartInvestisseurQpiMutationVariables> {
    document = RestartInvestisseurQpiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveConnaissanceExperienceDocument = gql`
    mutation SaveConnaissanceExperience($input: ConnaissanceExperienceInput!) {
  saveConnaissanceExperience(input: $input) {
    id
    investisseurId
    versionProfil
    resultatConnaissance
    reponsesProfil {
      connaissanceExperience {
        ...ConnaissanceExperienceReponsesFields
      }
    }
  }
}
    ${ConnaissanceExperienceReponsesFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveConnaissanceExperienceGQL extends Apollo.Mutation<SaveConnaissanceExperienceMutation, SaveConnaissanceExperienceMutationVariables> {
    document = SaveConnaissanceExperienceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveToleranceRisqueDocument = gql`
    mutation SaveToleranceRisque($input: ToleranceRisqueInput!) {
  saveToleranceRisque(input: $input) {
    id
    investisseurId
    versionProfil
    resultatToleranceAuRisque
    resultatProfilDeRisque
    reponsesProfil {
      toleranceRisque {
        ...ToleranceRisqueReponsesFields
      }
    }
  }
}
    ${ToleranceRisqueReponsesFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveToleranceRisqueGQL extends Apollo.Mutation<SaveToleranceRisqueMutation, SaveToleranceRisqueMutationVariables> {
    document = SaveToleranceRisqueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SynchroniserSelectionAutoRecueilDocument = gql`
    mutation SynchroniserSelectionAutoRecueil($investisseurId: Long!) {
  synchroniserSelectionAutoRecueil(investisseurId: $investisseurId) {
    produitsAjoutes
    isComplete
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SynchroniserSelectionAutoRecueilGQL extends Apollo.Mutation<SynchroniserSelectionAutoRecueilMutation, SynchroniserSelectionAutoRecueilMutationVariables> {
    document = SynchroniserSelectionAutoRecueilDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnsureConnaissanceClientDataCoherenceDocument = gql`
    mutation EnsureConnaissanceClientDataCoherence($investisseurId: Long!) {
  ensureConnaissanceClientDataCoherence(investisseurId: $investisseurId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnsureConnaissanceClientDataCoherenceGQL extends Apollo.Mutation<EnsureConnaissanceClientDataCoherenceMutation, EnsureConnaissanceClientDataCoherenceMutationVariables> {
    document = EnsureConnaissanceClientDataCoherenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurNameByIdDocument = gql`
    query InvestisseurNameById($id: Long!) {
  investisseurById(id: $id) {
    personnePhysique {
      nom
      prenom
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurNameByIdGQL extends Apollo.Query<InvestisseurNameByIdQuery, InvestisseurNameByIdQueryVariables> {
    document = InvestisseurNameByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurPersonnePhysiqueIdByInvestisseurCodeDocument = gql`
    query investisseurPersonnePhysiqueIdByInvestisseurCode($code: String!) {
  investisseurByCode(code: $code) {
    personnePhysique {
      id
      email {
        id
      }
      telephone {
        id
      }
      adresse {
        id
        typeAdresseCode
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurPersonnePhysiqueIdByInvestisseurCodeGQL extends Apollo.Query<InvestisseurPersonnePhysiqueIdByInvestisseurCodeQuery, InvestisseurPersonnePhysiqueIdByInvestisseurCodeQueryVariables> {
    document = InvestisseurPersonnePhysiqueIdByInvestisseurCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RelationPersonnePhysiqueIdByInvestisseurIdDocument = gql`
    query relationPersonnePhysiqueIdByInvestisseurId($id: Long!) {
  investisseurById(id: $id) {
    personnePhysique {
      id
      email {
        id
      }
      telephone {
        id
      }
      adresse {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RelationPersonnePhysiqueIdByInvestisseurIdGQL extends Apollo.Query<RelationPersonnePhysiqueIdByInvestisseurIdQuery, RelationPersonnePhysiqueIdByInvestisseurIdQueryVariables> {
    document = RelationPersonnePhysiqueIdByInvestisseurIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddRelationCoupleDocument = gql`
    mutation addRelationCouple($input: AddRelationCoupleInput!) {
  addRelationCoupleAndUpdateConnaissanceClient(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddRelationCoupleGQL extends Apollo.Mutation<AddRelationCoupleMutation, AddRelationCoupleMutationVariables> {
    document = AddRelationCoupleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMinotaureInvestisseurDocument = gql`
    mutation createMinotaureInvestisseur($investisseurId: Long!) {
  createMinotaureInvestisseur(investisseurId: $investisseurId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMinotaureInvestisseurGQL extends Apollo.Mutation<CreateMinotaureInvestisseurMutation, CreateMinotaureInvestisseurMutationVariables> {
    document = CreateMinotaureInvestisseurDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRelationAutreDocument = gql`
    mutation deleteRelationAutre($input: DeleteRelationInput!) {
  deleteRelationAutre(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRelationAutreGQL extends Apollo.Mutation<DeleteRelationAutreMutation, DeleteRelationAutreMutationVariables> {
    document = DeleteRelationAutreDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRelationCoupleDocument = gql`
    mutation deleteRelationCouple($input: DeleteRelationCoupleInput!) {
  deleteRelationCoupleAndUpdateConnaissanceClient(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRelationCoupleGQL extends Apollo.Mutation<DeleteRelationCoupleMutation, DeleteRelationCoupleMutationVariables> {
    document = DeleteRelationCoupleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRelationFamilleDocument = gql`
    mutation deleteRelationFamille($input: DeleteRelationInput!) {
  deleteRelationFamille(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRelationFamilleGQL extends Apollo.Mutation<DeleteRelationFamilleMutation, DeleteRelationFamilleMutationVariables> {
    document = DeleteRelationFamilleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSituationPersonnelleMinotaureDocument = gql`
    mutation updateSituationPersonnelleMinotaure($input: UpdateSituationPersonnelleInput!) {
  updateSituationPersonnelle(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSituationPersonnelleMinotaureGQL extends Apollo.Mutation<UpdateSituationPersonnelleMinotaureMutation, UpdateSituationPersonnelleMinotaureMutationVariables> {
    document = UpdateSituationPersonnelleMinotaureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertInvestisseurRelationAutreDocument = gql`
    mutation upsertInvestisseurRelationAutre($input: InvestisseurRelationAutreInput!) {
  upsertInvestisseurRelationAutre(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertInvestisseurRelationAutreGQL extends Apollo.Mutation<UpsertInvestisseurRelationAutreMutation, UpsertInvestisseurRelationAutreMutationVariables> {
    document = UpsertInvestisseurRelationAutreDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertInvestisseurRelationFamilleDocument = gql`
    mutation upsertInvestisseurRelationFamille($input: InvestisseurRelationFamilleInput!) {
  upsertInvestisseurRelationFamille(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertInvestisseurRelationFamilleGQL extends Apollo.Mutation<UpsertInvestisseurRelationFamilleMutation, UpsertInvestisseurRelationFamilleMutationVariables> {
    document = UpsertInvestisseurRelationFamilleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurByCodeNewRelationDocument = gql`
    query investisseurByCodeNewRelation($code: String!) {
  investisseurByCode(code: $code) {
    code
    id
    statutCode
    personnePhysique {
      civiliteCode
      id
      dateNaissance
      deuxiemePrenom
      nom
      nomNaissance
      prenom
      troisiemePrenom
      villeNaissanceNom
      email {
        adresse
        estAdresseCorrespondance
        id
        noteId
        typeEmailCode
      }
      telephone {
        estNumeroCorrespondance
        id
        noteId
        numero
        prefixe
        typeTelephoneCode
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurByCodeNewRelationGQL extends Apollo.Query<InvestisseurByCodeNewRelationQuery, InvestisseurByCodeNewRelationQueryVariables> {
    document = InvestisseurByCodeNewRelationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurByCodeSituationPersonnelleDocument = gql`
    query investisseurByCodeSituationPersonnelle($code: String!) {
  investisseurByCode(code: $code) {
    code
    id
    statutCode
    origineContactCode
    origineSaisie
    recommandeParId
    dateConnaissance
    recommandeParNom
    note {
      note1
    }
    recommandePar {
      personnePhysique {
        nom
        prenom
        id
      }
    }
    investisseurConsultant {
      consultantId
      typeRelationInvestisseurConsultantCode
      actif
      consultant {
        personnePhysique {
          nom
          prenom
          creationDate
        }
      }
    }
    personnePhysique {
      civiliteCode
      id
      codePaysNaissance
      codePaysNationalite
      codePaysNationaliteSecondaire
      dateNaissance
      deuxiemePrenom
      nom
      nomNaissance
      prenom
      troisiemePrenom
      typeMesureProtectionCode
      mesureProtectionDate
      villeNaissanceNom
      codePostaleNaissance
      relationAutrePersonnePhysique {
        id
        autrePersonnePhysiqueId
        typeRelationAutreCode
        typeRelationAutre
        autrePersonnePhysique {
          civiliteCode
          id
          nom
          nomNaissance
          prenom
          dateNaissance
          investisseur {
            code
          }
          email {
            adresse
            estAdresseCorrespondance
            id
            noteId
            typeEmailCode
          }
          telephone {
            estNumeroCorrespondance
            id
            noteId
            numero
            prefixe
            typeTelephoneCode
          }
          adresse {
            adresse1
            adresse2
            adresse3
            codePostalCode
            complement
            id
            modeLogement
            noteId
            paysCode
            typeAdresseCode
            villeNom
            note {
              note1
            }
          }
        }
      }
      relationAutrePersonnePhysiqueUnaccesible {
        typeRelationCode
        nom
        prenom
        typeRelationLibelle
      }
      disposition {
        autresDispositions
        beneficiaire
        dateDonation
        forme
        montant
        objet
        demembrement
        personnePhysiqueId
        note {
          note1
        }
        donationDernierVivant
      }
      email {
        adresse
        estAdresseCorrespondance
        id
        noteId
        typeEmailCode
      }
      etatCivil {
        personnePhysiqueId
        codePaysResidenceStableCouple
        dateChangementSituation
        dateContratUnion
        regimePacsIndivision
        typeAvantageMatrimonialCode
        typeRegimeSituationEtatCivilCode
        typeSituationEtatCivilCode
        lieuContratUnion
        foyerFiscalIdentique
        nombreEnfantACharge
        note {
          note1
        }
      }
      reglementaire {
        personnePhysiqueId
        codePaysFactaResidenceFiscale
        codePaysPpe
        creationDate
        factaStatut
        factaTinCode
        nifCode
        ppeAnciennete
        ppeStatut
        typePpeMotifCode
        typePpeRelationCode
      }
      relationCouplePersonnePhysique {
        autrePersonnePhysiqueId
        typeRelationCoupleCode
        autrePersonnePhysique {
          id
          investisseur {
            id
            code
            foyerFiscal {
              id
              imposableImpotFortuneImmo
              imposableImpotRevenu
              impotAnneeRevenus
              totalSalairesAssimiles
              revenusBrutGlobal
              impotAutre
              impotAutreCommentaire
              impotFortuneAnneeRevenus
              impotFortuneImmoCommentaire
              impotFortuneImmoNet
              impotRevenuBrut
              impotRevenuCommentaire
              impotRevenuNet
              impotRevenuTauxMarginal
              impotRevenuTotalCredit
              impotRevenuTotalReduction
              impotTotalAvantCreditsImpot
              csgDeductible
              chargesDeductiblesDuRevenuGlobal
              totalDesPrelevementsSociaux
              isCompleted
              nbParts
              plafondEpargneRetraireNonUtilise
            }
            objectifDefinis {
              objectif {
                categorieCode
                code
                libelle
              }
              priorite
              horizon
              objectifReferenceCode
              commentaire
            }
            capaciteFinanciere {
              commentaire
              epargnePrecautionCible
              effortEpargne
              levierType
            }
            engagementBudgetaire {
              mensualiteCreditTotale
              tauxEndettement
              capaciteRemboursementRestanteMensuel
              soldeBudgetMensuel
            }
            capaciteEpargne {
              capaciteEpargneMensuelle
            }
          }
          disposition {
            autresDispositions
            beneficiaire
            dateDonation
            forme
            montant
            objet
            demembrement
            personnePhysiqueId
            note {
              note1
            }
            donationDernierVivant
          }
          testament {
            personnePhysiqueId
            testamentRedige
            note {
              note1
            }
          }
        }
        note {
          note1
        }
      }
      relationCouplePersonnePhysiqueUnaccesible {
        typeRelationCode
        nom
        prenom
        typeRelationLibelle
      }
      relationFamillePersonnePhysique {
        autrePersonnePhysiqueId
        enfantAdopte
        gardeAlternee
        typeAdoptionCode
        typeRelationFamilleCode
        niveauEtudeCode
        autoriteParentale
        estTypeRelation
        dateFinChargeFiscale
        note {
          note1
        }
        autrePersonnePhysique {
          civiliteCode
          id
          dateNaissance
          deuxiemePrenom
          nom
          nomNaissance
          prenom
          troisiemePrenom
          investisseur {
            code
          }
          email {
            adresse
            estAdresseCorrespondance
            id
            noteId
            typeEmailCode
          }
          telephone {
            estNumeroCorrespondance
            id
            noteId
            numero
            prefixe
            typeTelephoneCode
          }
        }
        enfantACharge
      }
      relationFamillePersonnePhysiqueUnaccesible {
        typeRelationCode
        nom
        prenom
        typeRelationLibelle
      }
      situationProfessionnelle {
        personnePhysiqueId
        anciennete
        categorieSocioProfessionnelleCode
        nomSociete
        profession
        origineRevenus
        note {
          note1
        }
        categorieSocioProfessionnelleCodeAtlas
        categorieSocioProfessionnelleCodeAtlasNavigation {
          parent
        }
        typeStatutProfessionnelCode
        typeSituationProfessionnelleCode
        secteurActiviteCode
        regimeActiviteCode
        dateDepartRetraite
      }
      telephone {
        estNumeroCorrespondance
        id
        noteId
        numero
        prefixe
        typeTelephoneCode
      }
      adresse {
        adresse1
        adresse2
        adresse3
        codePostalCode
        complement
        id
        modeLogement
        noteId
        paysCode
        typeAdresseCode
        villeNom
        note {
          note1
        }
      }
      testament {
        personnePhysiqueId
        testamentRedige
        note {
          note1
        }
      }
    }
    foyerFiscal {
      id
      imposableImpotFortuneImmo
      imposableImpotRevenu
      impotAnneeRevenus
      totalSalairesAssimiles
      revenusBrutGlobal
      impotAutre
      impotAutreCommentaire
      impotFortuneAnneeRevenus
      impotFortuneImmoCommentaire
      impotFortuneImmoNet
      impotRevenuBrut
      impotRevenuCommentaire
      impotRevenuNet
      impotRevenuTauxMarginal
      impotRevenuTotalCredit
      impotRevenuTotalReduction
      impotTotalAvantCreditsImpot
      csgDeductible
      chargesDeductiblesDuRevenuGlobal
      totalDesPrelevementsSociaux
      isCompleted
      nbParts
      plafondEpargneRetraireNonUtilise
    }
    objectifDefinis {
      objectif {
        categorieCode
        code
        libelle
      }
      priorite
      horizon
      objectifReferenceCode
      commentaire
    }
    capaciteFinanciere {
      commentaire
      epargnePrecautionCible
      effortEpargne
      levierType
    }
    engagementBudgetaire {
      mensualiteCreditTotale
      tauxEndettement
      capaciteRemboursementRestanteMensuel
      soldeBudgetMensuel
    }
    capaciteEpargne {
      capaciteEpargneMensuelle
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurByCodeSituationPersonnelleGQL extends Apollo.Query<InvestisseurByCodeSituationPersonnelleQuery, InvestisseurByCodeSituationPersonnelleQueryVariables> {
    document = InvestisseurByCodeSituationPersonnelleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApicilSsoUrlDocument = gql`
    mutation ApicilSsoUrl($contratId: String!) {
  apicilSsoUrl(contratId: $contratId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApicilSsoUrlGQL extends Apollo.Mutation<ApicilSsoUrlMutation, ApicilSsoUrlMutationVariables> {
    document = ApicilSsoUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SuravenirExtranetDocument = gql`
    mutation SuravenirExtranet($numeroContrat: String!, $idPersonnePartenaire: String!) {
  surAvenirContratUrl(
    numeroContrat: $numeroContrat
    idPersonnePartenaire: $idPersonnePartenaire
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SuravenirExtranetGQL extends Apollo.Mutation<SuravenirExtranetMutation, SuravenirExtranetMutationVariables> {
    document = SuravenirExtranetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContratsDetailsDocument = gql`
    query contratsDetails($id: String!, $codeInvestisseur: String!) {
  contratsInvestisseur(
    codeInvestisseur: $codeInvestisseur
    where: {idContrat: {eq: $id}}
  ) {
    ...contratDetailsFragment
  }
}
    ${ContratDetailsFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ContratsDetailsGQL extends Apollo.Query<ContratsDetailsQuery, ContratsDetailsQueryVariables> {
    document = ContratsDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContratsDetailsBackOfficeDocument = gql`
    query contratsDetailsBackOffice($id: String!) {
  contratBackOffice(idContrat: $id) {
    ...contratDetailsFragment
  }
}
    ${ContratDetailsFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ContratsDetailsBackOfficeGQL extends Apollo.Query<ContratsDetailsBackOfficeQuery, ContratsDetailsBackOfficeQueryVariables> {
    document = ContratsDetailsBackOfficeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContratsInvestisseursDocument = gql`
    query contratsInvestisseurs($codeInvestisseur: String!) {
  contratsInvestisseur(codeInvestisseur: $codeInvestisseur) {
    idContrat
    idPartenaire
    codeInvestisseur
    contrat {
      idContrat
      idPartenaire
      numeroContrat
      valorisation
      cumulVersementsNets
      dateDebutContrat
      dateValorisation
      flagVp
      vpMontantUnitaire
      perfPlusMoinsValueFinanciereNette
      produit {
        designation
        enveloppe {
          libelle
        }
        partenaire {
          libelleLong
        }
      }
    }
    investisseur {
      nom
      prenom
    }
    autresInvestisseurs {
      codeInvestisseur
      investisseur {
        nom
        prenom
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContratsInvestisseursGQL extends Apollo.Query<ContratsInvestisseursQuery, ContratsInvestisseursQueryVariables> {
    document = ContratsInvestisseursDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ModelesDocumentsDocument = gql`
    query modelesDocuments($investisseurCouple: Boolean!, $codeConsultant: String) {
  modelesDocuments(
    investisseurCouple: $investisseurCouple
    codeConsultant: $codeConsultant
  ) {
    id
    categorie
    nom
    template
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ModelesDocumentsGQL extends Apollo.Query<ModelesDocumentsQuery, ModelesDocumentsQueryVariables> {
    document = ModelesDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateDocumentFromModelDocument = gql`
    mutation generateDocumentFromModel($fileName: String!, $investisseurId: Long!, $template: String!, $coInvestisseurId: Long, $consultantCode: String) {
  generateDocumentFromModel(
    fileName: $fileName
    investisseurId: $investisseurId
    template: $template
    coInvestisseurId: $coInvestisseurId
    consultantCode: $consultantCode
  ) {
    createdDate
    denomination
    documentType
    fileExtension
    fileName
    fileType
    id
    isBlob
    isTemporary
    lastModificationDate
    status
    fileConnectionInfo {
      blobFileId
      expiration
      permissions
      sasUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateDocumentFromModelGQL extends Apollo.Mutation<GenerateDocumentFromModelMutation, GenerateDocumentFromModelMutationVariables> {
    document = GenerateDocumentFromModelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateSyntesePatrimonialDocument = gql`
    mutation GenerateSyntesePatrimonial($investisseurId: Long!, $recueilMetadataId: Long!, $avecCoInvestisseur: Boolean!, $consultantCode: String, $pyramidChartImage: String) {
  generateSyntesePatrimonial(
    investisseurId: $investisseurId
    recueilMetadataId: $recueilMetadataId
    avecCoInvestisseur: $avecCoInvestisseur
    consultantCode: $consultantCode
    pyramidChartImage: $pyramidChartImage
  ) {
    consultantCode
    createdDate
    denomination
    documentType
    fileExtension
    fileName
    fileNameWithExtension
    fileType
    id
    isBlob
    isTemporary
    lastModificationDate
    status
    fileConnectionInfo {
      blobFileId
      expiration
      permissions
      sasUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateSyntesePatrimonialGQL extends Apollo.Mutation<GenerateSyntesePatrimonialMutation, GenerateSyntesePatrimonialMutationVariables> {
    document = GenerateSyntesePatrimonialDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVueDEnsemmbleByInvestisseurIdDocument = gql`
    query GetVueDEnsemmbleByInvestisseurId($id: Long!, $avecCoInvestisseur: Boolean) {
  investisseurById(id: $id) {
    id
    vueDEnsemble(avecCoInvestisseur: $avecCoInvestisseur) {
      ...vueDEnsembleDetails
    }
  }
}
    ${VueDEnsembleDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetVueDEnsemmbleByInvestisseurIdGQL extends Apollo.Query<GetVueDEnsemmbleByInvestisseurIdQuery, GetVueDEnsemmbleByInvestisseurIdQueryVariables> {
    document = GetVueDEnsemmbleByInvestisseurIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelSignaturesDocument = gql`
    mutation cancelSignatures($documentIds: [String!]!) {
  cancelSignatures(documentIds: $documentIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelSignaturesGQL extends Apollo.Mutation<CancelSignaturesMutation, CancelSignaturesMutationVariables> {
    document = CancelSignaturesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSignaturesDocument = gql`
    mutation createSignatures($input: [DocumentSignatureInput!]!) {
  createSignatures(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSignaturesGQL extends Apollo.Mutation<CreateSignaturesMutation, CreateSignaturesMutationVariables> {
    document = CreateSignaturesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDocumentDocument = gql`
    mutation deleteDocument($documentId: String!) {
  deleteDocument(documentId: $documentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDocumentGQL extends Apollo.Mutation<DeleteDocumentMutation, DeleteDocumentMutationVariables> {
    document = DeleteDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GedCreateEmptyGedFileDocument = gql`
    mutation GedCreateEmptyGedFile($fileName: String!, $dateFinValidite: DateTime, $documentType: GedDocumentType, $denomination: String!, $investisseurId: Long!, $tags: [String!], $dateSignature: DateTime, $isHandwrittenSignature: Boolean, $investisseurIds: [Long!], $categorieCode: GedCategory, $dateDeReference: LocalDate) {
  createFileMetadata(
    denomination: $denomination
    nomDeFichier: $fileName
    investisseurId: $investisseurId
    documentType: $documentType
    dateFinValidite: $dateFinValidite
    tags: $tags
    isHandwrittenSignature: $isHandwrittenSignature
    dateSignature: $dateSignature
    investisseurIds: $investisseurIds
    categorieCode: $categorieCode
    dateDeReference: $dateDeReference
  ) {
    fileId
    versionNumber
    url
    investisseurId
    extension
    denomination
    typeDocumentCode
    dateDeCreation
    creePar
    dateDeDerniereModification
    derniereModificationPar
    fileName
    dateSignature
    urlExpireDate
    permission
    typeLibelle
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GedCreateEmptyGedFileGQL extends Apollo.Mutation<GedCreateEmptyGedFileMutation, GedCreateEmptyGedFileMutationVariables> {
    document = GedCreateEmptyGedFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RelanceSignaturesDocument = gql`
    mutation relanceSignatures($documentIds: [String!]!) {
  relanceSignatures(documentIds: $documentIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RelanceSignaturesGQL extends Apollo.Mutation<RelanceSignaturesMutation, RelanceSignaturesMutationVariables> {
    document = RelanceSignaturesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestInvestisseurPurgeDocument = gql`
    mutation requestInvestisseurPurge($investisseurId: Long!) {
  requestInvestisseurPurge(investisseurId: $investisseurId) {
    investorId
    isBlocked
    check {
      investorId
      canPurge
      blockingIssueCount
      warningCount
      checks {
        key
        label
        severity
        isOk
        message
        familyRelations {
          relationId
          relationTypeCode
          relatedInvestorId
          relatedInvestorCode
          relatedInvestorDisplayName
          relatedInvestorStatusCode
        }
      }
    }
    execution {
      investorId
      executionId
      isInProgress
      statusLevel
      status
      startedAtUtc
      lastStatusCheckedAtUtc
      completedAtUtc
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestInvestisseurPurgeGQL extends Apollo.Mutation<RequestInvestisseurPurgeMutation, RequestInvestisseurPurgeMutationVariables> {
    document = RequestInvestisseurPurgeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateConsultantPreferencesSettingsDocument = gql`
    mutation UpdateConsultantPreferencesSettings($input: ConsultantPreferencesInput!) {
  createOrUpdateConsultantPreferences(input: $input) {
    ...preferencesSettingsFragment
  }
}
    ${PreferencesSettingsFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateConsultantPreferencesSettingsGQL extends Apollo.Mutation<UpdateConsultantPreferencesSettingsMutation, UpdateConsultantPreferencesSettingsMutationVariables> {
    document = UpdateConsultantPreferencesSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFileMetadataDocument = gql`
    mutation updateFileMetadata($fileId: String!, $newMetadata: UpdateDocumentMetadatasCommandInput!) {
  updateFileMetadata(fileId: $fileId, newMetadata: $newMetadata) {
    fileId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFileMetadataGQL extends Apollo.Mutation<UpdateFileMetadataMutation, UpdateFileMetadataMutationVariables> {
    document = UpdateFileMetadataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CanAccessMinotaureAppDocument = gql`
    query canAccessMinotaureApp {
  minotaureAppAccessRight
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CanAccessMinotaureAppGQL extends Apollo.Query<CanAccessMinotaureAppQuery, CanAccessMinotaureAppQueryVariables> {
    document = CanAccessMinotaureAppDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CategorieSocioProfessionnellesDocument = gql`
    query categorieSocioProfessionnelles {
  categorieSocioProfessionnelles(order: [{libelle: ASC}]) {
    code
    libelle
    parent
    parentNavigation {
      code
      libelle
    }
    inverseParentNavigation {
      code
      libelle
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CategorieSocioProfessionnellesGQL extends Apollo.Query<CategorieSocioProfessionnellesQuery, CategorieSocioProfessionnellesQueryVariables> {
    document = CategorieSocioProfessionnellesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConsultantPreferencesSettingsDocument = gql`
    query consultantPreferencesSettings {
  consultantPreferences {
    ...preferencesSettingsFragment
  }
}
    ${PreferencesSettingsFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConsultantPreferencesSettingsGQL extends Apollo.Query<ConsultantPreferencesSettingsQuery, ConsultantPreferencesSettingsQueryVariables> {
    document = ConsultantPreferencesSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConsultantByCodeDocument = gql`
    query consultantByCode($code: String!) {
  consultantByCode(code: $code) {
    id
    code
    personnePhysique {
      code
      nom
      prenom
      personnePhysiqueDocument {
        codeTypeDocument
        documentId
        id
      }
      email {
        id
        adresse
        estAdresseCorrespondance
      }
      telephone {
        id
        numero
        estNumeroCorrespondance
      }
    }
    consultantHabilitations {
      id
      habilitationId
      dateDebut
      dateFin
      consultantId
      codeHabilitation
      statut
      cifPartenaireCode
      habilitation {
        id
        code
        libelle
      }
    }
    email {
      id
      adresse
      estAdresseCorrespondance
    }
    telephone {
      id
      numero
      estNumeroCorrespondance
    }
    abonnementConsultant {
      expirationAcces
      referenceProduit
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConsultantByCodeGQL extends Apollo.Query<ConsultantByCodeQuery, ConsultantByCodeQueryVariables> {
    document = ConsultantByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentCategoriesDocument = gql`
    query documentCategories {
  documentCategories(order: [{label: DESC}]) {
    id
    label
    gedCategoryCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentCategoriesGQL extends Apollo.Query<DocumentCategoriesQuery, DocumentCategoriesQueryVariables> {
    document = DocumentCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentTypesDocument = gql`
    query documentTypes {
  documentTypes(order: [{label: ASC}]) {
    id
    label
    gedTypeCode
    isDeprecated
    replacementGedTypeCode
    availableForRequest
    groupName
    hasRectoVerso
    maxExpectedDocument
    hasReferenceDate
    hasExpirationDate
    fileNamePrefix
    documentCategory {
      gedCategoryCode
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentTypesGQL extends Apollo.Query<DocumentTypesQuery, DocumentTypesQueryVariables> {
    document = DocumentTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentsGetDocumentMedatadasByIdDocument = gql`
    query DocumentsGetDocumentMedatadasById($fileId: String!) {
  fileMetadataById(fileId: $fileId) {
    fileId
    dateDeDerniereModification
    dateDeCreation
    denomination
    extension
    fileName
    typeLibelle
    url
    urlExpireDate
    isHandwrittenSignature
    typeDocumentCode
    dateDeFinValidite
    dateDeReference
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentsGetDocumentMedatadasByIdGQL extends Apollo.Query<DocumentsGetDocumentMedatadasByIdQuery, DocumentsGetDocumentMedatadasByIdQueryVariables> {
    document = DocumentsGetDocumentMedatadasByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentsGetDocumentUploadUriByIdDocument = gql`
    query DocumentsGetDocumentUploadUriById($fileId: String!) {
  fileUploadUriById(fileId: $fileId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentsGetDocumentUploadUriByIdGQL extends Apollo.Query<DocumentsGetDocumentUploadUriByIdQuery, DocumentsGetDocumentUploadUriByIdQueryVariables> {
    document = DocumentsGetDocumentUploadUriByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentsByFilterDocument = gql`
    query documentsByFilter($documentFilterConfiguration: DocumentFilterConfigurationInput!) {
  fileMetadataByFilters(documentFilterConfiguration: $documentFilterConfiguration) {
    consultantId
    contratId
    creePar
    dateDeCreation
    dateDeDerniereModification
    dateDeFinValidite
    dateDeReference
    dateSignature
    denomination
    derniereModificationPar
    documentIdentifier
    etatSignature
    extension
    fileId
    fileName
    investisseurId
    investisseurIds
    isHandwrittenSignature
    patrimoineId
    tags
    typeDocumentCode
    url
    categorieCode
    signatureId
    signatureOrder
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentsByFilterGQL extends Apollo.Query<DocumentsByFilterQuery, DocumentsByFilterQueryVariables> {
    document = DocumentsByFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentsByFilterPaginatedDocument = gql`
    query documentsByFilterPaginated($documentFilterConfiguration: DocumentFilterConfigurationInput!) {
  fileMetadataByFiltersPaginated(
    documentFilterConfiguration: $documentFilterConfiguration
  ) {
    continuationToken
    totalCount
    data {
      consultantId
      contratId
      creePar
      dateDeCreation
      dateDeDerniereModification
      dateDeFinValidite
      dateDeReference
      dateSignature
      denomination
      derniereModificationPar
      documentIdentifier
      etatSignature
      extension
      fileId
      fileName
      investisseurId
      investisseurIds
      investisseurs {
        id
        code
        nom
        prenom
      }
      isHandwrittenSignature
      patrimoineId
      tags
      typeDocumentCode
      url
      categorieCode
      signatureId
      signatureOrder
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentsByFilterPaginatedGQL extends Apollo.Query<DocumentsByFilterPaginatedQuery, DocumentsByFilterPaginatedQueryVariables> {
    document = DocumentsByFilterPaginatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentsCountByFilterDocument = gql`
    query documentsCountByFilter($documentFilterConfiguration: DocumentFilterConfigurationInput!) {
  fileMetadataCountByFilters(
    documentFilterConfiguration: $documentFilterConfiguration
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentsCountByFilterGQL extends Apollo.Query<DocumentsCountByFilterQuery, DocumentsCountByFilterQueryVariables> {
    document = DocumentsCountByFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentsSignatureStateByFilterDocument = gql`
    query documentsSignatureStateByFilter($documentFilterConfiguration: DocumentFilterConfigurationInput!) {
  fileMetadataByFilters(documentFilterConfiguration: $documentFilterConfiguration) {
    fileId
    signatureStates {
      states {
        actionDate
        email
        firstName
        lastName
        signatureState
        internalId
        type
      }
      requestStatus
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentsSignatureStateByFilterGQL extends Apollo.Query<DocumentsSignatureStateByFilterQuery, DocumentsSignatureStateByFilterQueryVariables> {
    document = DocumentsSignatureStateByFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurPurgeCheckDocument = gql`
    query investisseurPurgeCheck($investisseurId: Long!) {
  investisseurPurgeCheck(investisseurId: $investisseurId) {
    investorId
    canPurge
    blockingIssueCount
    warningCount
    checks {
      key
      label
      severity
      isOk
      message
      familyRelations {
        relationId
        relationTypeCode
        relatedInvestorId
        relatedInvestorCode
        relatedInvestorDisplayName
        relatedInvestorStatusCode
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurPurgeCheckGQL extends Apollo.Query<InvestisseurPurgeCheckQuery, InvestisseurPurgeCheckQueryVariables> {
    document = InvestisseurPurgeCheckDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurPurgeExecutionDocument = gql`
    query investisseurPurgeExecution($investisseurId: Long!) {
  investisseurPurgeExecution(investisseurId: $investisseurId) {
    investorId
    executionId
    isInProgress
    statusLevel
    status
    startedAtUtc
    lastStatusCheckedAtUtc
    completedAtUtc
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurPurgeExecutionGQL extends Apollo.Query<InvestisseurPurgeExecutionQuery, InvestisseurPurgeExecutionQueryVariables> {
    document = InvestisseurPurgeExecutionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurAutoCompleteByNamePaginatedDocument = gql`
    query InvestisseurAutoCompleteByNamePaginated($order: [InvestisseurSortInput!], $skip: Int!, $take: Int!, $where: InvestisseurFilterInput, $searchText: String!) {
  investisseursByNamePaginated(
    order: $order
    skip: $skip
    take: $take
    where: $where
    searchText: $searchText
  ) {
    totalCount
    items {
      ...investisseurNameAndCode
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${InvestisseurNameAndCodeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurAutoCompleteByNamePaginatedGQL extends Apollo.Query<InvestisseurAutoCompleteByNamePaginatedQuery, InvestisseurAutoCompleteByNamePaginatedQueryVariables> {
    document = InvestisseurAutoCompleteByNamePaginatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvestisseurDocumentsDocument = gql`
    query investisseurDocuments($investisseurId: Long!, $where: FileMetadataFilterInput) {
  investisseurFiles(
    investisseurId: $investisseurId
    where: $where
    order: [{dateDeDerniereModification: DESC}]
  ) {
    consultantId
    contratId
    creePar
    dateDeCreation
    dateDeDerniereModification
    dateDeFinValidite
    dateDeReference
    dateSignature
    denomination
    derniereModificationPar
    documentIdentifier
    etatSignature
    extension
    fileId
    fileName
    investisseurId
    investisseurIds
    isHandwrittenSignature
    patrimoineId
    tags
    typeDocumentCode
    url
    categorieCode
    signatureId
    signatureOrder
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvestisseurDocumentsGQL extends Apollo.Query<InvestisseurDocumentsQuery, InvestisseurDocumentsQueryVariables> {
    document = InvestisseurDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaysDocument = gql`
    query pays {
  pays(order: [{libelle: ASC}]) {
    code
    libelle
    nationalite
    nationaliteCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaysGQL extends Apollo.Query<PaysQuery, PaysQueryVariables> {
    document = PaysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegimeActivitesDocument = gql`
    query regimeActivites {
  regimeActivites(order: [{code: ASC}]) {
    code
    libelle
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegimeActivitesGQL extends Apollo.Query<RegimeActivitesQuery, RegimeActivitesQueryVariables> {
    document = RegimeActivitesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SecteurActivitesDocument = gql`
    query secteurActivites {
  secteurActivites(order: [{libelle: ASC}]) {
    code
    libelle
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SecteurActivitesGQL extends Apollo.Query<SecteurActivitesQuery, SecteurActivitesQueryVariables> {
    document = SecteurActivitesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SignatureDocumentsFilterValuesDocument = gql`
    query signatureDocumentsFilterValues($documentFilterConfiguration: DocumentFilterConfigurationInput!) {
  signatureDocumentFilterValues(
    documentFilterConfiguration: $documentFilterConfiguration
  ) {
    typeDocumentCodes
    etatSignatures
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SignatureDocumentsFilterValuesGQL extends Apollo.Query<SignatureDocumentsFilterValuesQuery, SignatureDocumentsFilterValuesQueryVariables> {
    document = SignatureDocumentsFilterValuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TypeAvantageMatrimoniauxDocument = gql`
    query typeAvantageMatrimoniaux {
  typeAvantageMatrimoniaux(order: [{libelle: ASC}]) {
    code
    libelle
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TypeAvantageMatrimoniauxGQL extends Apollo.Query<TypeAvantageMatrimoniauxQuery, TypeAvantageMatrimoniauxQueryVariables> {
    document = TypeAvantageMatrimoniauxDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TypePpeMotifsDocument = gql`
    query typePpeMotifs {
  typePpeMotifs(order: [{libelle: ASC}]) {
    code
    libelle
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TypePpeMotifsGQL extends Apollo.Query<TypePpeMotifsQuery, TypePpeMotifsQueryVariables> {
    document = TypePpeMotifsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TypePpeRelationsDocument = gql`
    query typePpeRelations {
  typePpeRelations(order: [{libelle: ASC}]) {
    code
    libelle
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TypePpeRelationsGQL extends Apollo.Query<TypePpeRelationsQuery, TypePpeRelationsQueryVariables> {
    document = TypePpeRelationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TypeRelationAutresDocument = gql`
    query typeRelationAutres {
  typeRelationAutres(order: [{libelle: ASC}]) {
    code
    libelle
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TypeRelationAutresGQL extends Apollo.Query<TypeRelationAutresQuery, TypeRelationAutresQueryVariables> {
    document = TypeRelationAutresDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TypeSituationProfessionnellesDocument = gql`
    query typeSituationProfessionnelles {
  typeSituationProfessionnelles(order: [{code: ASC}]) {
    code
    libelle
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TypeSituationProfessionnellesGQL extends Apollo.Query<TypeSituationProfessionnellesQuery, TypeSituationProfessionnellesQueryVariables> {
    document = TypeSituationProfessionnellesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TypeStatutProfessionnelsDocument = gql`
    query typeStatutProfessionnels {
  typeStatutProfessionnels(order: [{code: ASC}]) {
    code
    libelle
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TypeStatutProfessionnelsGQL extends Apollo.Query<TypeStatutProfessionnelsQuery, TypeStatutProfessionnelsQueryVariables> {
    document = TypeStatutProfessionnelsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcknowledgeOperationSouscriptionBulletinDeletionDocument = gql`
    mutation AcknowledgeOperationSouscriptionBulletinDeletion($operationId: UUID!, $produitId: Long!, $fileId: String!) {
  acknowledgeOperationSouscriptionBulletinDeletion(
    operationId: $operationId
    produitId: $produitId
    fileId: $fileId
  ) {
    ...OperationDataFields
  }
}
    ${OperationDataFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AcknowledgeOperationSouscriptionBulletinDeletionGQL extends Apollo.Mutation<AcknowledgeOperationSouscriptionBulletinDeletionMutation, AcknowledgeOperationSouscriptionBulletinDeletionMutationVariables> {
    document = AcknowledgeOperationSouscriptionBulletinDeletionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AttachProjetDocumentDocument = gql`
    mutation attachProjetDocument($projetId: Long!, $fileId: String!) {
  attachProjetDocument(projetId: $projetId, fileId: $fileId) {
    ...ProjetDocumentFields
  }
}
    ${ProjetDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AttachProjetDocumentGQL extends Apollo.Mutation<AttachProjetDocumentMutation, AttachProjetDocumentMutationVariables> {
    document = AttachProjetDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOperationBoxPlacementDocument = gql`
    mutation CreateOperationBoxPlacement($input: CreateOperationFromProxeemaInput!) {
  createOperationBoxPlacement(input: $input) {
    operationId
    operationGroupId
    statutId
    resumePath
    resumeUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOperationBoxPlacementGQL extends Apollo.Mutation<CreateOperationBoxPlacementMutation, CreateOperationBoxPlacementMutationVariables> {
    document = CreateOperationBoxPlacementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProjetDocument = gql`
    mutation createProjet($input: ProjectCreationInput!) {
  createProjet(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProjetGQL extends Apollo.Mutation<CreateProjetMutation, CreateProjetMutationVariables> {
    document = CreateProjetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSouscriptionDocument = gql`
    mutation createSouscription($input: SouscriptionCreationInput!) {
  createSouscription(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSouscriptionGQL extends Apollo.Mutation<CreateSouscriptionMutation, CreateSouscriptionMutationVariables> {
    document = CreateSouscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteOperationDocument = gql`
    mutation DeleteOperation($operationId: UUID!) {
  deleteOperation(operationId: $operationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteOperationGQL extends Apollo.Mutation<DeleteOperationMutation, DeleteOperationMutationVariables> {
    document = DeleteOperationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteProjetDocument = gql`
    mutation deleteProjet($projectId: Long!) {
  deleteProjet(projectId: $projectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteProjetGQL extends Apollo.Mutation<DeleteProjetMutation, DeleteProjetMutationVariables> {
    document = DeleteProjetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteProjetDocumentDocument = gql`
    mutation deleteProjetDocument($projetDocumentId: Long!) {
  deleteProjetDocument(projetDocumentId: $projetDocumentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteProjetDocumentGQL extends Apollo.Mutation<DeleteProjetDocumentMutation, DeleteProjetDocumentMutationVariables> {
    document = DeleteProjetDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DetachOperationSouscriptionBulletinDocument = gql`
    mutation DetachOperationSouscriptionBulletin($operationId: UUID!, $produitId: Long!, $fileId: String!) {
  detachOperationSouscriptionBulletin(
    operationId: $operationId
    produitId: $produitId
    fileId: $fileId
  ) {
    ...OperationDataFields
  }
}
    ${OperationDataFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DetachOperationSouscriptionBulletinGQL extends Apollo.Mutation<DetachOperationSouscriptionBulletinMutation, DetachOperationSouscriptionBulletinMutationVariables> {
    document = DetachOperationSouscriptionBulletinDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateOperationConseilDocument = gql`
    mutation GenerateOperationConseil($operationId: UUID!) {
  generateOperationConseil(operationId: $operationId) {
    id
    createdDate
    denomination
    documentType
    fileExtension
    fileName
    fileType
    isBlob
    isTemporary
    lastModificationDate
    fileConnectionInfo {
      blobFileId
      expiration
      permissions
      sasUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateOperationConseilGQL extends Apollo.Mutation<GenerateOperationConseilMutation, GenerateOperationConseilMutationVariables> {
    document = GenerateOperationConseilDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateOperationConseilPreviewDocument = gql`
    mutation GenerateOperationConseilPreview($operationId: UUID!) {
  generateOperationConseilPreview(operationId: $operationId) {
    id
    fileName
    fileConnectionInfo {
      sasUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateOperationConseilPreviewGQL extends Apollo.Mutation<GenerateOperationConseilPreviewMutation, GenerateOperationConseilPreviewMutationVariables> {
    document = GenerateOperationConseilPreviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetOperationSignatureDocument = gql`
    mutation resetOperationSignature($operationId: UUID!) {
  resetOperationSignature(operationId: $operationId) {
    ...OperationDataFields
  }
}
    ${OperationDataFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetOperationSignatureGQL extends Apollo.Mutation<ResetOperationSignatureMutation, ResetOperationSignatureMutationVariables> {
    document = ResetOperationSignatureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOperationAdequationDocument = gql`
    mutation updateOperationAdequation($input: GenerateOperationAdequationInput!) {
  updateOperationAndGenerateAdequation(input: $input) {
    report {
      schemaVersion
      engineVersion
      evaluatedAtUtc
      evaluationDate
      validUntilUtc
      inputRevision
      rulesVersion
      configuration {
        operationConfigId
        operationConfigVersion
        conseilConfigId
        conseilConfigVersion
        enveloppeConfigId
        produitSpecificConfigId
        productAdequationConfigId
        effectiveFingerprint
      }
      entryPoints {
        operationId
        produitId
        natureOperationId
        enveloppeId
        typeInvestisseur
        modeDeGestion
      }
      fingerprints {
        algorithm
        canonicalizationVersion
        data
        configuration
        input
      }
      conclusion
      summary {
        total
        passed
        failed
        notApplicable
        notEvaluable
      }
      search {
        objectives
        availability
        horizon
        prerequisites
        payments
        fees
        risk
        allocation
        options
        subscription
      }
      fields {
        fieldKey
        status
        checks {
          checkKey
          validatorKey
          ruleVersion
          status
          severity
          reasonCode
          message
          investisseurId
          source
          parameters {
            key
            value
          }
        }
      }
    }
    isCurrent
    reused
    errors {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOperationAdequationGQL extends Apollo.Mutation<UpdateOperationAdequationMutation, UpdateOperationAdequationMutationVariables> {
    document = UpdateOperationAdequationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOperationAllocationConsultantFileDocument = gql`
    mutation updateOperationAllocationConsultantFile($operationId: UUID!, $fileId: String) {
  updateOperationAllocationConsultantFile(
    operationId: $operationId
    fileId: $fileId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOperationAllocationConsultantFileGQL extends Apollo.Mutation<UpdateOperationAllocationConsultantFileMutation, UpdateOperationAllocationConsultantFileMutationVariables> {
    document = UpdateOperationAllocationConsultantFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOperationDataDocument = gql`
    mutation updateOperationData($operationId: UUID!) {
  updateOperationData(operationId: $operationId) {
    ...OperationDataFields
  }
}
    ${OperationDataFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOperationDataGQL extends Apollo.Mutation<UpdateOperationDataMutation, UpdateOperationDataMutationVariables> {
    document = UpdateOperationDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOperationProduitDocument = gql`
    mutation updateOperationProduit($operationId: UUID!, $produitId: Long!) {
  updateOperationProduit(operationId: $operationId, produitId: $produitId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOperationProduitGQL extends Apollo.Mutation<UpdateOperationProduitMutation, UpdateOperationProduitMutationVariables> {
    document = UpdateOperationProduitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOperationStatutDocument = gql`
    mutation updateOperationStatut($operationId: UUID!, $newStatut: OperationState!) {
  updateOperationStatut(operationId: $operationId, newStatut: $newStatut)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOperationStatutGQL extends Apollo.Mutation<UpdateOperationStatutMutation, UpdateOperationStatutMutationVariables> {
    document = UpdateOperationStatutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProjetDocument = gql`
    mutation updateProjet($input: ProjetUpdateInput!) {
  updateProjet(input: $input) {
    id
    nom
    description
    notes
    creationDate
    editionDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProjetGQL extends Apollo.Mutation<UpdateProjetMutation, UpdateProjetMutationVariables> {
    document = UpdateProjetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertOperationDataDocument = gql`
    mutation upsertOperationData($operationId: UUID!, $data: OperationDataInput!) {
  upsertOperationData(operationId: $operationId, data: $data) {
    ...OperationDataFields
  }
}
    ${OperationDataFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertOperationDataGQL extends Apollo.Mutation<UpsertOperationDataMutation, UpsertOperationDataMutationVariables> {
    document = UpsertOperationDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisponibiliteEpargneOptionsDocument = gql`
    query disponibiliteEpargneOptions {
  disponibiliteEpargneOptions {
    id
    label
    value
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisponibiliteEpargneOptionsGQL extends Apollo.Query<DisponibiliteEpargneOptionsQuery, DisponibiliteEpargneOptionsQueryVariables> {
    document = DisponibiliteEpargneOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnveloppesDocument = gql`
    query enveloppes {
  enveloppeProduits {
    code
    libelle
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnveloppesGQL extends Apollo.Query<EnveloppesQuery, EnveloppesQueryVariables> {
    document = EnveloppesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OperationByIdDocument = gql`
    query operationById($operationId: UUID!) {
  operationById(operationId: $operationId) {
    id
    statut
    projetId
    natureOperationId
    produitId
    produit {
      nom
    }
    statut
    allocationConsultantFileId
    allocationConsultantFile {
      fileName
      fileType
      id
      fileExtension
      isBlob
    }
    versement
    projet {
      nom
    }
    enveloppe {
      code
      libelle
    }
    operationConfig {
      ...OperationConfigFields
    }
    operationInvestisseurs {
      investisseur {
        id
        code
        personnePhysique {
          nom
          prenom
          dateNaissance
          email {
            adresse
            estAdresseCorrespondance
          }
          telephone {
            numero
            estNumeroCorrespondance
          }
        }
        avancementConnaissanceClientInvestisseur {
          investisseurId
          derEtat
          recueilEtat
          recueilLastChangeDate
          isRecueilFormCompleted
          qpiEtat
          qpiLastChangeDate
        }
        currentQPI {
          resultatProfilDeRisque
          resultatConnaissance
          resultatSensibiliteExtraFinanciere
          reponseESG
        }
      }
    }
    operationData {
      ...OperationDataFields
    }
  }
}
    ${OperationConfigFieldsFragmentDoc}
${OperationDataFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OperationByIdGQL extends Apollo.Query<OperationByIdQuery, OperationByIdQueryVariables> {
    document = OperationByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProjetByIdDocument = gql`
    query projetById($projetId: Int!) {
  projetById(projetId: $projetId) {
    id
    nom
    description
    notes
    creationDate
    editionDate
    projetsUtilisateurs {
      investisseurId
    }
    documents {
      ...ProjetDocumentFields
    }
    operations {
      id
      natureOperationId
      statut
      versement
      dateModification
      operationConfig {
        ...OperationConfigFields
      }
      enveloppe {
        code
        libelle
      }
      operationInvestisseurs {
        investisseurId
      }
      operationData {
        ...OperationDataFields
      }
    }
  }
}
    ${ProjetDocumentFieldsFragmentDoc}
${OperationConfigFieldsFragmentDoc}
${OperationDataFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjetByIdGQL extends Apollo.Query<ProjetByIdQuery, ProjetByIdQueryVariables> {
    document = ProjetByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProjetsByInvestisseurDocument = gql`
    query projetsByInvestisseur($investisseurId: Int!) {
  projetsByInvestisseur(investisseurId: $investisseurId) {
    id
    nom
    description
    editionDate
    operations {
      versement
      statut
      dateModification
      natureOperation {
        libelle
      }
      enveloppe {
        libelle
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjetsByInvestisseurGQL extends Apollo.Query<ProjetsByInvestisseurQuery, ProjetsByInvestisseurQueryVariables> {
    document = ProjetsByInvestisseurDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToleranceRisqueOptionsDocument = gql`
    query toleranceRisqueOptions {
  toleranceRisqueOptions {
    id
    label
    value
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ToleranceRisqueOptionsGQL extends Apollo.Query<ToleranceRisqueOptionsQuery, ToleranceRisqueOptionsQueryVariables> {
    document = ToleranceRisqueOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }